/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 394);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(395);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["c"] = __rest;
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* harmony export (immutable) */ __webpack_exports__["d"] = __spreadArrays;
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.7.0
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-05-11T18:29Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket trac-14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var version = "3.7.0",

	rhtmlSuffix = /HTML$/i,

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},


	// Retrieve the text value of an array of DOM nodes
	text: function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;

		if ( !nodeType ) {

			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {

				// Do not traverse comment nodes
				ret += jQuery.text( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			return elem.textContent;
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}

		// Do not include comment or processing instruction nodes

		return ret;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	isXMLDoc: function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;

		// Assume HTML when documentElement doesn't yet exist, such as inside
		// document fragments.
		return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}


function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var pop = arr.pop;


var sort = arr.sort;


var splice = arr.splice;


var whitespace = "[\\x20\\t\\r\\n\\f]";


var rtrimCSS = new RegExp(
	"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
	"g"
);




// Note: an element does not contain itself
jQuery.contains = function( a, b ) {
	var bup = b && b.parentNode;

	return a === bup || !!( bup && bup.nodeType === 1 && (

		// Support: IE 9 - 11+
		// IE doesn't have `contains` on SVG.
		a.contains ?
			a.contains( bup ) :
			a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
	) );
};




// CSS string/identifier serialization
// https://drafts.csswg.org/cssom/#common-serializing-idioms
var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;

function fcssescape( ch, asCodePoint ) {
	if ( asCodePoint ) {

		// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
		if ( ch === "\0" ) {
			return "\uFFFD";
		}

		// Control characters and (dependent upon position) numbers get escaped as code points
		return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
	}

	// Other potentially-special ASCII characters get backslash-escaped
	return "\\" + ch;
}

jQuery.escapeSelector = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};




var preferredDoc = document,
	pushNative = push;

( function() {

var i,
	Expr,
	outermostContext,
	sortInput,
	hasDuplicate,
	push = pushNative,

	// Local document vars
	document,
	documentElement,
	documentIsHTML,
	rbuggyQSA,
	matches,

	// Instance-specific data
	expando = jQuery.expando,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
		"loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
		whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		ID: new RegExp( "^#(" + identifier + ")" ),
		CLASS: new RegExp( "^\\.(" + identifier + ")" ),
		TAG: new RegExp( "^(" + identifier + "|[*])" ),
		ATTR: new RegExp( "^" + attributes ),
		PSEUDO: new RegExp( "^" + pseudos ),
		CHILD: new RegExp(
			"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		bool: new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		needsContext: new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		if ( nonHex ) {

			// Strip the backslash prefix from a non-hex escape sequence
			return nonHex;
		}

		// Replace a hexadecimal escape sequence with the encoded Unicode code point
		// Support: IE <=11+
		// For values outside the Basic Multilingual Plane (BMP), manually construct a
		// surrogate pair
		return high < 0 ?
			String.fromCharCode( high + 0x10000 ) :
			String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes; see `setDocument`.
	// Support: IE 9 - 11+, Edge 12 - 18+
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE/Edge.
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && nodeName( elem, "fieldset" );
		},
		{ dir: "parentNode", next: "legend" }
	);

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android <=4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = {
		apply: function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		},
		call: function( target ) {
			pushNative.apply( target, slice.call( arguments, 1 ) );
		}
	};
}

function find( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE 9 only
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								push.call( results, elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE 9 only
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							find.contains( context, elem ) &&
							elem.id === m ) {

							push.call( results, elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( !nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when
					// strict-comparing two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( newContext != context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = jQuery.escapeSelector( nid );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties
		// (see https://github.com/jquery/sizzle/issues/157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		return nodeName( elem, "input" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
			elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11+
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
function setDocument( node ) {
	var subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	documentElement = document.documentElement;
	documentIsHTML = !jQuery.isXMLDoc( document );

	// Support: iOS 7 only, IE 9 - 11+
	// Older browsers didn't support unprefixed `matches`.
	matches = documentElement.matches ||
		documentElement.webkitMatchesSelector ||
		documentElement.msMatchesSelector;

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors (see trac-13936)
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 9 - 11+, Edge 12 - 18+
		subWindow.addEventListener( "unload", unloadHandler );
	}

	// Support: IE <10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		documentElement.appendChild( el ).id = jQuery.expando;
		return !document.getElementsByName ||
			!document.getElementsByName( jQuery.expando ).length;
	} );

	// Support: IE 9 only
	// Check to see if it's possible to do matchesSelector
	// on a disconnected node.
	support.disconnectedMatch = assert( function( el ) {
		return matches.call( el, "*" );
	} );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// IE/Edge don't support the :scope pseudo-class.
	support.scope = assert( function() {
		return document.querySelectorAll( ":scope" );
	} );

	// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
	// Make sure the `:has()` argument is parsed unforgivingly.
	// We include `*` in the test to detect buggy implementations that are
	// _selectively_ forgiving (specifically when the list includes at least
	// one valid selector).
	// Note that we treat complete lack of support for `:has()` as if it were
	// spec-compliant support, which is fine because use of `:has()` in such
	// environments will fail in the qSA path and fall back to jQuery traversal
	// anyway.
	support.cssHas = assert( function() {
		try {
			document.querySelector( ":has(*,:jqfake)" );
			return false;
		} catch ( e ) {
			return true;
		}
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter.ID = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter.ID =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find.TAG = function( tag, context ) {
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			return context.getElementsByTagName( tag );

		// DocumentFragment nodes don't have gEBTN
		} else {
			return context.querySelectorAll( tag );
		}
	};

	// Class
	Expr.find.CLASS = function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	rbuggyQSA = [];

	// Build QSA regex
	// Regex strategy adopted from Diego Perini
	assert( function( el ) {

		var input;

		documentElement.appendChild( el ).innerHTML =
			"<a id='" + expando + "' href='' disabled='disabled'></a>" +
			"<select id='" + expando + "-\r\\' disabled='disabled'>" +
			"<option selected=''></option></select>";

		// Support: iOS <=7 - 8 only
		// Boolean attributes and "value" are not treated correctly in some XML documents
		if ( !el.querySelectorAll( "[selected]" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
		}

		// Support: iOS <=7 - 8 only
		if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
			rbuggyQSA.push( "~=" );
		}

		// Support: iOS 8 only
		// https://bugs.webkit.org/show_bug.cgi?id=136851
		// In-page `selector#id sibling-combinator selector` fails
		if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
			rbuggyQSA.push( ".#.+[+~]" );
		}

		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		if ( !el.querySelectorAll( ":checked" ).length ) {
			rbuggyQSA.push( ":checked" );
		}

		// Support: Windows 8 Native Apps
		// The type and name attributes are restricted during .innerHTML assignment
		input = document.createElement( "input" );
		input.setAttribute( "type", "hidden" );
		el.appendChild( input ).setAttribute( "name", "D" );

		// Support: IE 9 - 11+
		// IE's :disabled selector does not pick up the children of disabled fieldsets
		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		documentElement.appendChild( el ).disabled = true;
		if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
			rbuggyQSA.push( ":enabled", ":disabled" );
		}

		// Support: IE 11+, Edge 15 - 18+
		// IE 11/Edge don't find elements on a `[name='']` query in some cases.
		// Adding a temporary attribute to the document before the selection works
		// around the issue.
		// Interestingly, IE 10 & older don't seem to have the issue.
		input = document.createElement( "input" );
		input.setAttribute( "name", "" );
		el.appendChild( input );
		if ( !el.querySelectorAll( "[name='']" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
				whitespace + "*(?:''|\"\")" );
		}
	} );

	if ( !support.cssHas ) {

		// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
		// Our regular `try-catch` mechanism fails to detect natively-unsupported
		// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
		// in browsers that parse the `:has()` argument as a forgiving selector list.
		// https://drafts.csswg.org/selectors/#relational now requires the argument
		// to be parsed unforgivingly, but browsers have not yet fully adjusted.
		rbuggyQSA.push( ":has" );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a === document || a.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b === document || b.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	};

	return document;
}

find.matches = function( expr, elements ) {
	return find( expr, null, null, elements );
};

find.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return find( expr, document, null, [ elem ] ).length > 0;
};

find.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return jQuery.contains( context, elem );
};


find.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (see trac-13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	if ( val !== undefined ) {
		return val;
	}

	return elem.getAttribute( name );
};

find.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
jQuery.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	//
	// Support: Android <=4.0+
	// Testing for detecting duplicates is unpredictable so instead assume we can't
	// depend on duplicate detection in all browsers without a stable sort.
	hasDuplicate = !support.sortStable;
	sortInput = !support.sortStable && slice.call( results, 0 );
	sort.call( results, sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			splice.call( results, duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

jQuery.fn.uniqueSort = function() {
	return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
};

Expr = jQuery.expr = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		ATTR: function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
				.replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		CHILD: function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					find.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
				);
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

			// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				find.error( match[ 0 ] );
			}

			return match;
		},

		PSEUDO: function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		TAG: function( nodeNameSelector ) {
			var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return nodeName( elem, expectedNodeName );
				};
		},

		CLASS: function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace + ")" + className +
					"(" + whitespace + "|$)" ) ) &&
				classCache( className, function( elem ) {
					return pattern.test(
						typeof elem.className === "string" && elem.className ||
							typeof elem.getAttribute !== "undefined" &&
								elem.getAttribute( "class" ) ||
							""
					);
				} );
		},

		ATTR: function( name, operator, check ) {
			return function( elem ) {
				var result = find.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				if ( operator === "=" ) {
					return result === check;
				}
				if ( operator === "!=" ) {
					return result !== check;
				}
				if ( operator === "^=" ) {
					return check && result.indexOf( check ) === 0;
				}
				if ( operator === "*=" ) {
					return check && result.indexOf( check ) > -1;
				}
				if ( operator === "$=" ) {
					return check && result.slice( -check.length ) === check;
				}
				if ( operator === "~=" ) {
					return ( " " + result.replace( rwhitespace, " " ) + " " )
						.indexOf( check ) > -1;
				}
				if ( operator === "|=" ) {
					return result === check || result.slice( 0, check.length + 1 ) === check + "-";
				}

				return false;
			};
		},

		CHILD: function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index
							outerCache = parent[ expando ] || ( parent[ expando ] = {} );
							cache = outerCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									outerCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {
								outerCache = elem[ expando ] || ( elem[ expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );
											outerCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		PSEUDO: function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// https://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					find.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as jQuery does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf.call( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		not: markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrimCSS, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element
					// (see https://github.com/jquery/sizzle/issues/299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		has: markFunction( function( selector ) {
			return function( elem ) {
				return find( selector, elem ).length > 0;
			};
		} ),

		contains: markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// https://www.w3.org/TR/selectors/#lang-pseudo
		lang: markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				find.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		target: function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		root: function( elem ) {
			return elem === documentElement;
		},

		focus: function( elem ) {
			return elem === safeActiveElement() &&
				document.hasFocus() &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		enabled: createDisabledPseudo( false ),
		disabled: createDisabledPseudo( true ),

		checked: function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			return ( nodeName( elem, "input" ) && !!elem.checked ) ||
				( nodeName( elem, "option" ) && !!elem.selected );
		},

		selected: function( elem ) {

			// Support: IE <=11+
			// Accessing the selectedIndex property
			// forces the browser to treat the default option as
			// selected when in an optgroup.
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		empty: function( elem ) {

			// https://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		parent: function( elem ) {
			return !Expr.pseudos.empty( elem );
		},

		// Element/input types
		header: function( elem ) {
			return rheader.test( elem.nodeName );
		},

		input: function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		button: function( elem ) {
			return nodeName( elem, "input" ) && elem.type === "button" ||
				nodeName( elem, "button" );
		},

		text: function( elem ) {
			var attr;
			return nodeName( elem, "input" ) && elem.type === "text" &&

				// Support: IE <10 only
				// New HTML5 attribute values (e.g., "search") appear
				// with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		first: createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		last: createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		even: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		odd: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i;

			if ( argument < 0 ) {
				i = argument + length;
			} else if ( argument > length ) {
				i = length;
			} else {
				i = argument;
			}

			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos.nth = Expr.pseudos.eq;

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

function tokenize( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrimCSS, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	if ( parseOnly ) {
		return soFar.length;
	}

	return soFar ?
		find.error( selector ) :

		// Cache the tokens
		tokenCache( selector, groups ).slice( 0 );
}

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						if ( skip && nodeName( elem, skip ) ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = outerCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							outerCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		find( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem, matcherOut,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed ||
				multipleContexts( selector || "*",
					context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems;

		if ( matcher ) {

			// If we have a postFinder, or filtered seed, or non-seed postFilter
			// or preexisting results,
			matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

				// ...intermediate processing is necessary
				[] :

				// ...otherwise use results directly
				results;

			// Find primary matches
			matcher( matcherIn, matcherOut, context, xml );
		} else {
			matcherOut = matcherIn;
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf.call( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element
			// (see https://github.com/jquery/sizzle/issues/299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrimCSS, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find.TAG( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: iOS <=7 - 9 only
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
			// elements by id. (see trac-14142)
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							push.call( results, elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					jQuery.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

function compile( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
}

/**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
function select( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find.ID(
				token.matches[ 0 ].replace( runescape, funescape ),
				context
			) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) &&
						testContext( context.parentNode ) || context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
}

// One-time assignments

// Support: Android <=4.0 - 4.1+
// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Initialize against the default document
setDocument();

// Support: Android <=4.0 - 4.1+
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

jQuery.find = find;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.unique = jQuery.uniqueSort;

// These have always been private, but they used to be documented
// as part of Sizzle so let's maintain them in the 3.x line
// for backwards compatibility purposes.
find.compile = compile;
find.select = select;
find.setDocument = setDocument;

find.escape = jQuery.escapeSelector;
find.getText = jQuery.text;
find.isXML = jQuery.isXMLDoc;
find.selectors = jQuery.expr;
find.support = jQuery.support;
find.uniqueSort = jQuery.uniqueSort;

	/* eslint-enable */

} )();


var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
	// Strict HTML recognition (trac-11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to jQuery#find
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.error );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the error, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getErrorHook ) {
									process.error = jQuery.Deferred.getErrorHook();

								// The deprecated alias of the above. While the name suggests
								// returning the stack, not an error instance, jQuery just passes
								// it directly to `console.warn` so both will work; an instance
								// just better cooperates with source maps.
								} else if ( jQuery.Deferred.getStackHook ) {
									process.error = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
// captured before the async barrier to get the original error cause
// which may otherwise be hidden.
jQuery.Deferred.exceptionHook = function( error, asyncError ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message,
			error.stack, asyncError );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See trac-6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (trac-9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see trac-8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (trac-14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (trac-11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (trac-14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (trac-13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (trac-12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (trac-13208)
				// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (trac-13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", true );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, isSetup ) {

	// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
	if ( !isSetup ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				if ( !saved ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					this[ type ]();
					result = dataPriv.get( this, type );
					dataPriv.set( this, type, false );

					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						return result;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering
				// the native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved ) {

				// ...and capture the result
				dataPriv.set( this, type, jQuery.event.trigger(
					saved[ 0 ],
					saved.slice( 1 ),
					this
				) );

				// Abort handling of the native event by all jQuery handlers while allowing
				// native handlers on the same element to run. On target, this is achieved
				// by stopping immediate propagation just on the jQuery event. However,
				// the native event is re-wrapped by a jQuery one on each level of the
				// propagation so the only way to stop it for jQuery is to stop it for
				// everyone via native `stopPropagation()`. This is not a problem for
				// focus/blur which don't bubble, but it does also stop click on checkboxes
				// and radios. We accept this limitation.
				event.stopPropagation();
				event.isImmediatePropagationStopped = returnTrue;
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (trac-504, trac-13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {

	function focusMappedHandler( nativeEvent ) {
		if ( document.documentMode ) {

			// Support: IE 11+
			// Attach a single focusin/focusout handler on the document while someone wants
			// focus/blur. This is because the former are synchronous in IE while the latter
			// are async. In other browsers, all those handlers are invoked synchronously.

			// `handle` from private data would already wrap the event, but we need
			// to change the `type` here.
			var handle = dataPriv.get( this, "handle" ),
				event = jQuery.event.fix( nativeEvent );
			event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
			event.isSimulated = true;

			// First, handle focusin/focusout
			handle( nativeEvent );

			// ...then, handle focus/blur
			//
			// focus/blur don't bubble while focusin/focusout do; simulate the former by only
			// invoking the handler at the lower level.
			if ( event.target === event.currentTarget ) {

				// The setup part calls `leverageNative`, which, in turn, calls
				// `jQuery.event.add`, so event handle will already have been set
				// by this point.
				handle( event );
			}
		} else {

			// For non-IE browsers, attach a single capturing handler on the document
			// while someone wants focusin/focusout.
			jQuery.event.simulate( delegateType, nativeEvent.target,
				jQuery.event.fix( nativeEvent ) );
		}
	}

	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			var attaches;

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, true );

			if ( document.documentMode ) {

				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				attaches = dataPriv.get( this, delegateType );
				if ( !attaches ) {
					this.addEventListener( delegateType, focusMappedHandler );
				}
				dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
			} else {

				// Return false to allow normal processing in the caller
				return false;
			}
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		teardown: function() {
			var attaches;

			if ( document.documentMode ) {
				attaches = dataPriv.get( this, delegateType ) - 1;
				if ( !attaches ) {
					this.removeEventListener( delegateType, focusMappedHandler );
					dataPriv.remove( this, delegateType );
				} else {
					dataPriv.set( this, delegateType, attaches );
				}
			} else {

				// Return false to indicate standard teardown should be applied
				return false;
			}
		},

		// Suppress native focus or blur if we're currently inside
		// a leveraged native-event stack
		_default: function( event ) {
			return dataPriv.get( event.target, type );
		},

		delegateType: delegateType
	};

	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	//
	// Support: IE 9 - 11+
	// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
	// attach a single handler for both events in IE.
	jQuery.event.special[ delegateType ] = {
		setup: function() {

			// Handle: regular nodes (via `this.ownerDocument`), window
			// (via `this.document`) & document (via `this`).
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType );

			// Support: IE 9 - 11+
			// We use the same native handler for focusin & focus (and focusout & blur)
			// so we need to coordinate setup & teardown parts between those events.
			// Use `delegateType` as the key as `type` is already used by `leverageNative`.
			if ( !attaches ) {
				if ( document.documentMode ) {
					this.addEventListener( delegateType, focusMappedHandler );
				} else {
					doc.addEventListener( type, focusMappedHandler, true );
				}
			}
			dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
		},
		teardown: function() {
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType ) - 1;

			if ( !attaches ) {
				if ( document.documentMode ) {
					this.removeEventListener( delegateType, focusMappedHandler );
				} else {
					doc.removeEventListener( type, focusMappedHandler, true );
				}
				dataPriv.remove( dataHolder, delegateType );
			} else {
				dataPriv.set( dataHolder, delegateType, attaches );
			}
		}
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,

	rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (trac-8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {

							// Unwrap a CDATA section containing script contents. This shouldn't be
							// needed as in XML documents they're already not visible when
							// inspecting element contents and in HTML documents they have no
							// meaning but we're preserving that logic for backwards compatibility.
							// This will be removed completely in 4.0. See gh-4904.
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew jQuery#find here for performance reasons:
			// https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var rcustomProp = /^--/;


var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (trac-8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is display: block
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		isCustomProp = rcustomProp.test( name ),

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, trac-12537)
	//   .css('--customProperty) (gh-3144)
	if ( computed ) {

		// Support: IE <=9 - 11+
		// IE only supports `"float"` in `getPropertyValue`; in computed styles
		// it's only available as `"cssFloat"`. We no longer modify properties
		// sent to `.css()` apart from camelCasing, so we need to check both.
		// Normally, this would create difference in behavior: if
		// `getPropertyValue` returns an empty string, the value returned
		// by `.css()` would be `undefined`. This is usually the case for
		// disconnected elements. However, in IE even disconnected elements
		// with no styles return `"none"` for `getPropertyValue( "float" )`
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( isCustomProp && ret ) {

			// Support: Firefox 105+, Chrome <=105+
			// Spec requires trimming whitespace for custom properties (gh-4926).
			// Firefox only trims leading whitespace. Chrome just collapses
			// both leading & trailing whitespace to a single space.
			//
			// Fall back to `undefined` if empty string returned.
			// This collapses a missing definition with property defined
			// and set to an empty string but there's no standard API
			// allowing us to differentiate them without a performance penalty
			// and returning `undefined` aligns with older jQuery.
			//
			// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
			// as whitespace while CSS does not, but this is not a problem
			// because CSS preprocessing replaces them with U+000A LINE FEED
			// (which *is* CSS whitespace)
			// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
			ret = ret.replace( rtrimCSS, "$1" ) || undefined;
		}

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0,
		marginDelta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		// Count margin delta separately to only add it after scroll gutter adjustment.
		// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
		if ( box === "margin" ) {
			marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta + marginDelta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		animationIterationCount: true,
		aspectRatio: true,
		borderImageSlice: true,
		columnCount: true,
		flexGrow: true,
		flexShrink: true,
		fontWeight: true,
		gridArea: true,
		gridColumn: true,
		gridColumnEnd: true,
		gridColumnStart: true,
		gridRow: true,
		gridRowEnd: true,
		gridRowStart: true,
		lineHeight: true,
		opacity: true,
		order: true,
		orphans: true,
		scale: true,
		widows: true,
		zIndex: true,
		zoom: true,

		// SVG-related
		fillOpacity: true,
		floodOpacity: true,
		stopOpacity: true,
		strokeMiterlimit: true,
		strokeOpacity: true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (trac-7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug trac-9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (trac-7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// Use proper attribute retrieval (trac-12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
						if ( cur.indexOf( " " + className + " " ) < 0 ) {
							cur += className + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	removeClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );

				// This expression is here for better compressibility (see addClass)
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];

						// Remove *all* instances
						while ( cur.indexOf( " " + className + " " ) > -1 ) {
							cur = cur.replace( " " + className + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var classNames, className, i, self,
			type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		classNames = classesToArray( value );

		return this.each( function() {
			if ( isValidValue ) {

				// Toggle individual class names
				self = jQuery( this );

				for ( i = 0; i < classNames.length; i++ ) {
					className = classNames[ i ];

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (trac-14686, trac-14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (trac-2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (trac-9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (trac-6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// trac-7653, trac-8125, trac-8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes trac-9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (trac-10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket trac-12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// trac-9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (trac-11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// trac-1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see trac-8605, trac-14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// trac-14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
// Require that the "whitespace run" starts from a non-whitespace
// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "$1" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (trac-13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LinkButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icons__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__button_css__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__button_css__);





var SizeMap = {
    'small': 'h-btn--sm',
    'regular': '',
    'large': 'h-btn--lg'
};
var IconSizeMap = {
    'small': 13,
    'regular': 15,
    'large': 18,
};
var ColorMap = {
    'red': 'h-btn--red',
    'blue': 'h-btn--blue',
    'black': 'h-btn--black',
    'white': 'h-btn--white',
    'outline-red': 'h-btn--outline-red',
    'outline-blue': 'h-btn--outline-blue',
    'outline-black': 'h-btn--outline-black',
    'outline-white': 'h-btn--outline-white'
};
var LinkButton = function (_a) {
    var children = _a.children, color = _a.color, size = _a.size, block = _a.block, className = _a.className, elRef = _a.elRef, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["children", "color", "size", "block", "className", "elRef"]);
    var sizeClassName = SizeMap[size || 'regular'];
    var colorClassName = ColorMap[color || 'red'];
    var blockClassName = block ? 'h-btn--block' : undefined;
    var classes = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-btn', sizeClassName, colorClassName, blockClassName, className);
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ ref: elRef, className: classes }, otherProps), children);
};
var Button = function (_a) {
    var children = _a.children, color = _a.color, size = _a.size, block = _a.block, busy = _a.busy, className = _a.className, elRef = _a.elRef, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["children", "color", "size", "block", "busy", "className", "elRef"]);
    var sizeClassName = SizeMap[size || 'regular'];
    var colorClassName = ColorMap[color || 'red'];
    var blockClassName = block ? 'h-btn--block' : undefined;
    var classes = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-btn', sizeClassName, colorClassName, blockClassName, className);
    var iconSize = IconSizeMap[size || 'regular'];
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ ref: elRef, className: classes }, otherProps),
        busy &&
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__icons__["SpinnerIcon"], { className: "h-btn__icon", circleClassName: "h-btn__icon-circle", width: iconSize, height: iconSize }),
        children));
};
//# sourceMappingURL=button.js.map

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlackColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Gray700Color; });
/* unused harmony export Gray600Color */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Gray500Color; });
/* unused harmony export Gray200Color */
/* unused harmony export Gray100Color */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return WhiteColor; });
/* unused harmony export Blue900Color */
/* unused harmony export Blue800Color */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Blue600Color; });
/* unused harmony export Blue500Color */
/* unused harmony export Blue400Color */
/* unused harmony export Blue300Color */
/* unused harmony export Blue100Color */
/* unused harmony export Red900Color */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Red700Color; });
/* unused harmony export Red600Color */
/* unused harmony export Red500Color */
/* unused harmony export Red200Color */
/* unused harmony export Green600Color */
/* unused harmony export RedColor */
/* unused harmony export RedHoverColor */
/* unused harmony export RedActiveColor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BlueColor; });
/* unused harmony export BlueHoverColor */
/* unused harmony export BlueActiveColor */
/* unused harmony export BgColor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SuccessColor; });
/* unused harmony export AlertColor */
/* unused harmony export BgDisabledColor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DisabledColor; });
/* unused harmony export PrimaryColor */
/* unused harmony export SecondaryColor */
/**
 * IMPORTANT: keep in sync with _colors.scss
 */
///
/// Gray palette
///
var BlackColor = '#000';
var Gray700Color = '#555';
var Gray600Color = '#88888A';
var Gray500Color = '#CBC9C9';
var Gray200Color = '#ECECEC';
var Gray100Color = '#F9F9F9';
var WhiteColor = '#FFF';
///
/// Blue palette
///
var Blue900Color = '#001260';
var Blue800Color = '#052049';
var Blue600Color = '#10559A';
var Blue500Color = '#06F';
var Blue400Color = '#4085EF';
var Blue300Color = '#A1CAFF';
var Blue100Color = '#E3F2FA';
///
/// Red palette
///
var Red900Color = '#9B242F';
var Red700Color = '#E60000';
var Red600Color = '#DC1125';
var Red500Color = '#F33';
var Red200Color = '#FFC9C9';
///
/// Green
///
var Green600Color = '#008285';
///
/// Red colors
///
var RedColor = Red600Color;
var RedHoverColor = Red700Color;
var RedActiveColor = Red900Color;
///
/// Blue colors
///
var BlueColor = Blue600Color;
var BlueHoverColor = Blue500Color;
var BlueActiveColor = Blue400Color;
///
/// State colors
///
var BgColor = Gray100Color;
var SuccessColor = Green600Color;
var AlertColor = Red700Color;
var BgDisabledColor = Gray200Color;
var DisabledColor = Gray600Color;
///
/// Bootstrap overrides
///
var PrimaryColor = Red600Color;
var SecondaryColor = Blue600Color;
//# sourceMappingURL=colors.js.map

/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icon_props__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icon_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__icon_props__);
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__icon_props__, "BedIcon")) __webpack_require__.d(__webpack_exports__, "BedIcon", function() { return __WEBPACK_IMPORTED_MODULE_0__icon_props__["BedIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__icon_props__, "CabinIcon")) __webpack_require__.d(__webpack_exports__, "CabinIcon", function() { return __WEBPACK_IMPORTED_MODULE_0__icon_props__["CabinIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__icon_props__, "CheckmarkIcon")) __webpack_require__.d(__webpack_exports__, "CheckmarkIcon", function() { return __WEBPACK_IMPORTED_MODULE_0__icon_props__["CheckmarkIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__icon_props__, "Chevron")) __webpack_require__.d(__webpack_exports__, "Chevron", function() { return __WEBPACK_IMPORTED_MODULE_0__icon_props__["Chevron"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__icon_props__, "ChevronCircle")) __webpack_require__.d(__webpack_exports__, "ChevronCircle", function() { return __WEBPACK_IMPORTED_MODULE_0__icon_props__["ChevronCircle"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__icon_props__, "CirclePlusIcon")) __webpack_require__.d(__webpack_exports__, "CirclePlusIcon", function() { return __WEBPACK_IMPORTED_MODULE_0__icon_props__["CirclePlusIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__icon_props__, "ClockIcon")) __webpack_require__.d(__webpack_exports__, "ClockIcon", function() { return __WEBPACK_IMPORTED_MODULE_0__icon_props__["ClockIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__icon_props__, "CloseIcon")) __webpack_require__.d(__webpack_exports__, "CloseIcon", function() { return __WEBPACK_IMPORTED_MODULE_0__icon_props__["CloseIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__icon_props__, "Collapsible")) __webpack_require__.d(__webpack_exports__, "Collapsible", function() { return __WEBPACK_IMPORTED_MODULE_0__icon_props__["Collapsible"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__icon_props__, "EditIcon")) __webpack_require__.d(__webpack_exports__, "EditIcon", function() { return __WEBPACK_IMPORTED_MODULE_0__icon_props__["EditIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__icon_props__, "ExclamationIcon")) __webpack_require__.d(__webpack_exports__, "ExclamationIcon", function() { return __WEBPACK_IMPORTED_MODULE_0__icon_props__["ExclamationIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__icon_props__, "InfoIcon")) __webpack_require__.d(__webpack_exports__, "InfoIcon", function() { return __WEBPACK_IMPORTED_MODULE_0__icon_props__["InfoIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__icon_props__, "ModalHeadingClassName")) __webpack_require__.d(__webpack_exports__, "ModalHeadingClassName", function() { return __WEBPACK_IMPORTED_MODULE_0__icon_props__["ModalHeadingClassName"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__icon_props__, "ModalShell")) __webpack_require__.d(__webpack_exports__, "ModalShell", function() { return __WEBPACK_IMPORTED_MODULE_0__icon_props__["ModalShell"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__icon_props__, "Notification")) __webpack_require__.d(__webpack_exports__, "Notification", function() { return __WEBPACK_IMPORTED_MODULE_0__icon_props__["Notification"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__icon_props__, "PrinterIcon")) __webpack_require__.d(__webpack_exports__, "PrinterIcon", function() { return __WEBPACK_IMPORTED_MODULE_0__icon_props__["PrinterIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__icon_props__, "SadFaceIcon")) __webpack_require__.d(__webpack_exports__, "SadFaceIcon", function() { return __WEBPACK_IMPORTED_MODULE_0__icon_props__["SadFaceIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__icon_props__, "Spinner")) __webpack_require__.d(__webpack_exports__, "Spinner", function() { return __WEBPACK_IMPORTED_MODULE_0__icon_props__["Spinner"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__icon_props__, "SpinnerIcon")) __webpack_require__.d(__webpack_exports__, "SpinnerIcon", function() { return __WEBPACK_IMPORTED_MODULE_0__icon_props__["SpinnerIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__icon_props__, "createControlModel")) __webpack_require__.d(__webpack_exports__, "createControlModel", function() { return __WEBPACK_IMPORTED_MODULE_0__icon_props__["createControlModel"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__circle_plus_icon__ = __webpack_require__(527);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "CirclePlusIcon", function() { return __WEBPACK_IMPORTED_MODULE_1__circle_plus_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__close_icon__ = __webpack_require__(528);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "CloseIcon", function() { return __WEBPACK_IMPORTED_MODULE_2__close_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__info_icon__ = __webpack_require__(529);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "InfoIcon", function() { return __WEBPACK_IMPORTED_MODULE_3__info_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sad_face_icon__ = __webpack_require__(530);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "SadFaceIcon", function() { return __WEBPACK_IMPORTED_MODULE_4__sad_face_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__checkmark_icon__ = __webpack_require__(531);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "CheckmarkIcon", function() { return __WEBPACK_IMPORTED_MODULE_5__checkmark_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bed_icon__ = __webpack_require__(532);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "BedIcon", function() { return __WEBPACK_IMPORTED_MODULE_6__bed_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cabin_interior_icon__ = __webpack_require__(210);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cabin_interior_porthole_icon__ = __webpack_require__(211);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cabin_oceanview_icon__ = __webpack_require__(212);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__cabin_balcony_icon__ = __webpack_require__(213);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__cabin_suite_icon__ = __webpack_require__(214);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__cabin_icon__ = __webpack_require__(533);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "CabinIcon", function() { return __WEBPACK_IMPORTED_MODULE_12__cabin_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__edit_icon__ = __webpack_require__(534);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "EditIcon", function() { return __WEBPACK_IMPORTED_MODULE_13__edit_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__spinner_icon__ = __webpack_require__(535);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "SpinnerIcon", function() { return __WEBPACK_IMPORTED_MODULE_14__spinner_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__exclamation_icon__ = __webpack_require__(537);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "ExclamationIcon", function() { return __WEBPACK_IMPORTED_MODULE_15__exclamation_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__clock_icon__ = __webpack_require__(538);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "ClockIcon", function() { return __WEBPACK_IMPORTED_MODULE_16__clock_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__printer_icon__ = __webpack_require__(155);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "PrinterIcon", function() { return __WEBPACK_IMPORTED_MODULE_17__printer_icon__["a"]; });


















//# sourceMappingURL=index.js.map

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_control_group__ = __webpack_require__(216);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__models_control_group__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_0__models_control_group__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_0__models_control_group__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_control_model__ = __webpack_require__(158);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__models_control_model__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_1__models_control_model__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_1__models_control_model__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_validator__ = __webpack_require__(217);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_form_validation__ = __webpack_require__(562);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_3__models_form_validation__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_3__models_form_validation__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__input__ = __webpack_require__(563);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__input__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__checkbox__ = __webpack_require__(565);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__checkbox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__error__ = __webpack_require__(567);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__error__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__label__ = __webpack_require__(569);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__label__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__select__ = __webpack_require__(571);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_8__select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__radio__ = __webpack_require__(573);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_9__radio__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_9__radio__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_9__radio__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__field__ = __webpack_require__(575);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_10__field__["a"]; });











//# sourceMappingURL=index.js.map

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(58)('wks');
var uid = __webpack_require__(39);
var Symbol = __webpack_require__(12).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 12 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Eyebrow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eyebrow_css__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eyebrow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__eyebrow_css__);



var Eyebrow = function (_a) {
    var children = _a.children, className = _a.className, tagName = _a.tagName;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](tagName || 'div', { className: __WEBPACK_IMPORTED_MODULE_1_classnames__('h-eyebrow', className) }, children));
};
//# sourceMappingURL=eyebrow.js.map

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VisuallyHidden; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var style = {
    border: '0',
    clip: 'rect(0 0 0 0)',
    height: '1px',
    width: '1px',
    margin: '-1px',
    padding: '0',
    overflow: 'hidden',
    position: 'absolute',
    outline: 'none'
};
var VisuallyHidden = function (_a) {
    var children = _a.children, elRef = _a.elRef, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["children", "elRef"]);
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ style: style, ref: elRef }, otherProps), children);
};
//# sourceMappingURL=visually-hidden.js.map

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(12);
var core = __webpack_require__(8);
var ctx = __webpack_require__(27);
var hide = __webpack_require__(21);
var has = __webpack_require__(23);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Modal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal_shell__ = __webpack_require__(19);





var Modal = function (props) {
    var closeModalText = props.closeModalText, onRequestClose = props.onRequestClose, header = props.header, children = props.children, footer = props.footer, shell = props.shell, dialogDescription = props.dialogDescription, fullScreen = props.fullScreen, className = props.className, disableClose = props.disableClose, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(props, ["closeModalText", "onRequestClose", "header", "children", "footer", "shell", "dialogDescription", "fullScreen", "className", "disableClose"]);
    var computedClassName = __WEBPACK_IMPORTED_MODULE_3_classnames__(fullScreen ? 'h-modal-full-screen' : 'h-modal', className);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_modal__, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ role: "dialog", contentLabel: dialogDescription, onRequestClose: onRequestClose, className: computedClassName, htmlOpenClassName: "h-modal__html", bodyOpenClassName: "h-modal__body", overlayClassName: "h-modal__overlay" }, otherProps), shell ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__modal_shell__["b" /* ModalShell */], { header: header, footer: footer, closeModalText: closeModalText, onRequestClose: onRequestClose, disableClose: disableClose }, children)) : (children)));
};
//# sourceMappingURL=modal.js.map

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(22);
var IE8_DOM_DEFINE = __webpack_require__(80);
var toPrimitive = __webpack_require__(54);
var dP = Object.defineProperty;

exports.f = __webpack_require__(18) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(24)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalHeadingClassName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ModalShell; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_colors__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icons__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal_shell_css__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal_shell_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__modal_shell_css__);





var ModalHeadingClassName = 'h-modal-shell__header-heading';
var ModalShell = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_3_classnames__('h-modal-shell', props.shellClassName) },
        renderHeader(props),
        renderNotificationBar(props.notification),
        renderBody(props.children),
        renderFooter(props.footer)));
};
function renderHeader(props) {
    if (!props.header) {
        return null;
    }
    var closeModalText = props.closeModalText, onRequestClose = props.onRequestClose, header = props.header, closeButtonRef = props.closeButtonRef, disable = props.disableClose;
    // tslint:disable-next-line:no-any
    var onClose = onRequestClose;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-modal-shell__header" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col h-modal-shell__header-container" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, header),
                    closeModalText && onRequestClose &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "d-print-none h-modal-shell__header-close", "aria-label": closeModalText, onClick: onClose, ref: closeButtonRef, disabled: disable },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__icons__["CloseIcon"], { stroke: disable ? __WEBPACK_IMPORTED_MODULE_1__styles_colors__["d" /* DisabledColor */] : __WEBPACK_IMPORTED_MODULE_1__styles_colors__["c" /* BlueColor */], circleOpacity: disable ? '0.1' : '1', circleStrokeWidth: "2" })))))));
}
function renderNotificationBar(children) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-modal-shell__notification-bar" },
        children,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-modal-shell__notification-bar__sep" })));
}
function renderBody(children) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-modal-shell__body" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col" }, children)))));
}
function renderFooter(footer) {
    if (!footer) {
        return null;
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-modal-shell__footer" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col" }, footer)))));
}
//# sourceMappingURL=modal-shell.js.map

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(17);
var createDesc = __webpack_require__(29);
module.exports = __webpack_require__(18) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(69);
var defined = __webpack_require__(52);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(487)();
}


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(53);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(52);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(396);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Chevron; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


function mapDirectionToRotation(direction) {
    switch (direction) {
        case 'up':
            return 'rotate(270deg)';
        case 'down':
            return 'rotate(90deg)';
        case 'left':
            return 'rotate(180deg)';
        default:
            return 'rotate(0deg)';
    }
}
var Chevron = function (_a) {
    var size = _a.size, direction = _a.direction, color = _a.color, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["size", "direction", "color"]);
    var styles = {
        transform: mapDirectionToRotation(direction),
    };
    color = color || 'black';
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: size, height: size, style: styles, focusable: "false" }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { strokeWidth: "1px", fill: color, stroke: color, d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" })));
};
//# sourceMappingURL=chevron.js.map

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(82);
var enumBugKeys = __webpack_require__(59);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x3, _x4, _x5) { var _again = true; _function: while (_again) { var object = _x3, property = _x4, receiver = _x5; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x3 = parent; _x4 = property; _x5 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(31);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(26);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _baseStyles = __webpack_require__(607);

var _baseStyles2 = _interopRequireDefault(_baseStyles);

var _BurgerIcon = __webpack_require__(608);

var _BurgerIcon2 = _interopRequireDefault(_BurgerIcon);

var _CrossIcon = __webpack_require__(609);

var _CrossIcon2 = _interopRequireDefault(_CrossIcon);

exports['default'] = function (styles) {
  var Menu = (function (_Component) {
    _inherits(Menu, _Component);

    function Menu(props) {
      _classCallCheck(this, Menu);

      _get(Object.getPrototypeOf(Menu.prototype), 'constructor', this).call(this, props);
      this.state = {
        isOpen: false
      };
    }

    _createClass(Menu, [{
      key: 'toggleMenu',
      value: function toggleMenu() {
        var _this = this;

        var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
        var isOpen = options.isOpen;
        var noStateChange = options.noStateChange;

        var newState = {
          isOpen: typeof isOpen !== 'undefined' ? isOpen : !this.state.isOpen
        };

        this.applyWrapperStyles();

        this.setState(newState, function () {
          !noStateChange && _this.props.onStateChange(newState);

          // Timeout ensures wrappers are cleared after animation finishes.
          _this.timeoutId && clearTimeout(_this.timeoutId);
          _this.timeoutId = setTimeout(function () {
            _this.timeoutId = null;
            if (!newState.isOpen) {
              _this.applyWrapperStyles(false);
            }
          }, 500);
        });
      }

      // Applies component-specific styles to external wrapper elements.
    }, {
      key: 'applyWrapperStyles',
      value: function applyWrapperStyles() {
        var set = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

        if (this.props.bodyClassName) {
          var body = document.querySelector('body');
          body.classList[set ? 'add' : 'remove'](this.props.bodyClassName);
        }

        if (styles.pageWrap && this.props.pageWrapId) {
          this.handleExternalWrapper(this.props.pageWrapId, styles.pageWrap, set);
        }

        if (styles.outerContainer && this.props.outerContainerId) {
          this.handleExternalWrapper(this.props.outerContainerId, styles.outerContainer, set);
        }
      }

      // Sets or unsets styles on DOM elements outside the menu component.
      // This is necessary for correct page interaction with some of the menus.
      // Throws and returns if the required external elements don't exist,
      // which means any external page animations won't be applied.
    }, {
      key: 'handleExternalWrapper',
      value: function handleExternalWrapper(id, wrapperStyles, set) {
        var html = document.querySelector('html');
        var body = document.querySelector('body');
        var wrapper = document.getElementById(id);

        if (!wrapper) {
          console.error("Element with ID '" + id + "' not found");
          return;
        }

        var builtStyles = this.getStyle(wrapperStyles);

        for (var prop in builtStyles) {
          if (builtStyles.hasOwnProperty(prop)) {
            wrapper.style[prop] = set ? builtStyles[prop] : '';
          }
        }

        // Prevent any horizontal scroll.
        [html, body].forEach(function (element) {
          element.style['overflow-x'] = set ? 'hidden' : '';
        });
      }

      // Builds styles incrementally for a given element.
    }, {
      key: 'getStyles',
      value: function getStyles(el, index, inline) {
        var propName = 'bm' + el.replace(el.charAt(0), el.charAt(0).toUpperCase());

        // Set base styles.
        var output = _baseStyles2['default'][el] ? this.getStyle(_baseStyles2['default'][el]) : {};

        // Add animation-specific styles.
        if (styles[el]) {
          output = _extends({}, output, this.getStyle(styles[el], index + 1));
        }

        // Add custom styles.
        if (this.props.styles[propName]) {
          output = _extends({}, output, this.props.styles[propName]);
        }

        // Add element inline styles.
        if (inline) {
          output = _extends({}, output, inline);
        }

        return output;
      }
    }, {
      key: 'getStyle',
      value: function getStyle(style, index) {
        var width = this.props.width;

        var formattedWidth = typeof width !== 'string' ? width + 'px' : width;
        return style(this.state.isOpen, formattedWidth, this.props.right, index);
      }
    }, {
      key: 'listenForClose',
      value: function listenForClose(e) {
        e = e || window.event;

        if (this.state.isOpen && (e.key === 'Escape' || e.keyCode === 27)) {
          this.toggleMenu();
        }
      }
    }, {
      key: 'shouldDisableOverlayClick',
      value: function shouldDisableOverlayClick() {
        if (typeof this.props.disableOverlayClick === 'function') {
          return this.props.disableOverlayClick();
        } else {
          return this.props.disableOverlayClick;
        }
      }
    }, {
      key: 'componentWillMount',
      value: function componentWillMount() {
        if (!styles) {
          throw new Error('No styles supplied');
        }
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        // Bind ESC key handler (unless disabled or custom function supplied).
        if (this.props.customOnKeyDown) {
          window.onkeydown = this.props.customOnKeyDown;
        } else if (!this.props.disableCloseOnEsc) {
          window.onkeydown = this.listenForClose.bind(this);
        }

        // Allow initial open state to be set by props.
        if (this.props.isOpen) {
          this.toggleMenu({ isOpen: true, noStateChange: true });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.onkeydown = null;

        this.applyWrapperStyles(false);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        var _this2 = this;

        if (styles.svg) {
          (function () {
            var morphShape = _reactDom2['default'].findDOMNode(_this2, 'bm-morph-shape');
            var path = styles.svg.lib(morphShape).select('path');

            if (_this2.state.isOpen) {
              // Animate SVG path.
              styles.svg.animate(path);
            } else {
              // Reset path (timeout ensures animation happens off screen).
              setTimeout(function () {
                path.attr('d', styles.svg.pathInitial);
              }, 300);
            }
          })();
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (typeof nextProps.isOpen !== 'undefined' && nextProps.isOpen !== this.state.isOpen) {
          this.toggleMenu();
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this3 = this;

        return _react2['default'].createElement(
          'div',
          null,
          !this.props.noOverlay && _react2['default'].createElement('div', {
            className: ('bm-overlay ' + this.props.overlayClassName).trim(),
            onClick: function () {
              return !_this3.shouldDisableOverlayClick() && _this3.toggleMenu();
            },
            style: this.getStyles('overlay')
          }),
          _react2['default'].createElement(
            'div',
            {
              id: this.props.id,
              className: ('bm-menu-wrap ' + this.props.className).trim(),
              style: this.getStyles('menuWrap')
            },
            styles.svg && _react2['default'].createElement(
              'div',
              {
                className: ('bm-morph-shape ' + this.props.morphShapeClassName).trim(),
                style: this.getStyles('morphShape')
              },
              _react2['default'].createElement(
                'svg',
                {
                  width: '100%',
                  height: '100%',
                  viewBox: '0 0 100 800',
                  preserveAspectRatio: 'none'
                },
                _react2['default'].createElement('path', { d: styles.svg.pathInitial })
              )
            ),
            _react2['default'].createElement(
              'div',
              {
                className: ('bm-menu ' + this.props.menuClassName).trim(),
                style: this.getStyles('menu')
              },
              _react2['default'].createElement(
                'nav',
                {
                  className: ('bm-item-list ' + this.props.itemListClassName).trim(),
                  style: this.getStyles('itemList')
                },
                _react2['default'].Children.map(this.props.children, function (item, index) {
                  if (item) {
                    var classList = ['bm-item', _this3.props.itemClassName, item.props.className].filter(function (className) {
                      return !!className;
                    }).join(' ');
                    var extraProps = {
                      key: index,
                      className: classList,
                      style: _this3.getStyles('item', index, item.props.style)
                    };
                    return _react2['default'].cloneElement(item, extraProps);
                  }
                })
              )
            ),
            this.props.customCrossIcon !== false && _react2['default'].createElement(
              'div',
              { style: this.getStyles('closeButton') },
              _react2['default'].createElement(_CrossIcon2['default'], {
                onClick: function () {
                  return _this3.toggleMenu();
                },
                styles: this.props.styles,
                customIcon: this.props.customCrossIcon,
                className: this.props.crossButtonClassName,
                crossClassName: this.props.crossClassName
              })
            )
          ),
          this.props.customBurgerIcon !== false && _react2['default'].createElement(
            'div',
            { style: this.getStyles('burgerIcon') },
            _react2['default'].createElement(_BurgerIcon2['default'], {
              onClick: function () {
                return _this3.toggleMenu();
              },
              styles: this.props.styles,
              customIcon: this.props.customBurgerIcon,
              className: this.props.burgerButtonClassName,
              barClassName: this.props.burgerBarClassName
            })
          )
        );
      }
    }]);

    return Menu;
  })(_react.Component);

  Menu.propTypes = {
    bodyClassName: _propTypes2['default'].string,
    burgerBarClassName: _propTypes2['default'].string,
    burgerButtonClassName: _propTypes2['default'].string,
    crossButtonClassName: _propTypes2['default'].string,
    crossClassName: _propTypes2['default'].string,
    customBurgerIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].oneOf([false])]),
    customCrossIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].oneOf([false])]),
    customOnKeyDown: _propTypes2['default'].func,
    disableCloseOnEsc: _propTypes2['default'].bool,
    disableOverlayClick: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].func]),
    id: _propTypes2['default'].string,
    isOpen: _propTypes2['default'].bool,
    itemClassName: _propTypes2['default'].string,
    itemListClassName: _propTypes2['default'].string,
    menuClassName: _propTypes2['default'].string,
    morphShapeClassName: _propTypes2['default'].string,
    noOverlay: _propTypes2['default'].bool,
    onStateChange: _propTypes2['default'].func,
    outerContainerId: styles && styles.outerContainer ? _propTypes2['default'].string.isRequired : _propTypes2['default'].string,
    overlayClassName: _propTypes2['default'].string,
    pageWrapId: styles && styles.pageWrap ? _propTypes2['default'].string.isRequired : _propTypes2['default'].string,
    right: _propTypes2['default'].bool,
    styles: _propTypes2['default'].object,
    width: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string])
  };

  Menu.defaultProps = {
    bodyClassName: '',
    burgerBarClassName: '',
    burgerButtonClassName: '',
    className: '',
    crossButtonClassName: '',
    crossClassName: '',
    disableCloseOnEsc: false,
    id: '',
    itemClassName: '',
    itemListClassName: '',
    menuClassName: '',
    morphShapeClassName: '',
    noOverlay: false,
    onStateChange: function onStateChange() {},
    outerContainerId: '',
    overlayClassName: '',
    pageWrapId: '',
    styles: {},
    width: 300
  };

  return Menu;
};

module.exports = exports['default'];

/***/ }),
/* 38 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(17).f;
var has = __webpack_require__(23);
var TAG = __webpack_require__(11)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlackColor; });
/* unused harmony export Gray700Color */
/* unused harmony export Gray600Color */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Gray500Color; });
/* unused harmony export Gray200Color */
/* unused harmony export Gray100Color */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return WhiteColor; });
/* unused harmony export Blue900Color */
/* unused harmony export Blue800Color */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Blue600Color; });
/* unused harmony export Blue500Color */
/* unused harmony export Blue400Color */
/* unused harmony export Blue300Color */
/* unused harmony export Blue100Color */
/* unused harmony export Red900Color */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Red700Color; });
/* unused harmony export Red600Color */
/* unused harmony export Red500Color */
/* unused harmony export Red200Color */
/* unused harmony export Green600Color */
/* unused harmony export RedColor */
/* unused harmony export RedHoverColor */
/* unused harmony export RedActiveColor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BlueColor; });
/* unused harmony export BlueHoverColor */
/* unused harmony export BlueActiveColor */
/* unused harmony export BgColor */
/* unused harmony export SuccessColor */
/* unused harmony export AlertColor */
/* unused harmony export BgDisabledColor */
/* unused harmony export DisabledColor */
/* unused harmony export PrimaryColor */
/* unused harmony export SecondaryColor */
/**
 * IMPORTANT: keep in sync with _colors.scss
 */
///
/// Gray palette
///
var BlackColor = '#000';
var Gray700Color = '#555';
var Gray600Color = '#88888A';
var Gray500Color = '#CBC9C9';
var Gray200Color = '#ECECEC';
var Gray100Color = '#F9F9F9';
var WhiteColor = '#FFF';
///
/// Blue palette
///
var Blue900Color = '#001260';
var Blue800Color = '#052049';
var Blue600Color = '#10559A';
var Blue500Color = '#06F';
var Blue400Color = '#4085EF';
var Blue300Color = '#A1CAFF';
var Blue100Color = '#E3F2FA';
///
/// Red palette
///
var Red900Color = '#9B242F';
var Red700Color = '#E60000';
var Red600Color = '#DC1125';
var Red500Color = '#F33';
var Red200Color = '#FFC9C9';
///
/// Green
///
var Green600Color = '#008285';
///
/// Red colors
///
var RedColor = Red600Color;
var RedHoverColor = Red700Color;
var RedActiveColor = Red900Color;
///
/// Blue colors
///
var BlueColor = Blue600Color;
var BlueHoverColor = Blue500Color;
var BlueActiveColor = Blue400Color;
///
/// State colors
///
var BgColor = Gray100Color;
var SuccessColor = Green600Color;
var AlertColor = Red700Color;
var BgDisabledColor = Gray200Color;
var DisabledColor = Gray600Color;
///
/// Bootstrap overrides
///
var PrimaryColor = Red600Color;
var SecondaryColor = Blue600Color;
//# sourceMappingURL=colors.js.map

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Avatar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__avatar_css__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__avatar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__avatar_css__);




function getInitials(fullName) {
    if (!fullName) {
        return '--';
    }
    var parts = fullName.trim().split(' ');
    if (parts.length === 1) {
        return parts[0].substring(0, 2);
    }
    return "" + parts[0].charAt(0) + parts[1].charAt(0);
}
var Avatar = function (_a) {
    var fullName = _a.fullName, className = _a.className, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["fullName", "className"]);
    var classes = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-avatar', className);
    var initials = getInitials(fullName).toUpperCase();
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ className: classes }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null, initials));
};
//# sourceMappingURL=avatar.js.map

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tabs__ = __webpack_require__(702);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Tabs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabList__ = __webpack_require__(704);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__components_TabList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Tab__ = __webpack_require__(705);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__components_Tab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TabPanel__ = __webpack_require__(706);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__components_TabPanel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_uuid__ = __webpack_require__(235);
/* unused harmony reexport resetIdCounter */






/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getGuestName;
/* harmony export (immutable) */ __webpack_exports__["f"] = isVppLine;
/* harmony export (immutable) */ __webpack_exports__["e"] = isGratuitiesLine;
/* harmony export (immutable) */ __webpack_exports__["d"] = isAgencyBooking;
/* harmony export (immutable) */ __webpack_exports__["h"] = quoteWithGratuities;
/* harmony export (immutable) */ __webpack_exports__["i"] = quoteWithVpp;
/* harmony export (immutable) */ __webpack_exports__["g"] = quoteFromInvoice;
/* harmony export (immutable) */ __webpack_exports__["c"] = hasHiddenAmounts;
/* harmony export (immutable) */ __webpack_exports__["b"] = getPaymentDue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models__ = __webpack_require__(166);


function getGuestName(index, content, firstName, lastName) {
    var fullName = firstName + " " + lastName;
    if (firstName === 'TBA') {
        fullName = content.guest + " " + (index + 1);
    }
    return fullName;
}
function isVppLine(line) {
    return line.code === 'INSU';
}
function isGratuitiesLine(line) {
    return line.code === 'GRAT';
}
function isAgencyBooking(sailing, bookingNumber) {
    return sailing.bookings.filter(function (n) { return n.bookingNumber === bookingNumber; })[0].isAgencyBooking;
}
function quoteWithGratuities(quote, gratuities) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, quote), { gratuities: gratuities === 'add' });
}
function quoteWithVpp(quote, invoice, seqNumber, vpp) {
    if (!quote.vpp) {
        quote.vpp = [];
    }
    if (vpp === 'add') {
        if (quote.vpp.indexOf(seqNumber) >= 0) {
            return quote;
        }
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, quote), { vpp: quote.vpp.concat([seqNumber]) });
    }
    else if (vpp === 'remove') {
        if (quote.vpp.indexOf(seqNumber) < 0) {
            return quote;
        }
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, quote), { vpp: quote.vpp.filter(function (n) { return n !== seqNumber; }) });
    }
    else if (vpp === 'addAll') {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, quote), { vpp: invoice.guests.map(function (n) { return n.seqNumber; }) });
    }
    return quote;
}
function quoteFromInvoice(invoice, bookingNumber, quoteType) {
    return {
        bookingNumber: bookingNumber,
        vpp: quoteType === 'VPP'
            ? invoice.insurancePrepaidGratuitiesQuote.guests.filter(function (n) { return n.insuranceAmount && n.insuranceAmount > 0; }).map(function (n) { return n.seqNumber; })
            : null,
        gratuities: quoteType === 'GRATS'
            ? invoice.insurancePrepaidGratuitiesQuote.guests.filter(function (l) { return l.prepaidGratuitiesAmount && l.prepaidGratuitiesAmount > 0; }).length > 0
            : null
    };
}
function hasHiddenAmounts(invoice) {
    return invoice.lineItems.some(function (x) { return x.amountFormatted === __WEBPACK_IMPORTED_MODULE_1__models__["a" /* HiddenAmountToken */]; });
}
function getPaymentDue(invoice) {
    if (!invoice) {
        return null;
    }
    var paymentInstallments = invoice.paymentInstallments, schedule = invoice.schedule;
    var showDepositDue = !paymentInstallments && schedule && schedule.depositAmountDue > 0;
    var showBalanceDue = !showDepositDue && schedule && schedule.balanceDue > 0;
    if (showDepositDue) {
        return {
            showDepositDue: true,
            amountFormatted: schedule.depositAmountDueFormatted,
            dueByDateFormatted: schedule.depositDueDateMmmDYyyy,
        };
    }
    if (showBalanceDue) {
        return {
            showBalanceDue: true,
            amountFormatted: schedule.balanceDueFormatted,
            dueByDateFormatted: schedule.finalPaymentDueDateMmmDYyyy,
        };
    }
    return null;
}
//# sourceMappingURL=common.js.map

/***/ }),
/* 46 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(121);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(130);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_sitecore__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_sitecore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__models_sitecore__);
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__models_sitecore__, "BlackColor")) __webpack_require__.d(__webpack_exports__, "BlackColor", function() { return __WEBPACK_IMPORTED_MODULE_0__models_sitecore__["BlackColor"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__models_sitecore__, "BlueColor")) __webpack_require__.d(__webpack_exports__, "BlueColor", function() { return __WEBPACK_IMPORTED_MODULE_0__models_sitecore__["BlueColor"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__models_sitecore__, "Button")) __webpack_require__.d(__webpack_exports__, "Button", function() { return __WEBPACK_IMPORTED_MODULE_0__models_sitecore__["Button"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__models_sitecore__, "Chevron")) __webpack_require__.d(__webpack_exports__, "Chevron", function() { return __WEBPACK_IMPORTED_MODULE_0__models_sitecore__["Chevron"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__models_sitecore__, "ChevronCircle")) __webpack_require__.d(__webpack_exports__, "ChevronCircle", function() { return __WEBPACK_IMPORTED_MODULE_0__models_sitecore__["ChevronCircle"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__models_sitecore__, "CloseIcon")) __webpack_require__.d(__webpack_exports__, "CloseIcon", function() { return __WEBPACK_IMPORTED_MODULE_0__models_sitecore__["CloseIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__models_sitecore__, "Collapsible")) __webpack_require__.d(__webpack_exports__, "Collapsible", function() { return __WEBPACK_IMPORTED_MODULE_0__models_sitecore__["Collapsible"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__models_sitecore__, "EditIcon")) __webpack_require__.d(__webpack_exports__, "EditIcon", function() { return __WEBPACK_IMPORTED_MODULE_0__models_sitecore__["EditIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__models_sitecore__, "Gray700Color")) __webpack_require__.d(__webpack_exports__, "Gray700Color", function() { return __WEBPACK_IMPORTED_MODULE_0__models_sitecore__["Gray700Color"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__models_sitecore__, "ModalHeadingClassName")) __webpack_require__.d(__webpack_exports__, "ModalHeadingClassName", function() { return __WEBPACK_IMPORTED_MODULE_0__models_sitecore__["ModalHeadingClassName"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__models_sitecore__, "ModalShell")) __webpack_require__.d(__webpack_exports__, "ModalShell", function() { return __WEBPACK_IMPORTED_MODULE_0__models_sitecore__["ModalShell"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__models_sitecore__, "Notification")) __webpack_require__.d(__webpack_exports__, "Notification", function() { return __WEBPACK_IMPORTED_MODULE_0__models_sitecore__["Notification"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__models_sitecore__, "Spinner")) __webpack_require__.d(__webpack_exports__, "Spinner", function() { return __WEBPACK_IMPORTED_MODULE_0__models_sitecore__["Spinner"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__models_sitecore__, "SpinnerIcon")) __webpack_require__.d(__webpack_exports__, "SpinnerIcon", function() { return __WEBPACK_IMPORTED_MODULE_0__models_sitecore__["SpinnerIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__models_sitecore__, "createControlModel")) __webpack_require__.d(__webpack_exports__, "createControlModel", function() { return __WEBPACK_IMPORTED_MODULE_0__models_sitecore__["createControlModel"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_common__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__models_common__);
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__models_common__, "BlackColor")) __webpack_require__.d(__webpack_exports__, "BlackColor", function() { return __WEBPACK_IMPORTED_MODULE_1__models_common__["BlackColor"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__models_common__, "BlueColor")) __webpack_require__.d(__webpack_exports__, "BlueColor", function() { return __WEBPACK_IMPORTED_MODULE_1__models_common__["BlueColor"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__models_common__, "Button")) __webpack_require__.d(__webpack_exports__, "Button", function() { return __WEBPACK_IMPORTED_MODULE_1__models_common__["Button"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__models_common__, "Chevron")) __webpack_require__.d(__webpack_exports__, "Chevron", function() { return __WEBPACK_IMPORTED_MODULE_1__models_common__["Chevron"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__models_common__, "ChevronCircle")) __webpack_require__.d(__webpack_exports__, "ChevronCircle", function() { return __WEBPACK_IMPORTED_MODULE_1__models_common__["ChevronCircle"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__models_common__, "CloseIcon")) __webpack_require__.d(__webpack_exports__, "CloseIcon", function() { return __WEBPACK_IMPORTED_MODULE_1__models_common__["CloseIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__models_common__, "Collapsible")) __webpack_require__.d(__webpack_exports__, "Collapsible", function() { return __WEBPACK_IMPORTED_MODULE_1__models_common__["Collapsible"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__models_common__, "EditIcon")) __webpack_require__.d(__webpack_exports__, "EditIcon", function() { return __WEBPACK_IMPORTED_MODULE_1__models_common__["EditIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__models_common__, "Gray700Color")) __webpack_require__.d(__webpack_exports__, "Gray700Color", function() { return __WEBPACK_IMPORTED_MODULE_1__models_common__["Gray700Color"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__models_common__, "ModalHeadingClassName")) __webpack_require__.d(__webpack_exports__, "ModalHeadingClassName", function() { return __WEBPACK_IMPORTED_MODULE_1__models_common__["ModalHeadingClassName"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__models_common__, "ModalShell")) __webpack_require__.d(__webpack_exports__, "ModalShell", function() { return __WEBPACK_IMPORTED_MODULE_1__models_common__["ModalShell"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__models_common__, "Notification")) __webpack_require__.d(__webpack_exports__, "Notification", function() { return __WEBPACK_IMPORTED_MODULE_1__models_common__["Notification"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__models_common__, "Spinner")) __webpack_require__.d(__webpack_exports__, "Spinner", function() { return __WEBPACK_IMPORTED_MODULE_1__models_common__["Spinner"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__models_common__, "SpinnerIcon")) __webpack_require__.d(__webpack_exports__, "SpinnerIcon", function() { return __WEBPACK_IMPORTED_MODULE_1__models_common__["SpinnerIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__models_common__, "createControlModel")) __webpack_require__.d(__webpack_exports__, "createControlModel", function() { return __WEBPACK_IMPORTED_MODULE_1__models_common__["createControlModel"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_colors__ = __webpack_require__(6);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "BlackColor", function() { return __WEBPACK_IMPORTED_MODULE_2__styles_colors__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "BlueColor", function() { return __WEBPACK_IMPORTED_MODULE_2__styles_colors__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Gray700Color", function() { return __WEBPACK_IMPORTED_MODULE_2__styles_colors__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_breakpoints__ = __webpack_require__(95);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_alerts_models__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_alerts_models___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_alerts_models__);
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_4__components_alerts_models__, "Button")) __webpack_require__.d(__webpack_exports__, "Button", function() { return __WEBPACK_IMPORTED_MODULE_4__components_alerts_models__["Button"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_4__components_alerts_models__, "Chevron")) __webpack_require__.d(__webpack_exports__, "Chevron", function() { return __WEBPACK_IMPORTED_MODULE_4__components_alerts_models__["Chevron"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_4__components_alerts_models__, "ChevronCircle")) __webpack_require__.d(__webpack_exports__, "ChevronCircle", function() { return __WEBPACK_IMPORTED_MODULE_4__components_alerts_models__["ChevronCircle"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_4__components_alerts_models__, "CloseIcon")) __webpack_require__.d(__webpack_exports__, "CloseIcon", function() { return __WEBPACK_IMPORTED_MODULE_4__components_alerts_models__["CloseIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_4__components_alerts_models__, "Collapsible")) __webpack_require__.d(__webpack_exports__, "Collapsible", function() { return __WEBPACK_IMPORTED_MODULE_4__components_alerts_models__["Collapsible"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_4__components_alerts_models__, "EditIcon")) __webpack_require__.d(__webpack_exports__, "EditIcon", function() { return __WEBPACK_IMPORTED_MODULE_4__components_alerts_models__["EditIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_4__components_alerts_models__, "ModalHeadingClassName")) __webpack_require__.d(__webpack_exports__, "ModalHeadingClassName", function() { return __WEBPACK_IMPORTED_MODULE_4__components_alerts_models__["ModalHeadingClassName"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_4__components_alerts_models__, "ModalShell")) __webpack_require__.d(__webpack_exports__, "ModalShell", function() { return __WEBPACK_IMPORTED_MODULE_4__components_alerts_models__["ModalShell"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_4__components_alerts_models__, "Notification")) __webpack_require__.d(__webpack_exports__, "Notification", function() { return __WEBPACK_IMPORTED_MODULE_4__components_alerts_models__["Notification"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_4__components_alerts_models__, "Spinner")) __webpack_require__.d(__webpack_exports__, "Spinner", function() { return __WEBPACK_IMPORTED_MODULE_4__components_alerts_models__["Spinner"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_4__components_alerts_models__, "SpinnerIcon")) __webpack_require__.d(__webpack_exports__, "SpinnerIcon", function() { return __WEBPACK_IMPORTED_MODULE_4__components_alerts_models__["SpinnerIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_4__components_alerts_models__, "createControlModel")) __webpack_require__.d(__webpack_exports__, "createControlModel", function() { return __WEBPACK_IMPORTED_MODULE_4__components_alerts_models__["createControlModel"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_alerts_alerts_manager__ = __webpack_require__(524);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_button_button__ = __webpack_require__(5);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return __WEBPACK_IMPORTED_MODULE_6__components_button_button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_eyebrow_eyebrow__ = __webpack_require__(13);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_offer_offer__ = __webpack_require__(215);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_badge_badge__ = __webpack_require__(157);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_icons__ = __webpack_require__(9);
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_10__components_icons__, "Chevron")) __webpack_require__.d(__webpack_exports__, "Chevron", function() { return __WEBPACK_IMPORTED_MODULE_10__components_icons__["Chevron"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_10__components_icons__, "ChevronCircle")) __webpack_require__.d(__webpack_exports__, "ChevronCircle", function() { return __WEBPACK_IMPORTED_MODULE_10__components_icons__["ChevronCircle"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_10__components_icons__, "CloseIcon")) __webpack_require__.d(__webpack_exports__, "CloseIcon", function() { return __WEBPACK_IMPORTED_MODULE_10__components_icons__["CloseIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_10__components_icons__, "Collapsible")) __webpack_require__.d(__webpack_exports__, "Collapsible", function() { return __WEBPACK_IMPORTED_MODULE_10__components_icons__["Collapsible"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_10__components_icons__, "EditIcon")) __webpack_require__.d(__webpack_exports__, "EditIcon", function() { return __WEBPACK_IMPORTED_MODULE_10__components_icons__["EditIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_10__components_icons__, "ModalHeadingClassName")) __webpack_require__.d(__webpack_exports__, "ModalHeadingClassName", function() { return __WEBPACK_IMPORTED_MODULE_10__components_icons__["ModalHeadingClassName"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_10__components_icons__, "ModalShell")) __webpack_require__.d(__webpack_exports__, "ModalShell", function() { return __WEBPACK_IMPORTED_MODULE_10__components_icons__["ModalShell"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_10__components_icons__, "Notification")) __webpack_require__.d(__webpack_exports__, "Notification", function() { return __WEBPACK_IMPORTED_MODULE_10__components_icons__["Notification"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_10__components_icons__, "Spinner")) __webpack_require__.d(__webpack_exports__, "Spinner", function() { return __WEBPACK_IMPORTED_MODULE_10__components_icons__["Spinner"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_10__components_icons__, "SpinnerIcon")) __webpack_require__.d(__webpack_exports__, "SpinnerIcon", function() { return __WEBPACK_IMPORTED_MODULE_10__components_icons__["SpinnerIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_10__components_icons__, "createControlModel")) __webpack_require__.d(__webpack_exports__, "createControlModel", function() { return __WEBPACK_IMPORTED_MODULE_10__components_icons__["createControlModel"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_media_offer_media_offer__ = __webpack_require__(550);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_media_query_media_query__ = __webpack_require__(76);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_to_dos_to_dos__ = __webpack_require__(552);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_to_dos_to_do__ = __webpack_require__(578);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_to_dos_to_do_status__ = __webpack_require__(218);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_booked_tile_booked_tile__ = __webpack_require__(581);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_store_category_list_store_category_list__ = __webpack_require__(584);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_itinerary_calendar_model__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_itinerary_calendar_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_itinerary_calendar_model__);
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_18__components_itinerary_calendar_model__, "Chevron")) __webpack_require__.d(__webpack_exports__, "Chevron", function() { return __WEBPACK_IMPORTED_MODULE_18__components_itinerary_calendar_model__["Chevron"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_18__components_itinerary_calendar_model__, "ChevronCircle")) __webpack_require__.d(__webpack_exports__, "ChevronCircle", function() { return __WEBPACK_IMPORTED_MODULE_18__components_itinerary_calendar_model__["ChevronCircle"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_18__components_itinerary_calendar_model__, "CloseIcon")) __webpack_require__.d(__webpack_exports__, "CloseIcon", function() { return __WEBPACK_IMPORTED_MODULE_18__components_itinerary_calendar_model__["CloseIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_18__components_itinerary_calendar_model__, "Collapsible")) __webpack_require__.d(__webpack_exports__, "Collapsible", function() { return __WEBPACK_IMPORTED_MODULE_18__components_itinerary_calendar_model__["Collapsible"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_18__components_itinerary_calendar_model__, "EditIcon")) __webpack_require__.d(__webpack_exports__, "EditIcon", function() { return __WEBPACK_IMPORTED_MODULE_18__components_itinerary_calendar_model__["EditIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_18__components_itinerary_calendar_model__, "ModalHeadingClassName")) __webpack_require__.d(__webpack_exports__, "ModalHeadingClassName", function() { return __WEBPACK_IMPORTED_MODULE_18__components_itinerary_calendar_model__["ModalHeadingClassName"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_18__components_itinerary_calendar_model__, "ModalShell")) __webpack_require__.d(__webpack_exports__, "ModalShell", function() { return __WEBPACK_IMPORTED_MODULE_18__components_itinerary_calendar_model__["ModalShell"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_18__components_itinerary_calendar_model__, "Notification")) __webpack_require__.d(__webpack_exports__, "Notification", function() { return __WEBPACK_IMPORTED_MODULE_18__components_itinerary_calendar_model__["Notification"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_18__components_itinerary_calendar_model__, "Spinner")) __webpack_require__.d(__webpack_exports__, "Spinner", function() { return __WEBPACK_IMPORTED_MODULE_18__components_itinerary_calendar_model__["Spinner"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_18__components_itinerary_calendar_model__, "SpinnerIcon")) __webpack_require__.d(__webpack_exports__, "SpinnerIcon", function() { return __WEBPACK_IMPORTED_MODULE_18__components_itinerary_calendar_model__["SpinnerIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_18__components_itinerary_calendar_model__, "createControlModel")) __webpack_require__.d(__webpack_exports__, "createControlModel", function() { return __WEBPACK_IMPORTED_MODULE_18__components_itinerary_calendar_model__["createControlModel"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_itinerary_calendar_compact_itinerary_calendar__ = __webpack_require__(587);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_top_nav_top_nav_full__ = __webpack_require__(219);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_top_nav_top_nav_compact__ = __webpack_require__(222);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_dropdown_dropdown__ = __webpack_require__(110);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_chevron_chevron__ = __webpack_require__(32);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Chevron", function() { return __WEBPACK_IMPORTED_MODULE_23__components_chevron_chevron__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_chevron_chevron_circle__ = __webpack_require__(97);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "ChevronCircle", function() { return __WEBPACK_IMPORTED_MODULE_24__components_chevron_chevron_circle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_booked_nav_booked_nav__ = __webpack_require__(604);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_booked_nav_models__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_booked_nav_models___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_booked_nav_models__);
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_26__components_booked_nav_models__, "CloseIcon")) __webpack_require__.d(__webpack_exports__, "CloseIcon", function() { return __WEBPACK_IMPORTED_MODULE_26__components_booked_nav_models__["CloseIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_26__components_booked_nav_models__, "Collapsible")) __webpack_require__.d(__webpack_exports__, "Collapsible", function() { return __WEBPACK_IMPORTED_MODULE_26__components_booked_nav_models__["Collapsible"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_26__components_booked_nav_models__, "EditIcon")) __webpack_require__.d(__webpack_exports__, "EditIcon", function() { return __WEBPACK_IMPORTED_MODULE_26__components_booked_nav_models__["EditIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_26__components_booked_nav_models__, "ModalHeadingClassName")) __webpack_require__.d(__webpack_exports__, "ModalHeadingClassName", function() { return __WEBPACK_IMPORTED_MODULE_26__components_booked_nav_models__["ModalHeadingClassName"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_26__components_booked_nav_models__, "ModalShell")) __webpack_require__.d(__webpack_exports__, "ModalShell", function() { return __WEBPACK_IMPORTED_MODULE_26__components_booked_nav_models__["ModalShell"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_26__components_booked_nav_models__, "Notification")) __webpack_require__.d(__webpack_exports__, "Notification", function() { return __WEBPACK_IMPORTED_MODULE_26__components_booked_nav_models__["Notification"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_26__components_booked_nav_models__, "Spinner")) __webpack_require__.d(__webpack_exports__, "Spinner", function() { return __WEBPACK_IMPORTED_MODULE_26__components_booked_nav_models__["Spinner"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_26__components_booked_nav_models__, "SpinnerIcon")) __webpack_require__.d(__webpack_exports__, "SpinnerIcon", function() { return __WEBPACK_IMPORTED_MODULE_26__components_booked_nav_models__["SpinnerIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_26__components_booked_nav_models__, "createControlModel")) __webpack_require__.d(__webpack_exports__, "createControlModel", function() { return __WEBPACK_IMPORTED_MODULE_26__components_booked_nav_models__["createControlModel"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_booked_nav_component_factory__ = __webpack_require__(224);
/* unused harmony reexport BookedComponentFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_main_nav_main_nav__ = __webpack_require__(96);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_hero_hero__ = __webpack_require__(657);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_countdown_countdown__ = __webpack_require__(227);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_cruise_summary_card_cruise_summary_card__ = __webpack_require__(660);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_ada_global_outline_ada_global_outline__ = __webpack_require__(665);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_carousel_carousel__ = __webpack_require__(160);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_avatar_avatar__ = __webpack_require__(43);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_skip_nav_skip_nav__ = __webpack_require__(667);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_modal_modal_shell__ = __webpack_require__(19);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "ModalHeadingClassName", function() { return __WEBPACK_IMPORTED_MODULE_36__components_modal_modal_shell__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "ModalShell", function() { return __WEBPACK_IMPORTED_MODULE_36__components_modal_modal_shell__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_modal_modal__ = __webpack_require__(16);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_access_booking_access_booking__ = __webpack_require__(162);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_access_booking_access_booking_modal_trigger__ = __webpack_require__(682);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_access_booking_access_booking_dob__ = __webpack_require__(232);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_access_booking_access_booking_dob_form__ = __webpack_require__(685);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_access_booking_models__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_access_booking_models___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_access_booking_models__);
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_42__components_access_booking_models__, "CloseIcon")) __webpack_require__.d(__webpack_exports__, "CloseIcon", function() { return __WEBPACK_IMPORTED_MODULE_42__components_access_booking_models__["CloseIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_42__components_access_booking_models__, "Collapsible")) __webpack_require__.d(__webpack_exports__, "Collapsible", function() { return __WEBPACK_IMPORTED_MODULE_42__components_access_booking_models__["Collapsible"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_42__components_access_booking_models__, "EditIcon")) __webpack_require__.d(__webpack_exports__, "EditIcon", function() { return __WEBPACK_IMPORTED_MODULE_42__components_access_booking_models__["EditIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_42__components_access_booking_models__, "Notification")) __webpack_require__.d(__webpack_exports__, "Notification", function() { return __WEBPACK_IMPORTED_MODULE_42__components_access_booking_models__["Notification"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_42__components_access_booking_models__, "Spinner")) __webpack_require__.d(__webpack_exports__, "Spinner", function() { return __WEBPACK_IMPORTED_MODULE_42__components_access_booking_models__["Spinner"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_42__components_access_booking_models__, "SpinnerIcon")) __webpack_require__.d(__webpack_exports__, "SpinnerIcon", function() { return __WEBPACK_IMPORTED_MODULE_42__components_access_booking_models__["SpinnerIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_42__components_access_booking_models__, "createControlModel")) __webpack_require__.d(__webpack_exports__, "createControlModel", function() { return __WEBPACK_IMPORTED_MODULE_42__components_access_booking_models__["createControlModel"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_sailing_tile_sailing_tile__ = __webpack_require__(225);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_forms__ = __webpack_require__(10);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "createControlModel", function() { return __WEBPACK_IMPORTED_MODULE_44__components_forms__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_tooltip_tooltip__ = __webpack_require__(116);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_visually_hidden_visually_hidden__ = __webpack_require__(14);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_notification_notification__ = __webpack_require__(64);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Notification", function() { return __WEBPACK_IMPORTED_MODULE_47__components_notification_notification__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_notification_notifications_group__ = __webpack_require__(49);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_booking_details_card_booking_details_card__ = __webpack_require__(688);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_booking_details_card_booking_details_heading__ = __webpack_require__(699);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_booking_details_card_model__ = __webpack_require__(163);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_guest_details_models__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_guest_details_models___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__components_guest_details_models__);
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_52__components_guest_details_models__, "CloseIcon")) __webpack_require__.d(__webpack_exports__, "CloseIcon", function() { return __WEBPACK_IMPORTED_MODULE_52__components_guest_details_models__["CloseIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_52__components_guest_details_models__, "Collapsible")) __webpack_require__.d(__webpack_exports__, "Collapsible", function() { return __WEBPACK_IMPORTED_MODULE_52__components_guest_details_models__["Collapsible"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_52__components_guest_details_models__, "EditIcon")) __webpack_require__.d(__webpack_exports__, "EditIcon", function() { return __WEBPACK_IMPORTED_MODULE_52__components_guest_details_models__["EditIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_52__components_guest_details_models__, "Spinner")) __webpack_require__.d(__webpack_exports__, "Spinner", function() { return __WEBPACK_IMPORTED_MODULE_52__components_guest_details_models__["Spinner"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_52__components_guest_details_models__, "SpinnerIcon")) __webpack_require__.d(__webpack_exports__, "SpinnerIcon", function() { return __WEBPACK_IMPORTED_MODULE_52__components_guest_details_models__["SpinnerIcon"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_guest_details_guest_details__ = __webpack_require__(233);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_guest_details_guest_details_modal_trigger__ = __webpack_require__(714);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_money_money__ = __webpack_require__(77);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_bedding_details_bedding_details__ = __webpack_require__(238);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_bedding_details_bedding_details_modal_trigger__ = __webpack_require__(718);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_bedding_details_models__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_bedding_details_models___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__components_bedding_details_models__);
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_58__components_bedding_details_models__, "CloseIcon")) __webpack_require__.d(__webpack_exports__, "CloseIcon", function() { return __WEBPACK_IMPORTED_MODULE_58__components_bedding_details_models__["CloseIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_58__components_bedding_details_models__, "Collapsible")) __webpack_require__.d(__webpack_exports__, "Collapsible", function() { return __WEBPACK_IMPORTED_MODULE_58__components_bedding_details_models__["Collapsible"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_58__components_bedding_details_models__, "EditIcon")) __webpack_require__.d(__webpack_exports__, "EditIcon", function() { return __WEBPACK_IMPORTED_MODULE_58__components_bedding_details_models__["EditIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_58__components_bedding_details_models__, "Spinner")) __webpack_require__.d(__webpack_exports__, "Spinner", function() { return __WEBPACK_IMPORTED_MODULE_58__components_bedding_details_models__["Spinner"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_58__components_bedding_details_models__, "SpinnerIcon")) __webpack_require__.d(__webpack_exports__, "SpinnerIcon", function() { return __WEBPACK_IMPORTED_MODULE_58__components_bedding_details_models__["SpinnerIcon"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_orders_model__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_orders_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__components_orders_model__);
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_59__components_orders_model__, "CloseIcon")) __webpack_require__.d(__webpack_exports__, "CloseIcon", function() { return __WEBPACK_IMPORTED_MODULE_59__components_orders_model__["CloseIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_59__components_orders_model__, "Collapsible")) __webpack_require__.d(__webpack_exports__, "Collapsible", function() { return __WEBPACK_IMPORTED_MODULE_59__components_orders_model__["Collapsible"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_59__components_orders_model__, "EditIcon")) __webpack_require__.d(__webpack_exports__, "EditIcon", function() { return __WEBPACK_IMPORTED_MODULE_59__components_orders_model__["EditIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_59__components_orders_model__, "Spinner")) __webpack_require__.d(__webpack_exports__, "Spinner", function() { return __WEBPACK_IMPORTED_MODULE_59__components_orders_model__["Spinner"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_59__components_orders_model__, "SpinnerIcon")) __webpack_require__.d(__webpack_exports__, "SpinnerIcon", function() { return __WEBPACK_IMPORTED_MODULE_59__components_orders_model__["SpinnerIcon"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_orders_helpers__ = __webpack_require__(66);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_orders_orders__ = __webpack_require__(721);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_orders_orders_heading__ = __webpack_require__(239);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_orders_edit_order__ = __webpack_require__(240);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_orders_edit_order_modal_trigger__ = __webpack_require__(730);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_dining_details_dining_details__ = __webpack_require__(241);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_dining_details_dining_details_modal_trigger__ = __webpack_require__(737);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_dining_details_models__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_dining_details_models___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__components_dining_details_models__);
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_67__components_dining_details_models__, "CloseIcon")) __webpack_require__.d(__webpack_exports__, "CloseIcon", function() { return __WEBPACK_IMPORTED_MODULE_67__components_dining_details_models__["CloseIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_67__components_dining_details_models__, "Collapsible")) __webpack_require__.d(__webpack_exports__, "Collapsible", function() { return __WEBPACK_IMPORTED_MODULE_67__components_dining_details_models__["Collapsible"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_67__components_dining_details_models__, "EditIcon")) __webpack_require__.d(__webpack_exports__, "EditIcon", function() { return __WEBPACK_IMPORTED_MODULE_67__components_dining_details_models__["EditIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_67__components_dining_details_models__, "Spinner")) __webpack_require__.d(__webpack_exports__, "Spinner", function() { return __WEBPACK_IMPORTED_MODULE_67__components_dining_details_models__["Spinner"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_67__components_dining_details_models__, "SpinnerIcon")) __webpack_require__.d(__webpack_exports__, "SpinnerIcon", function() { return __WEBPACK_IMPORTED_MODULE_67__components_dining_details_models__["SpinnerIcon"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_cancel_booking_cancel_booking__ = __webpack_require__(242);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_cancel_booking_cancel_booking_modal_trigger__ = __webpack_require__(243);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_cancel_booking_cancellation_info__ = __webpack_require__(740);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_cancel_booking_models__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_cancel_booking_models___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__components_cancel_booking_models__);
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_71__components_cancel_booking_models__, "CloseIcon")) __webpack_require__.d(__webpack_exports__, "CloseIcon", function() { return __WEBPACK_IMPORTED_MODULE_71__components_cancel_booking_models__["CloseIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_71__components_cancel_booking_models__, "Collapsible")) __webpack_require__.d(__webpack_exports__, "Collapsible", function() { return __WEBPACK_IMPORTED_MODULE_71__components_cancel_booking_models__["Collapsible"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_71__components_cancel_booking_models__, "EditIcon")) __webpack_require__.d(__webpack_exports__, "EditIcon", function() { return __WEBPACK_IMPORTED_MODULE_71__components_cancel_booking_models__["EditIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_71__components_cancel_booking_models__, "Spinner")) __webpack_require__.d(__webpack_exports__, "Spinner", function() { return __WEBPACK_IMPORTED_MODULE_71__components_cancel_booking_models__["Spinner"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_71__components_cancel_booking_models__, "SpinnerIcon")) __webpack_require__.d(__webpack_exports__, "SpinnerIcon", function() { return __WEBPACK_IMPORTED_MODULE_71__components_cancel_booking_models__["SpinnerIcon"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_invoice_details_models__ = __webpack_require__(166);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_invoice_details_invoice_details__ = __webpack_require__(245);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_invoice_details_invoice_details_modal_trigger__ = __webpack_require__(756);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_spinner_spinner__ = __webpack_require__(757);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Spinner", function() { return __WEBPACK_IMPORTED_MODULE_75__components_spinner_spinner__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_footer_booked_footer__ = __webpack_require__(759);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_hub_app_hub_app_download__ = __webpack_require__(253);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_promotional_modules_model__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_promotional_modules_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__components_promotional_modules_model__);
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_78__components_promotional_modules_model__, "CloseIcon")) __webpack_require__.d(__webpack_exports__, "CloseIcon", function() { return __WEBPACK_IMPORTED_MODULE_78__components_promotional_modules_model__["CloseIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_78__components_promotional_modules_model__, "Collapsible")) __webpack_require__.d(__webpack_exports__, "Collapsible", function() { return __WEBPACK_IMPORTED_MODULE_78__components_promotional_modules_model__["Collapsible"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_78__components_promotional_modules_model__, "EditIcon")) __webpack_require__.d(__webpack_exports__, "EditIcon", function() { return __WEBPACK_IMPORTED_MODULE_78__components_promotional_modules_model__["EditIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_78__components_promotional_modules_model__, "SpinnerIcon")) __webpack_require__.d(__webpack_exports__, "SpinnerIcon", function() { return __WEBPACK_IMPORTED_MODULE_78__components_promotional_modules_model__["SpinnerIcon"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_promotional_modules_promotional_modules__ = __webpack_require__(770);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_store_banner_store_banner__ = __webpack_require__(772);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_itinerary_calendar_itinerary_calendar__ = __webpack_require__(774);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_product_card_product_card__ = __webpack_require__(254);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_product_carousel_product_carousel__ = __webpack_require__(784);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_collapsible_collapsible__ = __webpack_require__(251);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Collapsible", function() { return __WEBPACK_IMPORTED_MODULE_84__components_collapsible_collapsible__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_shorex_recommendations_shorex_recommendations_banner__ = __webpack_require__(786);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__components_cruise_tips_cruise_tip__ = __webpack_require__(255);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__components_cruise_tips_cruise_tips_stack__ = __webpack_require__(789);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__components_print_documents_print_documents__ = __webpack_require__(256);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__components_print_documents_print_documents_modal__ = __webpack_require__(257);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__components_print_documents_print_documents_modal_trigger__ = __webpack_require__(793);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__components_booking_selector_booking_selector__ = __webpack_require__(112);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__components_social_social_share_buttons__ = __webpack_require__(229);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__components_social_share_itinerary_button__ = __webpack_require__(228);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__components_social_models__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__components_social_models___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94__components_social_models__);
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_94__components_social_models__, "CloseIcon")) __webpack_require__.d(__webpack_exports__, "CloseIcon", function() { return __WEBPACK_IMPORTED_MODULE_94__components_social_models__["CloseIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_94__components_social_models__, "EditIcon")) __webpack_require__.d(__webpack_exports__, "EditIcon", function() { return __WEBPACK_IMPORTED_MODULE_94__components_social_models__["EditIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_94__components_social_models__, "SpinnerIcon")) __webpack_require__.d(__webpack_exports__, "SpinnerIcon", function() { return __WEBPACK_IMPORTED_MODULE_94__components_social_models__["SpinnerIcon"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__components_social_facebook_countdown_share_button__ = __webpack_require__(795);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__components_reservation_form_reservation_form__ = __webpack_require__(797);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__components_email_invitation_email_invitation_form__ = __webpack_require__(258);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__components_email_invitation_model__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__components_email_invitation_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_98__components_email_invitation_model__);
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_98__components_email_invitation_model__, "CloseIcon")) __webpack_require__.d(__webpack_exports__, "CloseIcon", function() { return __WEBPACK_IMPORTED_MODULE_98__components_email_invitation_model__["CloseIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_98__components_email_invitation_model__, "EditIcon")) __webpack_require__.d(__webpack_exports__, "EditIcon", function() { return __WEBPACK_IMPORTED_MODULE_98__components_email_invitation_model__["EditIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_98__components_email_invitation_model__, "SpinnerIcon")) __webpack_require__.d(__webpack_exports__, "SpinnerIcon", function() { return __WEBPACK_IMPORTED_MODULE_98__components_email_invitation_model__["SpinnerIcon"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__components_travel_companion_travel_companion_section__ = __webpack_require__(802);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__components_travel_companion_travel_companion_form__ = __webpack_require__(811);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__components_travel_companion_model__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__components_travel_companion_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_101__components_travel_companion_model__);
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_101__components_travel_companion_model__, "CloseIcon")) __webpack_require__.d(__webpack_exports__, "CloseIcon", function() { return __WEBPACK_IMPORTED_MODULE_101__components_travel_companion_model__["CloseIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_101__components_travel_companion_model__, "EditIcon")) __webpack_require__.d(__webpack_exports__, "EditIcon", function() { return __WEBPACK_IMPORTED_MODULE_101__components_travel_companion_model__["EditIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_101__components_travel_companion_model__, "SpinnerIcon")) __webpack_require__.d(__webpack_exports__, "SpinnerIcon", function() { return __WEBPACK_IMPORTED_MODULE_101__components_travel_companion_model__["SpinnerIcon"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__components_generic_header_generic_header__ = __webpack_require__(816);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__components_guest_list_model__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__components_guest_list_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_103__components_guest_list_model__);
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_103__components_guest_list_model__, "CloseIcon")) __webpack_require__.d(__webpack_exports__, "CloseIcon", function() { return __WEBPACK_IMPORTED_MODULE_103__components_guest_list_model__["CloseIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_103__components_guest_list_model__, "EditIcon")) __webpack_require__.d(__webpack_exports__, "EditIcon", function() { return __WEBPACK_IMPORTED_MODULE_103__components_guest_list_model__["EditIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_103__components_guest_list_model__, "SpinnerIcon")) __webpack_require__.d(__webpack_exports__, "SpinnerIcon", function() { return __WEBPACK_IMPORTED_MODULE_103__components_guest_list_model__["SpinnerIcon"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__components_guest_list_guest_list__ = __webpack_require__(260);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__components_travel_companion_travel_companion_lists__ = __webpack_require__(259);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__components_travel_companion_travel_companion_conflict_modal__ = __webpack_require__(167);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__components_travel_companion_travel_companion_remove_card__ = __webpack_require__(261);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__components_travel_companion_travel_companion_remove_modal_trigger__ = __webpack_require__(823);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__components_onboard_credit_onboard_credit__ = __webpack_require__(250);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__components_insurance_model__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__components_insurance_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_110__components_insurance_model__);
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_110__components_insurance_model__, "CloseIcon")) __webpack_require__.d(__webpack_exports__, "CloseIcon", function() { return __WEBPACK_IMPORTED_MODULE_110__components_insurance_model__["CloseIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_110__components_insurance_model__, "EditIcon")) __webpack_require__.d(__webpack_exports__, "EditIcon", function() { return __WEBPACK_IMPORTED_MODULE_110__components_insurance_model__["EditIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_110__components_insurance_model__, "SpinnerIcon")) __webpack_require__.d(__webpack_exports__, "SpinnerIcon", function() { return __WEBPACK_IMPORTED_MODULE_110__components_insurance_model__["SpinnerIcon"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__components_insurance_insurance_modal__ = __webpack_require__(248);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__components_edit_booking_edit_booking_modal_trigger__ = __webpack_require__(825);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__components_edit_booking_edit_booking__ = __webpack_require__(262);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__components_edit_booking_edit_booking_tile__ = __webpack_require__(263);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__components_edit_booking_models__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__components_edit_booking_models___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_115__components_edit_booking_models__);
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_115__components_edit_booking_models__, "CloseIcon")) __webpack_require__.d(__webpack_exports__, "CloseIcon", function() { return __WEBPACK_IMPORTED_MODULE_115__components_edit_booking_models__["CloseIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_115__components_edit_booking_models__, "EditIcon")) __webpack_require__.d(__webpack_exports__, "EditIcon", function() { return __WEBPACK_IMPORTED_MODULE_115__components_edit_booking_models__["EditIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_115__components_edit_booking_models__, "SpinnerIcon")) __webpack_require__.d(__webpack_exports__, "SpinnerIcon", function() { return __WEBPACK_IMPORTED_MODULE_115__components_edit_booking_models__["SpinnerIcon"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__components_cancel_booking_view_cancellation_info_modal_trigger__ = __webpack_require__(828);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__components_cancel_booking_view_cancellation_info_modal__ = __webpack_require__(264);
/* unused harmony namespace reexport */
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_71__components_cancel_booking_models__, "CloseIcon")) __webpack_require__.d(__webpack_exports__, "CloseIcon", function() { return __WEBPACK_IMPORTED_MODULE_71__components_cancel_booking_models__["CloseIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_71__components_cancel_booking_models__, "EditIcon")) __webpack_require__.d(__webpack_exports__, "EditIcon", function() { return __WEBPACK_IMPORTED_MODULE_71__components_cancel_booking_models__["EditIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_71__components_cancel_booking_models__, "SpinnerIcon")) __webpack_require__.d(__webpack_exports__, "SpinnerIcon", function() { return __WEBPACK_IMPORTED_MODULE_71__components_cancel_booking_models__["SpinnerIcon"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__components_guest_details_guest_action_confirmation__ = __webpack_require__(265);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__components_guest_details_guest_action_confirmation_modal_trigger__ = __webpack_require__(831);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__components_remove_guest_remove_guest_modal_trigger__ = __webpack_require__(832);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__components_remove_guest_remove_guest_item__ = __webpack_require__(266);
/* unused harmony namespace reexport */
__webpack_require__(520);



























































































































//# sourceMappingURL=cclr-huge-ui.js.map

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NotificationsGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notifications_group_css__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notifications_group_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__notifications_group_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notification__ = __webpack_require__(64);



var NotificationsGroup = function (_a) {
    var notifications = _a.notifications, closeAriaLabel = _a.closeAriaLabel, autoCloseAriaLabel = _a.autoCloseAriaLabel, className = _a.className, onCloseGroup = _a.onCloseGroup;
    if (!notifications || !notifications.length) {
        return null;
    }
    var successMessages = notifications
        .filter(function (notification) { return notification.type === 'success'; })
        .map(function (notification) { return notification.message; });
    var errorMessages = notifications
        .filter(function (notification) { return notification.type === 'error'; })
        .map(function (notification) { return notification.message; });
    var urgentMessages = notifications
        .filter(function (notification) { return notification.type === 'urgent'; })
        .map(function (notification) { return notification.message; });
    var infoMessages = notifications
        .filter(function (notification) { return notification.type === 'info'; })
        .map(function (notification) { return notification.message; });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: className, "aria-live": "assertive", role: "alert" },
        renderGroup('success', successMessages, closeAriaLabel, autoCloseAriaLabel, function () { return onCloseGroup('success'); }),
        renderGroup('error', errorMessages, closeAriaLabel, autoCloseAriaLabel, function () { return onCloseGroup('error'); }),
        renderGroup('urgent', urgentMessages, closeAriaLabel, autoCloseAriaLabel, function () { return onCloseGroup('urgent'); }),
        renderGroup('info', infoMessages, closeAriaLabel, autoCloseAriaLabel, function () { return onCloseGroup('info'); })));
};
function renderGroup(type, messages, closeAriaLabel, autoCloseAriaLabel, onClose) {
    if (!messages || !messages.length) {
        return null;
    }
    if (type === 'success' || type === 'info') {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__notification__["a" /* Notification */], { type: type, mode: "edge", closeMode: "auto", closeAriaLabel: autoCloseAriaLabel, onClose: onClose }, renderMessages(messages)));
    }
    else {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__notification__["a" /* Notification */], { type: type, mode: "edge", closeMode: "manual", closeAriaLabel: closeAriaLabel, onClose: onClose }, renderMessages(messages)));
    }
}
function renderMessages(messages) {
    return messages.map(function (message, i) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: i }, message)); });
}
//# sourceMappingURL=notifications-group.js.map

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(123)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(67)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 51 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(20);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(22);
var dPs = __webpack_require__(125);
var enumBugKeys = __webpack_require__(59);
var IE_PROTO = __webpack_require__(57)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(68)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(98).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(51);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(58)('keys');
var uid = __webpack_require__(39);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(8);
var global = __webpack_require__(12);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(33) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 59 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(11);


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(12);
var core = __webpack_require__(8);
var LIBRARY = __webpack_require__(33);
var wksExt = __webpack_require__(60);
var defineProperty = __webpack_require__(17).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 62 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export validation */
/* unused harmony export DynatraceApi */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ccl_fetch__ = __webpack_require__(414);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ccl_fetch__["a"]; });
/* unused harmony reexport cclFetchRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__load_js__ = __webpack_require__(415);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__load_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__load_css__ = __webpack_require__(416);
/* unused harmony reexport loadCSS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dispatchEvent__ = __webpack_require__(417);
/* unused harmony reexport dispatchEvent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__input_validation__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cookies_service__ = __webpack_require__(182);
/* unused harmony reexport CookieService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__local_storage_service__ = __webpack_require__(183);
/* unused harmony reexport LocalStorageService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__locality_service__ = __webpack_require__(420);
/* unused harmony reexport LocalityService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dynatrace_api__ = __webpack_require__(421);





var validation = __WEBPACK_IMPORTED_MODULE_4__input_validation__;




var DynatraceApi = __WEBPACK_IMPORTED_MODULE_8__dynatrace_api__;
//# sourceMappingURL=ccl-utilities.js.map

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Notification; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notification_css__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notification_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__notification_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icons__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_colors__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icons_close_timer_icon__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__timer_timer__ = __webpack_require__(156);








var iconMap = {
    'success': __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__icons__["CheckmarkIcon"], { width: "16", height: "16" }),
    'info': __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__icons__["ExclamationIcon"], { width: "16", height: "16", textColor: __WEBPACK_IMPORTED_MODULE_5__styles_colors__["b" /* Blue600Color */], borderColor: __WEBPACK_IMPORTED_MODULE_5__styles_colors__["g" /* Red700Color */] }),
    'error': __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__icons__["SadFaceIcon"], { width: "16", height: "16" }),
    'urgent': __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__icons__["SadFaceIcon"], { width: "16", height: "16" })
};
var Notification = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Notification, _super);
    function Notification() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.timerRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.contentRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.state = {
            closing: false,
            centerContent: false
        };
        _this.pauseTimer = function () {
            if (_this.timerRef.current) {
                _this.timerRef.current.pause();
            }
        };
        _this.resumeTimer = function () {
            if (_this.timerRef.current) {
                _this.timerRef.current.resume();
            }
        };
        _this.onClose = function (event) {
            if (event) {
                event.preventDefault();
            }
            _this.startClosing();
        };
        _this.onCloseAndStopTimer = function (stopTimer, event) {
            if (event) {
                event.preventDefault();
            }
            if (typeof stopTimer === 'function') {
                stopTimer();
            }
            _this.startClosing();
        };
        _this.startClosing = function () {
            if (!_this.state.closing) {
                _this.setState({ closing: true }, function () { return setTimeout(_this.close, 500); });
            }
        };
        _this.close = function () {
            var onClose = _this.props.onClose;
            _this.setState({ closing: false }, function () { return onClose(); });
        };
        return _this;
    }
    Notification.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.computeAlignment();
    };
    Notification.prototype.componentDidMount = function () {
        this.computeAlignment();
    };
    Notification.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, type = _a.type, mode = _a.mode;
        if (!children) {
            return null;
        }
        var _b = this.state, closing = _b.closing, centerContent = _b.centerContent;
        var cn = __WEBPACK_IMPORTED_MODULE_2_classnames__('d-print-none', "h-notification h-notification--" + type, className, { 'h-notification--centered': centerContent, 'h-notification--hidden': closing });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: cn }, mode === 'edge' ?
            this.renderEdge() :
            this.renderContent()));
    };
    Notification.prototype.renderEdge = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "container" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col" }, this.renderContent()))));
    };
    Notification.prototype.renderContent = function () {
        var _a = this.props, children = _a.children, type = _a.type, hideIcon = _a.hideIcon, bodyClassName = _a.bodyClassName;
        var bodyClass = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-notification__body', bodyClassName);
        var contentClass = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-notification__content', { 'h-notification__content--no-icon': hideIcon });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: bodyClass, onMouseEnter: this.pauseTimer, onMouseLeave: this.resumeTimer },
            !hideIcon && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-notification__icon", "aria-hidden": true }, iconMap[type]),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: contentClass, ref: this.contentRef }, children),
            this.renderCloseButton()));
    };
    Notification.prototype.renderCloseButton = function () {
        var _this = this;
        var _a = this.props, type = _a.type, closeMode = _a.closeMode;
        var closeIconColor = type === 'info' ? __WEBPACK_IMPORTED_MODULE_5__styles_colors__["a" /* BlackColor */] : __WEBPACK_IMPORTED_MODULE_5__styles_colors__["i" /* WhiteColor */];
        if (closeMode === 'manual') {
            var closeAriaLabel = this.props.closeAriaLabel;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-notification__close" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "", role: "button", "aria-label": closeAriaLabel, onClick: this.onClose },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__icons__["CloseIcon"], { className: "h-notification__close-icon", "aria-hidden": "true", width: 24, height: 24, color: closeIconColor }))));
        }
        else if (closeMode === 'auto') {
            var closeAriaLabel_1 = this.props.closeAriaLabel;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__timer_timer__["a" /* Timer */], { intervalMs: 100, maxIterations: 100, onTerminate: this.startClosing, ref: this.timerRef }, function (counter, stopTimer) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-notification__close" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "", role: "button", "aria-label": closeAriaLabel_1, 
                        // tslint:disable-next-line:no-any
                        onClick: _this.onCloseAndStopTimer.bind(_this, stopTimer) },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__icons_close_timer_icon__["a" /* CloseTimerIcon */], { className: "h-notification__close-icon", "aria-hidden": "true", width: 24, height: 24, color: closeIconColor, percent: counter }))));
            }));
        }
        return null;
    };
    Notification.prototype.computeAlignment = function () {
        if (this.contentRef.current) {
            var centerContent_1 = this.contentRef.current.offsetHeight <= 30;
            this.setState(function (prevState) {
                if (prevState.centerContent === centerContent_1) {
                    return null;
                }
                return { centerContent: centerContent_1 };
            });
        }
    };
    return Notification;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=notification.js.map

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _classCallCheck = _interopDefault(__webpack_require__(198));
var _createClass = _interopDefault(__webpack_require__(199));
var _possibleConstructorReturn = _interopDefault(__webpack_require__(200));
var _getPrototypeOf = _interopDefault(__webpack_require__(201));
var _inherits = _interopDefault(__webpack_require__(202));
var _typeof = _interopDefault(__webpack_require__(93));
var _objectWithoutProperties = _interopDefault(__webpack_require__(203));
var _extends = _interopDefault(__webpack_require__(204));
var React = _interopDefault(__webpack_require__(0));
var PropTypes = _interopDefault(__webpack_require__(26));
var warning = _interopDefault(__webpack_require__(205));

function defineProperty(object, property, attr) {
  return Object.defineProperty(object, property, attr);
} // Passive options
// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js


var passiveOption = function () {
  var cache = null;
  return function () {
    if (cache !== null) {
      return cache;
    }

    var supportsPassiveOption = false;

    try {
      window.addEventListener('test', null, defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      }));
    } catch (err) {//
    }

    cache = supportsPassiveOption;
    return supportsPassiveOption;
  }();
}();

var defaultEventOptions = {
  capture: false,
  passive: false
};

function mergeDefaultEventOptions(options) {
  return _extends({}, defaultEventOptions, options);
}

function getEventListenerArgs(eventName, callback, options) {
  var args = [eventName, callback];
  args.push(passiveOption ? options : options.capture);
  return args;
}

function on(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function off(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function forEachListener(props, iteratee) {
  var children = props.children,
      target = props.target,
      eventProps = _objectWithoutProperties(props, ["children", "target"]);

  Object.keys(eventProps).forEach(function (name) {
    if (name.substring(0, 2) !== 'on') {
      return;
    }

    var prop = eventProps[name];

    var type = _typeof(prop);

    var isObject = type === 'object';
    var isFunction = type === 'function';

    if (!isObject && !isFunction) {
      return;
    }

    var capture = name.substr(-7).toLowerCase() === 'capture';
    var eventName = name.substring(2).toLowerCase();
    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;

    if (isObject) {
      iteratee(eventName, prop.handler, prop.options);
    } else {
      iteratee(eventName, prop, mergeDefaultEventOptions({
        capture: capture
      }));
    }
  });
}

function withOptions(handler, options) {
   false ? warning(options, 'react-event-listener: should be specified options in withOptions.') : void 0;
  return {
    handler: handler,
    options: mergeDefaultEventOptions(options)
  };
}

var EventListener =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(EventListener, _React$PureComponent);

  function EventListener() {
    _classCallCheck(this, EventListener);

    return _possibleConstructorReturn(this, _getPrototypeOf(EventListener).apply(this, arguments));
  }

  _createClass(EventListener, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.applyListeners(on);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.applyListeners(off, prevProps);
      this.applyListeners(on);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.applyListeners(off);
    }
  }, {
    key: "applyListeners",
    value: function applyListeners(onOrOff) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
      var target = props.target;

      if (target) {
        var element = target;

        if (typeof target === 'string') {
          element = window[target];
        }

        forEachListener(props, onOrOff.bind(null, element));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children || null;
    }
  }]);

  return EventListener;
}(React.PureComponent);

EventListener.propTypes =  false ? {
  /**
   * You can provide a single child too.
   */
  children: PropTypes.node,

  /**
   * The DOM target to listen to.
   */
  target: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired
} : {};

exports.withOptions = withOptions;
exports.default = EventListener;


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getJointKeys;
/* harmony export (immutable) */ __webpack_exports__["d"] = guestGuestList;
/* harmony export (immutable) */ __webpack_exports__["a"] = getEditOrderLinkId;
/* harmony export (immutable) */ __webpack_exports__["i"] = showQuantity;
/* harmony export (immutable) */ __webpack_exports__["h"] = showGuests;
/* harmony export (immutable) */ __webpack_exports__["g"] = showGuestDetails;
/* harmony export (immutable) */ __webpack_exports__["f"] = joinOrderSummaryGuests;
/* unused harmony export withDetailsExpanded */
/* unused harmony export withLineRemoved */
/* unused harmony export withGuestRemoved */
/* unused harmony export setAdjustment */
/* harmony export (immutable) */ __webpack_exports__["c"] = getRemovedGuests;
/* harmony export (immutable) */ __webpack_exports__["e"] = isOrderEditable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

function getJointKeys() {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
    }
    return params.reduce(function (acc, param) { return "" + acc + (!!acc ? '-' : '') + param; }, '');
}
function guestGuestList(guests) {
    return guests.reduce(function (acc, g) { return "" + acc + (!!acc ? ', ' : '') + g.fullName; }, '');
}
function getEditOrderLinkId(bookingNumber, orderNumber) {
    return "edit-order-link-" + bookingNumber + "-" + orderNumber;
}
function showQuantity(orderType) {
    return orderType === 'FS';
}
function showGuests(orderType) {
    return orderType !== 'XD';
}
function showGuestDetails(orderType) {
    return orderType === 'XD';
}
function joinOrderSummaryGuests(line) {
    var entries = [];
    line.bookings.forEach(function (b) { return b.guests.forEach(function (g) { return entries.push(g.firstName + " " + g.lastName); }); });
    return entries.join(', ');
}
function withDetailsExpanded(detailsExpanded, line, order) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, order), { lineItems: order.lineItems.map(function (li) {
            if (li === line) {
                return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, li), { detailsExpanded: detailsExpanded });
            }
            return li;
        }) });
}
function withLineRemoved(isRemoved, line, order) {
    return setAdjustment(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, order), { lineItems: order.lineItems.map(function (li) {
            if (li === line) {
                return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, li), { bookings: li.bookings.map(function (b) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, b), { guests: b.guests.map(function (g) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, g), { isRemoved: false })); }) })); }), isRemoved: isRemoved });
            }
            return li;
        }) }));
}
// tslint:disable-next-line:max-line-length
function withGuestRemoved(isRemoved, guest, booking, line, order) {
    return setAdjustment(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, order), { lineItems: order.lineItems.map(function (li) {
            if (li === line) {
                return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, li), { bookings: li.bookings.map(function (b) {
                        if (b === booking) {
                            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, b), { guests: b.guests.map(function (g) {
                                    if (g === guest) {
                                        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, g), { isRemoved: isRemoved });
                                    }
                                    return g;
                                }) });
                        }
                        return b;
                    }) });
            }
            return li;
        }) }));
}
function setAdjustment(order) {
    var value = 0;
    order.lineItems.forEach(function (l) { return l.bookings.forEach(function (b) { return b.guests.forEach(function (g) { return value += l.isRemoved || g.isRemoved ? g.price : 0; }); }); });
    value = roundNumber(value);
    order.adjustment = value;
    order.adjustmentFormatted = order.currencyTemplate.replace('XX', value.toFixed(2));
    return order;
}
function getRemovedGuests(order) {
    var guests = [];
    order.lineItems.forEach(function (l) { return l.bookings.forEach(function (b) { return b.guests.forEach(function (g) {
        if (l.isRemoved || g.isRemoved) {
            guests.push({ seqNumber: g.seqNumber, bookingNumber: b.bookingNumber, productId: l.productId });
        }
    }); }); });
    return guests;
}
function isOrderEditable(order) {
    return order.allowPartialEdits || order.editAction === 'remove';
}
function roundNumber(num) {
    return Math.round(num * 100) / 100;
}
//# sourceMappingURL=helpers.js.map

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(33);
var $export = __webpack_require__(15);
var redefine = __webpack_require__(81);
var hide = __webpack_require__(21);
var Iterators = __webpack_require__(30);
var $iterCreate = __webpack_require__(124);
var setToStringTag = __webpack_require__(40);
var getPrototypeOf = __webpack_require__(99);
var ITERATOR = __webpack_require__(11)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var document = __webpack_require__(12).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(38);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(401), __esModule: true };

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(403);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(47);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(406);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(410);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(47);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LinkButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icons__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__button_css__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__button_css__);





var SizeMap = {
    'small': 'h-btn--sm',
    'regular': '',
    'large': 'h-btn--lg'
};
var IconSizeMap = {
    'small': 13,
    'regular': 15,
    'large': 18,
};
var ColorMap = {
    'red': 'h-btn--red',
    'blue': 'h-btn--blue',
    'black': 'h-btn--black',
    'white': 'h-btn--white',
    'outline-red': 'h-btn--outline-red',
    'outline-blue': 'h-btn--outline-blue',
    'outline-black': 'h-btn--outline-black',
    'outline-white': 'h-btn--outline-white'
};
var LinkButton = function (_a) {
    var children = _a.children, color = _a.color, size = _a.size, block = _a.block, className = _a.className, elRef = _a.elRef, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["children", "color", "size", "block", "className", "elRef"]);
    var sizeClassName = SizeMap[size || 'regular'];
    var colorClassName = ColorMap[color || 'red'];
    var blockClassName = block ? 'h-btn--block' : undefined;
    var classes = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-btn', sizeClassName, colorClassName, blockClassName, className);
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ ref: elRef, className: classes }, otherProps), children);
};
var Button = function (_a) {
    var children = _a.children, color = _a.color, size = _a.size, block = _a.block, busy = _a.busy, className = _a.className, elRef = _a.elRef, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["children", "color", "size", "block", "busy", "className", "elRef"]);
    var sizeClassName = SizeMap[size || 'regular'];
    var colorClassName = ColorMap[color || 'red'];
    var blockClassName = block ? 'h-btn--block' : undefined;
    var classes = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-btn', sizeClassName, colorClassName, blockClassName, className);
    var iconSize = IconSizeMap[size || 'regular'];
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ ref: elRef, className: classes }, otherProps),
        busy &&
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__icons__["SpinnerIcon"], { className: "h-btn__icon", circleClassName: "h-btn__icon-circle", width: iconSize, height: iconSize }),
        children));
};
//# sourceMappingURL=button.js.map

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MediaQuery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


/**
 * Slimmed down version of:
 * https://github.com/ReactTraining/react-media
 */
var MediaQuery = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(MediaQuery, _super);
    function MediaQuery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            matches: _this.props.defaultMatches
        };
        _this.updateMatches = function () { return _this.setState({ matches: _this._mediaQueryList.matches }); };
        return _this;
    }
    MediaQuery.prototype.componentWillMount = function () {
        var query = this.props.query;
        this._mediaQueryList = window.matchMedia(query);
        this._mediaQueryList.addListener(this.updateMatches);
        this.updateMatches();
    };
    MediaQuery.prototype.componentWillUnmount = function () {
        this._mediaQueryList.removeListener(this.updateMatches);
    };
    MediaQuery.prototype.render = function () {
        var _a = this.props, children = _a.children, render = _a.render;
        var matches = this.state.matches;
        if (render) {
            return matches ? render() : null;
        }
        if (children) {
            if (typeof children === 'function') {
                return children(matches);
            }
            else {
                return matches ? __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(children) : null;
            }
        }
        return null;
    };
    return MediaQuery;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=media-query.js.map

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Money; });
/* harmony export (immutable) */ __webpack_exports__["b"] = money;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var Money = function (_a) {
    var amount = _a.amount, currencyCode = _a.currencyCode, currencySymbol = _a.currencySymbol, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["amount", "currencyCode", "currencySymbol"]);
    if (!amount) {
        return null;
    }
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, otherProps), money(amount, currencyCode, currencySymbol));
};
function money(amount, currencyCode, currencySymbol) {
    if (!amount) {
        return '';
    }
    currencyCode = currencyCode || '';
    currencySymbol = currencySymbol || '';
    if (currencyCode === 'USD' || currencyCode === 'EUR' || currencyCode === 'GBP') {
        return "" + currencySymbol + amount.toFixed(2);
    }
    return currencyCode + " " + currencySymbol + amount.toFixed(2);
}
//# sourceMappingURL=money.js.map

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewInvoiceLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model__ = __webpack_require__(163);


var ViewInvoiceLink = function (_a) {
    var data = _a.data, content = _a.content, onViewBalance = _a.onViewBalance;
    var describedById = Object(__WEBPACK_IMPORTED_MODULE_1__model__["a" /* genId */])(data.bookingNumber, 'view-balance');
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "d-flex flex-column align-items-md-center flex-md-row h-bk-dtl-card__footer-left-row" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: "h-bk-dtl-card__action-link", href: "#", id: describedById, onClick: onViewBalance, "aria-label": (content.viewBalanceDetailsAriaLabel || '').replace('{BookingNumber}', data.bookingNumber), role: "button" }, content.viewBalanceDetails))));
};
//# sourceMappingURL=view-invoice-link.js.map

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StateroomTabPanelClassName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StateroomTabPanelSelectedClassName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StateroomTabDisabledClassName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return StateroomTabs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tabs__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scrollable_tab_list_scrollable_tab_list__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__eyebrow_eyebrow__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__chevron_chevron_circle__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_colors__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__stateroom_tabs_css__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__stateroom_tabs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__stateroom_tabs_css__);









var StateroomTabPanelClassName = 'h-stateroom-tabs__tabpanel';
var StateroomTabPanelSelectedClassName = 'h-stateroom-tabs__tabpanel--active';
var StateroomTabDisabledClassName = 'h-stateroom-tabs--disabled';
var StateroomTabs = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(StateroomTabs, _super);
    function StateroomTabs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSelect = function (index) {
            var _a = _this.props, onSelect = _a.onSelect, tabTitles = _a.tabTitles;
            onSelect(tabTitles[index].id);
        };
        return _this;
    }
    StateroomTabs.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children, tabTitles = _a.tabTitles, enableTabScrolling = _a.enableTabScrolling;
        var selectedIndex = this.getSelectedIndex();
        var hasPrev = selectedIndex > 0 && enableTabScrolling;
        var hasNext = selectedIndex < tabTitles.length - 1 && enableTabScrolling;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_tabs__["d" /* Tabs */], { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-stateroom-tabs', className), selectedIndex: selectedIndex, onSelect: this.onSelect },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__scrollable_tab_list_scrollable_tab_list__["a" /* ScrollableTabList */], { className: "h-stateroom-tabs__container", onSelect: this.onSelect, selectedIndex: selectedIndex, selectedTabSelector: ".h-stateroom-tabs__tab--active", renderPrevArrow: function (props) { return hasPrev && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__chevron_chevron_circle__["a" /* ChevronCircle */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ className: "h-stateroom-tabs__arrow-prev", size: 32, direction: "left", color: __WEBPACK_IMPORTED_MODULE_7__styles_colors__["c" /* BlueColor */], role: "button", "aria-label": "Previous stateroom" }, props))); }, renderNextArrow: function (props) { return hasNext && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__chevron_chevron_circle__["a" /* ChevronCircle */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ className: "h-stateroom-tabs__arrow-next", size: 32, direction: "right", color: __WEBPACK_IMPORTED_MODULE_7__styles_colors__["c" /* BlueColor */], role: "button", "aria-label": "Next stateroom" }, props))); } }, tabTitles.map(function (tab, index) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_tabs__["a" /* Tab */], { key: index, className: "h-stateroom-tabs__tab", selectedClassName: "h-stateroom-tabs__tab--active", disabledClassName: "h-stateroom-tabs--disabled", disabled: !!tab.disabled },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__eyebrow_eyebrow__["a" /* Eyebrow */], null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { "data-pii": "true" }, tab.eyebrow)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h3", { className: "h-stateroom-tabs__title" }, tab.title))); })),
            children));
    };
    StateroomTabs.prototype.getSelectedIndex = function () {
        var _a = this.props, selectedId = _a.selectedId, tabTitles = _a.tabTitles;
        for (var i = 0; i < tabTitles.length; i++) {
            if (tabTitles[i].id === selectedId) {
                return i;
            }
        }
        return -1;
    };
    return StateroomTabs;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=stateroom-tabs.js.map

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(18) && !__webpack_require__(24)(function () {
  return Object.defineProperty(__webpack_require__(68)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(21);


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(23);
var toIObject = __webpack_require__(25);
var arrayIndexOf = __webpack_require__(126)(false);
var IE_PROTO = __webpack_require__(57)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(128);
var global = __webpack_require__(12);
var hide = __webpack_require__(21);
var Iterators = __webpack_require__(30);
var TO_STRING_TAG = __webpack_require__(11)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(39)('meta');
var isObject = __webpack_require__(20);
var has = __webpack_require__(23);
var setDesc = __webpack_require__(17).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(24)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(82);
var hiddenKeys = __webpack_require__(59).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 86 */
/***/ (function(module, exports) {



/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(38);
var TAG = __webpack_require__(11)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getInitialData;
/* harmony export (immutable) */ __webpack_exports__["b"] = populateInitialData;
function getInitialData(key) {
    if ('initialData' in window) {
        // tslint:disable-next-line:no-string-literal no-any
        var initialData = window['initialData'];
        if (initialData) {
            var data = initialData[key];
            if (data) {
                return data;
            }
        }
    }
    return undefined;
}
function populateInitialData(data) {
    for (var propName in data) {
        if (data.hasOwnProperty(propName)) {
            setInitialData(propName, data[propName]);
        }
    }
}
function setInitialData(key, value) {
    // tslint:disable:no-string-literal
    // tslint:disable-next-line:no-any
    var initialData = window['initialData'];
    if (!initialData) {
        // tslint:disable-next-line:no-any
        initialData = window['initialData'] = {};
    }
    initialData[key] = value;
}
//# sourceMappingURL=initial-data-service.js.map

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Eyebrow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eyebrow_css__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eyebrow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__eyebrow_css__);



var Eyebrow = function (_a) {
    var children = _a.children, className = _a.className, tagName = _a.tagName;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](tagName || 'div', { className: __WEBPACK_IMPORTED_MODULE_1_classnames__('h-eyebrow', className) }, children));
};
//# sourceMappingURL=eyebrow.js.map

/***/ }),
/* 93 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var createFocusTrap = __webpack_require__(498);

var checkedProps = ['active', 'paused', 'tag', 'focusTrapOptions', '_createFocusTrap'];

var FocusTrap = function (_React$Component) {
  _inherits(FocusTrap, _React$Component);

  function FocusTrap(props) {
    _classCallCheck(this, FocusTrap);

    var _this = _possibleConstructorReturn(this, (FocusTrap.__proto__ || Object.getPrototypeOf(FocusTrap)).call(this, props));

    _this.setNode = function (el) {
      _this.node = el;
    };

    if (typeof document !== 'undefined') {
      _this.previouslyFocusedElement = document.activeElement;
    }
    return _this;
  }

  _createClass(FocusTrap, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // We need to hijack the returnFocusOnDeactivate option,
      // because React can move focus into the element before we arrived at
      // this lifecycle hook (e.g. with autoFocus inputs). So the component
      // captures the previouslyFocusedElement in componentWillMount,
      // then (optionally) returns focus to it in componentWillUnmount.
      var specifiedFocusTrapOptions = this.props.focusTrapOptions;
      var tailoredFocusTrapOptions = {
        returnFocusOnDeactivate: false
      };
      for (var optionName in specifiedFocusTrapOptions) {
        if (!specifiedFocusTrapOptions.hasOwnProperty(optionName)) continue;
        if (optionName === 'returnFocusOnDeactivate') continue;
        tailoredFocusTrapOptions[optionName] = specifiedFocusTrapOptions[optionName];
      }

      this.focusTrap = this.props._createFocusTrap(this.node, tailoredFocusTrapOptions);
      if (this.props.active) {
        this.focusTrap.activate();
      }
      if (this.props.paused) {
        this.focusTrap.pause();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.active && !this.props.active) {
        this.focusTrap.deactivate();
      } else if (!prevProps.active && this.props.active) {
        this.focusTrap.activate();
      }

      if (prevProps.paused && !this.props.paused) {
        this.focusTrap.unpause();
      } else if (!prevProps.paused && this.props.paused) {
        this.focusTrap.pause();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.focusTrap.deactivate();
      if (this.props.focusTrapOptions.returnFocusOnDeactivate !== false && this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
        this.previouslyFocusedElement.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var elementProps = {
        ref: this.setNode
      };

      // This will get id, className, style, etc. -- arbitrary element props
      for (var prop in this.props) {
        if (!this.props.hasOwnProperty(prop)) continue;
        if (checkedProps.indexOf(prop) !== -1) continue;
        elementProps[prop] = this.props[prop];
      }

      return React.createElement(this.props.tag, elementProps, this.props.children);
    }
  }]);

  return FocusTrap;
}(React.Component);

FocusTrap.defaultProps = {
  active: true,
  tag: 'div',
  paused: false,
  focusTrapOptions: {},
  _createFocusTrap: createFocusTrap
};

module.exports = FocusTrap;

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ExtraSmall */
/* unused harmony export Small */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Medium; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Large; });
/* unused harmony export ExtraLarge */
var ExtraSmall = 0;
var Small = 544;
var Medium = 768;
var Large = 1024;
var ExtraLarge = 1232;
//# sourceMappingURL=breakpoints.js.map

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainNav; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_nav_rect__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main_nav_css__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main_nav_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__main_nav_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main_nav_item__ = __webpack_require__(114);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main_nav_link__ = __webpack_require__(159);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__main_nav_link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main_nav_image__ = __webpack_require__(596);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__main_nav_dropdown__ = __webpack_require__(598);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_8__main_nav_dropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__main_nav_button__ = __webpack_require__(221);
/* unused harmony namespace reexport */





var MainNav = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(MainNav, _super);
    function MainNav() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.elementRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        return _this;
    }
    MainNav.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children, useRectProvider = _a.useRectProvider;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-main-nav', className), ref: this.elementRef }, useRectProvider ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__main_nav_rect__["b" /* MainNavRectProvider */], { mainNavRef: this.elementRef }, children)) : children));
    };
    return MainNav;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

///
/// Export related components
///





//# sourceMappingURL=main-nav.js.map

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChevronCircle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_colors__ = __webpack_require__(6);



function mapDirectionToRotation(direction) {
    switch (direction) {
        case 'up':
            return 'rotate(270deg)';
        case 'down':
            return 'rotate(90deg)';
        case 'left':
            return 'rotate(180deg)';
        default:
            return 'rotate(0deg)';
    }
}
function mapShadowMode(shadowMode) {
    switch (shadowMode) {
        case 'simple':
            return 'drop-shadow(rgba(132, 132, 132, .5) 0px 0px 3px)';
        default:
            return undefined;
    }
}
var ChevronCircle = function (_a) {
    var direction = _a.direction, size = _a.size, circleColor = _a.circleColor, circleFill = _a.circleFill, chevronColor = _a.chevronColor, shadowMode = _a.shadowMode, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["direction", "size", "circleColor", "circleFill", "chevronColor", "shadowMode"]);
    var styles = {
        transform: mapDirectionToRotation(direction),
        filter: mapShadowMode(shadowMode)
    };
    circleColor = circleColor || 'rgba(15, 85, 154, 0.3)';
    circleFill = circleFill || __WEBPACK_IMPORTED_MODULE_2__styles_colors__["i" /* WhiteColor */];
    chevronColor = chevronColor || __WEBPACK_IMPORTED_MODULE_2__styles_colors__["b" /* Blue600Color */];
    /* tslint:disable */
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: size, height: size, style: styles }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("circle", { fill: circleFill, r: "15.5", cy: "16", cx: "16", stroke: circleColor }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { fill: "none", strokeWidth: "2", strokeLinejoin: "round", strokeLinecap: "round", stroke: chevronColor, d: "M15 19l3-2.945L15 13" })));
    /* tslint:enable */
};
//# sourceMappingURL=chevron-circle.js.map

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(12).document;
module.exports = document && document.documentElement;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(23);
var toObject = __webpack_require__(28);
var IE_PROTO = __webpack_require__(57)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(38);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(41);
var createDesc = __webpack_require__(29);
var toIObject = __webpack_require__(25);
var toPrimitive = __webpack_require__(54);
var has = __webpack_require__(23);
var IE8_DOM_DEFINE = __webpack_require__(80);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(18) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(22);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(30);
var ITERATOR = __webpack_require__(11)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(87);
var ITERATOR = __webpack_require__(11)('iterator');
var Iterators = __webpack_require__(30);
module.exports = __webpack_require__(8).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(11)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(146), __esModule: true };

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getContent;
/* unused harmony export getRawContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ccl_utilities__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_parser__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__initial_data_service__ = __webpack_require__(91);



var store = {};
function getContent(id) {
    if (!store[id]) {
        var content = Object(__WEBPACK_IMPORTED_MODULE_2__initial_data_service__["a" /* getInitialData */])(id.toLowerCase());
        if (content) {
            store[id] = Promise.resolve(Object(__WEBPACK_IMPORTED_MODULE_1__content_parser__["a" /* parseContent */])(content));
        }
        else {
            var contentVersionParam = getContentVersionParam();
            var url = "/booked/api/v1.0/Content?" + contentVersionParam + "id=" + id;
            store[id] = Object(__WEBPACK_IMPORTED_MODULE_0_ccl_utilities__["a" /* cclFetch */])(url)
                .then(function (rawContent) { return Object(__WEBPACK_IMPORTED_MODULE_1__content_parser__["a" /* parseContent */])(rawContent); });
        }
    }
    return store[id];
}
var rowStore = {};
function getRawContent(id) {
    if (!rowStore[id]) {
        var content = Object(__WEBPACK_IMPORTED_MODULE_2__initial_data_service__["a" /* getInitialData */])(id.toLowerCase());
        if (content) {
            rowStore[id] = Promise.resolve(content);
        }
        else {
            var contentVersionParam = getContentVersionParam();
            var url = "/booked/api/v1.0/Content?" + contentVersionParam + "id=" + id;
            rowStore[id] = Object(__WEBPACK_IMPORTED_MODULE_0_ccl_utilities__["a" /* cclFetch */])(url);
        }
    }
    return rowStore[id];
}
function getContentVersionParam() {
    var hstElement = document.getElementById('hst');
    if (hstElement) {
        var contentVersion = hstElement.getAttribute('ver');
        if (contentVersion) {
            var hash = getContentHash();
            return "version=" + contentVersion + "." + hash + "&";
        }
    }
    return '';
}
function getContentHash() {
    var hashElement = document.getElementById('content-hash');
    return hashElement ? hashElement.value : '';
}
//# sourceMappingURL=content-service.js.map

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Icon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icon_css__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icon_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__icon_css__);




var Icon = function (_a) {
    var className = _a.className, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["className"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-icon', className) }, otherProps)));
};
//# sourceMappingURL=icon.js.map

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dropdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__click_away_listener_click_away_listener__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chevron_chevron__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_popper__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_colors__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_focus_trap_react__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_focus_trap_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_focus_trap_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_event_listener__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dropdown_css__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__dropdown_css__);










var Dropdown = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Dropdown, _super);
    function Dropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buttonRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.containerRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.state = {
            isOpen: false
        };
        _this.toggle = function (e) {
            e.preventDefault();
            _this.setState(function (state) { return ({
                isOpen: !state.isOpen
            }); });
        };
        _this.close = function (e) {
            if (e.target === _this.buttonRef.current || _this.buttonRef.current.contains(e.target)) {
                return;
            }
            if (_this.state.isOpen) {
                _this.setState({ isOpen: false });
            }
        };
        _this.onKeyPress = function (e) {
            if (e.keyCode === 27) { // escape key
                if (_this.containerRef.current.contains(e.target)) {
                    _this.setState(function (state) {
                        if (state.isOpen) {
                            _this.buttonRef.current.focus();
                            return { isOpen: false };
                        }
                        return null;
                    });
                }
            }
        };
        return _this;
    }
    Dropdown.prototype.renderButton = function (title, isOpen, id, ariaLabel) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", { type: "button", ref: this.buttonRef, onClick: this.toggle, className: "h-dropdown__toggle", "aria-expanded": isOpen ? 'true' : 'false', "aria-controls": id, "aria-label": ariaLabel || '' },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null, title),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__chevron_chevron__["a" /* Chevron */], { className: "h-dropdown__chevron", size: 16, direction: isOpen ? 'up' : 'down', color: __WEBPACK_IMPORTED_MODULE_6__styles_colors__["c" /* BlueColor */] })));
    };
    Dropdown.prototype.renderContent = function (popperProps, id, children) {
        if (!popperProps) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { id: id, className: "h-dropdown__content" }, children));
        }
        var ref = popperProps.ref, style = popperProps.style, placement = popperProps.placement;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { id: id, ref: ref, style: style, "data-placement": placement, className: "h-dropdown__content" }, children));
    };
    Dropdown.prototype.renderFlyout = function (title, isOpen, id, children, buttonAriaLabel) {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react_popper__["a" /* Manager */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react_popper__["c" /* Reference */], null, function (_a) {
                var ref = _a.ref;
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "h-dropdown__toggle-container", ref: ref }, _this.renderButton(title, isOpen, id, buttonAriaLabel)));
            }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__click_away_listener_click_away_listener__["a" /* ClickAwayListener */], { onClickAway: this.close },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react_popper__["b" /* Popper */], { placement: "bottom" }, function (popperProps) { return (_this.renderContent(popperProps, id, children)); }))));
    };
    Dropdown.prototype.renderRelative = function (title, isOpen, id, children, ariaLabel) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            this.renderButton(title, isOpen, id, ariaLabel),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__click_away_listener_click_away_listener__["a" /* ClickAwayListener */], { onClickAway: this.close }, this.renderContent(null, id, children))));
    };
    Dropdown.prototype.renderStatic = function (title, isOpen, id, children, ariaLabel) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            this.renderButton(title, isOpen, id, ariaLabel),
            this.renderContent(null, id, children)));
    };
    Dropdown.prototype.render = function () {
        var _a = this.props, title = _a.title, className = _a.className, display = _a.display, children = _a.children, id = _a.id, buttonAriaLabel = _a.buttonAriaLabel;
        var isOpen = this.state.isOpen;
        var displayClassName = display === 'static' ? 'h-dropdown--static' : 'h-dropdown--flyout';
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-dropdown', className, displayClassName, { 'h-dropdown--open': isOpen }), ref: this.containerRef },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_react_event_listener___default.a, { target: "document", onKeyUp: this.onKeyPress },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_focus_trap_react__, { active: isOpen, className: "h-dropdown__focus-trap" }, display === 'static' ? this.renderStatic(title, isOpen, id, children, buttonAriaLabel) :
                    (display === 'absolute' ? this.renderFlyout(title, isOpen, id, children, buttonAriaLabel) :
                        this.renderRelative(title, isOpen, id, children, buttonAriaLabel))))));
    };
    return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=dropdown.js.map

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClickAwayListener; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_event_listener__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_event_listener__);




/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 * Brought from:
 * https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/ClickAwayListener/ClickAwayListener.js
 */
var ClickAwayListener = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(ClickAwayListener, _super);
    function ClickAwayListener() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.node = null;
        _this.mounted = false;
        // tslint:disable-next-line:no-any
        _this.handleClickAway = function (event) {
            // Ignore events that have been `event.preventDefault()` marked.
            if (event.defaultPrevented) {
                return;
            }
            // IE11 support, which trigger the handleClickAway even after the unbind
            if (!_this.mounted) {
                return;
            }
            // The child might render null.
            if (!_this.node) {
                return;
            }
            var doc = _this.node.ownerDocument || document;
            if (doc.documentElement &&
                doc.documentElement.contains(event.target) &&
                !_this.node.contains(event.target)) {
                _this.props.onClickAway(event);
            }
        };
        return _this;
    }
    ClickAwayListener.prototype.componentDidMount = function () {
        this.node = __WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"](this);
        this.mounted = true;
    };
    ClickAwayListener.prototype.componentWillUnmount = function () {
        this.mounted = false;
    };
    ClickAwayListener.prototype.render = function () {
        var _a = this.props, children = _a.children, mouseEvent = _a.mouseEvent, touchEvent = _a.touchEvent, onClickAway = _a.onClickAway, other = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["children", "mouseEvent", "touchEvent", "onClickAway"]);
        // tslint:disable-next-line:no-any
        var listenerProps = {};
        if (mouseEvent !== false) {
            listenerProps[mouseEvent || ClickAwayListener.defaultProps.mouseEvent] = this.handleClickAway;
        }
        if (touchEvent !== false) {
            listenerProps[touchEvent || ClickAwayListener.defaultProps.touchEvent] = this.handleClickAway;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_event_listener___default.a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ target: "document" }, listenerProps, other), children));
    };
    ClickAwayListener.defaultProps = {
        mouseEvent: 'onMouseUp',
        touchEvent: 'onTouchEnd',
    };
    return ClickAwayListener;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=click-away-listener.js.map

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BookingSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eyebrow_eyebrow__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__avatar_avatar__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms_index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dropdown_dropdown__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__booking_selector_css__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__booking_selector_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__booking_selector_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);








var BookingSelector = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(BookingSelector, _super);
    function BookingSelector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSelectionChanged = function (e) {
            if (_this.props.onSelectedBookings) {
                var bookingNumber_1 = e.currentTarget.dataset.booknum;
                var selectedBookings = _this.props.selectedBookings;
                if (e.currentTarget.checked && !selectedBookings.find(function (s) { return s === bookingNumber_1; })) {
                    selectedBookings.push(bookingNumber_1);
                    _this.props.onSelectedBookings(selectedBookings);
                }
                else {
                    _this.props.onSelectedBookings(selectedBookings.filter(function (s) { return s !== bookingNumber_1; }));
                }
            }
        };
        return _this;
    }
    BookingSelector.prototype.render = function () {
        var _this = this;
        var _a = this.props, activeSailing = _a.activeSailing, content = _a.content, selectedBookings = _a.selectedBookings, parentNameRef = _a.parentNameRef, className = _a.className, disableSelector = _a.disableSelector;
        if (!activeSailing || !activeSailing.bookings || activeSailing.bookings.length === 1) {
            return null;
        }
        var selectedBookingsCount = selectedBookings.length;
        var key = 'booking-selector-' + (parentNameRef || 'component');
        var title = ((selectedBookingsCount === 1 ? content.oneStateroomTitle : content.multiStateroomTitle) || '')
            .replace('{StateroomCount}', selectedBookingsCount.toString());
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_7_classnames__('h-bk-sel', className) },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__dropdown_dropdown__["a" /* Dropdown */], { key: key, id: key, title: title, className: "h-bk-sel__dropdown", display: "relative", buttonAriaLabel: "" + (content.buttonAriaLabel || '').replace('{BookingsCount}', selectedBookingsCount.toString()) },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null, activeSailing.bookings.map(function (b, i) {
                    var checked = !!selectedBookings.find(function (selected) { return b.bookingNumber === selected; });
                    var lastSelected = checked && selectedBookingsCount === 1;
                    return _this.renderBookingSelector(b, i, content.eyebrow, content.avatarPrefix, content.defaultGuestName, content.stateroomSequence, checked, disableSelector !== true && !lastSelected, content.checkBoxAriaLabel, parentNameRef);
                })))));
    };
    BookingSelector.prototype.genId = function (bookingNumber, suffix, parentNameRef) {
        return parentNameRef + "-bk-selector-" + bookingNumber + "-" + suffix;
    };
    BookingSelector.prototype.renderBookingSelector = function (booking, index, eyebrow, avatarPrefix, defaultGuestName, stateroomSequence, checked, enable, checkBoxAriaLabel, parentNameRef) {
        var _this = this;
        var bookingNumber = booking.bookingNumber;
        var eyebrowId = this.genId(bookingNumber, 'bk-sel-eyebrow', parentNameRef);
        var divId = this.genId(bookingNumber, 'bk-sel-id', parentNameRef);
        var inputId = this.genId(bookingNumber, 'chx', parentNameRef);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { id: divId, key: bookingNumber + "-" + index },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms_index__["a" /* Checkbox */], { name: inputId, id: inputId, "data-booknum": bookingNumber, onChange: this.onSelectionChanged, disabled: !enable, defaultChecked: checked, "aria-label": "" + (checkBoxAriaLabel || '').replace('{BookingNumber}', bookingNumber) }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms_index__["e" /* Label */], { htmlFor: inputId },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__eyebrow_eyebrow__["a" /* Eyebrow */], { id: eyebrowId },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { "data-pii": "true" }, "" + eyebrow + booking.bookingNumber)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h3", { className: "h-bk-sel__heading" }, "" + (stateroomSequence || '').replace('{Sequence}', (index + 1).toString()))),
            booking.guests.map(function (g, i) { return _this.renderGuest(g, i, avatarPrefix, defaultGuestName); })));
    };
    BookingSelector.prototype.renderGuest = function (g, i, avatarPrefix, defaultGuestName) {
        var fullName = g.firstName === 'TBA'
            ? defaultGuestName + " " + (i + 1)
            : g.firstName + " " + g.lastName;
        var avatar = g.firstName === 'TBA'
            ? (avatarPrefix + (i + 1))
            : fullName;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "d-flex h-bk-sel__card__guest", key: i },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bk-sel__card__guest-num-col", "aria-hidden": "true" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__avatar_avatar__["a" /* Avatar */], { fullName: avatar })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { "data-pii": "true", className: "h-bk-sel__card__guest-info-col" }, fullName)));
    };
    return BookingSelector;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=booking-selector.js.map

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = renderItem;
/* harmony export (immutable) */ __webpack_exports__["a"] = filterItem;
/* harmony export (immutable) */ __webpack_exports__["c"] = replaceUrlPlaceholders;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main_nav_main_nav__ = __webpack_require__(96);



function renderItem(item, componentFactory, data) {
    var title = item.fields.title && item.fields.title.value;
    var primary = item.fields.primary && item.fields.primary.value;
    var isActive = isActiveRoute(item, data);
    var tags = item.fields.tags && (item.fields.tags.value || '');
    var otherProps = propEnhancer(tags, item, data);
    if (item.templateName === 'MainNavLink') {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__main_nav_main_nav__["c" /* MainNavLink */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ key: item.id, href: replaceUrlPlaceholders(item.fields.url.value, data), primary: primary, active: isActive }, otherProps), title));
    }
    else if (item.templateName === 'MainNavDropdown') {
        // tslint:disable:no-any
        var TitleComponent = componentFactory(tags);
        var ContentComponent_1 = componentFactory(item.fields.contentSource.value.fields.tags.value);
        // tslint:enable:no-any
        if (!ContentComponent_1) {
            return undefined;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__main_nav_main_nav__["b" /* MainNavDropdown */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ key: item.id, title: TitleComponent ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](TitleComponent, { item: item, data: data }) : title, id: data.idPrefix + item.id, primary: primary, active: isActive }, otherProps), function (props) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ContentComponent_1, { item: item.fields.contentSource.value, data: data, dropdown: props });
        }));
    }
    return null;
}
function filterItem(item, data) {
    var condition = item.fields.condition && item.fields.condition.value;
    if (!condition) {
        return true;
    }
    var conditionValue = condition.fields.condition.value;
    if (conditionValue === 'AuthenticatedOnly' && !data.isAuthenticated) {
        return false;
    }
    if (conditionValue === 'AnonymousOnly' && data.isAuthenticated) {
        return false;
    }
    return true;
}
function replaceUrlPlaceholders(url, data) {
    url = replacePlaceholder(url, '{returnUrl}', encodeURIComponent(window.location.pathname + window.location.search));
    if (data.activeSailing) {
        url = replacePlaceholder(url, '{shipCode}', encodeURIComponent(data.activeSailing.itinerary.shipCode));
        url = replacePlaceholder(url, '{sailDate}', encodeURIComponent(data.activeSailing.itinerary.sailDate));
        url = replacePlaceholder(url, '{encryptedBookingNumbers}', encodeURIComponent(data.activeSailing.encryptedBookingNumbers));
    }
    if (data.activeSailing && data.activeSailing.bookings && data.activeSailing.bookings[0]) {
        url = replacePlaceholder(url, '{bookingNumber}', encodeURIComponent(data.activeSailing.bookings[0].bookingNumber));
        url = replacePlaceholder(url, '{encryptedBookingNumber}', encodeURIComponent(data.activeSailing.bookings[0].encryptedBookingNumber));
    }
    return url;
}
function isActiveRoute(item, data) {
    var activeRegex = item.fields.activeRegex && item.fields.activeRegex.value;
    var isActive = !!activeRegex &&
        !!data.activeRoute &&
        new RegExp(activeRegex, 'i').test(data.activeRoute);
    return isActive;
}
function replacePlaceholder(url, placeholder, replacement) {
    if (url && url.indexOf(placeholder) >= 0) {
        url = url.replace(placeholder, replacement);
    }
    return url;
}
function propEnhancer(tags, item, data) {
    if (tags.indexOf('PropEnhancer:Sailings') >= 0) {
        var eyebrow = item.fields.title && item.fields.title.value;
        return {
            eyebrow: !!eyebrow ? eyebrow.replace('{ShipName}', data.activeSailing.itinerary.shipName.toUpperCase()) : null,
            title: data.activeSailing.itinerary.shortItineraryTitle,
            className: 'h-main-nav__sailings'
        };
    }
    else if (tags.indexOf('PropEnhancer:FunBrowser') >= 0) {
        return {
            className: 'h-main-nav__fun-browser'
        };
    }
    else if (tags.indexOf('PropEnhancer:Logo') >= 0) {
        return {
            className: 'h-main-nav__logo'
        };
    }
    return {};
}
//# sourceMappingURL=helpers.js.map

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainNavItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main_nav_item_css__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main_nav_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__main_nav_item_css__);



var MainNavItem = function (_a) {
    var children = _a.children, active = _a.active, className = _a.className, elRef = _a.elRef;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { ref: elRef, className: __WEBPACK_IMPORTED_MODULE_1_classnames__('h-main-nav__item', className, { 'h-main-nav__item--active': active }) }, children));
};
//# sourceMappingURL=main-nav-item.js.map

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(31);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOnDemandLazySlides = exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }
  return onDemandSlides;
};

// return list of slides that need to be present
var getRequiredLazySlides = exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }
  return requiredSlides;
};

// startIndex that needs to be present
var lazyStartIndex = exports.lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};
var lazyEndIndex = exports.lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};
var lazySlidesOnLeft = exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode || spec.centerPadding ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var lazySlidesOnRight = exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode || spec.centerPadding ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};

// get width of an element
var getWidth = exports.getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};
var getHeight = exports.getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};
var getSwipeDirection = exports.getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);
  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }
  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }
  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }
  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
};

// whether or not we can go next
var canGoNext = exports.canGoNext = function canGoNext(spec) {
  var canGo = true;
  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }
  return canGo;
};

// given an object and a list of keys, return new object with given keys
var extractObject = exports.extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
};

// get initialized state
var initializedState = exports.initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react2.default.Children.count(spec.children);
  var listWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.listRef)));
  var trackWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.trackRef)));
  var slideWidth = void 0;
  if (!spec.vertical) {
    var centerPaddingAdj = (spec.centerMode || spec.centerPadding) && parseInt(spec.centerPadding) * 2;
    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }
    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }
  var slideHeight = _reactDom2.default.findDOMNode(spec.listRef) && getHeight(_reactDom2.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }
  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides({ currentSlide: currentSlide, lazyLoadedList: lazyLoadedList }, spec);
  lazyLoadedList.concat(slidesToLoad);

  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

var slideHandler = exports.slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoadedList = spec.lazyLoadedList,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;

  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide = void 0,
      animationLeft = void 0,
      finalLeft = void 0;
  var state = {},
      nextState = {};
  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};
    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }
    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList.push(animationSlide);
    }
    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList
    };
    nextState = { animating: false };
  } else {
    finalSlide = animationSlide;
    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }
    animationLeft = getTrackLeft(_extends({}, spec, { slideIndex: animationSlide }));
    finalLeft = getTrackLeft(_extends({}, spec, { slideIndex: finalSlide }));
    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }
    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_extends({}, spec, { currentSlide: animationSlide })));
    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        lazyLoadedList: lazyLoadedList
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_extends({}, spec, { left: animationLeft })),
        lazyLoadedList: lazyLoadedList
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        swipeLeft: null
      };
    }
  }
  return { state: state, nextState: nextState };
};

var changeSlide = exports.changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;

  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;
    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;
    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
    if (targetSlide === options.currentSlide) {
      return null;
    }
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;
    if (targetSlide === options.currentSlide) {
      return null;
    }
    if (infinite) {
      var direction = siblingDirection(_extends({}, spec, { targetSlide: targetSlide }));
      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
    if (targetSlide === options.currentSlide) {
      return null;
    }
  }
  return targetSlide;
};
var keyHandler = exports.keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

var swipeStart = exports.swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && e.preventDefault();
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};
var swipeMove = exports.swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;

  if (scrolling) return;
  if (animating) return e.preventDefault();
  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
  var swipeLeft = void 0,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return { scrolling: true };
  }
  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;

  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;
  if (!infinite) {
    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;
      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }
  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }
  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }
  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }
  state = _extends({}, state, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_extends({}, spec, { left: swipeLeft }))
  });
  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }
  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    e.preventDefault();
  }
  return state;
};
var swipeEnd = exports.swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      currentSlide = spec.currentSlide,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe;

  if (!dragging) {
    if (swipe) e.preventDefault();
    return {};
  }
  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
  // reset the state of touch related state variables.
  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };
  if (scrolling) {
    return state;
  }
  if (!touchObject.swipeLength) {
    return state;
  }
  if (touchObject.swipeLength > minSwipe) {
    e.preventDefault();
    if (onSwipe) {
      onSwipe(swipeDirection);
    }
    var slideCount = void 0,
        newSlide = void 0;
    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = currentSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;
      case "right":
      case "down":
        newSlide = currentSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;
      default:
        slideCount = currentSlide;
    }
    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_extends({}, spec, { left: currentLeft }));
  }
  return state;
};
var getNavigableIndexes = exports.getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];
  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }
  return indexes;
};
var checkNavigable = exports.checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;
  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }
      prevNavigable = navigables[n];
    }
  }
  return index;
};
var getSlideCount = exports.getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
  if (spec.swipeToSlide) {
    var swipedSlide = void 0;
    var slickList = _reactDom2.default.findDOMNode(spec.listRef);
    var slides = slickList.querySelectorAll(".slick-slide");
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }
    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

var checkSpecKeys = exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth = void 0,
      trackHeight = void 0;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }
  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };
  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _extends({}, style, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }
  if (spec.fade) style = { opacity: 1 };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight;

  // Fallback for IE8
  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};
var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec);
  // useCSS is true by default so it can be undefined
  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }
  return style;
};
var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);

  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;


  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;
  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    }
    // shift current slide to center of the frame
    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }
    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }
  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = _reactDom2.default.findDOMNode(trackRef);
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;
      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }
      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

var getPreClones = exports.getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  if (spec.variableWidth) {
    return spec.slideCount;
  }
  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

var getPostClones = exports.getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  return spec.slideCount;
};

var getTotalSlides = exports.getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};
var siblingDirection = exports.siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }
    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }
    return "left";
  }
};

var slidesOnRight = exports.slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }
  if (rtl) {
    return 0;
  }
  return slidesToShow - 1;
};

var slidesOnLeft = exports.slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }
  if (rtl) {
    return slidesToShow - 1;
  }
  return 0;
};

var canUseDOM = exports.canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tooltip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tooltip_css__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tooltip_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__tooltip_css__);




var Tooltip = function (_a) {
    var placement = _a.placement, children = _a.children, className = _a.className, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["placement", "children", "className"]);
    var cn = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-tooltip h-tooltip--' + placement, className);
    if (typeof children === 'function') {
        // tslint:disable-next-line:no-any
        return children({
            className: cn
        });
    }
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ className: cn }, otherProps), children);
};
//# sourceMappingURL=tooltip.js.map

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isTab;
/* harmony export (immutable) */ __webpack_exports__["c"] = isTabPanel;
/* harmony export (immutable) */ __webpack_exports__["b"] = isTabList;
function isTab(el) {
  return el.type && el.type.tabsRole === 'Tab';
}
function isTabPanel(el) {
  return el.type && el.type.tabsRole === 'TabPanel';
}
function isTabList(el) {
  return el.type && el.type.tabsRole === 'TabList';
}

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LineExplanationTrigger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__visually_hidden_visually_hidden__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icons__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__line_explanation_trigger_css__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__line_explanation_trigger_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__line_explanation_trigger_css__);





var onExplanationClick = function (onClick) { return function (e) {
    e.preventDefault();
    onClick(e.currentTarget);
}; };
var LineExplanationTrigger = function (_a) {
    var content = _a.content, line = _a.line, onOpen = _a.onOpen;
    if (!line.explanation) {
        return null;
    }
    var ariaLabel = getTriggerAriaLabel(line, content);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "d-print-none" },
        content.insuranceDisclaimerSignal && Object(__WEBPACK_IMPORTED_MODULE_1__common__["f" /* isVppLine */])(line)
            && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "h-invoice-table__line-explanation-disc" }, content.insuranceDisclaimerSignal),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "", role: "button", className: "h-invoice-table__line-explantion-trigger", onClick: onExplanationClick(onOpen) },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], { dangerouslySetInnerHTML: { __html: ariaLabel } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__icons__["InfoIcon"], { "aria-hidden": "true", style: { verticalAlign: 'middle' } }))));
};
function getTriggerAriaLabel(line, content) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__common__["f" /* isVppLine */])(line)) {
        return content.vppTriggerAriaLabel;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_1__common__["e" /* isGratuitiesLine */])(line)) {
        return content.gratuitiesTriggerAriaLabel;
    }
    return '';
}
//# sourceMappingURL=line-explanation-trigger.js.map

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = replacePlaceHolders;
/* harmony export (immutable) */ __webpack_exports__["a"] = listGuests;
function replacePlaceHolders(text, props) {
    var invitedBy = props.invitedBy, sailDate = props.sailDate, regionName = props.regionName, shipName = props.shipName;
    return text.replace('{invitedBy}', invitedBy)
        .replace('{sailDate}', sailDate)
        .replace('{regionName}', regionName)
        .replace('{shipName}', shipName);
}
function listGuests(guests, message) {
    var guestList = guests.join(', ');
    var replaceLastCommaForAndExpression = '([^,]*)$/';
    guestList.replace(replaceLastCommaForAndExpression, ' and $1');
    var message = message.replace('{guests}', guestList);
    return message;
}
//# sourceMappingURL=common.js.map

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["default"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)))

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(122), __esModule: true };

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50);
__webpack_require__(83);
module.exports = __webpack_require__(60).f('iterator');


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(51);
var defined = __webpack_require__(52);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(55);
var descriptor = __webpack_require__(29);
var setToStringTag = __webpack_require__(40);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(21)(IteratorPrototype, __webpack_require__(11)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(17);
var anObject = __webpack_require__(22);
var getKeys = __webpack_require__(34);

module.exports = __webpack_require__(18) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(25);
var toLength = __webpack_require__(56);
var toAbsoluteIndex = __webpack_require__(127);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(51);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(129);
var step = __webpack_require__(100);
var Iterators = __webpack_require__(30);
var toIObject = __webpack_require__(25);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(67)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(131), __esModule: true };

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(132);
__webpack_require__(86);
__webpack_require__(135);
__webpack_require__(136);
module.exports = __webpack_require__(8).Symbol;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(12);
var has = __webpack_require__(23);
var DESCRIPTORS = __webpack_require__(18);
var $export = __webpack_require__(15);
var redefine = __webpack_require__(81);
var META = __webpack_require__(84).KEY;
var $fails = __webpack_require__(24);
var shared = __webpack_require__(58);
var setToStringTag = __webpack_require__(40);
var uid = __webpack_require__(39);
var wks = __webpack_require__(11);
var wksExt = __webpack_require__(60);
var wksDefine = __webpack_require__(61);
var enumKeys = __webpack_require__(133);
var isArray = __webpack_require__(101);
var anObject = __webpack_require__(22);
var isObject = __webpack_require__(20);
var toObject = __webpack_require__(28);
var toIObject = __webpack_require__(25);
var toPrimitive = __webpack_require__(54);
var createDesc = __webpack_require__(29);
var _create = __webpack_require__(55);
var gOPNExt = __webpack_require__(134);
var $GOPD = __webpack_require__(102);
var $GOPS = __webpack_require__(62);
var $DP = __webpack_require__(17);
var $keys = __webpack_require__(34);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(85).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(41).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(33)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(21)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(34);
var gOPS = __webpack_require__(62);
var pIE = __webpack_require__(41);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(25);
var gOPN = __webpack_require__(85).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(61)('asyncIterator');


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(61)('observable');


/***/ }),
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(15);
var core = __webpack_require__(8);
var fails = __webpack_require__(24);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(143), __esModule: true };

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(144);
module.exports = __webpack_require__(8).Object.assign;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(15);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(145) });


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(18);
var getKeys = __webpack_require__(34);
var gOPS = __webpack_require__(62);
var pIE = __webpack_require__(41);
var toObject = __webpack_require__(28);
var IObject = __webpack_require__(69);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(24)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50);
__webpack_require__(147);
module.exports = __webpack_require__(8).Array.from;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(27);
var $export = __webpack_require__(15);
var toObject = __webpack_require__(28);
var call = __webpack_require__(103);
var isArrayIter = __webpack_require__(104);
var toLength = __webpack_require__(56);
var createProperty = __webpack_require__(148);
var getIterFn = __webpack_require__(105);

$export($export.S + $export.F * !__webpack_require__(106)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(17);
var createDesc = __webpack_require__(29);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icon_props__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icon_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__icon_props__);
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__icon_props__, "CheckmarkIcon")) __webpack_require__.d(__webpack_exports__, "CheckmarkIcon", function() { return __WEBPACK_IMPORTED_MODULE_0__icon_props__["CheckmarkIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__icon_props__, "CloseIcon")) __webpack_require__.d(__webpack_exports__, "CloseIcon", function() { return __WEBPACK_IMPORTED_MODULE_0__icon_props__["CloseIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__icon_props__, "ExclamationIcon")) __webpack_require__.d(__webpack_exports__, "ExclamationIcon", function() { return __WEBPACK_IMPORTED_MODULE_0__icon_props__["ExclamationIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__icon_props__, "SadFaceIcon")) __webpack_require__.d(__webpack_exports__, "SadFaceIcon", function() { return __WEBPACK_IMPORTED_MODULE_0__icon_props__["SadFaceIcon"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__icon_props__, "SpinnerIcon")) __webpack_require__.d(__webpack_exports__, "SpinnerIcon", function() { return __WEBPACK_IMPORTED_MODULE_0__icon_props__["SpinnerIcon"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__circle_plus_icon__ = __webpack_require__(429);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__close_icon__ = __webpack_require__(430);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "CloseIcon", function() { return __WEBPACK_IMPORTED_MODULE_2__close_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__info_icon__ = __webpack_require__(431);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sad_face_icon__ = __webpack_require__(432);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "SadFaceIcon", function() { return __WEBPACK_IMPORTED_MODULE_4__sad_face_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__checkmark_icon__ = __webpack_require__(433);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "CheckmarkIcon", function() { return __WEBPACK_IMPORTED_MODULE_5__checkmark_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bed_icon__ = __webpack_require__(434);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cabin_interior_icon__ = __webpack_require__(184);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cabin_interior_porthole_icon__ = __webpack_require__(185);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cabin_oceanview_icon__ = __webpack_require__(186);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__cabin_balcony_icon__ = __webpack_require__(187);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__cabin_suite_icon__ = __webpack_require__(188);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__cabin_icon__ = __webpack_require__(435);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__edit_icon__ = __webpack_require__(436);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__spinner_icon__ = __webpack_require__(437);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "SpinnerIcon", function() { return __WEBPACK_IMPORTED_MODULE_14__spinner_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__exclamation_icon__ = __webpack_require__(439);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "ExclamationIcon", function() { return __WEBPACK_IMPORTED_MODULE_15__exclamation_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__clock_icon__ = __webpack_require__(440);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__printer_icon__ = __webpack_require__(441);
/* unused harmony namespace reexport */


















//# sourceMappingURL=index.js.map

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Chevron; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


function mapDirectionToRotation(direction) {
    switch (direction) {
        case 'up':
            return 'rotate(270deg)';
        case 'down':
            return 'rotate(90deg)';
        case 'left':
            return 'rotate(180deg)';
        default:
            return 'rotate(0deg)';
    }
}
var Chevron = function (_a) {
    var size = _a.size, direction = _a.direction, color = _a.color, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["size", "direction", "color"]);
    var styles = {
        transform: mapDirectionToRotation(direction),
    };
    color = color || 'black';
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: size, height: size, style: styles, focusable: "false" }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { strokeWidth: "1px", fill: color, stroke: color, d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" })));
};
//# sourceMappingURL=chevron.js.map

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createControlModel */
/* harmony export (immutable) */ __webpack_exports__["a"] = asDirty;
/* harmony export (immutable) */ __webpack_exports__["b"] = asTouched;
/* unused harmony export asValid */
/* unused harmony export asInvalid */
/* harmony export (immutable) */ __webpack_exports__["e"] = withValue;
/* harmony export (immutable) */ __webpack_exports__["d"] = withChecked;
/* unused harmony export withValidators */
/* harmony export (immutable) */ __webpack_exports__["c"] = asValidatedDirtyAndTouched;
/* unused harmony export asValidated */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validator__ = __webpack_require__(195);


var emptyObject = {};
function createControlModel(options) {
    var value = options.value === undefined ? '' : options.value;
    var validators = options.validators || emptyObject;
    var errors = Object(__WEBPACK_IMPORTED_MODULE_1__validator__["a" /* validate */])(options.checked === undefined ? value : options.checked, validators);
    var state = createControlModelState(options.state || emptyObject, errors);
    return {
        id: options.id || generateIdFromName(options.name),
        name: options.name,
        value: value,
        checked: options.checked,
        pii: options.pii,
        updateMode: options.updateMode || 'change',
        validators: validators,
        state: state,
        errorMessages: options.errorMessages,
        props: options.props,
    };
}
function asDirty(control) {
    var newState = stateAsDirty(control.state);
    if (newState === control.state) {
        return control;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, control), { state: newState });
}
function asTouched(control) {
    var newState = stateAsTouched(control.state);
    if (newState === control.state) {
        return control;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, control), { state: newState });
}
function asValid(state) {
    if (state.valid && !state.invalid) {
        return state;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, state), { valid: true, invalid: false });
}
function asInvalid(state) {
    if (state.invalid && !state.valid) {
        return state;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, state), { valid: false, invalid: true });
}
function withValue(control, value) {
    if (control.value === value) {
        return control;
    }
    var newControl = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, control), { value: value });
    return asValidated(newControl);
}
function withChecked(control, checked) {
    if (control.checked === checked) {
        return control;
    }
    var newControl = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, control), { checked: checked });
    return asValidated(newControl);
}
function withValidators(control, validators) {
    if (control.validators === validators) {
        return control;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, control), { validators: validators });
}
function asValidatedDirtyAndTouched(model) {
    return asValidated(asDirty(asTouched(model)));
}
function asValidated(control) {
    var errors = control.checked === undefined ?
        Object(__WEBPACK_IMPORTED_MODULE_1__validator__["a" /* validate */])(control.value, control.validators) :
        Object(__WEBPACK_IMPORTED_MODULE_1__validator__["a" /* validate */])(control.checked, control.validators);
    var state = control.state;
    if (errors.length !== state.errors.length) {
        if (errors.length === 0) {
            return createControlModelWithoutErrors(control, errors);
        }
        else {
            return createControlModelWithErrors(control, errors);
        }
    }
    for (var i = 0; i < errors.length; i++) {
        for (var j = 0; j < state.errors.length; j++) {
            if (errors[i] !== state.errors[j]) {
                return createControlModelWithErrors(control, errors);
            }
        }
    }
    return control;
}
function generateIdFromName(name) {
    return name.replace(/\./g, '-');
}
function stateAsDirty(state) {
    if (state.dirty && !state.pristine) {
        return state;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, state), { dirty: true, pristine: false });
}
function stateAsTouched(state) {
    if (state.touched && !state.untouched) {
        return state;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, state), { touched: true, untouched: false });
}
function createControlModelWithErrors(control, errors) {
    var newState = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, control.state), { invalid: true, valid: false, errors: errors });
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, control), { state: newState });
}
function createControlModelWithoutErrors(control, errors) {
    var newState = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, control.state), { invalid: false, valid: true, errors: [] });
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, control), { state: newState });
}
function createControlModelState(options, errors) {
    return {
        pristine: options.pristine === undefined ? true : options.pristine,
        dirty: options.dirty === undefined ? false : options.dirty,
        touched: options.touched === undefined ? false : options.touched,
        untouched: options.untouched === undefined ? true : options.untouched,
        errors: errors,
        invalid: errors.length > 0,
        valid: errors.length === 0
    };
}
//# sourceMappingURL=control-model.js.map

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(142);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ManagerContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_create_react_context__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_create_react_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_create_react_context__);









var ManagerContext = __WEBPACK_IMPORTED_MODULE_7_create_react_context___default()({ getReferenceRef: undefined, referenceNode: undefined });

var Manager = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Manager, _React$Component);

  function Manager() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Manager);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Manager.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Manager)).call(this));

    _this.getReferenceRef = function (referenceNode) {
      return _this.setState(function (_ref) {
        var context = _ref.context;
        return {
          context: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, context, { referenceNode: referenceNode })
        };
      });
    };

    _this.state = {
      context: {
        getReferenceRef: _this.getReferenceRef,
        referenceNode: undefined
      }
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Manager, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](
        ManagerContext.Provider,
        { value: this.state.context },
        this.props.children
      );
    }
  }]);

  return Manager;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

/* harmony default export */ __webpack_exports__["b"] = (Manager);

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Icon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icon_css__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icon_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__icon_css__);




var Icon = function (_a) {
    var className = _a.className, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["className"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-icon', className) }, otherProps)));
};
//# sourceMappingURL=icon.js.map

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PrinterIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_colors__ = __webpack_require__(6);



// tslint:disable:max-line-length
var PrinterIcon = function (_a) {
    var width = _a.width, height = _a.height, _b = _a.color, color = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_2__styles_colors__["c" /* BlueColor */] : _b, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height", "color"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", width: width || 18, height: height || 18 }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M16.945 7.236c0-1.586-1.14-2.872-2.545-2.872h-1.09V1.451c0-.226-.164-.41-.365-.41h-7.89c-.201 0-.364.184-.364.41v2.913H3.6c-1.406 0-2.545 1.286-2.545 2.872v4.267c0 1.586 1.14 2.871 2.545 2.871h.727v2.175c0 .226.163.41.364.41h8.618c.2 0 .364-.184.364-.41v-2.175h.727c1.406 0 2.545-1.285 2.545-2.871V7.236zM5.418 1.862h7.164v2.502H5.418V1.862zm7.527 14.276h-7.89v-5.312h7.89v5.312zm3.273-4.635c0 1.132-.814 2.05-1.818 2.05h-.727v-3.138c0-.226-.163-.41-.364-.41H4.691c-.2 0-.364.184-.364.41v3.139H3.6c-1.004 0-1.818-.919-1.818-2.051V7.236c0-1.133.814-2.051 1.818-2.051h10.8c1.004 0 1.818.918 1.818 2.05v4.268z", fillRule: "nonzero", fill: color, stroke: color })));
};
//# sourceMappingURL=printer-icon.js.map

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Timer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var Timer = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Timer, _super);
    function Timer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.timeoutId = 0;
        _this.state = {
            counter: 0,
            paused: false,
        };
        _this.clearTimeout = function () {
            window.clearInterval(_this.timeoutId);
        };
        _this.tick = function () {
            var _a = _this.props, maxIterations = _a.maxIterations, onTerminate = _a.onTerminate;
            if (maxIterations && _this.state.counter >= maxIterations) {
                _this.clearTimeout();
                if (typeof onTerminate === 'function') {
                    onTerminate();
                }
            }
            else {
                if (!_this.state.paused) {
                    _this.setState(function (prevState) {
                        return {
                            counter: prevState.counter + 1
                        };
                    });
                }
            }
        };
        return _this;
    }
    Timer.prototype.componentDidMount = function () {
        this.timeoutId = window.setInterval(this.tick, this.props.intervalMs);
    };
    Timer.prototype.componentWillUnmount = function () {
        window.clearInterval(this.timeoutId);
    };
    Timer.prototype.render = function () {
        return this.props.children(this.state.counter, this.clearTimeout);
    };
    Timer.prototype.pause = function () {
        this.setState({ paused: true });
    };
    Timer.prototype.resume = function () {
        this.setState({ paused: false });
    };
    return Timer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=timer.js.map

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Badge; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__badge_css__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__badge_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__badge_css__);



var Badge = function (_a) {
    var mode = _a.mode, children = _a.children, className = _a.className;
    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames__('h-badge', mode === 'block' ? 'h-badge--block' : undefined, className);
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: classes }, children);
};
//# sourceMappingURL=badge.js.map

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createControlModel;
/* harmony export (immutable) */ __webpack_exports__["a"] = asDirty;
/* harmony export (immutable) */ __webpack_exports__["b"] = asTouched;
/* unused harmony export asValid */
/* unused harmony export asInvalid */
/* harmony export (immutable) */ __webpack_exports__["g"] = withValue;
/* harmony export (immutable) */ __webpack_exports__["e"] = withChecked;
/* harmony export (immutable) */ __webpack_exports__["f"] = withValidators;
/* harmony export (immutable) */ __webpack_exports__["c"] = asValidatedDirtyAndTouched;
/* unused harmony export asValidated */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validator__ = __webpack_require__(217);


var emptyObject = {};
function createControlModel(options) {
    var value = options.value === undefined ? '' : options.value;
    var validators = options.validators || emptyObject;
    var errors = Object(__WEBPACK_IMPORTED_MODULE_1__validator__["a" /* validate */])(options.checked === undefined ? value : options.checked, validators);
    var state = createControlModelState(options.state || emptyObject, errors);
    return {
        id: options.id || generateIdFromName(options.name),
        name: options.name,
        value: value,
        checked: options.checked,
        pii: options.pii,
        updateMode: options.updateMode || 'change',
        validators: validators,
        state: state,
        errorMessages: options.errorMessages,
        props: options.props,
    };
}
function asDirty(control) {
    var newState = stateAsDirty(control.state);
    if (newState === control.state) {
        return control;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, control), { state: newState });
}
function asTouched(control) {
    var newState = stateAsTouched(control.state);
    if (newState === control.state) {
        return control;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, control), { state: newState });
}
function asValid(state) {
    if (state.valid && !state.invalid) {
        return state;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, state), { valid: true, invalid: false });
}
function asInvalid(state) {
    if (state.invalid && !state.valid) {
        return state;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, state), { valid: false, invalid: true });
}
function withValue(control, value) {
    if (control.value === value) {
        return control;
    }
    var newControl = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, control), { value: value });
    return asValidated(newControl);
}
function withChecked(control, checked) {
    if (control.checked === checked) {
        return control;
    }
    var newControl = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, control), { checked: checked });
    return asValidated(newControl);
}
function withValidators(control, validators) {
    if (control.validators === validators) {
        return control;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, control), { validators: validators });
}
function asValidatedDirtyAndTouched(model) {
    return asValidated(asDirty(asTouched(model)));
}
function asValidated(control) {
    var errors = control.checked === undefined ?
        Object(__WEBPACK_IMPORTED_MODULE_1__validator__["a" /* validate */])(control.value, control.validators) :
        Object(__WEBPACK_IMPORTED_MODULE_1__validator__["a" /* validate */])(control.checked, control.validators);
    var state = control.state;
    if (errors.length !== state.errors.length) {
        if (errors.length === 0) {
            return createControlModelWithoutErrors(control, errors);
        }
        else {
            return createControlModelWithErrors(control, errors);
        }
    }
    for (var i = 0; i < errors.length; i++) {
        for (var j = 0; j < state.errors.length; j++) {
            if (errors[i] !== state.errors[j]) {
                return createControlModelWithErrors(control, errors);
            }
        }
    }
    return control;
}
function generateIdFromName(name) {
    return name.replace(/\./g, '-');
}
function stateAsDirty(state) {
    if (state.dirty && !state.pristine) {
        return state;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, state), { dirty: true, pristine: false });
}
function stateAsTouched(state) {
    if (state.touched && !state.untouched) {
        return state;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, state), { touched: true, untouched: false });
}
function createControlModelWithErrors(control, errors) {
    var newState = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, control.state), { invalid: true, valid: false, errors: errors });
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, control), { state: newState });
}
function createControlModelWithoutErrors(control, errors) {
    var newState = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, control.state), { invalid: false, valid: true, errors: [] });
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, control), { state: newState });
}
function createControlModelState(options, errors) {
    return {
        pristine: options.pristine === undefined ? true : options.pristine,
        dirty: options.dirty === undefined ? false : options.dirty,
        touched: options.touched === undefined ? false : options.touched,
        untouched: options.untouched === undefined ? true : options.untouched,
        errors: errors,
        invalid: errors.length > 0,
        valid: errors.length === 0
    };
}
//# sourceMappingURL=control-model.js.map

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainNavLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_nav_item__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main_nav_link_css__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main_nav_link_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__main_nav_link_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__visually_hidden_visually_hidden__ = __webpack_require__(14);






var MainNavLink = function (_a) {
    var className = _a.className, active = _a.active, embedded = _a.embedded, children = _a.children, linkRef = _a.linkRef, navItemProps = _a.navItemProps, primary = _a.primary, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["className", "active", "embedded", "children", "linkRef", "navItemProps", "primary"]);
    var link = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ ref: linkRef, className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-main-nav__link', className) }, otherProps),
        renderContent(children, primary),
        active && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], null, "Current page")));
    return (embedded ? link : __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__main_nav_item__["a" /* MainNavItem */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ active: active }, navItemProps), link));
};
function renderContent(children, primary) {
    var textCn = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-main-nav__link-text', { 'h-main-nav__link-text--primary': primary });
    if (typeof children === 'string' || children instanceof String) {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: textCn, dangerouslySetInnerHTML: { __html: children } });
    }
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: textCn }, children);
}
//# sourceMappingURL=main-nav-link.js.map

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Carousel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__epignosisx_react_slick__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__epignosisx_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__epignosisx_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chevron_chevron_circle__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__carousel_css__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__carousel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__visually_hidden_visually_hidden__ = __webpack_require__(14);








var Carousel = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Carousel, _super);
    function Carousel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sliderRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.applyFocus = 'none';
        _this.lastIndex = 0;
        _this.lastMoveDirection = 'none';
        _this.afterChange = function (index) {
            if (!_this.sliderRef.current) {
                return;
            }
            var domEl = __WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"](_this.sliderRef.current);
            _this.detectFocusChanges(domEl);
            _this.detectMoveDirection(index);
            if (_this.props.afterChange) {
                _this.props.afterChange(index, domEl);
            }
        };
        _this.onReInit = function () {
            _this.handleDom();
        };
        _this.renderDot = function (index, dotCount, isCurrentDot) {
            var renderDotAriaLabel = _this.props.renderDotAriaLabel;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "", "data-index": index, className: __WEBPACK_IMPORTED_MODULE_3_classnames__('h-carousel__dot', { 'h-carousel__dot--active': isCurrentDot }) }, renderDotAriaLabel && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], null, renderDotAriaLabel(index, dotCount, isCurrentDot))));
        };
        return _this;
    }
    Carousel.prototype.detectMoveDirection = function (index) {
        if (index > this.lastIndex) {
            this.lastMoveDirection = 'next';
        }
        else if (index < this.lastIndex) {
            this.lastMoveDirection = 'prev';
        }
        else {
            this.lastMoveDirection = 'none';
        }
        this.lastIndex = index;
    };
    Carousel.prototype.detectFocusChanges = function (domEl) {
        var next = domEl.querySelector('.slick-next');
        var prev = domEl.querySelector('.slick-prev');
        if (next.className.indexOf('slick-disabled') >= 0) {
            this.applyFocus = 'next';
        }
        else if (prev.className.indexOf('slick-disabled') >= 0) {
            this.applyFocus = 'prev';
        }
        else {
            this.applyFocus = 'none';
        }
    };
    Carousel.prototype.handleDom = function () {
        if (!this.sliderRef.current) {
            return;
        }
        var domEl = __WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"](this.sliderRef.current);
        this.manageFocus(domEl);
        this.updateAdaDescription(domEl);
    };
    Carousel.prototype.manageFocus = function (domEl) {
        if (!this.props.focusManagement) {
            return;
        }
        // if we have a function let parent component handle focus
        if (typeof this.props.focusManagement === 'function') {
            this.props.focusManagement(domEl);
            return;
        }
        var focusSelector = this.props.focusManagement;
        var slides = domEl.querySelectorAll('.slick-slide');
        for (var i = 0; i < slides.length; i++) {
            var slide = slides[i];
            var tabIndex = slide.className.indexOf('slick-active') >= 0 ? 0 : -1;
            var elems = slide.querySelectorAll(focusSelector);
            for (var j = 0; j < elems.length; j++) {
                var link = elems[j];
                link.tabIndex = tabIndex;
            }
        }
        if (this.applyFocus === 'next') {
            var slide = slides[slides.length - 1];
            var link = slide.querySelector(focusSelector);
            if (link) {
                link.focus();
            }
        }
        else if (this.applyFocus === 'prev') {
            var slide = slides[0];
            var link = slide.querySelector(focusSelector);
            if (link) {
                link.focus();
            }
        }
        this.applyFocus = 'none';
    };
    Carousel.prototype.updateAdaDescription = function (domEl) {
        if (this.lastMoveDirection !== 'none') {
            var activeSlides = domEl.querySelectorAll('.slick-slide.slick-active');
            var lastActive = this.lastMoveDirection === 'prev'
                ? activeSlides[0]
                : activeSlides[activeSlides.length - 1];
            var slideDescription = this.props.getSlideDescription(parseInt(lastActive.dataset.index, 10));
            var descEl = domEl.parentElement.querySelector('[data-id="desc"]');
            descEl.textContent = slideDescription;
            this.lastMoveDirection = 'none';
        }
    };
    Carousel.prototype.render = function () {
        var LeftArrow = this.generateArrow('left');
        var RightArrow = this.generateArrow('right');
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__epignosisx_react_slick___default.a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ ref: this.sliderRef, onReInit: this.onReInit, afterChange: this.afterChange, className: __WEBPACK_IMPORTED_MODULE_3_classnames__('h-carousel', this.props.className), prevArrow: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](LeftArrow, null), nextArrow: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](RightArrow, null), customPaging: this.renderDot, centerPadding: "40px" }, this.props.slickSettings), this.props.children),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], { "data-id": "desc", "aria-live": "polite" })));
    };
    Carousel.prototype.generateArrow = function (direction) {
        var ariaLabel = direction === 'left' ? this.props.prevArrowAriaLabel : this.props.nextArrowAriaLabel;
        // tslint:disable-next-line:no-shadowed-variable no-any
        return function NavArrow(props) {
            var className = props.className, onClick = props.onClick;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { className: className, onClick: onClick, href: "", "aria-label": ariaLabel },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__chevron_chevron_circle__["a" /* ChevronCircle */], { direction: direction, circleColor: "#0F559A", shadowMode: "simple", size: 40 })));
        };
    };
    return Carousel;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=carousel.js.map

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;

var _exenv = __webpack_require__(676);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccessBooking; });
/* harmony export (immutable) */ __webpack_exports__["c"] = replace;
/* harmony export (immutable) */ __webpack_exports__["b"] = renderAdaLive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__access_booking_css__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__access_booking_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__access_booking_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_modal_shell__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icons__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__access_booking_request_line__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__notification_notification__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__visually_hidden_visually_hidden__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__forms__ = __webpack_require__(10);










var AccessBooking = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(AccessBooking, _super);
    function AccessBooking() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.focusSet = false;
        _this.errorFocusSet = false;
        _this.emptyFocusSet = false;
        _this.state = {
            errorMessage: null,
            requests: [_this.createNewLine(0)],
            requestsNotificationsVisible: true,
            submitting: false
        };
        _this.onRequestClose = function (e) {
            var results = _this.state.requests.filter(function (n) { return n.status === 'found'; });
            if (results.length > 0 && _this.props.onComplete) {
                _this.props.onComplete(results[0].bookingNumber.value);
            }
            if (_this.props.onRequestClose) {
                _this.props.onRequestClose(e);
            }
        };
        _this.renderLiveAnnouncement = function (request) {
            var content = _this.props.content;
            var liveAnnouncement = null;
            if (request.status === 'found') {
                liveAnnouncement = replace(content.bookingFoundLiveAnnouncement, [request.bookingNumber.value, request.lastName.value]);
            }
            else if (request.status === 'error') {
                liveAnnouncement = replace(content.bookingNotFoundLiveAnnouncement, [request.bookingNumber.value, request.lastName.value]);
            }
            return liveAnnouncement
                ? renderAdaLive(liveAnnouncement, request.index)
                : null;
        };
        _this.closeRequestNotifications = function () {
            _this.setState({ requestsNotificationsVisible: false });
        };
        _this.clearErrorMessage = function () {
            _this.setState({ errorMessage: null });
        };
        _this.handleAddNewBookingRequestLine = function (e) {
            e.preventDefault();
            if (_this.canAddRequest()) {
                _this.emptyFocusSet = false;
                _this.errorFocusSet = false;
                _this.addNewBookingLine();
            }
        };
        _this.addBookingsToProfile = function () {
            var requests = _this.state.requests;
            _this.enableFocusChange(true);
            var invalidRequests = requests.filter(function (request) {
                if (request.bookingNumber.value.length > 0 && request.lastName.value.length > 0) {
                    return request.bookingNumber.state.invalid || request.lastName.state.invalid;
                }
                return false;
            });
            var validRequests = requests.filter(function (request) {
                if (request.bookingNumber.value.length > 0 && request.lastName.value.length > 0 && request.status !== 'found') {
                    return request.bookingNumber.state.valid && request.lastName.state.valid;
                }
                return false;
            }).map(function (request) { return ({
                bookingNumber: request.bookingNumber.value,
                lastName: request.lastName.value,
                saveToProfile: request.saveToProfile.checked === true
            }); });
            if (invalidRequests.length && !validRequests.length) { // only reject if no correct requests
                _this.focusOnInvalidRequest(invalidRequests[0]);
                _this.enableFocusChange(false);
                return;
            }
            _this.setState({ errorMessage: null });
            if (validRequests.length) {
                _this.setState({ submitting: true });
                _this.props.onSubmit(validRequests)
                    .then(_this.handleSuccess)
                    .catch(_this.handleErrorSubmission);
            }
            else {
                _this.focusSet = true;
                _this.emptyFocusSet = true;
                var firstInvalidRequest = requests.find(function (r) { return r.status !== 'found'; }) || requests[0];
                _this.focusOnInvalidRequest(firstInvalidRequest);
            }
        };
        _this.enableFocusChange = function (enable) {
            _this.focusSet = _this.emptyFocusSet = _this.errorFocusSet = !enable;
        };
        _this.handleSuccess = function (response) {
            _this.focusSet = true;
            _this.setState(function (state) {
                var newRequests = state.requests.map(function (request) {
                    // only update to 'valid' requests
                    if (request.lastName.value && request.bookingNumber.value
                        && request.lastName.state.valid && request.bookingNumber.state.valid) {
                        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, request), { status: 'found' });
                    }
                    return request;
                });
                return {
                    requests: newRequests,
                    requestsNotificationsVisible: true,
                    submitting: false
                };
            });
        };
        _this.handleErrorSubmission = function (response) {
            if (!response.responses) {
                _this.setState({
                    errorMessage: _this.props.content.errorSubmittingForm,
                    submitting: false
                });
                return;
            }
            _this.enableFocusChange(false);
            _this.errorFocusSet = false;
            _this.setState(function (state) {
                var newRequests = state.requests.map(function (request) {
                    // skip requests already found
                    if (request.status === 'found') {
                        return request;
                    }
                    // find response
                    var requestResponse = response.responses.filter(function (n) {
                        return n.bookingNumber === request.bookingNumber.value &&
                            n.lastName === request.lastName.value;
                    })[0];
                    if (!requestResponse) {
                        return request;
                    }
                    var errorMessage = requestResponse.details && requestResponse.details.length > 0
                        ? requestResponse.details.map(function (e) { return e.message; }).join('. ')
                        : null;
                    // update request with new status
                    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, request), { errorMessage: errorMessage, status: requestResponse.success ? 'found' : 'error' });
                });
                return {
                    requests: newRequests,
                    requestsNotificationsVisible: true,
                    submitting: false
                };
            });
        };
        _this.handleUiRequestValueChange = function (newModel, index) {
            _this.setState(function (prevState) {
                var requests = prevState.requests.map(function (request, i) {
                    var _a;
                    if (index !== i) {
                        return request;
                    }
                    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, request), (_a = {}, _a[newModel.name] = Object(__WEBPACK_IMPORTED_MODULE_9__forms__["q" /* withValue */])(newModel, newModel.value.toUpperCase()), _a.status = 'unsubmitted', _a));
                });
                return { requests: requests };
            });
        };
        _this.renderBookingRequestItem = function (request, index) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__access_booking_request_line__["a" /* AccessBookingRequestLine */], { key: index, index: index, bookingNumber: request.bookingNumber, lastName: request.lastName, saveToProfile: request.saveToProfile, status: request.status, content: _this.props.content, onDataChange: _this.handleUiRequestValueChange, errorMessage: request.errorMessage, anonymousUser: _this.props.anonymousUser }));
        };
        return _this;
    }
    AccessBooking.prototype.createNewLine = function (index) {
        return {
            index: index,
            bookingNumber: Object(__WEBPACK_IMPORTED_MODULE_9__forms__["i" /* createControlModel */])({
                id: 'bookingNumber' + index,
                name: 'bookingNumber',
                value: '',
                validators: {
                    required: true,
                    pattern: this.props.content.bookingNumberRegex
                },
                errorMessages: {
                    required: this.props.content.invalidBookingNumber,
                    pattern: this.props.content.invalidBookingNumber
                }
            }),
            lastName: Object(__WEBPACK_IMPORTED_MODULE_9__forms__["i" /* createControlModel */])({
                id: 'lastName' + index,
                name: 'lastName',
                value: '',
                validators: {
                    required: true,
                    pattern: this.props.content.lastNameRegex
                },
                errorMessages: {
                    required: this.props.content.invalidLastName,
                    pattern: this.props.content.invalidLastName
                }
            }),
            saveToProfile: Object(__WEBPACK_IMPORTED_MODULE_9__forms__["i" /* createControlModel */])({
                id: 'saveToProfile' + index,
                name: 'saveToProfile',
                value: '1',
                checked: false
            }),
            status: 'unsubmitted'
        };
    };
    AccessBooking.prototype.render = function () {
        return this.props.mode === 'embedded'
            ? this.renderEmbedded()
            : this.renderModal();
    };
    AccessBooking.prototype.handleInvalidRequest = function (request) {
        if (this.isInvalidRequest(request, true)) {
            if (!this.errorFocusSet) {
                this.focusOnInvalidRequest(request);
            }
            return request;
        }
        return null;
    };
    AccessBooking.prototype.handleEmptyRequest = function (emptyRequest) {
        if (!this.emptyFocusSet) {
            var element = document.getElementById(emptyRequest.bookingNumber.id);
            focusOn(element);
            return this.emptyFocusSet = true;
        }
        return false;
    };
    AccessBooking.prototype.getFirstEmptyRequest = function () {
        return this.state.requests.find(function (request) {
            return request.status !== 'found'
                && (!request.bookingNumber.value
                    || !request.lastName.value);
        });
    };
    AccessBooking.prototype.componentDidUpdate = function () {
        var invalidRequest = null;
        for (var _i = 0, _a = this.state.requests; _i < _a.length; _i++) {
            var request = _a[_i];
            invalidRequest = this.handleInvalidRequest(request);
            if (invalidRequest) {
                break;
            }
        }
        if (!invalidRequest) {
            var emptyRequest = this.getFirstEmptyRequest();
            if (emptyRequest) {
                if (!this.handleEmptyRequest(emptyRequest)) {
                    this.handleFocus(false);
                }
            }
        }
    };
    AccessBooking.prototype.componentDidMount = function () {
        var _this = this;
        // ADA. firefox not counting first request if focus explicitily set.
        setTimeout(function () {
            _this.handleFocus(true);
        }, 500);
    };
    AccessBooking.prototype.handleFocus = function (onFirstNotFound) {
        var requests = this.state.requests;
        if (!requests) {
            return;
        }
        if (!this.focusSet) {
            var notFoundRequests = requests.filter(function (x) { return x.status !== 'found'; });
            if (notFoundRequests.length) {
                var focusRequest = onFirstNotFound ? notFoundRequests[0] : notFoundRequests[notFoundRequests.length - 1];
                var element = document.getElementById(focusRequest.bookingNumber.id);
                focusOn(element);
            }
            this.focusSet = true;
        }
    };
    AccessBooking.prototype.renderEmbedded = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
            this.renderHeader(),
            this.renderBody(),
            this.renderFooter()));
    };
    AccessBooking.prototype.renderModal = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__modal_modal_shell__["b" /* ModalShell */], { header: this.renderHeader(), footer: this.renderFooter(), notification: this.renderNotification(), onRequestClose: this.onRequestClose, closeModalText: this.props.content.closeModal }, this.renderBody()));
    };
    AccessBooking.prototype.renderHeader = function () {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h2", { className: __WEBPACK_IMPORTED_MODULE_3__modal_modal_shell__["a" /* ModalHeadingClassName */] }, this.props.content.heading);
    };
    AccessBooking.prototype.renderAddAnotherLink = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "container" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row h-access-booking__add-another-row" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "", className: "h-access-booking__add-another-button", id: "add-another-booking-link", onClick: this.handleAddNewBookingRequestLine, "aria-label": this.props.content.addAnotherAriaLabel, role: "button" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__icons__["CirclePlusIcon"], { "aria-hidden": "true", className: "h-access-booking__button-icon" }),
                        this.props.content.addAnother)))));
    };
    AccessBooking.prototype.renderBody = function () {
        var requests = this.state.requests;
        var maxNumberOfRequests = this.props.content.maximumNumberOfRequests;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("form", { className: "h-form", autoComplete: "off" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "container", ref: this.listRef }, requests.map(this.renderBookingRequestItem)),
            maxNumberOfRequests > requests.length && this.renderAddAnotherLink(),
            this.renderAdaSubmissionResult()));
    };
    AccessBooking.prototype.renderFooter = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__button_button__["a" /* Button */], { color: "red", type: "button", className: "h-btn--min-width", onClick: this.addBookingsToProfile, "aria-label": this.props.content.submitButtonAriaLabel, disabled: this.state.submitting, busy: this.state.submitting }, this.props.content.submitButton));
    };
    AccessBooking.prototype.renderAdaSubmissionResult = function () {
        var requests = this.state.requests;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], { "aria-live": "assertive", role: "alert" }, requests.map(this.renderLiveAnnouncement)));
    };
    AccessBooking.prototype.renderNotification = function () {
        var _this = this;
        var content = this.props.content;
        var _a = this.state, requests = _a.requests, requestsNotificationsVisible = _a.requestsNotificationsVisible, errorMessage = _a.errorMessage;
        if (requestsNotificationsVisible && requests.every(function (n) { return n.status === 'found'; })) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { "aria-live": "assertive", role: "alert" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__notification_notification__["a" /* Notification */], { type: "success", mode: "edge", closeMode: "auto", closeAriaLabel: content.autoCloseNotificationAriaLabel, onClose: this.closeRequestNotifications }, content.bookingsAddedSuccessfully)));
        }
        if (requestsNotificationsVisible && requests.some(function (n) { return _this.isInvalidRequest(n); })) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { "aria-live": "assertive", role: "alert" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__notification_notification__["a" /* Notification */], { type: "error", mode: "edge", closeMode: "manual", closeAriaLabel: content.closeNotificationAriaLabel, onClose: this.closeRequestNotifications }, content.requiredFields)));
        }
        if (errorMessage) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { "aria-live": "assertive", role: "alert" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__notification_notification__["a" /* Notification */], { type: "error", mode: "edge", closeMode: "manual", closeAriaLabel: content.closeNotificationAriaLabel, onClose: this.clearErrorMessage }, errorMessage)));
        }
        return null;
    };
    AccessBooking.prototype.canAddRequest = function () {
        var maxLines = this.props.content.maximumNumberOfRequests;
        return this.state.requests.length < maxLines;
    };
    AccessBooking.prototype.addNewBookingLine = function () {
        var _this = this;
        this.setState(function (state) {
            return {
                requests: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spreadArrays */])(state.requests, [
                    _this.createNewLine(state.requests.length)
                ]),
            };
        });
    };
    AccessBooking.prototype.isInvalidRequest = function (request, includeSubmissionError) {
        if (includeSubmissionError === void 0) { includeSubmissionError = false; }
        return (request.bookingNumber.state.invalid && request.bookingNumber.state.dirty && request.status !== 'unsubmitted')
            || (request.lastName.state.invalid && request.lastName.state.dirty && request.status !== 'unsubmitted')
            || (includeSubmissionError && request.status === 'error');
    };
    AccessBooking.prototype.focusOnInvalidRequest = function (request) {
        var id = null;
        if (request.status === 'error') {
            id = request.bookingNumber.id;
        }
        else if (request.bookingNumber.state.invalid) {
            id = request.bookingNumber.id;
        }
        else if (request.lastName.state.invalid) {
            id = request.lastName.id;
        }
        if (id) {
            var element = document.getElementById(id);
            focusOn(element);
        }
        this.errorFocusSet = true;
    };
    return AccessBooking;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

// tslint:disable-next-line:no-any
function replace(content, params) {
    var result = content;
    params.map(function (o, i) {
        result = result.replace('{' + i + '}', o);
    });
    return result;
}
function renderAdaLive(children, key) {
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { key: key }, children));
}
function focusOn(element) {
    if (element) {
        element.focus();
    }
}
//# sourceMappingURL=access-booking.js.map

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = genId;
function genId(bookingNumber, suffix) {
    return "bk-dtl-card-" + bookingNumber + "-" + suffix;
}
//# sourceMappingURL=model.js.map

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = deepMap;
/* harmony export (immutable) */ __webpack_exports__["a"] = deepForEach;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elementTypes__ = __webpack_require__(117);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




function isTabChild(child) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["a" /* isTab */])(child) || Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["b" /* isTabList */])(child) || Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["c" /* isTabPanel */])(child);
}

function deepMap(children, callback) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (child) {
    // null happens when conditionally rendering TabPanel/Tab
    // see https://github.com/reactjs/react-tabs/issues/37
    if (child === null) return null;

    if (isTabChild(child)) {
      return callback(child);
    }

    if (child.props && child.props.children && typeof child.props.children === 'object') {
      // Clone the child that has children and map them too
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, _objectSpread({}, child.props, {
        children: deepMap(child.props.children, callback)
      }));
    }

    return child;
  });
}
function deepForEach(children, callback) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].forEach(children, function (child) {
    // null happens when conditionally rendering TabPanel/Tab
    // see https://github.com/reactjs/react-tabs/issues/37
    if (child === null) return;

    if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["a" /* isTab */])(child) || Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["c" /* isTabPanel */])(child)) {
      callback(child);
    } else if (child.props && child.props.children && typeof child.props.children === 'object') {
      if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["b" /* isTabList */])(child)) callback(child);
      deepForEach(child.props.children, callback);
    }
  });
}

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = replaceUrlPlaceholder;
/* harmony export (immutable) */ __webpack_exports__["b"] = toTitleCase;
function replaceUrlPlaceholder(url, activeSailing) {
    if (!url) {
        return url;
    }
    url = url.replace('{encryptedBookingNumber}', activeSailing.bookings[0].encryptedBookingNumber)
        .replace('{encryptedBookingNumbers}', activeSailing.encryptedBookingNumbers)
        .replace('{plainBookingNumber}', activeSailing.bookings[0].bookingNumber)
        .replace('{bookingNumber}', activeSailing.bookings[0].bookingNumber)
        .replace('{shipCode}', activeSailing.itinerary.shipCode)
        .replace('{sailDate}', activeSailing.itinerary.sailDate);
    return url;
}
function toTitleCase(value) {
    return value.toLowerCase().split(' ').map(function (n) { return n.charAt(0).toUpperCase() + n.substring(1); }).join(' ');
}
//# sourceMappingURL=helpers.js.map

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HiddenAmountToken; });
var HiddenAmountToken = 'N/A';
//# sourceMappingURL=models.js.map

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TravelCompanionConflictModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal_modal_shell__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__travel_companion_conflict_modal_css__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__travel_companion_conflict_modal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__travel_companion_conflict_modal_css__);






var TravelCompanionConflictModal = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(TravelCompanionConflictModal, _super);
    function TravelCompanionConflictModal(props) {
        var _this = _super.call(this, props) || this;
        _this.closeModal = function () {
            _this.props.onClose();
        };
        _this.onMerge = function () {
            _this.props.onConflictSubmit('merge');
        };
        _this.onSplit = function () {
            _this.props.onConflictSubmit('join');
        };
        return _this;
    }
    TravelCompanionConflictModal.prototype.render = function () {
        var _a = this.props, openModal = _a.openModal, content = _a.content, bodyMessage = _a.bodyMessage;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__modal_modal__["a" /* Modal */], { shell: true, isOpen: openModal, fullScreen: false, header: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h2", { className: __WEBPACK_IMPORTED_MODULE_4__modal_modal_shell__["a" /* ModalHeadingClassName */] }, content.conflictModalHeader), closeModalText: content.closeModalText, onRequestClose: this.closeModal, dialogDescription: content.conflictModalAdaDescription, footer: this.renderFooter(), className: "h-tc-modal-shell", shouldCloseOnOverlayClick: false },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-tc-modal-body" }, bodyMessage))));
    };
    TravelCompanionConflictModal.prototype.renderFooter = function () {
        var _a = this.props, canMergeGroups = _a.canMergeGroups, submitting = _a.submitting, content = _a.content;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "container" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row h-tc-modal__footer" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-tc-modal__button col-md" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__button_button__["a" /* Button */], { color: "outline-black", type: "button", className: "h-btn--min-width", onClick: this.onSplit, "aria-label": content.joinGroupButtonAriaLabel, disabled: submitting, busy: submitting }, content.joinGroupButtonText)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-tc-modal__button col-md" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__button_button__["a" /* Button */], { color: "red", type: "button", className: "h-btn--min-width", onClick: this.onMerge, "aria-label": content.mergeGroupButtonAriaLabel, disabled: !canMergeGroups || submitting, busy: submitting }, content.mergeGroupButtonText)))));
    };
    return TravelCompanionConflictModal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=travel-companion-conflict-modal.js.map

/***/ }),
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_api_models__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_api_models___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_api_models__);
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__common_api_models__, "AlertsManagerContainer")) __webpack_require__.d(__webpack_exports__, "AlertsManagerContainer", function() { return __WEBPACK_IMPORTED_MODULE_0__common_api_models__["AlertsManagerContainer"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__common_api_models__, "CompactItineraryCalendarContainer")) __webpack_require__.d(__webpack_exports__, "CompactItineraryCalendarContainer", function() { return __WEBPACK_IMPORTED_MODULE_0__common_api_models__["CompactItineraryCalendarContainer"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__common_api_models__, "ParametersSailingProvider")) __webpack_require__.d(__webpack_exports__, "ParametersSailingProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__common_api_models__["ParametersSailingProvider"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__common_api_models__, "ToDosContainer")) __webpack_require__.d(__webpack_exports__, "ToDosContainer", function() { return __WEBPACK_IMPORTED_MODULE_0__common_api_models__["ToDosContainer"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_constants__ = __webpack_require__(180);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_content_parser__ = __webpack_require__(181);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_content_service__ = __webpack_require__(108);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_initial_data_service__ = __webpack_require__(91);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_network_cache__ = __webpack_require__(422);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_sailing_provider_sailing_provider_props__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_sailing_provider_sailing_provider_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_sailing_provider_sailing_provider_props__);
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_6__components_sailing_provider_sailing_provider_props__, "AlertsManagerContainer")) __webpack_require__.d(__webpack_exports__, "AlertsManagerContainer", function() { return __WEBPACK_IMPORTED_MODULE_6__components_sailing_provider_sailing_provider_props__["AlertsManagerContainer"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_6__components_sailing_provider_sailing_provider_props__, "CompactItineraryCalendarContainer")) __webpack_require__.d(__webpack_exports__, "CompactItineraryCalendarContainer", function() { return __WEBPACK_IMPORTED_MODULE_6__components_sailing_provider_sailing_provider_props__["CompactItineraryCalendarContainer"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_6__components_sailing_provider_sailing_provider_props__, "ParametersSailingProvider")) __webpack_require__.d(__webpack_exports__, "ParametersSailingProvider", function() { return __WEBPACK_IMPORTED_MODULE_6__components_sailing_provider_sailing_provider_props__["ParametersSailingProvider"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_6__components_sailing_provider_sailing_provider_props__, "ToDosContainer")) __webpack_require__.d(__webpack_exports__, "ToDosContainer", function() { return __WEBPACK_IMPORTED_MODULE_6__components_sailing_provider_sailing_provider_props__["ToDosContainer"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_sailing_provider_parameters_sailing_provider__ = __webpack_require__(424);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "ParametersSailingProvider", function() { return __WEBPACK_IMPORTED_MODULE_7__components_sailing_provider_parameters_sailing_provider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_itinerary_calendar_compact_itinerary_calendar_container__ = __webpack_require__(425);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "CompactItineraryCalendarContainer", function() { return __WEBPACK_IMPORTED_MODULE_8__components_itinerary_calendar_compact_itinerary_calendar_container__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_itinerary_calendar_itinerary_calendar_service__ = __webpack_require__(189);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_to_dos_to_dos_container__ = __webpack_require__(452);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "ToDosContainer", function() { return __WEBPACK_IMPORTED_MODULE_10__components_to_dos_to_dos_container__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_to_dos_to_dos_service__ = __webpack_require__(193);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_alerts_manager_alerts_manager_container__ = __webpack_require__(509);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "AlertsManagerContainer", function() { return __WEBPACK_IMPORTED_MODULE_12__components_alerts_manager_alerts_manager_container__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_alerts_manager_alert_manager_service__ = __webpack_require__(209);
/* unused harmony namespace reexport */














//# sourceMappingURL=cclr-booked.js.map

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export baseUrl */
/* unused harmony export editBookingUrlToken */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return localRoutes; });
var baseUrl = '/booked';
var editBookingUrlToken = '/edit-booking';
var localRoutes = {
    home: baseUrl + "/home",
    details: baseUrl + "/details",
    planner: baseUrl + "/planner",
    access: baseUrl + "/access",
    funmail: baseUrl + "/funmail",
    form: baseUrl + "/form",
    browseModeForm: baseUrl + "/appointment",
    travelCompanion: baseUrl + "/travelcompanion",
};
//# sourceMappingURL=constants.js.map

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ContentParser */
/* harmony export (immutable) */ __webpack_exports__["a"] = parseContent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

var ContentParser = /** @class */ (function () {
    function ContentParser() {
    }
    ContentParser.prototype.mapContent = function (item) {
        var target = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ children: this.mapItems(item.children) }, this.mapFields(item.fields));
        return target;
    };
    ContentParser.prototype.parseField = function (field) {
        var _this = this;
        if (!field) {
            return null;
        }
        var target = {};
        if (!field.value) {
            target = null;
        }
        else if (field.value.hasOwnProperty('templateId')) {
            target = this.mapItem(field.value);
        }
        else if (Array.isArray(field.value)) {
            var values_1 = [];
            field.value.forEach(function (value) {
                var mappedSubItem = _this.mapItem(value);
                if (mappedSubItem) {
                    values_1.push(mappedSubItem);
                }
            });
            target = values_1;
        }
        else {
            target = field.value;
        }
        return target;
    };
    ContentParser.prototype.mapFields = function (fields) {
        var _this = this;
        var targetFields = {};
        if (fields) {
            Object.keys(fields).forEach(function (key) {
                var fieldValue = fields[key];
                targetFields[key] = _this.parseField(fieldValue);
            });
        }
        return targetFields;
    };
    ContentParser.prototype.mapItems = function (items) {
        var _this = this;
        if (!items) {
            return [];
        }
        var contentItems = [];
        items.forEach(function (subItem) {
            var mappedSubItem = _this.mapItem(subItem);
            if (mappedSubItem) {
                contentItems.push(mappedSubItem);
            }
        });
        return contentItems;
    };
    ContentParser.prototype.mapItem = function (item) {
        if (!item) {
            return null;
        }
        var target = this.mapFields(item.fields);
        if (item.children && target.hasOwnProperty('children') !== undefined) {
            target.children = this.mapItems(item.children);
        }
        return target;
    };
    return ContentParser;
}());

function parseContent(item) {
    var converter = new ContentParser();
    var content = converter.mapContent(item);
    // tslint:disable-next-line:no-any
    return content;
}
//# sourceMappingURL=content-parser.js.map

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CookieService; });
// Brought from https://github.com/js-cookie/js-cookie
// and modified to play nice with typescript and webpack
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
function set(key, value, attributes) {
    if (typeof document === 'undefined' || !key || !value) {
        return undefined;
    }
    attributes = __assign({ path: '/' }, attributes);
    if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(new Date().getTime() + attributes.expires * 864e+5);
    }
    // We're using "expires" because "max-age" is not supported by IE
    attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
    try {
        var result = JSON.stringify(value);
        if (/^[\{\[]/.test(result)) {
            value = result;
        }
        // tslint:disable-next-line:no-empty
    }
    catch (e) { }
    value =
        encodeURIComponent(String(value))
            .replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
    key = encodeURIComponent(String(key))
        .replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
        .replace(/[\(\)]/g, escape);
    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
            continue;
        }
        stringifiedAttributes += '; ' + attributeName;
        if (attributes[attributeName] === true) {
            continue;
        }
        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }
    return (document.cookie = key + '=' + value + stringifiedAttributes);
}
function get(key) {
    return getHelper(key, false /* read as raw */);
}
function getJSON(key) {
    return getHelper(key, true /* read as json */);
}
function remove(key, attributes) {
    CookieService.set(key, '', __assign({}, attributes, { expires: -1 }));
}
function decode(s) {
    return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
}
function getHelper(key, json) {
    if (typeof document === 'undefined') {
        return undefined;
    }
    var jar = {};
    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var i = 0;
    for (; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var cookie = parts.slice(1).join('=');
        if (!json && cookie.charAt(0) === '"') {
            cookie = cookie.slice(1, -1);
        }
        try {
            var name_1 = decode(parts[0]);
            cookie = decode(cookie);
            if (json) {
                try {
                    cookie = JSON.parse(cookie);
                    // tslint:disable-next-line:no-empty
                }
                catch (e) { }
            }
            jar[name_1] = cookie;
            if (key === name_1) {
                break;
            }
            // tslint:disable-next-line:no-empty
        }
        catch (e) { }
    }
    return key ? jar[key] : jar;
}
/**
 * Returns the domain to be used when handling cookies.
 * @param {string} host - optional, will use window.location.host by default.
 * @returns {string} The domain to be used when handling cookies.
 */
function getCookieDomain(host) {
    if (!host) {
        host = window.location.host;
    }
    var parts = host.split('.');
    if (parts.length <= 2) {
        return host;
    }
    return parts.splice(1).join('.');
}
var CookieService = {
    set: set,
    get: get,
    getJSON: getJSON,
    remove: remove,
    getCookieDomain: getCookieDomain
};
//# sourceMappingURL=cookies-service.js.map

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isSupported */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocalStorageService; });
var isSupported = checkBrowserSupport();
function get(key) {
    if (hasError(key)) {
        return null;
    }
    try {
        var result = window.localStorage.getItem(key);
        return result !== null ? JSON.parse(result) : null;
    }
    catch (e) {
        return null;
    }
}
function set(key, value) {
    if (hasError(key) || !value) {
        return false;
    }
    window.localStorage.setItem(key, JSON.stringify(value));
    return true;
}
function hasError(key) {
    return !isSupported || !key;
}
function checkBrowserSupport() {
    var supported;
    try {
        supported = window.localStorage !== null;
        if (supported) {
            var key = '__testbrowsersupport';
            window.localStorage.setItem(key, key);
            window.localStorage.removeItem(key);
        }
        return supported;
    }
    catch (e) {
        supported = false;
    }
    return supported;
}
var LocalStorageService = {
    get: get,
    set: set,
    isSupported: isSupported
};
//# sourceMappingURL=local-storage-service.js.map

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CabinInteriorIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


// tslint:disable:max-line-length
var CabinInteriorIcon = function (_a) {
    var width = _a.width, height = _a.height, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: width || '25', height: height || '25' }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M24 21V4a4 4 0 0 0-4-4H4a4 4 0 0 0-4 4v19a1 1 0 0 0 1 1 1 1 0 0 0 1-1v-2h20v2a1 1 0 0 0 1 1 1 1 0 0 0 1-1v-2zM11 10v1H7a1 1 0 0 1 0-2h3a1 1 0 0 1 1 1zm9 3a2 2 0 0 1 2 2v4H2v-4.06A2 2 0 0 1 4 13zm-2-3a1 1 0 0 1-1 1h-4v-1a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1zm2-8a2 2 0 0 1 2 2v7.59a4 4 0 0 0-2-.59h-.17A3 3 0 0 0 17 7h-3a3 3 0 0 0-2 .8 3 3 0 0 0-2-.8H7a3 3 0 0 0-2.82 4H4a3.86 3.86 0 0 0-2 .56V4a2 2 0 0 1 2-2z" })));
};
// tslint:enable:max-line-length
//# sourceMappingURL=cabin-interior-icon.js.map

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CabinInteriorPortholeIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


// tslint:disable:max-line-length
var CabinInteriorPortholeIcon = function (_a) {
    var width = _a.width, height = _a.height, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: width || '25', height: height || '25' }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M8 18h8a1 1 0 1 0 0-2H8a1 1 0 1 0 0 2z" }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0zm0 2a10 10 0 0 1 10 10h-4a6 6 0 0 0-12 0H2A10 10 0 0 1 12 2zm4 10H8a4 4 0 0 1 8 0zm-4 10a10 10 0 0 1-9.8-8h19.6a10 10 0 0 1-9.8 8z" }))));
};
// tslint:enable:max-line-length
//# sourceMappingURL=cabin-interior-porthole-icon.js.map

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CabinOceanviewIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


// tslint:disable:max-line-length
var CabinOceanviewIcon = function (_a) {
    var width = _a.width, height = _a.height, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: width || '25', height: height || '25' }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M20 17H4a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2zM17 21H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2zM23 13h-3a7.92 7.92 0 0 0-8-8 7.93 7.93 0 0 0-8 8H1a1 1 0 0 0 0 2h22a1 1 0 0 0 0-2zM6 13a6 6 0 1 1 12 0zM12 3a1 1 0 0 0 1-1V1a1 1 0 0 0-2 0v1a1 1 0 0 0 1 1zM5.19 4.59A1 1 0 0 0 6 5a1 1 0 0 0 .81-1.59l-.59-.81A1 1 0 1 0 4.6 3.78z" }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M.72 10.13l1 .31a1.06 1.06 0 0 0 .31.05 1 1 0 0 0 .31-2l-.95-.31a1 1 0 0 0-1.26.64 1 1 0 0 0 .59 1.31zM22 10.62a1.18 1.18 0 0 0 .31 0l.95-.31a1 1 0 1 0-.62-1.9l-.95.31a1 1 0 0 0 .31 1.9zM18 5a1 1 0 0 0 .81-.42l.59-.81a1 1 0 0 0-1.62-1.17l-.59.81a1 1 0 0 0 .23 1.4A1 1 0 0 0 18 5z" }))));
};
// tslint:enable:max-line-length
//# sourceMappingURL=cabin-oceanview-icon.js.map

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CabinBalconyIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


// tslint:disable:max-line-length
var CabinBalconyIcon = function (_a) {
    var width = _a.width, height = _a.height, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: width || '25', height: height || '25' }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M-161.5-80a1.5 1.5 0 0 1-1.5-1.5 1.5 1.5 0 0 1 1.5-1.5 1.51 1.51 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5zM-151.88-67.28s-1.12-3-1.13-3.06a1 1 0 0 0-.93-.65H-160l-2.14-5.87a1 1 0 0 0-1.28-.6 1 1 0 0 0-.6 1.28l2.26 6.2-1 2.69a1 1 0 0 0 .58 1.24 1 1 0 0 0 1.24-.58L-160-69h5.39l.87 2.4a1 1 0 0 0 1.26.58 1 1 0 0 0 .6-1.26z", transform: "translate(168 84)" }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M-146-77a1 1 0 0 0-1 1v9a1 1 0 0 1-1 1h-18v-17a1 1 0 0 0-1-1 1 1 0 0 0-1 1v22a1 1 0 0 0 1 1 1 1 0 0 0 1-1v-3h18a3 3 0 0 0 3-3v-9a1 1 0 0 0-1-1z", transform: "translate(168 84)" }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M-155.42-72h-1.64a3 3 0 0 1-2.78-1.87l-1.51-3.75a1 1 0 0 1 .55-1.3 1 1 0 0 1 1.3.55l1.52 3.75a1 1 0 0 0 .92.62h1.64a1 1 0 0 0 .8-.4l3.42-4.22a1 1 0 0 1 .53-.34l4.42-1a1 1 0 0 1 1.22.72 1 1 0 0 1-.72 1.22l-4.1.91-3.15 3.94a3 3 0 0 1-2.42 1.17z", transform: "translate(168 84)" }))));
};
// tslint:enable:max-line-length
//# sourceMappingURL=cabin-balcony-icon.js.map

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CabinSuiteIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


// tslint:disable:max-line-length
var CabinSuiteIcon = function (_a) {
    var width = _a.width, height = _a.height, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: width || '25', height: height || '25' }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M24 20v-3a4 4 0 0 0-4-4h-.17a3.05 3.05 0 0 0 .17-1 3 3 0 0 0-3-3h-3a3 3 0 0 0-2 .79A3 3 0 0 0 10 9H7a3 3 0 0 0-3 3 3.05 3.05 0 0 0 .18 1H4a4 4 0 0 0-4 4v6a1 1 0 0 0 1 1 1 1 0 0 0 1-1v-2h20v2a1 1 0 0 0 1 1 1 1 0 0 0 1-1v-3zm-10-9h3a1 1 0 0 1 0 2h-4v-1a1 1 0 0 1 1-1zm-7 0h3a1 1 0 0 1 1 1v1H7a1 1 0 1 1 0-2zm-5 8v-2a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2zM9 7h6a1.5 1.5 0 0 0 1.06-.44 1.52 1.52 0 0 0 .44-1.06v-4a1.49 1.49 0 0 0-1-1.42A1.34 1.34 0 0 0 15 0a1.46 1.46 0 0 0-1.19.6l-.31.4-.31-.4A1.49 1.49 0 0 0 12 0a1.47 1.47 0 0 0-1.19.6l-.31.4-.3-.4A1.52 1.52 0 0 0 9 0a1.26 1.26 0 0 0-.47.08 1.48 1.48 0 0 0-1 1.42v4A1.5 1.5 0 0 0 9 7zm0-5.5l1.5 2 1.5-2 1.5 2 1.5-2v4H9z" })));
};
// tslint:enable:max-line-length
//# sourceMappingURL=cabin-suite-icon.js.map

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchCalendarData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ccl_utilities__ = __webpack_require__(63);

var store = {};
function fetchCalendarData(shipCode, sailDate, bookingFilters, retrieveMaxDays) {
    var sortedBookings = bookingFilters.sort();
    var calendarParams = sortedBookings.length > 0 ? '&bookingNumbers=' + sortedBookings.join('&bookingNumbers=') : '';
    if (retrieveMaxDays) {
        calendarParams += '&maxDays=' + retrieveMaxDays;
    }
    if (!store[calendarParams]) {
        var calendarUrl = "/booked/api/v1.0/Bookings/Sailing/Calendar?ShipCode=" + shipCode + "&SailDate=" + sailDate + calendarParams;
        store[calendarParams] = Object(__WEBPACK_IMPORTED_MODULE_0_ccl_utilities__["a" /* cclFetch */])(calendarUrl);
    }
    return store[calendarParams];
}
//# sourceMappingURL=itinerary-calendar-service.js.map

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ExtraSmall */
/* unused harmony export Small */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Medium; });
/* unused harmony export Large */
/* unused harmony export ExtraLarge */
var ExtraSmall = 0;
var Small = 544;
var Medium = 768;
var Large = 1024;
var ExtraLarge = 1232;
//# sourceMappingURL=breakpoints.js.map

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MediaQuery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


/**
 * Slimmed down version of:
 * https://github.com/ReactTraining/react-media
 */
var MediaQuery = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(MediaQuery, _super);
    function MediaQuery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            matches: _this.props.defaultMatches
        };
        _this.updateMatches = function () { return _this.setState({ matches: _this._mediaQueryList.matches }); };
        return _this;
    }
    MediaQuery.prototype.componentWillMount = function () {
        var query = this.props.query;
        this._mediaQueryList = window.matchMedia(query);
        this._mediaQueryList.addListener(this.updateMatches);
        this.updateMatches();
    };
    MediaQuery.prototype.componentWillUnmount = function () {
        this._mediaQueryList.removeListener(this.updateMatches);
    };
    MediaQuery.prototype.render = function () {
        var _a = this.props, children = _a.children, render = _a.render;
        var matches = this.state.matches;
        if (render) {
            return matches ? render() : null;
        }
        if (children) {
            if (typeof children === 'function') {
                return children(matches);
            }
            else {
                return matches ? __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(children) : null;
            }
        }
        return null;
    };
    return MediaQuery;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=media-query.js.map

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Collapsible; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__collapsible_css__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__collapsible_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__collapsible_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chevron_chevron__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_colors__ = __webpack_require__(42);






var Collapsible = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Collapsible, _super);
    function Collapsible(props) {
        var _this = _super.call(this, props) || this;
        _this.applyFocus = false;
        _this.contentRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.onToggle = function (e) {
            e.preventDefault();
            _this.applyFocus = true;
            _this.setState(function (prevState) { return ({ isOpen: !prevState.isOpen }); });
        };
        _this.state = {
            isOpen: !!props.openOnInit
        };
        return _this;
    }
    Collapsible.prototype.render = function () {
        var _a = this.props, children = _a.children, id = _a.id, expandedTitle = _a.expandedTitle, expandedTitleAriaLabel = _a.expandedTitleAriaLabel, collapsedTitle = _a.collapsedTitle, collapsedTitleAriaLabel = _a.collapsedTitleAriaLabel, chevronColor = _a.chevronColor;
        var isOpen = this.state.isOpen;
        var contentId = id + "-content";
        var title = isOpen ? expandedTitle : collapsedTitle;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { id: id, className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-collapsible', { 'h-collapsible--expanded': isOpen }) },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { className: "h-collapsible__toggle d-print-none", role: "button", href: "", onClick: this.onToggle, "aria-label": isOpen ? expandedTitleAriaLabel : collapsedTitleAriaLabel, "aria-expanded": isOpen, "aria-controls": contentId },
                title ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null, title)) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null, "\u00A0")),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__chevron_chevron__["a" /* Chevron */], { "aria-hidden": "true", direction: isOpen ? 'up' : 'down', size: 14, color: chevronColor || __WEBPACK_IMPORTED_MODULE_5__styles_colors__["b" /* Blue600Color */], className: "h-collapsible__chevron" })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { id: contentId, ref: this.contentRef, className: "h-collapsible__content d-print-block", tabIndex: -1, style: { outline: 'none' } }, children)));
    };
    Collapsible.prototype.componentDidUpdate = function () {
        if (this.applyFocus && this.state.isOpen && this.contentRef.current) {
            this.contentRef.current.focus();
        }
        this.applyFocus = false;
    };
    return Collapsible;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=collapsible.js.map

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchDataAndContent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_content_service__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ccl_utilities__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_initial_data_service__ = __webpack_require__(91);



function fetchData(sailing) {
    var todosInitialData = Object(__WEBPACK_IMPORTED_MODULE_2__common_initial_data_service__["a" /* getInitialData */])('todos');
    if (todosInitialData) {
        return Promise.resolve(todosInitialData);
    }
    var dataUrl = "/booked/api/v1.0/Bookings/todos?shipCode=" + encodeURIComponent(sailing.itinerary.shipCode) + "&sailDate=" + encodeURIComponent(sailing.itinerary.sailDate);
    return Object(__WEBPACK_IMPORTED_MODULE_1_ccl_utilities__["a" /* cclFetch */])(dataUrl);
}
function fetchDataAndContent(sailing) {
    return Promise.all([
        Object(__WEBPACK_IMPORTED_MODULE_0__common_content_service__["a" /* getContent */])('a54aa145-3a01-4f83-a851-027d43204e2e'),
        Object(__WEBPACK_IMPORTED_MODULE_0__common_content_service__["a" /* getContent */])('17F4E85D-C6EB-4744-B719-4553DF0AA529'),
        fetchData(sailing),
    ]).then(function (results) {
        var content = results[0], bookingSelectorContent = results[1], toDos = results[2];
        var filteredToDos = [];
        var selectedFilters = sailing.bookings.map(function (s) { return s.bookingNumber; });
        if (content && toDos && toDos.sailingToDos) {
            filteredToDos.push.apply(filteredToDos, toDos.sailingToDos);
        }
        return {
            selectedFilters: selectedFilters,
            content: content,
            filteredToDos: filteredToDos,
            bookingSelectorContent: bookingSelectorContent
        };
    });
}
//# sourceMappingURL=to-dos-service.js.map

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createControlGroup;
/* unused harmony export replaceControlModel */
/* unused harmony export values */
function createControlGroup() {
    var controls = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        controls[_i] = arguments[_i];
    }
    return {
        pristine: controls.every(function (n) { return n.state.pristine; }),
        dirty: controls.some(function (n) { return n.state.dirty; }),
        untouched: controls.every(function (n) { return n.state.untouched; }),
        touched: controls.some(function (n) { return n.state.touched; }),
        valid: controls.every(function (n) { return n.state.valid; }),
        invalid: controls.some(function (n) { return n.state.invalid; }),
        controls: createControlsDictionary(controls)
    };
}
function replaceControlModel(controlGroup) {
    var controls = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        controls[_i - 1] = arguments[_i];
    }
    var newControls = [];
    var _loop_1 = function (i) {
        var control = controlGroup.controls.all[i];
        var filteredControls = controls.filter(function (c) { return c.name === control.name; });
        if (filteredControls.length > 0) {
            newControls.push(filteredControls[0]);
        }
        else {
            newControls.push(control);
        }
    };
    for (var i = 0; i < controlGroup.controls.all.length; i++) {
        _loop_1(i);
    }
    return createControlGroup.apply(void 0, newControls);
}
function values(controlGroup) {
    // tslint:disable-next-line:no-any
    var map = {};
    for (var i = 0; i < controlGroup.controls.all.length; i++) {
        var control = controlGroup.controls.all[i];
        map[control.id] = typeof control.checked !== 'undefined' ? control.checked : control.value;
    }
    return map;
}
function createControlsDictionary(controls) {
    var dictionary = {
        all: controls,
        get: {}
    };
    for (var i = 0; i < controls.length; i++) {
        var control = controls[i];
        dictionary.get[control.name] = control;
    }
    return dictionary;
}
//# sourceMappingURL=control-group.js.map

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validators_validators__ = __webpack_require__(459);

function validate(value, validators) {
    var errors = [];
    for (var propName in validators) {
        if (validators.hasOwnProperty(propName)) {
            var options = validators[propName];
            var validatorName = getValidatorName(propName);
            // tslint:disable-next-line:no-any
            var isValid = __WEBPACK_IMPORTED_MODULE_0__validators_validators__["a" /* validators */][validatorName](value, options);
            if (!isValid) {
                errors.push(propName);
            }
        }
    }
    return errors;
}
function getValidatorName(propName) {
    var idx = propName.indexOf('custom');
    if (idx === 0) {
        return 'custom';
    }
    return propName;
}
//# sourceMappingURL=validator.js.map

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dropdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__click_away_listener_click_away_listener__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chevron_chevron__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_popper__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_colors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_focus_trap_react__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_focus_trap_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_focus_trap_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_event_listener__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dropdown_css__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__dropdown_css__);










var Dropdown = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Dropdown, _super);
    function Dropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buttonRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.containerRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.state = {
            isOpen: false
        };
        _this.toggle = function (e) {
            e.preventDefault();
            _this.setState(function (state) { return ({
                isOpen: !state.isOpen
            }); });
        };
        _this.close = function (e) {
            if (e.target === _this.buttonRef.current || _this.buttonRef.current.contains(e.target)) {
                return;
            }
            if (_this.state.isOpen) {
                _this.setState({ isOpen: false });
            }
        };
        _this.onKeyPress = function (e) {
            if (e.keyCode === 27) { // escape key
                if (_this.containerRef.current.contains(e.target)) {
                    _this.setState(function (state) {
                        if (state.isOpen) {
                            _this.buttonRef.current.focus();
                            return { isOpen: false };
                        }
                        return null;
                    });
                }
            }
        };
        return _this;
    }
    Dropdown.prototype.renderButton = function (title, isOpen, id, ariaLabel) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", { type: "button", ref: this.buttonRef, onClick: this.toggle, className: "h-dropdown__toggle", "aria-expanded": isOpen ? 'true' : 'false', "aria-controls": id, "aria-label": ariaLabel || '' },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null, title),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__chevron_chevron__["a" /* Chevron */], { className: "h-dropdown__chevron", size: 16, direction: isOpen ? 'up' : 'down', color: __WEBPACK_IMPORTED_MODULE_6__styles_colors__["c" /* BlueColor */] })));
    };
    Dropdown.prototype.renderContent = function (popperProps, id, children) {
        if (!popperProps) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { id: id, className: "h-dropdown__content" }, children));
        }
        var ref = popperProps.ref, style = popperProps.style, placement = popperProps.placement;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { id: id, ref: ref, style: style, "data-placement": placement, className: "h-dropdown__content" }, children));
    };
    Dropdown.prototype.renderFlyout = function (title, isOpen, id, children, buttonAriaLabel) {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react_popper__["a" /* Manager */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react_popper__["c" /* Reference */], null, function (_a) {
                var ref = _a.ref;
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "h-dropdown__toggle-container", ref: ref }, _this.renderButton(title, isOpen, id, buttonAriaLabel)));
            }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__click_away_listener_click_away_listener__["a" /* ClickAwayListener */], { onClickAway: this.close },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react_popper__["b" /* Popper */], { placement: "bottom" }, function (popperProps) { return (_this.renderContent(popperProps, id, children)); }))));
    };
    Dropdown.prototype.renderRelative = function (title, isOpen, id, children, ariaLabel) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            this.renderButton(title, isOpen, id, ariaLabel),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__click_away_listener_click_away_listener__["a" /* ClickAwayListener */], { onClickAway: this.close }, this.renderContent(null, id, children))));
    };
    Dropdown.prototype.renderStatic = function (title, isOpen, id, children, ariaLabel) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            this.renderButton(title, isOpen, id, ariaLabel),
            this.renderContent(null, id, children)));
    };
    Dropdown.prototype.render = function () {
        var _a = this.props, title = _a.title, className = _a.className, display = _a.display, children = _a.children, id = _a.id, buttonAriaLabel = _a.buttonAriaLabel;
        var isOpen = this.state.isOpen;
        var displayClassName = display === 'static' ? 'h-dropdown--static' : 'h-dropdown--flyout';
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-dropdown', className, displayClassName, { 'h-dropdown--open': isOpen }), ref: this.containerRef },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_react_event_listener___default.a, { target: "document", onKeyUp: this.onKeyPress },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_focus_trap_react__, { active: isOpen, className: "h-dropdown__focus-trap" }, display === 'static' ? this.renderStatic(title, isOpen, id, children, buttonAriaLabel) :
                    (display === 'absolute' ? this.renderFlyout(title, isOpen, id, children, buttonAriaLabel) :
                        this.renderRelative(title, isOpen, id, children, buttonAriaLabel))))));
    };
    return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=dropdown.js.map

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _classCallCheck = _interopDefault(__webpack_require__(198));
var _createClass = _interopDefault(__webpack_require__(199));
var _possibleConstructorReturn = _interopDefault(__webpack_require__(200));
var _getPrototypeOf = _interopDefault(__webpack_require__(201));
var _inherits = _interopDefault(__webpack_require__(202));
var _typeof = _interopDefault(__webpack_require__(93));
var _objectWithoutProperties = _interopDefault(__webpack_require__(203));
var _extends = _interopDefault(__webpack_require__(204));
var React = _interopDefault(__webpack_require__(0));
var PropTypes = _interopDefault(__webpack_require__(26));
var warning = _interopDefault(__webpack_require__(205));

function defineProperty(object, property, attr) {
  return Object.defineProperty(object, property, attr);
} // Passive options
// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js


var passiveOption = function () {
  var cache = null;
  return function () {
    if (cache !== null) {
      return cache;
    }

    var supportsPassiveOption = false;

    try {
      window.addEventListener('test', null, defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      }));
    } catch (err) {//
    }

    cache = supportsPassiveOption;
    return supportsPassiveOption;
  }();
}();

var defaultEventOptions = {
  capture: false,
  passive: false
};

function mergeDefaultEventOptions(options) {
  return _extends({}, defaultEventOptions, options);
}

function getEventListenerArgs(eventName, callback, options) {
  var args = [eventName, callback];
  args.push(passiveOption ? options : options.capture);
  return args;
}

function on(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function off(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function forEachListener(props, iteratee) {
  var children = props.children,
      target = props.target,
      eventProps = _objectWithoutProperties(props, ["children", "target"]);

  Object.keys(eventProps).forEach(function (name) {
    if (name.substring(0, 2) !== 'on') {
      return;
    }

    var prop = eventProps[name];

    var type = _typeof(prop);

    var isObject = type === 'object';
    var isFunction = type === 'function';

    if (!isObject && !isFunction) {
      return;
    }

    var capture = name.substr(-7).toLowerCase() === 'capture';
    var eventName = name.substring(2).toLowerCase();
    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;

    if (isObject) {
      iteratee(eventName, prop.handler, prop.options);
    } else {
      iteratee(eventName, prop, mergeDefaultEventOptions({
        capture: capture
      }));
    }
  });
}

function withOptions(handler, options) {
   false ? warning(options, 'react-event-listener: should be specified options in withOptions.') : void 0;
  return {
    handler: handler,
    options: mergeDefaultEventOptions(options)
  };
}

var EventListener =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(EventListener, _React$PureComponent);

  function EventListener() {
    _classCallCheck(this, EventListener);

    return _possibleConstructorReturn(this, _getPrototypeOf(EventListener).apply(this, arguments));
  }

  _createClass(EventListener, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.applyListeners(on);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.applyListeners(off, prevProps);
      this.applyListeners(on);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.applyListeners(off);
    }
  }, {
    key: "applyListeners",
    value: function applyListeners(onOrOff) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
      var target = props.target;

      if (target) {
        var element = target;

        if (typeof target === 'string') {
          element = window[target];
        }

        forEachListener(props, onOrOff.bind(null, element));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children || null;
    }
  }]);

  return EventListener;
}(React.PureComponent);

EventListener.propTypes =  false ? {
  /**
   * You can provide a single child too.
   */
  children: PropTypes.node,

  /**
   * The DOM target to listen to.
   */
  target: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired
} : {};

exports.withOptions = withOptions;
exports.default = EventListener;


/***/ }),
/* 198 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(482);
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(93)["default"];
var assertThisInitialized = __webpack_require__(484);
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return assertThisInitialized(self);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 201 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(485);
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(486);
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 204 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popper__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Manager__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Reference__ = __webpack_require__(496);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Popper__["a"]; });
/* unused harmony reexport placements */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Manager__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Reference__["a"]; });


// Public components





// Public types

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return unwrapArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return safeInvoke; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};

/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */
var safeInvoke = function safeInvoke(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (typeof fn === "function") {
    return fn.apply(undefined, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args));
  }
};

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Notification; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notification_css__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notification_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__notification_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icons__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_colors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icons_close_timer_icon__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__timer_timer__ = __webpack_require__(513);








var iconMap = {
    'success': __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__icons__["CheckmarkIcon"], { width: "16", height: "16" }),
    'info': __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__icons__["ExclamationIcon"], { width: "16", height: "16", textColor: __WEBPACK_IMPORTED_MODULE_5__styles_colors__["b" /* Blue600Color */], borderColor: __WEBPACK_IMPORTED_MODULE_5__styles_colors__["e" /* Red700Color */] }),
    'error': __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__icons__["SadFaceIcon"], { width: "16", height: "16" }),
    'urgent': __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__icons__["SadFaceIcon"], { width: "16", height: "16" })
};
var Notification = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Notification, _super);
    function Notification() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.timerRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.contentRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.state = {
            closing: false,
            centerContent: false
        };
        _this.pauseTimer = function () {
            if (_this.timerRef.current) {
                _this.timerRef.current.pause();
            }
        };
        _this.resumeTimer = function () {
            if (_this.timerRef.current) {
                _this.timerRef.current.resume();
            }
        };
        _this.onClose = function (event) {
            if (event) {
                event.preventDefault();
            }
            _this.startClosing();
        };
        _this.onCloseAndStopTimer = function (stopTimer, event) {
            if (event) {
                event.preventDefault();
            }
            if (typeof stopTimer === 'function') {
                stopTimer();
            }
            _this.startClosing();
        };
        _this.startClosing = function () {
            if (!_this.state.closing) {
                _this.setState({ closing: true }, function () { return setTimeout(_this.close, 500); });
            }
        };
        _this.close = function () {
            var onClose = _this.props.onClose;
            _this.setState({ closing: false }, function () { return onClose(); });
        };
        return _this;
    }
    Notification.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.computeAlignment();
    };
    Notification.prototype.componentDidMount = function () {
        this.computeAlignment();
    };
    Notification.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, type = _a.type, mode = _a.mode;
        if (!children) {
            return null;
        }
        var _b = this.state, closing = _b.closing, centerContent = _b.centerContent;
        var cn = __WEBPACK_IMPORTED_MODULE_2_classnames__('d-print-none', "h-notification h-notification--" + type, className, { 'h-notification--centered': centerContent, 'h-notification--hidden': closing });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: cn }, mode === 'edge' ?
            this.renderEdge() :
            this.renderContent()));
    };
    Notification.prototype.renderEdge = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "container" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col" }, this.renderContent()))));
    };
    Notification.prototype.renderContent = function () {
        var _a = this.props, children = _a.children, type = _a.type, hideIcon = _a.hideIcon, bodyClassName = _a.bodyClassName;
        var bodyClass = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-notification__body', bodyClassName);
        var contentClass = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-notification__content', { 'h-notification__content--no-icon': hideIcon });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: bodyClass, onMouseEnter: this.pauseTimer, onMouseLeave: this.resumeTimer },
            !hideIcon && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-notification__icon", "aria-hidden": true }, iconMap[type]),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: contentClass, ref: this.contentRef }, children),
            this.renderCloseButton()));
    };
    Notification.prototype.renderCloseButton = function () {
        var _this = this;
        var _a = this.props, type = _a.type, closeMode = _a.closeMode;
        var closeIconColor = type === 'info' ? __WEBPACK_IMPORTED_MODULE_5__styles_colors__["a" /* BlackColor */] : __WEBPACK_IMPORTED_MODULE_5__styles_colors__["f" /* WhiteColor */];
        if (closeMode === 'manual') {
            var closeAriaLabel = this.props.closeAriaLabel;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-notification__close" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "", role: "button", "aria-label": closeAriaLabel, onClick: this.onClose },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__icons__["CloseIcon"], { className: "h-notification__close-icon", "aria-hidden": "true", width: 24, height: 24, color: closeIconColor }))));
        }
        else if (closeMode === 'auto') {
            var closeAriaLabel_1 = this.props.closeAriaLabel;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__timer_timer__["a" /* Timer */], { intervalMs: 100, maxIterations: 100, onTerminate: this.startClosing, ref: this.timerRef }, function (counter, stopTimer) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-notification__close" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "", role: "button", "aria-label": closeAriaLabel_1, 
                        // tslint:disable-next-line:no-any
                        onClick: _this.onCloseAndStopTimer.bind(_this, stopTimer) },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__icons_close_timer_icon__["a" /* CloseTimerIcon */], { className: "h-notification__close-icon", "aria-hidden": "true", width: 24, height: 24, color: closeIconColor, percent: counter }))));
            }));
        }
        return null;
    };
    Notification.prototype.computeAlignment = function () {
        if (this.contentRef.current) {
            var centerContent_1 = this.contentRef.current.offsetHeight <= 30;
            this.setState(function (prevState) {
                if (prevState.centerContent === centerContent_1) {
                    return null;
                }
                return { centerContent: centerContent_1 };
            });
        }
    };
    return Notification;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=notification.js.map

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchAlerts;
/* harmony export (immutable) */ __webpack_exports__["a"] = emailOptIn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ccl_utilities__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_initial_data_service__ = __webpack_require__(91);


function fetchAlerts(shipCode, sailDate) {
    var alertsInitialData = Object(__WEBPACK_IMPORTED_MODULE_1__common_initial_data_service__["a" /* getInitialData */])('alerts');
    if (alertsInitialData) {
        return Promise.resolve(alertsInitialData);
    }
    var url = "/booked/api/v1.0/Bookings/Alerts?ShipCode=" + encodeURIComponent(shipCode) + "&SailDate=" + encodeURIComponent(sailDate);
    return Object(__WEBPACK_IMPORTED_MODULE_0_ccl_utilities__["a" /* cclFetch */])(url);
}
function emailOptIn() {
    var opts = {
        method: 'POST',
        headers: new Headers({
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }),
    };
    return Object(__WEBPACK_IMPORTED_MODULE_0_ccl_utilities__["a" /* cclFetch */])('/booked/api/v1.0/Profiles/EmailSignup', opts)
        .catch(function (error) {
        if (error.code === 'RequestFailed' && error.innerError && error.innerError.data) {
            // eslint-disable-next-line no-throw-literal
            throw error.innerError.data;
        }
        throw error;
    });
}
//# sourceMappingURL=alert-manager-service.js.map

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CabinInteriorIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


// tslint:disable:max-line-length
var CabinInteriorIcon = function (_a) {
    var width = _a.width, height = _a.height, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: width || '25', height: height || '25' }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M24 21V4a4 4 0 0 0-4-4H4a4 4 0 0 0-4 4v19a1 1 0 0 0 1 1 1 1 0 0 0 1-1v-2h20v2a1 1 0 0 0 1 1 1 1 0 0 0 1-1v-2zM11 10v1H7a1 1 0 0 1 0-2h3a1 1 0 0 1 1 1zm9 3a2 2 0 0 1 2 2v4H2v-4.06A2 2 0 0 1 4 13zm-2-3a1 1 0 0 1-1 1h-4v-1a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1zm2-8a2 2 0 0 1 2 2v7.59a4 4 0 0 0-2-.59h-.17A3 3 0 0 0 17 7h-3a3 3 0 0 0-2 .8 3 3 0 0 0-2-.8H7a3 3 0 0 0-2.82 4H4a3.86 3.86 0 0 0-2 .56V4a2 2 0 0 1 2-2z" })));
};
// tslint:enable:max-line-length
//# sourceMappingURL=cabin-interior-icon.js.map

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CabinInteriorPortholeIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


// tslint:disable:max-line-length
var CabinInteriorPortholeIcon = function (_a) {
    var width = _a.width, height = _a.height, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: width || '25', height: height || '25' }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M8 18h8a1 1 0 1 0 0-2H8a1 1 0 1 0 0 2z" }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0zm0 2a10 10 0 0 1 10 10h-4a6 6 0 0 0-12 0H2A10 10 0 0 1 12 2zm4 10H8a4 4 0 0 1 8 0zm-4 10a10 10 0 0 1-9.8-8h19.6a10 10 0 0 1-9.8 8z" }))));
};
// tslint:enable:max-line-length
//# sourceMappingURL=cabin-interior-porthole-icon.js.map

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CabinOceanviewIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


// tslint:disable:max-line-length
var CabinOceanviewIcon = function (_a) {
    var width = _a.width, height = _a.height, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: width || '25', height: height || '25' }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M20 17H4a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2zM17 21H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2zM23 13h-3a7.92 7.92 0 0 0-8-8 7.93 7.93 0 0 0-8 8H1a1 1 0 0 0 0 2h22a1 1 0 0 0 0-2zM6 13a6 6 0 1 1 12 0zM12 3a1 1 0 0 0 1-1V1a1 1 0 0 0-2 0v1a1 1 0 0 0 1 1zM5.19 4.59A1 1 0 0 0 6 5a1 1 0 0 0 .81-1.59l-.59-.81A1 1 0 1 0 4.6 3.78z" }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M.72 10.13l1 .31a1.06 1.06 0 0 0 .31.05 1 1 0 0 0 .31-2l-.95-.31a1 1 0 0 0-1.26.64 1 1 0 0 0 .59 1.31zM22 10.62a1.18 1.18 0 0 0 .31 0l.95-.31a1 1 0 1 0-.62-1.9l-.95.31a1 1 0 0 0 .31 1.9zM18 5a1 1 0 0 0 .81-.42l.59-.81a1 1 0 0 0-1.62-1.17l-.59.81a1 1 0 0 0 .23 1.4A1 1 0 0 0 18 5z" }))));
};
// tslint:enable:max-line-length
//# sourceMappingURL=cabin-oceanview-icon.js.map

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CabinBalconyIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


// tslint:disable:max-line-length
var CabinBalconyIcon = function (_a) {
    var width = _a.width, height = _a.height, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: width || '25', height: height || '25' }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M-161.5-80a1.5 1.5 0 0 1-1.5-1.5 1.5 1.5 0 0 1 1.5-1.5 1.51 1.51 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5zM-151.88-67.28s-1.12-3-1.13-3.06a1 1 0 0 0-.93-.65H-160l-2.14-5.87a1 1 0 0 0-1.28-.6 1 1 0 0 0-.6 1.28l2.26 6.2-1 2.69a1 1 0 0 0 .58 1.24 1 1 0 0 0 1.24-.58L-160-69h5.39l.87 2.4a1 1 0 0 0 1.26.58 1 1 0 0 0 .6-1.26z", transform: "translate(168 84)" }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M-146-77a1 1 0 0 0-1 1v9a1 1 0 0 1-1 1h-18v-17a1 1 0 0 0-1-1 1 1 0 0 0-1 1v22a1 1 0 0 0 1 1 1 1 0 0 0 1-1v-3h18a3 3 0 0 0 3-3v-9a1 1 0 0 0-1-1z", transform: "translate(168 84)" }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M-155.42-72h-1.64a3 3 0 0 1-2.78-1.87l-1.51-3.75a1 1 0 0 1 .55-1.3 1 1 0 0 1 1.3.55l1.52 3.75a1 1 0 0 0 .92.62h1.64a1 1 0 0 0 .8-.4l3.42-4.22a1 1 0 0 1 .53-.34l4.42-1a1 1 0 0 1 1.22.72 1 1 0 0 1-.72 1.22l-4.1.91-3.15 3.94a3 3 0 0 1-2.42 1.17z", transform: "translate(168 84)" }))));
};
// tslint:enable:max-line-length
//# sourceMappingURL=cabin-balcony-icon.js.map

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CabinSuiteIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


// tslint:disable:max-line-length
var CabinSuiteIcon = function (_a) {
    var width = _a.width, height = _a.height, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: width || '25', height: height || '25' }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M24 20v-3a4 4 0 0 0-4-4h-.17a3.05 3.05 0 0 0 .17-1 3 3 0 0 0-3-3h-3a3 3 0 0 0-2 .79A3 3 0 0 0 10 9H7a3 3 0 0 0-3 3 3.05 3.05 0 0 0 .18 1H4a4 4 0 0 0-4 4v6a1 1 0 0 0 1 1 1 1 0 0 0 1-1v-2h20v2a1 1 0 0 0 1 1 1 1 0 0 0 1-1v-3zm-10-9h3a1 1 0 0 1 0 2h-4v-1a1 1 0 0 1 1-1zm-7 0h3a1 1 0 0 1 1 1v1H7a1 1 0 1 1 0-2zm-5 8v-2a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2zM9 7h6a1.5 1.5 0 0 0 1.06-.44 1.52 1.52 0 0 0 .44-1.06v-4a1.49 1.49 0 0 0-1-1.42A1.34 1.34 0 0 0 15 0a1.46 1.46 0 0 0-1.19.6l-.31.4-.31-.4A1.49 1.49 0 0 0 12 0a1.47 1.47 0 0 0-1.19.6l-.31.4-.3-.4A1.52 1.52 0 0 0 9 0a1.26 1.26 0 0 0-.47.08 1.48 1.48 0 0 0-1 1.42v4A1.5 1.5 0 0 0 9 7zm0-5.5l1.5 2 1.5-2 1.5 2 1.5-2v4H9z" })));
};
// tslint:enable:max-line-length
//# sourceMappingURL=cabin-suite-icon.js.map

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Offer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eyebrow_eyebrow__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__badge_badge__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__icon_icon__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__visually_hidden_visually_hidden__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__offer_css__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__offer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__offer_css__);








var Offer = function (_a) {
    var className = _a.className, eyebrow = _a.eyebrow, heading = _a.heading, badge = _a.badge, badgeIconUrl = _a.badgeIconUrl, description = _a.description, ctaText = _a.ctaText, ctaUrl = _a.ctaUrl, onCtaClick = _a.onCtaClick, eyebrowTagName = _a.eyebrowTagName;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__('h-offer', className) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__eyebrow_eyebrow__["a" /* Eyebrow */], { className: "h-offer__eyebrow", tagName: eyebrowTagName },
                eyebrow,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], null,
                    "\u00A0-\u00A0",
                    heading)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-offer__heading", "aria-hidden": "true" }, heading),
            badge && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__badge_badge__["a" /* Badge */], { mode: "block", className: "h-offer__badge" },
                    badgeIconUrl && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__icon_icon__["a" /* Icon */], { className: "h-offer__badge-icon", color: "white", src: badgeIconUrl, alt: "", width: "14px", height: "14px" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, badge))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-offer__description", dangerouslySetInnerHTML: { __html: description } })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__button_button__["b" /* LinkButton */], { href: ctaUrl, block: true, onClick: onCtaClick }, ctaText)));
};
//# sourceMappingURL=offer.js.map

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createControlGroup;
/* harmony export (immutable) */ __webpack_exports__["b"] = replaceControlModel;
/* harmony export (immutable) */ __webpack_exports__["c"] = values;
function createControlGroup() {
    var controls = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        controls[_i] = arguments[_i];
    }
    return {
        pristine: controls.every(function (n) { return n.state.pristine; }),
        dirty: controls.some(function (n) { return n.state.dirty; }),
        untouched: controls.every(function (n) { return n.state.untouched; }),
        touched: controls.some(function (n) { return n.state.touched; }),
        valid: controls.every(function (n) { return n.state.valid; }),
        invalid: controls.some(function (n) { return n.state.invalid; }),
        controls: createControlsDictionary(controls)
    };
}
function replaceControlModel(controlGroup) {
    var controls = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        controls[_i - 1] = arguments[_i];
    }
    var newControls = [];
    var _loop_1 = function (i) {
        var control = controlGroup.controls.all[i];
        var filteredControls = controls.filter(function (c) { return c.name === control.name; });
        if (filteredControls.length > 0) {
            newControls.push(filteredControls[0]);
        }
        else {
            newControls.push(control);
        }
    };
    for (var i = 0; i < controlGroup.controls.all.length; i++) {
        _loop_1(i);
    }
    return createControlGroup.apply(void 0, newControls);
}
function values(controlGroup) {
    // tslint:disable-next-line:no-any
    var map = {};
    for (var i = 0; i < controlGroup.controls.all.length; i++) {
        var control = controlGroup.controls.all[i];
        map[control.id] = typeof control.checked !== 'undefined' ? control.checked : control.value;
    }
    return map;
}
function createControlsDictionary(controls) {
    var dictionary = {
        all: controls,
        get: {}
    };
    for (var i = 0; i < controls.length; i++) {
        var control = controls[i];
        dictionary.get[control.name] = control;
    }
    return dictionary;
}
//# sourceMappingURL=control-group.js.map

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validators_validators__ = __webpack_require__(555);

function validate(value, validators) {
    var errors = [];
    for (var propName in validators) {
        if (validators.hasOwnProperty(propName)) {
            var options = validators[propName];
            var validatorName = getValidatorName(propName);
            // tslint:disable-next-line:no-any
            var isValid = __WEBPACK_IMPORTED_MODULE_0__validators_validators__["a" /* validators */][validatorName](value, options);
            if (!isValid) {
                errors.push(propName);
            }
        }
    }
    return errors;
}
function getValidatorName(propName) {
    var idx = propName.indexOf('custom');
    if (idx === 0) {
        return 'custom';
    }
    return propName;
}
//# sourceMappingURL=validator.js.map

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToDoStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__to_do_status_css__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__to_do_status_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__to_do_status_css__);




var ToDoStatus = function (_a) {
    var className = _a.className, children = _a.children, type = _a.type, counter = _a.counter, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["className", "children", "type", "counter"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-to-do-status', "h-to-do-status--" + type, { 'h-to-do-status--counter': counter !== undefined }, className) }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "h-to-do-status__counter" }, counter),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "h-to-do-status__text" }, children)));
};
//# sourceMappingURL=to-do-status.js.map

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TopNavFull; });
/* unused harmony export renderItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dropdown_dropdown__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_nav_helpers__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__top_nav_full_css__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__top_nav_full_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__top_nav_full_css__);





var TopNavFull = function (_a) {
    var className = _a.className, items = _a.items, data = _a.data, componentFactory = _a.componentFactory;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__('h-top-nav-full', className) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-top-nav-full__bar" }, items.filter(function (item) { return Object(__WEBPACK_IMPORTED_MODULE_3__main_nav_helpers__["a" /* filterItem */])(item, data); }).map(function (item) { return renderItem(item, componentFactory, data); }))));
};
function renderItem(item, componentFactory, data) {
    var title = item.fields.title && item.fields.title.value;
    var tags = item.fields.tags && item.fields.tags.value;
    if (item.templateName === 'MainNavLink') {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: "h-top-nav-full__item h-top-nav-full__link", key: item.id, href: Object(__WEBPACK_IMPORTED_MODULE_3__main_nav_helpers__["c" /* replaceUrlPlaceholders */])(item.fields.url.value, data), dangerouslySetInnerHTML: { __html: title } }));
    }
    else if (item.templateName === 'MainNavDropdown') {
        // tslint:disable:no-any
        var TitleComponent = componentFactory(tags);
        var ContentComponent = componentFactory(item.fields.contentSource.value.fields.tags.value);
        // tslint:enable:no-any
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__dropdown_dropdown__["a" /* Dropdown */], { "data-pii": "true", key: item.id, id: data.idPrefix + item.id, title: TitleComponent ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TitleComponent, { item: item, data: data }) : title, className: "h-top-nav-full__item h-top-nav-full__dropdown", display: "relative" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ContentComponent, { item: item.fields.contentSource.value })));
    }
    else if (item.templateName === 'MainNavSpacer') {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: item.id, className: "h-top-nav-full__item h-top-nav-full__spacer" }));
    }
    return null;
}
//# sourceMappingURL=top-nav-full.js.map

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainNavRectContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MainNavRectProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_event_listener__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_event_listener__);



var MainNavRectContext = __WEBPACK_IMPORTED_MODULE_1_react__["createContext"](null);
var MainNavRectProvider = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(MainNavRectProvider, _super);
    function MainNavRectProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.timeout = 0;
        _this.state = {
            rect: null
        };
        _this.onResize = function () {
            window.clearTimeout(_this.timeout);
            _this.timeout = window.setTimeout(_this.updateRect, 100);
        };
        _this.updateRect = function () {
            var el = _this.props.mainNavRef.current;
            if (el) {
                var rect_1 = el.getBoundingClientRect();
                _this.setState(function (prevState) {
                    if (!prevState.rect ||
                        prevState.rect.left !== rect_1.left ||
                        prevState.rect.width !== rect_1.width) {
                        return { rect: rect_1 };
                    }
                    return null;
                });
            }
        };
        return _this;
    }
    MainNavRectProvider.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](MainNavRectContext.Provider, { value: this.state.rect },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_event_listener___default.a, { target: "window", onResize: this.onResize }, this.props.children)));
    };
    MainNavRectProvider.prototype.componentDidMount = function () {
        if (this.props.mainNavRef.current) {
            this.updateRect();
        }
        else {
            this.forceUpdate();
        }
    };
    MainNavRectProvider.prototype.componentWillUnmount = function () {
        window.clearTimeout(this.timeout);
    };
    MainNavRectProvider.prototype.componentDidUpdate = function () {
        this.updateRect();
    };
    return MainNavRectProvider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=main-nav-rect.js.map

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MainNavButton */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainNavHamburgerButton; });
/* unused harmony export MainNavButtonBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_nav_item__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main_nav_button_css__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main_nav_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__main_nav_button_css__);





var MainNavButton = function (_a) {
    var className = _a.className, children = _a.children, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["className", "children"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-main-nav__button', className), type: "button" }, otherProps), children));
};
/* tslint:disable */
var HamburgerMenuIcon = function () { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: "20", height: "20", className: "h-booked-nav__hamburger" },
    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M4,10h24c1.104,0,2-0.896,2-2s-0.896-2-2-2H4C2.896,6,2,6.896,2,8S2.896,10,4,10z M28,14H4c-1.104,0-2,0.896-2,2  s0.896,2,2,2h24c1.104,0,2-0.896,2-2S29.104,14,28,14z M28,22H4c-1.104,0-2,0.896-2,2s0.896,2,2,2h24c1.104,0,2-0.896,2-2  S29.104,22,28,22z" }))); };
/* tslint:enable */
var MainNavHamburgerButton = function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](MainNavButton, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ className: "h-main-nav__button-hamburger" }, props),
    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](HamburgerMenuIcon, null))); };
var MainNavButtonBar = function (_a) {
    var children = _a.children, className = _a.className;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__main_nav_item__["a" /* MainNavItem */], { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-main-nav__button-bar', className) }, children));
};
//# sourceMappingURL=main-nav-button.js.map

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TopNavCompact; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main_nav_helpers__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_nav_main_nav__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main_nav_main_nav_button__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__top_nav_compact_css__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__top_nav_compact_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__top_nav_compact_css__);






function renderHelper(item, index, props) {
    var navItem = Object(__WEBPACK_IMPORTED_MODULE_2__main_nav_helpers__["b" /* renderItem */])(item, props.componentFactory, props.data);
    if (index === 0) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], { key: "nav" },
            navItem,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__main_nav_main_nav_button__["a" /* MainNavHamburgerButton */], { "aria-label": props.burgerMenuLabel, onClick: props.onBurgerMenuClicked })));
    }
    return navItem;
}
var TopNavCompact = function (props) {
    var className = props.className, items = props.items;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__('h-top-nav-compact', className) },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__main_nav_main_nav__["a" /* MainNav */], null, items.filter(function (item) { return Object(__WEBPACK_IMPORTED_MODULE_2__main_nav_helpers__["a" /* filterItem */])(item, props.data); })
                    .map(function (item, index) { return renderHelper(item, index, props); }))))));
};
//# sourceMappingURL=top-nav-compact.js.map

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

exports['default'] = function () {
  var Snap = undefined;
  try {
    Snap = __webpack_require__(612);
  } finally {
    return Snap;
  }
};

module.exports = exports['default'];

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ComponentFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__renderers_renderers__ = __webpack_require__(626);

var ComponentFactory = /** @class */ (function () {
    function ComponentFactory() {
        var _this = this;
        // tslint:disable-next-line:no-any
        this._map = {};
        // tslint:disable-next-line:no-any
        this.get = function (tags) {
            if (!tags) {
                return undefined;
            }
            var name = tags.split(',')
                .filter(function (t) { return t.indexOf('Component:') >= 0; })
                .map(function (t) { return t.substring('Component:'.length); })[0];
            return _this._map[name];
        };
        this.set('HtmlContent', __WEBPACK_IMPORTED_MODULE_0__renderers_renderers__["b" /* HtmlContent */]);
        this.set('ProfileDropdown', __WEBPACK_IMPORTED_MODULE_0__renderers_renderers__["c" /* ProfileDropdown */]);
        this.set('ProfileTitle', __WEBPACK_IMPORTED_MODULE_0__renderers_renderers__["d" /* ProfileTitle */]);
        this.set('FunBrowserDropdown', __WEBPACK_IMPORTED_MODULE_0__renderers_renderers__["a" /* FunBrowserDropdown */]);
        this.set('SailingsDropdown', __WEBPACK_IMPORTED_MODULE_0__renderers_renderers__["e" /* SailingsDropdown */]);
    }
    // tslint:disable-next-line:no-any
    ComponentFactory.prototype.set = function (name, component) {
        this._map[name] = component;
    };
    return ComponentFactory;
}());

//# sourceMappingURL=component-factory.js.map

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SailingTile; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getDescription;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eyebrow_eyebrow__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__timer_timer__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sailing_tile_css__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sailing_tile_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__sailing_tile_css__);





var pageLoadedTimestamp = Date.now();
var SailingTile = function (props) {
    var className = props.className, bookingNumbers = props.bookingNumbers, itineraryTitle = props.itineraryTitle, courtesyHoldExpiration = props.courtesyHoldExpiration, content = props.content;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__('h-sailing-tile', className) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__eyebrow_eyebrow__["a" /* Eyebrow */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { "data-pii": "true" }, renderBookings(content, bookingNumbers))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-sailing-tile__title" }, itineraryTitle),
        courtesyHoldExpiration &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__timer_timer__["a" /* Timer */], { intervalMs: 60000 }, function (counter, clearTimeout) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-sailing-tile__alert", dangerouslySetInnerHTML: renderCourtesyHold(false, clearTimeout, content, courtesyHoldExpiration) }); }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "h-sailing-tile__description", dangerouslySetInnerHTML: renderDescription(content.description, props) })));
};
function renderCourtesyHold(isAda, clearTimeout, content, courtesyHoldExpiration) {
    if (!courtesyHoldExpiration) {
        return undefined;
    }
    var diffMs = Date.now() - pageLoadedTimestamp;
    var diffMins = Math.floor(diffMs / 60000);
    var totalMinutesLeft = courtesyHoldExpiration.hours * 60 + courtesyHoldExpiration.minutes;
    totalMinutesLeft = totalMinutesLeft - diffMins;
    if (totalMinutesLeft < 0) {
        clearTimeout();
        totalMinutesLeft = 0;
    }
    var hours = Math.floor(totalMinutesLeft / 60);
    var minutes = totalMinutesLeft % 60;
    var format = null;
    if (isAda) {
        // format = hours <= 0 ? content.adaCourtesyHoldMinutesMessage : content.adaCourtesyHoldHoursMessage;
        format = content.adaCourtesyHoldHoursMessage;
    }
    else {
        // format = hours <= 0 ? content.courtesyHoldMinutesMessage : content.courtesyHoldHoursMessage;
        format = content.courtesyHoldHoursMessage;
    }
    return {
        __html: (format || '')
            .replace('{Hours}', hours.toString())
            .replace('{Minutes}', minutes.toString())
    };
}
function renderBookings(content, bookingNumbers) {
    var bookings = bookingNumbers.map(function (n) { return '#' + n; }).join(', ');
    if (bookingNumbers.length === 1) {
        return content.booking + " " + bookings;
    }
    return content.bookings + " " + bookings;
}
function renderDescription(dateFormat, props) {
    return {
        __html: (dateFormat || '')
            .replace('{SailDate}', props.sailDateMmmmDYyyy)
            .replace('{FromDayOfWeek}', props.fromDayOfWeek)
            .replace('{ToDayOfWeek}', props.toDayOfWeek)
            .replace('{EmbarkationPortName}', props.embarkationPortName)
            .replace('{ShipName}', props.shipName)
    };
}
// tslint:disable-next-line:no-empty
function noop() { }
function getDescription(props) {
    var content = props.content;
    var pieces = [];
    pieces.push(renderBookings(content, props.bookingNumbers));
    pieces.push(props.itineraryTitle);
    pieces.push(renderDescription(content.adaDescription, props).__html);
    pieces.push(renderCourtesyHold(true, noop, content, props.courtesyHoldExpiration));
    return pieces.join('. ');
}
//# sourceMappingURL=sailing-tile.js.map

/***/ }),
/* 226 */
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Countdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__countdown_css__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__countdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__countdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timer_timer__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__visually_hidden_visually_hidden__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);





var Countdown = function (_a) {
    var content = _a.content, totalMinutesLeft = _a.totalMinutesLeft, className = _a.className;
    if (totalMinutesLeft <= 0) {
        return null;
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__timer_timer__["a" /* Timer */], { intervalMs: 60000, maxIterations: totalMinutesLeft }, function (counter) { return renderCountDown(content, totalMinutesLeft, counter, className); }));
};
function renderCountDown(content, totalMinutesLeft, counter, className) {
    var minutesLeft = totalMinutesLeft - counter;
    var days = Math.floor(minutesLeft / 24 / 60);
    var hours = Math.floor((minutesLeft - (days * 24 * 60)) / 60);
    var minutes = minutesLeft - (days * 24 * 60) - (hours * 60);
    var timeLeft = days + " " + content.days + ", " + hours + " " + content.hours + ", " + minutes + " " + content.minutes;
    var adaCountdown = content.adaCountdownFormat
        ? content.adaCountdownFormat.replace('{timeLeft}', timeLeft)
        : timeLeft;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_4_classnames__('h-countdown', className) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "h-countdown__details", "aria-hidden": true },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "h-countdown__details-title" }, content.days),
            days),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "h-countdown__details", "aria-hidden": true },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "h-countdown__details-title" }, content.hours),
            hours),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "h-countdown__details", "aria-hidden": true },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "h-countdown__details-title" }, content.minutes),
            minutes),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], null, adaCountdown)));
}
//# sourceMappingURL=countdown.js.map

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShareItineraryButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tooltip_tooltip__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__social_social_share_buttons__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_focus_trap_react__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_focus_trap_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_focus_trap_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_event_listener__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__share_itinerary_button_css__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__share_itinerary_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__share_itinerary_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__click_away_listener_click_away_listener__ = __webpack_require__(111);









var ShareItineraryButton = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(ShareItineraryButton, _super);
    function ShareItineraryButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buttonRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.containerRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.state = {
            isOpen: false,
            enableSocialShare: false
        };
        _this.close = function (e) {
            if (e.target === _this.buttonRef.current || _this.buttonRef.current.contains(e.target)) {
                return;
            }
            _this.setState(function (prevState) { return prevState.isOpen ? { isOpen: false } : null; });
        };
        _this.toggle = function (e) {
            _this.setState(function (prevState) { return ({ isOpen: !prevState.isOpen }); });
        };
        _this.onKeyPress = function (e) {
            if (e.keyCode === 27) { // escape key
                if (_this.containerRef.current.contains(e.target)) {
                    _this.setState(function (state) {
                        if (state.isOpen) {
                            _this.buttonRef.current.focus();
                            return { isOpen: false };
                        }
                        return null;
                    });
                }
            }
        };
        return _this;
    }
    ShareItineraryButton.prototype.render = function () {
        var _a = this.state, isOpen = _a.isOpen, enableSocialShare = _a.enableSocialShare;
        var _b = this.props, socialNetworksContents = _b.socialNetworksContents, itineraryImageUrl = _b.itineraryImageUrl, className = _b.className, itineraryUrl = _b.itineraryUrl, shareButtonText = _b.shareButtonText, itineraryName = _b.itineraryName, shareButtonAriaLabel = _b.shareButtonAriaLabel, parentNameRef = _b.parentNameRef;
        if (!shareButtonText) {
            return null;
        }
        var enableSocialButton = enableSocialShare && socialNetworksContents.length > 0 && !!itineraryUrl;
        var id = 'share_' + (parentNameRef || 'component');
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_6_classnames__('h-share-itin'), ref: this.containerRef },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react_event_listener___default.a, { target: "document", onKeyUp: this.onKeyPress },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_focus_trap_react__, { active: isOpen, className: "h-share-itin__focus-trap", focusTrapOptions: { clickOutsideDeactivates: true } },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", { ref: this.buttonRef, disabled: !enableSocialButton, onClick: this.toggle, className: isOpen ? 'h-btn h-share-itin-button--active' : 'h-btn h-share-itin-button', "aria-controls": id, "aria-expanded": isOpen ? 'true' : 'false', "aria-label": shareButtonAriaLabel || '' }, shareButtonText),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__click_away_listener_click_away_listener__["a" /* ClickAwayListener */], { onClickAway: this.close },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__tooltip_tooltip__["a" /* Tooltip */], { id: id, placement: "bottom-left", "aria-expanded": isOpen ? 'true' : 'false', className: isOpen ? 'h-share-itin-tooltip--open' : 'h-share-itin-tooltip--closed' }, this.renderSocialButtons(itineraryName, itineraryUrl, socialNetworksContents, itineraryImageUrl, className)))))));
    };
    ShareItineraryButton.prototype.renderSocialButtons = function (itineraryName, itineraryUrl, socialNetworksContents, itineraryImageUrl, className) {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__social_social_share_buttons__["a" /* SocialShareButtons */], { description: itineraryName, socialNetworkContents: socialNetworksContents, imageUrl: itineraryImageUrl, itineraryUrl: itineraryUrl, className: className, onScriptLoaded: function () { return _this.setState({ enableSocialShare: true }); } }));
    };
    return ShareItineraryButton;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=share-itinerary-button.js.map

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SocialShareButtons; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ccl_utilities__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__social_share_buttons_css__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__social_share_buttons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__social_share_buttons_css__);





var SocialShareButtons = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(SocialShareButtons, _super);
    function SocialShareButtons() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.shareSocialServiceUrl = '//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5c8a9264306b0726';
        return _this;
    }
    SocialShareButtons.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, socialNetworkContents = _a.socialNetworkContents, itineraryUrl = _a.itineraryUrl;
        if (!socialNetworkContents || socialNetworkContents.length === 0 || !itineraryUrl) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-social-share', className) }, socialNetworkContents.length &&
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "addthis_toolbox addthis_default_style addthis_32x32_style" }, socialNetworkContents.map(function (c) { return _this.renderButton(c); }))));
    };
    SocialShareButtons.prototype.renderButton = function (content) {
        var _a = this.props, itineraryUrl = _a.itineraryUrl, imageUrl = _a.imageUrl, description = _a.description;
        if (!imageUrl && content.serviceCode.indexOf('pinterest') > -1) {
            return null;
        }
        var imageSource = content.serviceCode !== 'mailto' ? imageUrl : '';
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { key: content.title, "data-addthis-title": content.title, "data-addthis-url": itineraryUrl, "data-addthis-media": imageSource, "data-addthis-description": description, className: "addthis_button_" + content.serviceCode.toLowerCase(), role: "button", "aria-label": content.buttonAriaLabel }));
    };
    SocialShareButtons.prototype.componentDidMount = function () {
        if (!document.getElementById('social-addthis')) {
            Object(__WEBPACK_IMPORTED_MODULE_3_ccl_utilities__["b" /* loadJS */])(this.shareSocialServiceUrl, this.props.onScriptLoaded, { id: 'social-addthis' });
        }
    };
    return SocialShareButtons;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

//# sourceMappingURL=social-share-buttons.js.map

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  // Otherwise we need to check some styles
  var style = window.getComputedStyle(element);
  return zeroSize ? style.getPropertyValue("overflow") !== "visible" : style.getPropertyValue("display") == "none";
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;

var _warning = __webpack_require__(675);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(161);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = "length" in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  if (!appElement && !globalElement) {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return false;
  }

  return true;
}

function hide(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).setAttribute("aria-hidden", "true");
  }
}

function show(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).removeAttribute("aria-hidden");
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = null;
}

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccessBookingByDob; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms_index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__access_booking_dob_css__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__access_booking_dob_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__access_booking_dob_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modal_modal_shell__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__notification_notification__ = __webpack_require__(64);







var AccessBookingByDob = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(AccessBookingByDob, _super);
    function AccessBookingByDob() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.firstInputElement = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.handleFocus = function () {
            var id = _this.props.controlGroup.invalid
                ? _this.props.controlGroup.controls.all.filter(function (control) { return control.state.invalid; })[0].id
                : _this.firstInputElement.current.id;
            var elem = document.getElementById(id);
            if (elem) {
                elem.focus();
            }
        };
        _this.onRequestClose = function (event) {
            if (_this.props.onRequestClose) {
                _this.props.onRequestClose(event);
            }
        };
        _this.searchBooking = function () {
            _this.props.onSubmit().catch(function () {
                _this.handleFocus();
            });
        };
        return _this;
    }
    AccessBookingByDob.prototype.render = function () {
        var _a = this.props, controlGroup = _a.controlGroup, content = _a.content, monthNames = _a.monthNames, onControlChange = _a.onControlChange, errorMessage = _a.errorMessage;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__modal_modal_shell__["b" /* ModalShell */], { header: this.renderHeader(content), footer: this.renderFooter(content), notification: errorMessage && this.renderNotification(errorMessage, content), onRequestClose: this.onRequestClose, closeModalText: content.closeModalText }, this.renderBody(controlGroup, monthNames, content, onControlChange)));
    };
    AccessBookingByDob.prototype.renderHeader = function (content) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h2", { className: __WEBPACK_IMPORTED_MODULE_5__modal_modal_shell__["a" /* ModalHeadingClassName */] }, content.header),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null, content.subHeader)));
    };
    AccessBookingByDob.prototype.renderNotification = function (errorMessage, content) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { "aria-live": "assertive", role: "alert" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__notification_notification__["a" /* Notification */], { type: "error", mode: "edge", closeMode: "manual", closeAriaLabel: content.closeNotificationAriaLabel, onClose: this.props.onNotificatonClosed }, errorMessage)));
    };
    AccessBookingByDob.prototype.renderBody = function (controlGroup, monthNames, content, onControlChange) {
        var _this = this;
        var months = getMonths(monthNames);
        var days = getDays();
        var years = getYears();
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-access-booking-form-match-dob-booking container" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-12 col-lg-3" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms_index__["c" /* FormField */], { controlModel: controlGroup.controls.get.lastName, onFieldUpdate: onControlChange }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms_index__["d" /* Input */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ parentRef: _this.firstInputElement, maxLength: 15 }, props.controlProps)),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms_index__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.labelProps), content.lastNameText),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms_index__["b" /* Error */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.errorProps)))); }))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { role: "group", "aria-labelledby": "h-access-booking-dob-heading" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { id: "h-access-booking-dob-heading", className: "h-access-booking-dob__heading" }, content.dateOfBirthText)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-12 col-lg-5" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms_index__["c" /* FormField */], { controlModel: controlGroup.controls.get.dobMonth, onFieldUpdate: onControlChange }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms_index__["g" /* Select */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.controlProps),
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("option", { "aria-label": content.selectText + " " + content.monthText }),
                                months.map(function (month) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("option", { key: month.value, value: month.value }, month.label)); })),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms_index__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.labelProps), content.monthText),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms_index__["b" /* Error */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.errorProps)))); })),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-12 col-lg-2" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms_index__["c" /* FormField */], { controlModel: controlGroup.controls.get.dobDay, onFieldUpdate: onControlChange }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms_index__["g" /* Select */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.controlProps),
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("option", { "aria-label": content.selectText + " " + content.dayText }),
                                days.map(function (day) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("option", { key: day.value, value: day.value }, day.label)); })),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms_index__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.labelProps), content.dayText),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms_index__["b" /* Error */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.errorProps)))); })),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-12 col-lg-5" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms_index__["c" /* FormField */], { controlModel: controlGroup.controls.get.dobYear, onFieldUpdate: onControlChange }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms_index__["g" /* Select */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.controlProps),
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("option", { "aria-label": content.selectText + " " + content.yearText }),
                                years.map(function (year) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("option", { key: year.value, value: year.value }, year.label)); })),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms_index__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.labelProps), content.yearText),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms_index__["b" /* Error */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.errorProps)))); }))))));
    };
    AccessBookingByDob.prototype.renderFooter = function (content) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col h-access-booking-dob__footer" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__button_button__["a" /* Button */], { color: "red", type: "button", className: "h-btn h-btn--min-width", onClick: this.searchBooking, "aria-label": this.props.content.submitButtonAriaLabel, disabled: this.props.submitting, busy: this.props.submitting }, this.props.content.submitButtonText))));
    };
    AccessBookingByDob.prototype.componentDidMount = function () {
        var _this = this;
        setTimeout(function () {
            _this.handleFocus();
        }, 200);
    };
    return AccessBookingByDob;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

function getYears() {
    var currentYear = new Date().getFullYear();
    var years = [];
    for (var year = currentYear; year > currentYear - 111; year--) {
        years.push({
            value: year,
            label: "" + year,
        });
    }
    return years;
}
function getMonths(monthNames) {
    return monthNames.map(function (monthName, index) {
        var monthIndex = index + 1;
        return {
            value: monthIndex,
            label: monthName,
        };
    });
}
function getDays() {
    var days = [];
    for (var day = 1; day <= 31; day++) {
        days.push({
            value: day,
            label: "" + day,
        });
    }
    return days;
}
//# sourceMappingURL=access-booking-dob.js.map

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GuestDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_tabs__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__guest_details_css__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__guest_details_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__guest_details_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stateroom_tabs_stateroom_tabs__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modal_modal_shell__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__guest_tabs__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__notification_notifications_group__ = __webpack_require__(49);









var GuestDetails = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(GuestDetails, _super);
    function GuestDetails() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            modifiedGuest: null,
            validateModel: undefined,
            submitting: false,
            notifications: null,
        };
        _this.closeButtonRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.formContainerRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.onCloseNotificationGroup = function (type) {
            _this.setState(function (state) {
                return {
                    notifications: state.notifications
                        ? state.notifications.filter(function (notification) { return notification.type !== type; })
                        : null,
                };
            });
        };
        _this.onSelectBooking = function (bookingNumber) {
            _this.actionOrNoop(function () { return _this.props.onSelectBooking(bookingNumber); });
        };
        _this.onSelectGuest = function (guestSeqNumber) {
            _this.actionOrNoop(function () { return _this.props.onSelectGuest(guestSeqNumber); });
        };
        _this.cleanNotifications = function () {
            _this.setState({
                notifications: null,
            });
        };
        _this.onGuestChanged = function (guest, validateModel) {
            _this.setState({
                modifiedGuest: guest,
                validateModel: validateModel,
            });
        };
        _this.onSubmitGuest = function (e) {
            e.preventDefault();
            var _a = _this.state, submitting = _a.submitting, modifiedGuest = _a.modifiedGuest, validateModel = _a.validateModel;
            if (submitting || !modifiedGuest || !_this.props.sailing || !_this.props.sailing.bookings) {
                return;
            }
            var _b = _this.props, bookingNumber = _b.bookingNumber, guestSeqNumber = _b.guestSeqNumber;
            var booking = _this.props.sailing.bookings.find(function (b) { return b.bookingNumber === bookingNumber; });
            if (!booking) {
                return;
            }
            var guest = booking.guests.find(function (g) { return g.seqNumber === guestSeqNumber; });
            if (!guest) {
                return;
            }
            var newGuest = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, guest), modifiedGuest);
            var isModelValid = (typeof validateModel === 'function')
                ? validateModel() : true;
            if (isModelValid) {
                _this.setState({ submitting: true, notifications: null });
                _this.props.onSubmit(booking.bookingNumber, newGuest)
                    .then(_this.onSubmissionSuccess)
                    .catch(_this.onSubmissionError);
            }
        };
        _this.onSubmissionSuccess = function (response) {
            var advs = response.advisories || [];
            var notifications = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spreadArrays */])([{
                    type: 'success',
                    message: _this.props.content.successSubmittingForm
                }], advs.map(function (n) { return ({
                type: 'info',
                message: n.message
            }); }));
            _this.setState({
                submitting: false,
                notifications: notifications
            });
            setFocus(_this.closeButtonRef.current);
        };
        _this.onSubmissionError = function (apiError) {
            var notifications;
            if (apiError.details && apiError.details.length > 0) {
                notifications = apiError.details.map(function (n) { return ({
                    type: 'error',
                    message: _this.processApiError(n),
                }); });
            }
            else {
                notifications = [{ type: 'error', message: apiError.message || _this.props.content.errorSubmittingForm }];
            }
            _this.setState({ notifications: notifications, submitting: false });
            setFocus(_this.closeButtonRef.current);
        };
        _this.onRefreshPage = function (e) {
            e.preventDefault();
            window.location.reload();
        };
        return _this;
    }
    GuestDetails.prototype.render = function () {
        if (!this.props.sailing.bookings) {
            return null;
        }
        return this.props.mode === 'embedded'
            ? this.renderEmbedded()
            : this.renderModal();
    };
    GuestDetails.prototype.renderEmbedded = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
            this.renderHeader(),
            this.renderBody(),
            this.renderFooter()));
    };
    GuestDetails.prototype.renderModal = function () {
        var _a = this.props, content = _a.content, additionalGuests = _a.additionalGuests;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__modal_modal_shell__["b" /* ModalShell */], { header: this.renderHeader(), footer: this.renderFooter(), notification: this.renderNotification(), onRequestClose: this.props.onRequestClose, closeModalText: additionalGuests > 0 ? content.addGuestCloseButton : content.closeModal, closeButtonRef: this.closeButtonRef, shellClassName: "h-guest-details-modal" }, this.renderBody()));
    };
    GuestDetails.prototype.renderHeader = function () {
        var _a;
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h2", { className: __WEBPACK_IMPORTED_MODULE_6__modal_modal_shell__["a" /* ModalHeadingClassName */] }, ((_a = this.props) === null || _a === void 0 ? void 0 : _a.additionalGuests) > 0 ? this.props.content.addGuest : this.props.content.heading);
    };
    GuestDetails.prototype.renderBody = function () {
        return (this.renderTabs());
    };
    GuestDetails.prototype.renderFooter = function () {
        var _this = this;
        var booking = this.props.sailing.bookings.find(function (n) { return n.bookingNumber === _this.props.bookingNumber; });
        if (!booking || !booking.guests) {
            return null;
        }
        var _a = this.props, pricing = _a.pricing, content = _a.content, additionalGuests = _a.additionalGuests, onRequestClose = _a.onRequestClose;
        var guest = booking.guests.filter(function (n) { return n.seqNumber === _this.props.guestSeqNumber; })[0];
        var ariaLabel = (this.props.content.submitButtonAriaLabel || '')
            .replace('{FirstName}', guest.firstName)
            .replace('{LastName}', guest.lastName);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row h-guest-details__footer" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-guest-details__balance" }, additionalGuests > 0 && pricing &&
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { dangerouslySetInnerHTML: { __html: content.additionalCost.replace('{price}', pricing.additionalCostFormatted) } })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-guest-details-modal__buttons" },
                additionalGuests > 0 && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-guest-details-modal__button" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__button_button__["a" /* Button */], { color: "outline-black", type: "button", className: "h-btn--min-width", onClick: onRequestClose, "aria-label": content.cancelAriaLabel, disabled: this.state.submitting }, content.cancel)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-guest-details-modal__button" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__button_button__["a" /* Button */], { color: "red", type: "button", className: "h-btn--min-width", onClick: this.onSubmitGuest, "aria-label": ariaLabel, disabled: this.state.submitting, busy: this.state.submitting }, content.submitButton)))));
    };
    GuestDetails.prototype.renderNotification = function () {
        var content = this.props.content;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__notification_notifications_group__["a" /* NotificationsGroup */], { notifications: this.state.notifications, closeAriaLabel: content.closeNotificationAriaLabel, autoCloseAriaLabel: content.autoCloseNotificationAriaLabel, onCloseGroup: this.onCloseNotificationGroup }));
    };
    GuestDetails.prototype.renderTabs = function () {
        var _this = this;
        var _a = this.props, sailing = _a.sailing, content = _a.content, bookingNumber = _a.bookingNumber, guestSeqNumber = _a.guestSeqNumber, additionalGuests = _a.additionalGuests;
        var bookings = sailing.bookings;
        var isAddingGuest = additionalGuests > 0;
        var tabTitles = bookings.map(function (booking, index) {
            return {
                id: booking.bookingNumber,
                eyebrow: content.booking + " " + booking.bookingNumber,
                title: content.stateroom + " " + (index + 1),
                disabled: isAddingGuest && booking.bookingNumber !== _this.props.bookingNumber,
            };
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__stateroom_tabs_stateroom_tabs__["d" /* StateroomTabs */], { tabTitles: tabTitles, selectedId: bookingNumber, onSelect: this.onSelectBooking, enableTabScrolling: !isAddingGuest }, bookings.map(function (booking) {
                var _a;
                var disabledPanel = additionalGuests > 0 && booking.bookingNumber !== _this.props.bookingNumber;
                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_tabs__["c" /* TabPanel */], { key: booking.bookingNumber, className: disabledPanel ? __WEBPACK_IMPORTED_MODULE_5__stateroom_tabs_stateroom_tabs__["a" /* StateroomTabDisabledClassName */] : __WEBPACK_IMPORTED_MODULE_5__stateroom_tabs_stateroom_tabs__["b" /* StateroomTabPanelClassName */], selectedClassName: __WEBPACK_IMPORTED_MODULE_5__stateroom_tabs_stateroom_tabs__["c" /* StateroomTabPanelSelectedClassName */], disabled: disabledPanel }, booking.canEditGuests ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__guest_tabs__["a" /* GuestTabs */], { guests: booking.guests, countries: _this.props.countries, titles: _this.props.titles, monthNames: _this.props.monthNames, specialServices: _this.props.specialServices, content: content, selectedGuestSeqNumber: guestSeqNumber, onSelect: _this.onSelectGuest, onGuestChanged: _this.onGuestChanged, ref: _this.formContainerRef, modifiedGuest: (_a = _this.state) === null || _a === void 0 ? void 0 : _a.modifiedGuest, isAddingGuest: isAddingGuest })) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { dangerouslySetInnerHTML: { __html: content.unableToEditGuests } })));
            }))));
    };
    // tslint:disable-next-line:no-any
    GuestDetails.prototype.actionOrNoop = function (action) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var additionalGuests = this.props.additionalGuests;
        // avoid re-rendering
        if (additionalGuests > 0) {
            return;
        }
        this.cleanNotifications();
        action(args);
    };
    GuestDetails.prototype.processApiError = function (error) {
        if (error.code === 'Advisory5170') {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null,
                error.message,
                " ",
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { style: { color: 'inherit' }, href: "", onClick: this.onRefreshPage }, this.props.content.refreshPage)));
        }
        return error.message;
    };
    return GuestDetails;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

function setFocus(element) {
    if (element) {
        element.focus();
    }
}
//# sourceMappingURL=guest-details.js.map

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export childrenPropType */
/* unused harmony export onSelectPropType */
/* unused harmony export selectedIndexPropType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elementTypes__ = __webpack_require__(117);


function childrenPropType(props, propName, componentName) {
  var error;
  var tabsCount = 0;
  var panelsCount = 0;
  var tabListFound = false;
  var listTabs = [];
  var children = props[propName];
  Object(__WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__["a" /* deepForEach */])(children, function (child) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["b" /* isTabList */])(child)) {
      if (child.props && child.props.children && typeof child.props.children === 'object') {
        Object(__WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__["a" /* deepForEach */])(child.props.children, function (listChild) {
          return listTabs.push(listChild);
        });
      }

      if (tabListFound) {
        error = new Error("Found multiple 'TabList' components inside 'Tabs'. Only one is allowed.");
      }

      tabListFound = true;
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["a" /* isTab */])(child)) {
      if (!tabListFound || listTabs.indexOf(child) === -1) {
        error = new Error("Found a 'Tab' component outside of the 'TabList' component. 'Tab' components " + "have to be inside the 'TabList' component.");
      }

      tabsCount++;
    } else if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["c" /* isTabPanel */])(child)) {
      panelsCount++;
    }
  });

  if (!error && tabsCount !== panelsCount) {
    error = new Error("There should be an equal number of 'Tab' and 'TabPanel' in `" + componentName + "`. " + ("Received " + tabsCount + " 'Tab' and " + panelsCount + " 'TabPanel'."));
  }

  return error;
}
function onSelectPropType(props, propName, componentName, location, propFullName) {
  var prop = props[propName];
  var name = propFullName || propName;
  var error = null;

  if (prop && typeof prop !== 'function') {
    error = new Error("Invalid " + location + " `" + name + "` of type `" + typeof prop + "` supplied " + ("to `" + componentName + "`, expected `function`."));
  } else if (props.selectedIndex != null && prop == null) {
    error = new Error("The " + location + " `" + name + "` is marked as required in `" + componentName + "`, but " + "its value is `undefined` or `null`.\n" + "`onSelect` is required when `selectedIndex` is also set. Not doing so will " + "make the tabs not do anything, as `selectedIndex` indicates that you want to " + "handle the selected tab yourself.\n" + "If you only want to set the inital tab replace `selectedIndex` with `defaultIndex`.");
  }

  return error;
}
function selectedIndexPropType(props, propName, componentName, location, propFullName) {
  var prop = props[propName];
  var name = propFullName || propName;
  var error = null;

  if (prop != null && typeof prop !== 'number') {
    error = new Error("Invalid " + location + " `" + name + "` of type `" + typeof prop + "` supplied to " + ("`" + componentName + "`, expected `number`."));
  } else if (props.defaultIndex != null && prop != null) {
    return new Error("The " + location + " `" + name + "` cannot be used together with `defaultIndex` " + ("in `" + componentName + "`.\n") + ("Either remove `" + name + "` to let `" + componentName + "` handle the selected ") + "tab internally or remove `defaultIndex` to handle it yourself.");
  }

  return error;
}

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = uuid;
/* unused harmony export reset */
// Get a universally unique identifier
var count = 0;
function uuid() {
  return "react-tabs-" + count++;
}
function reset() {
  count = 0;
}

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getTabsCount;
/* harmony export (immutable) */ __webpack_exports__["a"] = getPanelsCount;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elementTypes__ = __webpack_require__(117);


function getTabsCount(children) {
  var tabCount = 0;
  Object(__WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__["a" /* deepForEach */])(children, function (child) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["a" /* isTab */])(child)) tabCount++;
  });
  return tabCount;
}
function getPanelsCount(children) {
  var panelCount = 0;
  Object(__WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__["a" /* deepForEach */])(children, function (child) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["c" /* isTabPanel */])(child)) panelCount++;
  });
  return panelCount;
}

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollableTabList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tabs__ = __webpack_require__(44);




var ScrollableTabList = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(ScrollableTabList, _super);
    function ScrollableTabList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tabListRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.scrollbarRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.state = {
            tabListWidth: 'auto',
            selectedIndex: -1,
            direction: 'right'
        };
        _this.onPrev = function () {
            if (!_this.tabListRef.current) {
                return;
            }
            var tabListEl = __WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"](_this.tabListRef.current);
            var current = tabListEl.querySelector(_this.props.selectedTabSelector);
            var i = 0, node = current;
            // tslint:disable-next-line:curly
            for (i = 0; (node = node.previousSibling); i++)
                ;
            if (i === 0) {
                return;
            }
            _this.props.onSelect(i - 1);
        };
        _this.onNext = function () {
            if (!_this.tabListRef.current) {
                return;
            }
            var tabListEl = __WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"](_this.tabListRef.current);
            var current = tabListEl.querySelector(_this.props.selectedTabSelector);
            var i = 0, node = current;
            // tslint:disable-next-line:curly
            for (; (node = node.previousSibling); i++)
                ;
            if (i === tabListEl.childNodes.length - 1) {
                return;
            }
            _this.props.onSelect(i + 1);
        };
        return _this;
    }
    ScrollableTabList.prototype.render = function () {
        // tslint:disable-next-line:no-any
        var overflowValue = ScrollableTabList.overflowValue;
        var _a = this.props, renderPrevArrow = _a.renderPrevArrow, renderNextArrow = _a.renderNextArrow, className = _a.className, children = _a.children;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            renderPrevArrow && renderPrevArrow({ onClick: this.onPrev }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { tabIndex: -1, ref: this.scrollbarRef, style: { overflowX: overflowValue, outline: 'none' } },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_tabs__["b" /* TabList */], { className: className, 
                    // tslint:disable-next-line:no-any
                    ref: this.tabListRef, style: { width: this.state.tabListWidth } }, children)),
            renderNextArrow && renderNextArrow({ onClick: this.onNext })));
    };
    ScrollableTabList.getDerivedStateFromProps = function (props, state) {
        if (state.selectedIndex === -1) {
            return { selectedIndex: props.selectedIndex };
        }
        else if (state.selectedIndex > props.selectedIndex) {
            // moving left
            return { direction: 'left', selectedIndex: props.selectedIndex };
        }
        else if (state.selectedIndex < props.selectedIndex) {
            // moving right
            return { direction: 'right', selectedIndex: props.selectedIndex };
        }
        return null;
    };
    ScrollableTabList.prototype.calculateTabListWidth = function () {
        if (!this.tabListRef || !this.tabListRef.current) {
            return;
        }
        var el = __WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"](this.tabListRef.current);
        while (el.clientHeight > el.firstChild.offsetHeight) {
            el.style.width = el.offsetWidth + 2 + 'px';
        }
        this.setState({
            tabListWidth: el.style.width
        });
    };
    ScrollableTabList.prototype.componentDidMount = function () {
        this.calculateTabListWidth();
        window.addEventListener('resize', this.calculateTabListWidth, false);
    };
    ScrollableTabList.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.calculateTabListWidth, false);
    };
    ScrollableTabList.prototype.componentDidUpdate = function () {
        this.scrollToActive();
    };
    ScrollableTabList.prototype.scrollToActive = function () {
        if (!this.tabListRef.current) {
            return;
        }
        var tabListEl = __WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"](this.tabListRef.current);
        var current = tabListEl.querySelector(this.props.selectedTabSelector);
        var scrollbarEl = this.scrollbarRef.current;
        var leftScroll = current.getBoundingClientRect().left - scrollbarEl.getBoundingClientRect().left;
        var halfWidth = scrollbarEl.offsetWidth / 2.0;
        var needsScrollAdjustment = (this.state.direction === 'right' && leftScroll > halfWidth) ||
            (this.state.direction === 'left' && leftScroll < halfWidth);
        if (needsScrollAdjustment) {
            var newScrollLeft = scrollbarEl.scrollLeft + (leftScroll - halfWidth);
            scrollbarEl.scrollLeft = newScrollLeft;
        }
    };
    ScrollableTabList.getScrollbarWidth = function () {
        var scrollbarWidth;
        if (typeof document !== 'undefined') {
            var div = document.createElement('div');
            div.style.width = '100px';
            div.style.height = '100px';
            div.style.position = 'absolute';
            div.style.top = '-9999px';
            div.style.overflow = 'scroll';
            // tslint:disable-next-line:no-any
            div.style.msOverflowStyle = 'scrollbar';
            document.body.appendChild(div);
            scrollbarWidth = div.offsetWidth - div.clientWidth;
            document.body.removeChild(div);
        }
        else {
            scrollbarWidth = 0;
        }
        return scrollbarWidth || 0;
    };
    return ScrollableTabList;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

ScrollableTabList.tabsRole = 'TabList';
ScrollableTabList.overflowValue = ScrollableTabList.getScrollbarWidth() > 0 ? 'hidden' : 'scroll';
//# sourceMappingURL=scrollable-tab-list.js.map

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BeddingDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tabs__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bedding_details_css__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bedding_details_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__bedding_details_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modal_modal_shell__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__stateroom_tabs_stateroom_tabs__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__bedding_form_container__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__notification_notifications_group__ = __webpack_require__(49);










var BeddingDetails = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(BeddingDetails, _super);
    function BeddingDetails() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.closeButtonRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.formContainerRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.state = {
            submitting: false,
            selectedBookingNumber: _this.props.bookingNumber,
            notifications: null,
            selectedBeddingCode: BeddingDetails.findSelectedBeddingCode(_this.props.sailing, _this.props.bookingNumber)
        };
        _this.onSubmit = function (e) {
            e.preventDefault();
            _this.setState({ submitting: true, notifications: null });
            _this.props.onSubmit(_this.props.bookingNumber, _this.state.selectedBeddingCode)
                .then(_this.onSubmissionSuccess)
                .catch(_this.onSubmissionError);
        };
        _this.onChange = function (newBeddingCode) {
            _this.setState({ selectedBeddingCode: newBeddingCode });
        };
        _this.onSubmissionSuccess = function (response) {
            var advs = response.advisories || [];
            var notifications = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spreadArrays */])([{
                    type: 'success',
                    message: _this.props.content.confirmationMessage
                }], advs.map(function (n) { return ({
                type: 'info',
                message: n.message
            }); }));
            _this.setState({
                submitting: false,
                notifications: notifications
            });
            if (_this.closeButtonRef.current) {
                _this.closeButtonRef.current.focus();
            }
        };
        _this.onSubmissionError = function (apiError) {
            var notifications;
            if (apiError.details && apiError.details.length > 0) {
                notifications = apiError.details.map(function (n) { return ({
                    type: 'error',
                    message: _this.processApiError(n),
                }); });
            }
            else {
                notifications = [{ type: 'error', message: apiError.message || _this.props.content.genericErrorMessage }];
            }
            _this.setState({ notifications: notifications, submitting: false });
            if (_this.formContainerRef.current) {
                var el = __WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"](_this.formContainerRef.current);
                var firstInput = el.querySelector('input');
                firstInput.focus();
            }
        };
        _this.onRefreshPage = function (e) {
            e.preventDefault();
            window.location.reload();
        };
        _this.onCloseNotificationGroup = function (type) {
            _this.setState(function (state) {
                return {
                    notifications: state.notifications
                        ? state.notifications.filter(function (notification) { return notification.type !== type; })
                        : null,
                };
            });
        };
        return _this;
    }
    BeddingDetails.getDerivedStateFromProps = function (props, state) {
        if (props.bookingNumber !== state.selectedBookingNumber) {
            return {
                notifications: null,
                selectedBookingNumber: props.bookingNumber,
                selectedBeddingCode: BeddingDetails.findSelectedBeddingCode(props.sailing, props.bookingNumber)
            };
        }
        return null;
    };
    BeddingDetails.findSelectedBeddingCode = function (sailing, bookingNumber) {
        return sailing.bookings.filter(function (n) { return n.bookingNumber === bookingNumber; })[0]
            .beddingOptions.filter(function (n) { return n.selected; })[0].code;
    };
    BeddingDetails.prototype.processApiError = function (error) {
        if (error.code === 'Advisory5170') {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null,
                error.message,
                " ",
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { style: { color: 'inherit' }, href: "", onClick: this.onRefreshPage }, this.props.content.refreshPage)));
        }
        return error.message;
    };
    BeddingDetails.prototype.render = function () {
        return this.props.mode === 'embedded'
            ? this.renderEmbedded()
            : this.renderModal();
    };
    BeddingDetails.prototype.renderModal = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__modal_modal_shell__["b" /* ModalShell */], { header: this.renderHeader(), footer: this.renderFooter(), notification: this.renderNotification(), onRequestClose: this.props.onRequestClose, closeModalText: this.props.content.closeModal, closeButtonRef: this.closeButtonRef, shellClassName: "h-bedding-details-modal" }, this.renderBody()));
    };
    BeddingDetails.prototype.renderEmbedded = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
            this.renderHeader(),
            this.renderBody(),
            this.renderFooter()));
    };
    BeddingDetails.prototype.renderHeader = function () {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h2", { className: __WEBPACK_IMPORTED_MODULE_5__modal_modal_shell__["a" /* ModalHeadingClassName */] }, this.props.content.heading);
    };
    BeddingDetails.prototype.renderNotification = function () {
        var content = this.props.content;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__notification_notifications_group__["a" /* NotificationsGroup */], { notifications: this.state.notifications, closeAriaLabel: content.closeNotificationAriaLabel, autoCloseAriaLabel: content.autoCloseNotificationAriaLabel, onCloseGroup: this.onCloseNotificationGroup }));
    };
    BeddingDetails.prototype.renderBody = function () {
        return this.renderTabs();
    };
    BeddingDetails.prototype.renderTabs = function () {
        var _this = this;
        var _a = this.props, sailing = _a.sailing, content = _a.content, bookingNumber = _a.bookingNumber, onSelectBooking = _a.onSelectBooking;
        var bookings = sailing.bookings;
        var tabTitles = bookings.map(function (booking, index) {
            return {
                id: booking.bookingNumber,
                eyebrow: content.booking + " " + booking.bookingNumber,
                title: content.stateroom + " " + (index + 1),
            };
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__stateroom_tabs_stateroom_tabs__["d" /* StateroomTabs */], { tabTitles: tabTitles, selectedId: bookingNumber, onSelect: onSelectBooking }, bookings.map(function (booking) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_tabs__["c" /* TabPanel */], { key: booking.bookingNumber, className: __WEBPACK_IMPORTED_MODULE_7__stateroom_tabs_stateroom_tabs__["b" /* StateroomTabPanelClassName */], selectedClassName: __WEBPACK_IMPORTED_MODULE_7__stateroom_tabs_stateroom_tabs__["c" /* StateroomTabPanelSelectedClassName */] }, booking.canEditBedding ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__bedding_form_container__["a" /* BeddingFormContainer */], { booking: booking, content: content, onChange: _this.onChange, ref: _this.formContainerRef })) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { tabIndex: 0, className: "h-bedding-details__outline-none", dangerouslySetInnerHTML: { __html: content.unableToEditBedding } })))); })));
    };
    BeddingDetails.prototype.renderFooter = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__button_button__["a" /* Button */], { color: "red", type: "button", className: "h-btn--min-width", onClick: this.onSubmit, "aria-label": (this.props.content.submitButtonAriaLabel || '').replace('{BookingNumber}', this.state.selectedBookingNumber), disabled: this.state.submitting, busy: this.state.submitting }, this.props.content.submitButton));
    };
    return BeddingDetails;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=bedding-details.js.map

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OrdersHeading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__orders_heading_css__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__orders_heading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__orders_heading_css__);


var OrdersHeading = function (_a) {
    var children = _a.children;
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h-orders__history-heading" }, children);
};
//# sourceMappingURL=orders-heading.js.map

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditOrder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__edit_order_css__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__edit_order_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__edit_order_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eyebrow_eyebrow__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modal_modal_shell__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__notification_notifications_group__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__icons_printer_icon__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cancel_order_modal__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__order_items__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__visually_hidden_visually_hidden__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers__ = __webpack_require__(66);













var EditOrder = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(EditOrder, _super);
    function EditOrder(props) {
        var _this = _super.call(this, props) || this;
        _this.closeButtonRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.onCloseNotificationGroup = function (type) {
            _this.setState(function (state) {
                return {
                    notifications: state.notifications
                        ? state.notifications.filter(function (notification) { return notification.type !== type; })
                        : null,
                };
            });
        };
        _this.onSelection = function (selectedItems) {
            _this.setState({ selectedItems: selectedItems });
        };
        _this.openDialog = function (event) {
            event.preventDefault();
            _this.setState({ isCancelDialogOpen: true });
        };
        _this.closeDialog = function () {
            _this.setState({ isCancelDialogOpen: false });
        };
        _this.cancelOrder = function () {
            var order = _this.props.order;
            if (!order) {
                return Promise.resolve();
            }
            _this.setState({ notifications: null });
            if (_this.props.order.orderType === 'FS') {
                return _this.props.onCancelOrder(order.orderNumber).then(function () { return Promise.resolve(); });
            }
            else {
                return _this.props.onModifyOrder(order.orderNumber).then(function () { return Promise.resolve(); });
            }
        };
        _this.onForegroundCancelOrder = function () {
            var order = _this.props.order;
            if (!order) {
                return;
            }
            var selectedItems = _this.state.selectedItems;
            _this.setState({ submitting: true, notifications: null });
            _this.props.onModifyOrder(order.orderNumber, selectedItems)
                .then(_this.onSubmissionSuccess)
                .catch(_this.onSubmissionError);
        };
        _this.onCloseWithSuccess = function () {
            _this.setState({ isCancelDialogOpen: false }, function () {
                _this.props.onRequestClose();
            });
        };
        _this.onSubmissionSuccess = function (response) {
            var advs = response.advisories || [];
            var notifications = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spreadArrays */])([{
                    type: 'success',
                    message: _this.props.content.successSubmittingOrder,
                }], advs.map(function (n) { return ({
                type: 'info',
                message: n.message
            }); }));
            _this.setState({
                submitting: false,
                notifications: notifications
            });
            setFocus(_this.closeButtonRef.current);
        };
        _this.onSubmissionError = function (apiError) {
            var notifications;
            if (apiError.details && apiError.details.length > 0) {
                notifications = apiError.details.map(function (n) { return ({
                    type: 'error',
                    message: n.message
                }); });
            }
            else {
                notifications = [{ type: 'error', message: apiError.message || _this.props.content.errorSubmittingOrder }];
            }
            _this.setState({ notifications: notifications, submitting: false });
            setFocus(_this.closeButtonRef.current);
        };
        _this.print = function (event) {
            event.preventDefault();
            window.print();
        };
        _this.state = {
            isCancelDialogOpen: false,
            notifications: null,
            selectedItems: [],
            submitting: false,
        };
        return _this;
    }
    EditOrder.prototype.render = function () {
        if (!this.props.order.allowEdit) {
            return null;
        }
        return this.props.mode === 'embedded'
            ? this.renderEmbedded()
            : this.renderModal();
    };
    EditOrder.prototype.renderEmbedded = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
            this.renderHeader(),
            this.renderBody(),
            this.renderFooter()));
    };
    EditOrder.prototype.renderModal = function () {
        var _a = this.props, content = _a.content, order = _a.order, onRequestClose = _a.onRequestClose;
        var closeModal = (content.closeModal || '').replace('{OrderNumber}', order.orderNumber);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__modal_modal_shell__["b" /* ModalShell */], { header: this.renderHeader(), footer: this.renderFooter(), notification: this.renderNotification(), onRequestClose: onRequestClose, closeModalText: closeModal, closeButtonRef: this.closeButtonRef }, this.renderBody()));
    };
    EditOrder.prototype.renderHeader = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h2", { "data-pii": "true", className: __WEBPACK_IMPORTED_MODULE_2_classnames__(__WEBPACK_IMPORTED_MODULE_5__modal_modal_shell__["a" /* ModalHeadingClassName */], 'd-print-none') }, this.props.content.heading),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h1", { "data-pii": "true", className: __WEBPACK_IMPORTED_MODULE_2_classnames__(__WEBPACK_IMPORTED_MODULE_5__modal_modal_shell__["a" /* ModalHeadingClassName */], 'd-none d-print-block') }, this.props.content.printHeading)));
    };
    EditOrder.prototype.renderFooter = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            this.renderFooterDesktop(),
            this.renderFooterMobile()));
    };
    EditOrder.prototype.renderFooterDesktop = function () {
        var submitting = this.state.submitting;
        var content = this.props.content;
        var isConfirmButtonDisabled = this.isConfirmButtonDisabled();
        var action = this.isPerItemEditionAllowed()
            ? this.onForegroundCancelOrder
            : this.openDialog;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-edit-order--desktop" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-edit-order__footer-container" },
                this.isBundle() && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-edit-order__footer-item" }, content.bundleMessage),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__button_button__["a" /* Button */], { className: "d-print-none h-edit-order__btn-submit", color: "red", type: "button", busy: submitting, disabled: isConfirmButtonDisabled, onClick: action }, this.isPerItemEditionAllowed() ? content.confirmChanges : content.cancelOrder))));
    };
    EditOrder.prototype.renderFooterMobile = function () {
        var submitting = this.state.submitting;
        var content = this.props.content;
        var isConfirmButtonDisabled = this.isConfirmButtonDisabled();
        var action = this.isPerItemEditionAllowed()
            ? this.onForegroundCancelOrder
            : this.openDialog;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-edit-order--mobile" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-edit-order__footer-container" },
                this.isBundle() && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-edit-order__footer-item" }, content.bundleMessage),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__button_button__["a" /* Button */], { className: "d-print-none h-edit-order__btn-submit", color: "red", type: "button", busy: submitting, disabled: isConfirmButtonDisabled, onClick: action }, this.isPerItemEditionAllowed() ? content.cancelSelected : content.cancelOrder))));
    };
    EditOrder.prototype.renderNotification = function () {
        var content = this.props.content;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__notification_notifications_group__["a" /* NotificationsGroup */], { notifications: this.state.notifications, closeAriaLabel: content.closeNotificationAriaLabel, autoCloseAriaLabel: content.autoCloseNotificationAriaLabel, onCloseGroup: this.onCloseNotificationGroup }));
    };
    EditOrder.prototype.renderBody = function () {
        var _a = this.props, content = _a.content, order = _a.order;
        var isCancelDialogOpen = this.state.isCancelDialogOpen;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-edit-order') },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-edit-order__header" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row align-items-center" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-9 h-edit-order__details" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h3", { className: "h-edit-order__order-number d-print-none" }, "" + content.bookingNumber + order.bookingNumber),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h2", { className: "h-edit-order__order-number d-none d-print-block" }, "" + content.bookingNumber + order.bookingNumber)),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-3 d-print-none h-edit-order__print" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { className: "h-edit-order__print-link", href: "", onClick: this.print },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__icons_printer_icon__["a" /* PrinterIcon */], { height: 18, width: 18, "aria-hidden": "true", className: "h-edit-order__print-icon" }),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "h-edit-order__print-link-text", "aria-hidden": "true" }, content.print),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], null, content.print))))),
            !this.isEmptyOrder() && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-edit-order__list" },
                this.renderDetailsDesktop(),
                this.renderDetailsMobile())),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__cancel_order_modal__["a" /* CancelOrderModal */], { isOpen: isCancelDialogOpen, doCancel: this.cancelOrder, onAbort: this.closeDialog, onCloseWithSuccess: this.onCloseWithSuccess, onCloseWithError: this.onSubmissionError, content: content })));
    };
    EditOrder.prototype.renderDetailsDesktop = function () {
        var _a = this.props, content = _a.content, order = _a.order;
        var quantityRequired = Object(__WEBPACK_IMPORTED_MODULE_12__helpers__["i" /* showQuantity */])(order.orderType);
        var promoCode = order.discountCode;
        var colspan = this.getTotalsColspan(quantityRequired, promoCode);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("table", { role: "table", className: "h-edit-order__list-table h-edit-order__list-table--desktop", cellPadding: "0", cellSpacing: "0" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("thead", { role: "rowgroup" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tr", { role: "row" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("th", { role: "columnheader" }, this.isPerItemEditionAllowed() ? content.removeItem : content.item),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("th", { role: "columnheader" }, content.date),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("th", { role: "columnheader" }, content.guest),
                    quantityRequired && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("th", { role: "columnheader" }, content.quantity),
                    promoCode && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("th", { role: "columnheader" }, content.promoCode),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("th", { role: "columnheader", className: "h-edit-order__list-table__small-item" }, content.total))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tbody", { role: "rowgroup" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__order_items__["a" /* OrderItemsContainer */], { mode: "desktop", items: order.orderDetails, isPerItemEditionAllowed: this.isPerItemEditionAllowed(), onSelection: this.onSelection, quantityText: quantityRequired ? content.quantity : null, promoCode: promoCode })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tfoot", { role: "rowgroup" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tr", { role: "row" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell", colSpan: colspan }, content.total),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell" }, order.totalAmountFormatted)))));
    };
    EditOrder.prototype.getTotalsColspan = function (quantityRequired, promoCode) {
        var colspans = 3;
        if (quantityRequired) {
            colspans++;
        }
        if (promoCode) {
            colspans++;
        }
        return colspans;
    };
    EditOrder.prototype.renderDetailsMobile = function () {
        var _a = this.props, content = _a.content, order = _a.order;
        var quatityRequired = Object(__WEBPACK_IMPORTED_MODULE_12__helpers__["i" /* showQuantity */])(order.orderType);
        var promoCode = order.discountCode;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("table", { role: "table", className: "h-edit-order__list-table h-edit-order__list-table--mobile" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tbody", { role: "rowgroup" },
                order.orderDetails.length > 0 && this.isPerItemEditionAllowed() && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tr", { role: "row", className: "d-print-none" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("th", { role: "columnheader" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__eyebrow_eyebrow__["a" /* Eyebrow */], null, content.selectToRemove)),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("th", { role: "columnheader" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], null, content.total)))),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__order_items__["a" /* OrderItemsContainer */], { mode: "mobile", items: order.orderDetails, isPerItemEditionAllowed: this.isPerItemEditionAllowed(), onSelection: this.onSelection, quantityText: quatityRequired ? content.quantity : null, promoCode: promoCode })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tfoot", { role: "rowgroup" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tr", { role: "row" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell" }, content.total),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell" }, order.totalAmountFormatted)))));
    };
    EditOrder.prototype.isPerItemEditionAllowed = function () {
        return this.props.order.orderType !== 'FS' && !this.props.order.discountCode;
    };
    EditOrder.prototype.isBundle = function () {
        return !!this.props.order.discountCode;
    };
    EditOrder.prototype.isEmptyOrder = function () {
        var order = this.props.order;
        return (!order.orderDetails || order.orderDetails.length === 0);
    };
    EditOrder.prototype.isConfirmButtonDisabled = function () {
        var _a = this.state, selectedItems = _a.selectedItems, submitting = _a.submitting;
        var order = this.props.order;
        return (!order.orderDetails || order.orderDetails.length === 0) ||
            (this.isPerItemEditionAllowed() && (submitting || !selectedItems || selectedItems.length === 0));
    };
    return EditOrder;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

function setFocus(element) {
    if (element) {
        element.focus();
    }
}
//# sourceMappingURL=edit-order.js.map

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DiningDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tabs__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dining_details_css__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dining_details_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__dining_details_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modal_modal_shell__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__stateroom_tabs_stateroom_tabs__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__icons__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_colors__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dining_form_container__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__notification_notifications_group__ = __webpack_require__(49);












var DiningDetails = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(DiningDetails, _super);
    function DiningDetails() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.closeButtonRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.formContainerRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.state = {
            submitting: false,
            selectedBookingNumber: _this.props.bookingNumber,
            notifications: null,
            selection: null,
            diningOptions: null
        };
        _this.onSubmit = function (e) {
            e.preventDefault();
            if (_this.state.selection) {
                _this.setState({ submitting: true, notifications: null });
                _this.props.onSubmit(_this.props.bookingNumber, _this.state.selection)
                    .then(_this.onSubmissionSuccess)
                    .catch(_this.onSubmissionError);
            }
        };
        _this.onChange = function (diningSelection) {
            _this.setState({ selection: diningSelection });
        };
        _this.onSubmissionSuccess = function (response) {
            var advs = response.advisories || [];
            var notifications = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spreadArrays */])([{
                    type: 'success',
                    message: _this.props.content.confirmationMessage
                }], advs.map(function (n) { return ({
                type: 'info',
                message: n.message
            }); }));
            _this.setState({
                submitting: false,
                notifications: notifications,
                diningOptions: null,
                selection: null
            });
            if (_this.closeButtonRef.current) {
                _this.closeButtonRef.current.focus();
            }
            _this.fetchData();
        };
        _this.onSubmissionError = function (apiError) {
            var notifications;
            if (apiError.details && apiError.details.length > 0) {
                notifications = apiError.details.map(function (n) { return ({
                    type: 'error',
                    message: _this.processApiError(n),
                }); });
            }
            else {
                notifications = [{ type: 'error', message: apiError.message || _this.props.content.genericErrorMessage }];
            }
            _this.setState({ notifications: notifications, submitting: false });
            if (_this.formContainerRef.current) {
                var el = __WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"](_this.formContainerRef.current);
                var firstInput = el.querySelector('input');
                firstInput.focus();
            }
        };
        _this.onRefreshPage = function (e) {
            e.preventDefault();
            window.location.reload();
        };
        _this.fetchData = function () {
            _this.props.getDiningInfo(_this.state.selectedBookingNumber).then(function (diningOptions) {
                _this.setState({
                    diningOptions: diningOptions,
                    selection: DiningDetails.findSelectedDiningCode(diningOptions)
                });
            });
        };
        _this.onCloseNotificationGroup = function (type) {
            _this.setState(function (state) {
                return {
                    notifications: state.notifications
                        ? state.notifications.filter(function (notification) { return notification.type !== type; })
                        : null,
                };
            });
        };
        return _this;
    }
    DiningDetails.getDerivedStateFromProps = function (props, state) {
        if (props.bookingNumber !== state.selectedBookingNumber) {
            return {
                notifications: null,
                selectedBookingNumber: props.bookingNumber,
                selection: null,
                diningOptions: null
            };
        }
        return null;
    };
    DiningDetails.findSelectedDiningCode = function (diningOptions) {
        var availableDining = diningOptions.availableOptions.filter(function (n) { return n.selected; })[0];
        var waitlistDining = diningOptions.waitlistOptions.filter(function (n) { return n.selected; })[0];
        return {
            availableCode: availableDining ? availableDining.code : null,
            waitlistCode: waitlistDining ? waitlistDining.code : null
        };
    };
    DiningDetails.prototype.processApiError = function (error) {
        if (error.code === 'Advisory5170') {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null,
                error.message,
                " ",
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { style: { color: 'inherit' }, href: "", onClick: this.onRefreshPage }, this.props.content.refreshPage)));
        }
        return error.message;
    };
    DiningDetails.prototype.render = function () {
        return this.props.mode === 'embedded'
            ? this.renderEmbedded()
            : this.renderModal();
    };
    DiningDetails.prototype.renderModal = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__modal_modal_shell__["b" /* ModalShell */], { header: this.renderHeader(), footer: this.renderFooter(), notification: this.renderNotification(), onRequestClose: this.props.onRequestClose, closeModalText: this.props.content.closeModal, shellClassName: "h-dining-details-modal" }, this.renderBody()));
    };
    DiningDetails.prototype.renderEmbedded = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
            this.renderHeader(),
            this.renderBody(),
            this.renderFooter()));
    };
    DiningDetails.prototype.renderHeader = function () {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h2", { className: __WEBPACK_IMPORTED_MODULE_5__modal_modal_shell__["a" /* ModalHeadingClassName */] }, this.props.content.heading);
    };
    DiningDetails.prototype.renderNotification = function () {
        var content = this.props.content;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__notification_notifications_group__["a" /* NotificationsGroup */], { notifications: this.state.notifications, closeAriaLabel: content.closeNotificationAriaLabel, autoCloseAriaLabel: content.autoCloseNotificationAriaLabel, onCloseGroup: this.onCloseNotificationGroup }));
    };
    DiningDetails.prototype.renderBody = function () {
        return this.renderTabs();
    };
    DiningDetails.prototype.renderTabs = function () {
        var _this = this;
        var _a = this.props, sailing = _a.sailing, content = _a.content, bookingNumber = _a.bookingNumber, onSelectBooking = _a.onSelectBooking;
        var bookings = sailing.bookings;
        var tabTitles = bookings.map(function (booking, index) {
            return {
                id: booking.bookingNumber,
                eyebrow: content.booking + " " + booking.bookingNumber,
                title: content.stateroom + " " + (index + 1),
            };
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__stateroom_tabs_stateroom_tabs__["d" /* StateroomTabs */], { tabTitles: tabTitles, selectedId: bookingNumber, onSelect: onSelectBooking }, bookings.map(function (booking) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_tabs__["c" /* TabPanel */], { key: booking.bookingNumber, className: __WEBPACK_IMPORTED_MODULE_7__stateroom_tabs_stateroom_tabs__["b" /* StateroomTabPanelClassName */], selectedClassName: __WEBPACK_IMPORTED_MODULE_7__stateroom_tabs_stateroom_tabs__["c" /* StateroomTabPanelSelectedClassName */] }, _this.renderDiningForm(booking, content))); })));
    };
    DiningDetails.prototype.renderDiningForm = function (booking, content) {
        if (!this.state.diningOptions || !this.state.selection) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-dining-details__busy-container" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__icons__["SpinnerIcon"], { color: __WEBPACK_IMPORTED_MODULE_9__styles_colors__["c" /* BlueColor */], width: 32, height: 32 })));
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__dining_form_container__["a" /* DiningFormContainer */], { booking: booking, content: content, diningOptions: this.state.diningOptions, onChange: this.onChange, ref: this.formContainerRef }));
    };
    DiningDetails.prototype.renderFooter = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__button_button__["a" /* Button */], { color: "red", type: "button", onClick: this.onSubmit, className: "h-btn--min-width", "aria-label": (this.props.content.submitButtonAriaLabel || '').replace('{BookingNumber}', this.state.selectedBookingNumber), disabled: this.state.submitting || (!!this.state.diningOptions && !this.state.diningOptions.canEdit), busy: this.state.submitting }, this.props.content.submitButton));
    };
    DiningDetails.prototype.componentDidMount = function () {
        this.fetchData();
    };
    DiningDetails.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevState.selectedBookingNumber !== this.state.selectedBookingNumber) {
            this.fetchData();
        }
    };
    return DiningDetails;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=dining-details.js.map

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CancelBooking; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cancel_booking_css__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cancel_booking_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cancel_booking_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_colors__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icons__ = __webpack_require__(9);







var CancelBooking = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(CancelBooking, _super);
    function CancelBooking() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            submitting: false,
            bookingCancelled: false,
        };
        _this.onClose = function (event) {
            event.preventDefault();
            if (_this.state.bookingCancelled) {
                _this.props.onCloseWithSuccess();
            }
            else {
                _this.props.onAbort();
            }
        };
        _this.onAbort = function (event) {
            event.preventDefault();
            _this.props.onAbort();
        };
        _this.onCancelBooking = function (event) {
            event.preventDefault();
            _this.setState({ submitting: true });
            _this.props.cancelBooking()
                .then(_this.onSuccess)
                .catch(_this.onError);
        };
        _this.onSuccess = function () {
            _this.setState({ submitting: false, bookingCancelled: true });
        };
        _this.onError = function (apiError) {
            _this.props.onCloseWithError(apiError);
        };
        return _this;
    }
    CancelBooking.prototype.render = function () {
        var content = this.props.content;
        var _a = this.state, submitting = _a.submitting, bookingCancelled = _a.bookingCancelled;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-cancel-booking') },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-cancel-booking__wrapper" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__button_button__["a" /* Button */], { className: "h-cancel-booking__close", color: "outline-white", onClick: this.onClose, "aria-label": content.closeModalAriaLabel, disabled: submitting },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__icons__["CloseIcon"], { color: __WEBPACK_IMPORTED_MODULE_5__styles_colors__["c" /* BlueColor */] })),
                bookingCancelled ? this.renderSuccess() : this.renderConfirm())));
    };
    CancelBooking.prototype.renderConfirm = function () {
        var content = this.props.content;
        var submitting = this.state.submitting;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h5", { className: "h-cancel-booking__title" }, content.areYouSure),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-cancel-booking__actions" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__button_button__["a" /* Button */], { className: "h-cancel-booking__button", color: "red", onClick: this.onCancelBooking, disabled: submitting, busy: submitting }, content.cancelButton),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__button_button__["a" /* Button */], { className: "h-cancel-booking__button", color: "outline-black", onClick: this.onAbort, disabled: submitting }, content.abortButton))));
    };
    CancelBooking.prototype.renderSuccess = function () {
        var content = this.props.content;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h5", { "aria-live": "assertive", role: "alert", className: "h-cancel-booking__title" }, content.yourBookingHasBeenCancelled),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", null, content.enjoyTheFunAnotherTime),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-cancel-booking__actions" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__button_button__["b" /* LinkButton */], { className: "h-cancel-booking__button-close", color: "red", href: "", onClick: this.onClose }, content.closeDialog))));
    };
    return CancelBooking;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=cancel-booking.js.map

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CancelBookingModalTrigger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cancel_booking__ = __webpack_require__(242);




var CancelBookingModalTrigger = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(CancelBookingModalTrigger, _super);
    function CancelBookingModalTrigger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CancelBookingModalTrigger.prototype.render = function () {
        var _a = this.props, isOpen = _a.isOpen, restProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["isOpen"]);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__modal_modal__["a" /* Modal */], { shell: false, isOpen: isOpen, dialogDescription: this.props.content.dialogDescription },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__cancel_booking__["a" /* CancelBooking */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, restProps))));
    };
    return CancelBookingModalTrigger;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=cancel-booking-modal-trigger.js.map

/***/ }),
/* 244 */
/***/ (function(module, exports) {

//# sourceMappingURL=models.js.map

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InvoiceDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tabs__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal_modal_shell__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__stateroom_tabs_stateroom_tabs__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__icons__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_colors__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__notification_notifications_group__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__invoice_table__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__insurance_row__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__invoice_details_css__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__invoice_details_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__invoice_details_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__onboard_credit_onboard_credit__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__payment_info__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__visually_hidden_visually_hidden__ = __webpack_require__(14);

















var InvoiceDetails = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(InvoiceDetails, _super);
    function InvoiceDetails() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.closeButtonRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.state = {
            submitting: false,
            selectedBookingNumber: _this.props.bookingNumber,
            notifications: null,
            bookingQuote: undefined,
            bookingInvoice: undefined,
            onBoardCredits: null,
            insuranceModalOpen: false,
            selectedVppGuests: null,
            states: undefined
        };
        _this.onCloseNotificationGroup = function (type) {
            _this.setState(function (state) {
                return {
                    notifications: state.notifications
                        ? state.notifications.filter(function (notification) { return notification.type !== type; })
                        : null,
                };
            });
        };
        _this.print = function (event) {
            event.preventDefault();
            window.print();
        };
        _this.handleVppSubmission = function (bookingNumber, guestRequests) {
            _this.setState({ insuranceModalOpen: false, submitting: true, notifications: null });
            return _this.props.onVppUpdate(bookingNumber, guestRequests)
                .then(_this.onVppActionSuccess)
                .catch(_this.onSubmissionError);
        };
        _this.handleVppModalClosed = function () {
            _this.setState({ insuranceModalOpen: false });
        };
        _this.fetchInvoiceData = function () {
            var _a;
            var invoicePromise;
            var statesPromise;
            if (Object(__WEBPACK_IMPORTED_MODULE_9__common__["d" /* isAgencyBooking */])(_this.props.sailing, _this.state.selectedBookingNumber)) {
                var quote = _this.state.bookingQuote;
                var vpp = ((_a = quote === null || quote === void 0 ? void 0 : quote.vpp) === null || _a === void 0 ? void 0 : _a.length) ? quote.vpp : null;
                var grats = quote ? quote.gratuities : null;
                invoicePromise = _this.props.getQuote(_this.state.selectedBookingNumber, vpp, grats);
            }
            else {
                invoicePromise = _this.props.getInvoice(_this.state.selectedBookingNumber);
                statesPromise = _this.props.getStates();
            }
            if (statesPromise) {
                statesPromise.then(function (states) { return _this.setState({ states: states }); });
            }
            invoicePromise.then(function (bookingInvoiceAndCredits) {
                var currentNotifications = _this.state.notifications || [];
                var bookingInvoice = bookingInvoiceAndCredits.bookingInvoice, onBoardCredits = bookingInvoiceAndCredits.onBoardCredits;
                var notifications = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spreadArrays */])(currentNotifications, _this.getVppNotifications(bookingInvoice));
                _this.setState({ bookingInvoice: bookingInvoice, onBoardCredits: onBoardCredits, notifications: notifications });
            }).catch(function () {
                _this.setState({ bookingInvoice: null });
            });
        };
        _this.onSubmissionError = function (apiError) {
            var notifications;
            if (apiError.details && apiError.details.length > 0) {
                notifications = apiError.details.map(function (n) { return ({
                    type: 'error',
                    message: _this.processApiError(n),
                }); });
            }
            else {
                notifications = [{ type: 'error', message: apiError.message || _this.props.content.genericErrorMessage }];
            }
            _this.setState({ notifications: notifications, submitting: false });
            _this.setFocus(_this.closeButtonRef.current);
        };
        _this.onRefreshPage = function (e) {
            e.preventDefault();
            window.location.reload();
        };
        _this.onVppAction = function (seqNumber, action) {
            if (Object(__WEBPACK_IMPORTED_MODULE_9__common__["d" /* isAgencyBooking */])(_this.props.sailing, _this.state.selectedBookingNumber)) {
                var quote = _this.state.bookingQuote;
                if (!quote) {
                    quote = Object(__WEBPACK_IMPORTED_MODULE_9__common__["g" /* quoteFromInvoice */])(_this.state.bookingInvoice, _this.state.selectedBookingNumber, 'VPP');
                }
                quote = Object(__WEBPACK_IMPORTED_MODULE_9__common__["i" /* quoteWithVpp */])(quote, _this.state.bookingInvoice, seqNumber, action);
                _this.setState({ bookingQuote: quote }, function () { return _this.fetchInvoiceData(); });
                return Promise.resolve();
            }
            if (action !== 'remove') {
                _this.setState({ insuranceModalOpen: true });
                return Promise.resolve();
            }
            return _this.handleVppSubmission(_this.state.selectedBookingNumber, [{ seqNumber: seqNumber, action: action }]);
        };
        _this.onVppActionSuccess = function (response) {
            var advs = response.advisories || [];
            _this.onSubmissionSuccess(_this.props.content.vppSuccessMessage, advs);
        };
        _this.onGratuitiesAction = function (action) {
            if (Object(__WEBPACK_IMPORTED_MODULE_9__common__["d" /* isAgencyBooking */])(_this.props.sailing, _this.state.selectedBookingNumber)) {
                var quote = _this.state.bookingQuote;
                if (!quote) {
                    quote = Object(__WEBPACK_IMPORTED_MODULE_9__common__["g" /* quoteFromInvoice */])(_this.state.bookingInvoice, _this.state.selectedBookingNumber, 'GRATS');
                }
                quote = Object(__WEBPACK_IMPORTED_MODULE_9__common__["h" /* quoteWithGratuities */])(quote, action);
                _this.setState({ bookingQuote: quote }, function () { return _this.fetchInvoiceData(); });
                return Promise.resolve();
            }
            _this.setState({ submitting: true, notifications: null });
            return _this.props.onGratuitiesAction(_this.state.selectedBookingNumber, action)
                .then(_this.onGratuitiesActionSuccess)
                .catch(_this.onSubmissionError);
        };
        _this.onGratuitiesActionSuccess = function (response) {
            var advs = response.advisories || [];
            _this.onSubmissionSuccess(_this.props.content.gratuitiesSuccessMessage, advs);
        };
        return _this;
    }
    InvoiceDetails.getDerivedStateFromProps = function (props, state) {
        if (props.bookingNumber !== state.selectedBookingNumber) {
            return {
                notifications: null,
                selectedBookingNumber: props.bookingNumber,
                bookingInvoice: undefined,
                bookingQuote: undefined,
                onBoardCredits: undefined
            };
        }
        return null;
    };
    InvoiceDetails.prototype.componentDidMount = function () {
        this.fetchInvoiceData();
    };
    InvoiceDetails.prototype.componentDidUpdate = function (_, prevState) {
        if (prevState.selectedBookingNumber !== this.state.selectedBookingNumber) {
            this.fetchInvoiceData();
        }
    };
    InvoiceDetails.prototype.render = function () {
        return this.props.mode === 'embedded'
            ? this.renderEmbedded()
            : this.renderModal();
    };
    InvoiceDetails.prototype.renderModal = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__modal_modal_shell__["b" /* ModalShell */], { header: this.renderHeader(), footer: this.renderFooter(), notification: this.renderNotification(), onRequestClose: this.props.onRequestClose, closeModalText: this.props.content.closeModal, closeButtonRef: this.closeButtonRef, shellClassName: "h-invoice-details-modal" }, this.renderBody()));
    };
    InvoiceDetails.prototype.renderEmbedded = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
            this.renderHeader(),
            this.renderBody(),
            this.renderFooter()));
    };
    InvoiceDetails.prototype.renderHeader = function () {
        var heading = Object(__WEBPACK_IMPORTED_MODULE_9__common__["d" /* isAgencyBooking */])(this.props.sailing, this.state.selectedBookingNumber)
            ? this.props.content.cruiseAddonsHeading
            : this.props.content.heading;
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h2", { className: __WEBPACK_IMPORTED_MODULE_4__modal_modal_shell__["a" /* ModalHeadingClassName */] }, heading);
    };
    InvoiceDetails.prototype.renderNotification = function () {
        var content = this.props.content;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__notification_notifications_group__["a" /* NotificationsGroup */], { notifications: this.state.notifications, closeAriaLabel: content.closeNotificationAriaLabel, autoCloseAriaLabel: content.autoCloseNotificationAriaLabel, onCloseGroup: this.onCloseNotificationGroup }));
    };
    InvoiceDetails.prototype.renderBody = function () {
        return this.renderTabs();
    };
    InvoiceDetails.prototype.renderTabs = function () {
        var _this = this;
        var _a = this.props, sailing = _a.sailing, content = _a.content, bookingNumber = _a.bookingNumber, onSelectBooking = _a.onSelectBooking, onboardCreditContent = _a.onboardCreditContent;
        var bookings = sailing.bookings;
        var tabTitles = bookings.map(function (booking, index) {
            return {
                id: booking.bookingNumber,
                eyebrow: content.booking + " " + booking.bookingNumber,
                title: content.stateroom + " " + (index + 1),
            };
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__stateroom_tabs_stateroom_tabs__["d" /* StateroomTabs */], { tabTitles: tabTitles, selectedId: bookingNumber, onSelect: onSelectBooking }, bookings.map(function (booking) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_tabs__["c" /* TabPanel */], { key: booking.bookingNumber, className: "h-stateroom-tabs__tabpanel", selectedClassName: "h-stateroom-tabs__tabpanel--active" },
            _this.renderPrint(content),
            _this.renderInvoice(content),
            _this.renderOnboardCredits(onboardCreditContent))); })));
    };
    InvoiceDetails.prototype.renderPrint = function (content) {
        if (!this.state.bookingInvoice) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "d-print-none h-invoice-details__print" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { className: "h-invoice-details__print-link", href: "", onClick: this.print },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__icons__["PrinterIcon"], { height: 18, width: 18, "aria-hidden": "true", className: "h-invoice-details__print-icon" }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "h-invoice-details__print-link-text", "aria-hidden": "true" }, content.print),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], null, content.print))));
    };
    InvoiceDetails.prototype.renderInvoice = function (content) {
        if (this.state.bookingInvoice === undefined) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-dining-details__busy-container" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__icons__["SpinnerIcon"], { color: __WEBPACK_IMPORTED_MODULE_8__styles_colors__["c" /* BlueColor */], width: 32, height: 32 })));
        }
        if (this.state.bookingInvoice === null) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-details__unavailable h-invoice-details__outline-none", tabIndex: 0 }, content.invoiceUnavailable));
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-details__outline-none", tabIndex: 0 },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__invoice_table__["a" /* InvoiceTable */], { bookingNumber: this.state.selectedBookingNumber, invoice: this.state.bookingInvoice, content: content, onVppAction: this.onVppAction, onGratuitiesAction: this.onGratuitiesAction, onSubmitVppUpdate: this.handleVppSubmission, states: this.state.states, vppModalContent: this.props.vppModalContent, vppSelectedGuests: this.state.selectedVppGuests, isVppModalOpen: this.state.insuranceModalOpen, onCloseVppModal: this.handleVppModalClosed, submitting: this.state.submitting }),
            content.insuranceDisclaimerMessage &&
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-details__invoice-disclaimer" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "h-invoice-details__invoice-disclaimer--text", dangerouslySetInnerHTML: { __html: content.insuranceDisclaimerMessage } })),
            content.hiddenTravelAgentDisclaimer && Object(__WEBPACK_IMPORTED_MODULE_9__common__["c" /* hasHiddenAmounts */])(this.state.bookingInvoice) &&
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-details__invoice-disclaimer" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "h-invoice-details__invoice-disclaimer--text", dangerouslySetInnerHTML: { __html: content.hiddenTravelAgentDisclaimer } }))));
    };
    InvoiceDetails.prototype.renderOnboardCredits = function (obcContent) {
        var onBoardCredits = this.state.onBoardCredits;
        return (onBoardCredits &&
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__onboard_credit_onboard_credit__["a" /* OnBoardCredit */], { content: obcContent, bookingOnboardCredits: onBoardCredits }));
    };
    InvoiceDetails.prototype.renderFooter = function () {
        var _a = this.state, bookingInvoice = _a.bookingInvoice, selectedBookingNumber = _a.selectedBookingNumber;
        if (!bookingInvoice) {
            return null;
        }
        var schedule = bookingInvoice.schedule, showCancellationInfo = bookingInvoice.showCancellationInfo, paymentInstallments = bookingInvoice.paymentInstallments;
        var _b = this.props, content = _b.content, renderCancellationInfo = _b.renderCancellationInfo;
        var ctaUrl = paymentInstallments ? paymentInstallments.managePaymentsUrl : bookingInvoice.paymentUrl;
        var showDepositDue = !paymentInstallments && schedule && schedule.depositAmountDue > 0;
        var showBalanceDue = !showDepositDue && schedule && schedule.balanceDue > 0;
        var showPaymentButton = ((showDepositDue || showBalanceDue) && ctaUrl) ? true : false;
        var disabledPaymentButton = false;
        var ctaAriaLabel = paymentInstallments ? content.managePaymentsButtonAriaLabel : content.payBalanceButtonAriaLabel;
        var ctaLabel = paymentInstallments ? content.managePaymentsButton : content.payBalanceButton;
        if (Object(__WEBPACK_IMPORTED_MODULE_9__common__["d" /* isAgencyBooking */])(this.props.sailing, selectedBookingNumber)) {
            showPaymentButton = true;
            disabledPaymentButton = !ctaUrl;
            ctaLabel = content.payNowButton;
            ctaAriaLabel = content.payNowButtonAriaLabel;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row h-invoice-details__footer" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__payment_info__["a" /* PaymentInfo */], { invoice: bookingInvoice, balanceDueLabel: content.balanceDue, depositDueLabel: content.depositDue, installmentsScheduledLabel: content.installmentsScheduled },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-details__cancellation-info" }, showCancellationInfo && (renderCancellationInfo(this.onSubmissionError)))),
                showPaymentButton && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-details__actions d-print-none" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__button_button__["b" /* LinkButton */], { id: "h-invoice-details-pay-balance", color: "red", type: "button", className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-invoice-details__pay-button', { 'h-btn--disabled': disabledPaymentButton }), href: ctaUrl, "aria-label": (ctaAriaLabel || '').replace('{BookingNumber}', selectedBookingNumber) }, ctaLabel))))));
    };
    InvoiceDetails.prototype.processApiError = function (error) {
        if (error.code === 'Advisory5170') {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null,
                error.message,
                " ",
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { style: { color: 'inherit' }, href: "", onClick: this.onRefreshPage }, this.props.content.refreshPage)));
        }
        return error.message;
    };
    InvoiceDetails.prototype.getVppNotifications = function (bookingInvoice) {
        var notifications = [];
        if (Object(__WEBPACK_IMPORTED_MODULE_9__common__["d" /* isAgencyBooking */])(this.props.sailing, this.state.selectedBookingNumber)) {
            return notifications;
        }
        var filteredLines = bookingInvoice.lineItems.filter(__WEBPACK_IMPORTED_MODULE_12__insurance_row__["b" /* isVpp */]);
        if (!filteredLines.length) {
            return notifications;
        }
        var vppLine = filteredLines[0];
        var isVppAvailable = bookingInvoice.insurancePrepaidGratuitiesQuote.isInsuranceAvailable;
        if (vppLine && vppLine.amount > 0 && !isVppAvailable) {
            notifications.push({
                type: 'info',
                message: this.props.content.vppPenaltyPeriodMessage
            });
        }
        return notifications;
    };
    InvoiceDetails.prototype.onSubmissionSuccess = function (successMessage, advisories) {
        var _this = this;
        var notifications = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spreadArrays */])([{
                type: 'success',
                message: successMessage
            }], advisories.map(function (n) { return ({
            type: 'info',
            message: n.message
        }); }));
        this.setState({ submitting: false, notifications: notifications }, function () {
            _this.fetchInvoiceData();
            _this.setFocus(_this.closeButtonRef.current);
        });
    };
    InvoiceDetails.prototype.setFocus = function (element) {
        if (element) {
            element.focus();
        }
    };
    return InvoiceDetails;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=invoice-details.js.map

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InsuranceRow; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isVpp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eyebrow_eyebrow__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__visually_hidden_visually_hidden__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_colors__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icons__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__line_explanation_trigger__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__insurance_row_css__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__insurance_row_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__insurance_row_css__);









var InsuranceRow = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(InsuranceRow, _super);
    function InsuranceRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.onActionButtonClick = function (action) { return function (e) {
            e.preventDefault();
            var onAction = _this.props.onAction;
            _this.setState({ action: action });
            onAction(_this.props.guest.seqNumber, action, e.currentTarget);
        }; };
        return _this;
    }
    InsuranceRow.prototype.render = function () {
        var _a = this.props, bookingNumber = _a.bookingNumber, line = _a.line, invoice = _a.invoice, content = _a.content, guest = _a.guest, index = _a.guestIndex;
        if (this.props.submitting) {
            var guestName = Object(__WEBPACK_IMPORTED_MODULE_3__common__["a" /* getGuestName */])(index, content, guest.firstName, guest.lastName);
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                this.renderLineDescription(line, content),
                this.renderBusyIndicator(invoice, content, guestName, bookingNumber)));
        }
        var insuranceAvailability = this.calculateInsuranceAvailability(invoice, guest);
        if (insuranceAvailability === 'Unavailable') {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                this.renderLineDescription(line, content),
                this.renderRawLineAmount(line)));
        }
        else if (insuranceAvailability === 'All') {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                this.renderLineDescription(line, content),
                this.renderOfferInsuranceToAllGuest(index, content, invoice, guest, bookingNumber)));
        }
        else if (insuranceAvailability === 'Some') {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                this.renderLineDescription(line, content),
                this.renderActionsToModifyInsurance(line, index, content, invoice, guest, bookingNumber)));
        }
        return null;
    };
    InsuranceRow.prototype.renderLineDescription = function (line, content) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-invoice__cell__line-description" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__eyebrow_eyebrow__["a" /* Eyebrow */], null,
                line.description,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__line_explanation_trigger__["a" /* LineExplanationTrigger */], { content: content, line: line, onOpen: this.props.onExplanationOpen }))));
    };
    InsuranceRow.prototype.renderRawLineAmount = function (line) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-invoice__cell__line-amount" }, line.amountFormatted)));
    };
    InsuranceRow.prototype.renderBusyIndicator = function (invoice, content, guestName, bookingNumber) {
        var currentAction = this.state.action;
        var adaVerbiage = '';
        if (currentAction === 'addAll') {
            var guests = invoice.guests.map(function (g, i) { return Object(__WEBPACK_IMPORTED_MODULE_3__common__["a" /* getGuestName */])(i, content, g.firstName, g.lastName); }).join(', ');
            adaVerbiage = content.vppBusyMessage.replace('{Action}', content.vppAdding).replace('{Guest}', guests);
        }
        else if (currentAction === 'add') {
            adaVerbiage = content.vppBusyMessage.replace('{Action}', content.vppAdding).replace('{Guest}', guestName);
        }
        else if (currentAction === 'remove') {
            adaVerbiage = content.vppBusyMessage.replace('{Action}', content.vppRemoving).replace('{Guest}', guestName);
        }
        adaVerbiage = adaVerbiage.replace('{BookNum}', bookingNumber);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-invoice__cell__line-amount", "aria-hidden": "true" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-table__vpp-busy-container" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__icons__["SpinnerIcon"], { color: __WEBPACK_IMPORTED_MODULE_5__styles_colors__["c" /* BlueColor */], width: 22, height: 22 }))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], null, adaVerbiage)));
    };
    InsuranceRow.prototype.renderOfferInsuranceToAllGuest = function (index, content, invoice, guest, bookingNumber) {
        var quote = invoice.insurancePrepaidGratuitiesQuote;
        var guestName = Object(__WEBPACK_IMPORTED_MODULE_3__common__["a" /* getGuestName */])(index, content, guest.firstName, guest.lastName);
        var guestQuote = quote.guests.filter(function (g) { return g.seqNumber === guest.seqNumber; })[0];
        var ariaLabelPerGuest = content.vppAddPerGuestAriaLabel.replace('{Guest}', guestName)
            .replace('{Amount}', guestQuote.insuranceAmountFormatted)
            .replace('{BookNum}', bookingNumber);
        var addMobileFragment = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-invoice__cell__line-vpp-amount" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-table__vpp-container--mobile" },
                    this.renderActionButton(content.vppAddLabel, 'add', ariaLabelPerGuest),
                    this.renderAmountWithPlus(guestQuote)))));
        if (index === 0) {
            var helpText = content.vppAddHelpText.replace('{Amount}', guestQuote.insuranceAmountWholeNumberFormatted);
            var ariaLabel = content.vppAddAriaLabel.replace('{Amount}', guestQuote.insuranceAmountFormatted)
                .replace('{BookNum}', bookingNumber);
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-invoice__cell__line-vpp-amount" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-table__vpp-container" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-table__vpp-help-text", "aria-hidden": "true" }, helpText),
                    this.renderActionButton(content.vppAddLabel, 'addAll', ariaLabel)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-table__vpp-container--mobile" }, addMobileFragment)));
        }
        return addMobileFragment;
    };
    InsuranceRow.prototype.renderActionsToModifyInsurance = function (line, index, content, invoice, guest, bookingNumber) {
        var quote = invoice.insurancePrepaidGratuitiesQuote;
        var guestName = Object(__WEBPACK_IMPORTED_MODULE_3__common__["a" /* getGuestName */])(index, content, guest.firstName, guest.lastName);
        var guestQuote = quote.guests.filter(function (g) { return g.seqNumber === guest.seqNumber; })[0];
        if (!guestQuote.insuranceAmount) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-invoice__cell__line-amount" }, line.amountFormatted));
        }
        if (line.amount > 0) {
            var ariaLabel = content.vppRemoveAriaLabel.replace('{Guest}', guestName).replace('{BookNum}', bookingNumber);
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-invoice__cell__line-amount" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-invoice__cell__line-vpp-amount-remove" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null, line.amountFormatted),
                    this.renderActionButton(content.vppRemoveLabel, 'remove', ariaLabel))));
        }
        var ariaLabelPerGuest = content.vppAddPerGuestAriaLabel.replace('{Guest}', guestName)
            .replace('{Amount}', guestQuote.insuranceAmountFormatted)
            .replace('{BookNum}', bookingNumber);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-invoice__cell__line-amount" },
            this.renderAmountWithPlus(guestQuote),
            this.renderActionButton(content.vppAddLabel, 'add', ariaLabelPerGuest)));
    };
    InsuranceRow.prototype.renderAmountWithPlus = function (guestQuote) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-invoice__cell__line-vpp-amount-add", "aria-hidden": "true" }, "+ " + guestQuote.insuranceAmountFormatted));
    };
    InsuranceRow.prototype.renderActionButton = function (label, action, ariaLabel) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "", className: "h-invoice-table__vpp-cta  d-print-none", "aria-label": ariaLabel, role: "button", onClick: this.onActionButtonClick(action) }, label));
    };
    InsuranceRow.prototype.calculateInsuranceAvailability = function (invoice, guest) {
        var quote = invoice.insurancePrepaidGratuitiesQuote, invoiceLines = invoice.lineItems;
        if (!quote.isInsuranceAvailable) {
            return 'Unavailable';
        }
        var filteredGuests = quote.guests.filter(function (g) { return g.seqNumber === guest.seqNumber; });
        if (!filteredGuests.length) {
            return 'GuestDoesNotExists';
        }
        var totalInsurance = this.getInsuranceValueFromInvoiceLines(invoiceLines);
        var allGuestDontHaveInsurance = quote.isInsuranceAvailable && quote.guests.every(function (g) { return (g.insuranceAmount || 0) > 0; }) && totalInsurance === 0;
        if (allGuestDontHaveInsurance) {
            return 'All';
        }
        var someGuestsHasInsurance = quote.isInsuranceAvailable && totalInsurance > 0;
        if (someGuestsHasInsurance) {
            return 'Some';
        }
        return 'Unknown';
    };
    InsuranceRow.prototype.getInsuranceValueFromInvoiceLines = function (lineItems) {
        var filtered = lineItems.filter(isVpp);
        if (filtered.length > 0) {
            return filtered[0].amount;
        }
        return 0;
    };
    return InsuranceRow;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

function isVpp(line) {
    return line && line.code === 'INSU';
}
//# sourceMappingURL=insurance-row.js.map

/***/ }),
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InsuranceModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__insurance_modal_css__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__insurance_modal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__insurance_modal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modal_modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modal_modal_shell__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__insurance_guest_request__ = __webpack_require__(753);








var InsuranceModal = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(InsuranceModal, _super);
    function InsuranceModal(props) {
        var _this = _super.call(this, props) || this;
        _this.canRequestInsurance = function (gc) { return !gc.hasPurchasedVpp && gc.selected; };
        _this.validRequestCheck = function () {
            var guestControlGroups = _this.state.guestControlRequests;
            var validGuestSelections = guestControlGroups.filter(_this.canRequestInsurance);
            var valid = validGuestSelections.length > 0 && validGuestSelections.every(function (g) { return !g.hasError; });
            _this.setState({
                hasValidRequest: valid
            });
        };
        _this.handleControlChanged = function (g, control) {
            _this.setState(function (prevState) {
                var groups = prevState.guestControlRequests.map(function (group) {
                    if (group.seqNumber !== g.seqNumber) {
                        return group;
                    }
                    var newControlGroup = Object(__WEBPACK_IMPORTED_MODULE_3__forms__["m" /* replaceControlModel */])(g.controlGroup, control);
                    var controls = newControlGroup.controls.get;
                    var selected = controls.seqNumber.checked;
                    var hasError = selected ? !_this.hasValidState(controls.homeStateCode.value) : false;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, group), { controlGroup: newControlGroup, hasError: hasError, selected: selected, message: hasError ? _this.props.content.stateRequiredMessage : '' });
                });
                return { guestControlRequests: groups };
            }, function () { return _this.validRequestCheck(); });
        };
        _this.hasValidState = function (homeStateCode) { var _a; return homeStateCode && !!((_a = _this.props.states) === null || _a === void 0 ? void 0 : _a.find(function (s) { return s.code === homeStateCode; })); };
        _this.createInsuranceGuestRequests = function () { return _this.props.guests.map(_this.createInsuranceGuestControl); };
        _this.createInsuranceGuestControl = function (g, index) {
            var _a = _this.props, selectedGuests = _a.selectedGuests, content = _a.content;
            var hasPurchasedVpp = g.lineItems.filter(function (line) { return line.code === 'INSU' && line.amount > 0; }).length > 0;
            var guestFullName = g.firstName === 'TBA'
                ? content.guestSubName + " " + index
                : g.firstName + " " + g.lastName;
            var isGuestPreselected = selectedGuests.find(function (sel) { return sel === g.seqNumber; }) !== null || hasPurchasedVpp;
            var needsHomeStateCode = isGuestPreselected && !hasPurchasedVpp && !_this.hasValidState(g.homeStateCode);
            return {
                seqNumber: g.seqNumber,
                hasPurchasedVpp: hasPurchasedVpp,
                selected: isGuestPreselected,
                hasError: needsHomeStateCode,
                message: needsHomeStateCode ? content.stateRequiredMessage : '',
                controlGroup: Object(__WEBPACK_IMPORTED_MODULE_3__forms__["h" /* createControlGroup */])(Object(__WEBPACK_IMPORTED_MODULE_3__forms__["i" /* createControlModel */])({
                    name: 'seqNumber',
                    id: "seqNumber_" + g.seqNumber,
                    checked: isGuestPreselected,
                    value: "" + g.seqNumber,
                    validators: {
                        required: true
                    },
                    props: {
                        label: guestFullName,
                    }
                }), Object(__WEBPACK_IMPORTED_MODULE_3__forms__["i" /* createControlModel */])({
                    name: 'homeStateCode',
                    id: "homeStateCode_" + g.seqNumber,
                    value: g.homeStateCode || '',
                    validators: {
                        required: true
                    }
                })),
            };
        };
        _this.handleOnContinue = function () {
            var guestControlGroups = _this.state.guestControlRequests;
            var onContinue = _this.props.onContinue;
            var validRequests = guestControlGroups.filter(_this.canRequestInsurance).map(function (gc) { return ({
                action: 'add',
                homeStateCode: gc.controlGroup.controls.get.homeStateCode.value,
                seqNumber: gc.seqNumber
            }); });
            if (validRequests.length > 0) {
                onContinue(validRequests);
            }
        };
        _this.state = {
            hasValidRequest: false,
            guestControlRequests: _this.createInsuranceGuestRequests()
        };
        return _this;
    }
    InsuranceModal.prototype.renderFooter = function () {
        var _a = this.props, content = _a.content, onCancel = _a.onCancel;
        var hasValidRequest = this.state.hasValidRequest;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "container" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row h-cvp-modal__footer" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-cvp-modal__button col-md" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__button_button__["a" /* Button */], { color: "outline-black", type: "button", className: "h-btn--min-width", onClick: onCancel }, content.cancelText)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-cvp-modal__button col-md" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__button_button__["a" /* Button */], { color: "red", type: "button", className: "h-btn--min-width", disabled: !hasValidRequest, onClick: this.handleOnContinue }, content.continueText)))));
    };
    InsuranceModal.prototype.renderBody = function (states) {
        var _this = this;
        var content = this.props.content;
        var guestControlGroups = this.state.guestControlRequests;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "container h-cvp-modal-body" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-cvp-disclaimer" }, content.disclaimer),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-cvp-guest-list" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row h-cvp-guest-list__header" }, content.selectGuestsInfo),
                    guestControlGroups.map(function (g) {
                        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row", key: g.seqNumber },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__insurance_guest_request__["a" /* InsuranceGuestRequest */], { content: content, guestRequestControl: g, states: states, onControlChanged: _this.handleControlChanged }));
                    })))));
    };
    InsuranceModal.prototype.componentDidMount = function () {
        this.validRequestCheck();
    };
    InsuranceModal.prototype.render = function () {
        var _a = this.props, content = _a.content, states = _a.states, isOpen = _a.isOpen;
        if (!states || !content) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__modal_modal__["a" /* Modal */], { shell: true, isOpen: isOpen, fullScreen: false, header: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h2", { className: __WEBPACK_IMPORTED_MODULE_6__modal_modal_shell__["a" /* ModalHeadingClassName */] }, content.header), dialogDescription: content.header, className: "h-cvp-modal-shell", closeModalText: content.closeAriaLabel, onRequestClose: this.props.onCancel, footer: this.renderFooter() }, this.renderBody(states)));
    };
    return InsuranceModal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=insurance-modal.js.map

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OnBoardCredit; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_colors__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__collapsible_collapsible__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__icons__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tooltip_tooltip__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__visually_hidden_visually_hidden__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__onboard_credit_css__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__onboard_credit_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__onboard_credit_css__);









var OnBoardCredit = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(OnBoardCredit, _super);
    function OnBoardCredit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OnBoardCredit.prototype.onTooltipClick = function (e) {
        e.preventDefault();
    };
    OnBoardCredit.prototype.render = function () {
        var _a = this.props, content = _a.content, bookingOnboardCredits = _a.bookingOnboardCredits;
        if (!content || !bookingOnboardCredits || bookingOnboardCredits.initialTotal === 0) {
            return null;
        }
        var creditDetails = bookingOnboardCredits.creditDetails;
        if (!creditDetails || creditDetails.length === 0) {
            return null;
        }
        var subtitle = this.replaceTitleTokens(content.sectionSubtitle);
        var collapsedTitleAriaLabel = subtitle + " " + content.sectionSubtitleCollapsedAriaLabel;
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: "row h-obc" },
            this.renderTitle(content),
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__collapsible_collapsible__["a" /* Collapsible */], { id: "onboard-credit", collapsedTitle: subtitle, collapsedTitleAriaLabel: collapsedTitleAriaLabel, expandedTitle: subtitle, expandedTitleAriaLabel: content.sectionSubtitleExpandedAriaLabel, chevronColor: __WEBPACK_IMPORTED_MODULE_3__styles_colors__["f" /* Gray700Color */] },
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: "h-obc-table", role: "table" },
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: "h-obc-header", role: "row" },
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { role: "columnheader", className: "col-md h-obc-header__type" }, content.categoryColumnTitle),
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { role: "columnheader", className: "col-md h-obc-detail__header" }, content.amountIssuedColumnTitle),
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { role: "columnheader", className: "col-md h-obc-detail__header" }, content.usedTitle),
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { role: "columnheader", className: "col-md h-obc-detail__header" }, content.balanceColumnTitle)),
                    creditDetails.map(function (obc) { return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: "row h-obc-row", key: obc.category, role: "row" },
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { role: "cell", className: "col-md h-obc-header-desc" }, obc.categoryDescription),
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { role: "cell", className: "col-md h-obc-detail__info" }, obc.initialAmountFormatted),
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { role: "cell", className: "col-md h-obc-detail__info" }, obc.usedAmountFormatted),
                        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { role: "cell", className: "col-md h-obc-detail__info" }, obc.balanceAmountFormatted))); })))));
    };
    OnBoardCredit.prototype.replaceTitleTokens = function (str) {
        var bookingOnboardCredits = this.props.bookingOnboardCredits;
        if (!bookingOnboardCredits) {
            return str;
        }
        var result = str.replace('{leftOverAmount}', bookingOnboardCredits.totalAvailableFormatted)
            .replace('{totalAmount}', bookingOnboardCredits.initialTotalFormatted);
        return result;
    };
    OnBoardCredit.prototype.renderTitle = function (content) {
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: "h-obc-title" },
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", null,
                content.sectionTitle,
                " "),
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", { className: "h-obc__tooltip-container d-print-none" },
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("a", { href: "", role: "button", className: "h-obc__tooltip-trigger", onClick: this.onTooltipClick, "aria-describedby": "obc-tooltip" },
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], { dangerouslySetInnerHTML: { __html: this.props.content.openToolTipContent } }),
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__icons__["InfoIcon"], { "aria-hidden": "true", style: { verticalAlign: 'baseline' } })),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__tooltip_tooltip__["a" /* Tooltip */], { id: "obc-tooltip", role: "tooltip", "aria-hidden": "true", placement: "top-center", className: __WEBPACK_IMPORTED_MODULE_1_classnames__(['h-obc__tooltip', 'h-obc__tooltip--center']) },
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { dangerouslySetInnerHTML: { __html: content.toolTipContent } })))));
    };
    return OnBoardCredit;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]));

//# sourceMappingURL=onboard-credit.js.map

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Collapsible; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__collapsible_css__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__collapsible_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__collapsible_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chevron_chevron__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_colors__ = __webpack_require__(6);






var Collapsible = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Collapsible, _super);
    function Collapsible(props) {
        var _this = _super.call(this, props) || this;
        _this.applyFocus = false;
        _this.contentRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.onToggle = function (e) {
            e.preventDefault();
            _this.applyFocus = true;
            _this.setState(function (prevState) { return ({ isOpen: !prevState.isOpen }); });
        };
        _this.state = {
            isOpen: !!props.openOnInit
        };
        return _this;
    }
    Collapsible.prototype.render = function () {
        var _a = this.props, children = _a.children, id = _a.id, expandedTitle = _a.expandedTitle, expandedTitleAriaLabel = _a.expandedTitleAriaLabel, collapsedTitle = _a.collapsedTitle, collapsedTitleAriaLabel = _a.collapsedTitleAriaLabel, chevronColor = _a.chevronColor;
        var isOpen = this.state.isOpen;
        var contentId = id + "-content";
        var title = isOpen ? expandedTitle : collapsedTitle;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { id: id, className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-collapsible', { 'h-collapsible--expanded': isOpen }) },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { className: "h-collapsible__toggle d-print-none", role: "button", href: "", onClick: this.onToggle, "aria-label": isOpen ? expandedTitleAriaLabel : collapsedTitleAriaLabel, "aria-expanded": isOpen, "aria-controls": contentId },
                title ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null, title)) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null, "\u00A0")),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__chevron_chevron__["a" /* Chevron */], { "aria-hidden": "true", direction: isOpen ? 'up' : 'down', size: 14, color: chevronColor || __WEBPACK_IMPORTED_MODULE_5__styles_colors__["b" /* Blue600Color */], className: "h-collapsible__chevron" })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { id: contentId, ref: this.contentRef, className: "h-collapsible__content d-print-block", tabIndex: -1, style: { outline: 'none' } }, children)));
    };
    Collapsible.prototype.componentDidUpdate = function () {
        if (this.applyFocus && this.state.isOpen && this.contentRef.current) {
            this.contentRef.current.focus();
        }
        this.applyFocus = false;
    };
    return Collapsible;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=collapsible.js.map

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaymentInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__invoice_details_css__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__invoice_details_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__invoice_details_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(45);



var PaymentInfo = function (_a) {
    var invoice = _a.invoice, depositDueLabel = _a.depositDueLabel, balanceDueLabel = _a.balanceDueLabel, installmentsScheduledLabel = _a.installmentsScheduledLabel, children = _a.children, paidInFullLabel = _a.paidInFullLabel;
    if (!invoice) {
        return null;
    }
    var paymentDue = Object(__WEBPACK_IMPORTED_MODULE_2__common__["b" /* getPaymentDue */])(invoice);
    var paymentInstallment = invoice.paymentInstallments;
    var dueDateLabel = !!paymentDue
        ? ((paymentDue === null || paymentDue === void 0 ? void 0 : paymentDue.showDepositDue) ? depositDueLabel : balanceDueLabel)
            .replace('{DueDate}', paymentDue === null || paymentDue === void 0 ? void 0 : paymentDue.dueByDateFormatted)
        : paidInFullLabel || null;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-invoice-details__balance" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            paymentDue && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, (paymentDue === null || paymentDue === void 0 ? void 0 : paymentDue.amountFormatted) + " "),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, dueDateLabel)),
        paymentInstallment && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-invoice-details__installment-payment-scheduled" }, (installmentsScheduledLabel || '')
            .replace('{Date}', paymentInstallment.nextInstallmentDateMmmDYyyy)
            .replace('{Amount}', paymentInstallment.nextInstallmentAmountFormated))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, children)));
};
//# sourceMappingURL=payment-info.js.map

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HubAppDownload; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icons_apple_store_download_svg__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icons_apple_store_download_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__icons_apple_store_download_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icons_google_play_download_svg__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icons_google_play_download_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__icons_google_play_download_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hub_app_download_css__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hub_app_download_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__hub_app_download_css__);




var HubAppDownload = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-hub-app-dl d-flex flex-column flex-md-row align-items-center" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-hub-app-dl__col-content" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "h-hub-app-dl__logo", src: props.hubAppIcon.src, alt: props.hubAppIcon.alt })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-hub-app-dl__content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-hub-app-dl__heading" }, props.heading),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "h-hub-app-dl__desc", dangerouslySetInnerHTML: { __html: props.description } }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-hub-app-dl__col" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: props.appleStoreUrl, target: "_blank", rel: "noopener", "aria-label": props.appleStoreAriaLabel },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: __WEBPACK_IMPORTED_MODULE_1__icons_apple_store_download_svg___default.a, className: "h-hub-app-dl__apple-store-icon", alt: "" }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-hub-app-dl__col" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: props.googlePlayUrl, target: "_blank", rel: "noopener", "aria-label": props.googlePlayAriaLabel },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: __WEBPACK_IMPORTED_MODULE_2__icons_google_play_download_svg___default.a, className: "h-hub-app-dl__google-play-icon", alt: "" })))));
};
//# sourceMappingURL=hub-app-download.js.map

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductCard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__product_card_css__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__product_card_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__product_card_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eyebrow_eyebrow__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__badge_badge__ = __webpack_require__(157);





var ProductCard = function (_a) {
    var image = _a.image, eyebrow = _a.eyebrow, title = _a.title, badge = _a.badge, badgeIconUrl = _a.badgeIconUrl, pricing = _a.pricing, ctaUrl = _a.ctaUrl, ctaText = _a.ctaText, onClick = _a.onClick, ctaAriaLabelFormat = _a.ctaAriaLabelFormat;
    var ctaAriaLabelReplaced = (ctaAriaLabelFormat || '').replace('{CtaText}', ctaText).replace('{Title}', title);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-product-card" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("figure", { className: "h-product-card__thumbnail" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: image.src, alt: "", className: "h-product-card__thumbnail-image" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-product-card__body" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__eyebrow_eyebrow__["a" /* Eyebrow */], null, eyebrow),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-product-card__title" }, title),
            badge && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__badge_badge__["a" /* Badge */], { mode: "block" },
                badgeIconUrl && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: badgeIconUrl, alt: "", className: "h-product-card__tag-icon" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, badge)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-product-card__price", dangerouslySetInnerHTML: { __html: pricing } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__button_button__["b" /* LinkButton */], { className: "h-product-card__button", href: ctaUrl, onClick: onClick, "aria-label": ctaAriaLabelReplaced }, ctaText))));
};
//# sourceMappingURL=product-card.js.map

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CruiseTip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cruise_tip_css__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cruise_tip_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__cruise_tip_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eyebrow_eyebrow__ = __webpack_require__(13);



var CruiseTip = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-cruise-tip" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-cruise-tip__card h-cruise-tip__card--" + props.count, tabIndex: props.tabIndex },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-cruise-tip__card-line" },
                props.image && props.image.src && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: props.image.src, alt: "", className: "h-cruise-tip__image" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-cruise-tip__title" }, props.title),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-cruise-tip__desc", dangerouslySetInnerHTML: { __html: props.description } }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-cruise-tip__desc", dangerouslySetInnerHTML: { __html: props.description } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-cruise-tip__arrow" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-cruise-tip__author" },
            props.authorAvatar && props.authorAvatar.src && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: props.authorAvatar.src, alt: "", className: "h-cruise-tip__author-avatar" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                props.authorEyebrow && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__eyebrow_eyebrow__["a" /* Eyebrow */], { className: "h-cruise-tip__author-eyebrow" }, props.authorEyebrow),
                props.authorBio && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-cruise-tip__author-bio", dangerouslySetInnerHTML: { __html: props.authorBio } })))));
};
//# sourceMappingURL=cruise-tip.js.map

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PrintDocuments; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__print_documents_css__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__print_documents_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__print_documents_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__forms__ = __webpack_require__(10);




var PrintDocuments = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(PrintDocuments, _super);
    function PrintDocuments(props) {
        var _this = _super.call(this, props) || this;
        _this.onFieldUpdate = function (control) {
            _this.setState(function (prevState) {
                var newControlGroup = Object(__WEBPACK_IMPORTED_MODULE_3__forms__["m" /* replaceControlModel */])(prevState.controlGroup, control);
                var groupValues = Object(__WEBPACK_IMPORTED_MODULE_3__forms__["o" /* values */])(newControlGroup);
                _this.props.onChangeValues({
                    printLuggageTags: groupValues.printLuggageTags,
                    printBoardingPasses: groupValues.printBoardingPasses,
                    printGeneralInfo: groupValues.printGeneralInfo,
                });
                return {
                    controlGroup: newControlGroup
                };
            });
        };
        _this.state = {
            controlGroup: Object(__WEBPACK_IMPORTED_MODULE_3__forms__["h" /* createControlGroup */])(Object(__WEBPACK_IMPORTED_MODULE_3__forms__["i" /* createControlModel */])({
                name: 'printLuggageTags',
                value: 'true',
                checked: props.values.printLuggageTags,
                props: {
                    disabled: !!props.enabledValues && !props.enabledValues.printLuggageTags,
                }
            }), Object(__WEBPACK_IMPORTED_MODULE_3__forms__["i" /* createControlModel */])({
                name: 'printBoardingPasses',
                value: 'true',
                checked: props.values.printBoardingPasses,
                props: {
                    disabled: !!props.enabledValues && !props.enabledValues.printBoardingPasses,
                }
            }), Object(__WEBPACK_IMPORTED_MODULE_3__forms__["i" /* createControlModel */])({
                name: 'individualBoardingPasses',
                value: 'true',
                checked: true,
            }), Object(__WEBPACK_IMPORTED_MODULE_3__forms__["i" /* createControlModel */])({
                name: 'printGeneralInfo',
                value: 'true',
                checked: props.values.printGeneralInfo,
                props: {
                    disabled: !!props.enabledValues && !props.enabledValues.printGeneralInfo,
                }
            })),
        };
        return _this;
    }
    PrintDocuments.prototype.render = function () {
        var _a;
        var content = this.props.content;
        var controls = this.state.controlGroup.controls;
        var showPrintLuggageTags = (_a = this.props.visibleFields) === null || _a === void 0 ? void 0 : _a.showPrintLuggageTags;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-print-documents" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-print-documents__header" }, content.selectYourDocuments),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-print-documents__reader-text", dangerouslySetInnerHTML: { __html: content.documentReaderHtml } }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-print-documents__content" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("fieldset", { className: "h-print-documents__content-fields-container" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("legend", null,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h3", { className: "h-print-documents__content-fields-header" }, content.recommendedDocuments)),
                    showPrintLuggageTags && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__forms__["c" /* FormField */], { controlModel: controls.get.printLuggageTags, onFieldUpdate: this.onFieldUpdate }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__forms__["a" /* Checkbox */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ disabled: controls.get.printLuggageTags.props.disabled }, props.controlProps)),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.labelProps), content.printLuggageTags))); })),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__forms__["c" /* FormField */], { controlModel: controls.get.printBoardingPasses, onFieldUpdate: this.onFieldUpdate }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__forms__["a" /* Checkbox */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ disabled: controls.get.printBoardingPasses.props.disabled }, props.controlProps)),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.labelProps), content.printBoardingPasses))); }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-print-documents__content-subfield" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__forms__["c" /* FormField */], { controlModel: controls.get.individualBoardingPasses, onFieldUpdate: this.onFieldUpdate }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__forms__["f" /* Radio */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ disabled: !controls.get.printBoardingPasses.checked ||
                                    controls.get.printBoardingPasses.props.disabled }, Object(__WEBPACK_IMPORTED_MODULE_3__forms__["k" /* radioControlProps */])(props.controlProps, '', 'true'))),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, Object(__WEBPACK_IMPORTED_MODULE_3__forms__["l" /* radioLabelProps */])(props.labelProps, '')), content.individualBoardingPasses))); }))),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("fieldset", { className: "h-print-documents__content-fields-container" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("legend", null,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h3", { className: "h-print-documents__content-fields-header" }, content.additionalDocuments)),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__forms__["c" /* FormField */], { controlModel: controls.get.printGeneralInfo, onFieldUpdate: this.onFieldUpdate }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__forms__["a" /* Checkbox */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ disabled: controls.get.printGeneralInfo.props.disabled }, props.controlProps)),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.labelProps), content.printGeneralInfo))); }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-print-documents__content-fields-description", dangerouslySetInnerHTML: { __html: content.generalInfoDetailsHtml } })))));
    };
    return PrintDocuments;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=print-documents.js.map

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PrintDocumentsModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_modal_shell__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__print_documents_modal_css__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__print_documents_modal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__print_documents_modal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__print_documents__ = __webpack_require__(256);







var PrintDocumentsModal = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(PrintDocumentsModal, _super);
    function PrintDocumentsModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.closeButtonRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        return _this;
    }
    PrintDocumentsModal.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__modal_modal_shell__["b" /* ModalShell */], { header: this.renderHeader(), footer: this.renderFooter(), onRequestClose: this.props.onRequestClose, closeModalText: this.props.content.closeModal, closeButtonRef: this.closeButtonRef, shellClassName: "h-print-documents-modal" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__print_documents__["a" /* PrintDocuments */], { content: this.props.content, values: this.props.values, enabledValues: this.props.enabledValues, visibleFields: this.props.visibleFields, onChangeValues: this.props.onChangeValues })));
    };
    PrintDocumentsModal.prototype.renderHeader = function () {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h2", { className: __WEBPACK_IMPORTED_MODULE_2__modal_modal_shell__["a" /* ModalHeadingClassName */] }, this.props.content.heading);
    };
    PrintDocumentsModal.prototype.renderFooter = function () {
        var _a = this.props, bookingNumber = _a.bookingNumber, content = _a.content, printUrl = _a.printUrl;
        var ariaLabel = content.printButtonAriaLabel
            .replace('{BookingNumber}', "" + bookingNumber);
        var buttonClassname = __WEBPACK_IMPORTED_MODULE_3_classnames__('h-btn--min-width h-print-documents-modal__footer-cta', { 'h-btn--disabled': !printUrl });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-print-documents-modal__footer" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-print-documents-modal__footer-info" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { className: "h-print-documents-modal__footer-info-link", href: content.viewCruiseTicketContractUrl, target: "_blank", "aria-label": content.viewCruiseTicketContractAria }, content.viewCruiseTicketContract),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-print-documents-modal__footer-info-text" }, bookingNumber)),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__button_button__["b" /* LinkButton */], { color: "red", type: "button", className: buttonClassname, href: printUrl, target: "_blank", "aria-label": ariaLabel }, content.printButton)));
    };
    return PrintDocumentsModal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=print-documents-modal.js.map

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmailInvitationForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__email_invitation__ = __webpack_require__(799);




var EmailInvitationForm = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(EmailInvitationForm, _super);
    function EmailInvitationForm(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (model) {
            _this.setState({
                status: 'none',
                control: model,
            });
        };
        _this.onSubmit = function () {
            if (_this.isValidForm()) {
                _this.setState({ sendingEmail: true });
                _this.props.onSubmit(_this.state.control.value)
                    .then(_this.onSubmissionSuccess)
                    .catch(_this.onSubmissionError);
            }
        };
        _this.onSubmissionError = function () {
            _this.setState({ status: 'error', sendingEmail: false });
        };
        _this.onSubmissionSuccess = function () {
            _this.setState({ status: 'success', sendingEmail: false });
        };
        _this.isValidForm = function () {
            return _this.state.control.state.valid;
        };
        _this.createEmailControl = function () {
            return Object(__WEBPACK_IMPORTED_MODULE_2__forms__["i" /* createControlModel */])({
                name: 'emailTo',
                value: '',
                validators: {
                    required: true,
                    pattern: _this.props.content.emailRegex,
                },
                errorMessages: {
                    required: _this.props.content.emailRequired,
                    pattern: _this.props.content.invalidEmail,
                }
            });
        };
        _this.state = {
            status: 'none',
            control: _this.createEmailControl(),
            sendingEmail: false,
        };
        return _this;
    }
    EmailInvitationForm.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("form", { className: "h-form" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "container" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__email_invitation__["a" /* EmailInvitation */], { content: this.props.content, status: this.state.status, email: this.state.control, onChange: this.onChange, onSendClick: this.onSubmit, submitting: this.props.submitting, sendingEmail: this.state.sendingEmail }))));
    };
    return EmailInvitationForm;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=email-invitation-form.js.map

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TravelCompanionLists; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cclr_huge_ui__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__guest_list_guest_list__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__link_managed_bookings_card__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__travel_companion_lists_css__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__travel_companion_lists_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__travel_companion_lists_css__);






var TravelCompanionLists = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(TravelCompanionLists, _super);
    function TravelCompanionLists(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function (e) {
            e.preventDefault();
            _this.setState({ error: null });
            _this.props.onLinkClick('default');
        };
        _this.renderOtherCompanions = function (otherCompanions) {
            var content = _this.props.content;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("hr", null),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row h-tc-guest-list" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__cclr_huge_ui__["Collapsible"], { id: "unmanaged-tc", collapsedTitle: content.additionalCruiseCompanions, collapsedTitleAriaLabel: content.additionalCruiseCompanionsCollapsedAriaLabel, expandedTitle: content.additionalCruiseCompanions, expandedTitleAriaLabel: content.additionalCruiseCompanionsExpandedAriaLabel, openOnInit: true, chevronColor: __WEBPACK_IMPORTED_MODULE_2__cclr_huge_ui__["Gray700Color"] },
                        content.removeAdditionalCompanionsLink && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "h-tc-unmanaged-span_action-link" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { className: "h-tc-unmanaged-card__action-link", href: "", id: "unmanaged-tc-remove", "aria-label": content.removeAdditionalCompanionsLink, role: "button", onClick: _this.onRemoveUnmanagedGuests },
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__cclr_huge_ui__["EditIcon"], { width: "14", height: "14", color: __WEBPACK_IMPORTED_MODULE_2__cclr_huge_ui__["BlueColor"], "aria-hidden": "true" }),
                                content.removeAdditionalCompanionsLink)),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-tc-guest-list__container" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__guest_list_guest_list__["a" /* GuestList */], { guests: otherCompanions, guestNameSub: content.guestNameWhenTba, showOnlyLastNameInitial: true }))))));
        };
        _this.renderManagedGuests = function () {
            var _a = _this.props, content = _a.content, guests = _a.guests, linkManagedBookingsEnabled = _a.linkManagedBookingsEnabled, submitting = _a.submitting, errorMessage = _a.errorMessage, linkingBookings = _a.linkingBookings;
            if (!content || !guests || guests.length === 0) {
                return null;
            }
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row h-tc-guest-list" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__cclr_huge_ui__["Collapsible"], { id: "managed-tc", collapsedTitle: content.yourManagedGuestsHeader, collapsedTitleAriaLabel: content.yourManagedGuestsCollapsedAriaLabel, expandedTitle: content.yourManagedGuestsHeader, expandedTitleAriaLabel: content.yourManagedGuestsExpandedAriaLabel, openOnInit: true, chevronColor: __WEBPACK_IMPORTED_MODULE_2__cclr_huge_ui__["Gray700Color"] },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-tc-guest-list__container" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__guest_list_guest_list__["a" /* GuestList */], { guests: guests, guestNameSub: content.guestNameWhenTba }),
                        linkManagedBookingsEnabled &&
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__link_managed_bookings_card__["a" /* LinkManagedBookingsCard */], { submitting: submitting, linkingBookings: linkingBookings, errorMessage: errorMessage, imgUrl: content.yourManagedBookingsNotLinkedIcon.src, title: content.yourManagedBookingsNotLinked, description: content.yourManagedBookingsNotLinkedDescription, buttonText: content.yourManagedBookingsNotLinkedButtonText, buttonAriaLabel: content.yourManagedBookingsNotLinkedButtonAriaLabel, onLinkClick: _this.handleClick })))));
        };
        _this.onRemoveUnmanagedGuests = function (event) {
            event.preventDefault();
            _this.setState({ error: null });
            _this.props.onRemoveLinkClick();
        };
        return _this;
    }
    TravelCompanionLists.prototype.render = function () {
        var _a = this.props, content = _a.content, otherCompanions = _a.otherCompanions;
        if (!content) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-tc-managed-guest-header" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-col-md h-tc-managed-guest-header__icon" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", { src: content.yourManagedGuestsIcon.src, alt: "" })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-col-md h-tc-managed-guest-header__description--container" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-tc-managed-guest-header__description", dangerouslySetInnerHTML: { __html: content.yourManagedGuestsDescription } }))),
            this.renderManagedGuests(),
            otherCompanions && otherCompanions.length > 0 && this.renderOtherCompanions(otherCompanions)));
    };
    return TravelCompanionLists;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=travel-companion-lists.js.map

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GuestList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__guest_list_row__ = __webpack_require__(803);


var GuestList = function (_a) {
    var guests = _a.guests, className = _a.className, maxColumns = _a.maxColumns, showOnlyLastNameInitial = _a.showOnlyLastNameInitial, guestNameSub = _a.guestNameSub;
    if (!guests || guests.length === 0) {
        return null;
    }
    var maxCol = maxColumns || 4;
    var rows = guests.map(function (_, i) {
        return i % maxCol === 0 ? guests.slice(i, i + maxCol) : null;
    }).filter(function (x) { return !!x; });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, rows.map(function (guestsRow, i) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__guest_list_row__["a" /* GuestListRow */], { key: i, guests: guestsRow, className: className, guestNameSub: guestNameSub, showOnlyLastNameInitial: showOnlyLastNameInitial })); })));
};
//# sourceMappingURL=guest-list.js.map

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TravelCompanionRemoveCard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatar_avatar__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modal_modal_shell__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__travel_companion_remove_confirm_modal__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__travel_companion_remove_card_css__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__travel_companion_remove_card_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__travel_companion_remove_card_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__guest_details_guest_form_scss__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__guest_details_guest_form_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__guest_details_guest_form_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common__ = __webpack_require__(119);










var TravelCompanionRemoveCard = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(TravelCompanionRemoveCard, _super);
    function TravelCompanionRemoveCard(props) {
        var _this = _super.call(this, props) || this;
        _this.createFormGroups = function () {
            var companions = _this.props.companions;
            var controls = companions.map(function (guest, index) {
                var model = _this.createGuestControlModel(guest, index);
                return Object(__WEBPACK_IMPORTED_MODULE_4__forms__["h" /* createControlGroup */])(model);
            });
            return controls;
        };
        _this.createGuestControlModel = function (g, index) {
            var guestName = _this.getGuestFullName(g, index);
            return Object(__WEBPACK_IMPORTED_MODULE_4__forms__["i" /* createControlModel */])({
                name: _this.getGuestControlName(index),
                props: {
                    guestName: guestName,
                    guest: g
                }
            });
        };
        _this.getGuestFullName = function (g, index) {
            if (g.firstName === 'TBA') {
                return _this.props.content.guestNameWhenTba + " " + (index + 1);
            }
            var fullName = g.firstName + " " + (g.lastName.slice(0, 1) + '.');
            return fullName;
        };
        _this.openConfirmModal = function (e) {
            _this.setState({ isConfirmModalOpen: true });
        };
        _this.onSaveRemove = function () {
            var onRemoveCompanions = _this.props.onRemoveCompanions;
            var removedCompanions = _this.state.removedCompanions;
            onRemoveCompanions(removedCompanions);
        };
        _this.onCancelRemove = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.props.onCancelRemove();
        };
        _this.handleControlValueChange = function (control) {
            _this.setState(function (prevState) {
                if (control.props != null && control.checked != null) {
                    var removedCompanions = prevState.removedCompanions;
                    _this.updateRemovedGuestList(removedCompanions, control);
                    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, prevState), { removedCompanions: removedCompanions });
                }
                return prevState;
            });
        };
        _this.closeConfirmModal = function () { return _this.setState({ isConfirmModalOpen: false }); };
        _this.state = {
            openModal: false,
            companions: props.companions,
            removedCompanions: [],
            controls: _this.createFormGroups(),
            isConfirmModalOpen: false,
        };
        _this.closeButtonRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.formContainerRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        return _this;
    }
    TravelCompanionRemoveCard.prototype.render = function () {
        var content = this.props.content;
        if (content == null) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__modal_modal_shell__["b" /* ModalShell */], { closeModalText: this.props.content.closeModal, closeButtonRef: this.closeButtonRef, onRequestClose: this.onCancelRemove, header: this.renderHeader(), footer: this.renderFooter(), shellClassName: "h-invoice-details-modal" }, this.renderBody()),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__travel_companion_remove_confirm_modal__["a" /* TravelCompanionRemoveConfirmModal */], { isOpen: this.state.isConfirmModalOpen, content: content, guests: this.getGuestToRemoveNames(), onConfirm: this.onSaveRemove, onCancel: this.closeConfirmModal })));
    };
    TravelCompanionRemoveCard.prototype.getGuestToRemoveNames = function () {
        return this.state.removedCompanions.map(function (g) { return g.firstName + " " + g.lastName; });
    };
    TravelCompanionRemoveCard.prototype.getGuestControlName = function (index) {
        return "remove-unmanage-guest-" + index;
    };
    TravelCompanionRemoveCard.prototype.renderBody = function () {
        var _this = this;
        var companions = this.props.companions;
        if (!companions || companions.length === 0) {
            return null;
        }
        var maxCol = 3;
        var controls = this.state.controls;
        var rows = controls.map(function (_, i) {
            return i % maxCol === 0 ? controls.slice(i, i + maxCol) : null;
        }).filter(function (x) { return !!x; });
        var guestIndex = 0;
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this.formContainerRef, className: "h-tc-guest-list__container" }, rows.map(function (controlsPerRow, i) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: i, className: "row h-guest-list__row" }, controlsPerRow === null || controlsPerRow === void 0 ? void 0 : controlsPerRow.map(function (guestControl, gi) {
                var control = guestControl.controls.get[_this.getGuestControlName(guestIndex)];
                if (control == null) {
                    return null;
                }
                guestIndex++;
                var propName = 'guestName';
                var guestName = control.props ? control.props[propName] : '';
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "d-flex h-guest-row" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["c" /* FormField */], { className: "h-form__field h-guest-list-item", controlModel: control, onFieldUpdate: _this.handleControlValueChange }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: i, className: "h-checkbox__container" },
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["a" /* Checkbox */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ "aria-label": guestName }, props.controlProps)),
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.labelProps))),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: i + "-" + gi, className: "h-guest-list-item" },
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__avatar_avatar__["a" /* Avatar */], { fullName: guestName, "aria-hidden": "true" }),
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-guest-list-name__container" },
                                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { "data-pii": "true", className: "h-guest-list-guest__name" }, guestName))))); }))));
            })))); }));
    };
    TravelCompanionRemoveCard.prototype.renderFooter = function () {
        var content = this.props.content;
        if (content == null) {
            return null;
        }
        var saveAriaLabel = Object(__WEBPACK_IMPORTED_MODULE_9__common__["a" /* listGuests */])(this.getGuestToRemoveNames(), content.saveButtonAriaLabel);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-sm-6 col-md-12 col-lg-auto h-bk-dtl-card__footer-actions" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__button_button__["a" /* Button */], { className: "h-bk-dtl-card__footer-action", color: "outline-black", onClick: this.onCancelRemove, "aria-label": content.cancelButtonAriaLabel }, content.cancelButton),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__button_button__["a" /* Button */], { className: "h-bk-dtl-card__footer-action", color: "red", disabled: this.state.removedCompanions.length === 0, onClick: this.openConfirmModal, "aria-label": saveAriaLabel }, content.saveButton))));
    };
    TravelCompanionRemoveCard.prototype.renderHeader = function () {
        var content = this.props.content;
        if (content == null) {
            return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h2", { className: __WEBPACK_IMPORTED_MODULE_5__modal_modal_shell__["a" /* ModalHeadingClassName */] }, content.removeAdditionalCompanionsHeader);
    };
    TravelCompanionRemoveCard.prototype.updateRemovedGuestList = function (removedCompanions, control) {
        var _this = this;
        var propName = 'guest';
        var guest = control.props[propName];
        var guestInListIndex = removedCompanions.findIndex(function (g) { return _this.isGuest(g, guest); });
        var shouldAdd = control.checked && guestInListIndex === -1;
        if (shouldAdd) {
            removedCompanions.push(guest);
        }
        else if (guestInListIndex !== -1) {
            removedCompanions.splice(guestInListIndex, 1);
        }
    };
    TravelCompanionRemoveCard.prototype.isGuest = function (g, guest) {
        return g.firstName === guest.firstName
            && g.lastName === guest.lastName
            && g.bookingNumber === guest.bookingNumber
            && g.sequenceNumber === guest.sequenceNumber;
    };
    return TravelCompanionRemoveCard;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=travel-companion-remove-card.js.map

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditBooking; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_tabs__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cclr_huge_ui__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stateroom_tabs_stateroom_tabs__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__edit_booking_tile__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__edit_booking_css__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__edit_booking_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__edit_booking_css__);







var EditBooking = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(EditBooking, _super);
    function EditBooking() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleContinue = function () {
            var _a = _this.props, bookingNumber = _a.bookingNumber, selectedAction = _a.selectedAction, onContinue = _a.onContinue;
            if (selectedAction) {
                onContinue(bookingNumber, selectedAction);
            }
        };
        _this.handleSelectBooking = function (bookingNumber) {
            _this.props.onSelectBooking(bookingNumber);
        };
        _this.handleFieldUpdate = function (control) {
            var _a = _this.props, stateroomEditOperations = _a.stateroomEditOperations, guestEditOperations = _a.guestEditOperations;
            if (!stateroomEditOperations) {
                return;
            }
            var action = stateroomEditOperations.find(function (a) { return a.operationType === control.value; })
                || (guestEditOperations === null || guestEditOperations === void 0 ? void 0 : guestEditOperations.find(function (a) { return a.operationType === control.value; }));
            _this.props.onSelectOperation(action);
        };
        _this.generateContinueButtonAriaLabel = function () {
            var _a;
            return (_this.props.content.continueButtonArialLabel || '')
                .replace('{BookingNumber}', _this.props.bookingNumber)
                .replace('{Description}', ((_a = _this.props.selectedAction) === null || _a === void 0 ? void 0 : _a.description) || '');
        };
        return _this;
    }
    EditBooking.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__cclr_huge_ui__["ModalShell"], { header: this.renderHeader(), footer: this.renderFooter(), onRequestClose: this.props.onClose, closeModalText: this.props.content.closeModalText, shellClassName: "h-edit-booking-modal" }, this.renderTabs()));
    };
    EditBooking.prototype.renderTabs = function () {
        var _this = this;
        var _a = this.props, activeSailing = _a.activeSailing, content = _a.content, bookingNumber = _a.bookingNumber;
        var bookings = activeSailing.bookings;
        var tabTitles = bookings.map(function (booking, index) {
            return {
                id: booking.bookingNumber,
                eyebrow: content.bookingNumberText + " " + booking.bookingNumber,
                title: content.stateroomNumberText + " " + (index + 1),
            };
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__stateroom_tabs_stateroom_tabs__["d" /* StateroomTabs */], { tabTitles: tabTitles, selectedId: bookingNumber, onSelect: this.handleSelectBooking }, bookings.map(function (booking) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_tabs__["c" /* TabPanel */], { key: booking.bookingNumber, className: __WEBPACK_IMPORTED_MODULE_4__stateroom_tabs_stateroom_tabs__["b" /* StateroomTabPanelClassName */], selectedClassName: __WEBPACK_IMPORTED_MODULE_4__stateroom_tabs_stateroom_tabs__["c" /* StateroomTabPanelSelectedClassName */] },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-edit row" },
                _this.renderEditBookingForm(content),
                _this.renderEditGuestForm(content),
                _this.renderUpdatesUnavailable(content)))); })));
    };
    EditBooking.prototype.renderUpdatesUnavailable = function (content) {
        var _a = this.props, activeSailing = _a.activeSailing, bookingNumber = _a.bookingNumber, guestEditOperations = _a.guestEditOperations, stateroomEditOperations = _a.stateroomEditOperations, loading = _a.loading;
        var booking = activeSailing.bookings.find(function (b) { return b.bookingNumber === bookingNumber; });
        if ((guestEditOperations === null || guestEditOperations === void 0 ? void 0 : guestEditOperations.length) === 0 && (stateroomEditOperations === null || stateroomEditOperations === void 0 ? void 0 : stateroomEditOperations.length) === 0) {
            if (booking === null || booking === void 0 ? void 0 : booking.isAgencyBooking) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-edit__busy-container" }, content.travelAgencyUnavailableMessage));
            }
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null, !loading && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-edit__busy-container" }, content.noUpdatesAvailable)));
        }
        return null;
    };
    EditBooking.prototype.renderEditBookingForm = function (content) {
        var _this = this;
        var _a = this.props, stateroomEditOperations = _a.stateroomEditOperations, loading = _a.loading;
        if (loading) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-edit__busy-container" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__cclr_huge_ui__["SpinnerIcon"], { color: __WEBPACK_IMPORTED_MODULE_3__cclr_huge_ui__["BlueColor"], width: 32, height: 32 })));
        }
        if (!stateroomEditOperations || stateroomEditOperations.length === 0) {
            return null;
        }
        var selectedAction = this.props.selectedAction;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-edit--column col", role: "radiogroup" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h4", { className: "h-booking-edit-section__title" }, content.stateroomSectionText),
            stateroomEditOperations.map(function (action, i) {
                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__edit_booking_tile__["a" /* EditBookingTile */], { key: i, editAction: action, onFieldUpdate: _this.handleFieldUpdate, editBookingModel: Object(__WEBPACK_IMPORTED_MODULE_3__cclr_huge_ui__["createControlModel"])({
                        name: 'edit-booking',
                        value: selectedAction === null || selectedAction === void 0 ? void 0 : selectedAction.operationType,
                        checked: true
                    }) });
            })));
    };
    EditBooking.prototype.renderEditGuestForm = function (content) {
        var _this = this;
        var guestEditOperations = this.props.guestEditOperations;
        if (!this.props.bookingNumber || !guestEditOperations || guestEditOperations.length === 0) {
            return null;
        }
        var selectedAction = this.props.selectedAction;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-edit--column col" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h4", { className: "h-booking-edit-section__title" }, content.guestSectionText),
            guestEditOperations.map(function (action, i) {
                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__edit_booking_tile__["a" /* EditBookingTile */], { key: i, editAction: action, onFieldUpdate: _this.handleFieldUpdate, editBookingModel: Object(__WEBPACK_IMPORTED_MODULE_3__cclr_huge_ui__["createControlModel"])({
                        name: 'edit-guest',
                        value: selectedAction === null || selectedAction === void 0 ? void 0 : selectedAction.operationType,
                        checked: true
                    }) });
            })));
    };
    EditBooking.prototype.renderHeader = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h2", { className: __WEBPACK_IMPORTED_MODULE_3__cclr_huge_ui__["ModalHeadingClassName"] }, this.props.content.modalTitle),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { className: "h-booking-edit-modal--description" }, this.props.content.modalDescription)));
    };
    EditBooking.prototype.renderFooter = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__cclr_huge_ui__["Button"], { color: "red", type: "button", className: "h-btn--min-width", onClick: this.handleContinue, "aria-label": this.generateContinueButtonAriaLabel(), disabled: !this.props.selectedAction }, this.props.content.continueText));
    };
    return EditBooking;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=edit-booking.js.map

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditBookingTile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms__ = __webpack_require__(10);



var EditBookingTile = function (_a) {
    var editAction = _a.editAction, editBookingModel = _a.editBookingModel, onFieldUpdate = _a.onFieldUpdate;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-tile--container" },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms__["c" /* FormField */], { controlModel: editBookingModel, onFieldUpdate: onFieldUpdate }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms__["f" /* Radio */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, Object(__WEBPACK_IMPORTED_MODULE_2__forms__["k" /* radioControlProps */])(props.controlProps, editAction.operationType, editAction.operationType), { role: "radio" })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, Object(__WEBPACK_IMPORTED_MODULE_2__forms__["l" /* radioLabelProps */])(props.labelProps, editAction.operationType)), editAction.description))); })));
};
//# sourceMappingURL=edit-booking-tile.js.map

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewCancellationInfoModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_colors__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icons__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modal_modal_shell__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__view_cancellation_info_modal_css__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__view_cancellation_info_modal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__view_cancellation_info_modal_css__);







var ViewCancellationInfoModal = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(ViewCancellationInfoModal, _super);
    function ViewCancellationInfoModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            submitting: false,
            bookingCancelled: false,
            pendingInfo: false,
            errors: null,
            data: null,
            fetchingErrors: false
        };
        _this.fetchData = function () {
            _this.setState({ pendingInfo: true });
            _this.props.fetchCancellationInfo()
                .then(function (result) { return _this.setState({ data: result, pendingInfo: false, errors: null }); })
                .catch(function (e) { return _this.onActionError(e, true); });
        };
        _this.onActionError = function (apiError, fetchingError) {
            if (apiError.details) {
                _this.setState({
                    pendingInfo: false,
                    submitting: false,
                    fetchingErrors: fetchingError,
                    errors: apiError.details.map(function (n) { return n.message; }),
                });
            }
            else if (apiError.message) {
                _this.setState({
                    pendingInfo: false,
                    submitting: false,
                    fetchingErrors: fetchingError,
                    errors: [apiError.message],
                });
            }
            else {
                _this.setState({
                    pendingInfo: false,
                    submitting: false,
                    fetchingErrors: fetchingError,
                    errors: [_this.props.content.errorFetchingData],
                });
            }
        };
        _this.renderInfo = function () {
            var _a = _this.props, content = _a.content, sailBaseCurrency = _a.sailBaseCurrency, bookingNumber = _a.bookingNumber, sailing = _a.sailing;
            var _b = _this.state, pendingInfo = _b.pendingInfo, errors = _b.errors, data = _b.data, submitting = _b.submitting, bookingCancelled = _b.bookingCancelled;
            if (pendingInfo) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-ccm-info__busy-container" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__icons__["SpinnerIcon"], { color: __WEBPACK_IMPORTED_MODULE_2__styles_colors__["c" /* BlueColor */], width: 32, height: 32 })));
            }
            if (bookingCancelled) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h5", { "aria-live": "assertive", role: "alert", className: "h-ccm-booking__title" }, content.yourBookingHasBeenCancelled),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", null, content.enjoyTheFunAnotherTime)));
            }
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                data && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", null, _this.renderBookingInfo(content, sailing, bookingNumber) + " " + content.cancellationPenaltyInfo + " ",
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "h-cancellation-info__penalty-amount" }, data.penaltyAmountFormatted),
                    ".")),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-cancellation-info__actions" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { className: "h-cancellation-info__action", target: "_blank", href: sailBaseCurrency === 'AUD' ? content.cancellationFaqsLinkAu : content.cancellationFaqsLink, "aria-label": content.readCancellationFaqsAriaLabel }, content.readCancellationFaqs)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null, (errors && errors.length > 0 && !submitting && !bookingCancelled) &&
                    errors.map(function (error, index) { return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { key: index }, error); }))));
        };
        _this.onClose = function (event) {
            event.preventDefault();
            if (_this.state.bookingCancelled) {
                _this.props.onCloseWithSuccess();
            }
            else {
                _this.props.onAbort();
            }
        };
        _this.onAbort = function (event) {
            event.preventDefault();
            _this.props.onAbort();
        };
        _this.onCancelBooking = function (event) {
            event.preventDefault();
            _this.setState({ submitting: true });
            _this.props.cancelBooking()
                .then(_this.onSuccess)
                .catch(function (e) { return _this.onActionError(e, true); });
        };
        _this.onSuccess = function () {
            _this.setState({ submitting: false, bookingCancelled: true });
        };
        _this.renderBookingInfo = function (content, sailing, bookingNumber) {
            if (!content.bookingInfoText || !sailing.itinerary || !sailing.itinerary.itineraryTitle) {
                return '';
            }
            return content.bookingInfoText.replace('{bookingNumber}', bookingNumber)
                .replace('{itineraryTitle}', sailing.itinerary.itineraryTitle);
        };
        return _this;
    }
    ViewCancellationInfoModal.prototype.componentDidMount = function () {
        this.fetchData();
    };
    ViewCancellationInfoModal.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__modal_modal_shell__["b" /* ModalShell */], { header: this.renderHeader(), footer: this.renderFooter(), onRequestClose: this.onClose, closeModalText: this.props.content.abortButton }, this.renderInfo()));
    };
    ViewCancellationInfoModal.prototype.renderFooter = function () {
        var bookingCancelled = this.state.bookingCancelled;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-ccm-shell__footer" }, bookingCancelled ? this.renderSuccess() : this.renderConfirm()));
    };
    ViewCancellationInfoModal.prototype.renderConfirm = function () {
        var content = this.props.content;
        var _a = this.state, submitting = _a.submitting, fetchingErrors = _a.fetchingErrors;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-ccm-booking__actions" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__button_button__["a" /* Button */], { className: "h-ccm-booking__button", color: "outline-black", onClick: this.onCancelBooking, disabled: submitting || fetchingErrors, busy: submitting }, content.cancelButton),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__button_button__["a" /* Button */], { className: "h-ccm-booking__button", color: "red", onClick: this.onAbort, disabled: submitting }, content.abortButton)));
    };
    ViewCancellationInfoModal.prototype.renderSuccess = function () {
        var content = this.props.content;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-ccm-booking__actions" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__button_button__["b" /* LinkButton */], { className: "h-ccm-booking__button-close", color: "red", href: "", onClick: this.onClose }, content.closeDialog))));
    };
    ViewCancellationInfoModal.prototype.renderHeader = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h2", { className: __WEBPACK_IMPORTED_MODULE_5__modal_modal_shell__["a" /* ModalHeadingClassName */] }, this.props.content.cancelThisBooking)));
    };
    return ViewCancellationInfoModal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=view-cancellation-info-modal.js.map

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GuestActionConfirmation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_modal_shell__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__guest_action_confirmation_css__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__guest_action_confirmation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__guest_action_confirmation_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icons__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cclr_huge_ui__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__invoice_details_payment_info__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__invoice_details_common__ = __webpack_require__(45);








var GuestActionConfirmation = function (props) {
    var content = props.content, sailing = props.sailing, bookingNumber = props.bookingNumber, sequenceNumber = props.sequenceNumber, invoice = props.invoice, showGuestPricing = props.showGuestPricing, guestsAffected = props.guestsAffected, advisories = props.advisories;
    var booking = sailing.bookings.find(function (b) { return b.bookingNumber === bookingNumber; });
    var closeButtonRef = __WEBPACK_IMPORTED_MODULE_0_react__["createRef"]();
    var _a = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), isPricingDetailsOpen = _a[0], setIsPricingDetailsOpen = _a[1];
    var _b = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](true), showAdvisories = _b[0], setShowAdvisories = _b[1];
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () { return setShowAdvisories(true); }, [advisories]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__modal_modal_shell__["b" /* ModalShell */], { header: renderHeader(), footer: renderFooter(), onRequestClose: props.onClose, closeModalText: content === null || content === void 0 ? void 0 : content.modaCloseButtonText, closeButtonRef: closeButtonRef, notification: renderNotifications(), shellClassName: "h-guest-action-modal" }, renderBody()));
    function renderBody() {
        if (!booking || !content || !invoice) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-booking-edit__busy-container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__icons__["SpinnerIcon"], { color: __WEBPACK_IMPORTED_MODULE_5__cclr_huge_ui__["BlueColor"], width: 32, height: 32 })));
        }
        var guestListMessage = content.affectedGuestListMessage.replace('{sailing}', props.sailing.itinerary.itineraryTitle);
        var mainMessage = content.confirmationMessage.replace('{bookingNumber}', booking.bookingNumber)
            .replace('{email}', booking.guests[0].email || '');
        var backgroundImage = content.confettiImage
            ? { backgroundImage: "url(" + content.confettiImage.src + ")" }
            : undefined;
        var paymentDue = Object(__WEBPACK_IMPORTED_MODULE_7__invoice_details_common__["b" /* getPaymentDue */])(invoice);
        var paymentLine = paymentDue && paymentDue.amountFormatted
            ? content.confirmationBalance.replace('{dueDate}', paymentDue.dueByDateFormatted)
            : undefined;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-guest-action__body", style: backgroundImage },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "h-guest-action__header" }, content.confirmationHeader),
            guestsAffected &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-affected-guest__container" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-affected-guest__header" }, guestListMessage),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-affected-guest-list" }, guestsAffected.map(function (guest) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { key: guest.seqNumber },
                        "- ",
                        guest.guestName,
                        "."); }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-guest-action-payment-due" }, paymentLine),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-guest-action__message", dangerouslySetInnerHTML: { __html: mainMessage } })));
    }
    function renderFooter() {
        if (!content) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row h-guest-action__footer" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-guest-action__balance" }, invoice && renderPricing()),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-guest-action-modal__buttons" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-guest-action-modal__button" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__button_button__["a" /* Button */], { color: "outline-black", type: "button", className: "h-btn--min-width", onClick: props.onEditAnotherBooking, "aria-label": content.editAnotherBooking }, content.editAnotherBooking)),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-guest-action-modal__button" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__button_button__["a" /* Button */], { color: "red", type: "button", className: "h-btn--min-width", onClick: props.onViewBalanceDetails, "aria-label": content.viewInvoiceDetails }, content.viewInvoiceDetails)))));
    }
    function renderHeader() {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, content &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: __WEBPACK_IMPORTED_MODULE_1__modal_modal_shell__["a" /* ModalHeadingClassName */] },
                " ",
                content.modalHeaderText)));
    }
    function togglePricingDetails(e) {
        e.preventDefault();
        setIsPricingDetailsOpen(!isPricingDetailsOpen);
    }
    function getPricing() {
        if (!invoice) {
            return null;
        }
        var guestPricing = invoice.guests.find(function (g) { return g.seqNumber === sequenceNumber; })
            || invoice.guests[invoice.guests.length - 1];
        return showGuestPricing
            ? {
                cruiseRateFormatted: guestPricing.cruiseRateAmountFormatted,
                taxesAndFeesFormatted: guestPricing.taxesAndFeesFormatted,
                otherFeesFormatted: guestPricing.otherFeesFormatted
            }
            : {
                cruiseRateFormatted: invoice.totalCruiseRateAmountFormatted,
                taxesAndFeesFormatted: invoice.totalTaxesAndFeesFormatted,
                otherFeesFormatted: invoice.totalOtherFeesFormatted
            };
    }
    function renderPricing() {
        var arrowDirection = isPricingDetailsOpen ? 'up' : 'down';
        var pricing = getPricing();
        if (!pricing || !content) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-guest-pricing-details" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-guest-action__balance row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__invoice_details_payment_info__["a" /* PaymentInfo */], { invoice: invoice, balanceDueLabel: content.balanceDueLabel, depositDueLabel: content.depositDueLabel, paidInFullLabel: content.paidInFullLabel, installmentsScheduledLabel: content.installmentsScheduledLabel })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "", className: "h-pricing-info__open-info-link", onClick: togglePricingDetails },
                        content.confirmationViewDetails,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__cclr_huge_ui__["Chevron"], { className: "h-pricing-info__open-info-link__arrow", color: __WEBPACK_IMPORTED_MODULE_5__cclr_huge_ui__["BlueColor"], size: 18, direction: arrowDirection }))),
                isPricingDetailsOpen && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-pricing-info__details" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-pricing-row row" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-pricing-row__title" }, content.additionalCostPerGuestAction),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-pricing-row__amount" }, pricing.cruiseRateFormatted)),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-pricing-row row" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-pricing-row__title" }, content.taxesAndFees),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-pricing-row__amount" }, pricing.taxesAndFeesFormatted)),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-pricing-row row" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-pricing-row__title" }, content.otherFees),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-pricing-row__amount" }, pricing.otherFeesFormatted))))));
    }
    function handleOnCloseNotificationGroup() {
        setShowAdvisories(false);
    }
    function renderNotifications() {
        if (!content) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, showAdvisories && advisories && (advisories === null || advisories === void 0 ? void 0 : advisories.length) &&
            advisories.map(function (adv, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: index, "aria-live": "assertive", role: "alert" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__cclr_huge_ui__["Notification"], { type: "info", mode: "edge", closeMode: "manual", closeAriaLabel: content.autoCloseNotificationAriaLabel, onClose: handleOnCloseNotificationGroup }, adv.message))); })));
    }
};
//# sourceMappingURL=guest-action-confirmation.js.map

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RemoveGuestItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms__ = __webpack_require__(10);



var RemoveGuestItem = function (props) {
    var guestControl = props.guestControl, submitting = props.submitting, onSelectGuestChanged = props.onSelectGuestChanged;
    var controlModel = guestControl.controlGroup.controls.get.seqNumber;
    var onValueChange = function (model) { return onSelectGuestChanged(guestControl, model); };
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row h-cvp-guest-request__list-item" },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-md h-cvp-guest-request__col" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms__["c" /* FormField */], { key: guestControl.seqNumber, controlModel: controlModel, onFieldUpdate: onValueChange }, function (otherprops) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms__["a" /* Checkbox */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ disabled: guestControl.disabled || submitting }, otherprops.controlProps)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ "data-pii": "true" }, otherprops.labelProps), guestControl.guestName))); }))));
};
//# sourceMappingURL=remove-guest-item.js.map

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Error; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* eslint-disable */
var Error = function Error() {
    return '';
};

/***/ }),
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_todoPlanner_TodoPlanner__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_scrollToTop_ScrollToTop__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_alertsContainer_AlertsContainer__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__serviceWorker__ = __webpack_require__(842);








/* eslint-disable */
if (document.getElementById('todoPlanner')) {
  __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_todoPlanner_TodoPlanner__["a" /* TodoPlanner */], null), document.getElementById('todoPlanner'));
}

if (document.getElementById('scrollToTop-CCL')) {
  __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_scrollToTop_ScrollToTop__["a" /* default */], null), document.getElementById('scrollToTop-CCL'));
}

if (document.getElementById('CCL_alertContainer_react')) {
  __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_alertsContainer_AlertsContainer__["a" /* default */], null), document.getElementById('CCL_alertContainer_react'));
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
__WEBPACK_IMPORTED_MODULE_6__serviceWorker__["a" /* unregister */]();

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(178),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(178),r=__webpack_require__(397);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(398);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TodoPlanner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_cclr_booked__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_cclr_huge_ui__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__error__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__todoPlanner_scss__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__todoPlanner_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__todoPlanner_scss__);












/* eslint-disable */
var TodoPlanner = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TodoPlanner, _Component);

  function TodoPlanner(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TodoPlanner);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TodoPlanner.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(TodoPlanner)).call(this, props));

    _this.state = { sailDate: "", shipCode: "" };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TodoPlanner, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if ($('#sailDate').length >= 0) {
        var currentSailDate = $('#sailDate')[0].value;
        var currentShipCode = $('#shipCode')[0].value;
        this.setState({
          sailDate: currentSailDate,
          shipCode: currentShipCode
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.sailDate && this.state.shipCode) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_cclr_booked__["ParametersSailingProvider"],
          {
            sailDate: this.state.sailDate,
            shipCode: this.state.shipCode,
            renderLoading: function renderLoading() {
              return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_cclr_huge_ui__["Spinner"], null);
            },
            renderError: function renderError() {
              return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__error__["a" /* Error */], null);
            }
          },
          function (sailing, sailings) {
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'div',
              { className: 'home-container' },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'section',
                { className: 'home-sidebar' },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_cclr_booked__["ToDosContainer"], {
                  sailing: sailing,
                  isCompactMode: true,
                  expandedMobileMode: false
                }),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_cclr_booked__["CompactItineraryCalendarContainer"], {
                  shipCode: sailing.itinerary.shipCode,
                  sailDate: sailing.itinerary.sailDate
                })
              )
            );
          }
        );
      } else {
        return null;
      }
    }
  }]);

  return TodoPlanner;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(402);
module.exports = __webpack_require__(8).Object.getPrototypeOf;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(28);
var $getPrototypeOf = __webpack_require__(99);

__webpack_require__(141)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(404), __esModule: true };

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(405);
var $Object = __webpack_require__(8).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(15);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(18), 'Object', { defineProperty: __webpack_require__(17).f });


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(407), __esModule: true };

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(408);
module.exports = __webpack_require__(8).Object.setPrototypeOf;


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(15);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(409).set });


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(20);
var anObject = __webpack_require__(22);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(27)(Function.call, __webpack_require__(102).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(411), __esModule: true };

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(412);
var $Object = __webpack_require__(8).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(15);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(55) });


/***/ }),
/* 413 */
/***/ (function(module, exports) {

//# sourceMappingURL=api-models.js.map

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cclFetch;
/* unused harmony export cclFetchRaw */
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
function handleNetworkError() {
    var error = { code: 'NetworkError', message: 'There is a network issue and your request could not be processed.' };
    throw error;
}
function isJSONResponse(response) {
    if (!response) {
        return false;
    }
    return response.headers.has('Content-Type') && response.headers.get('Content-Type').indexOf('application/json') > -1;
}
function handleResponseStatus(response) {
    var isJSON = isJSONResponse(response);
    if (response.ok) {
        return isJSON ? response.json() : response.text();
    }
    if (isJSON) {
        return response.json().then(function (apiError) {
            throw apiError;
        });
    }
    var error = { code: 'ServerError', message: 'We couldn\'t process your request. Please try again or call us at 1.800.764.7419.', response: response };
    throw error;
}
function cclFetch(input, init) {
    var credentials = 'include';
    var initWithCredentials = __assign({ credentials: credentials }, init);
    return fetch(input, initWithCredentials)
        .catch(handleNetworkError)
        .then(function (response) { return handleResponseStatus(response); });
}
function cclFetchRaw(input, init) {
    var credentials = 'include';
    var initWithCredentials = __assign({ credentials: credentials }, init);
    return fetch(input, initWithCredentials)
        .catch(handleNetworkError)
        .then(function (response) { return handleResponseStatus(response).then(function (data) { return ({ data: data, response: response }); }); });
}
//# sourceMappingURL=ccl-fetch.js.map

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loadJS;
function loadJS(src, cb, attrs) {
    var ref = document.getElementsByTagName('script')[0];
    var script = document.createElement('script');
    script.src = src;
    script.async = true;
    if (attrs && attrs.id) {
        script.id = attrs.id;
    }
    ref.parentNode.insertBefore(script, ref);
    if (cb && typeof (cb) === 'function') {
        script.onload = cb;
    }
    return script;
}
//# sourceMappingURL=load-js.js.map

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loadCSS */
function loadCSS(href) {
    var ss = document.createElement('link');
    ss.rel = 'stylesheet';
    ss.href = href;
    document.getElementsByTagName('head')[0].appendChild(ss);
}
//# sourceMappingURL=load-css.js.map

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export dispatchEvent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__custom_event_polyfill__ = __webpack_require__(418);

function dispatchEvent(eventName, data) {
    Object(__WEBPACK_IMPORTED_MODULE_0__custom_event_polyfill__["a" /* applyCustomEventPolyfill */])();
    var event = new CustomEvent(eventName, {
        detail: data,
    });
    document.dispatchEvent(event);
}
//# sourceMappingURL=dispatchEvent.js.map

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyCustomEventPolyfill;
// tslint:disable
function applyCustomEventPolyfill() {
    if (typeof window['CustomEvent'] === 'function') {
        return;
    }
    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }
    CustomEvent.prototype = window['Event'].prototype;
    window['CustomEvent'] = CustomEvent;
}
//# sourceMappingURL=custom-event-polyfill.js.map

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["sanitizeUri"] = sanitizeUri;
/* harmony export (immutable) */ __webpack_exports__["isValidUri"] = isValidUri;
/* harmony export (immutable) */ __webpack_exports__["sanitizeUriComponent"] = sanitizeUriComponent;
/* harmony export (immutable) */ __webpack_exports__["isValidUriComponent"] = isValidUriComponent;
/* harmony export (immutable) */ __webpack_exports__["sanitizeAlphaNumeric"] = sanitizeAlphaNumeric;
/* harmony export (immutable) */ __webpack_exports__["isAlphaNumeric"] = isAlphaNumeric;
/* harmony export (immutable) */ __webpack_exports__["sanitizeNumeric"] = sanitizeNumeric;
/* harmony export (immutable) */ __webpack_exports__["isNumeric"] = isNumeric;
var URI_INVALID_CHARS = /[^-A-Za-z0-9+&@#/%?=~_|!:,.;\(\)\*']/gi;
var URI_COMPONENT_INVALID_CHARS = /[^-A-Za-z0-9~_!.\(\)~\*']/gi;
var ALPHANUMERIC_INVALID_CHARS = /[^A-Za-z0-9]/gi;
var NUMERIC_INVALID_CHARS = /[^0-9]/gi;
function trimInvalidChars(invalidChars, value) {
    return value.replace(invalidChars, "");
}
function isUriEncoded(value) {
    value = value || "";
    try {
        return value !== decodeURI(value);
    }
    catch (error) {
        return false;
    }
}
function isUriComponentEncoded(value) {
    value = value || "";
    try {
        return value !== decodeURIComponent(value);
    }
    catch (error) {
        return false;
    }
}
function sanitize(value, regexInvalidChars) {
    if (!value)
        return "";
    if (isUriComponentEncoded(value)) {
        value = decodeURIComponent(value);
        value = trimInvalidChars(regexInvalidChars, value);
        return encodeURIComponent(value);
    }
    return trimInvalidChars(regexInvalidChars, value);
}
function sanitizeUri(value) {
    if (!value)
        return "";
    if (isUriEncoded(value)) {
        value = decodeURI(value);
        value = trimInvalidChars(URI_INVALID_CHARS, value);
        return encodeURI(value);
    }
    return trimInvalidChars(URI_INVALID_CHARS, value);
}
function isValidUri(value) {
    if (!value)
        return true;
    var sanitized = sanitizeUri(value);
    return value == sanitized;
}
function sanitizeUriComponent(value) {
    return sanitize(value, URI_COMPONENT_INVALID_CHARS);
}
function isValidUriComponent(value) {
    if (!value)
        return true;
    var sanitized = sanitizeUriComponent(value);
    return value == sanitized;
}
function sanitizeAlphaNumeric(value) {
    return sanitize(value, ALPHANUMERIC_INVALID_CHARS);
}
function isAlphaNumeric(value) {
    if (!value)
        return true;
    var sanitized = sanitizeAlphaNumeric(value);
    return value == sanitized;
}
function sanitizeNumeric(value) {
    return sanitize(value, NUMERIC_INVALID_CHARS);
}
function isNumeric(value) {
    if (!value)
        return true;
    var sanitized = sanitizeNumeric(value);
    return value == sanitized;
}
//# sourceMappingURL=input-validation.js.map

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CurrencySourceEnum */
/* unused harmony export LocalityService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__local_storage_service__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cookies_service__ = __webpack_require__(182);


var locality;
var currencies;
var CurrencySourceEnum;
(function (CurrencySourceEnum) {
    CurrencySourceEnum["URL"] = "Url";
    CurrencySourceEnum["LOCAL_STORAGE"] = "LocalStorage";
    CurrencySourceEnum["COOKIE"] = "Cookie";
    CurrencySourceEnum["SERVER"] = "Server";
})(CurrencySourceEnum || (CurrencySourceEnum = {}));
var CURRENCY_KEY = 'SelectedCurrency';
function initialize(data) {
    if (!data) {
        return;
    }
    locality = data.locality;
    currencies = data.currencies;
}
function getLocality() {
    return locality;
}
function getCurrency() {
    return getCurrencyFromUrl() || getCurrencyFromLocalStorage() || getCurrencyFromCookie() || getCurrencyFromInitialData();
}
function setCurrency(currency) {
    if (!currency || !currency.code) {
        return;
    }
    if (__WEBPACK_IMPORTED_MODULE_0__local_storage_service__["a" /* LocalStorageService */].isSupported) {
        __WEBPACK_IMPORTED_MODULE_0__local_storage_service__["a" /* LocalStorageService */].set(CURRENCY_KEY, currency);
    }
    else {
        var currencyStr = JSON.stringify(currency);
        __WEBPACK_IMPORTED_MODULE_1__cookies_service__["a" /* CookieService */].set(CURRENCY_KEY, currencyStr, {
            path: '/'
        });
    }
    window.location.reload();
}
function getCurrencyFromUrl() {
    var urlCurrency = getUrlParameter('currency');
    if (!urlCurrency) {
        return null;
    }
    var currencyCode = currencies.find(function (currency) { return currency.toLowerCase() === urlCurrency.toLowerCase(); });
    if (!currencyCode) {
        return null;
    }
    return {
        code: currencyCode,
        source: CurrencySourceEnum.URL
    };
}
function getCurrencyFromLocalStorage() {
    if (!__WEBPACK_IMPORTED_MODULE_0__local_storage_service__["a" /* LocalStorageService */].isSupported) {
        return null;
    }
    var currencyDto = __WEBPACK_IMPORTED_MODULE_0__local_storage_service__["a" /* LocalStorageService */].get(CURRENCY_KEY);
    if (currencyDto) {
        currencyDto.source = CurrencySourceEnum.LOCAL_STORAGE;
    }
    return currencyDto;
}
function getCurrencyFromCookie() {
    var currencyDto = __WEBPACK_IMPORTED_MODULE_1__cookies_service__["a" /* CookieService */].getJSON(CURRENCY_KEY) || null;
    if (currencyDto) {
        currencyDto.source = CurrencySourceEnum.COOKIE;
    }
    return currencyDto;
}
function getCurrencyFromInitialData() {
    if (!currencies || !currencies.length) {
        return null;
    }
    return {
        code: currencies[0],
        source: CurrencySourceEnum.SERVER
    };
}
function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}
var LocalityService = {
    initialize: initialize,
    getLocality: getLocality,
    getCurrency: getCurrency,
    setCurrency: setCurrency
};
//# sourceMappingURL=locality-service.js.map

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["identifyUser"] = identifyUser;
/* harmony export (immutable) */ __webpack_exports__["reportError"] = reportError;
/* harmony export (immutable) */ __webpack_exports__["sendSessionProperties"] = sendSessionProperties;
function identifyUser(identifier) {
    if (dtrum) {
        dtrum.identifyUser(identifier);
    }
}
function reportError(error) {
    if (dtrum) {
        dtrum.reportError(error);
    }
}
function sendSessionProperties(data) {
    if (dtrum) {
        var obj = {};
        for (var prop in data) {
            var value = data[prop];
            if (value !== undefined && value !== null) {
                obj[prop] = value.toString();
                if (obj[prop].length > 100) {
                    obj[prop] = obj[prop].substring(0, 100);
                }
            }
        }
        dtrum.sendSessionProperties(null, null, obj);
    }
}
//# sourceMappingURL=dynatrace-api.js.map

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getOrFetch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ccl_utilities__ = __webpack_require__(63);

var cache = {};
function getOrFetch(input, init) {
    if (typeof input !== 'string') {
        return Object(__WEBPACK_IMPORTED_MODULE_0_ccl_utilities__["a" /* cclFetch */])(input, init);
    }
    var key = input;
    if (!cache[key] || ((Date.now() - cache[key].timestamp) / 1000) > 60) {
        cache[key] = {
            timestamp: Date.now(),
            promise: Object(__WEBPACK_IMPORTED_MODULE_0_ccl_utilities__["a" /* cclFetch */])(input, init),
        };
    }
    return cache[key].promise;
}
//# sourceMappingURL=network-cache.js.map

/***/ }),
/* 423 */
/***/ (function(module, exports) {

//# sourceMappingURL=sailing-provider-props.js.map

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ParametersSailingProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ccl_utilities__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_initial_data_service__ = __webpack_require__(91);




var ParametersSailingProvider = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(ParametersSailingProvider, _super);
    function ParametersSailingProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            sailing: null,
            sailings: null,
            pending: true,
        };
        _this.fetchInitialData = function () {
            // tslint:disable-next-line:no-any
            var win = window;
            if (!win.cclBookedApiPromise) {
                win.cclBookedApiPromise = _this.fetchData();
            }
            return win.cclBookedApiPromise.then(function (results) {
                var sailing = results.sailing, sailings = results.sailings;
                _this.setState({
                    pending: false,
                    sailing: sailing,
                    sailings: sailings,
                }, _this.props.onLoaded);
            }).catch(function (e) {
                _this.setState({
                    pending: false,
                    sailing: null,
                    sailings: null
                });
            });
        };
        _this.fetchData = function () {
            var _a = _this.props, sailDate = _a.sailDate, shipCode = _a.shipCode;
            var pathname = window.location.pathname;
            if (pathname === '/booked/home') {
                return Object(__WEBPACK_IMPORTED_MODULE_2_ccl_utilities__["a" /* cclFetch */])("/booked/api/v1.0/app/home?shipCode=" + encodeURIComponent(shipCode) + "&sailDate=" + encodeURIComponent(sailDate)).then(function (results) {
                    Object(__WEBPACK_IMPORTED_MODULE_3__common_initial_data_service__["b" /* populateInitialData */])(results);
                    return results;
                });
            }
            return Promise.all([
                _this.fetchSailingData(),
                _this.fetchSailingsData(),
            ]).then(function (results) {
                var sailing = results[0], sailings = results[1];
                return { sailing: sailing, sailings: sailings };
            });
        };
        _this.fetchSailingData = function () {
            var _a = _this.props, sailDate = _a.sailDate, shipCode = _a.shipCode;
            var sailingUrl = "/booked/api/v1.0/Bookings/Sailing?shipCode=" + encodeURIComponent(shipCode) + "&sailDate=" + encodeURIComponent(sailDate);
            return Object(__WEBPACK_IMPORTED_MODULE_2_ccl_utilities__["a" /* cclFetch */])(sailingUrl);
        };
        _this.fetchSailingsData = function () {
            var sailingsUrl = '/booked/api/v1.0/Bookings/Sailings';
            return Object(__WEBPACK_IMPORTED_MODULE_2_ccl_utilities__["a" /* cclFetch */])(sailingsUrl);
        };
        return _this;
    }
    ParametersSailingProvider.prototype.componentDidMount = function () {
        this.fetchInitialData();
    };
    ParametersSailingProvider.prototype.render = function () {
        var _a = this.state, pending = _a.pending, sailing = _a.sailing, sailings = _a.sailings;
        var _b = this.props, children = _b.children, renderLoading = _b.renderLoading, renderError = _b.renderError;
        if (pending) {
            return renderLoading();
        }
        if (!sailing || !sailings) {
            return renderError();
        }
        return children(sailing, sailings);
    };
    return ParametersSailingProvider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=parameters-sailing-provider.js.map

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompactItineraryCalendarContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cclr_huge_ui_dist_src_components_itinerary_calendar_compact_itinerary_calendar__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_content_service__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__itinerary_calendar_service__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_cclr_huge_ui_dist_src_styles_breakpoints__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_cclr_huge_ui_dist_src_components_spinner_spinner__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_cclr_huge_ui_dist_src_components_media_query_media_query__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_cclr_huge_ui_dist_src_components_collapsible_collapsible__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__compact_itinerary_calendar_container_css__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__compact_itinerary_calendar_container_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__compact_itinerary_calendar_container_css__);










var CompactItineraryCalendarContainer = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(CompactItineraryCalendarContainer, _super);
    function CompactItineraryCalendarContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            calendar: null,
            content: null,
            pending: false,
        };
        return _this;
    }
    CompactItineraryCalendarContainer.prototype.componentDidMount = function () {
        this.fetchData();
    };
    CompactItineraryCalendarContainer.prototype.render = function () {
        var _a = this.state, pending = _a.pending, calendar = _a.calendar, content = _a.content;
        if (pending) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_cclr_huge_ui_dist_src_components_spinner_spinner__["a" /* Spinner */], null);
        }
        if (!calendar || !content) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "bp-itin-container" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_cclr_huge_ui_dist_src_components_media_query_media_query__["a" /* MediaQuery */], { query: "(min-width: " + __WEBPACK_IMPORTED_MODULE_5_cclr_huge_ui_dist_src_styles_breakpoints__["a" /* Medium */] + "px)" }, function (matches) { return matches ?
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_cclr_huge_ui_dist_src_components_itinerary_calendar_compact_itinerary_calendar__["a" /* CompactItineraryCalendar */], { calendar: calendar, content: content }) :
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_cclr_huge_ui_dist_src_components_collapsible_collapsible__["a" /* Collapsible */], { id: "bp-compact-itin", expandedTitle: content.mobileExpandedTitle, expandedTitleAriaLabel: content.mobileExpandedAriaLabel, collapsedTitle: content.mobileCollapsedTitle, collapsedTitleAriaLabel: content.mobileCollapsedAriaLabel },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_cclr_huge_ui_dist_src_components_itinerary_calendar_compact_itinerary_calendar__["a" /* CompactItineraryCalendar */], { calendar: calendar, content: content })); })));
    };
    CompactItineraryCalendarContainer.prototype.fetchData = function () {
        var _this = this;
        this.setState({ pending: true });
        // content's embedded.
        this.fetchContent().then(function (content) {
            Object(__WEBPACK_IMPORTED_MODULE_4__itinerary_calendar_service__["a" /* fetchCalendarData */])(_this.props.shipCode, _this.props.sailDate, [], content.numberOfDaysToShowInCompactCalendar)
                .then(function (calendar) {
                _this.setState({
                    pending: false,
                    calendar: calendar,
                    content: content,
                });
            }).catch(function () { return _this.setState({ pending: false }); });
        });
    };
    CompactItineraryCalendarContainer.prototype.fetchContent = function () {
        var _this = this;
        return Object(__WEBPACK_IMPORTED_MODULE_3__common_content_service__["a" /* getContent */])('077df3d4-0502-4664-99e8-dfd86c44217e')
            .then(function (content) {
            content.fullCalendarUrl = content.fullCalendarUrl
                .replace('{shipCode}', _this.props.shipCode)
                .replace('{sailDate}', _this.props.sailDate);
            return content;
        });
    };
    return CompactItineraryCalendarContainer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=compact-itinerary-calendar-container.js.map

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompactItineraryCalendar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eyebrow_eyebrow__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__button_button__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compact_itinerary_calendar_css__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compact_itinerary_calendar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__compact_itinerary_calendar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__compact_itinerary_calendar_day__ = __webpack_require__(444);






var CompactItineraryCalendar = function (_a) {
    var calendar = _a.calendar, className = _a.className, content = _a.content;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__('h-compact-itin-cal', className) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__eyebrow_eyebrow__["a" /* Eyebrow */], { className: "h-compact-itin-cal__eyebrow" }, content.yourPlanner),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h-compact-itin-cal__heading" }, content.heading),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "h-compact-itin-cal__body" }, calendar.days && calendar.days.map(function (day, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__compact_itinerary_calendar_day__["a" /* CompactItineraryCalendarDay */], { key: index, day: day, expandedByDefault: index === 0, fullCalendarUrl: content.fullCalendarUrl })); })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__button_button__["b" /* LinkButton */], { block: true, href: content.fullCalendarUrl, className: "h-compact-itin-cal__cta", color: "outline-black" }, content.fullCalendarText)));
};
//# sourceMappingURL=compact-itinerary-calendar.js.map

/***/ }),
/* 427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 428 */
/***/ (function(module, exports) {

//# sourceMappingURL=icon-props.js.map

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CirclePlusIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var CirclePlusIcon = function (_a) {
    var width = _a.width, height = _a.height, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: width || 32, height: height || 32 }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("circle", { stroke: "#0F559A", fill: "none", opacity: ".3", cx: "16", cy: "16", r: "15.5" }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { stroke: "#0F559A", fill: "none", d: "M9.74 16h12.52M16 9.74v12.52", strokeWidth: "2", strokeLinecap: "round" })));
};
//# sourceMappingURL=circle-plus-icon.js.map

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CloseIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var CloseIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color, circleOpacity = _a.circleOpacity, circleStrokeWidth = _a.circleStrokeWidth, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height", "color", "circleOpacity", "circleStrokeWidth"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 34 34", width: width || 34, height: height || 34 }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("circle", { opacity: circleOpacity || '.6', strokeWidth: circleStrokeWidth, cx: "17", cy: "17", r: "16", fill: "transparent", stroke: color }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M12.763 12.91l8.632 8.337m-.148-8.484l-8.336 8.632", stroke: color, strokeLinecap: "round", strokeWidth: "2" })));
};
//# sourceMappingURL=close-icon.js.map

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InfoIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var InfoIcon = function (_a) {
    var width = _a.width, height = _a.height, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", width: width || 16, height: height || 16 }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("text", { fontSize: "12", fontWeight: "bold", fill: "#0F559A" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tspan", { x: "6", y: "12" }, "i")),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("circle", { fill: "none", stroke: "#0F559A", opacity: ".3", cx: "8", cy: "8", r: "7.5" })));
};
//# sourceMappingURL=info-icon.js.map

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SadFaceIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_colors__ = __webpack_require__(42);



// tslint:disable:max-line-length
var SadFaceIcon = function (_a) {
    var width = _a.width, height = _a.height, _b = _a.color, color = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_2__styles_colors__["f" /* WhiteColor */] : _b, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height", "color"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", width: width || 16, height: height || 16 }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("mask", { id: "b" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M0 0h16v16H0z", fill: color })),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 2.021a5.986 5.986 0 0 1 5.979 5.98A5.986 5.986 0 0 1 8 13.978 5.986 5.986 0 0 1 2.021 8 5.986 5.986 0 0 1 8 2.021", fill: color, mask: "url(#b)" }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M10.205 10.963A2.958 2.958 0 0 0 8 9.983c-.883 0-1.676.384-2.22.997", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M7 5.987a1.008 1.008 0 1 1-2.015 0 1.008 1.008 0 0 1 2.015 0M11.01 5.987a1.008 1.008 0 1 1-2.015 0 1.008 1.008 0 0 1 2.016 0", fill: color })));
};
// tslint:enable:max-line-length
//# sourceMappingURL=sad-face-icon.js.map

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CheckmarkIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


// tslint:disable:max-line-length
var CheckmarkIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height", "color"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", width: width || 16, height: height || 16 }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M15.388 3.755l-9.791 9.751-4.21-4.182", stroke: color || '#FFF', strokeWidth: "2", fill: "none", strokeLinecap: "round", strokeLinejoin: "round" })));
};
// tslint:enable:max-line-length
//# sourceMappingURL=checkmark-icon.js.map

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BedIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


// tslint:disable:max-line-length
var BedIcon = function (_a) {
    var width = _a.width, height = _a.height, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 22 22", width: width || 32, height: height || 32 }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M1.948 9.572h15.363c1.99 0 3.62 1.62 3.62 3.602v1.825c0 .497-.404.9-.905.9H1.948a.903.903 0 0 1-.905-.9v-4.527c0-.495.407-.9.905-.9z", stroke: "#000", fill: "#FFF", strokeWidth: "2" }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M1.043 2.358l.038 17.157M20.93 14.11l.039 5.405", stroke: "#000", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M7.371 8.668H1.947V7.312c0-.746.61-1.356 1.356-1.356h2.712c.746 0 1.356.61 1.356 1.356v1.356z", fill: "#000" })));
};
// tslint:enable:max-line-length
//# sourceMappingURL=bed-icon.js.map

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CabinIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cabin_suite_icon__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cabin_balcony_icon__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cabin_interior_porthole_icon__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cabin_oceanview_icon__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cabin_interior_icon__ = __webpack_require__(184);







var CabinIcon = function (_a) {
    var metaCategoryCode = _a.metaCategoryCode, stateroomTypeName = _a.stateroomTypeName, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["metaCategoryCode", "stateroomTypeName"]);
    if (metaCategoryCode === 'ST' || metaCategoryCode === 'SU') {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__cabin_suite_icon__["a" /* CabinSuiteIcon */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, otherProps));
    }
    if (metaCategoryCode === 'BL' || metaCategoryCode === 'OB') {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__cabin_balcony_icon__["a" /* CabinBalconyIcon */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, otherProps));
    }
    if (metaCategoryCode === 'OS' || metaCategoryCode === 'OV') {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__cabin_oceanview_icon__["a" /* CabinOceanviewIcon */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, otherProps));
    }
    if (stateroomTypeName && stateroomTypeName.toLowerCase().indexOf('porthole') >= 0) {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__cabin_interior_porthole_icon__["a" /* CabinInteriorPortholeIcon */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, otherProps));
    }
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__cabin_interior_icon__["a" /* CabinInteriorIcon */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, otherProps));
};
//# sourceMappingURL=cabin-icon.js.map

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EditIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


// tslint:disable:max-line-length
var EditIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height", "color"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: width || '24', height: height || '24' },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", { fill: "none", fillRule: "evenodd" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M0 0h20v20H0z" }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { transform: "translate(0 3.593)", d: "M14 0H6a6 6 0 0 0-6 6v8a6 6 0 0 0 6 6h8a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6m0 2c2.206 0 4 1.794 4 4v8c0 2.206-1.794 4-4 4H6c-2.206 0-4-1.794-4-4V6c0-2.206 1.794-4 4-4h8", fill: color || '#000' }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M20.88 0c-.408 0-.832.174-1.161.517L9.584 11.08c-.301.313-.48.728-.498 1.15l-.07 1.671c-.035.842.565 1.495 1.36 1.495h.06l1.597-.067a1.637 1.637 0 0 0 1.1-.516L23.27 4.25c.62-.646.669-1.646.11-2.233L21.854.412A1.328 1.328 0 0 0 20.88 0", fill: color || '#000' }))));
};
// tslint:enable:max-line-length
//# sourceMappingURL=edit-icon.js.map

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpinnerIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__spinner_icon_css__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__spinner_icon_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__spinner_icon_css__);




var SpinnerIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color, className = _a.className, circleClassName = _a.circleClassName, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height", "color", "className", "circleClassName"]);
    var wrapperClasses = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-spinner-icon', className);
    var classes = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-spinner-icon__circle', circleClassName);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ className: wrapperClasses, width: width || 24, height: height || 24 }, otherProps, { viewBox: "0 0 50 50" }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("circle", { className: classes, cx: "25", cy: "25", r: "20", fill: "none", stroke: color || undefined, strokeWidth: "5" })));
};
//# sourceMappingURL=spinner-icon.js.map

/***/ }),
/* 438 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExclamationIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_colors__ = __webpack_require__(42);



var ExclamationIcon = function (_a) {
    var width = _a.width, height = _a.height, _b = _a.textColor, textColor = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_2__styles_colors__["b" /* Blue600Color */] : _b, _c = _a.borderColor, borderColor = _c === void 0 ? __WEBPACK_IMPORTED_MODULE_2__styles_colors__["b" /* Blue600Color */] : _c, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height", "textColor", "borderColor"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", width: width || 16, height: height || 16 }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("text", { fontSize: "12", fontWeight: "bold", fill: textColor },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tspan", { x: "6.2", y: "12" }, "!")),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("circle", { fill: "none", stroke: borderColor, strokeWidth: "2", cx: "8", cy: "8", r: "7" })));
};
//# sourceMappingURL=exclamation-icon.js.map

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ClockIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


// tslint:disable:max-line-length
var ClockIcon = function (_a) {
    var width = _a.width, height = _a.height, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", width: width || 16, height: height || 16 }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", { fill: "none" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("mask", { id: "b", fill: "#fff" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M0 0h16v16H0z" })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 1.333A6.674 6.674 0 0 1 14.667 8 6.674 6.674 0 0 1 8 14.667 6.674 6.674 0 0 1 1.333 8 6.674 6.674 0 0 1 8 1.333", fill: "#000", mask: "url(#b)" }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M8 3.707v4.149l2.988 2.935c.304.3.82.277 1.071-.066.592-.807.941-1.798.941-2.869 0-2.441-1.813-4.467-4.189-4.847A.708.708 0 0 0 8 3.707", fill: "#000" }))));
};
// tslint:enable:max-line-length
//# sourceMappingURL=clock-icon.js.map

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PrinterIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_colors__ = __webpack_require__(42);



// tslint:disable:max-line-length
var PrinterIcon = function (_a) {
    var width = _a.width, height = _a.height, _b = _a.color, color = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_2__styles_colors__["c" /* BlueColor */] : _b, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height", "color"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", width: width || 18, height: height || 18 }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M16.945 7.236c0-1.586-1.14-2.872-2.545-2.872h-1.09V1.451c0-.226-.164-.41-.365-.41h-7.89c-.201 0-.364.184-.364.41v2.913H3.6c-1.406 0-2.545 1.286-2.545 2.872v4.267c0 1.586 1.14 2.871 2.545 2.871h.727v2.175c0 .226.163.41.364.41h8.618c.2 0 .364-.184.364-.41v-2.175h.727c1.406 0 2.545-1.285 2.545-2.871V7.236zM5.418 1.862h7.164v2.502H5.418V1.862zm7.527 14.276h-7.89v-5.312h7.89v5.312zm3.273-4.635c0 1.132-.814 2.05-1.818 2.05h-.727v-3.138c0-.226-.163-.41-.364-.41H4.691c-.2 0-.364.184-.364.41v3.139H3.6c-1.004 0-1.818-.919-1.818-2.051V7.236c0-1.133.814-2.051 1.818-2.051h10.8c1.004 0 1.818.918 1.818 2.05v4.268z", fillRule: "nonzero", fill: color, stroke: color })));
};
//# sourceMappingURL=printer-icon.js.map

/***/ }),
/* 442 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 443 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompactItineraryCalendarDay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__compact_itinerary_calendar_day_css__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__compact_itinerary_calendar_day_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__compact_itinerary_calendar_day_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compact_itinerary_calendar_entry__ = __webpack_require__(446);





var CompactItineraryCalendarDay = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(CompactItineraryCalendarDay, _super);
    function CompactItineraryCalendarDay(props) {
        var _this = _super.call(this, props) || this;
        _this.onClick = function (e) {
            e.preventDefault();
            if (_this.props.day.isOverflowPlaceholder) {
                window.location.href = _this.props.fullCalendarUrl;
            }
            _this.setState(function (state) { return ({
                expanded: !state.expanded
            }); });
        };
        _this.state = {
            expanded: !!props.expandedByDefault
        };
        return _this;
    }
    CompactItineraryCalendarDay.prototype.render = function () {
        var _a = this.props, day = _a.day, className = _a.className;
        if (!day) {
            return null;
        }
        var expanded = this.state.expanded;
        var dayClassName = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-compact-itin-cal-day', { 'h-compact-itin-cal-day--expanded': expanded }, className);
        var dayId = day.day.trim().replace(' ', '_');
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { className: dayClassName },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "", className: "h-compact-itin-cal-day__heading", "aria-expanded": expanded, "aria-controls": expanded ? dayId : undefined, onClick: this.onClick },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-compact-itin-cal-day__day" }, day.day),
                !day.isOverflowPlaceholder && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-compact-itin-cal-day__port" }, day.port)),
            !day.isOverflowPlaceholder && expanded && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-compact-itin-cal-day__content", id: dayId }, this.renderEntries()))));
    };
    CompactItineraryCalendarDay.prototype.renderEntries = function () {
        var day = this.props.day;
        if (!day || !day.entries) {
            return null;
        }
        return day.entries.map(function (entry, index) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__compact_itinerary_calendar_entry__["a" /* CompactItineraryCalendarEntry */], { key: index, time: entry.timeHMmTt },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { dangerouslySetInnerHTML: { __html: entry.title } }))); });
    };
    return CompactItineraryCalendarDay;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=compact-itinerary-calendar-day.js.map

/***/ }),
/* 445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompactItineraryCalendarEntry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__compact_itinerary_calendar_entry_css__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__compact_itinerary_calendar_entry_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__compact_itinerary_calendar_entry_css__);



var CompactItineraryCalendarEntry = function (_a) {
    var className = _a.className, time = _a.time, children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__('h-compact-itin-cal-entry', className) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-compact-itin-cal-entry__time" }, time),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-compact-itin-cal-entry__body" }, children)));
};
//# sourceMappingURL=compact-itinerary-calendar-entry.js.map

/***/ }),
/* 447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Spinner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icons_index__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_colors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__spinner_css__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__spinner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__spinner_css__);






var Spinner = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Spinner, _super);
    function Spinner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Spinner.prototype.render = function () {
        var _a = this.props, className = _a.className, height = _a.height, width = _a.width, color = _a.color;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-spinner__busy-container', className) },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__icons_index__["SpinnerIcon"], { color: color || __WEBPACK_IMPORTED_MODULE_4__styles_colors__["c" /* BlueColor */], width: width, height: height })));
    };
    return Spinner;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=spinner.js.map

/***/ }),
/* 449 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 451 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToDosContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__to_dos_service__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_cclr_huge_ui_dist_src_styles_breakpoints__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_cclr_huge_ui_dist_src_components_media_query_media_query__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_cclr_huge_ui_dist_src_components_collapsible_collapsible__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_cclr_huge_ui_dist_src_components_to_dos_to_dos__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_cclr_huge_ui_dist_src_components_to_dos_to_do__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_cclr_huge_ui_dist_src_components_chevron_chevron_circle__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_constants__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_hosting__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_querystring__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__to_dos_container_css__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__to_dos_container_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__to_dos_container_css__);

/* eslint-disable jsx-a11y/anchor-is-valid */












var ToDosContainer = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(ToDosContainer, _super);
    function ToDosContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.topRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.isFullMode = Object(__WEBPACK_IMPORTED_MODULE_10__common_hosting__["a" /* isFullMode */])();
        _this.state = {
            content: null,
            filteredToDos: null,
            selectedFilters: null,
            isExpanded: false,
            bookingSelectorContent: null
        };
        _this.onFilterChange = function (selectedBookings) {
            _this.setState({
                selectedFilters: selectedBookings
            });
        };
        _this.isModal = function (type) {
            return type.toLowerCase().indexOf('completeguestnames') >= 0;
        };
        _this.onToDoClick = function (e, toDo, filteredToDos) {
            var url = null;
            if (_this.isModal(toDo.type)) {
                var selectedToDo = filteredToDos.find(function (x) { return x.title === toDo.title; });
                var bookingNumber_1 = selectedToDo.bookingNumber;
                var booking = _this.props.sailing.bookings.filter(function (n) { return n.bookingNumber === bookingNumber_1; })[0];
                var seqNumber = booking.guests[0].seqNumber;
                url = _this.createModalUrl(bookingNumber_1, seqNumber.toString(), window.location.search);
            }
            else if (e.currentTarget.href) {
                url = e.currentTarget.getAttribute('href');
            }
            if (url) {
                e.preventDefault();
                if (_this.props.navigate && _this.isFullMode && _this.isValidForRouterNavigation(url, _this.props)) {
                    _this.props.navigate(url);
                }
                else {
                    window.location.href = url;
                }
            }
        };
        _this.toggleDetails = function (e) {
            e.preventDefault();
            _this.setState(function (prevState) {
                return {
                    isExpanded: !prevState.isExpanded,
                };
                // tslint:disable-next-line:align
            }, function () {
                if (!_this.state.isExpanded) {
                    _this.scrollToTop();
                }
            });
        };
        _this.scrollToTop = function () {
            if (_this.topRef.current) {
                _this.topRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        };
        return _this;
    }
    ToDosContainer.prototype.createModalUrl = function (bookingNumber, seqNumber, querystring) {
        if (!bookingNumber.match(/^[a-zA-Z0-9]*$/)) {
            return null;
        }
        if (!seqNumber.match(/^[0-9]*$/)) {
            return null;
        }
        // eslint-disable-next-line no-useless-escape
        if (!querystring.match(/^[a-zA-Z0-9%&=?+\-]*$/)) {
            return null;
        }
        var url = __WEBPACK_IMPORTED_MODULE_9__common_constants__["a" /* localRoutes */].details + "/guests/" + bookingNumber + "/" + seqNumber + querystring;
        return url;
    };
    ToDosContainer.prototype.isValidForRouterNavigation = function (url, props) {
        url = url.toLowerCase();
        for (var propName in __WEBPACK_IMPORTED_MODULE_9__common_constants__["a" /* localRoutes */]) {
            if (!Object.prototype.hasOwnProperty(propName)) {
                // tslint:disable-next-line:no-any
                var route = __WEBPACK_IMPORTED_MODULE_9__common_constants__["a" /* localRoutes */][propName];
                if (url.indexOf(route) === 0) {
                    return true;
                }
            }
        }
        return false;
    };
    ToDosContainer.prototype.render = function () {
        var _a = this.props, sailing = _a.sailing, isCompactMode = _a.isCompactMode;
        var _b = this.state, content = _b.content, filteredToDos = _b.filteredToDos, selectedFilters = _b.selectedFilters;
        if (!sailing || !content || !filteredToDos || !selectedFilters) {
            return null;
        }
        var expandedContainerId = 'bp-sailing-todos-full-container';
        return isCompactMode
            ? this.renderContent(null)
            : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { id: expandedContainerId, className: sailing.itinerary.totalMinutesUntilSailing <= 0 ? 'bp-sailing-todos-full__no-counter-sharing' : 'bp-sailing-todos-full' }, this.renderContent(expandedContainerId)));
    };
    ToDosContainer.prototype.renderContent = function (containerId) {
        var _this = this;
        var _a = this.props, sailing = _a.sailing, isCompactMode = _a.isCompactMode, expandedMobileMode = _a.expandedMobileMode;
        var _b = this.state, content = _b.content, filteredToDos = _b.filteredToDos, selectedFilters = _b.selectedFilters, isExpanded = _b.isExpanded, bookingSelectorContent = _b.bookingSelectorContent;
        if (!sailing || !content || !filteredToDos || !selectedFilters) {
            return null;
        }
        var bookingSelectorProps = this.buildBookingSelectorProps(content, bookingSelectorContent, sailing, selectedFilters);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "bp-sailing-todos", ref: this.topRef },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_cclr_huge_ui_dist_src_components_media_query_media_query__["a" /* MediaQuery */], { query: "(min-width: " + __WEBPACK_IMPORTED_MODULE_3_cclr_huge_ui_dist_src_styles_breakpoints__["a" /* Medium */] + "px)" }, function (matches) { return matches || !isCompactMode ?
                _this.renderToDos(sailing, content, filteredToDos, isCompactMode, expandedMobileMode, isExpanded, containerId, bookingSelectorProps) :
                _this.renderCollapsible(sailing, content, filteredToDos, isCompactMode, bookingSelectorProps); })));
    };
    ToDosContainer.prototype.renderCollapsible = function (sailing, content, filteredToDos, compactMode, bookingSelectorProps) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_cclr_huge_ui_dist_src_components_collapsible_collapsible__["a" /* Collapsible */], { id: "bp-to-dos", collapsedTitle: content.mobileCollapsedTitle, collapsedTitleAriaLabel: content.mobileCollapsedAriaLabel, expandedTitle: content.mobileExpandedTitle, expandedTitleAriaLabel: content.mobileExpandedAriaLabel }, this.renderToDos(sailing, content, filteredToDos, compactMode, false, false, null, bookingSelectorProps)));
    };
    ToDosContainer.prototype.renderToDos = function (sailing, content, sailingToDos, compactMode, expandedMobileMode, isExpanded, containerId, bookingSelectorProps) {
        var _this = this;
        var todosBottomCtaUrl = __WEBPACK_IMPORTED_MODULE_9__common_constants__["a" /* localRoutes */].details + "?shipCode=" + encodeURIComponent(sailing.itinerary.shipCode) + "&sailDate=" + encodeURIComponent(sailing.itinerary.sailDate);
        var filteredTodos = this.filterTodos(sailingToDos, bookingSelectorProps);
        var showBottomCta = compactMode && filteredTodos.length > content.maxNumberOfToDos;
        filteredTodos = showBottomCta ? filteredTodos.slice(0, content.maxNumberOfToDos) : filteredTodos;
        var maxShowWhenMobileExpandedView = 3;
        var needsExpandOption = !compactMode && expandedMobileMode && filteredTodos.length > maxShowWhenMobileExpandedView;
        if (needsExpandOption && !isExpanded) {
            filteredTodos = filteredTodos.slice(0, maxShowWhenMobileExpandedView);
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_cclr_huge_ui_dist_src_components_to_dos_to_dos__["a" /* ToDos */], { id: "todos", className: "bp-to-dos", eyebrow: content.eyebrow, heading: content.heading, bottomCtaAriaLabel: content.bottomCtaAriaLabel, bottomCtaText: content.bottomCtaText, bottomCtaUrl: todosBottomCtaUrl, showBottomCta: showBottomCta, isCompactMode: compactMode, bookingSelectorProps: bookingSelectorProps }, filteredTodos.map(function (toDo, i) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_cclr_huge_ui_dist_src_components_to_dos_to_do__["a" /* ToDo */], { key: i, id: i, title: toDo.title, icon: toDo.icon, linkUrl: _this.isModal(toDo.type) || !toDo.callToActionUrl ? '' : getTodoUrl(toDo.bookingNumber, _this.props.baseUrl, toDo.callToActionUrl, getUrlParameters(sailing)), onClick: function (e) { return _this.onToDoClick(e, toDo, sailingToDos); }, completed: toDo.completed, disabled: toDo.disabled, isCompactMode: compactMode, displayCallToAction: toDo.displayCallToAction, callToActionText: toDo.callToActionText, adaCallToActionDescription: toDo.adaCallToActionDescription }, toDo.description && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { dangerouslySetInnerHTML: { __html: toDo.description } }))); })),
            needsExpandOption && containerId && this.displayToggleDetails(containerId, content)));
    };
    ToDosContainer.prototype.filterTodos = function (filteredToDos, bookingSelectorProps) {
        var selectedBookingsToDos = [];
        bookingSelectorProps.selectedBookings.forEach(function (selectedBooking) {
            selectedBookingsToDos.push.apply(selectedBookingsToDos, filteredToDos.filter(function (x) { return x.bookingNumber === selectedBooking; }));
        });
        return selectedBookingsToDos.sort(function (a, b) {
            if (a.priority < b.priority) {
                return -1;
            }
            if (a.priority > b.priority) {
                return 1;
            }
            return 0;
        });
    };
    ToDosContainer.prototype.buildBookingSelectorProps = function (todosContent, bookingSelectorContent, sailing, selectedFilters) {
        var bookingSelectorProps;
        if (bookingSelectorContent !== null) {
            bookingSelectorContent.checkBoxAriaLabel = todosContent.checkBoxAriaLabel || bookingSelectorContent.checkBoxAriaLabel;
            bookingSelectorContent.buttonAriaLabel = todosContent.buttonAriaLabel || bookingSelectorContent.buttonAriaLabel;
            bookingSelectorProps = {
                content: bookingSelectorContent,
                activeSailing: sailing,
                selectedBookings: selectedFilters,
                onSelectedBookings: this.onFilterChange,
                parentNameRef: 'todo',
            };
        }
        return bookingSelectorProps;
    };
    ToDosContainer.prototype.displayToggleDetails = function (id, content) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "d-lg-none h-bk-todos__toggle-details-row no-gutters" }, this.renderToggleDetails(id, content, this.state.isExpanded)));
    };
    ToDosContainer.prototype.renderToggleDetails = function (id, content, isOpen) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "", className: "h-bk-todos__action-link h-bk-todos__toggle-link", onClick: this.toggleDetails, role: "button", "aria-expanded": isOpen ? 'true' : 'false', "aria-controls": id }, content.viewAllToDos)),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "", className: "h-bk-todos__toggle-details-icon", onClick: this.toggleDetails, role: "button", "aria-expanded": isOpen ? 'true' : 'false', "aria-controls": id, "aria-label": content.viewAllToDos },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_cclr_huge_ui_dist_src_components_chevron_chevron_circle__["a" /* ChevronCircle */], { direction: isOpen ? 'up' : 'down', size: 44, shadowMode: "simple" })))));
    };
    ToDosContainer.prototype.componentDidMount = function () {
        var _this = this;
        Object(__WEBPACK_IMPORTED_MODULE_2__to_dos_service__["a" /* fetchDataAndContent */])(this.props.sailing).then(function (data) { return _this.setState(data); });
    };
    return ToDosContainer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

function getTodoUrl(bookingNumber, theBaseUrl, actionUrl, urlParameters) {
    return actionUrl
        ? actionUrl
            .replace('{BaseUrl}', theBaseUrl || '/booked/details')
            .replace('{BookingNumber}', bookingNumber)
            .replace('{UrlParameters}', urlParameters)
        : '';
}
function getUrlParameters(sailing) {
    if (!sailing) {
        return window.location.search;
    }
    var parsedQs = Object(__WEBPACK_IMPORTED_MODULE_11__common_querystring__["a" /* parse */])();
    var searchParams = window.location.search;
    if (!parsedQs.shipCode && !parsedQs.ShipCode) {
        searchParams = appendParameter(searchParams, 'shipCode', sailing.itinerary.shipCode);
    }
    if (!parsedQs.sailDate && !parsedQs.SailDate) {
        searchParams = appendParameter(searchParams, 'sailDate', sailing.itinerary.sailDate);
    }
    return searchParams;
}
function appendParameter(search, paramKey, paramValue) {
    return search + (search.indexOf('?') === -1 ? '?' : '&') + paramKey + '=' + encodeURIComponent(paramValue);
}
//# sourceMappingURL=to-dos-container.js.map

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToDos; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eyebrow_eyebrow__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__button_button__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__to_dos_css__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__to_dos_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__to_dos_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__booking_selector_booking_selector__ = __webpack_require__(455);







var ToDos = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(ToDos, _super);
    function ToDos() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToDos.prototype.render = function () {
        var _a = this.props, id = _a.id, className = _a.className, eyebrow = _a.eyebrow, heading = _a.heading, children = _a.children, isCompactMode = _a.isCompactMode, bookingSelectorProps = _a.bookingSelectorProps;
        var ddlId = 'h-to-dos-ddl-' + id;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-to-dos', className) },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { id: ddlId, className: "h-to-dos__content" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__eyebrow_eyebrow__["a" /* Eyebrow */], { className: isCompactMode ? 'h-to-dos__eyebrow' : 'h-to-dos__eyebrow-expanded' }, eyebrow),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h2", { className: "h-to-dos__heading" }, heading),
                bookingSelectorProps && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-to-dos__filter" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__booking_selector_booking_selector__["a" /* BookingSelector */], { content: bookingSelectorProps.content, onSelectedBookings: bookingSelectorProps.onSelectedBookings, selectedBookings: bookingSelectorProps.selectedBookings, activeSailing: bookingSelectorProps.activeSailing, parentNameRef: "to-dos" })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__({ 'h-to-dos__list-wrapper': !isCompactMode }) },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("ul", { className: "h-to-dos__list" }, __WEBPACK_IMPORTED_MODULE_1_react__["Children"].map(children, function (toDo) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { className: "h-to-dos__list-item" }, toDo)); })),
                    isCompactMode && this.renderButton(this.props)))));
    };
    ToDos.prototype.renderButton = function (props) {
        var showBottomCta = props.showBottomCta, bottomCtaText = props.bottomCtaText, bottomCtaUrl = props.bottomCtaUrl, bottomCtaClick = props.bottomCtaClick, bottomCtaAriaLabel = props.bottomCtaAriaLabel;
        var classes = {
            'h-to-dos__button--always': showBottomCta,
            'h-to-dos__button--only-mobile': !showBottomCta,
        };
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__button_button__["b" /* LinkButton */], { color: "outline-black", className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-to-dos__button', classes), "aria-label": bottomCtaAriaLabel, href: bottomCtaUrl, onClick: bottomCtaClick }, bottomCtaText));
    };
    return ToDos;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=to-dos.js.map

/***/ }),
/* 454 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BookingSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eyebrow_eyebrow__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__avatar_avatar__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms_index__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dropdown_dropdown__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__booking_selector_css__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__booking_selector_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__booking_selector_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);








var BookingSelector = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(BookingSelector, _super);
    function BookingSelector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSelectionChanged = function (e) {
            if (_this.props.onSelectedBookings) {
                var bookingNumber_1 = e.currentTarget.dataset.booknum;
                var selectedBookings = _this.props.selectedBookings;
                if (e.currentTarget.checked && !selectedBookings.find(function (s) { return s === bookingNumber_1; })) {
                    selectedBookings.push(bookingNumber_1);
                    _this.props.onSelectedBookings(selectedBookings);
                }
                else {
                    _this.props.onSelectedBookings(selectedBookings.filter(function (s) { return s !== bookingNumber_1; }));
                }
            }
        };
        return _this;
    }
    BookingSelector.prototype.render = function () {
        var _this = this;
        var _a = this.props, activeSailing = _a.activeSailing, content = _a.content, selectedBookings = _a.selectedBookings, parentNameRef = _a.parentNameRef, className = _a.className, disableSelector = _a.disableSelector;
        if (!activeSailing || !activeSailing.bookings || activeSailing.bookings.length === 1) {
            return null;
        }
        var selectedBookingsCount = selectedBookings.length;
        var key = 'booking-selector-' + (parentNameRef || 'component');
        var title = ((selectedBookingsCount === 1 ? content.oneStateroomTitle : content.multiStateroomTitle) || '')
            .replace('{StateroomCount}', selectedBookingsCount.toString());
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_7_classnames__('h-bk-sel', className) },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__dropdown_dropdown__["a" /* Dropdown */], { key: key, id: key, title: title, className: "h-bk-sel__dropdown", display: "relative", buttonAriaLabel: "" + (content.buttonAriaLabel || '').replace('{BookingsCount}', selectedBookingsCount.toString()) },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null, activeSailing.bookings.map(function (b, i) {
                    var checked = !!selectedBookings.find(function (selected) { return b.bookingNumber === selected; });
                    var lastSelected = checked && selectedBookingsCount === 1;
                    return _this.renderBookingSelector(b, i, content.eyebrow, content.avatarPrefix, content.defaultGuestName, content.stateroomSequence, checked, disableSelector !== true && !lastSelected, content.checkBoxAriaLabel, parentNameRef);
                })))));
    };
    BookingSelector.prototype.genId = function (bookingNumber, suffix, parentNameRef) {
        return parentNameRef + "-bk-selector-" + bookingNumber + "-" + suffix;
    };
    BookingSelector.prototype.renderBookingSelector = function (booking, index, eyebrow, avatarPrefix, defaultGuestName, stateroomSequence, checked, enable, checkBoxAriaLabel, parentNameRef) {
        var _this = this;
        var bookingNumber = booking.bookingNumber;
        var eyebrowId = this.genId(bookingNumber, 'bk-sel-eyebrow', parentNameRef);
        var divId = this.genId(bookingNumber, 'bk-sel-id', parentNameRef);
        var inputId = this.genId(bookingNumber, 'chx', parentNameRef);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { id: divId, key: bookingNumber + "-" + index },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms_index__["a" /* Checkbox */], { name: inputId, id: inputId, "data-booknum": bookingNumber, onChange: this.onSelectionChanged, disabled: !enable, defaultChecked: checked, "aria-label": "" + (checkBoxAriaLabel || '').replace('{BookingNumber}', bookingNumber) }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms_index__["b" /* Label */], { htmlFor: inputId },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__eyebrow_eyebrow__["a" /* Eyebrow */], { id: eyebrowId },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { "data-pii": "true" }, "" + eyebrow + booking.bookingNumber)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h3", { className: "h-bk-sel__heading" }, "" + (stateroomSequence || '').replace('{Sequence}', (index + 1).toString()))),
            booking.guests.map(function (g, i) { return _this.renderGuest(g, i, avatarPrefix, defaultGuestName); })));
    };
    BookingSelector.prototype.renderGuest = function (g, i, avatarPrefix, defaultGuestName) {
        var fullName = g.firstName === 'TBA'
            ? defaultGuestName + " " + (i + 1)
            : g.firstName + " " + g.lastName;
        var avatar = g.firstName === 'TBA'
            ? (avatarPrefix + (i + 1))
            : fullName;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "d-flex h-bk-sel__card__guest", key: i },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bk-sel__card__guest-num-col", "aria-hidden": "true" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__avatar_avatar__["a" /* Avatar */], { fullName: avatar })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { "data-pii": "true", className: "h-bk-sel__card__guest-info-col" }, fullName)));
    };
    return BookingSelector;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=booking-selector.js.map

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Avatar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__avatar_css__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__avatar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__avatar_css__);




function getInitials(fullName) {
    if (!fullName) {
        return '--';
    }
    var parts = fullName.trim().split(' ');
    if (parts.length === 1) {
        return parts[0].substring(0, 2);
    }
    return "" + parts[0].charAt(0) + parts[1].charAt(0);
}
var Avatar = function (_a) {
    var fullName = _a.fullName, className = _a.className, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["fullName", "className"]);
    var classes = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-avatar', className);
    var initials = getInitials(fullName).toUpperCase();
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ className: classes }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null, initials));
};
//# sourceMappingURL=avatar.js.map

/***/ }),
/* 457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_control_group__ = __webpack_require__(194);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_control_model__ = __webpack_require__(151);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_validator__ = __webpack_require__(195);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_form_validation__ = __webpack_require__(466);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__input__ = __webpack_require__(467);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__checkbox__ = __webpack_require__(469);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__checkbox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__error__ = __webpack_require__(471);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__label__ = __webpack_require__(473);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__label__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__select__ = __webpack_require__(475);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__radio__ = __webpack_require__(477);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__field__ = __webpack_require__(479);
/* unused harmony reexport FormField */











//# sourceMappingURL=index.js.map

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validators; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__custom__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__email__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__required__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__minlength__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__maxlength__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pattern__ = __webpack_require__(465);






var validators = {
    custom: __WEBPACK_IMPORTED_MODULE_0__custom__["a" /* custom */],
    email: __WEBPACK_IMPORTED_MODULE_1__email__["a" /* email */],
    required: __WEBPACK_IMPORTED_MODULE_2__required__["a" /* required */],
    minlength: __WEBPACK_IMPORTED_MODULE_3__minlength__["a" /* minlength */],
    maxlength: __WEBPACK_IMPORTED_MODULE_4__maxlength__["a" /* maxlength */],
    pattern: __WEBPACK_IMPORTED_MODULE_5__pattern__["a" /* pattern */]
};
//# sourceMappingURL=validators.js.map

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = custom;
function custom(value, customValidator) {
    return customValidator(value);
}
//# sourceMappingURL=custom.js.map

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = email;
function email(value) {
    if (value) {
        return /.+@.{2,}\..+/.test(value); // contains @ and a .
    }
    return true;
}
//# sourceMappingURL=email.js.map

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = required;
function required(value, isRequired) {
    if (isRequired) {
        if (typeof value === 'boolean') {
            return value;
        }
        else {
            return !!value && value.length > 0;
        }
    }
    return true;
}
//# sourceMappingURL=required.js.map

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = minlength;
function minlength(value, minLength) {
    if (value) {
        return value.length >= minLength;
    }
    return true;
}
//# sourceMappingURL=minlength.js.map

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = maxlength;
function maxlength(value, maxLength) {
    if (value) {
        return value.length <= maxLength;
    }
    return true;
}
//# sourceMappingURL=maxlength.js.map

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pattern;
function pattern(value, regex) {
    if (value && regex) {
        if (typeof regex === 'string') {
            return new RegExp(regex).test(value);
        }
        else {
            return regex.test(value);
        }
    }
    return true;
}
//# sourceMappingURL=pattern.js.map

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export validateControlGroup */
/* unused harmony export getInvalidControlsFromControlGroup */
/* unused harmony export getErrorMessages */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__control_model__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__control_group__ = __webpack_require__(194);


function validateControlGroup(controlGroup, container) {
    var controls = controlGroup.controls.all.map(function (c) { return Object(__WEBPACK_IMPORTED_MODULE_0__control_model__["c" /* asValidatedDirtyAndTouched */])(c); });
    var validatedControlGroup = __WEBPACK_IMPORTED_MODULE_1__control_group__["a" /* createControlGroup */].apply(void 0, controls);
    if (validatedControlGroup.invalid && container) {
        scrollAndFocusToFirstInvalidElement(container, validatedControlGroup);
    }
    return validatedControlGroup;
}
function getInvalidControlsFromControlGroup(controlGroup) {
    return controlGroup.controls.all.filter(function (c) { return c.state.invalid; });
}
function getErrorMessages(controls) {
    var errors = [];
    for (var i = 0; i < controls.length; i++) {
        var control = controls[i];
        if (control.state.valid) {
            continue;
        }
        for (var j = 0; j < control.state.errors.length; j++) {
            var error = control.state.errors[j];
            var errorMessage = control.errorMessages[error];
            if (errorMessage) {
                errors.push(errorMessage);
            }
        }
    }
    return errors;
}
function scrollAndFocusToFirstInvalidElement(container, controlGroup) {
    if (controlGroup.valid) {
        return;
    }
    var id = getInvalidControlsFromControlGroup(controlGroup)[0].id;
    var input = container.querySelector('#' + id);
    var label = container.querySelector("label[for=\"" + id + "\"]");
    scrollAndFocusElement(input, label);
}
function scrollAndFocusElement(elementToFocus, elementToScroll) {
    (elementToScroll || elementToFocus).scrollIntoView(true);
    elementToFocus.focus();
}
//# sourceMappingURL=form-validation.js.map

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Input */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__input_css__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__input_css__);




var Input = function (_a) {
    var className = _a.className, parentRef = _a.parentRef, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["className", "parentRef"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("input", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ ref: parentRef, className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-form__input', className) }, otherProps)));
};
//# sourceMappingURL=input.js.map

/***/ }),
/* 468 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Checkbox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__checkbox_css__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__checkbox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__checkbox_css__);




var Checkbox = function (_a) {
    var className = _a.className, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["className"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("input", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ type: "checkbox", className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-form__checkbox', className) }, otherProps)));
};
//# sourceMappingURL=checkbox.js.map

/***/ }),
/* 470 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Error */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__error_css__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__error_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__error_css__);




var Error = function (_a) {
    var className = _a.className, errors = _a.errors, children = _a.children, prefix = _a.prefix, messages = _a.messages, role = _a.role, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["className", "errors", "children", "prefix", "messages", "role"]);
    prefix = prefix + '-val-msg-';
    if (!role && errors && errors.length) {
        role = 'alert';
    }
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-form__error', className), role: role }, otherProps), errors && errors.map(function (err, idx) {
        return messages[err] ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: idx, id: prefix + idx, dangerouslySetInnerHTML: { __html: messages[err] } }) : null;
    })));
};
//# sourceMappingURL=error.js.map

/***/ }),
/* 472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Label; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__label_css__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__label_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__label_css__);




var Label = function (_a) {
    var className = _a.className, children = _a.children, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["className", "children"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("label", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-form__label', className) }, otherProps), children));
};
//# sourceMappingURL=label.js.map

/***/ }),
/* 474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Select */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chevron_chevron__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__select_css__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__select_css__);





var Select = __WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"](function (_a, ref) {
    var className = _a.className, children = _a.children, value = _a.value, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["className", "children", "value"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__chevron_chevron__["a" /* Chevron */], { className: "h-form__select-arrow", color: "black", size: 14, direction: "down" }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("select", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ ref: ref, className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-form__select', { 'h-form__select--filled': !!value }, className), value: value }, otherProps), children)));
});
//# sourceMappingURL=select.js.map

/***/ }),
/* 476 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Radio */
/* unused harmony export radioControlProps */
/* unused harmony export radioLabelProps */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__radio_css__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__radio_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__radio_css__);




var Radio = function (_a) {
    var className = _a.className, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["className"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("input", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ type: "radio", className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-form__radio', className) }, otherProps)));
};
function radioControlProps(controlProps, idSuffix, value) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, controlProps), { id: getId(controlProps.id, idSuffix), value: value, checked: controlProps.value === value, 'aria-checked': controlProps.value === value });
}
function radioLabelProps(labelProps, idSuffix) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, labelProps), { htmlFor: getId(labelProps.htmlFor, idSuffix), 'aria-owns': getId(labelProps['aria-owns'], idSuffix) });
}
function getId(id, idSuffix) {
    var newId = id;
    if (idSuffix) {
        newId += '-' + idSuffix;
    }
    return newId;
}
//# sourceMappingURL=radio.js.map

/***/ }),
/* 478 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createControlProps */
/* unused harmony export controlOnChange */
/* unused harmony export controlOnBlur */
/* unused harmony export areErrorsVisible */
/* unused harmony export FormField */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_control_model__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__field_css__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__field_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__field_css__);





function createControlProps(model, onChange, onBlur) {
    return {
        name: model.name,
        id: model.id,
        required: !!(model.validators && model.validators.required),
        value: model.value,
        checked: model.checked,
        'aria-required': model.checked === undefined && model.validators && model.validators.required ? true : undefined,
        'aria-invalid': model.state.invalid,
        'aria-describedby': areErrorsVisible(model.state) ? (model.id + '-val-msg-0') : undefined,
        'aria-checked': model.checked === undefined ? undefined : model.checked,
        onChange: onChange,
        onBlur: onBlur,
        'data-pii': !!model.pii ? 'true' : undefined
    };
}
function controlOnChange(model, e, forceUpperCaseText) {
    var newModel = null;
    if (!e.isDefaultPrevented() && model.updateMode === 'change') {
        if (e.currentTarget.type === 'checkbox') {
            newModel = Object(__WEBPACK_IMPORTED_MODULE_3__models_control_model__["b" /* asTouched */])(Object(__WEBPACK_IMPORTED_MODULE_3__models_control_model__["d" /* withChecked */])(model, e.currentTarget.checked));
        }
        else if (e.currentTarget.type === 'radio') {
            newModel = Object(__WEBPACK_IMPORTED_MODULE_3__models_control_model__["e" /* withValue */])(Object(__WEBPACK_IMPORTED_MODULE_3__models_control_model__["d" /* withChecked */])(model, e.currentTarget.checked), e.currentTarget.value);
        }
        else {
            var value = forceUpperCaseText && e.currentTarget.value ? e.currentTarget.value.toUpperCase() : e.currentTarget.value;
            newModel = Object(__WEBPACK_IMPORTED_MODULE_3__models_control_model__["e" /* withValue */])(model, value);
        }
    }
    newModel = Object(__WEBPACK_IMPORTED_MODULE_3__models_control_model__["a" /* asDirty */])(newModel || model);
    return newModel;
}
function controlOnBlur(model, e) {
    var newModel = null;
    if (!e.isDefaultPrevented() && model.updateMode === 'blur') {
        if (e.currentTarget.type === 'checkbox') {
            newModel = Object(__WEBPACK_IMPORTED_MODULE_3__models_control_model__["d" /* withChecked */])(model, e.currentTarget.checked);
        }
        else {
            newModel = Object(__WEBPACK_IMPORTED_MODULE_3__models_control_model__["e" /* withValue */])(model, e.currentTarget.value);
        }
    }
    newModel = Object(__WEBPACK_IMPORTED_MODULE_3__models_control_model__["b" /* asTouched */])(newModel || model);
    return newModel;
}
function areErrorsVisible(controlState) {
    return controlState.invalid && controlState.dirty && controlState.touched && controlState.errors.length > 0;
}
var FormField = function (props) {
    var className = props.className, children = props.children, onFieldUpdate = props.onFieldUpdate, controlModel = props.controlModel, forceUpperCaseText = props.forceUpperCaseText, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(props, ["className", "children", "onFieldUpdate", "controlModel", "forceUpperCaseText"]);
    var onChange = function (e) {
        var model = props.controlModel;
        var newModel = controlOnChange(model, e, forceUpperCaseText);
        if (newModel !== model && props.onFieldUpdate) {
            props.onFieldUpdate(newModel);
        }
    };
    var onBlur = function (e) {
        var model = props.controlModel;
        var newModel = controlOnBlur(model, e);
        if (newModel !== model && props.onFieldUpdate) {
            props.onFieldUpdate(newModel);
        }
    };
    var childrenProps = {
        controlProps: createControlProps(controlModel, onChange, onBlur),
        labelProps: {
            htmlFor: controlModel.id,
            'aria-owns': controlModel.id
        },
        errorProps: {
            prefix: controlModel.id,
            errors: areErrorsVisible(controlModel.state) ? controlModel.state.errors : undefined,
            messages: controlModel.errorMessages || {}
        }
    };
    var cn = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-form__field', { 'h-form__field--dirty': controlModel.state.dirty }, { 'h-form__field--pristine': controlModel.state.pristine }, { 'h-form__field--valid': controlModel.state.valid }, { 'h-form__field--invalid': controlModel.state.invalid }, { 'h-form__field--touched': controlModel.state.touched }, { 'h-form__field--untouched': controlModel.state.untouched }, className);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ className: cn }, otherProps), children(childrenProps)));
};
//# sourceMappingURL=field.js.map

/***/ }),
/* 480 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClickAwayListener; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_event_listener__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_event_listener__);




/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 * Brought from:
 * https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/ClickAwayListener/ClickAwayListener.js
 */
var ClickAwayListener = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(ClickAwayListener, _super);
    function ClickAwayListener() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.node = null;
        _this.mounted = false;
        // tslint:disable-next-line:no-any
        _this.handleClickAway = function (event) {
            // Ignore events that have been `event.preventDefault()` marked.
            if (event.defaultPrevented) {
                return;
            }
            // IE11 support, which trigger the handleClickAway even after the unbind
            if (!_this.mounted) {
                return;
            }
            // The child might render null.
            if (!_this.node) {
                return;
            }
            var doc = _this.node.ownerDocument || document;
            if (doc.documentElement &&
                doc.documentElement.contains(event.target) &&
                !_this.node.contains(event.target)) {
                _this.props.onClickAway(event);
            }
        };
        return _this;
    }
    ClickAwayListener.prototype.componentDidMount = function () {
        this.node = __WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"](this);
        this.mounted = true;
    };
    ClickAwayListener.prototype.componentWillUnmount = function () {
        this.mounted = false;
    };
    ClickAwayListener.prototype.render = function () {
        var _a = this.props, children = _a.children, mouseEvent = _a.mouseEvent, touchEvent = _a.touchEvent, onClickAway = _a.onClickAway, other = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["children", "mouseEvent", "touchEvent", "onClickAway"]);
        // tslint:disable-next-line:no-any
        var listenerProps = {};
        if (mouseEvent !== false) {
            listenerProps[mouseEvent || ClickAwayListener.defaultProps.mouseEvent] = this.handleClickAway;
        }
        if (touchEvent !== false) {
            listenerProps[touchEvent || ClickAwayListener.defaultProps.touchEvent] = this.handleClickAway;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_event_listener___default.a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ target: "document" }, listenerProps, other), children));
    };
    ClickAwayListener.defaultProps = {
        mouseEvent: 'onMouseUp',
        touchEvent: 'onTouchEnd',
    };
    return ClickAwayListener;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=click-away-listener.js.map

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(93)["default"];
var toPrimitive = __webpack_require__(483);
function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(93)["default"];
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 484 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 485 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 486 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(488);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InnerPopper */
/* unused harmony export placements */
/* harmony export (immutable) */ __webpack_exports__["a"] = Popper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_popper_js__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Manager__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(207);












var initialStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  pointerEvents: 'none'
};

var initialArrowStyle = {};

var InnerPopper = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(InnerPopper, _React$Component);

  function InnerPopper() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InnerPopper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = InnerPopper.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(InnerPopper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      popperNode: undefined,
      arrowNode: undefined,
      popperInstance: undefined,
      data: undefined
    }, _this.setPopperNode = function (popperNode) {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* safeInvoke */])(_this.props.innerRef, popperNode);
      _this.setState({ popperNode: popperNode });
    }, _this.setArrowNode = function (arrowNode) {
      return _this.setState({ arrowNode: arrowNode });
    }, _this.updateStateModifier = {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        _this.setState({ data: data });
        return data;
      }
    }, _this.getOptions = function () {
      return {
        placement: _this.props.placement,
        eventsEnabled: _this.props.eventsEnabled,
        positionFixed: _this.props.positionFixed,
        modifiers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.props.modifiers, {
          arrow: {
            enabled: !!_this.state.arrowNode,
            element: _this.state.arrowNode
          },
          applyStyle: { enabled: false },
          updateStateModifier: _this.updateStateModifier
        })
      };
    }, _this.getPopperStyle = function () {
      return !_this.state.popperNode || !_this.state.data ? initialStyle : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        position: _this.state.data.offsets.popper.position
      }, _this.state.data.styles);
    }, _this.getPopperPlacement = function () {
      return !_this.state.data ? undefined : _this.state.data.placement;
    }, _this.getArrowStyle = function () {
      return !_this.state.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
    }, _this.getOutOfBoundariesState = function () {
      return _this.state.data ? _this.state.data.hide : undefined;
    }, _this.initPopperInstance = function () {
      var referenceElement = _this.props.referenceElement;
      var _this$state = _this.state,
          popperNode = _this$state.popperNode,
          popperInstance = _this$state.popperInstance;

      if (referenceElement && popperNode && !popperInstance) {
        var _popperInstance = new __WEBPACK_IMPORTED_MODULE_7_popper_js__["default"](referenceElement, popperNode, _this.getOptions());
        _this.setState({ popperInstance: _popperInstance });
        return true;
      }
      return false;
    }, _this.destroyPopperInstance = function (callback) {
      if (_this.state.popperInstance) {
        _this.state.popperInstance.destroy();
      }
      _this.setState({ popperInstance: undefined }, callback);
    }, _this.updatePopperInstance = function () {
      if (_this.state.popperInstance) {
        _this.destroyPopperInstance(function () {
          return _this.initPopperInstance();
        });
      }
    }, _this.scheduleUpdate = function () {
      if (_this.state.popperInstance) {
        _this.state.popperInstance.scheduleUpdate();
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(InnerPopper, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      // If needed, initialize the Popper.js instance
      // it will return `true` if it initialized a new instance, or `false` otherwise
      // if it returns `false`, we make sure Popper props haven't changed, and update
      // the Popper.js instance if needed
      if (!this.initPopperInstance()) {
        // If the Popper.js options have changed, update the instance (destroy + create)
        if (this.props.placement !== prevProps.placement || this.props.eventsEnabled !== prevProps.eventsEnabled || this.state.arrowNode !== prevState.arrowNode || this.state.popperNode !== prevState.popperNode || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed) {
          this.updatePopperInstance();
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.state.popperInstance) {
        this.state.popperInstance.destroy();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return Object(__WEBPACK_IMPORTED_MODULE_9__utils__["b" /* unwrapArray */])(this.props.children)({
        ref: this.setPopperNode,
        style: this.getPopperStyle(),
        placement: this.getPopperPlacement(),
        outOfBoundaries: this.getOutOfBoundariesState(),
        scheduleUpdate: this.scheduleUpdate,
        arrowProps: {
          ref: this.setArrowNode,
          style: this.getArrowStyle()
        }
      });
    }
  }]);

  return InnerPopper;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

InnerPopper.defaultProps = {
  placement: 'bottom',
  eventsEnabled: true,
  referenceElement: undefined,
  positionFixed: false
};
var placements = __WEBPACK_IMPORTED_MODULE_7_popper_js__["default"].placements;


function Popper(props) {
  return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](
    __WEBPACK_IMPORTED_MODULE_8__Manager__["a" /* ManagerContext */].Consumer,
    null,
    function (_ref2) {
      var referenceNode = _ref2.referenceNode;
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](InnerPopper, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ referenceElement: referenceNode }, props));
    }
  );
}

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(491);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(26);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(492);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(493);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(494);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(107);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Reference;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_warning__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Manager__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(207);











var InnerReference = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(InnerReference, _React$Component);

  function InnerReference() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InnerReference);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = InnerReference.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(InnerReference)).call.apply(_ref, [this].concat(args))), _this), _this.refHandler = function (node) {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* safeInvoke */])(_this.props.innerRef, node);
      Object(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* safeInvoke */])(_this.props.getReferenceRef, node);
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(InnerReference, [{
    key: 'render',
    value: function render() {
      __WEBPACK_IMPORTED_MODULE_7_warning___default()(this.props.getReferenceRef, '`Reference` should not be used outside of a `Manager` component.');
      return Object(__WEBPACK_IMPORTED_MODULE_9__utils__["b" /* unwrapArray */])(this.props.children)({ ref: this.refHandler });
    }
  }]);

  return InnerReference;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

function Reference(props) {
  return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](
    __WEBPACK_IMPORTED_MODULE_8__Manager__["a" /* ManagerContext */].Consumer,
    null,
    function (_ref2) {
      var getReferenceRef = _ref2.getReferenceRef;
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](InnerReference, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ getReferenceRef: getReferenceRef }, props));
    }
  );
}

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

var tabbable = __webpack_require__(499);
var xtend = __webpack_require__(500);

var listeningFocusTrap = null;

function focusTrap(element, userOptions) {
  var doc = document;
  var container =
    typeof element === 'string' ? doc.querySelector(element) : element;

  var config = xtend(
    {
      returnFocusOnDeactivate: true,
      escapeDeactivates: true
    },
    userOptions
  );

  var state = {
    firstTabbableNode: null,
    lastTabbableNode: null,
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false
  };

  var trap = {
    activate: activate,
    deactivate: deactivate,
    pause: pause,
    unpause: unpause
  };

  return trap;

  function activate(activateOptions) {
    if (state.active) return;

    updateTabbableNodes();

    state.active = true;
    state.paused = false;
    state.nodeFocusedBeforeActivation = doc.activeElement;

    var onActivate =
      activateOptions && activateOptions.onActivate
        ? activateOptions.onActivate
        : config.onActivate;
    if (onActivate) {
      onActivate();
    }

    addListeners();
    return trap;
  }

  function deactivate(deactivateOptions) {
    if (!state.active) return;

    removeListeners();
    state.active = false;
    state.paused = false;

    var onDeactivate =
      deactivateOptions && deactivateOptions.onDeactivate !== undefined
        ? deactivateOptions.onDeactivate
        : config.onDeactivate;
    if (onDeactivate) {
      onDeactivate();
    }

    var returnFocus =
      deactivateOptions && deactivateOptions.returnFocus !== undefined
        ? deactivateOptions.returnFocus
        : config.returnFocusOnDeactivate;
    if (returnFocus) {
      delay(function() {
        tryFocus(state.nodeFocusedBeforeActivation);
      });
    }

    return trap;
  }

  function pause() {
    if (state.paused || !state.active) return;
    state.paused = true;
    removeListeners();
  }

  function unpause() {
    if (!state.paused || !state.active) return;
    state.paused = false;
    addListeners();
  }

  function addListeners() {
    if (!state.active) return;

    // There can be only one listening focus trap at a time
    if (listeningFocusTrap) {
      listeningFocusTrap.pause();
    }
    listeningFocusTrap = trap;

    updateTabbableNodes();

    // Delay ensures that the focused element doesn't capture the event
    // that caused the focus trap activation.
    delay(function() {
      tryFocus(getInitialFocusNode());
    });
    doc.addEventListener('focusin', checkFocusIn, true);
    doc.addEventListener('mousedown', checkPointerDown, true);
    doc.addEventListener('touchstart', checkPointerDown, true);
    doc.addEventListener('click', checkClick, true);
    doc.addEventListener('keydown', checkKey, true);

    return trap;
  }

  function removeListeners() {
    if (!state.active || listeningFocusTrap !== trap) return;

    doc.removeEventListener('focusin', checkFocusIn, true);
    doc.removeEventListener('mousedown', checkPointerDown, true);
    doc.removeEventListener('touchstart', checkPointerDown, true);
    doc.removeEventListener('click', checkClick, true);
    doc.removeEventListener('keydown', checkKey, true);

    listeningFocusTrap = null;

    return trap;
  }

  function getNodeForOption(optionName) {
    var optionValue = config[optionName];
    var node = optionValue;
    if (!optionValue) {
      return null;
    }
    if (typeof optionValue === 'string') {
      node = doc.querySelector(optionValue);
      if (!node) {
        throw new Error('`' + optionName + '` refers to no known node');
      }
    }
    if (typeof optionValue === 'function') {
      node = optionValue();
      if (!node) {
        throw new Error('`' + optionName + '` did not return a node');
      }
    }
    return node;
  }

  function getInitialFocusNode() {
    var node;
    if (getNodeForOption('initialFocus') !== null) {
      node = getNodeForOption('initialFocus');
    } else if (container.contains(doc.activeElement)) {
      node = doc.activeElement;
    } else {
      node = state.firstTabbableNode || getNodeForOption('fallbackFocus');
    }

    if (!node) {
      throw new Error(
        "You can't have a focus-trap without at least one focusable element"
      );
    }

    return node;
  }

  // This needs to be done on mousedown and touchstart instead of click
  // so that it precedes the focus event.
  function checkPointerDown(e) {
    if (container.contains(e.target)) return;
    if (config.clickOutsideDeactivates) {
      deactivate({
        returnFocus: !tabbable.isFocusable(e.target)
      });
    } else {
      e.preventDefault();
    }
  }

  // In case focus escapes the trap for some strange reason, pull it back in.
  function checkFocusIn(e) {
    // In Firefox when you Tab out of an iframe the Document is briefly focused.
    if (container.contains(e.target) || e.target instanceof Document) {
      return;
    }
    e.stopImmediatePropagation();
    tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
  }

  function checkKey(e) {
    if (config.escapeDeactivates !== false && isEscapeEvent(e)) {
      e.preventDefault();
      deactivate();
      return;
    }
    if (isTabEvent(e)) {
      checkTab(e);
      return;
    }
  }

  // Hijack Tab events on the first and last focusable nodes of the trap,
  // in order to prevent focus from escaping. If it escapes for even a
  // moment it can end up scrolling the page and causing confusion so we
  // kind of need to capture the action at the keydown phase.
  function checkTab(e) {
    updateTabbableNodes();
    if (e.shiftKey && e.target === state.firstTabbableNode) {
      e.preventDefault();
      tryFocus(state.lastTabbableNode);
      return;
    }
    if (!e.shiftKey && e.target === state.lastTabbableNode) {
      e.preventDefault();
      tryFocus(state.firstTabbableNode);
      return;
    }
  }

  function checkClick(e) {
    if (config.clickOutsideDeactivates) return;
    if (container.contains(e.target)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }

  function updateTabbableNodes() {
    var tabbableNodes = tabbable(container);
    state.firstTabbableNode = tabbableNodes[0] || getInitialFocusNode();
    state.lastTabbableNode =
      tabbableNodes[tabbableNodes.length - 1] || getInitialFocusNode();
  }

  function tryFocus(node) {
    if (node === doc.activeElement) return;
    if (!node || !node.focus) {
      tryFocus(getInitialFocusNode());
      return;
    }

    node.focus();
    state.mostRecentlyFocusedNode = node;
    if (isSelectableInput(node)) {
      node.select();
    }
  }
}

function isSelectableInput(node) {
  return (
    node.tagName &&
    node.tagName.toLowerCase() === 'input' &&
    typeof node.select === 'function'
  );
}

function isEscapeEvent(e) {
  return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}

function isTabEvent(e) {
  return e.key === 'Tab' || e.keyCode === 9;
}

function delay(fn) {
  return setTimeout(fn, 0);
}

module.exports = focusTrap;


/***/ }),
/* 499 */
/***/ (function(module, exports) {

var candidateSelectors = [
  'input',
  'select',
  'textarea',
  'a[href]',
  'button',
  '[tabindex]',
  'audio[controls]',
  'video[controls]',
  '[contenteditable]:not([contenteditable="false"])',
];
var candidateSelector = candidateSelectors.join(',');

var matches = typeof Element === 'undefined'
  ? function () {}
  : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

function tabbable(el, options) {
  options = options || {};

  var elementDocument = el.ownerDocument || el;
  var regularTabbables = [];
  var orderedTabbables = [];

  var untouchabilityChecker = new UntouchabilityChecker(elementDocument);
  var candidates = el.querySelectorAll(candidateSelector);

  if (options.includeContainer) {
    if (matches.call(el, candidateSelector)) {
      candidates = Array.prototype.slice.apply(candidates);
      candidates.unshift(el);
    }
  }

  var i, candidate, candidateTabindex;
  for (i = 0; i < candidates.length; i++) {
    candidate = candidates[i];

    if (!isNodeMatchingSelectorTabbable(candidate, untouchabilityChecker)) continue;

    candidateTabindex = getTabindex(candidate);
    if (candidateTabindex === 0) {
      regularTabbables.push(candidate);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        node: candidate,
      });
    }
  }

  var tabbableNodes = orderedTabbables
    .sort(sortOrderedTabbables)
    .map(function(a) { return a.node })
    .concat(regularTabbables);

  return tabbableNodes;
}

tabbable.isTabbable = isTabbable;
tabbable.isFocusable = isFocusable;

function isNodeMatchingSelectorTabbable(node, untouchabilityChecker) {
  if (
    !isNodeMatchingSelectorFocusable(node, untouchabilityChecker)
    || isNonTabbableRadio(node)
    || getTabindex(node) < 0
  ) {
    return false;
  }
  return true;
}

function isTabbable(node, untouchabilityChecker) {
  if (!node) throw new Error('No node provided');
  if (matches.call(node, candidateSelector) === false) return false;
  return isNodeMatchingSelectorTabbable(node, untouchabilityChecker);
}

function isNodeMatchingSelectorFocusable(node, untouchabilityChecker) {
  untouchabilityChecker = untouchabilityChecker || new UntouchabilityChecker(node.ownerDocument || node);
  if (
    node.disabled
    || isHiddenInput(node)
    || untouchabilityChecker.isUntouchable(node)
  ) {
    return false;
  }
  return true;
}

var focusableCandidateSelector = candidateSelectors.concat('iframe').join(',');
function isFocusable(node, untouchabilityChecker) {
  if (!node) throw new Error('No node provided');
  if (matches.call(node, focusableCandidateSelector) === false) return false;
  return isNodeMatchingSelectorFocusable(node, untouchabilityChecker);
}

function getTabindex(node) {
  var tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);
  if (!isNaN(tabindexAttr)) return tabindexAttr;
  // Browsers do not return `tabIndex` correctly for contentEditable nodes;
  // so if they don't have a tabindex attribute specifically set, assume it's 0.
  if (isContentEditable(node)) return 0;
  return node.tabIndex;
}

function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
}

// Array.prototype.find not available in IE.
function find(list, predicate) {
  for (var i = 0, length = list.length; i < length; i++) {
    if (predicate(list[i])) return list[i];
  }
}

function isContentEditable(node) {
  return node.contentEditable === 'true';
}

function isInput(node) {
  return node.tagName === 'INPUT';
}

function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
}

function isRadio(node) {
  return isInput(node) && node.type === 'radio';
}

function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
}

function getCheckedRadio(nodes) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked) {
      return nodes[i];
    }
  }
}

function isTabbableRadio(node) {
  if (!node.name) return true;
  // This won't account for the edge case where you have radio groups with the same
  // in separate forms on the same page.
  var radioSet = node.ownerDocument.querySelectorAll('input[type="radio"][name="' + node.name + '"]');
  var checked = getCheckedRadio(radioSet);
  return !checked || checked === node;
}

// An element is "untouchable" if *it or one of its ancestors* has
// `visibility: hidden` or `display: none`.
function UntouchabilityChecker(elementDocument) {
  this.doc = elementDocument;
  // Node cache must be refreshed on every check, in case
  // the content of the element has changed. The cache contains tuples
  // mapping nodes to their boolean result.
  this.cache = [];
}

// getComputedStyle accurately reflects `visibility: hidden` of ancestors
// but not `display: none`, so we need to recursively check parents.
UntouchabilityChecker.prototype.hasDisplayNone = function hasDisplayNone(node, nodeComputedStyle) {
  if (node.nodeType !== Node.ELEMENT_NODE) return false;

    // Search for a cached result.
    var cached = find(this.cache, function(item) {
      return item === node;
    });
    if (cached) return cached[1];

    nodeComputedStyle = nodeComputedStyle || this.doc.defaultView.getComputedStyle(node);

    var result = false;

    if (nodeComputedStyle.display === 'none') {
      result = true;
    } else if (node.parentNode) {
      result = this.hasDisplayNone(node.parentNode);
    }

    this.cache.push([node, result]);

    return result;
}

UntouchabilityChecker.prototype.isUntouchable = function isUntouchable(node) {
  if (node === this.doc.documentElement) return false;
  var computedStyle = this.doc.defaultView.getComputedStyle(node);
  if (this.hasDisplayNone(node, computedStyle)) return true;
  return computedStyle.visibility === 'hidden';
}

module.exports = tabbable;


/***/ }),
/* 500 */
/***/ (function(module, exports) {

module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),
/* 501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToDo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__to_do_css__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__to_do_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__to_do_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__button_button__ = __webpack_require__(75);




var ToDo = function (_a) {
    var id = _a.id, title = _a.title, icon = _a.icon, className = _a.className, linkUrl = _a.linkUrl, completed = _a.completed, disabled = _a.disabled, callToActionText = _a.callToActionText, displayCallToAction = _a.displayCallToAction, adaCallToActionDescription = _a.adaCallToActionDescription, isCompactMode = _a.isCompactMode, onClick = _a.onClick, children = _a.children;
    var adaDescriptionId = "todo_" + id;
    var containsPii = title.toLocaleLowerCase().includes('booking');
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(isCompactMode ? 'h-to-do' : 'h-to-do__expanded', className, { 'h-to-do--disabled': disabled }) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-to-do-col__left" },
            icon && icon.src && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "h-to-do__icon", src: icon.src, alt: icon.alt, "aria-hidden": true })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                completed ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { "data-pii": containsPii, id: adaDescriptionId, className: "h-to-do__title--completed", dangerouslySetInnerHTML: { __html: title } })) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { "data-pii": containsPii, href: linkUrl, onClick: onClick, id: adaDescriptionId, className: "h-to-do__title", dangerouslySetInnerHTML: { __html: title } })),
                children && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-to-do__description" }, children),
                isCompactMode && completed && !disabled && displayCallToAction && callToActionText && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: linkUrl, onClick: onClick, className: "h-to-do__link h-to-do__description", "aria-label": adaCallToActionDescription, "aria-labelledby": adaCallToActionDescription ? undefined : adaDescriptionId, dangerouslySetInnerHTML: { __html: callToActionText } })))),
        !isCompactMode && !disabled && displayCallToAction && callToActionText && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-to-do__cta" }, completed ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { "data-pii": containsPii, href: linkUrl, onClick: onClick, className: "h-to-do__link", "aria-label": adaCallToActionDescription, "aria-labelledby": adaCallToActionDescription ? undefined : adaDescriptionId, dangerouslySetInnerHTML: { __html: callToActionText } })) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__button_button__["b" /* LinkButton */], { "data-pii": containsPii, href: linkUrl, onClick: onClick, block: true, "aria-label": adaCallToActionDescription, "aria-labelledby": adaCallToActionDescription ? undefined : adaDescriptionId, dangerouslySetInnerHTML: { __html: callToActionText } }))))));
};
//# sourceMappingURL=to-do.js.map

/***/ }),
/* 504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChevronCircle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_colors__ = __webpack_require__(42);



function mapDirectionToRotation(direction) {
    switch (direction) {
        case 'up':
            return 'rotate(270deg)';
        case 'down':
            return 'rotate(90deg)';
        case 'left':
            return 'rotate(180deg)';
        default:
            return 'rotate(0deg)';
    }
}
function mapShadowMode(shadowMode) {
    switch (shadowMode) {
        case 'simple':
            return 'drop-shadow(rgba(132, 132, 132, .5) 0px 0px 3px)';
        default:
            return undefined;
    }
}
var ChevronCircle = function (_a) {
    var direction = _a.direction, size = _a.size, circleColor = _a.circleColor, circleFill = _a.circleFill, chevronColor = _a.chevronColor, shadowMode = _a.shadowMode, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["direction", "size", "circleColor", "circleFill", "chevronColor", "shadowMode"]);
    var styles = {
        transform: mapDirectionToRotation(direction),
        filter: mapShadowMode(shadowMode)
    };
    circleColor = circleColor || 'rgba(15, 85, 154, 0.3)';
    circleFill = circleFill || __WEBPACK_IMPORTED_MODULE_2__styles_colors__["f" /* WhiteColor */];
    chevronColor = chevronColor || __WEBPACK_IMPORTED_MODULE_2__styles_colors__["b" /* Blue600Color */];
    /* tslint:disable */
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: size, height: size, style: styles }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("circle", { fill: circleFill, r: "15.5", cy: "16", cx: "16", stroke: circleColor }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { fill: "none", strokeWidth: "2", strokeLinejoin: "round", strokeLinecap: "round", stroke: chevronColor, d: "M15 19l3-2.945L15 13" })));
    /* tslint:enable */
};
//# sourceMappingURL=chevron-circle.js.map

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isFullMode;
function isFullMode() {
    var el = document.getElementById('host-mode');
    return el && el.value === 'full';
}
//# sourceMappingURL=hosting.js.map

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parse;
/* unused harmony export getDetailsParams */
function parse() {
    if (!window.location.search) {
        return {};
    }
    var hash = {};
    window.location.search.substring(1).split('&').map(function (n) { return n.split('='); }).forEach(function (kv) {
        hash[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
    });
    return hash;
}
function getDetailsParams() {
    return parse();
}
//# sourceMappingURL=querystring.js.map

/***/ }),
/* 508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlertsManagerContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cclr_huge_ui_dist_src_components_alerts_alerts_manager__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_content_service__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__alert_manager_service__ = __webpack_require__(209);





var AlertsManagerContainer = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(AlertsManagerContainer, _super);
    function AlertsManagerContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            data: null,
            content: null,
        };
        return _this;
    }
    AlertsManagerContainer.prototype.componentDidMount = function () {
        this.fetchData();
    };
    AlertsManagerContainer.prototype.render = function () {
        var _a = this.state, data = _a.data, content = _a.content;
        if (!data || !content) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_cclr_huge_ui_dist_src_components_alerts_alerts_manager__["a" /* AlertsManager */], { data: data, content: content, onEmailSignUp: __WEBPACK_IMPORTED_MODULE_4__alert_manager_service__["a" /* emailOptIn */] }));
    };
    AlertsManagerContainer.prototype.fetchData = function () {
        var _this = this;
        Promise.all([
            Object(__WEBPACK_IMPORTED_MODULE_4__alert_manager_service__["b" /* fetchAlerts */])(this.props.shipCode, this.props.sailDate),
            Object(__WEBPACK_IMPORTED_MODULE_3__common_content_service__["a" /* getContent */])('BCE8093A-5A59-4182-BF6B-097B61CE3EAA'),
        ]).then(function (results) {
            var data = results[0], content = results[1];
            _this.setState({
                data: data,
                content: content,
            });
        });
    };
    return AlertsManagerContainer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=alerts-manager-container.js.map

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlertsManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notification_notification__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__alert_todo__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__alert_email_signup__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__alert_homepage_advisory__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__alerts_manager_css__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__alerts_manager_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__alerts_manager_css__);







var AlertsManager = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(AlertsManager, _super);
    function AlertsManager(props) {
        var _this = _super.call(this, props) || this;
        _this.renderAlert = function (alert) {
            var _a;
            var content = _this.props.content;
            var alertId = getAlertId(alert);
            if (!alertId) {
                return null;
            }
            switch (alert.alertType) {
                case 'Todo':
                    // tslint:disable-next-line:no-any
                    var closeMode = alert.content.tags.indexOf('Payment.CourtesyHold') >= 0
                        || alert.content.tags.indexOf('HealthAssessment.Available') >= 0
                        || alert.content.notificationType === 'urgent' ? 'manual' : 'auto';
                    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__notification_notification__["a" /* Notification */], { key: alertId, type: (_a = alert.content.notificationType) !== null && _a !== void 0 ? _a : 'info', hideIcon: true, mode: "none", closeAriaLabel: content.autoCloseAriaLabel, closeMode: closeMode, onClose: _this.onNotificationClosed.bind(_this, alertId), bodyClassName: "container", "aria-hidden": true },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__alert_todo__["a" /* AlertTodo */], { alert: alert, alertId: alertId, content: content })));
                case 'EmailSignup':
                    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__alert_email_signup__["a" /* AlertEmailSignup */], { key: alertId, alert: alert, alertId: alertId, content: _this.props.content, onEmailSignUp: _this.props.onEmailSignUp, onNotificationClosed: _this.onNotificationClosed.bind(_this, alertId) }));
                case 'HomePageAdvisory':
                    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { "aria-live": "assertive", role: "alert", key: alertId },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__notification_notification__["a" /* Notification */], { type: "info", hideIcon: true, mode: "none", closeAriaLabel: content.autoCloseAriaLabel, closeMode: "auto", onClose: _this.onNotificationClosed.bind(_this, alertId), bodyClassName: "container", "aria-hidden": true },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__alert_homepage_advisory__["a" /* AlertHomePageAdvisory */], { alertId: alertId, alert: alert }))));
                default:
                    return null;
            }
        };
        _this.onNotificationClosed = function (alertId) {
            _this.setState(function (state) {
                var _a;
                var newHiddenAlertIds = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, state.hiddenAlertIds), (_a = {}, _a[alertId] = Date.now(), _a));
                saveToLocalStorage(newHiddenAlertIds);
                return {
                    hiddenAlertIds: newHiddenAlertIds,
                };
            });
        };
        var storedValues = loadFromLocalStorage();
        var nonExpiredValues = cleanExpired(storedValues, _this.props.data.hiddenTimeInHours);
        _this.state = {
            hiddenAlertIds: nonExpiredValues,
        };
        return _this;
    }
    AlertsManager.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.data !== this.props.data ||
            prevProps.data.hiddenTimeInHours !== this.props.data.hiddenTimeInHours) {
            var storedValues = loadFromLocalStorage();
            var nonExpiredValues = cleanExpired(storedValues, this.props.data.hiddenTimeInHours);
            this.setState({
                hiddenAlertIds: nonExpiredValues,
            });
        }
    };
    AlertsManager.prototype.render = function () {
        var visibleAlerts = this.getVisibleNotifications();
        if (!visibleAlerts || visibleAlerts.length < 1) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null, visibleAlerts.map(this.renderAlert)));
    };
    AlertsManager.prototype.getVisibleNotifications = function () {
        var data = this.props.data;
        var hiddenAlertIds = this.state.hiddenAlertIds;
        return data.alerts
            .filter(function (alert) {
            var alertId = getAlertId(alert);
            if (!alertId) {
                return false;
            }
            var closedTime = hiddenAlertIds[alertId];
            return !closedTime ||
                ((Date.now() - closedTime) / 1000 / 60 / 60) > data.hiddenTimeInHours;
        })
            .slice(0, data.showMaxCount);
    };
    return AlertsManager;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

var LocalStorageKey = 'hiddenAlerts';
function saveToLocalStorage(hiddenAlertIds) {
    var value = JSON.stringify(hiddenAlertIds);
    localStorage.setItem(LocalStorageKey, value);
}
function loadFromLocalStorage() {
    var value = localStorage.getItem(LocalStorageKey);
    if (!value) {
        return {};
    }
    var hiddenAlertIds = JSON.parse(value);
    return hiddenAlertIds ? hiddenAlertIds : {};
}
function getAlertId(alert) {
    if (!alert.alertType || !alert.content || !alert.content.tags) {
        return null;
    }
    var type = alert.alertType.trim().replace(' ', '_');
    var tags = alert.content.tags.trim().replace(' ', '_');
    if (alert.alertType === 'Todo') {
        var title = alert.content.title ? alert.content.title.trim().replace(' ', '_') : '';
        return type + "_" + tags + "_" + title;
    }
    if (alert.alertType === 'HomePageAdvisory') {
        return type + "_" + tags + "_" + alert.content.name;
    }
    return type + "_" + tags;
}
function cleanExpired(values, hiddenTimeInHours) {
    var nonExpiredValues = Object.keys(values)
        .filter(function (key) {
        var closedTime = values[key];
        return ((Date.now() - closedTime) / 1000 / 60 / 60) < hiddenTimeInHours;
    })
        .reduce(function (previousValue, key) {
        var _a;
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, previousValue), (_a = {}, _a[key] = values[key], _a));
    }, {});
    saveToLocalStorage(nonExpiredValues);
    return nonExpiredValues;
}
//# sourceMappingURL=alerts-manager.js.map

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CloseTimerIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_colors__ = __webpack_require__(42);




// tslint:disable:max-line-length
var CloseTimerIcon = function (_a) {
    var width = _a.width, height = _a.height, className = _a.className, percent = _a.percent, _b = _a.color, color = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_3__styles_colors__["f" /* WhiteColor */] : _b, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height", "className", "percent", "color"]);
    var cn = __WEBPACK_IMPORTED_MODULE_2_classnames__("h-close-timer-icon", className);
    var circumference = 106.814; // 2 * Pi * r
    var progress = percent / 100;
    var dashOffset = circumference * (1 - progress);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 34 34", width: width || 34, height: height || 34, className: cn, style: { transform: 'rotate(-90deg)' } }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("circle", { cx: "17", cy: "17", r: "16", fill: "none", strokeWidth: "1", stroke: __WEBPACK_IMPORTED_MODULE_3__styles_colors__["d" /* Gray500Color */] }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("circle", { cx: "17", cy: "17", r: "16", fill: "none", strokeWidth: "2", stroke: color, strokeDasharray: circumference, strokeDashoffset: dashOffset }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M12.763 12.91l8.632 8.337m-.148-8.484l-8.336 8.632", stroke: color, strokeLinecap: "round", strokeWidth: "2" })));
};
// tslint:enable:max-line-length
//# sourceMappingURL=close-timer-icon.js.map

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Timer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var Timer = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Timer, _super);
    function Timer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.timeoutId = 0;
        _this.state = {
            counter: 0,
            paused: false,
        };
        _this.clearTimeout = function () {
            window.clearInterval(_this.timeoutId);
        };
        _this.tick = function () {
            var _a = _this.props, maxIterations = _a.maxIterations, onTerminate = _a.onTerminate;
            if (maxIterations && _this.state.counter >= maxIterations) {
                _this.clearTimeout();
                if (typeof onTerminate === 'function') {
                    onTerminate();
                }
            }
            else {
                if (!_this.state.paused) {
                    _this.setState(function (prevState) {
                        return {
                            counter: prevState.counter + 1
                        };
                    });
                }
            }
        };
        return _this;
    }
    Timer.prototype.componentDidMount = function () {
        this.timeoutId = window.setInterval(this.tick, this.props.intervalMs);
    };
    Timer.prototype.componentWillUnmount = function () {
        window.clearInterval(this.timeoutId);
    };
    Timer.prototype.render = function () {
        return this.props.children(this.state.counter, this.clearTimeout);
    };
    Timer.prototype.pause = function () {
        this.setState({ paused: true });
    };
    Timer.prototype.resume = function () {
        this.setState({ paused: false });
    };
    return Timer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=timer.js.map

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlertTodo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icon_icon__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_button__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eyebrow_eyebrow__ = __webpack_require__(92);




var AlertTodo = function (_a) {
    var alert = _a.alert, alertId = _a.alertId, content = _a.content;
    var adaDescribedById = "alert_" + alertId;
    var imageSource = alert.content.alertIcon || alert.content.icon;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-alert" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-alert__content-container" },
            imageSource &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__icon_icon__["a" /* Icon */], { className: "h-alert__icon", src: imageSource.src, alt: imageSource.alt, "aria-hidden": true }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-alert__content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__eyebrow_eyebrow__["a" /* Eyebrow */], null, alert.content.todoAlertEyebrowOverride || content.todoEyebrow),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { "data-pii": "true", id: adaDescribedById, dangerouslySetInnerHTML: { __html: alert.content.title } }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { dangerouslySetInnerHTML: { __html: alert.content.description } }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-alert__actions" },
            alert.content.displayCallToActionInAlert && alert.content.callToActionUrl && alert.content.callToActionText && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__button_button__["b" /* LinkButton */], { href: alert.content.callToActionUrl, size: "small", color: alert.content.notificationType === 'urgent' ? 'outline-white' : 'red', "aria-label": alert.content.adaCallToActionDescription, "aria-labelledby": alert.content.adaCallToActionDescription ? undefined : adaDescribedById, dangerouslySetInnerHTML: { __html: alert.content.callToActionText } })),
            alert.content.secondaryCtaUrl && alert.content.secondaryCtaText && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__button_button__["b" /* LinkButton */], { href: alert.content.secondaryCtaUrl, color: "outline-black", size: "small", "aria-label": alert.content.adaSecondaryCtaDescription, dangerouslySetInnerHTML: { __html: alert.content.secondaryCtaText } })))));
};
//# sourceMappingURL=alert-todo.js.map

/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlertEmailSignup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icon_icon__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__button_button__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__notification_notification__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__visually_hidden_visually_hidden__ = __webpack_require__(517);






var AlertEmailSignup = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(AlertEmailSignup, _super);
    function AlertEmailSignup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            pending: false,
            operationSuccess: null,
        };
        _this.onSignUp = function (event) {
            event.preventDefault();
            _this.setState({ pending: true, operationSuccess: null });
            _this.props.onEmailSignUp()
                .then(function () {
                _this.setState({ pending: false, operationSuccess: true });
            })
                .catch(function () {
                _this.setState({ pending: false, operationSuccess: false });
            });
        };
        return _this;
    }
    AlertEmailSignup.prototype.render = function () {
        var _a = this.props, content = _a.content, onNotificationClosed = _a.onNotificationClosed;
        var operationSuccess = this.state.operationSuccess;
        if (operationSuccess === null) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__notification_notification__["a" /* Notification */], { type: "info", hideIcon: operationSuccess === null, mode: "none", closeAriaLabel: content.closeAriaLabel, closeMode: "manual", onClose: onNotificationClosed, bodyClassName: "container" }, this.renderAlert()));
        }
        var alertContent = operationSuccess
            ? content.emailSignUpSuccessMessage
            : content.emailSignUpErrorMessage;
        var notificationType = operationSuccess ? 'success' : 'error';
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { "aria-live": "assertive", role: "alert" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__notification_notification__["a" /* Notification */], { type: notificationType, hideIcon: operationSuccess === null, mode: "none", closeAriaLabel: content.autoCloseAriaLabel, closeMode: "auto", onClose: onNotificationClosed, bodyClassName: "container" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { dangerouslySetInnerHTML: { __html: alertContent } }))));
    };
    AlertEmailSignup.prototype.renderAlert = function () {
        var _a = this.props, alert = _a.alert, alertId = _a.alertId;
        var pending = this.state.pending;
        var alertDescription = alert.email
            ? alert.content.description.replace('{email}', alert.email)
            : alert.content.description;
        var adaButtonDescriptionId = "alert_" + alertId;
        var adaButtonDescription = alert.content.callToActionText + " for " + alertDescription;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-alert" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-alert__content-container" },
                alert.content.icon &&
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__icon_icon__["a" /* Icon */], { className: "h-alert__icon", src: alert.content.icon.src, alt: alert.content.icon.alt, "aria-hidden": true }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-alert__content" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { dangerouslySetInnerHTML: { __html: alert.content.title } }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { "data-pii": "true", dangerouslySetInnerHTML: { __html: alertDescription } }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], null,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { id: adaButtonDescriptionId, "aria-hidden": true, dangerouslySetInnerHTML: { __html: adaButtonDescription } })))),
            alert.content.callToActionUrl && alert.content.callToActionText && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-alert__actions" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__button_button__["a" /* Button */], { onClick: this.onSignUp, busy: pending, disabled: pending, size: "small", "aria-label": alert.content.adaCallToActionDescription, "aria-labelledby": alert.content.adaCallToActionDescription ? undefined : adaButtonDescriptionId }, alert.content.callToActionText)))));
    };
    return AlertEmailSignup;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=alert-email-signup.js.map

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VisuallyHidden; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var style = {
    border: '0',
    clip: 'rect(0 0 0 0)',
    height: '1px',
    width: '1px',
    margin: '-1px',
    padding: '0',
    overflow: 'hidden',
    position: 'absolute',
    outline: 'none'
};
var VisuallyHidden = function (_a) {
    var children = _a.children, elRef = _a.elRef, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["children", "elRef"]);
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ style: style, ref: elRef }, otherProps), children);
};
//# sourceMappingURL=visually-hidden.js.map

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlertHomePageAdvisory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icon_icon__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_button__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eyebrow_eyebrow__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dropdown_dropdown__ = __webpack_require__(196);





var AlertHomePageAdvisory = function (_a) {
    var alert = _a.alert, alertId = _a.alertId;
    var adaDescribedById = "alert_" + alertId;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-alert" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-alert__content-container" },
                alert.content.icon &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__icon_icon__["a" /* Icon */], { className: "h-alert__icon", src: alert.content.icon.src, alt: alert.content.icon.alt, "aria-hidden": true }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-alert__content" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__eyebrow_eyebrow__["a" /* Eyebrow */], null, alert.content.title),
                    alert.content.description && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: adaDescribedById, dangerouslySetInnerHTML: { __html: alert.content.description } }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-alert__actions" }, alert.content.callToActionUrl && alert.content.callToActionText && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__button_button__["b" /* LinkButton */], { href: alert.content.callToActionUrl, target: "_blank", size: "small", "aria-label": alert.content.adaCallToActionDescription, "aria-labelledby": alert.content.adaCallToActionDescription ? undefined : adaDescribedById, dangerouslySetInnerHTML: { __html: alert.content.callToActionText } })))),
        alert.content.expandedMessage &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-alert__homepage-advisory__text" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__dropdown_dropdown__["a" /* Dropdown */], { id: alertId + "-extended", title: alert.content.callToActionText, display: "relative", buttonAriaLabel: alert.content.adaCallToActionDescription },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { dangerouslySetInnerHTML: { __html: alert.content.expandedMessage } })))));
};
//# sourceMappingURL=alert-homepage-advisory.js.map

/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/ecma262/#sec-array.prototype.find
// tslint:disable
if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
        value: function (predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }
            var o = Object(this);
            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;
            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }
            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];
            // 5. Let k be 0.
            var k = 0;
            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return kValue.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue;
                }
                // e. Increase k by 1.
                k++;
            }
            // 7. Return undefined.
            return undefined;
        },
        configurable: true,
        writable: true
    });
}
//# sourceMappingURL=find.polyfill.js.map

/***/ }),
/* 521 */
/***/ (function(module, exports) {

//# sourceMappingURL=sitecore.js.map

/***/ }),
/* 522 */
/***/ (function(module, exports) {

//# sourceMappingURL=common.js.map

/***/ }),
/* 523 */
/***/ (function(module, exports) {

//# sourceMappingURL=models.js.map

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AlertsManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notification_notification__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__alert_todo__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__alert_email_signup__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__alert_homepage_advisory__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__alerts_manager_css__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__alerts_manager_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__alerts_manager_css__);







var AlertsManager = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(AlertsManager, _super);
    function AlertsManager(props) {
        var _this = _super.call(this, props) || this;
        _this.renderAlert = function (alert) {
            var _a;
            var content = _this.props.content;
            var alertId = getAlertId(alert);
            if (!alertId) {
                return null;
            }
            switch (alert.alertType) {
                case 'Todo':
                    // tslint:disable-next-line:no-any
                    var closeMode = alert.content.tags.indexOf('Payment.CourtesyHold') >= 0
                        || alert.content.tags.indexOf('HealthAssessment.Available') >= 0
                        || alert.content.notificationType === 'urgent' ? 'manual' : 'auto';
                    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__notification_notification__["a" /* Notification */], { key: alertId, type: (_a = alert.content.notificationType) !== null && _a !== void 0 ? _a : 'info', hideIcon: true, mode: "none", closeAriaLabel: content.autoCloseAriaLabel, closeMode: closeMode, onClose: _this.onNotificationClosed.bind(_this, alertId), bodyClassName: "container", "aria-hidden": true },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__alert_todo__["a" /* AlertTodo */], { alert: alert, alertId: alertId, content: content })));
                case 'EmailSignup':
                    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__alert_email_signup__["a" /* AlertEmailSignup */], { key: alertId, alert: alert, alertId: alertId, content: _this.props.content, onEmailSignUp: _this.props.onEmailSignUp, onNotificationClosed: _this.onNotificationClosed.bind(_this, alertId) }));
                case 'HomePageAdvisory':
                    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { "aria-live": "assertive", role: "alert", key: alertId },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__notification_notification__["a" /* Notification */], { type: "info", hideIcon: true, mode: "none", closeAriaLabel: content.autoCloseAriaLabel, closeMode: "auto", onClose: _this.onNotificationClosed.bind(_this, alertId), bodyClassName: "container", "aria-hidden": true },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__alert_homepage_advisory__["a" /* AlertHomePageAdvisory */], { alertId: alertId, alert: alert }))));
                default:
                    return null;
            }
        };
        _this.onNotificationClosed = function (alertId) {
            _this.setState(function (state) {
                var _a;
                var newHiddenAlertIds = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, state.hiddenAlertIds), (_a = {}, _a[alertId] = Date.now(), _a));
                saveToLocalStorage(newHiddenAlertIds);
                return {
                    hiddenAlertIds: newHiddenAlertIds,
                };
            });
        };
        var storedValues = loadFromLocalStorage();
        var nonExpiredValues = cleanExpired(storedValues, _this.props.data.hiddenTimeInHours);
        _this.state = {
            hiddenAlertIds: nonExpiredValues,
        };
        return _this;
    }
    AlertsManager.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.data !== this.props.data ||
            prevProps.data.hiddenTimeInHours !== this.props.data.hiddenTimeInHours) {
            var storedValues = loadFromLocalStorage();
            var nonExpiredValues = cleanExpired(storedValues, this.props.data.hiddenTimeInHours);
            this.setState({
                hiddenAlertIds: nonExpiredValues,
            });
        }
    };
    AlertsManager.prototype.render = function () {
        var visibleAlerts = this.getVisibleNotifications();
        if (!visibleAlerts || visibleAlerts.length < 1) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null, visibleAlerts.map(this.renderAlert)));
    };
    AlertsManager.prototype.getVisibleNotifications = function () {
        var data = this.props.data;
        var hiddenAlertIds = this.state.hiddenAlertIds;
        return data.alerts
            .filter(function (alert) {
            var alertId = getAlertId(alert);
            if (!alertId) {
                return false;
            }
            var closedTime = hiddenAlertIds[alertId];
            return !closedTime ||
                ((Date.now() - closedTime) / 1000 / 60 / 60) > data.hiddenTimeInHours;
        })
            .slice(0, data.showMaxCount);
    };
    return AlertsManager;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

var LocalStorageKey = 'hiddenAlerts';
function saveToLocalStorage(hiddenAlertIds) {
    var value = JSON.stringify(hiddenAlertIds);
    localStorage.setItem(LocalStorageKey, value);
}
function loadFromLocalStorage() {
    var value = localStorage.getItem(LocalStorageKey);
    if (!value) {
        return {};
    }
    var hiddenAlertIds = JSON.parse(value);
    return hiddenAlertIds ? hiddenAlertIds : {};
}
function getAlertId(alert) {
    if (!alert.alertType || !alert.content || !alert.content.tags) {
        return null;
    }
    var type = alert.alertType.trim().replace(' ', '_');
    var tags = alert.content.tags.trim().replace(' ', '_');
    if (alert.alertType === 'Todo') {
        var title = alert.content.title ? alert.content.title.trim().replace(' ', '_') : '';
        return type + "_" + tags + "_" + title;
    }
    if (alert.alertType === 'HomePageAdvisory') {
        return type + "_" + tags + "_" + alert.content.name;
    }
    return type + "_" + tags;
}
function cleanExpired(values, hiddenTimeInHours) {
    var nonExpiredValues = Object.keys(values)
        .filter(function (key) {
        var closedTime = values[key];
        return ((Date.now() - closedTime) / 1000 / 60 / 60) < hiddenTimeInHours;
    })
        .reduce(function (previousValue, key) {
        var _a;
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, previousValue), (_a = {}, _a[key] = values[key], _a));
    }, {});
    saveToLocalStorage(nonExpiredValues);
    return nonExpiredValues;
}
//# sourceMappingURL=alerts-manager.js.map

/***/ }),
/* 525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 526 */
/***/ (function(module, exports) {

//# sourceMappingURL=icon-props.js.map

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CirclePlusIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var CirclePlusIcon = function (_a) {
    var width = _a.width, height = _a.height, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: width || 32, height: height || 32 }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("circle", { stroke: "#0F559A", fill: "none", opacity: ".3", cx: "16", cy: "16", r: "15.5" }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { stroke: "#0F559A", fill: "none", d: "M9.74 16h12.52M16 9.74v12.52", strokeWidth: "2", strokeLinecap: "round" })));
};
//# sourceMappingURL=circle-plus-icon.js.map

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CloseIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var CloseIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color, circleOpacity = _a.circleOpacity, circleStrokeWidth = _a.circleStrokeWidth, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height", "color", "circleOpacity", "circleStrokeWidth"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 34 34", width: width || 34, height: height || 34 }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("circle", { opacity: circleOpacity || '.6', strokeWidth: circleStrokeWidth, cx: "17", cy: "17", r: "16", fill: "transparent", stroke: color }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M12.763 12.91l8.632 8.337m-.148-8.484l-8.336 8.632", stroke: color, strokeLinecap: "round", strokeWidth: "2" })));
};
//# sourceMappingURL=close-icon.js.map

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfoIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var InfoIcon = function (_a) {
    var width = _a.width, height = _a.height, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", width: width || 16, height: height || 16 }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("text", { fontSize: "12", fontWeight: "bold", fill: "#0F559A" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tspan", { x: "6", y: "12" }, "i")),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("circle", { fill: "none", stroke: "#0F559A", opacity: ".3", cx: "8", cy: "8", r: "7.5" })));
};
//# sourceMappingURL=info-icon.js.map

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SadFaceIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_colors__ = __webpack_require__(6);



// tslint:disable:max-line-length
var SadFaceIcon = function (_a) {
    var width = _a.width, height = _a.height, _b = _a.color, color = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_2__styles_colors__["i" /* WhiteColor */] : _b, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height", "color"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", width: width || 16, height: height || 16 }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("mask", { id: "b" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M0 0h16v16H0z", fill: color })),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 2.021a5.986 5.986 0 0 1 5.979 5.98A5.986 5.986 0 0 1 8 13.978 5.986 5.986 0 0 1 2.021 8 5.986 5.986 0 0 1 8 2.021", fill: color, mask: "url(#b)" }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M10.205 10.963A2.958 2.958 0 0 0 8 9.983c-.883 0-1.676.384-2.22.997", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M7 5.987a1.008 1.008 0 1 1-2.015 0 1.008 1.008 0 0 1 2.015 0M11.01 5.987a1.008 1.008 0 1 1-2.015 0 1.008 1.008 0 0 1 2.016 0", fill: color })));
};
// tslint:enable:max-line-length
//# sourceMappingURL=sad-face-icon.js.map

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CheckmarkIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


// tslint:disable:max-line-length
var CheckmarkIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height", "color"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", width: width || 16, height: height || 16 }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M15.388 3.755l-9.791 9.751-4.21-4.182", stroke: color || '#FFF', strokeWidth: "2", fill: "none", strokeLinecap: "round", strokeLinejoin: "round" })));
};
// tslint:enable:max-line-length
//# sourceMappingURL=checkmark-icon.js.map

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BedIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


// tslint:disable:max-line-length
var BedIcon = function (_a) {
    var width = _a.width, height = _a.height, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 22 22", width: width || 32, height: height || 32 }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M1.948 9.572h15.363c1.99 0 3.62 1.62 3.62 3.602v1.825c0 .497-.404.9-.905.9H1.948a.903.903 0 0 1-.905-.9v-4.527c0-.495.407-.9.905-.9z", stroke: "#000", fill: "#FFF", strokeWidth: "2" }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M1.043 2.358l.038 17.157M20.93 14.11l.039 5.405", stroke: "#000", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M7.371 8.668H1.947V7.312c0-.746.61-1.356 1.356-1.356h2.712c.746 0 1.356.61 1.356 1.356v1.356z", fill: "#000" })));
};
// tslint:enable:max-line-length
//# sourceMappingURL=bed-icon.js.map

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CabinIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cabin_suite_icon__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cabin_balcony_icon__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cabin_interior_porthole_icon__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cabin_oceanview_icon__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cabin_interior_icon__ = __webpack_require__(210);







var CabinIcon = function (_a) {
    var metaCategoryCode = _a.metaCategoryCode, stateroomTypeName = _a.stateroomTypeName, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["metaCategoryCode", "stateroomTypeName"]);
    if (metaCategoryCode === 'ST' || metaCategoryCode === 'SU') {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__cabin_suite_icon__["a" /* CabinSuiteIcon */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, otherProps));
    }
    if (metaCategoryCode === 'BL' || metaCategoryCode === 'OB') {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__cabin_balcony_icon__["a" /* CabinBalconyIcon */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, otherProps));
    }
    if (metaCategoryCode === 'OS' || metaCategoryCode === 'OV') {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__cabin_oceanview_icon__["a" /* CabinOceanviewIcon */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, otherProps));
    }
    if (stateroomTypeName && stateroomTypeName.toLowerCase().indexOf('porthole') >= 0) {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__cabin_interior_porthole_icon__["a" /* CabinInteriorPortholeIcon */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, otherProps));
    }
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__cabin_interior_icon__["a" /* CabinInteriorIcon */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, otherProps));
};
//# sourceMappingURL=cabin-icon.js.map

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


// tslint:disable:max-line-length
var EditIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height", "color"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: width || '24', height: height || '24' },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", { fill: "none", fillRule: "evenodd" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M0 0h20v20H0z" }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { transform: "translate(0 3.593)", d: "M14 0H6a6 6 0 0 0-6 6v8a6 6 0 0 0 6 6h8a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6m0 2c2.206 0 4 1.794 4 4v8c0 2.206-1.794 4-4 4H6c-2.206 0-4-1.794-4-4V6c0-2.206 1.794-4 4-4h8", fill: color || '#000' }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M20.88 0c-.408 0-.832.174-1.161.517L9.584 11.08c-.301.313-.48.728-.498 1.15l-.07 1.671c-.035.842.565 1.495 1.36 1.495h.06l1.597-.067a1.637 1.637 0 0 0 1.1-.516L23.27 4.25c.62-.646.669-1.646.11-2.233L21.854.412A1.328 1.328 0 0 0 20.88 0", fill: color || '#000' }))));
};
// tslint:enable:max-line-length
//# sourceMappingURL=edit-icon.js.map

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpinnerIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__spinner_icon_css__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__spinner_icon_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__spinner_icon_css__);




var SpinnerIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color, className = _a.className, circleClassName = _a.circleClassName, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height", "color", "className", "circleClassName"]);
    var wrapperClasses = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-spinner-icon', className);
    var classes = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-spinner-icon__circle', circleClassName);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ className: wrapperClasses, width: width || 24, height: height || 24 }, otherProps, { viewBox: "0 0 50 50" }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("circle", { className: classes, cx: "25", cy: "25", r: "20", fill: "none", stroke: color || undefined, strokeWidth: "5" })));
};
//# sourceMappingURL=spinner-icon.js.map

/***/ }),
/* 536 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExclamationIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_colors__ = __webpack_require__(6);



var ExclamationIcon = function (_a) {
    var width = _a.width, height = _a.height, _b = _a.textColor, textColor = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_2__styles_colors__["b" /* Blue600Color */] : _b, _c = _a.borderColor, borderColor = _c === void 0 ? __WEBPACK_IMPORTED_MODULE_2__styles_colors__["b" /* Blue600Color */] : _c, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height", "textColor", "borderColor"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", width: width || 16, height: height || 16 }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("text", { fontSize: "12", fontWeight: "bold", fill: textColor },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tspan", { x: "6.2", y: "12" }, "!")),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("circle", { fill: "none", stroke: borderColor, strokeWidth: "2", cx: "8", cy: "8", r: "7" })));
};
//# sourceMappingURL=exclamation-icon.js.map

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClockIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


// tslint:disable:max-line-length
var ClockIcon = function (_a) {
    var width = _a.width, height = _a.height, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", width: width || 16, height: height || 16 }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", { fill: "none" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("mask", { id: "b", fill: "#fff" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M0 0h16v16H0z" })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 1.333A6.674 6.674 0 0 1 14.667 8 6.674 6.674 0 0 1 8 14.667 6.674 6.674 0 0 1 1.333 8 6.674 6.674 0 0 1 8 1.333", fill: "#000", mask: "url(#b)" }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M8 3.707v4.149l2.988 2.935c.304.3.82.277 1.071-.066.592-.807.941-1.798.941-2.869 0-2.441-1.813-4.467-4.189-4.847A.708.708 0 0 0 8 3.707", fill: "#000" }))));
};
// tslint:enable:max-line-length
//# sourceMappingURL=clock-icon.js.map

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CloseTimerIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_colors__ = __webpack_require__(6);




// tslint:disable:max-line-length
var CloseTimerIcon = function (_a) {
    var width = _a.width, height = _a.height, className = _a.className, percent = _a.percent, _b = _a.color, color = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_3__styles_colors__["i" /* WhiteColor */] : _b, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height", "className", "percent", "color"]);
    var cn = __WEBPACK_IMPORTED_MODULE_2_classnames__("h-close-timer-icon", className);
    var circumference = 106.814; // 2 * Pi * r
    var progress = percent / 100;
    var dashOffset = circumference * (1 - progress);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 34 34", width: width || 34, height: height || 34, className: cn, style: { transform: 'rotate(-90deg)' } }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("circle", { cx: "17", cy: "17", r: "16", fill: "none", strokeWidth: "1", stroke: __WEBPACK_IMPORTED_MODULE_3__styles_colors__["e" /* Gray500Color */] }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("circle", { cx: "17", cy: "17", r: "16", fill: "none", strokeWidth: "2", stroke: color, strokeDasharray: circumference, strokeDashoffset: dashOffset }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M12.763 12.91l8.632 8.337m-.148-8.484l-8.336 8.632", stroke: color, strokeLinecap: "round", strokeWidth: "2" })));
};
// tslint:enable:max-line-length
//# sourceMappingURL=close-timer-icon.js.map

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlertTodo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icon_icon__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eyebrow_eyebrow__ = __webpack_require__(13);




var AlertTodo = function (_a) {
    var alert = _a.alert, alertId = _a.alertId, content = _a.content;
    var adaDescribedById = "alert_" + alertId;
    var imageSource = alert.content.alertIcon || alert.content.icon;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-alert" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-alert__content-container" },
            imageSource &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__icon_icon__["a" /* Icon */], { className: "h-alert__icon", src: imageSource.src, alt: imageSource.alt, "aria-hidden": true }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-alert__content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__eyebrow_eyebrow__["a" /* Eyebrow */], null, alert.content.todoAlertEyebrowOverride || content.todoEyebrow),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { "data-pii": "true", id: adaDescribedById, dangerouslySetInnerHTML: { __html: alert.content.title } }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { dangerouslySetInnerHTML: { __html: alert.content.description } }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-alert__actions" },
            alert.content.displayCallToActionInAlert && alert.content.callToActionUrl && alert.content.callToActionText && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__button_button__["b" /* LinkButton */], { href: alert.content.callToActionUrl, size: "small", color: alert.content.notificationType === 'urgent' ? 'outline-white' : 'red', "aria-label": alert.content.adaCallToActionDescription, "aria-labelledby": alert.content.adaCallToActionDescription ? undefined : adaDescribedById, dangerouslySetInnerHTML: { __html: alert.content.callToActionText } })),
            alert.content.secondaryCtaUrl && alert.content.secondaryCtaText && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__button_button__["b" /* LinkButton */], { href: alert.content.secondaryCtaUrl, color: "outline-black", size: "small", "aria-label": alert.content.adaSecondaryCtaDescription, dangerouslySetInnerHTML: { __html: alert.content.secondaryCtaText } })))));
};
//# sourceMappingURL=alert-todo.js.map

/***/ }),
/* 541 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 542 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 543 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlertEmailSignup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icon_icon__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__notification_notification__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__visually_hidden_visually_hidden__ = __webpack_require__(14);






var AlertEmailSignup = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(AlertEmailSignup, _super);
    function AlertEmailSignup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            pending: false,
            operationSuccess: null,
        };
        _this.onSignUp = function (event) {
            event.preventDefault();
            _this.setState({ pending: true, operationSuccess: null });
            _this.props.onEmailSignUp()
                .then(function () {
                _this.setState({ pending: false, operationSuccess: true });
            })
                .catch(function () {
                _this.setState({ pending: false, operationSuccess: false });
            });
        };
        return _this;
    }
    AlertEmailSignup.prototype.render = function () {
        var _a = this.props, content = _a.content, onNotificationClosed = _a.onNotificationClosed;
        var operationSuccess = this.state.operationSuccess;
        if (operationSuccess === null) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__notification_notification__["a" /* Notification */], { type: "info", hideIcon: operationSuccess === null, mode: "none", closeAriaLabel: content.closeAriaLabel, closeMode: "manual", onClose: onNotificationClosed, bodyClassName: "container" }, this.renderAlert()));
        }
        var alertContent = operationSuccess
            ? content.emailSignUpSuccessMessage
            : content.emailSignUpErrorMessage;
        var notificationType = operationSuccess ? 'success' : 'error';
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { "aria-live": "assertive", role: "alert" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__notification_notification__["a" /* Notification */], { type: notificationType, hideIcon: operationSuccess === null, mode: "none", closeAriaLabel: content.autoCloseAriaLabel, closeMode: "auto", onClose: onNotificationClosed, bodyClassName: "container" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { dangerouslySetInnerHTML: { __html: alertContent } }))));
    };
    AlertEmailSignup.prototype.renderAlert = function () {
        var _a = this.props, alert = _a.alert, alertId = _a.alertId;
        var pending = this.state.pending;
        var alertDescription = alert.email
            ? alert.content.description.replace('{email}', alert.email)
            : alert.content.description;
        var adaButtonDescriptionId = "alert_" + alertId;
        var adaButtonDescription = alert.content.callToActionText + " for " + alertDescription;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-alert" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-alert__content-container" },
                alert.content.icon &&
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__icon_icon__["a" /* Icon */], { className: "h-alert__icon", src: alert.content.icon.src, alt: alert.content.icon.alt, "aria-hidden": true }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-alert__content" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { dangerouslySetInnerHTML: { __html: alert.content.title } }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { "data-pii": "true", dangerouslySetInnerHTML: { __html: alertDescription } }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], null,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { id: adaButtonDescriptionId, "aria-hidden": true, dangerouslySetInnerHTML: { __html: adaButtonDescription } })))),
            alert.content.callToActionUrl && alert.content.callToActionText && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-alert__actions" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__button_button__["a" /* Button */], { onClick: this.onSignUp, busy: pending, disabled: pending, size: "small", "aria-label": alert.content.adaCallToActionDescription, "aria-labelledby": alert.content.adaCallToActionDescription ? undefined : adaButtonDescriptionId }, alert.content.callToActionText)))));
    };
    return AlertEmailSignup;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=alert-email-signup.js.map

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlertHomePageAdvisory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icon_icon__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eyebrow_eyebrow__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dropdown_dropdown__ = __webpack_require__(110);





var AlertHomePageAdvisory = function (_a) {
    var alert = _a.alert, alertId = _a.alertId;
    var adaDescribedById = "alert_" + alertId;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-alert" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-alert__content-container" },
                alert.content.icon &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__icon_icon__["a" /* Icon */], { className: "h-alert__icon", src: alert.content.icon.src, alt: alert.content.icon.alt, "aria-hidden": true }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-alert__content" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__eyebrow_eyebrow__["a" /* Eyebrow */], null, alert.content.title),
                    alert.content.description && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: adaDescribedById, dangerouslySetInnerHTML: { __html: alert.content.description } }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-alert__actions" }, alert.content.callToActionUrl && alert.content.callToActionText && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__button_button__["b" /* LinkButton */], { href: alert.content.callToActionUrl, target: "_blank", size: "small", "aria-label": alert.content.adaCallToActionDescription, "aria-labelledby": alert.content.adaCallToActionDescription ? undefined : adaDescribedById, dangerouslySetInnerHTML: { __html: alert.content.callToActionText } })))),
        alert.content.expandedMessage &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-alert__homepage-advisory__text" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__dropdown_dropdown__["a" /* Dropdown */], { id: alertId + "-extended", title: alert.content.callToActionText, display: "relative", buttonAriaLabel: alert.content.adaCallToActionDescription },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { dangerouslySetInnerHTML: { __html: alert.content.expandedMessage } })))));
};
//# sourceMappingURL=alert-homepage-advisory.js.map

/***/ }),
/* 546 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 548 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MediaOffer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__offer_offer__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__media_offer_css__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__media_offer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__media_offer_css__);





/**
 * This component cannot be made responsive with just CSS because
 * the layout changes for small screens. For large screens the media
 * is shown after the offer:
 * <MediaOffer>
 *  <Offer />
 *  <Media />
 * </MediaOffer>
 *
 * whereas for small screens the media is shown first:
 *
 * <MediaOffer>
 *  <Media />
 *  <Offer />
 * </MediaOffer>
 *
 * While it is doable to switch the order of the
 * <Media /> and <Offer /> components via just CSS, the solution
 * it is not ADA compliant because screen readers read based on the HTML.
 */
var MediaOffer = function (_a) {
    var mode = _a.mode, offerProps = _a.offerProps, className = _a.className, media = _a.media, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["mode", "offerProps", "className", "media"]);
    var classes = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-media-offer', 'h-media-offer--' + mode, className);
    var offerClassName = offerProps.className, otherOfferProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(offerProps, ["className"]);
    var mediaClassName = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-media-offer__media', media.props.className);
    var offer = __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__offer_offer__["a" /* Offer */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-media-offer__offer', offerClassName) }, otherOfferProps));
    var clonedMedia = __WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"](media, { className: mediaClassName });
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ className: classes }, otherProps),
        (mode === 'media-top' || mode === 'media-left') ? clonedMedia : offer,
        (mode === 'media-top' || mode === 'media-left') ? offer : clonedMedia));
};
//# sourceMappingURL=media-offer.js.map

/***/ }),
/* 551 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ToDos */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eyebrow_eyebrow__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__to_dos_css__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__to_dos_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__to_dos_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__booking_selector_booking_selector__ = __webpack_require__(112);







var ToDos = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(ToDos, _super);
    function ToDos() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToDos.prototype.render = function () {
        var _a = this.props, id = _a.id, className = _a.className, eyebrow = _a.eyebrow, heading = _a.heading, children = _a.children, isCompactMode = _a.isCompactMode, bookingSelectorProps = _a.bookingSelectorProps;
        var ddlId = 'h-to-dos-ddl-' + id;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-to-dos', className) },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { id: ddlId, className: "h-to-dos__content" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__eyebrow_eyebrow__["a" /* Eyebrow */], { className: isCompactMode ? 'h-to-dos__eyebrow' : 'h-to-dos__eyebrow-expanded' }, eyebrow),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h2", { className: "h-to-dos__heading" }, heading),
                bookingSelectorProps && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-to-dos__filter" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__booking_selector_booking_selector__["a" /* BookingSelector */], { content: bookingSelectorProps.content, onSelectedBookings: bookingSelectorProps.onSelectedBookings, selectedBookings: bookingSelectorProps.selectedBookings, activeSailing: bookingSelectorProps.activeSailing, parentNameRef: "to-dos" })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__({ 'h-to-dos__list-wrapper': !isCompactMode }) },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("ul", { className: "h-to-dos__list" }, __WEBPACK_IMPORTED_MODULE_1_react__["Children"].map(children, function (toDo) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { className: "h-to-dos__list-item" }, toDo)); })),
                    isCompactMode && this.renderButton(this.props)))));
    };
    ToDos.prototype.renderButton = function (props) {
        var showBottomCta = props.showBottomCta, bottomCtaText = props.bottomCtaText, bottomCtaUrl = props.bottomCtaUrl, bottomCtaClick = props.bottomCtaClick, bottomCtaAriaLabel = props.bottomCtaAriaLabel;
        var classes = {
            'h-to-dos__button--always': showBottomCta,
            'h-to-dos__button--only-mobile': !showBottomCta,
        };
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__button_button__["b" /* LinkButton */], { color: "outline-black", className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-to-dos__button', classes), "aria-label": bottomCtaAriaLabel, href: bottomCtaUrl, onClick: bottomCtaClick }, bottomCtaText));
    };
    return ToDos;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=to-dos.js.map

/***/ }),
/* 553 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 554 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validators; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__custom__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__email__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__required__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__minlength__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__maxlength__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pattern__ = __webpack_require__(561);






var validators = {
    custom: __WEBPACK_IMPORTED_MODULE_0__custom__["a" /* custom */],
    email: __WEBPACK_IMPORTED_MODULE_1__email__["a" /* email */],
    required: __WEBPACK_IMPORTED_MODULE_2__required__["a" /* required */],
    minlength: __WEBPACK_IMPORTED_MODULE_3__minlength__["a" /* minlength */],
    maxlength: __WEBPACK_IMPORTED_MODULE_4__maxlength__["a" /* maxlength */],
    pattern: __WEBPACK_IMPORTED_MODULE_5__pattern__["a" /* pattern */]
};
//# sourceMappingURL=validators.js.map

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = custom;
function custom(value, customValidator) {
    return customValidator(value);
}
//# sourceMappingURL=custom.js.map

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = email;
function email(value) {
    if (value) {
        return /.+@.{2,}\..+/.test(value); // contains @ and a .
    }
    return true;
}
//# sourceMappingURL=email.js.map

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = required;
function required(value, isRequired) {
    if (isRequired) {
        if (typeof value === 'boolean') {
            return value;
        }
        else {
            return !!value && value.length > 0;
        }
    }
    return true;
}
//# sourceMappingURL=required.js.map

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = minlength;
function minlength(value, minLength) {
    if (value) {
        return value.length >= minLength;
    }
    return true;
}
//# sourceMappingURL=minlength.js.map

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = maxlength;
function maxlength(value, maxLength) {
    if (value) {
        return value.length <= maxLength;
    }
    return true;
}
//# sourceMappingURL=maxlength.js.map

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pattern;
function pattern(value, regex) {
    if (value && regex) {
        if (typeof regex === 'string') {
            return new RegExp(regex).test(value);
        }
        else {
            return regex.test(value);
        }
    }
    return true;
}
//# sourceMappingURL=pattern.js.map

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = validateControlGroup;
/* unused harmony export getInvalidControlsFromControlGroup */
/* harmony export (immutable) */ __webpack_exports__["a"] = getErrorMessages;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__control_model__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__control_group__ = __webpack_require__(216);


function validateControlGroup(controlGroup, container) {
    var controls = controlGroup.controls.all.map(function (c) { return Object(__WEBPACK_IMPORTED_MODULE_0__control_model__["c" /* asValidatedDirtyAndTouched */])(c); });
    var validatedControlGroup = __WEBPACK_IMPORTED_MODULE_1__control_group__["a" /* createControlGroup */].apply(void 0, controls);
    if (validatedControlGroup.invalid && container) {
        scrollAndFocusToFirstInvalidElement(container, validatedControlGroup);
    }
    return validatedControlGroup;
}
function getInvalidControlsFromControlGroup(controlGroup) {
    return controlGroup.controls.all.filter(function (c) { return c.state.invalid; });
}
function getErrorMessages(controls) {
    var errors = [];
    for (var i = 0; i < controls.length; i++) {
        var control = controls[i];
        if (control.state.valid) {
            continue;
        }
        for (var j = 0; j < control.state.errors.length; j++) {
            var error = control.state.errors[j];
            var errorMessage = control.errorMessages[error];
            if (errorMessage) {
                errors.push(errorMessage);
            }
        }
    }
    return errors;
}
function scrollAndFocusToFirstInvalidElement(container, controlGroup) {
    if (controlGroup.valid) {
        return;
    }
    var id = getInvalidControlsFromControlGroup(controlGroup)[0].id;
    var input = container.querySelector('#' + id);
    var label = container.querySelector("label[for=\"" + id + "\"]");
    scrollAndFocusElement(input, label);
}
function scrollAndFocusElement(elementToFocus, elementToScroll) {
    (elementToScroll || elementToFocus).scrollIntoView(true);
    elementToFocus.focus();
}
//# sourceMappingURL=form-validation.js.map

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Input; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__input_css__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__input_css__);




var Input = function (_a) {
    var className = _a.className, parentRef = _a.parentRef, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["className", "parentRef"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("input", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ ref: parentRef, className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-form__input', className) }, otherProps)));
};
//# sourceMappingURL=input.js.map

/***/ }),
/* 564 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Checkbox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__checkbox_css__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__checkbox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__checkbox_css__);




var Checkbox = function (_a) {
    var className = _a.className, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["className"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("input", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ type: "checkbox", className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-form__checkbox', className) }, otherProps)));
};
//# sourceMappingURL=checkbox.js.map

/***/ }),
/* 566 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Error; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__error_css__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__error_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__error_css__);




var Error = function (_a) {
    var className = _a.className, errors = _a.errors, children = _a.children, prefix = _a.prefix, messages = _a.messages, role = _a.role, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["className", "errors", "children", "prefix", "messages", "role"]);
    prefix = prefix + '-val-msg-';
    if (!role && errors && errors.length) {
        role = 'alert';
    }
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-form__error', className), role: role }, otherProps), errors && errors.map(function (err, idx) {
        return messages[err] ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: idx, id: prefix + idx, dangerouslySetInnerHTML: { __html: messages[err] } }) : null;
    })));
};
//# sourceMappingURL=error.js.map

/***/ }),
/* 568 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Label; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__label_css__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__label_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__label_css__);




var Label = function (_a) {
    var className = _a.className, children = _a.children, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["className", "children"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("label", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-form__label', className) }, otherProps), children));
};
//# sourceMappingURL=label.js.map

/***/ }),
/* 570 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Select; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chevron_chevron__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__select_css__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__select_css__);





var Select = __WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"](function (_a, ref) {
    var className = _a.className, children = _a.children, value = _a.value, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["className", "children", "value"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__chevron_chevron__["a" /* Chevron */], { className: "h-form__select-arrow", color: "black", size: 14, direction: "down" }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("select", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ ref: ref, className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-form__select', { 'h-form__select--filled': !!value }, className), value: value }, otherProps), children)));
});
//# sourceMappingURL=select.js.map

/***/ }),
/* 572 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Radio; });
/* harmony export (immutable) */ __webpack_exports__["b"] = radioControlProps;
/* harmony export (immutable) */ __webpack_exports__["c"] = radioLabelProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__radio_css__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__radio_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__radio_css__);




var Radio = function (_a) {
    var className = _a.className, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["className"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("input", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ type: "radio", className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-form__radio', className) }, otherProps)));
};
function radioControlProps(controlProps, idSuffix, value) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, controlProps), { id: getId(controlProps.id, idSuffix), value: value, checked: controlProps.value === value, 'aria-checked': controlProps.value === value });
}
function radioLabelProps(labelProps, idSuffix) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, labelProps), { htmlFor: getId(labelProps.htmlFor, idSuffix), 'aria-owns': getId(labelProps['aria-owns'], idSuffix) });
}
function getId(id, idSuffix) {
    var newId = id;
    if (idSuffix) {
        newId += '-' + idSuffix;
    }
    return newId;
}
//# sourceMappingURL=radio.js.map

/***/ }),
/* 574 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createControlProps */
/* unused harmony export controlOnChange */
/* unused harmony export controlOnBlur */
/* unused harmony export areErrorsVisible */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_control_model__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__field_css__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__field_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__field_css__);





function createControlProps(model, onChange, onBlur) {
    return {
        name: model.name,
        id: model.id,
        required: !!(model.validators && model.validators.required),
        value: model.value,
        checked: model.checked,
        'aria-required': model.checked === undefined && model.validators && model.validators.required ? true : undefined,
        'aria-invalid': model.state.invalid,
        'aria-describedby': areErrorsVisible(model.state) ? (model.id + '-val-msg-0') : undefined,
        'aria-checked': model.checked === undefined ? undefined : model.checked,
        onChange: onChange,
        onBlur: onBlur,
        'data-pii': !!model.pii ? 'true' : undefined
    };
}
function controlOnChange(model, e, forceUpperCaseText) {
    var newModel = null;
    if (!e.isDefaultPrevented() && model.updateMode === 'change') {
        if (e.currentTarget.type === 'checkbox') {
            newModel = Object(__WEBPACK_IMPORTED_MODULE_3__models_control_model__["b" /* asTouched */])(Object(__WEBPACK_IMPORTED_MODULE_3__models_control_model__["e" /* withChecked */])(model, e.currentTarget.checked));
        }
        else if (e.currentTarget.type === 'radio') {
            newModel = Object(__WEBPACK_IMPORTED_MODULE_3__models_control_model__["g" /* withValue */])(Object(__WEBPACK_IMPORTED_MODULE_3__models_control_model__["e" /* withChecked */])(model, e.currentTarget.checked), e.currentTarget.value);
        }
        else {
            var value = forceUpperCaseText && e.currentTarget.value ? e.currentTarget.value.toUpperCase() : e.currentTarget.value;
            newModel = Object(__WEBPACK_IMPORTED_MODULE_3__models_control_model__["g" /* withValue */])(model, value);
        }
    }
    newModel = Object(__WEBPACK_IMPORTED_MODULE_3__models_control_model__["a" /* asDirty */])(newModel || model);
    return newModel;
}
function controlOnBlur(model, e) {
    var newModel = null;
    if (!e.isDefaultPrevented() && model.updateMode === 'blur') {
        if (e.currentTarget.type === 'checkbox') {
            newModel = Object(__WEBPACK_IMPORTED_MODULE_3__models_control_model__["e" /* withChecked */])(model, e.currentTarget.checked);
        }
        else {
            newModel = Object(__WEBPACK_IMPORTED_MODULE_3__models_control_model__["g" /* withValue */])(model, e.currentTarget.value);
        }
    }
    newModel = Object(__WEBPACK_IMPORTED_MODULE_3__models_control_model__["b" /* asTouched */])(newModel || model);
    return newModel;
}
function areErrorsVisible(controlState) {
    return controlState.invalid && controlState.dirty && controlState.touched && controlState.errors.length > 0;
}
var FormField = function (props) {
    var className = props.className, children = props.children, onFieldUpdate = props.onFieldUpdate, controlModel = props.controlModel, forceUpperCaseText = props.forceUpperCaseText, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(props, ["className", "children", "onFieldUpdate", "controlModel", "forceUpperCaseText"]);
    var onChange = function (e) {
        var model = props.controlModel;
        var newModel = controlOnChange(model, e, forceUpperCaseText);
        if (newModel !== model && props.onFieldUpdate) {
            props.onFieldUpdate(newModel);
        }
    };
    var onBlur = function (e) {
        var model = props.controlModel;
        var newModel = controlOnBlur(model, e);
        if (newModel !== model && props.onFieldUpdate) {
            props.onFieldUpdate(newModel);
        }
    };
    var childrenProps = {
        controlProps: createControlProps(controlModel, onChange, onBlur),
        labelProps: {
            htmlFor: controlModel.id,
            'aria-owns': controlModel.id
        },
        errorProps: {
            prefix: controlModel.id,
            errors: areErrorsVisible(controlModel.state) ? controlModel.state.errors : undefined,
            messages: controlModel.errorMessages || {}
        }
    };
    var cn = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-form__field', { 'h-form__field--dirty': controlModel.state.dirty }, { 'h-form__field--pristine': controlModel.state.pristine }, { 'h-form__field--valid': controlModel.state.valid }, { 'h-form__field--invalid': controlModel.state.invalid }, { 'h-form__field--touched': controlModel.state.touched }, { 'h-form__field--untouched': controlModel.state.untouched }, className);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ className: cn }, otherProps), children(childrenProps)));
};
//# sourceMappingURL=field.js.map

/***/ }),
/* 576 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 577 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ToDo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__to_do_css__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__to_do_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__to_do_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__button_button__ = __webpack_require__(5);




var ToDo = function (_a) {
    var id = _a.id, title = _a.title, icon = _a.icon, className = _a.className, linkUrl = _a.linkUrl, completed = _a.completed, disabled = _a.disabled, callToActionText = _a.callToActionText, displayCallToAction = _a.displayCallToAction, adaCallToActionDescription = _a.adaCallToActionDescription, isCompactMode = _a.isCompactMode, onClick = _a.onClick, children = _a.children;
    var adaDescriptionId = "todo_" + id;
    var containsPii = title.toLocaleLowerCase().includes('booking');
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(isCompactMode ? 'h-to-do' : 'h-to-do__expanded', className, { 'h-to-do--disabled': disabled }) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-to-do-col__left" },
            icon && icon.src && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "h-to-do__icon", src: icon.src, alt: icon.alt, "aria-hidden": true })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                completed ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { "data-pii": containsPii, id: adaDescriptionId, className: "h-to-do__title--completed", dangerouslySetInnerHTML: { __html: title } })) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { "data-pii": containsPii, href: linkUrl, onClick: onClick, id: adaDescriptionId, className: "h-to-do__title", dangerouslySetInnerHTML: { __html: title } })),
                children && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-to-do__description" }, children),
                isCompactMode && completed && !disabled && displayCallToAction && callToActionText && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: linkUrl, onClick: onClick, className: "h-to-do__link h-to-do__description", "aria-label": adaCallToActionDescription, "aria-labelledby": adaCallToActionDescription ? undefined : adaDescriptionId, dangerouslySetInnerHTML: { __html: callToActionText } })))),
        !isCompactMode && !disabled && displayCallToAction && callToActionText && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-to-do__cta" }, completed ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { "data-pii": containsPii, href: linkUrl, onClick: onClick, className: "h-to-do__link", "aria-label": adaCallToActionDescription, "aria-labelledby": adaCallToActionDescription ? undefined : adaDescriptionId, dangerouslySetInnerHTML: { __html: callToActionText } })) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__button_button__["b" /* LinkButton */], { "data-pii": containsPii, href: linkUrl, onClick: onClick, block: true, "aria-label": adaCallToActionDescription, "aria-labelledby": adaCallToActionDescription ? undefined : adaDescriptionId, dangerouslySetInnerHTML: { __html: callToActionText } }))))));
};
//# sourceMappingURL=to-do.js.map

/***/ }),
/* 579 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 580 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BookedTile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icons_circle_chevron_svg__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icons_circle_chevron_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__icons_circle_chevron_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__booked_tile_css__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__booked_tile_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__booked_tile_css__);




var BookedTile = function (_a) {
    var className = _a.className, iconSrc = _a.iconSrc, title = _a.title, linkUrl = _a.linkUrl, children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__('h-booked-tile', className) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "h-booked-tile__icon", src: iconSrc, width: "24px", alt: "", "aria-hidden": "true" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: "h-booked-tile__content", href: linkUrl },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", { className: "h-booked-tile__content-title" }, title),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "h-booked-tile__content-description" }, children),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "h-booked-tile__content-chevron", src: __WEBPACK_IMPORTED_MODULE_2__icons_circle_chevron_svg___default.a, alt: "", "aria-hidden": "true" }))));
};
//# sourceMappingURL=booked-tile.js.map

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_ui/responsive/ccl/assets/fonts/circle-chevron.svg";

/***/ }),
/* 583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StoreCategoryList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_category_list_css__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_category_list_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__store_category_list_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eyebrow_eyebrow__ = __webpack_require__(13);





var StoreCategoryList = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(StoreCategoryList, _super);
    function StoreCategoryList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StoreCategoryList.prototype.render = function () {
        var _a = this.props, categories = _a.categories, content = _a.content, className = _a.className, eyebrowTagName = _a.eyebrowTagName;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-store-category-list', className) },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__eyebrow_eyebrow__["a" /* Eyebrow */], { className: "h-store-category-list__eyebrow", tagName: eyebrowTagName }, content.shopByCategory),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-store-category-list__list" }, categories && categories.map(function (category, index) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { key: index, href: category.linkUrl, className: "h-store-category-list__item" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", { src: category.icon.src, alt: category.icon.alt, "aria-hidden": true, className: "h-store-category-list__item-icon" }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-store-category-list__item-name" }, category.title))); }))));
    };
    return StoreCategoryList;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=store-category-list.js.map

/***/ }),
/* 585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */
/***/ (function(module, exports) {

//# sourceMappingURL=model.js.map

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CompactItineraryCalendar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eyebrow_eyebrow__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compact_itinerary_calendar_css__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compact_itinerary_calendar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__compact_itinerary_calendar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__compact_itinerary_calendar_day__ = __webpack_require__(589);






var CompactItineraryCalendar = function (_a) {
    var calendar = _a.calendar, className = _a.className, content = _a.content;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__('h-compact-itin-cal', className) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__eyebrow_eyebrow__["a" /* Eyebrow */], { className: "h-compact-itin-cal__eyebrow" }, content.yourPlanner),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h-compact-itin-cal__heading" }, content.heading),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "h-compact-itin-cal__body" }, calendar.days && calendar.days.map(function (day, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__compact_itinerary_calendar_day__["a" /* CompactItineraryCalendarDay */], { key: index, day: day, expandedByDefault: index === 0, fullCalendarUrl: content.fullCalendarUrl })); })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__button_button__["b" /* LinkButton */], { block: true, href: content.fullCalendarUrl, className: "h-compact-itin-cal__cta", color: "outline-black" }, content.fullCalendarText)));
};
//# sourceMappingURL=compact-itinerary-calendar.js.map

/***/ }),
/* 588 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompactItineraryCalendarDay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__compact_itinerary_calendar_day_css__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__compact_itinerary_calendar_day_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__compact_itinerary_calendar_day_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compact_itinerary_calendar_entry__ = __webpack_require__(591);





var CompactItineraryCalendarDay = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(CompactItineraryCalendarDay, _super);
    function CompactItineraryCalendarDay(props) {
        var _this = _super.call(this, props) || this;
        _this.onClick = function (e) {
            e.preventDefault();
            if (_this.props.day.isOverflowPlaceholder) {
                window.location.href = _this.props.fullCalendarUrl;
            }
            _this.setState(function (state) { return ({
                expanded: !state.expanded
            }); });
        };
        _this.state = {
            expanded: !!props.expandedByDefault
        };
        return _this;
    }
    CompactItineraryCalendarDay.prototype.render = function () {
        var _a = this.props, day = _a.day, className = _a.className;
        if (!day) {
            return null;
        }
        var expanded = this.state.expanded;
        var dayClassName = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-compact-itin-cal-day', { 'h-compact-itin-cal-day--expanded': expanded }, className);
        var dayId = day.day.trim().replace(' ', '_');
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { className: dayClassName },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "", className: "h-compact-itin-cal-day__heading", "aria-expanded": expanded, "aria-controls": expanded ? dayId : undefined, onClick: this.onClick },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-compact-itin-cal-day__day" }, day.day),
                !day.isOverflowPlaceholder && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-compact-itin-cal-day__port" }, day.port)),
            !day.isOverflowPlaceholder && expanded && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-compact-itin-cal-day__content", id: dayId }, this.renderEntries()))));
    };
    CompactItineraryCalendarDay.prototype.renderEntries = function () {
        var day = this.props.day;
        if (!day || !day.entries) {
            return null;
        }
        return day.entries.map(function (entry, index) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__compact_itinerary_calendar_entry__["a" /* CompactItineraryCalendarEntry */], { key: index, time: entry.timeHMmTt },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { dangerouslySetInnerHTML: { __html: entry.title } }))); });
    };
    return CompactItineraryCalendarDay;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=compact-itinerary-calendar-day.js.map

/***/ }),
/* 590 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompactItineraryCalendarEntry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__compact_itinerary_calendar_entry_css__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__compact_itinerary_calendar_entry_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__compact_itinerary_calendar_entry_css__);



var CompactItineraryCalendarEntry = function (_a) {
    var className = _a.className, time = _a.time, children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__('h-compact-itin-cal-entry', className) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-compact-itin-cal-entry__time" }, time),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-compact-itin-cal-entry__body" }, children)));
};
//# sourceMappingURL=compact-itinerary-calendar-entry.js.map

/***/ }),
/* 592 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 593 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 594 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 595 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MainNavImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_nav_link__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main_nav_image_css__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main_nav_image_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__main_nav_image_css__);





var MainNavImage = function (_a) {
    var className = _a.className, navItemProps = _a.navItemProps, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["className", "navItemProps"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__main_nav_link__["a" /* MainNavLink */], { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-main-nav__image', className), navItemProps: navItemProps },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, otherProps))));
};
//# sourceMappingURL=main-nav-image.js.map

/***/ }),
/* 597 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainNavDropdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_focus_trap_react__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_focus_trap_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_focus_trap_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_event_listener__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chevron_chevron__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__click_away_listener_click_away_listener__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main_nav_item__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__main_nav_dropdown_positioner__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__main_nav_link__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_colors__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__main_nav_dropdown_css__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__main_nav_dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__main_nav_dropdown_css__);












var MainNavDropdown = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(MainNavDropdown, _super);
    function MainNavDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buttonRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.contentRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.containerRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.state = {
            isOpen: false,
            isOpenFirst: false,
            focusTrapEnabled: true
        };
        _this.focusTrapToggle = function (enable) {
            _this.setState(function (prevState) {
                if (prevState.focusTrapEnabled === enable) {
                    return null;
                }
                return { focusTrapEnabled: enable };
            });
        };
        _this.childrenProps = {
            focusTrapToggle: _this.focusTrapToggle
        };
        _this.toggle = function (e) {
            e.preventDefault();
            _this.setState(function (state) { return ({
                isOpen: !state.isOpen,
                isOpenFirst: state.isOpen === false
            }); });
        };
        _this.close = function (e) {
            if (e.target === _this.buttonRef.current || _this.buttonRef.current.contains(e.target)) {
                return;
            }
            _this.setState(function (prevState) { return prevState.isOpen ? { isOpen: false } : null; });
        };
        _this.onKeyPress = function (e) {
            if (e.keyCode === 27) { // escape key
                if (_this.containerRef.current.contains(e.target)) {
                    _this.setState(function (state) {
                        if (state.isOpen) {
                            _this.buttonRef.current.focus();
                            return { isOpen: false };
                        }
                        return null;
                    });
                }
            }
        };
        return _this;
    }
    MainNavDropdown.prototype.render = function () {
        var _this = this;
        var _a = this.props, title = _a.title, className = _a.className, children = _a.children, navItemProps = _a.navItemProps, eyebrow = _a.eyebrow, id = _a.id, primary = _a.primary, active = _a.active;
        // tslint:disable-next-line:no-any
        var cchildren = children;
        var _b = this.state, isOpen = _b.isOpen, focusTrapEnabled = _b.focusTrapEnabled;
        var cn = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-main-nav__dropdown', className, { 'h-main-nav__dropdown--open': isOpen });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__main_nav_item__["a" /* MainNavItem */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ elRef: this.containerRef, className: cn, active: active }, navItemProps),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_event_listener___default.a, { target: "document", onKeyUp: this.onKeyPress },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_focus_trap_react__, { active: isOpen && focusTrapEnabled, className: "h-main-nav__dropdown__focus-trap" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__main_nav_link__["a" /* MainNavLink */], { embedded: true, onClick: this.toggle, linkRef: this.buttonRef, href: "", "aria-expanded": isOpen, "aria-controls": id, primary: primary },
                        eyebrow && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "h-main-nav__dropdown__eyebrow" }, eyebrow),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "h-dropdown__title" }, title),
                        ' ',
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__chevron_chevron__["a" /* Chevron */], { "aria-hidden": "true", className: "h-dropdown__chevron", size: 16, direction: isOpen ? 'up' : 'down', color: __WEBPACK_IMPORTED_MODULE_10__styles_colors__["c" /* BlueColor */] })),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__main_nav_dropdown_positioner__["a" /* MainNavDropDownPositioner */], { elementRef: this.contentRef }, function (styles) {
                        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: _this.contentRef, id: id, className: "h-main-nav__dropdown-content-box", style: styles },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__click_away_listener_click_away_listener__["a" /* ClickAwayListener */], { onClickAway: _this.close },
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-main-nav__dropdown-content" }, typeof children === 'function'
                                    ? cchildren(_this.childrenProps)
                                    : cchildren)));
                    })))));
    };
    MainNavDropdown.prototype.componentDidUpdate = function () {
        this.setState(function (prevState) { return prevState.isOpenFirst ? { isOpenFirst: false } : null; });
    };
    return MainNavDropdown;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=main-nav-dropdown.js.map

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainNavDropDownPositioner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main_nav_rect__ = __webpack_require__(220);



var MainNavDropDownPositioner = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(MainNavDropDownPositioner, _super);
    function MainNavDropDownPositioner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currentStyles = null;
        return _this;
    }
    MainNavDropDownPositioner.prototype.computeStyles = function (rect) {
        var styles = {};
        if (rect && this.props.elementRef.current) {
            var contentEl = this.props.elementRef.current;
            var contentRect = contentEl.getBoundingClientRect();
            var currLeft = parseFloat(contentEl.style.left || '0');
            var newLeft = currLeft - contentRect.left;
            // tslint:disable-next-line:no-any
            var mainContainer = document.getElementsByClassName('h-main-container')[0];
            var body = document.body;
            var html = document.documentElement;
            var pageHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
            var height = mainContainer && pageHeight
                ? pageHeight - mainContainer.offsetTop
                : '100vh';
            styles = {
                width: document.documentElement.clientWidth + 'px',
                left: newLeft + 'px',
                height: height,
            };
        }
        return styles;
    };
    MainNavDropDownPositioner.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__main_nav_rect__["a" /* MainNavRectContext */].Consumer, null, function (rect) { return (_this.props.children(_this.computeStyles(rect))); }));
    };
    return MainNavDropDownPositioner;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=main-nav-dropdown-positioner.js.map

/***/ }),
/* 600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 601 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 602 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 603 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BookedNav */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_burger_menu__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_burger_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_burger_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__media_query_media_query__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__top_nav_top_nav_full__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__top_nav_top_nav_compact__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__booked_nav_horizontal__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__booked_nav_vertical__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__close_menu_button__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__component_factory__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__booked_nav_css__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__booked_nav_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__booked_nav_css__);












var BookedNav = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(BookedNav, _super);
    function BookedNav(props) {
        var _this = _super.call(this, props) || this;
        _this.componentFactory = new __WEBPACK_IMPORTED_MODULE_10__component_factory__["a" /* ComponentFactory */]();
        _this.restoreFocus = false;
        _this.ref = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.state = {
            isMenuOpen: false
        };
        _this.onHamburgerMenuClick = function (e) {
            e.preventDefault();
            _this.restoreFocus = true;
            _this.setState({ isMenuOpen: true });
        };
        _this.onHamburgerMenuCloseButtonClick = function (e) {
            e.preventDefault();
            _this.restoreFocus = true;
            _this.setState({ isMenuOpen: false });
        };
        _this.onMenuStateChange = function (state) {
            if (_this.state.isMenuOpen !== state.isOpen) {
                _this.restoreFocus = true;
                _this.setState({ isMenuOpen: state.isOpen });
            }
        };
        _this.renderNav = function (renderFull) {
            if (renderFull) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booked-nav__row" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "container" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col" },
                                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__top_nav_top_nav_full__["a" /* TopNavFull */], { items: _this.props.item.fields.desktopTopNavigation.value, data: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, _this.props.data), { idPrefix: 't-' }), componentFactory: _this.componentFactory.get }))))),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booked-nav__row" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "container" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col" },
                                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__booked_nav_horizontal__["a" /* BookedNavHorizontal */], { items: _this.props.item.fields.desktopMainNavigation.value, data: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, _this.props.data), { idPrefix: 'h-' }), componentFactory: _this.componentFactory.get })))))));
            }
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__top_nav_top_nav_compact__["a" /* TopNavCompact */], { className: _this.state.isMenuOpen ? 'h-top-nav-compact--menu-open' : undefined, items: _this.props.item.fields.mobileTopNavigation.value, onBurgerMenuClicked: _this.onHamburgerMenuClick, burgerMenuLabel: _this.props.item.fields.mobileBurgerMenuButtonText.value, componentFactory: _this.componentFactory.get, data: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, _this.props.data), { idPrefix: 'c-' }) }));
        };
        _this.state = {
            isMenuOpen: false
        };
        return _this;
    }
    BookedNav.prototype.render = function () {
        var menuClassName = this.state.isMenuOpen ?
            'h-booked-nav__menu h-booked-nav__menu--visible' :
            'h-booked-nav__menu h-booked-nav__menu--hidden';
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("header", { ref: this.ref, className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-booked-nav', this.props.className) },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_burger_menu__["slide"], { isOpen: this.state.isMenuOpen, onStateChange: this.onMenuStateChange, customBurgerIcon: false, customCrossIcon: false, width: window.innerWidth < 366 ? '275px' : '310px', overlayClassName: 'h-booked-nav__menu-overlay', menuClassName: menuClassName },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__booked_nav_vertical__["a" /* BookedNavVertical */], { items: this.props.item.fields.mobileMainNavigation.value, data: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.props.data), { idPrefix: 'v-' }), componentFactory: this.componentFactory.get })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__close_menu_button__["a" /* CloseMenuButton */], { isOpen: this.state.isMenuOpen, onClick: this.onHamburgerMenuCloseButtonClick, "aria-label": this.props.item.fields.mobileCloseMenuButtonText.value }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("nav", null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__media_query_media_query__["a" /* MediaQuery */], { query: this.props.fullMediaQuery }, this.renderNav))));
    };
    BookedNav.prototype.componentDidUpdate = function () {
        this.restoreFocusIfNeeded();
    };
    BookedNav.prototype.restoreFocusIfNeeded = function () {
        if (this.restoreFocus && this.ref.current) {
            if (this.state.isMenuOpen) {
                this.applyFocus('.h-booked-nav__menu--visible a');
            }
            else {
                this.applyFocus('.h-main-nav__button-hamburger');
            }
            this.restoreFocus = false;
        }
    };
    BookedNav.prototype.applyFocus = function (selector) {
        if (!this.ref.current) {
            return;
        }
        var el = this.ref.current.querySelector(selector);
        if (!el) {
            return;
        }
        el.focus();
    };
    return BookedNav;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=booked-nav.js.map

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = {
  slide: __webpack_require__(606),
  stack: __webpack_require__(610),
  elastic: __webpack_require__(611),
  bubble: __webpack_require__(613),
  push: __webpack_require__(614),
  pushRotate: __webpack_require__(615),
  scaleDown: __webpack_require__(616),
  scaleRotate: __webpack_require__(617),
  fallDown: __webpack_require__(618),
  reveal: __webpack_require__(619)
};
module.exports = exports['default'];

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(37);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
var styles = {
  overlay: function overlay(isOpen) {
    return {
      position: 'fixed',
      zIndex: 1000,
      width: '100%',
      height: '100%',
      background: 'rgba(0, 0, 0, 0.3)',
      opacity: isOpen ? 1 : 0,
      MozTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
      MsTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
      OTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
      WebkitTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
      transform: isOpen ? '' : 'translate3d(100%, 0, 0)',
      transition: isOpen ? 'opacity 0.3s' : 'opacity 0.3s, transform 0s 0.3s'
    };
  },

  menuWrap: function menuWrap(isOpen, width, right) {
    return {
      position: 'fixed',
      right: right ? 0 : 'inherit',
      zIndex: 1100,
      width: width,
      height: '100%',
      MozTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      MsTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      OTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      WebkitTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      transform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      transition: 'all 0.5s'
    };
  },

  menu: function menu() {
    return {
      height: '100%',
      boxSizing: 'border-box',
      overflow: 'auto'
    };
  },

  itemList: function itemList() {
    return {
      height: '100%'
    };
  },

  item: function item() {
    return {
      display: 'block',
      outline: 'none'
    };
  }
};

exports['default'] = styles;
module.exports = exports['default'];

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(26);

var _propTypes2 = _interopRequireDefault(_propTypes);

var BurgerIcon = (function (_Component) {
  _inherits(BurgerIcon, _Component);

  function BurgerIcon(props) {
    _classCallCheck(this, BurgerIcon);

    _get(Object.getPrototypeOf(BurgerIcon.prototype), 'constructor', this).call(this, props);
    this.state = {
      hover: false
    };
  }

  _createClass(BurgerIcon, [{
    key: 'getLineStyle',
    value: function getLineStyle(index) {
      return {
        position: 'absolute',
        height: '20%',
        left: 0,
        right: 0,
        top: 20 * (index * 2) + '%',
        opacity: this.state.hover ? 0.6 : 1
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this = this;

      var icon = undefined;
      var buttonStyle = {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        margin: 0,
        padding: 0,
        border: 'none',
        opacity: 0,
        fontSize: 8,
        cursor: 'pointer'
      };

      if (this.props.customIcon) {
        var extraProps = {
          className: 'bm-icon',
          style: _extends({ width: '100%', height: '100%' }, this.props.styles.bmIcon)
        };
        icon = _react2['default'].cloneElement(this.props.customIcon, extraProps);
      } else {
        icon = _react2['default'].createElement(
          'span',
          null,
          [0, 1, 2].map(function (bar) {
            return _react2['default'].createElement('span', {
              key: bar,
              className: ('bm-burger-bars ' + _this.props.barClassName).trim(),
              style: _extends({}, _this.getLineStyle(bar), _this.props.styles.bmBurgerBars)
            });
          })
        );
      }

      return _react2['default'].createElement(
        'div',
        {
          className: ('bm-burger-button ' + this.props.className).trim(),
          style: _extends({ zIndex: 1000 }, this.props.styles.bmBurgerButton)
        },
        icon,
        _react2['default'].createElement(
          'button',
          {
            onClick: this.props.onClick,
            onMouseOver: function () {
              return _this.setState({ hover: true });
            },
            onMouseOut: function () {
              return _this.setState({ hover: false });
            },
            style: buttonStyle
          },
          'Open Menu'
        )
      );
    }
  }]);

  return BurgerIcon;
})(_react.Component);

exports['default'] = BurgerIcon;

BurgerIcon.propTypes = {
  barClassName: _propTypes2['default'].string,
  customIcon: _propTypes2['default'].element,
  styles: _propTypes2['default'].object
};

BurgerIcon.defaultProps = {
  barClassName: '',
  className: '',
  styles: {}
};
module.exports = exports['default'];

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(26);

var _propTypes2 = _interopRequireDefault(_propTypes);

var CrossIcon = (function (_Component) {
  _inherits(CrossIcon, _Component);

  function CrossIcon() {
    _classCallCheck(this, CrossIcon);

    _get(Object.getPrototypeOf(CrossIcon.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(CrossIcon, [{
    key: 'getCrossStyle',
    value: function getCrossStyle(type) {
      return {
        position: 'absolute',
        width: 3,
        height: 14,
        transform: type === 'before' ? 'rotate(45deg)' : 'rotate(-45deg)'
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this = this;

      var icon;
      var buttonWrapperStyle = {
        position: 'absolute',
        width: 24,
        height: 24,
        right: 8,
        top: 8
      };
      var buttonStyle = {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        margin: 0,
        padding: 0,
        border: 'none',
        textIndent: -9999,
        background: 'transparent',
        outline: 'none',
        cursor: 'pointer'
      };

      if (this.props.customIcon) {
        var extraProps = {
          className: 'bm-cross',
          style: _extends({ width: '100%', height: '100%' }, this.props.styles.bmCross)
        };
        icon = _react2['default'].cloneElement(this.props.customIcon, extraProps);
      } else {
        icon = _react2['default'].createElement(
          'span',
          { style: { position: 'absolute', top: '6px', right: '14px' } },
          ['before', 'after'].map(function (type, i) {
            return _react2['default'].createElement('span', {
              key: i,
              className: ('bm-cross ' + _this.props.crossClassName).trim(),
              style: _extends({}, _this.getCrossStyle(type), _this.props.styles.bmCross)
            });
          })
        );
      }

      return _react2['default'].createElement(
        'div',
        {
          className: ('bm-cross-button ' + this.props.className).trim(),
          style: _extends({}, buttonWrapperStyle, this.props.styles.bmCrossButton)
        },
        icon,
        _react2['default'].createElement(
          'button',
          { onClick: this.props.onClick, style: buttonStyle },
          'Close Menu'
        )
      );
    }
  }]);

  return CrossIcon;
})(_react.Component);

exports['default'] = CrossIcon;

CrossIcon.propTypes = {
  crossClassName: _propTypes2['default'].string,
  customIcon: _propTypes2['default'].element,
  styles: _propTypes2['default'].object
};

CrossIcon.defaultProps = {
  crossClassName: '',
  className: '',
  styles: {}
};
module.exports = exports['default'];

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(37);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {
  menuWrap: function menuWrap(isOpen, width, right) {
    return {
      MozTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      MsTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      OTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      WebkitTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      transform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      transition: isOpen ? 'transform 0.8s cubic-bezier(0.7, 0, 0.3, 1)' : 'transform 0.4s cubic-bezier(0.7, 0, 0.3, 1)'
    };
  },

  item: function item(isOpen, width, right, nthChild) {
    return {
      MozTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
      MsTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
      OTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
      WebkitTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
      transform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
      transition: isOpen ? 'transform 0.8s cubic-bezier(0.7, 0, 0.3, 1)' : 'transform 0s 0.2s cubic-bezier(0.7, 0, 0.3, 1)'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _snapsvgImporter = __webpack_require__(223);

var _snapsvgImporter2 = _interopRequireDefault(_snapsvgImporter);

var _menuFactory = __webpack_require__(37);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {
  svg: {
    lib: _snapsvgImporter2['default'],
    pathInitial: 'M-1,0h101c0,0-97.833,153.603-97.833,396.167C2.167,627.579,100,800,100,800H-1V0z',
    pathOpen: 'M-1,0h101c0,0,0-1,0,395c0,404,0,405,0,405H-1V0z',
    animate: function animate(path) {
      path.animate({ path: this.pathOpen }, 400, window.mina.easeinout);
    }
  },

  morphShape: function morphShape(isOpen, width, right) {
    return {
      position: 'absolute',
      width: 120,
      height: '100%',
      right: right ? 'inherit' : 0,
      left: right ? 0 : 'inherit',
      MozTransform: right ? 'rotateY(180deg)' : '',
      MsTransform: right ? 'rotateY(180deg)' : '',
      OTransform: right ? 'rotateY(180deg)' : '',
      WebkitTransform: right ? 'rotateY(180deg)' : '',
      transform: right ? 'rotateY(180deg)' : ''
    };
  },

  menuWrap: function menuWrap(isOpen, width, right) {
    return {
      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      transition: 'all 0.3s'
    };
  },

  menu: function menu(isOpen, width, right) {
    return {
      position: 'fixed',
      right: right ? 0 : 'inherit',
      width: 180,
      whiteSpace: 'nowrap',
      boxSizing: 'border-box',
      overflow: 'visible'
    };
  },

  itemList: function itemList(isOpen, width, right) {
    if (right) {
      return {
        position: 'relative',
        left: '-110px',
        width: '170%',
        overflow: 'auto'
      };
    }
  },

  pageWrap: function pageWrap(isOpen, width, right) {
    return {
      MozTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
      MsTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
      OTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
      WebkitTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
      transform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
      transition: isOpen ? 'all 0.3s' : 'all 0.3s 0.1s'
    };
  },

  outerContainer: function outerContainer(isOpen) {
    return {
      overflow: isOpen ? '' : 'hidden'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_ui/responsive/ccl/assets/images/snap.svg-cjs.js";

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _snapsvgImporter = __webpack_require__(223);

var _snapsvgImporter2 = _interopRequireDefault(_snapsvgImporter);

var _menuFactory = __webpack_require__(37);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {
  svg: {
    lib: _snapsvgImporter2['default'],
    pathInitial: 'M-7.312,0H0c0,0,0,113.839,0,400c0,264.506,0,400,0,400h-7.312V0z',
    pathOpen: 'M-7.312,0H15c0,0,66,113.339,66,399.5C81,664.006,15,800,15,800H-7.312V0z;M-7.312,0H100c0,0,0,113.839,0,400c0,264.506,0,400,0,400H-7.312V0z',
    animate: function animate(path) {
      var pos = 0;
      var steps = this.pathOpen.split(';');
      var stepsTotal = steps.length;
      var mina = window.mina;

      var nextStep = function nextStep() {
        if (pos > stepsTotal - 1) return;

        path.animate({ path: steps[pos] }, pos === 0 ? 400 : 500, pos === 0 ? mina.easein : mina.elastic, function () {
          nextStep();
        });

        pos++;
      };

      nextStep();
    }
  },

  morphShape: function morphShape(isOpen, width, right) {
    return {
      position: 'absolute',
      width: '100%',
      height: '100%',
      right: right ? 'inherit' : 0,
      left: right ? 0 : 'inherit',
      MozTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
      MsTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
      OTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
      WebkitTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
      transform: right ? 'rotateY(180deg)' : 'rotateY(0deg)'
    };
  },

  menuWrap: function menuWrap(isOpen, width, right) {
    return {
      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      transition: isOpen ? 'transform 0.4s 0s' : 'transform 0.4s'
    };
  },

  menu: function menu(isOpen, width, right) {
    width -= 140;
    return {
      position: 'fixed',
      MozTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      MsTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      OTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      WebkitTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      transform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      transition: isOpen ? 'opacity 0.1s 0.4s cubic-bezier(.17, .67, .1, 1.27), transform 0.1s 0.4s cubic-bezier(.17, .67, .1, 1.27)' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
      opacity: isOpen ? 1 : 0
    };
  },

  item: function item(isOpen, width, right, nthChild) {
    width -= 140;
    return {
      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      transition: isOpen ? 'opacity 0.3s 0.4s, transform 0.3s 0.4s' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
      opacity: isOpen ? 1 : 0
    };
  },

  closeButton: function closeButton(isOpen, width, right) {
    width -= 140;
    return {
      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      transition: isOpen ? 'opacity 0.3s 0.4s cubic-bezier(.17, .67, .1, 1.27), transform 0.3s 0.4s cubic-bezier(.17, .67, .1, 1.27)' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
      opacity: isOpen ? 1 : 0
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(37);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {
  pageWrap: function pageWrap(isOpen, width, right) {
    return {
      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      transition: 'all 0.5s'
    };
  },

  outerContainer: function outerContainer(isOpen) {
    return {
      overflow: isOpen ? '' : 'hidden'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(37);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {
  pageWrap: function pageWrap(isOpen, width, right) {
    return {
      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
      transformOrigin: right ? '100% 50%' : '0% 50%',
      transformStyle: 'preserve-3d',
      transition: 'all 0.5s'
    };
  },

  outerContainer: function outerContainer(isOpen) {
    return {
      perspective: '1500px',
      overflow: isOpen ? '' : 'hidden'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(37);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {
  pageWrap: function pageWrap(isOpen, width) {
    return {
      MozTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
      MsTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
      OTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
      WebkitTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
      transform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
      transformOrigin: '100%',
      transformStyle: 'preserve-3d',
      transition: 'all 0.5s'
    };
  },

  outerContainer: function outerContainer() {
    return {
      perspective: '1500px'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(37);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {
  pageWrap: function pageWrap(isOpen, width, right) {
    return {
      MozTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
      MsTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
      OTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
      WebkitTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
      transform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
      transformStyle: 'preserve-3d',
      transition: 'all 0.5s',
      overflow: isOpen ? '' : 'hidden'
    };
  },

  outerContainer: function outerContainer(isOpen) {
    return {
      perspective: '1500px',
      overflow: isOpen ? '' : 'hidden'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(37);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {
  menuWrap: function menuWrap(isOpen) {
    return {
      MozTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
      MsTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
      OTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
      WebkitTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
      transform: isOpen ? '' : 'translate3d(0, -100%, 0)',
      transition: 'all 0.5s ease-in-out'
    };
  },

  pageWrap: function pageWrap(isOpen, width, right) {
    return {
      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      transition: 'all 0.5s'
    };
  },

  outerContainer: function outerContainer(isOpen) {
    return {
      perspective: '1500px',
      perspectiveOrigin: '0% 50%',
      overflow: isOpen ? '' : 'hidden'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(37);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {
  menuWrap: function menuWrap(isOpen, width, right) {
    return {
      visibility: isOpen ? 'visible' : 'hidden',
      MozTransform: 'translate3d(0, 0, 0)',
      MsTransform: 'translate3d(0, 0, 0)',
      OTransform: 'translate3d(0, 0, 0)',
      WebkitTransform: 'translate3d(0, 0, 0)',
      transform: 'translate3d(0, 0, 0)',
      zIndex: 1000
    };
  },

  overlay: function overlay(isOpen, width, right) {
    return {
      zIndex: 1400,
      MozTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      MsTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      OTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      WebkitTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      transform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      transition: 'all 0.5s',
      visibility: isOpen ? 'visible' : 'hidden'
    };
  },

  pageWrap: function pageWrap(isOpen, width, right) {
    return {
      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      transition: 'all 0.5s',
      zIndex: 1200,
      position: 'relative'
    };
  },

  burgerIcon: function burgerIcon(isOpen, width, right) {
    return {
      MozTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      MsTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      OTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      WebkitTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      transform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      transition: 'all 0.1s',
      position: 'relative',
      zIndex: 1300
    };
  },

  outerContainer: function outerContainer(isOpen) {
    return {
      overflow: isOpen ? '' : 'hidden'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BookedNavHorizontal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main_nav_main_nav__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_nav_helpers__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__booked_nav_horizontal_css__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__booked_nav_horizontal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__booked_nav_horizontal_css__);





var BookedNavHorizontal = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(BookedNavHorizontal, _super);
    function BookedNavHorizontal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderNavItem = function (item) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__main_nav_helpers__["b" /* renderItem */])(item, _this.props.componentFactory, _this.props.data);
        };
        _this.filterNavItem = function (item) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__main_nav_helpers__["a" /* filterItem */])(item, _this.props.data);
        };
        return _this;
    }
    BookedNavHorizontal.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__main_nav_main_nav__["a" /* MainNav */], { className: "h-main-nav--horizontal h-booked-nav-horizontal", useRectProvider: true }, this.props.items.filter(this.filterNavItem).map(this.renderNavItem)));
    };
    return BookedNavHorizontal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=booked-nav-horizontal.js.map

/***/ }),
/* 621 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BookedNavVertical; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_nav_main_nav__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main_nav_helpers__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__booked_nav_vertical_css__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__booked_nav_vertical_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__booked_nav_vertical_css__);






var BookedNavVertical = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(BookedNavVertical, _super);
    function BookedNavVertical() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderNavItem = function (item) {
            return Object(__WEBPACK_IMPORTED_MODULE_4__main_nav_helpers__["b" /* renderItem */])(item, _this.props.componentFactory, _this.props.data);
        };
        _this.filterNavItem = function (item) {
            return Object(__WEBPACK_IMPORTED_MODULE_4__main_nav_helpers__["a" /* filterItem */])(item, _this.props.data);
        };
        return _this;
    }
    BookedNavVertical.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__main_nav_main_nav__["a" /* MainNav */], { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-main-nav', this.props.className), useRectProvider: false }, this.props.items.filter(this.filterNavItem).map(this.renderNavItem)));
    };
    return BookedNavVertical;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=booked-nav-vertical.js.map

/***/ }),
/* 623 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CloseMenuButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icons_circle_x_svg__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icons_circle_x_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__icons_circle_x_svg__);




var CloseMenuButton = function (_a) {
    var isOpen = _a.isOpen, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["isOpen"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-booked-nav__menu-close', { 'h-booked-nav__menu-close--hidden': !isOpen }) }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", { width: "32px", height: "32px", src: __WEBPACK_IMPORTED_MODULE_3__icons_circle_x_svg___default.a, alt: "", "aria-hidden": "true" })));
};
//# sourceMappingURL=close-menu-button.js.map

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_ui/responsive/ccl/assets/fonts/circle-x.svg";

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__html_content__ = __webpack_require__(627);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__html_content__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__profile_title__ = __webpack_require__(629);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__profile_title__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__profile_dropdown__ = __webpack_require__(631);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__profile_dropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fun_browser_dropdown__ = __webpack_require__(633);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__fun_browser_dropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sailings_dropdown__ = __webpack_require__(635);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__sailings_dropdown__["a"]; });





//# sourceMappingURL=renderers.js.map

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HtmlContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__html_content_css__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__html_content_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__html_content_css__);


var HtmlContent = function (_a) {
    var item = _a.item;
    var content = item.fields.content.value;
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-html-content", dangerouslySetInnerHTML: { __html: content } });
};
//# sourceMappingURL=html-content.js.map

/***/ }),
/* 628 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProfileTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__avatar_avatar__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__profile_title_css__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__profile_title_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__profile_title_css__);



function getFirstName(fullName) {
    if (!fullName) {
        return null;
    }
    return fullName.split(' ')[0];
}
function getCclSessionData() {
    try {
        var cookieNameValue = document.cookie.split(';').filter(function (n) { return n.indexOf('cclSession=') >= 0; })[0];
        if (!cookieNameValue) {
            return null;
        }
        var cookieValue = cookieNameValue.split('=')[1];
        var cclSession = JSON.parse(decodeURIComponent(cookieValue));
        return cclSession;
    }
    catch (err) {
        return null;
    }
}
function getTierImage() {
    var cclSessionData = getCclSessionData();
    if (!cclSessionData) {
        return null;
    }
    switch (cclSessionData.TierCode) {
        case '01':
            return { src: '/vifp/~/media/cclus/images/loyalty/icons/vifpredsmgif.gif', alt: 'red tier' };
        case '02':
            return { src: '/vifp/~/media/cclus/images/loyalty/icons/vifpgoldsmgif.gif', alt: 'gold tier' };
        case '03':
            return { src: '/vifp/~/media/cclus/images/loyalty/icons/vifpplatinumsmgif.gif', alt: 'platinum tier' };
        case '04':
            return { src: '/vifp/~/media/cclus/images/loyalty/icons/vifpblacksmgif.gif', alt: 'diamond tier' };
        case '00':
        default:
            return { src: 'https://www.carnival.com/vifp/~/media/cclus/images/loyalty/icons/vifpbluesmgif.gif', alt: 'blue tier' };
    }
}
var ProfileTitle = function (_a) {
    var data = _a.data;
    var tierImage = getTierImage();
    var firstName = getFirstName(data.fullName);
    if (tierImage) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "h-profile-title", "aria-label": firstName + " is a " + tierImage.alt + " user" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: tierImage.src, alt: tierImage.alt, className: "h-profile-title__image" }),
            " ",
            firstName));
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__avatar_avatar__["a" /* Avatar */], { fullName: data.fullName }),
        " ",
        firstName));
};
//# sourceMappingURL=profile-title.js.map

/***/ }),
/* 630 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProfileDropdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__profile_dropdown_css__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__profile_dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__profile_dropdown_css__);



function onLogoutClick(e) {
    e.preventDefault();
    e.currentTarget.parentElement.submit();
}
function renderLogout(url, text, ariaLabel) {
    var returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
    var actionUrl = url + "?returnUrl=" + returnUrl;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("form", { className: "h-profile-dropdown__logout-form", action: actionUrl, method: "POST" },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { role: "button", type: "submit", href: "", onClick: onLogoutClick, className: "h-profile-dropdown__link", "aria-label": ariaLabel }, text)));
}
function renderRegular(url, text, ariaLabel) {
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: url, className: "h-profile-dropdown__link", "aria-label": ariaLabel }, text));
}
function renderLink(item) {
    var image = item.fields.icon.value;
    var url = item.fields.url.value;
    var text = item.fields.text.value;
    var ariaLabel = item.fields.ariaLabel.value;
    var tags = item.fields.tags.value;
    var isLogout = (tags || '').indexOf('Action:Logout') >= 0;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { className: "h-profile-dropdown__list-item", key: item.id },
        image
            ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ className: "h-profile-dropdown__icon" }, image, { "aria-hidden": "true" }))
            : __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "h-profile-dropdown__icon" }),
        isLogout ? renderLogout(url, text, ariaLabel) : renderRegular(url, text, ariaLabel)));
}
var ProfileDropdown = function (_a) {
    var item = _a.item;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-profile-dropdown" },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("ul", { className: "h-profile-dropdown__list" }, item.fields.links.value.map(renderLink))));
};
//# sourceMappingURL=profile-dropdown.js.map

/***/ }),
/* 632 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export generateUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FunBrowserDropdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fun_browser_dropdown_css__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fun_browser_dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fun_browser_dropdown_css__);


function generateUrl(url) {
    return window.location.hostname === 'localhost'
        ? 'https://dev.carnival.com' + url
        : url;
}
function renderListItem(item, sailing) {
    var itemImage = item.fields.icon.value;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { key: item.id, className: "h-fun-browser-dropdown__list-item" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: "h-fun-browser-dropdown__item-link", href: replaceUrlBookingNumberPlaceholder(item.fields.url.value, sailing), "aria-label": ((item.fields.ariaLabel && item.fields.ariaLabel.value) || null) },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "h-fun-browser-dropdown__item-icon", src: buildImageUrl(itemImage), alt: "", width: "24px", height: "24px" }),
            item.fields.text.value)));
}
function buildImageUrl(image) {
    if (!image) {
        return '';
    }
    return generateUrl(image.src);
}
function replaceUrlBookingNumberPlaceholder(url, sailingData) {
    var singleEncBookingToken = '{encryptedBookingNumber}';
    var multipleEncBookingToken = '{encryptedBookingNumbers}';
    var plainBookingNumberToken = '{plainBookingNumber}';
    var sailDate = '{sailDate}';
    var shipCode = '{shipCode}';
    url = url.replace(singleEncBookingToken, sailingData.bookings[0].encryptedBookingNumber)
        .replace(multipleEncBookingToken, sailingData.encryptedBookingNumbers)
        .replace(plainBookingNumberToken, sailingData.bookings[0].bookingNumber)
        .replace(sailDate, sailingData.itinerary.sailDate)
        .replace(shipCode, sailingData.itinerary.shipCode);
    url = generateUrl(url);
    return url;
}
var FunBrowserDropdown = function (_a) {
    var item = _a.item, data = _a.data;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col h-fun-browser-dropdown" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "h-fun-browser-dropdown__list" }, item.fields.links.value.map(function (obj) { return renderListItem(obj, data.activeSailing); }))))));
};
//# sourceMappingURL=fun-browser-dropdown.js.map

/***/ }),
/* 634 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SailingsDropdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sailing_tile_sailing_tile__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__carousel_carousel__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_breakpoints__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__media_query_media_query__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sailings_dropdown_css__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sailings_dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__sailings_dropdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__visually_hidden_visually_hidden__ = __webpack_require__(14);









var SailingsDropdown = function (_a) {
    var data = _a.data, item = _a.item, dropdown = _a.dropdown;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-sailings-dropdown" },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "container" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col" }, data.accessBooking && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-sailings-dropdown__add-booking-container" }, data.accessBooking(function () { return dropdown.focusTrapToggle(false); }, function () { return dropdown.focusTrapToggle(true); }))))),
        renderSailings(data, item)));
};
function renderSailings(data, item) {
    if (!data.sailingData) {
        return null;
    }
    var mediaQuery = "(min-width: " + __WEBPACK_IMPORTED_MODULE_5__styles_breakpoints__["b" /* Medium */] + "px)";
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-sailings-dropdown__sailings" },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__media_query_media_query__["a" /* MediaQuery */], { query: mediaQuery }, function (matches) { return (matches ? renderCarousel(data, item) : renderRegular(data, item)); })));
}
function renderCarousel(data, item) {
    if (data.sailingData.sailings.length <= 3) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "container" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col" }, renderRegular(data, item, 'h-sailings-dropdown__item-wrapper--inline')))));
    }
    var activeIndex = findActiveSailingIndex(data);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__carousel_carousel__["a" /* Carousel */], { prevArrowAriaLabel: item.fields.prevArrowAriaLabel.value, nextArrowAriaLabel: item.fields.nextArrowAriaLabel.value, focusManagement: ".h-sailings-dropdown__item-link", getSlideDescription: generateSlideDescription(data.sailingData.sailings, data.activeSailing, item), slickSettings: {
            initialSlide: activeIndex,
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: __WEBPACK_IMPORTED_MODULE_5__styles_breakpoints__["a" /* Large */] - 1,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        } }, renderRegular(data, item)));
}
function renderRegular(data, item, className) {
    return data.sailingData.sailings.map(function (s, i) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: i, className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-sailings-dropdown__item-wrapper', className) }, renderSailing(s, data, item))); });
}
function parse() {
    if (!window.location.search) {
        return {};
    }
    // tslint:disable-next-line:no-any
    var hash = {};
    window.location.search.substring(1).split('&').map(function (n) { return n.split('='); }).forEach(function (kv) {
        hash[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
    });
    return hash;
}
function renderSailing(s, data, item) {
    var qs = parse();
    var url = "?shipCode=" + encodeURIComponent(s.itinerary.shipCode) + "&sailDate=" + s.itinerary.sailDate;
    // tslint:disable:no-string-literal
    if (qs['formId']) {
        url += "&formId=" + encodeURIComponent(qs['formId']);
    }
    // tslint:enable:no-string-literal
    var sailingProps = getSailingProps(s, item);
    var activeSailing = isActiveSailing(s, data);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: url, className: "h-sailings-dropdown__item-link" },
        activeSailing &&
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], { role: "alert" }, item.fields.adaActiveSailingAnnouncement.value),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__sailing_tile_sailing_tile__["a" /* SailingTile */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-sailings-dropdown__item', { 'h-sailings-dropdown__item--active': activeSailing }) }, sailingProps))));
}
function isActiveSailing(s, data) {
    var activeSailing = data.activeSailing.itinerary.sailDate === s.itinerary.sailDate &&
        data.activeSailing.itinerary.shipCode === s.itinerary.shipCode;
    return activeSailing;
}
function findActiveSailingIndex(data) {
    var sailings = data.sailingData.sailings;
    for (var i = 0; i < sailings.length; i++) {
        if (isActiveSailing(sailings[i], data)) {
            return i;
        }
    }
    return undefined;
}
function getSailingProps(s, item) {
    return {
        bookingNumbers: s.bookings.map(function (b) { return b.bookingNumber; }),
        embarkationPortName: s.itinerary.embarkationPortName,
        shipName: s.itinerary.shipName,
        shipCode: s.itinerary.shipCode,
        sailDate: s.itinerary.sailDate,
        sailDateMmmmDYyyy: s.itinerary.sailDateMmmmDYyyy,
        fromDayOfWeek: s.itinerary.departureDayOfWeek,
        toDayOfWeek: s.itinerary.arrivalDayOfWeek,
        itineraryTitle: s.itinerary.shortItineraryTitle,
        courtesyHoldExpiration: s.closestCourtesyHoldExpiration,
        content: {
            booking: item.fields.booking.value,
            bookings: item.fields.bookings.value,
            description: item.fields.description.value,
            adaDescription: item.fields.adaDescription.value,
            courtesyHoldHoursMessage: item.fields.courtesyHoldHoursMessage.value,
            adaCourtesyHoldHoursMessage: item.fields.adaCourtesyHoldHoursMessage.value,
            courtesyHoldMinutesMessage: item.fields.courtesyHoldMinutesMessage.value,
            adaCourtesyHoldMinutesMessage: item.fields.adaCourtesyHoldMinutesMessage.value
        }
    };
}
function generateSlideDescription(sailings, activeSailing, item) {
    return function getSlideDescription(index) {
        var sailing = sailings[index];
        var sailingProps = getSailingProps(sailing, item);
        var desc = Object(__WEBPACK_IMPORTED_MODULE_3__sailing_tile_sailing_tile__["b" /* getDescription */])(sailingProps);
        if (sailing === activeSailing) {
            return item.fields.adaActiveSailingAnnouncement.value + ". " + desc;
        }
        return desc;
    };
}
//# sourceMappingURL=sailings-dropdown.js.map

/***/ }),
/* 636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _slider = __webpack_require__(638);

var _slider2 = _interopRequireDefault(_slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _slider2.default;

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _innerSlider = __webpack_require__(639);

var _json2mq = __webpack_require__(646);

var _json2mq2 = _interopRequireDefault(_json2mq);

var _defaultProps = __webpack_require__(648);

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _innerSliderUtils = __webpack_require__(115);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(649);

var Slider = function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.innerSliderRefHandler = function (ref) {
      return _this.innerSlider = ref;
    };

    _this.slickPrev = function () {
      return _this.innerSlider.slickPrev();
    };

    _this.slickNext = function () {
      return _this.innerSlider.slickNext();
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    };

    _this.slickPause = function () {
      return _this.innerSlider.pause("paused");
    };

    _this.slickPlay = function () {
      return _this.innerSlider.autoPlay("play");
    };

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  Slider.prototype.media = function media(query, handler) {
    // javascript handler for  css media query
    enquire.register(query, handler);
    this._responsiveMediaHandlers.push({ query: query, handler: handler });
  };

  // handles responsive breakpoints


  Slider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // performance monitoring
    //if (process.env.NODE_ENV !== 'production') {
    //const { whyDidYouUpdate } = require('why-did-you-update')
    //whyDidYouUpdate(React)
    //}
    if (this.props.responsive) {
      var breakpoints = this.props.responsive.map(function (breakpt) {
        return breakpt.breakpoint;
      });
      // sort them in increasing order of their numerical value
      breakpoints.sort(function (x, y) {
        return x - y;
      });

      breakpoints.forEach(function (breakpoint, index) {
        // media query for each breakpoint
        var bQuery = void 0;
        if (index === 0) {
          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
        } else {
          bQuery = (0, _json2mq2.default)({
            minWidth: breakpoints[index - 1] + 1,
            maxWidth: breakpoint
          });
        }
        // when not using server side rendering
        (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
          _this2.setState({ breakpoint: breakpoint });
        });
      });

      // Register media query for full screen. Need to support resize from small to large
      // convert javascript object to media query string
      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });

      (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
        _this2.setState({ breakpoint: null });
      });
    }
  };

  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
    this._responsiveMediaHandlers.forEach(function (obj) {
      enquire.unregister(obj.query, obj.handler);
    });
  };

  Slider.prototype.render = function render() {
    var _this3 = this;

    var settings;
    var newProps;
    if (this.state.breakpoint) {
      newProps = this.props.responsive.filter(function (resp) {
        return resp.breakpoint === _this3.state.breakpoint;
      });
      settings = newProps[0].settings === "unslick" ? "unslick" : _extends({}, _defaultProps2.default, this.props, newProps[0].settings);
    } else {
      settings = _extends({}, _defaultProps2.default, this.props);
    }

    // force scrolling by one if centerMode is on
    if (settings.centerMode) {
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 in centerMode, you are using " + settings.slidesToScroll);
      }
      settings.slidesToScroll = 1;
    }
    // force showing one slide and scrolling by one if the fade mode is on
    if (settings.fade) {
      if (settings.slidesToShow > 1 && "production" !== "production") {
        console.warn("slidesToShow should be equal to 1 when fade is true, you're using " + settings.slidesToShow);
      }
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 when fade is true, you're using " + settings.slidesToScroll);
      }
      settings.slidesToShow = 1;
      settings.slidesToScroll = 1;
    }

    // makes sure that children is an array, even when there is only 1 child
    var children = _react2.default.Children.toArray(this.props.children);

    // Children may contain false or null, so we should filter them
    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
    children = children.filter(function (child) {
      if (typeof child === "string") {
        return !!child.trim();
      }
      return !!child;
    });

    // rows and slidesPerRow logic is handled here
    if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
      console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
      settings.variableWidth = false;
    }
    var newChildren = [];
    var currentWidth = null;
    for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
      var newSlide = [];
      for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
        var row = [];
        for (var k = j; k < j + settings.slidesPerRow; k += 1) {
          if (settings.variableWidth && children[k].props.style) {
            currentWidth = children[k].props.style.width;
          }
          if (k >= children.length) break;
          row.push(_react2.default.cloneElement(children[k], {
            key: 100 * i + 10 * j + k,
            tabIndex: -1,
            style: {
              width: 100 / settings.slidesPerRow + "%",
              display: "inline-block"
            }
          }));
        }
        newSlide.push(_react2.default.createElement(
          "div",
          { key: 10 * i + j },
          row
        ));
      }
      if (settings.variableWidth) {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i, style: { width: currentWidth } },
          newSlide
        ));
      } else {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i },
          newSlide
        ));
      }
    }

    if (settings === "unslick") {
      var className = "regular slider " + (this.props.className || "");
      return _react2.default.createElement(
        "div",
        { className: className },
        newChildren
      );
    } else if (newChildren.length <= settings.slidesToShow) {
      settings.unslick = true;
    }
    return _react2.default.createElement(
      _innerSlider.InnerSlider,
      _extends({ ref: this.innerSliderRefHandler }, settings),
      newChildren
    );
  };

  return Slider;
}(_react2.default.Component);

exports.default = Slider;

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.InnerSlider = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(31);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _initialState = __webpack_require__(640);

var _initialState2 = _interopRequireDefault(_initialState);

var _lodash = __webpack_require__(641);

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(115);

var _track = __webpack_require__(642);

var _dots = __webpack_require__(643);

var _arrows = __webpack_require__(644);

var _resizeObserverPolyfill = __webpack_require__(645);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InnerSlider = exports.InnerSlider = function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  function InnerSlider(props) {
    _classCallCheck(this, InnerSlider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.listRefHandler = function (ref) {
      return _this.list = ref;
    };

    _this.trackRefHandler = function (ref) {
      return _this.track = ref;
    };

    _this.adaptHeight = function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"" + _this.state.currentSlide + "\"]");
        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    };

    _this.componentWillMount = function () {
      _this.ssrInit();
      _this.props.onInit && _this.props.onInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
    };

    _this.componentDidMount = function () {
      var spec = _extends({ listRef: _this.list, trackRef: _this.track }, _this.props);
      _this.updateState(spec, true, function () {
        _this.adaptHeight();
        _this.props.autoplay && _this.autoPlay("update");
      });
      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }
      _this.ro = new _resizeObserverPolyfill2.default(function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });
      _this.ro.observe(_this.list);
      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });
      // To support server-side rendering
      if (!window) {
        return;
      }
      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    };

    _this.componentWillUnmount = function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }
      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }
      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });
        _this.callbackTimers = [];
      }
      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
    };

    _this.componentWillReceiveProps = function (nextProps) {
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, nextProps, _this.state);
      var setTrackStyle = false;
      for (var _iterator = Object.keys(_this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var key = _ref;

        if (!nextProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }
        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
          continue;
        }
        if (nextProps[key] !== _this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react2.default.Children.count(nextProps.children)) {
          _this.changeSlide({
            message: "index",
            index: _react2.default.Children.count(nextProps.children) - nextProps.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }
        if (nextProps.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    };

    _this.componentDidUpdate = function () {
      _this.checkImagesLoad();
      _this.props.onReInit && _this.props.onReInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
      // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }
      _this.adaptHeight();
    };

    _this.onWindowResized = function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash2.default)(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);
      _this.debouncedResize();
    };

    _this.resizeWindow = function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!_reactDom2.default.findDOMNode(_this.track)) return;
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props, _this.state);
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      });
      // animating state should be cleared while resizing, otherwise autoplay stops working
      _this.setState({
        animating: false
      });

      if (setTrackStyle) {
        clearTimeout(_this.animationEndCallback);
        delete _this.animationEndCallback;
      }
    };

    _this.updateState = function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _extends({}, spec, updatedState, { slideIndex: updatedState.currentSlide });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _extends({}, spec, { left: targetLeft });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
      if (setTrackStyle || _react2.default.Children.count(_this.props.children) !== _react2.default.Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }
      _this.setState(updatedState, callback);
    };

    _this.ssrInit = function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });
        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }
        for (var _i2 = 0; _i2 < postClones; _i2++) {
          _trackWidth += childrenWidths[_i2];
        }
        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
          _trackLeft += childrenWidths[_i3];
        }
        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };
        if (_this.props.centerMode || _this.props.centerPadding) {
          var currentWidth = childrenWidths[_this.state.currentSlide] + "px";
          _trackStyle.left = "calc(" + _trackStyle.left + " + (100% - " + currentWidth + ") / 2 ) ";
        }
        _this.setState({
          trackStyle: _trackStyle
        });
        return;
      }
      var childrenCount = _react2.default.Children.count(_this.props.children);
      var spec = _extends({}, _this.props, _this.state, { slideCount: childrenCount });
      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
      if (_this.props.centerMode || _this.props.centerPadding) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }
      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      _this.setState({
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      });
    };

    _this.checkImagesLoad = function () {
      var images = document.querySelectorAll(".slick-slide img");
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };
        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;
          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }
        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();
              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;
            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    };

    _this.progressiveLazyLoad = function () {
      var slidesToLoad = [];
      var spec = _extends({}, _this.props, _this.state);
      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }
      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }
      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });
        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    };

    _this.slideHandler = function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          currentSlide = _this$props.currentSlide,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_extends({
        index: index
      }, _this.props, _this.state, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
      _this.setState(state, function () {
        asNavFor && asNavFor.innerSlider.state.currentSlide !== currentSlide && asNavFor.innerSlider.slideHandler(index);
        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({ animating: animating });
            }, 10));
            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    };

    _this.changeSlide = function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _extends({}, _this.props, _this.state);
      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;
      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }
    };

    _this.clickHandler = function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }
      _this.clickable = true;
    };

    _this.keyHandler = function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({ message: dir });
    };

    _this.selectHandler = function (options) {
      _this.changeSlide(options);
    };

    _this.disableBodyScroll = function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };
      window.ontouchmove = preventDefault;
    };

    _this.enableBodyScroll = function () {
      window.ontouchmove = null;
    };

    _this.swipeStart = function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }
      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    };

    _this.swipeMove = function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      if (state["swiping"]) {
        _this.clickable = false;
      }
      _this.setState(state);
    };

    _this.swipeEnd = function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];
      _this.setState(state);
      if (triggerSlideHandler === undefined) return;
      _this.slideHandler(triggerSlideHandler);
      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    };

    _this.slickPrev = function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "previous" });
      }, 0));
    };

    _this.slickNext = function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "next" });
      }, 0));
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      slide = Number(slide);
      if (isNaN(slide)) return "";
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    };

    _this.play = function () {
      var nextIndex;
      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_extends({}, _this.props, _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    };

    _this.autoPlay = function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
      var autoplaying = _this.state.autoplaying;
      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }
      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
      _this.setState({ autoplaying: "playing" });
    };

    _this.pause = function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }
      var autoplaying = _this.state.autoplaying;
      if (pauseType === "paused") {
        _this.setState({ autoplaying: "paused" });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({ autoplaying: "focused" });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({ autoplaying: "hovered" });
        }
      }
    };

    _this.onDotsOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onDotsLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onTrackOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onTrackLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onSlideFocus = function () {
      return _this.props.autoplay && _this.pause("focused");
    };

    _this.onSlideBlur = function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    };

    _this.render = function () {
      var className = (0, _classnames2.default)("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });
      var spec = _extends({}, _this.props, _this.state);
      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
      var pauseOnHover = _this.props.pauseOnHover;

      trackProps = _extends({}, trackProps, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
      });

      var dots;
      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;

        dotProps = _extends({}, dotProps, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = _react2.default.createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true || _this.props.centerPadding) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true || _this.props.centerPadding) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _extends({}, verticalHeightStyle, centerPaddingStyle);
      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.swipeEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };

      var innerSliderProps = {
        className: className,
        dir: "ltr"
      };

      if (_this.props.unslick) {
        listProps = { className: "slick-list" };
        innerSliderProps = { className: className };
      }
      return _react2.default.createElement(
        "div",
        innerSliderProps,
        !_this.props.unslick ? prevArrow : "",
        _react2.default.createElement(
          "div",
          _extends({ ref: _this.listRefHandler }, listProps),
          _react2.default.createElement(
            _track.Track,
            _extends({ ref: _this.trackRefHandler }, trackProps),
            _this.props.children
          )
        ),
        !_this.props.unslick ? nextArrow : "",
        !_this.props.unslick ? dots : ""
      );
    };

    _this.list = null;
    _this.track = null;
    _this.state = _extends({}, _initialState2.default, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react2.default.Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;
    return _this;
  }

  return InnerSlider;
}(_react2.default.Component);

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false, // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: { startX: 0, startY: 0, curX: 0, curY: 0 },
  trackStyle: {},
  trackWidth: 0
};

exports.default = initialState;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Track = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(115);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }
  slickCloned = index < 0 || index >= spec.slideCount;
  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }
  var slickCurrent = index === spec.currentSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL
  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";
    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }
    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];
  var childrenCount = _react2.default.Children.count(spec.children);
  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react2.default.Children.forEach(spec.children, function (elem, index) {
    var child = void 0;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    };

    // in case of lazyLoad, whether or not we want to fetch the slide
    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = _react2.default.createElement("div", null);
    }
    var childStyle = getSlideStyle(_extends({}, spec, { index: index }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_extends({}, spec, { index: index }));
    // push a cloned element of the desired slide
    slides.push(_react2.default.cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames2.default)(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _extends({ outline: "none" }, child.props.style || {}, childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);
        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    }));

    // if slide needs to be precloned or postcloned
    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;
      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;
        if (key >= startIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        preCloneSlides.push(_react2.default.cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;
        if (key < endIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        postCloneSlides.push(_react2.default.cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = exports.Track = function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  function Track() {
    _classCallCheck(this, Track);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Track.prototype.render = function render() {
    var slides = renderSlides(this.props);
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    return _react2.default.createElement(
      "div",
      _extends({
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents),
      slides
    );
  };

  return Track;
}(_react2.default.PureComponent);

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Dots = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots = exports.Dots = function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  function Dots() {
    _classCallCheck(this, Dots);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Dots.prototype.clickHandler = function clickHandler(options, e) {
    // In Autoplay the focus stays on clicked button even after transition
    // to next slide. That only goes away by click somewhere outside
    e.preventDefault();
    this.props.clickHandler(options);
  };

  Dots.prototype.render = function render() {
    var _this2 = this;

    var dotCount = getDotCount({
      slideCount: this.props.slideCount,
      slidesToScroll: this.props.slidesToScroll,
      slidesToShow: this.props.slidesToShow,
      infinite: this.props.infinite
    });

    // Apply join & split to Array to pre-fill it for IE8
    //
    // Credit: http://stackoverflow.com/a/13735425/1849458
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
      var leftBound = i * _this2.props.slidesToScroll;
      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
      var active = _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound;
      var className = (0, _classnames2.default)({ "slick-active": active });

      var dotOptions = {
        message: "dots",
        index: i,
        slidesToScroll: _this2.props.slidesToScroll,
        currentSlide: _this2.props.currentSlide
      };

      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
      return _react2.default.createElement(
        "li",
        { key: i, className: className },
        _react2.default.cloneElement(_this2.props.customPaging(i, dotCount, active), { onClick: onClick })
      );
    });

    return _react2.default.cloneElement(this.props.appendDots(dots), _extends({
      className: this.props.dotsClass
    }, mouseEvents));
  };

  return Dots;
}(_react2.default.PureComponent);

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.NextArrow = exports.PrevArrow = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(115);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrevArrow = exports.PrevArrow = function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  PrevArrow.prototype.render = function render() {
    var prevClasses = { "slick-arrow": true, "slick-prev": true };
    var prevHandler = this.clickHandler.bind(this, { message: "previous" });

    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
      prevClasses["slick-disabled"] = true;
      prevHandler = null;
    }

    var prevArrowProps = {
      key: "0",
      "data-role": "none",
      className: (0, _classnames2.default)(prevClasses),
      style: { display: "block" },
      onClick: prevHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var prevArrow = void 0;

    if (this.props.prevArrow) {
      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
    } else {
      prevArrow = _react2.default.createElement(
        "button",
        _extends({ key: "0", type: "button" }, prevArrowProps),
        " ",
        "Previous"
      );
    }

    return prevArrow;
  };

  return PrevArrow;
}(_react2.default.PureComponent);

var NextArrow = exports.NextArrow = function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
  }

  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  NextArrow.prototype.render = function render() {
    var nextClasses = { "slick-arrow": true, "slick-next": true };
    var nextHandler = this.clickHandler.bind(this, { message: "next" });

    if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
      nextClasses["slick-disabled"] = true;
      nextHandler = null;
    }

    var nextArrowProps = {
      key: "1",
      "data-role": "none",
      className: (0, _classnames2.default)(nextClasses),
      style: { display: "block" },
      onClick: nextHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var nextArrow = void 0;

    if (this.props.nextArrow) {
      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
    } else {
      nextArrow = _react2.default.createElement(
        "button",
        _extends({ key: "1", type: "button" }, nextArrowProps),
        " ",
        "Next"
      );
    }

    return nextArrow;
  };

  return NextArrow;
}(_react2.default.PureComponent);

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)))

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(647);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),
/* 647 */
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return _react2.default.createElement(
      "ul",
      { style: { display: "block" } },
      dots
    );
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: null,
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return _react2.default.createElement(
      "button",
      null,
      i + 1
    );
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};

exports.default = defaultProps;

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(650);
module.exports = new MediaQueryDispatch();


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(651);
var Util = __webpack_require__(226);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(652);
var each = __webpack_require__(226).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),
/* 652 */
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),
/* 653 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 654 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 655 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 656 */
/***/ (function(module, exports) {

//# sourceMappingURL=models.js.map

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Hero */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hero_css__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hero_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__hero_css__);



var Hero = function (props) {
    var children = props.children, heroImage = props.heroImage, className = props.className, overlayClassName = props.overlayClassName;
    var backgroundImage = heroImage ? {
        backgroundImage: "url(" + heroImage.src + ")",
    } : undefined;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__('h-hero', className), style: backgroundImage },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__('h-hero__overlay', overlayClassName) }, children)));
};
//# sourceMappingURL=hero.js.map

/***/ }),
/* 658 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 659 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CruiseSummaryCard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eyebrow_eyebrow__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cruise_summary_card_css__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cruise_summary_card_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cruise_summary_card_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__social_share_itinerary_button__ = __webpack_require__(228);





var CruiseSummaryCard = function (props) {
    var content = props.content, itineraryName = props.itineraryName, departure = props.departure, arrival = props.arrival, shipName = props.shipName, className = props.className, shareItineraryContentProps = props.shareItineraryContentProps, itineraryUrl = props.itineraryUrl, itineraryImageUrl = props.itineraryImageUrl, onExploreClick = props.onExploreClick, exploreShipUrl = props.exploreShipUrl, plannerUrl = props.plannerUrl, canEditBooking = props.canEditBooking, onEditBooking = props.onEditBooking;
    var _a = content ? content : {
        heading: '',
        itineraryText: '',
        shareButton: '',
        exploreShipText: '',
        exploreShipIcon: { src: '', alt: '' },
        openPlannerText: '',
        openPlannerIcon: { src: '', alt: '' },
        openPlannerAvailable: false,
        editBookingIcon: { src: '', alt: '' },
        editBookingText: '',
        editBookingAriaLabel: ''
    }, heading = _a.heading, itineraryText = _a.itineraryText, shareButton = _a.shareButton, exploreShipText = _a.exploreShipText, exploreShipIcon = _a.exploreShipIcon, openPlannerText = _a.openPlannerText, openPlannerIcon = _a.openPlannerIcon, openPlannerAvailable = _a.openPlannerAvailable, editBookingIcon = _a.editBookingIcon, editBookingText = _a.editBookingText, editBookingAriaLabel = _a.editBookingAriaLabel;
    var exploreShip = exploreShipText ? exploreShipText + " " + shipName : undefined;
    var dates = departure + (arrival ? " - " + arrival : '');
    var _b = shareItineraryContentProps ? shareItineraryContentProps : {
        shareButtonAriaLabel: '', shareNetworks: []
    }, shareNetworksContents = _b.shareNetworks, shareButtonAriaLabel = _b.shareButtonAriaLabel;
    var onEditBookingClick = function (e) {
        e.preventDefault();
        onEditBooking();
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__('h-cruise-summary-card', className) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-cruise-summary-card__container" },
            heading && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h-cruise-summary-card__title" }, heading),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-cruise-summary-card__details" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__eyebrow_eyebrow__["a" /* Eyebrow */], { className: "h-cruise-summary-card__eyebrow" }, itineraryText),
                heading
                    ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "h-cruise-summary-card__name" }, itineraryName)
                    : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h-cruise-summary-card__name" }, itineraryName),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "h-cruise-summary-card__dates" }, dates)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-cruise-summary-card__actions" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row d-flex align-items-center" },
                    exploreShip && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { onClick: onExploreClick, href: exploreShipUrl, target: "_blank", className: "h-cruise-summary-card__link" },
                            exploreShipIcon && exploreShipIcon.src &&
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: exploreShipIcon.src, alt: exploreShipIcon.alt }),
                            exploreShip)),
                    openPlannerAvailable && plannerUrl &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: plannerUrl, className: "h-cruise-summary-card__link" },
                                openPlannerIcon && openPlannerIcon.src &&
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: openPlannerIcon.src, alt: openPlannerIcon.alt }),
                                openPlannerText)),
                    canEditBooking &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { onClick: onEditBookingClick, href: "", "aria-label": editBookingAriaLabel, className: "h-cruise-summary-card__link h-cruise-summary-card__link--last" },
                                editBookingIcon && editBookingIcon.src &&
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: editBookingIcon.src, alt: editBookingIcon.alt }),
                                editBookingText)))),
            shareNetworksContents.length && itineraryUrl && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md h-cruise-summary-card__share" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__social_share_itinerary_button__["a" /* ShareItineraryButton */], { itineraryImageUrl: itineraryImageUrl, itineraryUrl: itineraryUrl, shareButtonText: shareButton, shareButtonAriaLabel: shareButtonAriaLabel, socialNetworksContents: shareNetworksContents, parentNameRef: "bk-details-itinerary", itineraryName: itineraryName }))))));
};
//# sourceMappingURL=cruise-summary-card.js.map

/***/ }),
/* 661 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 662 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 663 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 664 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AdaGlobalOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_event_listener__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ada_global_outline_css__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ada_global_outline_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ada_global_outline_css__);




var AdaGlobalOutline = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(AdaGlobalOutline, _super);
    function AdaGlobalOutline() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onKeyPress = function (e) {
            document.documentElement.classList.add('h-ada-global-outline');
        };
        return _this;
    }
    AdaGlobalOutline.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_event_listener___default.a, { target: "document", onKeyUp: this.onKeyPress }, this.props.children));
    };
    return AdaGlobalOutline;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=ada-global-outline.js.map

/***/ }),
/* 666 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SkipNav */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__skip_nav_css__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__skip_nav_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__skip_nav_css__);




var SkipNav = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(SkipNav, _super);
    function SkipNav() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onFocus = function (e) {
            document.documentElement.classList.add('h-skip-nav--active');
        };
        _this.onBlur = function (e) {
            document.documentElement.classList.remove('h-skip-nav--active');
        };
        return _this;
    }
    SkipNav.prototype.render = function () {
        var _a = this.props, text = _a.text, targetDomId = _a.targetDomId, className = _a.className, onClick = _a.onClick, id = _a.id;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-skip-nav', className) },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { id: id, href: '#' + targetDomId, className: "h-skip-nav__link", onClick: onClick, onFocus: this.onFocus, onBlur: this.onBlur }, text)));
    };
    return SkipNav;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=skip-nav.js.map

/***/ }),
/* 668 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 669 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(671);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(31);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(26);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(672);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(231);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(161);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(678);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _reactDom2.default.createPortal !== undefined;
var createPortal = isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      parent.removeChild(_this.node);
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement("div");
      }

      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  parentSelector: function parentSelector() {
    return document.body;
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

exports.default = Modal;

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(26);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(673);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(674);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(231);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(677);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(161);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      classList.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus();
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen();
          }
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus();
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {
        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.afterClose();
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      classList.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      return this.shouldBeClosed() ? null : _react2.default.createElement(
        "div",
        {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", overlayClassName),
          style: _extends({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown,
          "aria-modal": "true"
        },
        _react2.default.createElement(
          "div",
          _extends({
            ref: this.setContentRef,
            style: _extends({}, contentStyles, this.props.style.content),
            className: this.buildClassName("content", className),
            tabIndex: "-1",
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onMouseUp: this.handleContentOnMouseUp,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            "aria-label": this.props.contentLabel
          }, this.attributesFromObject("aria", this.props.aria || {}), this.attributesFromObject("data", this.props.data || {})),
          this.props.children
        )
      );
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(230);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus();
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__(230);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === document.activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  var target;
  if (tail === document.activeElement && !shiftKey) {
    target = head;
  }

  if (head === document.activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(document.activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  event.preventDefault();

  tabbable[x].focus();
}
module.exports = exports["default"];

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dumpClassLists = dumpClassLists;
var htmlClassList = {};
var docBodyClassList = {};

function dumpClassLists() {
  if (false) {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n";
    }

    classes = document.body.className;

    // eslint-disable-next-line max-len
    buffer += "\n\ndoc.body (" + classes + "):\n";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
    }

    buffer += "\n";

    // eslint-disable-next-line no-console
    console.log(buffer);
  }
}

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 679 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccessBookingRequestLine; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__access_booking__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__icons__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_colors__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__access_booking_request_line_css__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__access_booking_request_line_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__access_booking_request_line_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__visually_hidden_visually_hidden__ = __webpack_require__(14);









function renderRequestStatus(status, statusMessage) {
    var cn = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-access-booking__status-text', { 'h-access-booking__status-text--error': status === 'error' }, { 'h-access-booking__status-text--success': status === 'found' });
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row h-access-booking__list-item" },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: cn }, statusMessage))));
}
function renderFound(content) {
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-md" },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-access-booking__status-text h-access-booking__status-text--success" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__icons__["CheckmarkIcon"], { color: __WEBPACK_IMPORTED_MODULE_6__styles_colors__["h" /* SuccessColor */], width: "12", height: "12" }),
            "\u00A0",
            content.bookingFound)));
}
function renderAdaRequestCountDown(index, content) {
    var count = index + 1;
    var message = Object(__WEBPACK_IMPORTED_MODULE_3__access_booking__["c" /* replace */])(content.requestNumberShownLive, [count, content.maximumNumberOfRequests]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], { "aria-live": "assertive", role: "alert" }, Object(__WEBPACK_IMPORTED_MODULE_3__access_booking__["b" /* renderAdaLive */])(message, count)));
}
var AccessBookingRequestLine = function (_a) {
    var index = _a.index, status = _a.status, bookingNumber = _a.bookingNumber, lastName = _a.lastName, saveToProfile = _a.saveToProfile, content = _a.content, onDataChange = _a.onDataChange, anonymousUser = _a.anonymousUser, errorMessage = _a.errorMessage;
    var onChange = function (newModel) { return onDataChange(newModel, index); };
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row h-access-booking__list-item" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-md" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["c" /* FormField */], { controlModel: bookingNumber, onFieldUpdate: onChange }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["d" /* Input */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ disabled: status === 'found', maxLength: 6 }, props.controlProps)),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.labelProps), content.bookingNumber),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["b" /* Error */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.errorProps)))); })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-md" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["c" /* FormField */], { controlModel: lastName, onFieldUpdate: onChange }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["d" /* Input */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ disabled: status === 'found', maxLength: 32 }, props.controlProps)),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.labelProps), content.lastName),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["b" /* Error */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.errorProps)))); })),
            status !== 'found' && !anonymousUser &&
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-md" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["c" /* FormField */], { controlModel: saveToProfile, onFieldUpdate: onChange }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["a" /* Checkbox */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.controlProps)),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.labelProps), content.saveToProfile))); })),
            status === 'found' && renderFound(content)),
        status === 'error' && renderRequestStatus(status, errorMessage || content.bookingNotFound),
        renderAdaRequestCountDown(index, content)));
};
//# sourceMappingURL=access-booking-request-line.js.map

/***/ }),
/* 681 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AccessBookingModalTrigger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icons__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__access_booking__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modal_modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__visually_hidden_visually_hidden__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tooltip_tooltip__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_breakpoints__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__media_query_media_query__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__access_booking_modal_trigger_css__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__access_booking_modal_trigger_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__access_booking_modal_trigger_css__);











var AccessBookingModalTrigger = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(AccessBookingModalTrigger, _super);
    function AccessBookingModalTrigger() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isModalOpen: false
        };
        _this.openModal = function (e) {
            e.preventDefault();
            if (_this.props.forceInternalModal) {
                if (_this.props.onOpening) {
                    _this.props.onOpening();
                }
                _this.setState({ isModalOpen: true });
            }
        };
        _this.closeModal = function () {
            _this.setState({ isModalOpen: false });
            if (_this.props.onClosed) {
                _this.props.onClosed();
            }
        };
        return _this;
    }
    AccessBookingModalTrigger.prototype.onTooltipClick = function (e) {
        e.preventDefault();
    };
    AccessBookingModalTrigger.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "", role: "button", className: "h-access-booking-modal__button link-a-booking organizer-access-modal-open-button", onClick: this.openModal, "aria-label": this.props.content.openModalButtonAriaLabel },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__icons__["CirclePlusIcon"], { "aria-hidden": "true", className: "h-access-booking-modal__button-icon" }),
                    this.props.content.openModalButton),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "h-access-booking-modal__tooltip-container" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "", role: "presentation", className: "h-access-booking-modal__tooltip-trigger", onClick: this.onTooltipClick },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], null, this.props.content.openModalButtonTooltip),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__icons__["InfoIcon"], { "aria-hidden": "true", style: { verticalAlign: 'baseline' } })),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__media_query_media_query__["a" /* MediaQuery */], { query: "(min-width: " + __WEBPACK_IMPORTED_MODULE_8__styles_breakpoints__["b" /* Medium */] + "px)" }, function (matches) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__tooltip_tooltip__["a" /* Tooltip */], { "aria-hidden": "true", placement: matches ? 'top-right' : 'top-center', className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-access-booking-modal__tooltip', { 'h-access-booking-modal__tooltip--center': !matches }) }, _this.props.content.openModalButtonTooltip)); }))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__modal_modal__["a" /* Modal */], { shell: false, isOpen: this.state.isModalOpen, fullScreen: true, onRequestClose: this.closeModal, dialogDescription: this.props.content.heading },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__access_booking__["a" /* AccessBooking */], { mode: "modal", onRequestClose: this.closeModal, content: this.props.content, onSubmit: this.props.onSubmit, onComplete: this.props.onComplete, anonymousUser: this.props.anonymousUser }))));
    };
    return AccessBookingModalTrigger;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=access-booking-modal-trigger.js.map

/***/ }),
/* 683 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 684 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AccessBookingByDobForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms_index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__access_booking_dob__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__visually_hidden_visually_hidden__ = __webpack_require__(14);





var AccessBookingByDobForm = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(AccessBookingByDobForm, _super);
    function AccessBookingByDobForm(props) {
        var _this = _super.call(this, props) || this;
        _this.onNotificationClosed = function () {
            _this.setState({ submissionErrorMessage: null });
        };
        _this.onSubmit = function () {
            var request = Object(__WEBPACK_IMPORTED_MODULE_2__forms_index__["o" /* values */])(_this.state.controlGroup);
            _this.setState({ submissionErrorMessage: null, submitting: true });
            return _this.props.onSubmit(request, _this.isModelValid)
                .then(function () {
                _this.setState({ submissionErrorMessage: null });
            })
                .catch(function (e) {
                _this.setState({ submitting: false, submissionErrorMessage: _this.props.content.submissionErrorMessage });
                throw e;
            });
        };
        _this.isModelValid = function () {
            var controlGroup = _this.state.controlGroup;
            var validatedControlGroup = Object(__WEBPACK_IMPORTED_MODULE_2__forms_index__["n" /* validateControlGroup */])(controlGroup, _this.formContainerRef.current);
            if (!validatedControlGroup.valid) {
                _this.setState({
                    controlGroup: validatedControlGroup,
                    validationErrors: Object(__WEBPACK_IMPORTED_MODULE_2__forms_index__["j" /* getErrorMessages */])(validatedControlGroup.controls.all),
                });
                return false;
            }
            return true;
        };
        _this.onControlChange = function (control) {
            _this.setState(function (prevState) {
                var newControlGroup = Object(__WEBPACK_IMPORTED_MODULE_2__forms_index__["m" /* replaceControlModel */])(prevState.controlGroup, control);
                return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, prevState), { controlGroup: newControlGroup });
            });
        };
        _this.createControlGroup = function () {
            var controlGroup = Object(__WEBPACK_IMPORTED_MODULE_2__forms_index__["h" /* createControlGroup */])(Object(__WEBPACK_IMPORTED_MODULE_2__forms_index__["i" /* createControlModel */])({
                name: 'lastName',
                value: '',
                validators: {
                    required: true,
                },
                errorMessages: {
                    required: _this.props.content.lastNameRequired,
                }
            }), Object(__WEBPACK_IMPORTED_MODULE_2__forms_index__["i" /* createControlModel */])({
                name: 'dobMonth',
                value: '',
                validators: {
                    required: true,
                },
                errorMessages: {
                    required: _this.props.content.monthRequired,
                }
            }), Object(__WEBPACK_IMPORTED_MODULE_2__forms_index__["i" /* createControlModel */])({
                name: 'dobDay',
                value: '',
                validators: {
                    required: true,
                },
                errorMessages: {
                    required: _this.props.content.dayRequired,
                }
            }), Object(__WEBPACK_IMPORTED_MODULE_2__forms_index__["i" /* createControlModel */])({
                name: 'dobYear',
                value: '',
                validators: {
                    required: true,
                },
                errorMessages: {
                    required: _this.props.content.yearRequired,
                }
            }));
            return {
                controlGroup: controlGroup
            };
        };
        _this.state = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ submissionErrorMessage: null, submitting: false, validationErrors: null }, _this.createControlGroup());
        _this.formContainerRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        return _this;
    }
    AccessBookingByDobForm.prototype.render = function () {
        var _a = this.state, submitting = _a.submitting, submissionErrorMessage = _a.submissionErrorMessage, controlGroup = _a.controlGroup, errors = _a.validationErrors;
        var _b = this.props, content = _b.content, monthNames = _b.monthNames, onRequestClose = _b.onRequestClose;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__access_booking_dob__["a" /* AccessBookingByDob */], { content: content, controlGroup: controlGroup, monthNames: monthNames, errorMessage: submissionErrorMessage, submitting: submitting, onControlChange: this.onControlChange, onSubmit: this.onSubmit, onNotificatonClosed: this.onNotificationClosed, onRequestClose: onRequestClose }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], null, errors && errors.join('. '))));
    };
    return AccessBookingByDobForm;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=access-booking-dob-form.js.map

/***/ }),
/* 686 */
/***/ (function(module, exports) {

//# sourceMappingURL=models.js.map

/***/ }),
/* 687 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BookingDetailsCard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_colors__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eyebrow_eyebrow__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__icons__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__avatar_avatar__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__chevron_chevron_circle__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__model__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__footer_actions__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__balance_due_footer__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__paid_in_full_footer__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__final_payment_scheduled_footer__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__courtesy_hold_footer__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__installments_footer__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__booking_alert__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__booking_details_card_css__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__booking_details_card_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__booking_details_card_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__view_invoice_link__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modal_confirmation_modal__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__icons_trash_icon__ = __webpack_require__(698);




















var BookingDetailsCard = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(BookingDetailsCard, _super);
    function BookingDetailsCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.stateroomRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.infoRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.focus = null;
        _this.state = {
            isOpen: false,
            isRemoveBookingConfirmationModalOpen: false
        };
        _this.toggleDetails = function (e) {
            e.preventDefault();
            _this.setState(function (prevState) {
                _this.focus = prevState.isOpen ? 'info' : 'stateroom';
                return {
                    isOpen: !prevState.isOpen,
                };
            });
        };
        _this.onEditGuests = function (e) {
            e.preventDefault();
            if (_this.props.onEditGuest) {
                var seqNumber = e.currentTarget.dataset.seq;
                _this.props.onEditGuest(_this.props.data, parseInt(seqNumber, 10));
            }
        };
        _this.onViewRoomDetails = function (e) {
            e.preventDefault();
            if (_this.props.onViewRoomDetails) {
                _this.props.onViewRoomDetails(_this.props.data);
            }
        };
        _this.onEditDining = function (e) {
            e.preventDefault();
            if (_this.props.onEditDining) {
                _this.props.onEditDining(_this.props.data);
            }
        };
        _this.onEditBedding = function (e) {
            e.preventDefault();
            if (_this.props.onEditBedding) {
                _this.props.onEditBedding(_this.props.data);
            }
        };
        _this.onViewDocuments = function (e) {
            e.preventDefault();
            if (_this.props.onViewDocuments) {
                _this.props.onViewDocuments(_this.props.data);
            }
        };
        _this.onViewBalanceDetails = function (e) {
            e.preventDefault();
            if (_this.props.onViewBalanceDetails) {
                _this.props.onViewBalanceDetails(_this.props.data);
            }
        };
        _this.onClickRemoveBooking = function (event) {
            event.preventDefault();
            event.stopPropagation();
            _this.setState(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, _this.state), { isRemoveBookingConfirmationModalOpen: true }));
        };
        _this.onCancelRemoveBooking = function () { return _this.setState(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, _this.state), { isRemoveBookingConfirmationModalOpen: false })); };
        _this.onRemoveBooking = function () {
            _this.setState(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, _this.state), { isRemoveBookingConfirmationModalOpen: false }));
            if (_this.props.onRemoveBooking) {
                _this.props.onRemoveBooking(_this.props.data.bookingNumber);
            }
        };
        _this.onFooterActionClick = function (e) {
            var todoType = e.currentTarget.dataset.type;
            if (todoType === 'CompleteGuestNames.NotDone' && _this.props.onEditGuest) {
                e.preventDefault();
                _this.props.onEditGuest(_this.props.data, _this.props.data.guests[0].seqNumber);
            }
            else if ((todoType === 'PrintDocuments.Available' || todoType === 'PrintDocuments.NotAvailable') && _this.props.onViewDocuments) {
                e.preventDefault();
                _this.props.onViewDocuments(_this.props.data);
            }
        };
        return _this;
    }
    BookingDetailsCard.prototype.componentDidUpdate = function () {
        if (this.focus) {
            if (this.focus === 'stateroom' && this.stateroomRef.current) {
                this.stateroomRef.current.focus();
            }
            else if (this.focus === 'info' && this.infoRef.current) {
                this.infoRef.current.focus();
            }
            this.focus = null;
        }
    };
    BookingDetailsCard.prototype.render = function () {
        var _a = this.props, className = _a.className, index = _a.index, data = _a.data, content = _a.content;
        var cn = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-bk-dtl-card', { 'h-bk-dtl-card--collapsed': !this.state.isOpen }, className);
        var id = Object(__WEBPACK_IMPORTED_MODULE_8__model__["a" /* genId */])(data.bookingNumber, 'container');
        var eyebrowId = Object(__WEBPACK_IMPORTED_MODULE_8__model__["a" /* genId */])(data.bookingNumber, 'eyebrow');
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            " ",
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: cn, id: id },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row h-bk-dtl-card__header-row no-gutters" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-md-9 col-lg-6 h-bk-dtl-card__info-col" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", { className: "h-bk-dtl-card__image", src: data.stateroomImageUrl, alt: "" }),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bk-dtl-card__info-container", tabIndex: -1, ref: this.infoRef },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__eyebrow_eyebrow__["a" /* Eyebrow */], { id: eyebrowId },
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { "data-pii": "true" }, "" + content.eyebrow + data.bookingNumber)),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h3", { className: "h-bk-dtl-card__heading" }, "" + (content.stateroomSequence || '').replace('{Sequence}', (index + 1).toString())),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "h-bk-dtl-card__remove-link" },
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19__icons_trash_icon__["a" /* TrashIcon */], null),
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "", className: "h-bk-dtl-card__action-link", onClick: this.onClickRemoveBooking }, content.removeBookingLink)),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__booking_alert__["a" /* BookingAlert */], { data: data, content: content }))),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-md-3 col-lg-6 h-bk-dtl-card__stateroom-col" }, this.renderStateroomInfo(data, content))),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row h-bk-dtl-card__guest-bed-dining-row no-gutters" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-lg-4 h-bk-dtl-card__guests" }, this.renderGuestsColumn(data, content)),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-lg-4 h-bk-dtl-card__bedding" }, this.renderBeddingColumn(data, content)),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-lg-4 h-bk-dtl-card__dining" }, this.renderDiningColumns(data, content))),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row h-bk-dtl-card__footer align-items-center no-gutters" }, this.renderFooter(data, content)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "d-md-none h-bk-dtl-card__toggle-details-row no-gutters" }, this.renderToggleDetails(id, content, this.state.isOpen))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__modal_confirmation_modal__["a" /* ConfirmationModal */], { isOpen: this.state.isRemoveBookingConfirmationModalOpen, confirmText: content.removeModalConfimationText, confirmTextAriaLabel: content.removeModalConfirmationAriaLabel.replace('{booking}', data.bookingNumber), cancelText: content.removeModalCancelText, cancelTextAriaLabel: content.removeModalCancelAriaLabel.replace('{booking}', data.bookingNumber), header: content.removeBookingModalHeader, description: content.removeBookingModalDescription.replace('{booking}', data.bookingNumber), onConfirm: this.onRemoveBooking, onCancel: this.onCancelRemoveBooking })));
    };
    BookingDetailsCard.prototype.renderStateroomInfo = function (data, content) {
        var roomDetailsId = Object(__WEBPACK_IMPORTED_MODULE_8__model__["a" /* genId */])(data.bookingNumber, 'view-room');
        var roomDescId = Object(__WEBPACK_IMPORTED_MODULE_8__model__["a" /* genId */])(data.bookingNumber, 'room-desc');
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "d-lg-flex justify-content-lg-end h-bk-dtl-card__stateroom", ref: this.stateroomRef, tabIndex: -1 },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bk-dtl-card__meta" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__icons__["CabinIcon"], { metaCategoryCode: data.metaCategoryCode, stateroomTypeName: data.stateroomTypeName, width: "23", height: "23", "aria-hidden": "true", style: { verticalAlign: 'middle' } }),
                ' ' + data.metaCategoryName),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bk-dtl-card__room" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__icons__["BedIcon"], { width: "23", height: "23", "aria-hidden": "true", style: { verticalAlign: 'middle' } }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { id: roomDescId }, ' ' + content.room + ' ' + data.stateroomNumber)),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bk-dtl-card__view-room" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "", className: "h-bk-dtl-card__action-link", role: "button", id: roomDetailsId, "aria-label": (content.viewRoomDetailsAriaLabel || '').replace('{BookingNumber}', data.bookingNumber), "aria-describedby": roomDescId, onClick: this.onViewRoomDetails }, content.viewRoomDetails))));
    };
    BookingDetailsCard.prototype.renderGuestsColumn = function (data, content) {
        var _this = this;
        var viewDocsId = Object(__WEBPACK_IMPORTED_MODULE_8__model__["a" /* genId */])(data.bookingNumber, 'view-docs');
        var editGuestsId = Object(__WEBPACK_IMPORTED_MODULE_8__model__["a" /* genId */])(data.bookingNumber, 'edit-guest');
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            data.guests.map(function (g, i) { return _this.renderGuest(g, i, data, content, editGuestsId); }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: { display: 'none' } },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { className: "h-bk-dtl-card__action-link", href: "", id: viewDocsId, "aria-label": (content.viewDocumentsAriaLabel || '').replace('{BookingNumber}', data.bookingNumber), onClick: this.onViewDocuments, role: "button" }, content.viewDocuments))));
    };
    BookingDetailsCard.prototype.renderGuest = function (g, i, data, content, editGuestsId) {
        var fullName = g.firstName === 'TBA'
            ? content.guest + " " + (i + 1)
            : g.firstName + " " + g.lastName;
        var avatar = g.firstName === 'TBA'
            ? (content.avatarPrefix + (i + 1))
            : fullName;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "d-flex h-bk-dtl-card__guest", key: i },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bk-dtl-card__guest-num-col", "aria-hidden": "true" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__avatar_avatar__["a" /* Avatar */], { fullName: avatar })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bk-dtl-card__guest-info-col" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { "data-pii": "true", className: "h-bk-dtl-card__large-text" }, fullName),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null, data.canEditGuests ?
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { className: "h-bk-dtl-card__action-link", href: "", "data-seq": g.seqNumber, onClick: this.onEditGuests, role: "button", id: editGuestsId + '-' + i, "aria-label": (content.editGuestsDetailsAriaLabel || '')
                            .replace('{GuestName}', fullName)
                            .replace('{BookingNumber}', data.bookingNumber) },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__icons__["EditIcon"], { width: "14", height: "14", color: __WEBPACK_IMPORTED_MODULE_3__styles_colors__["c" /* BlueColor */], "aria-hidden": "true" }),
                        ' ' + content.editGuestsDetails)
                    :
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bk-dtl-card__help-text", "aria-label": content.guestsDetailsNotChangeableAriaLabel }, content.guestsDetailsNotChangeable)))));
    };
    BookingDetailsCard.prototype.renderBeddingColumn = function (data, content) {
        var editBeddingId = Object(__WEBPACK_IMPORTED_MODULE_8__model__["a" /* genId */])(data.bookingNumber, 'edit-bedding');
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bk-dtl-card__large-text" }, data.beddingName),
            data.canEditBedding ?
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { className: "h-bk-dtl-card__action-link", href: "", id: editBeddingId, "aria-label": (content.editBeddingAriaLabel || '').replace('{BookingNumber}', data.bookingNumber), role: "button", onClick: this.onEditBedding },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__icons__["EditIcon"], { width: "14", height: "14", color: __WEBPACK_IMPORTED_MODULE_3__styles_colors__["c" /* BlueColor */], "aria-hidden": "true" }),
                    ' ' + content.editBedding)
                :
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bk-dtl-card__help-text", "aria-label": content.beddingNotChangeableAriaLabel }, content.beddingNotChangeable)));
    };
    BookingDetailsCard.prototype.renderDiningColumns = function (data, content) {
        var editDiningId = Object(__WEBPACK_IMPORTED_MODULE_8__model__["a" /* genId */])(data.bookingNumber, 'edit-dining');
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bk-dtl-card__large-text" }, data.assignedDiningTime
                ? (content.assignedDining || '')
                    .replace('{DiningName}', data.assignedDiningName)
                    .replace('{DiningTime}', data.assignedDiningTime)
                : (content.assignedDiningNoTime || '')
                    .replace('{DiningName}', data.assignedDiningName)),
            data.waitlistedDiningCode &&
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bk-dtl-card__help-text" }, data.waitlistedDiningTime
                    ? (content.waitlistDining || '')
                        .replace('{DiningName}', data.waitlistedDiningName)
                        .replace('{DiningTime}', data.waitlistedDiningTime)
                    : (content.waitlistDiningNoTime || '')
                        .replace('{DiningName}', data.waitlistedDiningName)),
            data.canEditDining ?
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { className: "h-bk-dtl-card__action-link", href: "", id: editDiningId, onClick: this.onEditDining, role: "button", "aria-label": (content.editDiningAriaLabel || '').replace('{BookingNumber}', data.bookingNumber) },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__icons__["EditIcon"], { width: "14", height: "14", color: __WEBPACK_IMPORTED_MODULE_3__styles_colors__["c" /* BlueColor */], "aria-hidden": "true" }),
                    ' ' + content.editDining) :
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bk-dtl-card__help-text", "aria-label": content.diningNotChangeableAriaLabel }, content.diningNotChangeable)));
    };
    BookingDetailsCard.prototype.renderFooter = function (data, content) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-sm-6 col-md-12 col-lg-auto h-bk-dtl-card__footer-info" }, this.renderLeftFooterColumn(data, content)),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-sm-6 col-md-12 col-lg-auto h-bk-dtl-card__footer-actions" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__footer_actions__["a" /* FooterActions */], { data: data, onClick: this.onFooterActionClick }))));
    };
    BookingDetailsCard.prototype.renderLeftFooterColumn = function (data, content) {
        if (!data.paymentSchedule) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__view_invoice_link__["a" /* ViewInvoiceLink */], { data: data, content: content, onViewBalance: this.onViewBalanceDetails });
        }
        if (data.courtesyHoldExpiration) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__courtesy_hold_footer__["a" /* CourtesyHoldFooter */], { data: data, content: content, onViewBalance: this.onViewBalanceDetails });
        }
        if (data.paymentInstallments) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__installments_footer__["a" /* InstallmentsFooter */], { data: data, content: content, onViewBalance: this.onViewBalanceDetails });
        }
        if (data.isFinalPaymentScheduled) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__final_payment_scheduled_footer__["a" /* FinalPaymentScheduledFooter */], { data: data, content: content, onViewBalance: this.onViewBalanceDetails });
        }
        if (data.paymentSchedule.balanceDue > 0) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__balance_due_footer__["a" /* BalanceDueFooter */], { data: data, content: content, onViewBalance: this.onViewBalanceDetails });
        }
        if (data.paymentSchedule.balanceDue === 0) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__paid_in_full_footer__["a" /* PaidInFullFooter */], { data: data, content: content, onViewBalance: this.onViewBalanceDetails });
        }
        return null;
    };
    BookingDetailsCard.prototype.renderToggleDetails = function (id, content, isOpen) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "#", className: "h-bk-dtl-card__action-link h-bk-dtl-card__toggle-link", onClick: this.toggleDetails, role: "button", "aria-expanded": isOpen ? 'true' : 'false', "aria-controls": id }, content.bookingAndGuestDetails)),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "#", className: "h-bk-dtl-card__toggle-details-icon", onClick: this.toggleDetails, role: "button", "aria-expanded": isOpen ? 'true' : 'false', "aria-controls": id, "aria-label": content.bookingAndGuestDetails },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__chevron_chevron_circle__["a" /* ChevronCircle */], { direction: isOpen ? 'up' : 'down', size: 44, shadowMode: "simple" })))));
    };
    return BookingDetailsCard;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=booking-details-card.js.map

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FooterActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__button_button__ = __webpack_require__(5);


var FooterActions = function (_a) {
    var data = _a.data, onClick = _a.onClick;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-bk-dtl-card__footer-action-list" }, data.toDos.filter(function (todo, i) { return i < 2; }).map(function (todo, i) { return (todo.callToActionUrl && !todo.disabled ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__button_button__["b" /* LinkButton */], { className: "h-bk-dtl-card__footer-action", color: i === 0 ? 'red' : 'outline-black', href: todo.callToActionUrl.replace(/{.+?}/g, ''), key: i, "data-type": todo.type, onClick: onClick, dangerouslySetInnerHTML: { __html: todo.callToActionText } })) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__button_button__["a" /* Button */], { className: "h-bk-dtl-card__footer-action", color: i === 0 ? 'red' : 'outline-black', key: i, disabled: todo.disabled, "data-type": todo.type, onClick: onClick },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { dangerouslySetInnerHTML: { __html: todo.callToActionText } })))); })));
};
//# sourceMappingURL=footer-actions.js.map

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BalanceDueFooter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__money_money__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_invoice_link__ = __webpack_require__(78);



var BalanceDueFooter = function (_a) {
    var data = _a.data, content = _a.content, onViewBalance = _a.onViewBalance;
    var _b = data.paymentSchedule, depositAmountDue = _b.depositAmountDue, balanceDue = _b.balanceDue, depositDueDateMmmDYyyy = _b.depositDueDateMmmDYyyy, finalPaymentDueDateMmmDYyyy = _b.finalPaymentDueDateMmmDYyyy;
    var dateLabel = depositAmountDue > 0 ?
        (content.depositDueDate || '').replace('{Date}', depositDueDateMmmDYyyy) :
        (content.paymentDueDate || '').replace('{Date}', finalPaymentDueDateMmmDYyyy);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "d-flex flex-column align-items-md-center flex-md-row h-bk-dtl-card__footer-left-row" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-bk-dtl-card__large-text h-bk-dtl-card__amount-due" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__money_money__["a" /* Money */], { amount: depositAmountDue || balanceDue, currencyCode: data.currencyCode, currencySymbol: data.currencySymbol }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-bk-dtl-card__large-text h-bk-dtl-card__date-due" }, dateLabel),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__view_invoice_link__["a" /* ViewInvoiceLink */], { onViewBalance: onViewBalance, data: data, content: content }))));
};
//# sourceMappingURL=balance-due-footer.js.map

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaidInFullFooter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_invoice_link__ = __webpack_require__(78);


var PaidInFullFooter = function (_a) {
    var data = _a.data, content = _a.content, onViewBalance = _a.onViewBalance;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "d-flex flex-column align-items-md-center flex-md-row h-bk-dtl-card__footer-left-row" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-bk-dtl-card__large-text h-bk-dtl-card__amount-paid" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, content.paidInFull)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__view_invoice_link__["a" /* ViewInvoiceLink */], { onViewBalance: onViewBalance, data: data, content: content }))),
        !data.onlineCheckIn.isAvailable &&
            content.onlineCheckInAvailableDate && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-bk-dtl-card__footer-left-row h-bk-dtl-card__oci-unavailable" }, content.onlineCheckInAvailableDate.replace('{Date}', data.onlineCheckIn.availableOnMmmDYyyy))));
};
//# sourceMappingURL=paid-in-full-footer.js.map

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FinalPaymentScheduledFooter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__money_money__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_invoice_link__ = __webpack_require__(78);



var FinalPaymentScheduledFooter = function (_a) {
    var data = _a.data, content = _a.content, onViewBalance = _a.onViewBalance;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "d-flex flex-column align-items-md-center flex-md-row h-bk-dtl-card__footer-left-row" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-bk-dtl-card__large-text h-bk-dtl-card__amount-due" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__money_money__["a" /* Money */], { amount: data.paymentSchedule.balanceDue, currencyCode: data.currencyCode, currencySymbol: data.currencySymbol }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-bk-dtl-card__large-text h-bk-dtl-card__date-due" }, (content.paymentDueDate || '').replace('{Date}', data.paymentSchedule.finalPaymentDueDateMmmDYyyy)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__view_invoice_link__["a" /* ViewInvoiceLink */], { onViewBalance: onViewBalance, data: data, content: content }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-bk-dtl-card__footer-left-row h-bk-dtl-card__final-payment-scheduled" }, content.finalPaymentScheduled)));
};
//# sourceMappingURL=final-payment-scheduled-footer.js.map

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CourtesyHoldFooter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__money_money__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_invoice_link__ = __webpack_require__(78);



var CourtesyHoldFooter = function (_a) {
    var data = _a.data, content = _a.content, onViewBalance = _a.onViewBalance;
    // const describedById = genId(data.bookingNumber, 'view-balance');
    var expirationMmmDYyyyOrHm = data.courtesyHoldExpiration.expirationMmmDYyyyOrHm;
    var _b = data.paymentSchedule, depositAmountDue = _b.depositAmountDue, balanceDue = _b.balanceDue;
    var dateLabel = depositAmountDue > 0 ?
        (content.depositDueDate || '').replace('{Date}', expirationMmmDYyyyOrHm) :
        (content.paymentDueDate || '').replace('{Date}', expirationMmmDYyyyOrHm);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "d-flex flex-column align-items-md-center flex-md-row h-bk-dtl-card__footer-left-row" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-bk-dtl-card__large-text h-bk-dtl-card__amount-due" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__money_money__["a" /* Money */], { amount: depositAmountDue || balanceDue, currencyCode: data.currencyCode, currencySymbol: data.currencySymbol }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-bk-dtl-card__large-text h-bk-dtl-card__date-due" }, dateLabel),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__view_invoice_link__["a" /* ViewInvoiceLink */], { onViewBalance: onViewBalance, data: data, content: content })))));
};
//# sourceMappingURL=courtesy-hold-footer.js.map

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InstallmentsFooter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__money_money__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_invoice_link__ = __webpack_require__(78);



var InstallmentsFooter = function (_a) {
    var data = _a.data, content = _a.content, onViewBalance = _a.onViewBalance;
    var _b = data.paymentInstallments, nextInstallmentDateMmmDYyyy = _b.nextInstallmentDateMmmDYyyy, nextInstallmentAmount = _b.nextInstallmentAmount;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "d-flex flex-column align-items-md-center flex-md-row h-bk-dtl-card__footer-left-row" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-bk-dtl-card__large-text h-bk-dtl-card__amount-due" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__money_money__["a" /* Money */], { amount: data.paymentSchedule.balanceDue, currencyCode: data.currencyCode, currencySymbol: data.currencySymbol }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-bk-dtl-card__large-text h-bk-dtl-card__date-due" }, (content.paymentDueDate || '').replace('{Date}', data.paymentSchedule.finalPaymentDueDateMmmDYyyy)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__view_invoice_link__["a" /* ViewInvoiceLink */], { onViewBalance: onViewBalance, data: data, content: content }))),
        content.installmentsScheduled && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-bk-dtl-card__footer-left-row h-bk-dtl-card__final-payment-scheduled" }, content.installmentsScheduled
            .replace('{Date}', nextInstallmentDateMmmDYyyy)
            .replace('{Amount}', Object(__WEBPACK_IMPORTED_MODULE_1__money_money__["b" /* money */])(nextInstallmentAmount, data.currencyCode, data.currencySymbol)))));
};
//# sourceMappingURL=installments-footer.js.map

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BookingAlert; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__money_money__ = __webpack_require__(77);

// import { Timer } from '../timer/timer';

// const pageLoadedTimestamp = Date.now();
var BookingAlert = function (_a) {
    var data = _a.data, content = _a.content;
    // courtesy hold
    if (data.courtesyHoldExpiration) {
        var _b = data.courtesyHoldExpiration, hours = _b.hours, minutes = _b.minutes, expirationMmmDYyyyHm = _b.expirationMmmDYyyyHm;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { dangerouslySetInnerHTML: {
                __html: (content.courtesyHoldAlert || '')
                    .replace('{Hours}', hours.toString())
                    .replace('{Minutes}', minutes.toString())
                    .replace('{DueDate}', expirationMmmDYyyyHm)
            } }));
    }
    // balance due
    if (data.paymentSchedule &&
        data.paymentSchedule.balanceDue > 0 &&
        !data.isFinalPaymentScheduled &&
        !data.paymentInstallments) {
        var amount = Object(__WEBPACK_IMPORTED_MODULE_1__money_money__["b" /* money */])(data.paymentSchedule.balanceDue, data.currencyCode, data.currencySymbol);
        var text = (content.balanceDueAlert || '').replace('{Amount}', amount);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { dangerouslySetInnerHTML: { __html: text } });
    }
    // complete guest names
    if (data.guests.some(function (n) { return n.firstName === 'TBA'; })) {
        var count = data.guests.filter(function (n) { return n.firstName === 'TBA'; }).length;
        var text = (content.completeGuestNamesAlert || '').replace('{Count}', count.toString());
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { dangerouslySetInnerHTML: { __html: text } });
    }
    // online check-in
    if (data.onlineCheckIn.isAvailable && data.onlineCheckIn.onlineCheckInStatus !== 'complete') {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { dangerouslySetInnerHTML: { __html: content.onlineCheckInAlert } });
    }
    return null;
};
// const CourtesyHoldAlert: React.FunctionComponent<{
//     data: BookingDetailsCardData;
//     template: string;
// }> = ({
//     data,
//     template
// }) => {
//     return (
//         <Timer intervalMs={60000}>
//             {(counter, clearTimeout) => <span
//                 className="h-bk-dtl-card__alert"
//                 dangerouslySetInnerHTML={renderCourtesyHold(clearTimeout, template, data.courtesyHoldExpiration!)}
//             />}
//         </Timer>
//     );
// };
// function renderCourtesyHold(clearTimeout: () => void, template: string, courtesyHoldExpiration: CourtesyHoldBookingDetailsCardData) {
//     const diffMs = Date.now() - pageLoadedTimestamp;
//     const diffMins = Math.floor(diffMs / 60000);
//     let totalMinutesLeft = courtesyHoldExpiration.hours * 60 + courtesyHoldExpiration.minutes;
//     totalMinutesLeft = totalMinutesLeft - diffMins;
//     if (totalMinutesLeft < 0) {
//         clearTimeout();
//         totalMinutesLeft = 0;
//     }
//     const hours = Math.floor(totalMinutesLeft / 60);
//     const minutes = totalMinutesLeft % 60;
//     return {
//         __html: template
//             .replace('{Hours}', hours.toString())
//             .replace('{Minutes}', minutes.toString())
//             .replace('{DueDate}', courtesyHoldExpiration.expirationMmmDYyyyHm)
//     };
// }
//# sourceMappingURL=booking-alert.js.map

/***/ }),
/* 696 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConfirmationModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal_modal_shell__ = __webpack_require__(19);





var ConfirmationModal = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(ConfirmationModal, _super);
    function ConfirmationModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onCancel = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (_this.props.onCancel) {
                _this.props.onCancel();
            }
        };
        _this.onConfirm = function (e) {
            e.preventDefault();
            e.stopPropagation();
            var onConfirm = _this.props.onConfirm;
            if (onConfirm) {
                onConfirm();
            }
        };
        _this.renderFooter = function () {
            var _a = _this.props, cancelText = _a.cancelText, cancelTextAriaLabel = _a.cancelTextAriaLabel, confirmText = _a.confirmText, confirmTextAriaLabel = _a.confirmTextAriaLabel;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-sm-6 col-md-12 col-lg-auto h-bk-dtl-card__footer-actions" },
                    cancelText &&
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__button_button__["a" /* Button */], { className: "h-bk-dtl-card__footer-action", color: "outline-black", onClick: _this.onCancel, "aria-label": cancelTextAriaLabel }, cancelText),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__button_button__["a" /* Button */], { className: "h-bk-dtl-card__footer-action", color: "red", onClick: _this.onConfirm, "aria-label": confirmTextAriaLabel }, confirmText))));
        };
        _this.closeButtonRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        return _this;
    }
    ConfirmationModal.prototype.render = function () {
        var _a = this.props, isOpen = _a.isOpen, header = _a.header, description = _a.description;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__modal_modal__["a" /* Modal */], { isOpen: isOpen, shell: true, fullScreen: false, header: this.renderHeader(header), dialogDescription: description, closeButtonRef: this.closeButtonRef, onRequestClose: this.onCancel, footer: this.renderFooter() },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" }, description)));
    };
    ConfirmationModal.prototype.renderHeader = function (header) {
        if (header == null || header === '') {
            return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h2", { className: __WEBPACK_IMPORTED_MODULE_4__modal_modal_shell__["a" /* ModalHeadingClassName */] }, header);
    };
    return ConfirmationModal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=confirmation-modal.js.map

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrashIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var TrashIcon = function (_a) {
    var width = _a.width, height = _a.height, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["width", "height"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 13 12", width: width || 13, height: height || 12 }, otherProps),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", { mask: "url(#eyLdE3oPaKm9)" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M11.4085,2.98906h-10.502238c-.411969,0-.749035-.33724-.749035-.74941s.337066-.74942.749035-.74942h10.502238c.412,0,.749.33724.749.74942s-.337.74941-.749.74941Z", "clip-rule": "evenodd", fill: "#10559a", "fill-rule": "evenodd" }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", { mask: "url(#eyLdE3oPaKm7)" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M11.4085,0.989057h-10.502238v4.000003h10.502238v-4.000003Zm-10.502238,0c.693548,0,1.250968.559143,1.250968,1.250593h-4c0,1.5158,1.231548,2.74941,2.749032,2.74941v-4.000003ZM2.15723,2.23965c0,.69144-.55742,1.25058-1.250968,1.25058v-3.999996c-1.517484,0-2.749032,1.233611-2.749032,2.749416h4ZM0.906262,3.49023h10.502238v-3.999996h-10.502238v3.999996Zm10.502238,0c-.6936,0-1.251-.55914-1.251-1.25058h4c0-1.515805-1.2315-2.749416-2.749-2.749416v3.999996Zm-1.251-1.25058c0-.69145.5574-1.250593,1.251-1.250593v4.000003c1.5175,0,2.749-1.23361,2.749-2.74941h-4Z", transform: "translate(.03047 0)", fill: "#10549b" }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("mask", { id: "eyLdE3oPaKm7", "mask-type": "luminance", x: "-150%", y: "-150%", height: "400%", width: "400%" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M11.4085,2.98906h-10.502238c-.411969,0-.749035-.33724-.749035-.74941s.337066-.74942.749035-.74942h10.502238c.412,0,.749.33724.749.74942s-.337.74941-.749.74941Z", transform: "translate(.000001 0)", "clip-rule": "evenodd", fill: "#fff", "fill-rule": "evenodd" })))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("mask", { id: "eyLdE3oPaKm9", "mask-type": "luminance", x: "-150%", y: "-150%", height: "400%", width: "400%" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M0.157227,1.49023h11.999973v1.49883h-11.999973v-1.49883Z", "clip-rule": "evenodd", fill: "#fff", "fill-rule": "evenodd" }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", { mask: "url(#eyLdE3oPaKm13)" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M0.157227,1.49023v-1.999996h-1.999997v1.999996h1.999997Zm11.999973,0h2v-1.999996h-2v1.999996Zm0,1.49883v2h2v-2h-2Zm-11.999973,0h-1.999997v2h1.999997v-2Zm0,.50117h11.999973v-3.999996h-11.999973v3.999996Zm9.999973-2v1.49883h4v-1.49883h-4Zm2-.501173h-11.999973v4.000003h11.999973v-4.000003ZM2.15723,2.98906v-1.49883h-4v1.49883h4Z", fill: "#fff" }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("mask", { id: "eyLdE3oPaKm13", "mask-type": "luminance", x: "-150%", y: "-150%", height: "400%", width: "400%" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M0.157227,1.49023h11.999973v1.49883h-11.999973v-1.49883Z", "clip-rule": "evenodd", fill: "#fff", "fill-rule": "evenodd" }))))),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", { transform: "matrix(1.062549 0 0 1-.377778-.01875)", mask: "url(#eyLdE3oPaKm23)" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M2.66596,9.820491v-6.904089", transform: "translate(.572407 0.091408)", fill: "#10559a", stroke: "#10549b", "stroke-width": "2" }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M9.135035,2.916402c0,.0005,0,7.413295,0,7.413795", transform: "translate(.572407 0.091408)", fill: "#10559a", stroke: "#10549b", "stroke-width": "2" }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M4.892409,11.161144c-.820877-.046829-1.99248-.644821-2.226449-1.755594m1.479498,1.694655c1.487497.416215,5.458291.149777,5.015446-1.790623M2.691829,10.330197", transform: "translate(.534252 0.095968)", fill: "#10559a", stroke: "#10549b", "stroke-width": "2" }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M2.66596,8.463953", transform: "translate(.572407 0.091408)", fill: "#10559a", stroke: "#10549b", "stroke-width": "2" }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M2.66596,9.40555c0-.0005,0-.00101,0-.00151", fill: "#10559a", stroke: "#10549b", "stroke-width": "2" }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M2.64953,4.00781m.01642,5.39318l.00001.00305m0,0", fill: "#10559a", stroke: "#10549b", "stroke-width": "2" })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("mask", { id: "eyLdE3oPaKm23", "mask-type": "luminance", x: "-150%", y: "-150%", height: "400%", width: "400%" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M1.64648,3.00781h9.00792v8.99209h-9.00792v-8.99209Z", "clip-rule": "evenodd", fill: "#fff", "fill-rule": "evenodd" }))),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M6.89944,0.749411C6.89944,0.337235,6.56237,0,6.1504,0s-.74903.337235-.74903.749411v1.504819h1.49807v-1.504819Z", "clip-rule": "evenodd", fill: "#10559a", "fill-rule": "evenodd" }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", { mask: "url(#eyLdE3oPaKm29)" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M5.40137,2.25423h-2v2h2v-2Zm1.49807,0v2h2v-2h-2Zm2-1.504819C8.89944,-0.766389,7.66789,-2,6.1504,-2v4c-.69354,0-1.25096-.55914-1.25096-1.250589h4ZM6.1504,-2c-1.51748,0-2.74903,1.233611-2.74903,2.749411h4C7.40137,1.44086,6.84395,2,6.1504,2v-4ZM3.40137,0.749411v1.504819h4v-1.504819h-4Zm2,3.504819h1.49807v-4.000001h-1.49807v4.000001Zm3.49807-2v-1.504819h-4v1.504819h4Z", fill: "#10559a" }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("mask", { id: "eyLdE3oPaKm29", "mask-type": "luminance", x: "-150%", y: "-150%", height: "400%", width: "400%" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M6.89944,0.749411C6.89944,0.337235,6.56237,0,6.1504,0s-.74903.337235-.74903.749411v1.504819h1.49807v-1.504819Z", "clip-rule": "evenodd", fill: "#fff", "fill-rule": "evenodd" }))))));
};
//# sourceMappingURL=trash-icon.js.map

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BookingDetailsHeading */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__booking_details_heading_css__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__booking_details_heading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__booking_details_heading_css__);


var BookingDetailsHeading = function (_a) {
    var heading = _a.heading, accessBooking = _a.accessBooking;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-bk-dtl-heading" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h-bk-dtl-heading__title" }, heading),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "d-none d-md-block h-bk-dtl-heading__booking-access" }, accessBooking)));
};
//# sourceMappingURL=booking-details-heading.js.map

/***/ }),
/* 700 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 701 */
/***/ (function(module, exports) {

//# sourceMappingURL=models.js.map

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tabs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_propTypes__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UncontrolledTabs__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_count__ = __webpack_require__(236);
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }







var Tabs =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Tabs, _Component);

  function Tabs(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleSelected = function (index, last, event) {
      var onSelect = _this.props.onSelect; // Call change event handler

      if (typeof onSelect === 'function') {
        // Check if the change event handler cancels the tab change
        if (onSelect(index, last, event) === false) return;
      }

      var state = {
        // Set focus if the change was triggered from the keyboard
        focus: event.type === 'keydown'
      };

      if (Tabs.inUncontrolledMode(_this.props)) {
        // Update selected index
        state.selectedIndex = index;
      }

      _this.setState(state);
    };

    _this.state = Tabs.copyPropsToState(_this.props, {}, props.defaultFocus);
    return _this;
  }

  var _proto = Tabs.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
    if (false) {
      throw new Error("Switching between controlled mode (by using `selectedIndex`) and uncontrolled mode is not supported in `Tabs`.\nFor more information about controlled and uncontrolled mode of react-tabs see the README.");
    } // Use a transactional update to prevent race conditions
    // when reading the state in copyPropsToState
    // See https://github.com/reactjs/react-tabs/issues/51


    this.setState(function (state) {
      return Tabs.copyPropsToState(newProps, state);
    });
  };

  Tabs.inUncontrolledMode = function inUncontrolledMode(props) {
    return props.selectedIndex === null;
  };

  // preserve the existing selectedIndex from state.
  // If the state has not selectedIndex, default to the defaultIndex or 0
  Tabs.copyPropsToState = function copyPropsToState(props, state, focus) {
    if (focus === void 0) {
      focus = false;
    }

    var newState = {
      focus: focus
    };

    if (Tabs.inUncontrolledMode(props)) {
      var maxTabIndex = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_count__["b" /* getTabsCount */])(props.children) - 1;
      var selectedIndex = null;

      if (state.selectedIndex != null) {
        selectedIndex = Math.min(state.selectedIndex, maxTabIndex);
      } else {
        selectedIndex = props.defaultIndex || 0;
      }

      newState.selectedIndex = selectedIndex;
    }

    return newState;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        defaultIndex = _this$props.defaultIndex,
        defaultFocus = _this$props.defaultFocus,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "defaultIndex", "defaultFocus"]);

    var _this$state = this.state,
        focus = _this$state.focus,
        selectedIndex = _this$state.selectedIndex;
    props.focus = focus;
    props.onSelect = this.handleSelected;

    if (selectedIndex != null) {
      props.selectedIndex = selectedIndex;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__UncontrolledTabs__["a" /* default */], props, children);
  };

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Tabs.defaultProps = {
  defaultFocus: false,
  forceRenderTabPanel: false,
  selectedIndex: null,
  defaultIndex: null
};

Tabs.propTypes =  false ? {
  children: childrenPropType,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  defaultFocus: PropTypes.bool,
  defaultIndex: PropTypes.number,
  disabledTabClassName: PropTypes.string,
  domRef: PropTypes.func,
  forceRenderTabPanel: PropTypes.bool,
  onSelect: onSelectPropType,
  selectedIndex: selectedIndexPropType,
  selectedTabClassName: PropTypes.string,
  selectedTabPanelClassName: PropTypes.string
} : {};
Tabs.tabsRole = 'Tabs';

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UncontrolledTabs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_uuid__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_propTypes__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_count__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_childrenDeepMap__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_elementTypes__ = __webpack_require__(117);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }








 // Determine if a node from event.target is a Tab element

function isTabNode(node) {
  return 'getAttribute' in node && node.getAttribute('role') === 'tab';
} // Determine if a tab node is disabled


function isTabDisabled(node) {
  return node.getAttribute('aria-disabled') === 'true';
}

var canUseActiveElement;

try {
  canUseActiveElement = !!(typeof window !== 'undefined' && window.document && window.document.activeElement);
} catch (e) {
  // Work around for IE bug when accessing document.activeElement in an iframe
  // Refer to the following resources:
  // http://stackoverflow.com/a/10982960/369687
  // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12733599
  canUseActiveElement = false;
}

var UncontrolledTabs =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(UncontrolledTabs, _Component);

  function UncontrolledTabs() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.tabNodes = [];

    _this.handleKeyDown = function (e) {
      if (_this.isTabFromContainer(e.target)) {
        var index = _this.props.selectedIndex;
        var preventDefault = false;
        var useSelectedIndex = false;

        if (e.keyCode === 32 || e.keyCode === 13) {
          preventDefault = true;
          useSelectedIndex = false;

          _this.handleClick(e);
        }

        if (e.keyCode === 37 || e.keyCode === 38) {
          // Select next tab to the left
          index = _this.getPrevTab(index);
          preventDefault = true;
          useSelectedIndex = true;
        } else if (e.keyCode === 39 || e.keyCode === 40) {
          // Select next tab to the right
          index = _this.getNextTab(index);
          preventDefault = true;
          useSelectedIndex = true;
        } else if (e.keyCode === 35) {
          // Select last tab (End key)
          index = _this.getLastTab();
          preventDefault = true;
          useSelectedIndex = true;
        } else if (e.keyCode === 36) {
          // Select first tab (Home key)
          index = _this.getFirstTab();
          preventDefault = true;
          useSelectedIndex = true;
        } // This prevents scrollbars from moving around


        if (preventDefault) {
          e.preventDefault();
        } // Only use the selected index in the state if we're not using the tabbed index


        if (useSelectedIndex) {
          _this.setSelected(index, e);
        }
      }
    };

    _this.handleClick = function (e) {
      var node = e.target; // eslint-disable-next-line no-cond-assign

      do {
        if (_this.isTabFromContainer(node)) {
          if (isTabDisabled(node)) {
            return;
          }

          var index = [].slice.call(node.parentNode.children).filter(isTabNode).indexOf(node);

          _this.setSelected(index, e);

          return;
        }
      } while ((node = node.parentNode) !== null);
    };

    return _this;
  }

  var _proto = UncontrolledTabs.prototype;

  _proto.setSelected = function setSelected(index, event) {
    // Check index boundary
    if (index < 0 || index >= this.getTabsCount()) return;
    var _this$props = this.props,
        onSelect = _this$props.onSelect,
        selectedIndex = _this$props.selectedIndex; // Call change event handler

    onSelect(index, selectedIndex, event);
  };

  _proto.getNextTab = function getNextTab(index) {
    var count = this.getTabsCount(); // Look for non-disabled tab from index to the last tab on the right

    for (var i = index + 1; i < count; i++) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    } // If no tab found, continue searching from first on left to index


    for (var _i = 0; _i < index; _i++) {
      if (!isTabDisabled(this.getTab(_i))) {
        return _i;
      }
    } // No tabs are disabled, return index


    return index;
  };

  _proto.getPrevTab = function getPrevTab(index) {
    var i = index; // Look for non-disabled tab from index to first tab on the left

    while (i--) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    } // If no tab found, continue searching from last tab on right to index


    i = this.getTabsCount();

    while (i-- > index) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    } // No tabs are disabled, return index


    return index;
  };

  _proto.getFirstTab = function getFirstTab() {
    var count = this.getTabsCount(); // Look for non disabled tab from the first tab

    for (var i = 0; i < count; i++) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    }

    return null;
  };

  _proto.getLastTab = function getLastTab() {
    var i = this.getTabsCount(); // Look for non disabled tab from the last tab

    while (i--) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    }

    return null;
  };

  _proto.getTabsCount = function getTabsCount() {
    var children = this.props.children;
    return Object(__WEBPACK_IMPORTED_MODULE_5__helpers_count__["b" /* getTabsCount */])(children);
  };

  _proto.getPanelsCount = function getPanelsCount() {
    var children = this.props.children;
    return Object(__WEBPACK_IMPORTED_MODULE_5__helpers_count__["a" /* getPanelsCount */])(children);
  };

  _proto.getTab = function getTab(index) {
    return this.tabNodes["tabs-" + index];
  };

  _proto.getChildren = function getChildren() {
    var _this2 = this;

    var index = 0;
    var _this$props2 = this.props,
        children = _this$props2.children,
        disabledTabClassName = _this$props2.disabledTabClassName,
        focus = _this$props2.focus,
        forceRenderTabPanel = _this$props2.forceRenderTabPanel,
        selectedIndex = _this$props2.selectedIndex,
        selectedTabClassName = _this$props2.selectedTabClassName,
        selectedTabPanelClassName = _this$props2.selectedTabPanelClassName;
    this.tabIds = this.tabIds || [];
    this.panelIds = this.panelIds || [];
    var diff = this.tabIds.length - this.getTabsCount(); // Add ids if new tabs have been added
    // Don't bother removing ids, just keep them in case they are added again
    // This is more efficient, and keeps the uuid counter under control

    while (diff++ < 0) {
      this.tabIds.push(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_uuid__["a" /* default */])());
      this.panelIds.push(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_uuid__["a" /* default */])());
    } // Map children to dynamically setup refs


    return Object(__WEBPACK_IMPORTED_MODULE_6__helpers_childrenDeepMap__["b" /* deepMap */])(children, function (child) {
      var result = child; // Clone TabList and Tab components to have refs

      if (Object(__WEBPACK_IMPORTED_MODULE_7__helpers_elementTypes__["b" /* isTabList */])(child)) {
        var listIndex = 0; // Figure out if the current focus in the DOM is set on a Tab
        // If it is we should keep the focus on the next selected tab

        var wasTabFocused = false;

        if (canUseActiveElement) {
          wasTabFocused = __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.toArray(child.props.children).filter(__WEBPACK_IMPORTED_MODULE_7__helpers_elementTypes__["a" /* isTab */]).some(function (tab, i) {
            return document.activeElement === _this2.getTab(i);
          });
        }

        result = Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(child, {
          children: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_childrenDeepMap__["b" /* deepMap */])(child.props.children, function (tab) {
            var key = "tabs-" + listIndex;
            var selected = selectedIndex === listIndex;
            var props = {
              tabRef: function tabRef(node) {
                _this2.tabNodes[key] = node;
              },
              id: _this2.tabIds[listIndex],
              panelId: _this2.panelIds[listIndex],
              selected: selected,
              focus: selected && (focus || wasTabFocused)
            };
            if (selectedTabClassName) props.selectedClassName = selectedTabClassName;
            if (disabledTabClassName) props.disabledClassName = disabledTabClassName;
            listIndex++;
            return Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(tab, props);
          })
        });
      } else if (Object(__WEBPACK_IMPORTED_MODULE_7__helpers_elementTypes__["c" /* isTabPanel */])(child)) {
        var props = {
          id: _this2.panelIds[index],
          tabId: _this2.tabIds[index],
          selected: selectedIndex === index
        };
        if (forceRenderTabPanel) props.forceRender = forceRenderTabPanel;
        if (selectedTabPanelClassName) props.selectedClassName = selectedTabPanelClassName;
        index++;
        result = Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(child, props);
      }

      return result;
    });
  };

  /**
   * Determine if a node from event.target is a Tab element for the current Tabs container.
   * If the clicked element is not a Tab, it returns false.
   * If it finds another Tabs container between the Tab and `this`, it returns false.
   */
  _proto.isTabFromContainer = function isTabFromContainer(node) {
    // return immediately if the clicked element is not a Tab.
    if (!isTabNode(node)) {
      return false;
    } // Check if the first occurrence of a Tabs container is `this` one.


    var nodeAncestor = node.parentElement;

    do {
      if (nodeAncestor === this.node) return true;
      if (nodeAncestor.getAttribute('data-tabs')) break;
      nodeAncestor = nodeAncestor.parentElement;
    } while (nodeAncestor);

    return false;
  };

  _proto.render = function render() {
    var _this3 = this;

    // Delete all known props, so they don't get added to DOM
    var _this$props3 = this.props,
        children = _this$props3.children,
        className = _this$props3.className,
        disabledTabClassName = _this$props3.disabledTabClassName,
        domRef = _this$props3.domRef,
        focus = _this$props3.focus,
        forceRenderTabPanel = _this$props3.forceRenderTabPanel,
        onSelect = _this$props3.onSelect,
        selectedIndex = _this$props3.selectedIndex,
        selectedTabClassName = _this$props3.selectedTabClassName,
        selectedTabPanelClassName = _this$props3.selectedTabPanelClassName,
        attributes = _objectWithoutPropertiesLoose(_this$props3, ["children", "className", "disabledTabClassName", "domRef", "focus", "forceRenderTabPanel", "onSelect", "selectedIndex", "selectedTabClassName", "selectedTabPanelClassName"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", _extends({}, attributes, {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className),
      onClick: this.handleClick,
      onKeyDown: this.handleKeyDown,
      ref: function ref(node) {
        _this3.node = node;
        if (domRef) domRef(node);
      },
      "data-tabs": true
    }), this.getChildren());
  };

  return UncontrolledTabs;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

UncontrolledTabs.defaultProps = {
  className: 'react-tabs',
  focus: false
};

UncontrolledTabs.propTypes =  false ? {
  children: childrenPropType,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  disabledTabClassName: PropTypes.string,
  domRef: PropTypes.func,
  focus: PropTypes.bool,
  forceRenderTabPanel: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  selectedIndex: PropTypes.number.isRequired,
  selectedTabClassName: PropTypes.string,
  selectedTabPanelClassName: PropTypes.string
} : {};

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }





var TabList =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(TabList, _Component);

  function TabList() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = TabList.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        attributes = _objectWithoutPropertiesLoose(_this$props, ["children", "className"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul", _extends({}, attributes, {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className),
      role: "tablist"
    }), children);
  };

  return TabList;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

TabList.defaultProps = {
  className: 'react-tabs__tab-list'
};

TabList.propTypes =  false ? {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object])
} : {};
TabList.tabsRole = 'TabList';

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var DEFAULT_CLASS = 'react-tabs__tab';

var Tab =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Tab, _Component);

  function Tab() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Tab.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.checkFocus();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.checkFocus();
  };

  _proto.checkFocus = function checkFocus() {
    var _this$props = this.props,
        selected = _this$props.selected,
        focus = _this$props.focus;

    if (selected && focus) {
      this.node.focus();
    }
  };

  _proto.render = function render() {
    var _cx,
        _this = this;

    var _this$props2 = this.props,
        children = _this$props2.children,
        className = _this$props2.className,
        disabled = _this$props2.disabled,
        disabledClassName = _this$props2.disabledClassName,
        focus = _this$props2.focus,
        id = _this$props2.id,
        panelId = _this$props2.panelId,
        selected = _this$props2.selected,
        selectedClassName = _this$props2.selectedClassName,
        tabIndex = _this$props2.tabIndex,
        tabRef = _this$props2.tabRef,
        attributes = _objectWithoutPropertiesLoose(_this$props2, ["children", "className", "disabled", "disabledClassName", "focus", "id", "panelId", "selected", "selectedClassName", "tabIndex", "tabRef"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li", _extends({}, attributes, {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, (_cx = {}, _cx[selectedClassName] = selected, _cx[disabledClassName] = disabled, _cx)),
      ref: function ref(node) {
        _this.node = node;
        if (tabRef) tabRef(node);
      },
      role: "tab",
      id: id,
      "aria-selected": selected ? 'true' : 'false',
      "aria-disabled": disabled ? 'true' : 'false',
      "aria-controls": panelId,
      tabIndex: tabIndex || (selected ? '0' : null)
    }), children);
  };

  return Tab;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Tab.defaultProps = {
  className: DEFAULT_CLASS,
  disabledClassName: DEFAULT_CLASS + "--disabled",
  focus: false,
  id: null,
  panelId: null,
  selected: false,
  selectedClassName: DEFAULT_CLASS + "--selected"
};

Tab.propTypes =  false ? {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  disabled: PropTypes.bool,
  tabIndex: PropTypes.string,
  disabledClassName: PropTypes.string,
  focus: PropTypes.bool,
  // private
  id: PropTypes.string,
  // private
  panelId: PropTypes.string,
  // private
  selected: PropTypes.bool,
  // private
  selectedClassName: PropTypes.string,
  tabRef: PropTypes.func // private

} : {};
Tab.tabsRole = 'Tab';

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabPanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var DEFAULT_CLASS = 'react-tabs__tab-panel';

var TabPanel =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(TabPanel, _Component);

  function TabPanel() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = TabPanel.prototype;

  _proto.render = function render() {
    var _cx;

    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        forceRender = _this$props.forceRender,
        id = _this$props.id,
        selected = _this$props.selected,
        selectedClassName = _this$props.selectedClassName,
        tabId = _this$props.tabId,
        attributes = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "forceRender", "id", "selected", "selectedClassName", "tabId"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", _extends({}, attributes, {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, (_cx = {}, _cx[selectedClassName] = selected, _cx)),
      role: "tabpanel",
      id: id,
      "aria-labelledby": tabId
    }), forceRender || selected ? children : null);
  };

  return TabPanel;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

TabPanel.defaultProps = {
  className: DEFAULT_CLASS,
  forceRender: false,
  selectedClassName: DEFAULT_CLASS + "--selected"
};

TabPanel.propTypes =  false ? {
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  forceRender: PropTypes.bool,
  id: PropTypes.string,
  // private
  selected: PropTypes.bool,
  // private
  selectedClassName: PropTypes.string,
  tabId: PropTypes.string // private

} : {};
TabPanel.tabsRole = 'TabPanel';

/***/ }),
/* 707 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 708 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GuestTabs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tabs__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__guest_tabs_css__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__guest_tabs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__guest_tabs_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__avatar_avatar__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__to_dos_to_do_status__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__guest_form_container__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__scrollable_tab_list_scrollable_tab_list__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__media_query_media_query__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_breakpoints__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__footer_helpers__ = __webpack_require__(165);












var GuestTabs = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(GuestTabs, _super);
    function GuestTabs(props) {
        var _this = _super.call(this, props) || this;
        _this.renderGuestTab = function (guest, index) {
            var guestFullName = _this.getGuestFullName(guest, index);
            var isAddingThisGuest = guest.actionCode === 'A';
            var isGuestDisabled = _this.props.isAddingGuest && !isAddingThisGuest;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_tabs__["a" /* Tab */], { key: guest.seqNumber, className: "h-guest-tabs__tab", selectedClassName: "h-guest-tabs__tab--active", disabledClassName: "h-guest-tabs__tab--disabled", disabled: isGuestDisabled },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "d-flex" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__avatar_avatar__["a" /* Avatar */], { fullName: guestFullName, "aria-hidden": "true" }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-guest-tabs__details" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { "data-pii": "true", className: "h-guest-tabs__subtitle" }, guestFullName),
                        !isAddingThisGuest && _this.renderGuestStatus(guest.onlineCheckInStatus)))));
        };
        _this.renderGuestPanel = function (guest, index) {
            var _a = _this.state, specialOccasions = _a.specialOccasions, medicalAdvisories = _a.medicalAdvisories;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_tabs__["c" /* TabPanel */], { key: guest.seqNumber, className: "h-guest-tabs__tabpanel", selectedClassName: "h-guest-tabs__tabpanel--active" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__guest_form_container__["a" /* GuestFormContainer */], { guest: guest, guestIndex: index + 1, countries: _this.props.countries, titles: _this.props.titles, monthNames: _this.props.monthNames, specialOccasions: specialOccasions, medicalAdvisories: medicalAdvisories, content: _this.props.content, onGuestChanged: _this.props.onGuestChanged })));
        };
        _this.renderGuestStatus = function (onlineCheckInStatus) {
            var _a = _this.props.content, content = _a === void 0 ? { checkedIn: '', notCheckedIn: '', partiallyCheckedIn: '' } : _a;
            switch (onlineCheckInStatus) {
                case 'complete':
                    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__to_dos_to_do_status__["a" /* ToDoStatus */], { type: "completed" }, content.checkedIn);
                case 'started':
                    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__to_dos_to_do_status__["a" /* ToDoStatus */], { type: "started" }, content.partiallyCheckedIn);
                case 'pending':
                default:
                    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__to_dos_to_do_status__["a" /* ToDoStatus */], { type: "pending" }, content.notCheckedIn);
            }
        };
        _this.onSelect = function (index) {
            var _a = _this.props, onSelect = _a.onSelect, guests = _a.guests;
            onSelect(guests[index].seqNumber);
        };
        _this.state = {
            specialOccasions: getSpecialOccasions(_this.props.specialServices),
            medicalAdvisories: getMedicalAdvisories(_this.props.specialServices),
        };
        return _this;
    }
    GuestTabs.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.specialServices !== prevProps.specialServices) {
            this.setState({
                specialOccasions: getSpecialOccasions(this.props.specialServices),
                medicalAdvisories: getMedicalAdvisories(this.props.specialServices),
            });
        }
    };
    GuestTabs.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, guests = _a.guests;
        var selectedIndex = this.getSelectedIndex();
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__media_query_media_query__["a" /* MediaQuery */], { query: "(min-width: " + (__WEBPACK_IMPORTED_MODULE_10__styles_breakpoints__["b" /* Medium */] + 1) + "px)" }, function (matches) { return (matches ?
            _this.renderTabList(selectedIndex, guests, className) :
            _this.renderScrollableTabList(selectedIndex, guests, className)); }));
    };
    GuestTabs.prototype.renderTabList = function (selectedIndex, guests, className) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_tabs__["d" /* Tabs */], { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-guest-tabs', className), selectedIndex: selectedIndex, onSelect: this.onSelect },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_tabs__["b" /* TabList */], { className: "h-guest-tabs__container" }, guests.map(this.renderGuestTab)),
            guests.map(this.renderGuestPanel)));
    };
    GuestTabs.prototype.renderScrollableTabList = function (selectedIndex, guests, className) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_tabs__["d" /* Tabs */], { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-guest-tabs', className), selectedIndex: selectedIndex, onSelect: this.onSelect },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__scrollable_tab_list_scrollable_tab_list__["a" /* ScrollableTabList */], { className: "h-guest-tabs__container", selectedTabSelector: ".h-guest-tabs__tab--active", onSelect: this.onSelect, selectedIndex: selectedIndex }, guests.map(this.renderGuestTab)),
            guests.map(this.renderGuestPanel)));
    };
    GuestTabs.prototype.getSelectedIndex = function () {
        var _a = this.props, selectedGuestSeqNumber = _a.selectedGuestSeqNumber, guests = _a.guests;
        for (var i = 0; i < guests.length; i++) {
            if (guests[i].seqNumber === selectedGuestSeqNumber) {
                return i;
            }
        }
        return -1;
    };
    GuestTabs.prototype.getGuestFullName = function (guest, index) {
        var _a = this.props, content = _a.content, modifiedGuest = _a.modifiedGuest;
        var guestFullName;
        if (guest.actionCode === 'A' && modifiedGuest) {
            guestFullName = Object(__WEBPACK_IMPORTED_MODULE_11__footer_helpers__["b" /* toTitleCase */])(modifiedGuest.firstName + " " + modifiedGuest.lastName);
        }
        else {
            guestFullName = guest.firstName === 'TBA'
                ? content.guest + " " + (index + 1)
                : guest.firstName + " " + guest.lastName;
        }
        return guestFullName;
    };
    return GuestTabs;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

function getMedicalAdvisories(specialServices) {
    return specialServices ? specialServices.filter(function (service) { return service.typeCode === 'MED'; }) : [];
}
function getSpecialOccasions(specialServices) {
    return specialServices ? specialServices.filter(function (service) { return service.typeCode === 'OCC'; }) : [];
}
//# sourceMappingURL=guest-tabs.js.map

/***/ }),
/* 710 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GuestFormContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__guest_form__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__visually_hidden_visually_hidden__ = __webpack_require__(14);





var GuestFormContainer = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(GuestFormContainer, _super);
    function GuestFormContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.handleControlValueChange = function (control) {
            _this.setState(function (prevState) {
                var newControlGroup = Object(__WEBPACK_IMPORTED_MODULE_3__forms__["m" /* replaceControlModel */])(prevState.generalGroup, control);
                return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, prevState), { generalGroup: newControlGroup, errors: null });
            }, function () {
                _this.updateGuestAndNotify();
            });
        };
        _this.handleSpecialOccasionChange = function (control) {
            _this.setState(function (prevState) {
                var newControlGroup = Object(__WEBPACK_IMPORTED_MODULE_3__forms__["m" /* replaceControlModel */])(prevState.specialOccasionsGroup, control);
                var newChildControlGroup = _this.updateSpecialOccasionsChildrenGroup(prevState.specialOccasionsChildrenGroup, control);
                return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, prevState), { specialOccasionsGroup: newControlGroup, specialOccasionsChildrenGroup: newChildControlGroup, errors: null });
            }, function () {
                _this.checkMaxSelected();
                _this.updateGuestAndNotify();
            });
        };
        _this.updateSpecialOccasionsChildrenGroup = function (childrenGroup, parentControl) {
            if (!parentControl.props || !parentControl.props.childControlId) {
                return childrenGroup;
            }
            var childControl = childrenGroup.controls.get[parentControl.props.childControlId];
            if (!childControl) {
                return childrenGroup;
            }
            var newChildControl = Object(__WEBPACK_IMPORTED_MODULE_3__forms__["p" /* withValidators */])(childControl, {
                required: !!parentControl.checked,
            });
            return Object(__WEBPACK_IMPORTED_MODULE_3__forms__["m" /* replaceControlModel */])(childrenGroup, newChildControl);
        };
        _this.handleMedicalAdvisoryChange = function (control) {
            _this.setState(function (prevState) {
                var newControlGroup = Object(__WEBPACK_IMPORTED_MODULE_3__forms__["m" /* replaceControlModel */])(prevState.medicalAdvisoriesGroup, control);
                return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, prevState), { medicalAdvisoriesGroup: newControlGroup, errors: null });
            }, function () {
                _this.checkMaxSelected();
                _this.updateGuestAndNotify();
            });
        };
        _this.handleSpecialOccasionChildControlChange = function (control) {
            _this.setState(function (prevState) {
                var newControlGroup = Object(__WEBPACK_IMPORTED_MODULE_3__forms__["m" /* replaceControlModel */])(prevState.specialOccasionsChildrenGroup, control);
                return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, prevState), { specialOccasionsChildrenGroup: newControlGroup, errors: null });
            }, function () {
                _this.updateGuestAndNotify();
            });
        };
        _this.checkMaxSelected = function () {
            var _a = _this.state, specialOccasionsGroup = _a.specialOccasionsGroup, medicalAdvisoriesGroup = _a.medicalAdvisoriesGroup;
            var checkedSpecialOccasions = specialOccasionsGroup.controls.all.filter(function (s) { return s.checked; }).length;
            var checkedMedicalAdvisories = medicalAdvisoriesGroup.controls.all.filter(function (s) { return s.checked; }).length;
            if (checkedSpecialOccasions + checkedMedicalAdvisories >= 5) {
                var newSpecialOccasionsGroup = _this.disableUnchecked(specialOccasionsGroup);
                var newMedicalAdvisoriesGroup = _this.disableUnchecked(medicalAdvisoriesGroup);
                _this.setState({
                    specialOccasionsGroup: newSpecialOccasionsGroup,
                    medicalAdvisoriesGroup: newMedicalAdvisoriesGroup,
                });
            }
            else {
                var newSpecialOccasionsGroup = _this.enableAll(specialOccasionsGroup);
                var newMedicalAdvisoriesGroup = _this.enableAll(medicalAdvisoriesGroup);
                _this.setState({
                    specialOccasionsGroup: newSpecialOccasionsGroup,
                    medicalAdvisoriesGroup: newMedicalAdvisoriesGroup,
                });
            }
        };
        _this.isModelValid = function () {
            var _a = _this.state, generalGroup = _a.generalGroup, specialOccasionsChildrenGroup = _a.specialOccasionsChildrenGroup;
            var validatedGeneralGroup = Object(__WEBPACK_IMPORTED_MODULE_3__forms__["n" /* validateControlGroup */])(generalGroup, _this.formContainerRef.current);
            if (!validatedGeneralGroup.valid) {
                _this.setState({
                    generalGroup: validatedGeneralGroup,
                    errors: Object(__WEBPACK_IMPORTED_MODULE_3__forms__["j" /* getErrorMessages */])(validatedGeneralGroup.controls.all),
                });
                return false;
            }
            var validatedSpecialOccasionsChildrenGroup = Object(__WEBPACK_IMPORTED_MODULE_3__forms__["n" /* validateControlGroup */])(specialOccasionsChildrenGroup, _this.formContainerRef.current);
            if (!validatedSpecialOccasionsChildrenGroup.valid) {
                _this.setState({
                    specialOccasionsChildrenGroup: validatedSpecialOccasionsChildrenGroup,
                    errors: Object(__WEBPACK_IMPORTED_MODULE_3__forms__["j" /* getErrorMessages */])(validatedSpecialOccasionsChildrenGroup.controls.all),
                });
                return false;
            }
            return true;
        };
        _this.disableUnchecked = function (specialServicesGroup) {
            var uncheckedServices = specialServicesGroup.controls.all
                .filter(function (s) { return !s.checked; })
                .map(function (control) {
                return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, control), { props: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, control.props), { disabled: true }) });
            });
            return uncheckedServices.reduce(function (current, control) { return Object(__WEBPACK_IMPORTED_MODULE_3__forms__["m" /* replaceControlModel */])(current, control); }, specialServicesGroup);
        };
        _this.enableAll = function (specialServicesGroup) {
            var uncheckedServices = specialServicesGroup.controls.all
                .map(function (control) {
                return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, control), { props: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, control.props), { disabled: false }) });
            });
            return uncheckedServices.reduce(function (current, control) { return Object(__WEBPACK_IMPORTED_MODULE_3__forms__["m" /* replaceControlModel */])(current, control); }, specialServicesGroup);
        };
        _this.createControlGroup = function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, _this.createGeneralControlGroup()), _this.createSpecialServicesControlGroup());
        };
        _this.createGeneralControlGroup = function () {
            var _a = _this.props.guest, guest = _a === void 0 ? {
                seqNumber: 0,
                firstName: '',
                lastName: '',
                titleCode: '',
                genderCode: '',
                dobYear: 0,
                dobMonth: 0,
                dobDay: 0,
                nationalityCode: '',
                phoneNumber: '',
                loyaltyNumber: '',
                specialServices: null
            } : _a;
            var generalGroup = Object(__WEBPACK_IMPORTED_MODULE_3__forms__["h" /* createControlGroup */])(Object(__WEBPACK_IMPORTED_MODULE_3__forms__["i" /* createControlModel */])({
                name: 'titleCode',
                value: guest.titleCode,
                validators: {
                    required: true,
                },
                errorMessages: {
                    required: _this.props.content.titleRequired,
                }
            }), Object(__WEBPACK_IMPORTED_MODULE_3__forms__["i" /* createControlModel */])({
                name: 'firstName',
                value: guest.firstName,
                validators: {
                    required: true,
                    pattern: _this.props.content.firstNameRegex,
                },
                errorMessages: {
                    required: _this.props.content.firstNameRequired,
                    pattern: _this.props.content.firstNameInvalid,
                }
            }), Object(__WEBPACK_IMPORTED_MODULE_3__forms__["i" /* createControlModel */])({
                name: 'lastName',
                value: guest.lastName,
                validators: {
                    required: true,
                    pattern: _this.props.content.lastNameRegex,
                },
                errorMessages: {
                    required: _this.props.content.lastNameRequired,
                    pattern: _this.props.content.lastNameInvalid,
                }
            }), Object(__WEBPACK_IMPORTED_MODULE_3__forms__["i" /* createControlModel */])({
                name: 'dobMonth',
                value: guest.dobMonth ? "" + guest.dobMonth : '',
                validators: {
                    required: true,
                },
                errorMessages: {
                    required: _this.props.content.monthRequired,
                }
            }), Object(__WEBPACK_IMPORTED_MODULE_3__forms__["i" /* createControlModel */])({
                name: 'dobDay',
                value: guest.dobDay ? "" + guest.dobDay : '',
                validators: {
                    required: true,
                },
                errorMessages: {
                    required: _this.props.content.dayRequired,
                }
            }), Object(__WEBPACK_IMPORTED_MODULE_3__forms__["i" /* createControlModel */])({
                name: 'dobYear',
                value: guest.dobYear ? "" + guest.dobYear : '',
                validators: {
                    required: true,
                },
                errorMessages: {
                    required: _this.props.content.yearRequired,
                }
            }), Object(__WEBPACK_IMPORTED_MODULE_3__forms__["i" /* createControlModel */])({
                name: 'genderCode',
                value: guest.genderCode,
                validators: {
                    required: true,
                },
                errorMessages: {
                    required: _this.props.content.genderRequired,
                }
            }), Object(__WEBPACK_IMPORTED_MODULE_3__forms__["i" /* createControlModel */])({
                name: 'nationalityCode',
                value: guest.nationalityCode,
                validators: {
                    required: true,
                },
                errorMessages: {
                    required: _this.props.content.nationalityRequired,
                }
            }), Object(__WEBPACK_IMPORTED_MODULE_3__forms__["i" /* createControlModel */])({
                name: 'phoneNumber',
                value: guest.phoneNumber,
                validators: {
                    pattern: _this.props.content.phoneNumberRegex,
                },
                errorMessages: {
                    pattern: _this.props.content.phoneNumberInvalid,
                }
            }), Object(__WEBPACK_IMPORTED_MODULE_3__forms__["i" /* createControlModel */])({
                name: 'loyaltyNumber',
                value: guest.loyaltyNumber,
                validators: {
                    pattern: _this.props.content.loyaltyNumberRegex,
                },
                errorMessages: {
                    pattern: _this.props.content.loyaltyNumberInvalid,
                }
            }), Object(__WEBPACK_IMPORTED_MODULE_3__forms__["i" /* createControlModel */])({
                name: 'militaryStatus',
                checked: false
            }));
            return {
                generalGroup: generalGroup,
            };
        };
        _this.createSpecialServicesControlGroup = function () {
            var _a = _this.props, _b = _a.specialOccasions, specialOccasions = _b === void 0 ? [] : _b, _c = _a.medicalAdvisories, medicalAdvisories = _c === void 0 ? [] : _c, _d = _a.guest, guest = _d === void 0 ? {
                specialServices: null
            } : _d;
            var specialOccasionsGroup = __WEBPACK_IMPORTED_MODULE_3__forms__["h" /* createControlGroup */].apply(void 0, specialOccasions.map(function (specialOccasion) { return Object(__WEBPACK_IMPORTED_MODULE_3__forms__["i" /* createControlModel */])({
                name: specialOccasion.code,
                checked: isIncluded(guest.specialServices, specialOccasion),
                props: {
                    label: specialOccasion.description,
                    disabled: false,
                    childControlId: specialOccasion.code + "_Date",
                },
            }); }));
            var medicalAdvisoriesGroup = __WEBPACK_IMPORTED_MODULE_3__forms__["h" /* createControlGroup */].apply(void 0, medicalAdvisories.map(function (medicalAdvisory) { return Object(__WEBPACK_IMPORTED_MODULE_3__forms__["i" /* createControlModel */])({
                name: medicalAdvisory.code,
                checked: isIncluded(guest.specialServices, medicalAdvisory),
                props: {
                    label: medicalAdvisory.description,
                    disabled: false,
                },
            }); }));
            var specialOccasionsChildrenControls = specialOccasions
                .reduce(function (current, specialOccasion) {
                var childControl = _this.createChildControl(guest.specialServices, specialOccasion);
                return childControl ? Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spreadArrays */])(current, [childControl]) : current;
            }, []);
            var specialOccasionsChildrenGroup = __WEBPACK_IMPORTED_MODULE_3__forms__["h" /* createControlGroup */].apply(void 0, specialOccasionsChildrenControls);
            return {
                specialOccasionsGroup: specialOccasionsGroup,
                medicalAdvisoriesGroup: medicalAdvisoriesGroup,
                specialOccasionsChildrenGroup: specialOccasionsChildrenGroup,
            };
        };
        _this.createChildControl = function (guestSpecialServices, specialService) {
            var dateValue = getDateValue(guestSpecialServices, specialService);
            return specialService.validDates && specialService.validDates.length > 0 ? Object(__WEBPACK_IMPORTED_MODULE_3__forms__["i" /* createControlModel */])({
                name: specialService.code + "_Date",
                value: dateValue,
                validators: {
                    required: isIncluded(guestSpecialServices, specialService),
                },
                errorMessages: {
                    required: _this.props.content.dateRequired,
                },
                props: {
                    validDates: specialService.validDates,
                },
            }) : undefined;
        };
        _this.state = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ errors: null }, _this.createControlGroup());
        _this.formContainerRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        return _this;
    }
    GuestFormContainer.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.props.guest && this.props.guest !== prevProps.guest ||
            this.props.countries !== prevProps.countries ||
            this.props.titles !== prevProps.titles ||
            this.props.monthNames !== prevProps.monthNames) {
            this.setState(this.createGeneralControlGroup());
        }
        if (this.props.specialOccasions !== prevProps.specialOccasions ||
            this.props.medicalAdvisories !== prevProps.medicalAdvisories) {
            this.setState(this.createSpecialServicesControlGroup());
        }
    };
    GuestFormContainer.prototype.render = function () {
        var errors = this.state.errors;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this.formContainerRef },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__guest_form__["a" /* GuestForm */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.props, { controls: this.state, onControlChange: this.handleControlValueChange, onSpecialOccasionChange: this.handleSpecialOccasionChange, onMedicalAdvisoryChange: this.handleMedicalAdvisoryChange, onChildControlChange: this.handleSpecialOccasionChildControlChange })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], null, errors && errors.join('. '))));
    };
    GuestFormContainer.prototype.updateGuestAndNotify = function () {
        var _a = this.state, generalGroup = _a.generalGroup, specialOccasionsGroup = _a.specialOccasionsGroup, medicalAdvisoriesGroup = _a.medicalAdvisoriesGroup, specialOccasionsChildrenGroup = _a.specialOccasionsChildrenGroup;
        // tslint:disable-next-line:no-any
        var guestValues = Object(__WEBPACK_IMPORTED_MODULE_3__forms__["o" /* values */])(generalGroup);
        var guestSpecialOccasions = getGuestSpecialServices(specialOccasionsGroup, specialOccasionsChildrenGroup, this.props.specialOccasions);
        var guestMedicalAdvisories = getGuestSpecialServices(medicalAdvisoriesGroup, null, this.props.medicalAdvisories);
        guestValues.dobMonth = guestValues.dobMonth ? parseInt(guestValues.dobMonth, 10) : null;
        guestValues.dobDay = guestValues.dobDay ? parseInt(guestValues.dobDay, 10) : null;
        guestValues.dobYear = guestValues.dobYear ? parseInt(guestValues.dobYear, 10) : null;
        var guest = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.props.guest), guestValues), { specialServices: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spreadArrays */])(guestSpecialOccasions, guestMedicalAdvisories) });
        this.props.onGuestChanged(guest, this.isModelValid);
    };
    return GuestFormContainer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

function isIncluded(guestSpecialServices, specialService) {
    return guestSpecialServices ? !!guestSpecialServices.find(function (srv) { return srv.code === specialService.code; }) : false;
}
function getDateValue(guestSpecialServices, specialService) {
    var guestSpecialService = guestSpecialServices ? guestSpecialServices.find(function (srv) { return srv.code === specialService.code; }) : '';
    return guestSpecialService && guestSpecialService.date ? guestSpecialService.date.substr(0, 10) : '';
}
function getGuestSpecialServices(controlGroup, childrenControlGroup, specialServices) {
    return controlGroup.controls.all
        .filter(function (control) { return control.checked; })
        .map(function (control) {
        return {
            code: control.id,
            typeCode: specialServices.find(function (s) { return s.code === control.id; }).typeCode,
            date: control.props && control.props.childControlId && childrenControlGroup &&
                childrenControlGroup.controls.get[control.props.childControlId]
                ? childrenControlGroup.controls.get[control.props.childControlId].value
                : null,
        };
    });
}
//# sourceMappingURL=guest-form-container.js.map

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GuestForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__guest_form_css__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__guest_form_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__guest_form_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__avatar_avatar__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__eyebrow_eyebrow__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icons__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_colors__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__visually_hidden_visually_hidden__ = __webpack_require__(14);









function scrollToElement(elemId) {
    var el = document.getElementById(elemId);
    if (el) {
        setTimeout(function () {
            el.scrollIntoView({ behavior: 'smooth' });
            el.focus();
        }, 100);
    }
}
function scrollAnchorToElement(anchorMatch, elemId, hash) {
    if (hash === anchorMatch) {
        scrollToElement(elemId);
    }
}
var GuestForm = function (componentProps) {
    var titles = componentProps.titles, countries = componentProps.countries, monthNames = componentProps.monthNames, content = componentProps.content, controls = componentProps.controls, guestIndex = componentProps.guestIndex, onControlChange = componentProps.onControlChange, onSpecialOccasionChange = componentProps.onSpecialOccasionChange, onMedicalAdvisoryChange = componentProps.onMedicalAdvisoryChange, onChildControlChange = componentProps.onChildControlChange;
    var generalGroup = controls.generalGroup, specialOccasionsGroup = controls.specialOccasionsGroup, medicalAdvisoriesGroup = controls.medicalAdvisoriesGroup, specialOccasionsChildrenGroup = controls.specialOccasionsChildrenGroup;
    var firstName = generalGroup.controls.get.firstName.value;
    var lastName = generalGroup.controls.get.lastName.value;
    var guestFullName = firstName === 'TBA'
        ? content.guest + " " + guestIndex
        : firstName + " " + lastName;
    var years = getYears();
    var months = getMonths(monthNames);
    var days = getDays();
    var hasSpecialOccasions = specialOccasionsGroup.controls.all && specialOccasionsGroup.controls.all.length > 0;
    var hasMedicalAdvisories = medicalAdvisoriesGroup.controls.all && medicalAdvisoriesGroup.controls.all.length > 0;
    var selectToApplyToGuest = content.selectAllThatApply.replace('{guest}', guestFullName);
    var hash = window.location.hash.substring(1);
    var formId = "h-form__guest-" + guestIndex;
    __WEBPACK_IMPORTED_MODULE_1_react__["useEffect"](function () {
        if (hasMedicalAdvisories) {
            var key = 'medical-advisories';
            scrollAnchorToElement(key, key, hash);
        }
        if (hasSpecialOccasions) {
            var key = 'special-occasion';
            scrollAnchorToElement(key, key, hash);
        }
    }, [hash]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("form", { className: "h-form-guest", noValidate: true },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row", id: formId },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-12 col-lg-3" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-form-guest__avatar-container" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__avatar_avatar__["a" /* Avatar */], { fullName: guestFullName, "aria-hidden": "true", className: "h-form-guest__avatar" })),
                false && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-form-guest__edit-image" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { className: "h-form-guest__action-link", href: "#", onClick: function () { return alert('Coming soon'); }, role: "button" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__icons__["EditIcon"], { width: 13, height: 13, color: __WEBPACK_IMPORTED_MODULE_7__styles_colors__["c" /* BlueColor */], "aria-hidden": "true" }),
                        ' ' + content.editImage))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-12 col-lg-9" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row align-items-center" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-12 col-lg-2" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["c" /* FormField */], { controlModel: generalGroup.controls.get.titleCode, onFieldUpdate: onControlChange }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["g" /* Select */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.controlProps),
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("option", { "aria-label": content.select + " " + content.title }),
                                titles.map(function (title) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("option", { key: title.titleCode, value: title.titleCode }, title.titleName)); })),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.labelProps), content.title),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["b" /* Error */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.errorProps)))); })),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-12 col-lg-5" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["c" /* FormField */], { controlModel: generalGroup.controls.get.firstName, onFieldUpdate: onControlChange }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["d" /* Input */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ maxLength: 10 }, props.controlProps)),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.labelProps), content.firstName),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["b" /* Error */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.errorProps)))); })),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-12 col-lg-5" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["c" /* FormField */], { controlModel: generalGroup.controls.get.lastName, onFieldUpdate: onControlChange }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["d" /* Input */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ maxLength: 15 }, props.controlProps)),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.labelProps), content.lastName),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["b" /* Error */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.errorProps)))); }))),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-12 col-lg-5" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["c" /* FormField */], { controlModel: generalGroup.controls.get.dobMonth, onFieldUpdate: onControlChange }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["g" /* Select */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.controlProps),
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("option", { "aria-label": content.select + " " + content.month }),
                                months.map(function (month) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("option", { key: month.value, value: month.value }, month.label)); })),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.labelProps), content.month),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["b" /* Error */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.errorProps)))); })),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-12 col-lg-2" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["c" /* FormField */], { controlModel: generalGroup.controls.get.dobDay, onFieldUpdate: onControlChange }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["g" /* Select */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.controlProps),
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("option", { "aria-label": content.select + " " + content.day }),
                                days.map(function (day) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("option", { key: day.value, value: day.value }, day.label)); })),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.labelProps), content.day),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["b" /* Error */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.errorProps)))); })),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-12 col-lg-5" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["c" /* FormField */], { controlModel: generalGroup.controls.get.dobYear, onFieldUpdate: onControlChange }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["g" /* Select */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.controlProps),
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("option", { "aria-label": content.select + " " + content.year }),
                                years.map(function (year) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("option", { key: year.value, value: year.value }, year.label)); })),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.labelProps), content.year),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["b" /* Error */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.errorProps)))); }))),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-12 col-lg-6" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["c" /* FormField */], { controlModel: generalGroup.controls.get.genderCode, onFieldUpdate: onControlChange }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["g" /* Select */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.controlProps),
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("option", { "aria-label": content.select + " " + content.gender }),
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("option", { value: "M" }, content.male),
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("option", { value: "F" }, content.female)),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.labelProps), content.gender),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["b" /* Error */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.errorProps)))); })),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-12 col-lg-6" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["c" /* FormField */], { controlModel: generalGroup.controls.get.nationalityCode, onFieldUpdate: onControlChange }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["g" /* Select */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.controlProps),
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("option", { "aria-label": content.select + " " + content.nationality }),
                                countries.map(function (country) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("option", { key: country.code, value: country.code }, country.name)); })),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.labelProps), content.nationality),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["b" /* Error */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.errorProps)))); }))),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-12 col-lg-6" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["c" /* FormField */], { controlModel: generalGroup.controls.get.phoneNumber, onFieldUpdate: onControlChange }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["d" /* Input */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ type: "tel", maxLength: 12 }, props.controlProps)),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.labelProps), content.phoneNumber),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["b" /* Error */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.errorProps)))); })),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-12- col-lg-6" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["c" /* FormField */], { controlModel: generalGroup.controls.get.loyaltyNumber, onFieldUpdate: onControlChange }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["d" /* Input */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ type: "tel", maxLength: 20 }, props.controlProps)),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.labelProps), content.vifpNumber),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["b" /* Error */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.errorProps)))); }))),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-12 h-form-guest__hidden-field" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("fieldset", { className: "h-form-guest__checkbox--container" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("legend", { className: "h-form-guest__legend" },
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__eyebrow_eyebrow__["a" /* Eyebrow */], null, content.militaryStatus)),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["c" /* FormField */], { controlModel: generalGroup.controls.get.militaryStatus, onFieldUpdate: onControlChange }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["a" /* Checkbox */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.controlProps)),
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.labelProps), content.militaryDescription))); }))),
                    hasSpecialOccasions && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-12", id: "special-occasion" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("fieldset", { className: "h-form-guest__checkbox--container" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("legend", { className: "h-form-guest__legend" },
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__eyebrow_eyebrow__["a" /* Eyebrow */], null, content.specialOccasion),
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { className: "h-form-guest__checkbox-hint" }, selectToApplyToGuest)),
                            specialOccasionsGroup.controls.all.map(function (controlModel) {
                                var childControl = controlModel.props && controlModel.props.childControlId
                                    ? specialOccasionsChildrenGroup.controls.get[controlModel.props.childControlId]
                                    : null;
                                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: controlModel.id },
                                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["c" /* FormField */], { controlModel: controlModel, onFieldUpdate: onSpecialOccasionChange }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["a" /* Checkbox */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ disabled: controlModel.props.disabled }, (childControl && {
                                            'aria-controls': controlModel.id + "_DateContainer",
                                            'aria-owns': controlModel.id + "_DateContainer",
                                        }), props.controlProps)),
                                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ id: controlModel.id + "_Label" }, props.labelProps),
                                            controlModel.props.label,
                                            childControl && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], null, content.checkToSelectDate))))); }),
                                    childControl && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-4", hidden: !controlModel.checked, id: controlModel.id + "_DateContainer" },
                                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["c" /* FormField */], { controlModel: childControl, onFieldUpdate: onChildControlChange }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["g" /* Select */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ "aria-labelledby": controlModel.id + "_Label" }, props.controlProps),
                                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("option", { "aria-label": content.select + " " + content.date }),
                                                childControl.props.validDates.map(function (date) {
                                                    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("option", { key: date.value, value: date.value }, date.label));
                                                })),
                                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["b" /* Error */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.errorProps)))); })))));
                            })))),
                    hasMedicalAdvisories && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-12", id: "medical-advisories" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("fieldset", { className: "h-form-guest__checkbox--container" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("legend", { className: "h-form-guest__legend" },
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__eyebrow_eyebrow__["a" /* Eyebrow */], null, content.medicalAdvisories),
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { className: "h-form-guest__checkbox-hint" }, selectToApplyToGuest),
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-form-guest__checkbox-disclaimer" },
                                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { className: "h-form-guest__checkbox-disclaimer-link", href: "#", onClick: function () { return alert('Coming soon'); } }, content.readAboutFacilitiesAndServices))),
                            medicalAdvisoriesGroup.controls.all.map(function (controlModel) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["c" /* FormField */], { key: controlModel.id, controlModel: controlModel, onFieldUpdate: onMedicalAdvisoryChange }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["a" /* Checkbox */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ disabled: !!controlModel.props.disabled }, props.controlProps)),
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.labelProps), controlModel.props.label))); })); })))),
                    (hasSpecialOccasions || hasMedicalAdvisories) && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-12" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-form-guest__max-selected-info" }, content.maxSpecialServicesSelected))))))));
};
function getYears() {
    var currentYear = new Date().getFullYear();
    var years = [];
    for (var year = currentYear; year > currentYear - 111; year--) {
        years.push({
            value: year,
            label: "" + year,
        });
    }
    return years;
}
function getMonths(monthNames) {
    return monthNames.map(function (monthName, index) {
        var monthIndex = index + 1;
        return {
            value: monthIndex,
            label: monthName,
        };
    });
}
function getDays() {
    var days = [];
    for (var day = 1; day <= 31; day++) {
        days.push({
            value: day,
            label: "" + day,
        });
    }
    return days;
}
//# sourceMappingURL=guest-form.js.map

/***/ }),
/* 713 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GuestDetailsModalTrigger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__guest_details__ = __webpack_require__(233);




var GuestDetailsModalTrigger = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(GuestDetailsModalTrigger, _super);
    function GuestDetailsModalTrigger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GuestDetailsModalTrigger.prototype.render = function () {
        var _a = this.props, isOpen = _a.isOpen, restProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["isOpen"]);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__modal_modal__["a" /* Modal */], { shell: false, isOpen: isOpen, fullScreen: true, onRequestClose: this.props.onRequestClose, dialogDescription: this.props.content.heading },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__guest_details__["a" /* GuestDetails */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ mode: "modal" }, restProps))));
    };
    return GuestDetailsModalTrigger;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=guest-details-modal-trigger.js.map

/***/ }),
/* 715 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BeddingFormContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bedding_form__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__forms_index__ = __webpack_require__(10);




var BeddingFormContainer = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(BeddingFormContainer, _super);
    function BeddingFormContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            beddingModel: Object(__WEBPACK_IMPORTED_MODULE_3__forms_index__["i" /* createControlModel */])({
                name: 'bedding',
                value: _this.props.booking.beddingOptions.filter(function (n) { return n.selected; })[0].code,
                checked: true
            })
        };
        _this.onFieldUpdate = function (control) {
            _this.setState({ beddingModel: control });
            _this.props.onChange(control.value);
        };
        return _this;
    }
    BeddingFormContainer.prototype.render = function () {
        var _a = this.props, content = _a.content, booking = _a.booking;
        var beddingModel = this.state.beddingModel;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__bedding_form__["a" /* BeddingForm */], { content: content, guestNames: booking.guestNames, options: booking.beddingOptions, beddingModel: beddingModel, onFieldUpdate: this.onFieldUpdate }));
    };
    return BeddingFormContainer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=bedding-form-container.js.map

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BeddingForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms_index__ = __webpack_require__(10);



var BeddingForm = function (_a) {
    var content = _a.content, guestNames = _a.guestNames, beddingModel = _a.beddingModel, options = _a.options, onFieldUpdate = _a.onFieldUpdate;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bedding-details" },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-lg-5" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bedding-details__form__options-col" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("fieldset", { className: "h-form__fieldset-reset" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("legend", { className: "h-form__fieldset-reset" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bedding-details__guests" },
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bedding-details__heading", tabIndex: 0 }, content.beddingFor),
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { "data-pii": "true", className: "h-bedding-details__guest-container" }, guestNames))),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bedding-details__bed-type" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms_index__["c" /* FormField */], { controlModel: beddingModel, onFieldUpdate: onFieldUpdate }, function (props) { return (options.map(function (o, i) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: i },
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms_index__["f" /* Radio */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, Object(__WEBPACK_IMPORTED_MODULE_2__forms_index__["k" /* radioControlProps */])(props.controlProps, o.code, o.code))),
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms_index__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, Object(__WEBPACK_IMPORTED_MODULE_2__forms_index__["l" /* radioLabelProps */])(props.labelProps, o.code)), o.name))); })); }))))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-lg-7 h-bedding-details__disclaimer", dangerouslySetInnerHTML: { __html: content.explanation } }))));
};
//# sourceMappingURL=bedding-form.js.map

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BeddingDetailsModalTrigger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bedding_details__ = __webpack_require__(238);




var BeddingDetailsModalTrigger = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(BeddingDetailsModalTrigger, _super);
    function BeddingDetailsModalTrigger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BeddingDetailsModalTrigger.prototype.render = function () {
        var _a = this.props, isOpen = _a.isOpen, restProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["isOpen"]);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__modal_modal__["a" /* Modal */], { shell: false, isOpen: isOpen, fullScreen: true, onRequestClose: this.props.onRequestClose, dialogDescription: this.props.content.heading },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__bedding_details__["a" /* BeddingDetails */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ mode: "modal" }, restProps))));
    };
    return BeddingDetailsModalTrigger;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=bedding-details-modal-trigger.js.map

/***/ }),
/* 719 */
/***/ (function(module, exports) {

//# sourceMappingURL=models.js.map

/***/ }),
/* 720 */
/***/ (function(module, exports) {

//# sourceMappingURL=model.js.map

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Orders */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_colors__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icons__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__visually_hidden_visually_hidden__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__orders_heading__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__orders_css__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__orders_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__orders_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__booking_selector_booking_selector__ = __webpack_require__(112);










var Orders = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Orders, _super);
    function Orders() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderBookingSelector = function (bookingSelectorProps) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "container" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-orders__booking-selector-wrapper" }, __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-orders__booking-selector-filter" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__booking_selector_booking_selector__["a" /* BookingSelector */], { content: bookingSelectorProps.content, onSelectedBookings: bookingSelectorProps.onSelectedBookings, selectedBookings: bookingSelectorProps.selectedBookings, activeSailing: bookingSelectorProps.activeSailing, parentNameRef: "order-details", disableSelector: bookingSelectorProps.disableSelector })))));
        };
        _this.renderDateOrders = function (dateOrders) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: dateOrders.orderDate },
                _this.renderOrderHeader(dateOrders),
                dateOrders.bookingsOrders && dateOrders.bookingsOrders.map(_this.renderBookingOrders)));
        };
        _this.renderBookingOrders = function (order) {
            var content = _this.props.content;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: order.bookingNumber + "_" + order.orderNumber, className: "h-orders__history-container" }, order.orderDetails.map(function (od, i) { return _this.renderOrderDetail(order, od, Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["b" /* getJointKeys */])(order.orderNumber, i), content, i === 0); })));
        };
        _this.renderOrderDetail = function (order, orderDetail, key, content, showEdit) {
            var bookingNumber = order.bookingNumber, associatedBookingNumbers = order.associatedBookingNumbers, orderType = order.orderType;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: key },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("article", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-orders__history-card', { 'h-orders__history-card-details--multiple': !showEdit }) },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-lg-2" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("figure", { className: "h-orders__history-card__thumbnail" },
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", { className: "h-orders__card-image", src: orderDetail.itemImageUrl, alt: "" }))),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: showEdit ? 'col-lg-8' : 'col-lg-10' },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-orders__history-card__details" },
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h3", { className: "h-order__history__card-details__service" }, orderDetail.productName),
                                orderDetail.portName &&
                                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { className: "h-order__history-card-details__date" },
                                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("strong", null, _this.props.content.port),
                                        " ",
                                        orderDetail.portName),
                                _this.renderDayOrDuration(orderDetail),
                                _this.renderServiceTime(orderDetail),
                                _this.renderGuests(bookingNumber, associatedBookingNumbers, orderDetail),
                                !orderDetail.isDining && _this.showQuantity(orderType) && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { className: "h-order__history-card-details__quantity" },
                                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("strong", null, _this.props.content.quantity),
                                    " ",
                                    orderDetail.quantity)))),
                        showEdit &&
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-lg-2" }, order.allowEdit && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { className: "h-orders__history__action-link--edit", href: "", role: "button", "data-order": order.orderNumber, id: Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* getEditOrderLinkId */])(order.bookingNumber, order.orderNumber), onClick: _this.onEditOrder },
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__icons__["EditIcon"], { width: 13, height: 13, color: __WEBPACK_IMPORTED_MODULE_3__styles_colors__["c" /* BlueColor */], "aria-hidden": "true" }),
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { "aria-hidden": "true" }, ' ' + content.editOrder),
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], null, _this.formatEditOrderAriaLabel(content, order)))))))));
        };
        _this.renderGuests = function (bookingNumber, associatedBookingNumbers, orderDetail) {
            if (orderDetail.isDining) {
                var guestCounts = (_this.props.content.guestsCount || '').replace('{GuestsCount}', orderDetail.quantity.toString());
                bookingNumber = associatedBookingNumbers.length > 0 ? '' : " #" + bookingNumber;
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { "data-pii": "true", className: "h-order__history-card-details__guests" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("strong", null, _this.props.content.guests),
                    bookingNumber,
                    " ",
                    guestCounts));
            }
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { "data-pii": "true", className: "h-order__history-card-details__guests" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("strong", null, _this.props.content.guests),
                " #",
                bookingNumber,
                " - ",
                Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["d" /* guestGuestList */])(orderDetail.guests)));
        };
        _this.formatCabanaDescription = function (orderDetail, content) {
            var format = content.cabanaDurationFormat;
            if (!format) {
                return orderDetail.serviceDate + " - " + orderDetail.arrivalDateFormatted;
            }
            return "" + format.replace('{from}', orderDetail.serviceDate).replace('{thru}', orderDetail.arrivalDateFormatted);
        };
        _this.renderDayOrDuration = function (orderDetail) {
            var content = _this.props.content;
            if (orderDetail.isCabana) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { className: "h-order__history-card-details__date" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("strong", null, _this.props.content.cabanaDuration),
                    " ",
                    _this.formatCabanaDescription(orderDetail, content)));
            }
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { className: "h-order__history-card-details__date" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("strong", null, content.day),
                " ",
                orderDetail.serviceDate || content.dayAssingnedOnboard));
        };
        _this.renderServiceTime = function (orderDetail) {
            if (orderDetail.isCabana) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { className: "h-order__history-card-details__date" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("strong", null, _this.props.content.cabanaDescription),
                    " ",
                    orderDetail.cabanaNumber));
            }
            if (orderDetail.isDining) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { className: "h-order__history-card-details__date" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("strong", null, _this.props.content.time),
                    " ",
                    orderDetail.serviceBeginTime));
            }
            if (orderDetail.serviceBeginTime && orderDetail.serviceEndTime) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { className: "h-order__history-card-details__date" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("strong", null, _this.props.content.time),
                    " ",
                    orderDetail.serviceBeginTime,
                    " - ",
                    orderDetail.serviceEndTime));
            }
            return null;
        };
        _this.renderOrderHeader = function (dateOrder) {
            var content = _this.props.content;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-orders__history" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-orders__history-header" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row align-items-center" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-lg-12" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-lg-4" },
                                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "h-orders__history-header--details" },
                                        content.orderDate,
                                        " ",
                                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("strong", null, dateOrder.orderDate)))))))));
        };
        _this.showQuantity = function (orderType) {
            return orderType === 'FS';
        };
        _this.onEditOrder = function (e) {
            e.preventDefault();
            var orderNumber = e.currentTarget.dataset.order;
            _this.props.onEditOrder(orderNumber);
        };
        return _this;
    }
    Orders.prototype.render = function () {
        var _a = this.props, datesOrdersData = _a.datesOrdersData, content = _a.content, bookingSelectorProps = _a.bookingSelectorProps;
        if (!datesOrdersData || !datesOrdersData.datesOrders ||
            (!datesOrdersData.datesOrders.length && bookingSelectorProps.activeSailing.bookings.length === 1)) {
            return null;
        }
        var datesOrders = datesOrdersData.datesOrders;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-orders') },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__orders_heading__["a" /* OrdersHeading */], null, this.props.content.heading),
            bookingSelectorProps && this.renderBookingSelector(bookingSelectorProps),
            datesOrders && datesOrders.length
                ? datesOrders.map(this.renderDateOrders)
                : __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { dangerouslySetInnerHTML: { __html: content.noOrders } })));
    };
    Orders.prototype.formatEditOrderAriaLabel = function (content, order) {
        if (!content.editOrderAriaLabel) {
            return content.editOrder;
        }
        return content.editOrderAriaLabel
            .replace('{ProductNames}', order.orderDetails.map(function (n) { return n.productName; }).join(', '))
            .replace('{OrderNumber}', order.orderNumber);
    };
    return Orders;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=orders.js.map

/***/ }),
/* 722 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 723 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 724 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CancelOrderModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cancel_order_modal_css__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cancel_order_modal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cancel_order_modal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal_modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_colors__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__icons__ = __webpack_require__(9);








var CancelOrderModal = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(CancelOrderModal, _super);
    function CancelOrderModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            submitting: false,
            cancelled: false,
        };
        _this.onCancelBooking = function (event) {
            event.preventDefault();
            _this.setState({ submitting: true });
            _this.props.doCancel()
                .then(_this.onSuccess)
                .catch(_this.onError);
        };
        _this.onSuccess = function () {
            _this.setState({ submitting: false, cancelled: true });
        };
        _this.onError = function (apiError) {
            _this.setState({ submitting: false }, function () {
                _this.props.onCloseWithError(apiError);
            });
        };
        _this.onAbort = function (event) {
            event.preventDefault();
            _this.props.onAbort();
        };
        _this.onClose = function (event) {
            event.preventDefault();
            if (_this.state.cancelled) {
                _this.props.onCloseWithSuccess();
            }
            else {
                _this.props.onAbort();
            }
        };
        return _this;
    }
    CancelOrderModal.prototype.render = function () {
        var isOpen = this.props.isOpen;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__modal_modal__["a" /* Modal */], { shell: false, isOpen: isOpen, dialogDescription: this.props.content.dialogDescription }, this.renderContent()));
    };
    CancelOrderModal.prototype.renderContent = function () {
        var content = this.props.content;
        var _a = this.state, submitting = _a.submitting, cancelled = _a.cancelled;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-cancel-order-modal') },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-cancel-order-modal__wrapper" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__button_button__["a" /* Button */], { className: "h-cancel-order-modal__close", color: "outline-white", onClick: this.onClose, "aria-label": content.closeModalAriaLabel, disabled: submitting },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__icons__["CloseIcon"], { color: __WEBPACK_IMPORTED_MODULE_6__styles_colors__["c" /* BlueColor */] })),
                cancelled ? this.renderConfirmation() : this.renderDialog())));
    };
    CancelOrderModal.prototype.renderDialog = function () {
        var content = this.props.content;
        var submitting = this.state.submitting;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h5", { className: "h-cancel-order-modal__title" }, content.areYouSure),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-cancel-order-modal__actions" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__button_button__["a" /* Button */], { className: "h-cancel-order-modal__button", color: "red", onClick: this.onCancelBooking, disabled: submitting, busy: submitting }, content.confirmButton),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__button_button__["a" /* Button */], { className: "h-cancel-order-modal__button", color: "outline-black", onClick: this.onAbort, disabled: submitting }, content.abortButton))));
    };
    CancelOrderModal.prototype.renderConfirmation = function () {
        var content = this.props.content;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h5", { "aria-live": "assertive", role: "alert", className: "h-cancel-order-modal__title" }, content.confirmationHeading),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", null, content.confirmationMessage),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-cancel-order-modal__actions" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__button_button__["b" /* LinkButton */], { className: "h-cancel-order-modal__button--centered", color: "red", href: "", onClick: this.onClose }, content.closeButton))));
    };
    return CancelOrderModal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=cancel-order-modal.js.map

/***/ }),
/* 726 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OrderItemsContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__order_item_mobile__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__order_item_desktop__ = __webpack_require__(729);






var OrderItems = function (_a) {
    var mode = _a.mode, items = _a.items, controlGroup = _a.controlGroup, isPerItemEditionAllowed = _a.isPerItemEditionAllowed, onDataChange = _a.onDataChange, quantityText = _a.quantityText, promoCode = _a.promoCode;
    if (!items) {
        return null;
    }
    if (isPerItemEditionAllowed) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null, items.map(function (item, index) {
            return item.guests.map(function (guest) {
                var key = Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["b" /* getJointKeys */])(mode, index, item.productId, guest.seqNumber);
                var control = controlGroup.controls.get[key];
                return (mode === 'mobile')
                    ?
                        // tslint:disable-next-line: max-line-length
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__order_item_mobile__["a" /* EditOrderItemMobile */], { key: key, item: item, guest: guest, control: control, onDataChange: onDataChange, quantityText: quantityText, promoCode: promoCode })
                    :
                        // tslint:disable-next-line: max-line-length
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__order_item_desktop__["a" /* EditOrderItemDesktop */], { key: key, item: item, guest: guest, control: control, onDataChange: onDataChange, quantityText: quantityText, promoCode: promoCode });
            });
        })));
    }
    else {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null, items.map(function (item, index) {
            var key = Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["b" /* getJointKeys */])(mode, index, item.productId);
            return (mode === 'mobile')
                ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__order_item_mobile__["b" /* ReviewOrderItemMobile */], { key: key, item: item, quantityText: quantityText, promoCode: promoCode })
                : __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__order_item_desktop__["b" /* ReviewOrderItemDesktop */], { key: key, item: item, quantityText: quantityText, promoCode: promoCode });
        })));
    }
};
var OrderItemsContainer = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(OrderItemsContainer, _super);
    function OrderItemsContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.onControlChange = function (control) {
            _this.setState(function (prevState) {
                var newControlGroup = Object(__WEBPACK_IMPORTED_MODULE_2__forms__["m" /* replaceControlModel */])(prevState.controlGroup, control);
                return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, prevState), { controlGroup: newControlGroup });
            }, _this.notifySelection);
        };
        _this.state = {
            controlGroup: props.isPerItemEditionAllowed ? _this.createControlGroup() : null,
        };
        return _this;
    }
    OrderItemsContainer.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a = this.props, items = _a.items, mode = _a.mode, isPerItemEditionAllowed = _a.isPerItemEditionAllowed, onSelection = _a.onSelection;
        if (items !== prevProps.items ||
            mode !== prevProps.mode ||
            isPerItemEditionAllowed !== prevProps.isPerItemEditionAllowed) {
            this.setState({
                controlGroup: isPerItemEditionAllowed ? this.createControlGroup() : null
            });
            onSelection([]);
        }
    };
    OrderItemsContainer.prototype.render = function () {
        var controlGroup = this.state.controlGroup;
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](OrderItems, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.props, { controlGroup: controlGroup, onDataChange: this.onControlChange, quantityText: this.props.quantityText }));
    };
    OrderItemsContainer.prototype.createControlGroup = function () {
        var _a = this.props, mode = _a.mode, items = _a.items;
        var controls = [];
        if (items) {
            items.forEach(function (item, index) {
                item.guests.forEach(function (guest) {
                    controls.push(Object(__WEBPACK_IMPORTED_MODULE_2__forms__["i" /* createControlModel */])({
                        name: Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["b" /* getJointKeys */])(mode, index, item.productId, guest.seqNumber),
                        checked: false,
                        props: {
                            productId: item.productId,
                            guestSeqNumber: guest.seqNumber,
                        },
                    }));
                });
            });
        }
        return __WEBPACK_IMPORTED_MODULE_2__forms__["h" /* createControlGroup */].apply(void 0, controls);
    };
    OrderItemsContainer.prototype.notifySelection = function () {
        var controlGroup = this.state.controlGroup;
        if (!controlGroup) {
            return;
        }
        var checked = [];
        for (var i = 0; i < controlGroup.controls.all.length; i++) {
            var control = controlGroup.controls.all[i];
            if (control.checked) {
                checked.push(control.props);
            }
        }
        this.props.onSelection(checked);
    };
    return OrderItemsContainer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=order-items.js.map

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ReviewOrderItemMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditOrderItemMobile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(66);




var ReviewOrderItemMobile = function (_a) {
    var item = _a.item, quantityText = _a.quantityText, promoCode = _a.promoCode;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tr", { role: "row" },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("strong", null, item.productName),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null, item.serviceDate),
            item.serviceBeginTime && item.serviceEndTime && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null,
                item.serviceBeginTime,
                " - ",
                item.serviceEndTime)),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null, Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["d" /* guestGuestList */])(item.guests)),
            quantityText && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null,
                quantityText,
                ": ",
                item.quantity),
            promoCode && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null, promoCode)),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell", className: "h-edit-order__list-table__small-item" }, item.priceFormatted)));
};
var EditOrderItemMobile = function (_a) {
    var item = _a.item, guest = _a.guest, control = _a.control, onDataChange = _a.onDataChange, quantityText = _a.quantityText;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tr", { role: "row" },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell" }, control && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms__["c" /* FormField */], { controlModel: control, onFieldUpdate: onDataChange }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms__["a" /* Checkbox */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.controlProps)),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.labelProps),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("strong", null, item.productName),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null, item.serviceDate),
                item.serviceBeginTime && item.serviceEndTime && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null,
                    item.serviceBeginTime,
                    " - ",
                    item.serviceEndTime)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { "data-pii": "true" }, guest.fullName),
                quantityText && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null,
                    quantityText,
                    ": ",
                    item.quantity)))); })),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell", className: "h-edit-order__list-table__small-item" }, guest.priceFormatted)));
};
//# sourceMappingURL=order-item-mobile.js.map

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ReviewOrderItemDesktop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditOrderItemDesktop; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(66);




var ReviewOrderItemDesktop = function (_a) {
    var item = _a.item, quantityText = _a.quantityText, promoCode = _a.promoCode;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tr", { role: "row" },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell" }, item.productName),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null, item.serviceDate),
            item.serviceBeginTime && item.serviceEndTime && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                item.serviceBeginTime,
                " - ",
                item.serviceEndTime))),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell", "data-pii": "true" }, Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["d" /* guestGuestList */])(item.guests)),
        quantityText && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell" }, item.quantity),
        promoCode && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell" }, promoCode),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell" }, item.priceFormatted)));
};
var EditOrderItemDesktop = function (_a) {
    var item = _a.item, guest = _a.guest, control = _a.control, onDataChange = _a.onDataChange, quantityText = _a.quantityText;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tr", { role: "row" },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell" }, control && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms__["c" /* FormField */], { controlModel: control, onFieldUpdate: onDataChange }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms__["a" /* Checkbox */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.controlProps)),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.labelProps), item.productName))); })),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null, item.serviceDate),
            item.serviceBeginTime && item.serviceEndTime && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                item.serviceBeginTime,
                " - ",
                item.serviceEndTime))),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell", "data-pii": "true" }, guest.fullName),
        quantityText && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell" }, item.quantity),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell" }, guest.priceFormatted)));
};
//# sourceMappingURL=order-item-desktop.js.map

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EditOrderModalTrigger */
/* unused harmony export EditOrderV2ModalTrigger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__edit_order__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__edit_order_v2__ = __webpack_require__(731);





var EditOrderModalTrigger = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(EditOrderModalTrigger, _super);
    function EditOrderModalTrigger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditOrderModalTrigger.prototype.render = function () {
        var _a = this.props, isOpen = _a.isOpen, restProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["isOpen"]);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__modal_modal__["a" /* Modal */], { shell: false, isOpen: isOpen, fullScreen: true, onRequestClose: this.props.onRequestClose, dialogDescription: this.props.content.heading },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__edit_order__["a" /* EditOrder */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ mode: "modal" }, restProps))));
    };
    return EditOrderModalTrigger;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

var EditOrderV2ModalTrigger = function (props) {
    var isOpen = props.isOpen, restProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(props, ["isOpen"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__modal_modal__["a" /* Modal */], { shell: false, isOpen: isOpen, fullScreen: true, onRequestClose: props.onRequestClose, dialogDescription: props.content.heading },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__edit_order_v2__["a" /* EditOrderV2 */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ mode: "modal" }, restProps))));
};
//# sourceMappingURL=edit-order-modal-trigger.js.map

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditOrderV2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_modal_shell__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icons_printer_icon__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__visually_hidden_visually_hidden__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__notification_notifications_group__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chevron_chevron__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_colors__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_breakpoints__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__media_query_media_query__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__edit_order_v2_css__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__edit_order_v2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__edit_order_v2_css__);














var EditOrderV2 = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(EditOrderV2, _super);
    function EditOrderV2(props) {
        var _this = _super.call(this, props) || this;
        _this.closeButtonRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.print = function (event) {
            event.preventDefault();
            window.print();
        };
        _this.state = {
            notifications: null
        };
        return _this;
    }
    EditOrderV2.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__media_query_media_query__["a" /* MediaQuery */], { query: "(min-width: " + (__WEBPACK_IMPORTED_MODULE_11__styles_breakpoints__["b" /* Medium */] + 1) + "px)" }, function (isDesktop) { return (_this.props.mode === 'embedded'
            ? _this.renderEmbedded(isDesktop)
            : _this.renderModal(isDesktop)); }));
    };
    EditOrderV2.prototype.renderEmbedded = function (isDesktop) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
            this.renderHeader(),
            this.renderBody(isDesktop),
            this.renderFooter()));
    };
    EditOrderV2.prototype.renderModal = function (isDesktop) {
        var _a = this.props, content = _a.content, order = _a.order, onRequestClose = _a.onRequestClose;
        var closeModal = (content.closeModal || '').replace('{OrderNumber}', order.orderNumber);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__modal_modal_shell__["b" /* ModalShell */], { header: this.renderHeader(), footer: this.renderFooter(), notification: this.renderNotification(), onRequestClose: onRequestClose, closeModalText: closeModal, closeButtonRef: this.closeButtonRef }, this.renderBody(isDesktop)));
    };
    EditOrderV2.prototype.renderHeader = function () {
        var order = this.props.order;
        var heading = Object(__WEBPACK_IMPORTED_MODULE_7__helpers__["e" /* isOrderEditable */])(order)
            ? (this.props.order.editAction === 'remove' ? this.props.content.heading : this.props.content.optOutHeading)
            : this.props.content.printHeading;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h2", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__(__WEBPACK_IMPORTED_MODULE_3__modal_modal_shell__["a" /* ModalHeadingClassName */], 'd-print-none') }, heading),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h1", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__(__WEBPACK_IMPORTED_MODULE_3__modal_modal_shell__["a" /* ModalHeadingClassName */], 'd-none d-print-block') }, this.props.content.printHeading)));
    };
    EditOrderV2.prototype.renderNotification = function () {
        var content = this.props.content;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__notification_notifications_group__["a" /* NotificationsGroup */], { notifications: this.props.notifications, closeAriaLabel: content.closeNotificationAriaLabel, autoCloseAriaLabel: content.autoCloseNotificationAriaLabel, onCloseGroup: this.props.closeNotificationGroup }));
    };
    EditOrderV2.prototype.renderBody = function (isDesktop) {
        var _a = this.props, content = _a.content, order = _a.order;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-eo') },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-eo__header" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-eo__order-by" },
                    content.orderedBy,
                    " ",
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("strong", { className: "h-eo__order-date-value" }, order.orderedBy)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-eo__order-date" },
                    content.orderDate,
                    " ",
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("strong", { className: "h-eo__order-date-value" }, order.orderDate)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row align-items-center" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-9 h-eo__details" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h3", { className: "h-eo__order-number d-print-none" }, "" + content.bookingNumber + order.primaryBookingNumber),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h2", { className: "h-eo__order-number d-none d-print-block" }, "" + content.bookingNumber + order.primaryBookingNumber)),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-3 d-print-none h-eo__print" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { className: "h-eo__print-link", href: "", onClick: this.print },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__icons_printer_icon__["a" /* PrinterIcon */], { height: 18, width: 18, "aria-hidden": "true", className: "h-eo__print-icon" }),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "h-eo__print-link-text", "aria-hidden": "true" }, content.print),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], null, content.print))))),
            !this.isEmptyOrder() && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null, this.renderDetailsDesktop(isDesktop)))));
    };
    EditOrderV2.prototype.renderDetailsDesktop = function (isDesktop) {
        var _this = this;
        var _a = this.props, content = _a.content, order = _a.order;
        var cn = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-eo__table', isDesktop ? 'h-eo__table--desktop' : 'h-eo__table--mobile');
        var cols = {
            quantity: isDesktop && Object(__WEBPACK_IMPORTED_MODULE_7__helpers__["i" /* showQuantity */])(order.orderType),
            guests: isDesktop && Object(__WEBPACK_IMPORTED_MODULE_7__helpers__["h" /* showGuests */])(order.orderType),
            day: isDesktop,
            action: isDesktop && order.editAction === 'remove'
        };
        var footerColSpan = cols.action ? 0 : 1;
        if (cols.quantity) {
            footerColSpan++;
        }
        if (cols.guests) {
            footerColSpan++;
        }
        if (cols.day) {
            footerColSpan++;
        }
        if (cols.action) {
            footerColSpan++;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("table", { role: "table", className: cn, cellPadding: "0", cellSpacing: "0" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("thead", { role: "rowgroup" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tr", { role: "row" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("th", { role: "columnheader", className: "h-eo__item-col" }, content.item),
                    cols.day && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("th", { role: "columnheader", className: "h-eo__day-col" }, content.dayTime),
                    cols.guests && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("th", { role: "columnheader", className: "h-eo__guest-col" }, content.guest),
                    cols.quantity && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("th", { role: "columnheader", className: "h-eo__quantity-col" }, content.quantity),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("th", { role: "columnheader", className: "h-eo__price-col" }, content.price),
                    cols.action && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("th", { role: "columnheader", className: "h-eo__action-col" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], null, content.action)))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tbody", { role: "rowgroup" }, order.lineItems.map(function (d, i) { return _this.renderOrderItem(d, i, cols, order); })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tfoot", { role: "rowgroup" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tr", { role: "row" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell", colSpan: footerColSpan }, content.adjustment),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell", className: "h-eo__price-col" }, order.adjustmentFormatted),
                    cols.action && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell" })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tr", { role: "row", className: "h-eo__table--bold" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell", colSpan: footerColSpan }, content.total),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell", className: "h-eo__price-col" }, order.totalFormatted),
                    cols.action && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell" })))));
    };
    EditOrderV2.prototype.renderOrderItem = function (item, index, cols, order) {
        var key = "o_" + index + "_" + item.productId;
        var content = this.props.content;
        var rowCn = __WEBPACK_IMPORTED_MODULE_2_classnames__({ 'h-eo__row--removed': item.isRemoved });
        var detailsColSpan = 2;
        if (cols.guests) {
            detailsColSpan++;
        }
        if (cols.quantity) {
            detailsColSpan++;
        }
        if (cols.day) {
            detailsColSpan++;
        }
        if (cols.action) {
            detailsColSpan++;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], { key: key },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tr", { role: "row", className: rowCn },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell", className: "h-eo__item-col" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-eo__item-name", id: key }, item.productName),
                    this.renderDayTime(item),
                    this.renderLineActions(item, content, key, order)),
                cols.day && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell", className: "h-eo__day-col" }, this.renderDayTime(item)),
                cols.guests && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell", className: "h-eo__guest-col" }, Object(__WEBPACK_IMPORTED_MODULE_7__helpers__["f" /* joinOrderSummaryGuests */])(item)),
                cols.quantity && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell", className: "h-eo__quantity-col" }, item.quantity),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell", className: "h-eo__price-col" }, item.lineTotalFormatted),
                cols.action && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: "cell", className: "h-eo__action-col" }, this.renderLineActions(item, content, key, order))),
            Object(__WEBPACK_IMPORTED_MODULE_7__helpers__["g" /* showGuestDetails */])(order.orderType) && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tr", null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { colSpan: detailsColSpan, className: rowCn }, this.renderGuests(item, key)))));
    };
    EditOrderV2.prototype.renderLineActions = function (item, content, productNameId, order) {
        var _this = this;
        if (order.editAction !== 'remove') {
            return null;
        }
        var removedCn = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-eo__removed h-eo__line__removed d-print-none', { 'd-none': !item.isRemoved });
        var btnCn = 'h-eo__remove d-print-none', text, action;
        if (item.isRemoved) {
            text = content.undoChange;
            action = function (e) { return _this.addLine(e, item); };
        }
        else {
            text = this.props.order.editAction === 'remove' ? content.remove : content.optout;
            action = function (e) { return _this.removeLine(e, item); };
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-eo__actions" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: removedCn, "aria-live": "assertive" }, content.removed),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "", role: "button", className: btnCn, onClick: action, "aria-describedby": productNameId }, text)));
    };
    EditOrderV2.prototype.renderDayTime = function (item) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-eo__day-time" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null, item.serviceDate),
            item.serviceBeginTime && item.serviceEndTime ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                item.serviceBeginTime,
                " - ",
                item.serviceEndTime)) : item.serviceBeginTime ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null, item.serviceBeginTime)) : null));
    };
    EditOrderV2.prototype.renderGuests = function (line, id) {
        var _this = this;
        var content = this.props.content;
        var detailsId = "edit-order-details-" + id;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-eo__bookings" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "h-eo__guests-count" },
                    content.detailGuests,
                    " ",
                    line.guestCount),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "", role: "button", className: "h-eo__details__trigger", onClick: function (e) { return _this.toggleRecipientDetails(e, line); }, "aria-expanded": line.detailsExpanded ? 'true' : 'false', "aria-controls": detailsId },
                    this.props.order.allowPartialEdits ? content.viewEditGuests : content.viewGuests,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__chevron_chevron__["a" /* Chevron */], { "aria-hidden": "true", className: "h-eo__details__toggle", size: 16, direction: line.detailsExpanded ? 'up' : 'down', color: __WEBPACK_IMPORTED_MODULE_9__styles_colors__["c" /* BlueColor */] }))),
            line.detailsExpanded && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { id: detailsId },
                line.bookings.map(function (b, i) { return _this.renderBooking(b, i, line); }),
                line.otherAttendees > 0 && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-eo__other-attendies" }, content.otherAttendies.replace('{Count}', line.otherAttendees.toString()))))));
    };
    EditOrderV2.prototype.renderBooking = function (booking, index, line) {
        var _this = this;
        var content = this.props.content;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: index, className: "h-eo__guests" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "h-eo__guests__stateroom" }, content.detailStateroom.replace('{Number}', (index + 1).toString()) + " "),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "h-eo__guests__booking" }, "" + content.detailBooking + booking.bookingNumber)),
            booking.guests.map(function (g, i) { return _this.renderGuest(g, i, booking, line, content); })));
    };
    // tslint:disable-next-line:max-line-length
    EditOrderV2.prototype.renderGuest = function (guest, index, booking, line, content) {
        var _this = this;
        var guestCn = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-eo__guest__name', { 'h-eo__guest__name--removed': guest.isRemoved });
        var removedCn = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-eo__removed h-eo__guest__removed d-print-none', { 'd-none': !guest.isRemoved });
        var guestId = line.productId + "_" + booking.bookingNumber + "_" + guest.seqNumber;
        var btnCn = 'h-eo__remove h-eo__guest__remove d-print-none';
        var allowPartialEdits = this.props.order.allowPartialEdits;
        var btnAction, btnText;
        if (guest.isRemoved) {
            btnText = content.undoChange;
            btnAction = function (e) { return _this.addGuest(e, guest, booking, line); };
        }
        else {
            btnText = this.props.order.editAction === 'remove' ? content.remove : content.optout;
            btnAction = function (e) { return _this.removeGuest(e, guest, booking, line); };
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: index, className: "h-eo__guest" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: guestCn, id: guestId }, guest.firstName + " " + guest.lastName),
            allowPartialEdits && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: removedCn, "aria-live": "assertive" }, content.removed),
            allowPartialEdits && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "", className: btnCn, role: "button", onClick: btnAction, "aria-describedby": guestId }, btnText)));
    };
    EditOrderV2.prototype.toggleRecipientDetails = function (e, line) {
        e.preventDefault();
        this.props.toggleRecipientDetails(line);
    };
    // tslint:disable-next-line:max-line-length
    EditOrderV2.prototype.removeGuest = function (e, guest, booking, lineItem) {
        e.preventDefault();
        this.props.removeGuest(guest, booking, lineItem);
    };
    EditOrderV2.prototype.addGuest = function (e, guest, booking, lineItem) {
        e.preventDefault();
        this.props.addGuest(guest, booking, lineItem);
    };
    EditOrderV2.prototype.removeLine = function (e, line) {
        e.preventDefault();
        this.props.removeLine(line);
    };
    EditOrderV2.prototype.addLine = function (e, line) {
        e.preventDefault();
        this.props.addLine(line);
    };
    EditOrderV2.prototype.renderFooter = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null, this.renderFooterDesktop()));
    };
    EditOrderV2.prototype.renderFooterDesktop = function () {
        var _a = this.props, order = _a.order, content = _a.content, submitting = _a.submitting, modifyOrder = _a.modifyOrder;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-eo__footer" }, Object(__WEBPACK_IMPORTED_MODULE_7__helpers__["e" /* isOrderEditable */])(order) ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__button_button__["a" /* Button */], { className: "d-print-none h-edit-order__btn-submit", color: "red", type: "button", busy: submitting, disabled: this.isConfirmButtonDisabled(), onClick: modifyOrder }, content.confirmChanges)) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__button_button__["a" /* Button */], { className: "d-print-none h-edit-order__btn-submit h-btn--min-width", color: "red", type: "button", onClick: this.props.onRequestClose }, content.closeButton))));
    };
    EditOrderV2.prototype.isConfirmButtonDisabled = function () {
        var _a = this.props, submitting = _a.submitting, order = _a.order;
        var isModified = Object(__WEBPACK_IMPORTED_MODULE_7__helpers__["c" /* getRemovedGuests */])(order).length > 0;
        return submitting || !isModified;
    };
    EditOrderV2.prototype.isEmptyOrder = function () {
        var order = this.props.order;
        return (!order.lineItems || order.lineItems.length === 0);
    };
    return EditOrderV2;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=edit-order-v2.js.map

/***/ }),
/* 732 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 733 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DiningFormContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dining_form__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__forms_index__ = __webpack_require__(10);




var availableName = 'available';
var waitlistName = 'waitlist';
var DiningFormContainer = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(DiningFormContainer, _super);
    function DiningFormContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            availableDining: Object(__WEBPACK_IMPORTED_MODULE_3__forms_index__["i" /* createControlModel */])({
                name: availableName,
                value: DiningFormContainer.findSelectedCode(_this.props.diningOptions.availableOptions),
                checked: true
            }),
            waitlistDining: Object(__WEBPACK_IMPORTED_MODULE_3__forms_index__["i" /* createControlModel */])({
                name: waitlistName,
                value: DiningFormContainer.findSelectedCode(_this.props.diningOptions.waitlistOptions),
                checked: true
            })
        };
        _this.onFieldUpdate = function (control) {
            if (control.name === availableName) {
                _this.setState(function (prevState) { return ({ availableDining: control }); }, function () { return (_this.props.onChange({
                    availableCode: _this.state.availableDining.value,
                    waitlistCode: _this.state.waitlistDining.value
                })); });
            }
            else if (control.name === waitlistName) {
                _this.setState(function (prevState) { return ({ waitlistDining: control }); }, function () { return (_this.props.onChange({
                    availableCode: _this.state.availableDining.value,
                    waitlistCode: _this.state.waitlistDining.value
                })); });
            }
        };
        return _this;
    }
    DiningFormContainer.findSelectedCode = function (options) {
        var selected = options.filter(function (n) { return n.selected; })[0];
        return selected ? selected.code : '';
    };
    DiningFormContainer.prototype.render = function () {
        var _a = this.props, content = _a.content, booking = _a.booking, diningOptions = _a.diningOptions;
        var _b = this.state, availableDining = _b.availableDining, waitlistDining = _b.waitlistDining;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__dining_form__["a" /* DiningForm */], { content: content, guestNames: booking.guestNames, availableOptions: diningOptions.availableOptions, waitlistOptions: diningOptions.waitlistOptions, availableDining: availableDining, waitlistDining: waitlistDining, onFieldUpdate: this.onFieldUpdate, canEdit: diningOptions.canEdit, unassignedOptionsOnly: diningOptions.unassignedOptionsOnly }));
    };
    return DiningFormContainer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=dining-form-container.js.map

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DiningForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icons__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eyebrow_eyebrow__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dining_form_css__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dining_form_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__dining_form_css__);






var DiningForm = function (_a) {
    var content = _a.content, guestNames = _a.guestNames, availableDining = _a.availableDining, waitlistDining = _a.waitlistDining, availableOptions = _a.availableOptions, waitlistOptions = _a.waitlistOptions, onFieldUpdate = _a.onFieldUpdate, canEdit = _a.canEdit, unassignedOptionsOnly = _a.unassignedOptionsOnly;
    var noOptions = availableOptions.length + waitlistOptions.length === 0;
    var noOptionsToSelect = !canEdit && (unassignedOptionsOnly || noOptions);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-dining-details__form" },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-12 col-lg-5" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-dining-details__form__options-col" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-dining-details__form__guests" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-dining-details__form__heading", tabIndex: 0 }, content.diningFor),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { "data-pii": "true", className: "h-dining-details__form__guest-container" }, guestNames)),
                    noOptionsToSelect
                        ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { className: "h-dining-details__form_no-options" }, content.noDiningOptions)
                        : renderForm(content, availableDining, waitlistDining, availableOptions, waitlistOptions, onFieldUpdate, canEdit))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-12 col-lg-7" }, !noOptionsToSelect &&
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-dining-details__form__disclaimer", dangerouslySetInnerHTML: { __html: content.explanation } })))));
};
function renderForm(content, availableDining, waitlistDining, availableOptions, waitlistOptions, onFieldUpdate, canEdit) {
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
        availableOptions.length > 0 && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["c" /* FormField */], { controlModel: availableDining, onFieldUpdate: onFieldUpdate }, function (props) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("fieldset", { className: "h-form__fieldset-reset" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("legend", { className: "h-form__fieldset-reset" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__eyebrow_eyebrow__["a" /* Eyebrow */], { className: "h-dining-details__form-eyebrow" }, content.availableOptionsHeading)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("table", { className: "h-dining-details__form__schedule-table", cellSpacing: "0", cellPadding: "0", role: "presentation" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tbody", null, availableOptions.map(function (o, i) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tr", { key: i, className: "h-dining-details__form__opt-" + o.code },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { className: "h-dining-details__form__schedule-table__cell" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["f" /* Radio */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, Object(__WEBPACK_IMPORTED_MODULE_4__forms__["k" /* radioControlProps */])(props.controlProps, o.code, o.code), { disabled: !canEdit, "aria-describedby": o.selected ? 'dining-confirmed-indicator' : undefined })),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, Object(__WEBPACK_IMPORTED_MODULE_4__forms__["l" /* radioLabelProps */])(props.labelProps, o.code)), o.time + " " + o.description)),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { className: "h-dining-details__form__schedule-table__cell" }, o.selected && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__icons__["CheckmarkIcon"], { color: "#008285", width: "14", height: "11" }),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "h-dining-details__form__tag", id: "dining-confirmed-indicator" }, content.confirmedIndicator)))))); }))));
        }),
        availableOptions.length > 0 && waitlistOptions.length > 0 && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-dining-details__form__divider" }),
        waitlistOptions.length > 0 && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["c" /* FormField */], { controlModel: waitlistDining, onFieldUpdate: onFieldUpdate }, function (props) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("fieldset", { className: "h-form__fieldset-reset" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("legend", { className: "h-form__fieldset-reset" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__eyebrow_eyebrow__["a" /* Eyebrow */], { className: "h-dining-details__form-eyebrow" }, content.waitlistOptionsHeading)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("table", { className: "h-dining-details__form__schedule-table", role: "presentation", cellSpacing: "0", cellPadding: "0" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tbody", null, waitlistOptions.map(function (o, i) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tr", { key: i },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { className: "h-dining-details__form__schedule-table__cell" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["f" /* Radio */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, Object(__WEBPACK_IMPORTED_MODULE_4__forms__["k" /* radioControlProps */])(props.controlProps, o.code, o.code), { disabled: !canEdit, "aria-describedby": o.selected ? 'dining-waiting-indicator' : undefined })),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, Object(__WEBPACK_IMPORTED_MODULE_4__forms__["l" /* radioLabelProps */])(props.labelProps, o.code)), o.time + " " + o.description)),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { className: "h-dining-details__form__schedule-table__cell" }, o.selected && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__icons__["ClockIcon"], { width: "14", height: "14", style: { verticalAlign: 'middle' } }),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "h-dining-details__form__tag", id: "dining-waiting-indicator" }, content.waitlistIndicator)))))); }))));
        })));
}
//# sourceMappingURL=dining-form.js.map

/***/ }),
/* 736 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DiningDetailsModalTrigger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dining_details__ = __webpack_require__(241);




var DiningDetailsModalTrigger = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(DiningDetailsModalTrigger, _super);
    function DiningDetailsModalTrigger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DiningDetailsModalTrigger.prototype.render = function () {
        var _a = this.props, isOpen = _a.isOpen, restProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["isOpen"]);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__modal_modal__["a" /* Modal */], { shell: false, isOpen: isOpen, fullScreen: true, onRequestClose: this.props.onRequestClose, dialogDescription: this.props.content.heading },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__dining_details__["a" /* DiningDetails */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ mode: "modal" }, restProps))));
    };
    return DiningDetailsModalTrigger;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=dining-details-modal-trigger.js.map

/***/ }),
/* 738 */
/***/ (function(module, exports) {

//# sourceMappingURL=models.js.map

/***/ }),
/* 739 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CancellationInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cancellation_info_css__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cancellation_info_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cancellation_info_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cancel_booking_modal_trigger__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_colors__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icons__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__chevron_chevron__ = __webpack_require__(32);








var CancellationInfo = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(CancellationInfo, _super);
    function CancellationInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isInfoOpen: false,
            isModalOpen: false,
            pending: false,
            errors: null,
        };
        _this.renderInfo = function () {
            var _a = _this.props, content = _a.content, cancellationInfoData = _a.cancellationInfoData, cancelBooking = _a.cancelBooking, sailBaseCurrency = _a.sailBaseCurrency;
            var _b = _this.state, pending = _b.pending, errors = _b.errors;
            if (pending) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-cancellation-info__busy-container" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__icons__["SpinnerIcon"], { color: __WEBPACK_IMPORTED_MODULE_5__styles_colors__["c" /* BlueColor */], width: 32, height: 32 })));
            }
            if (errors && errors.length > 0) {
                return errors.map(function (error, index) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { key: index }, error)); });
            }
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                cancellationInfoData && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", null, content.cancellationPenaltyInfo + " ",
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "h-cancellation-info__penalty-amount" }, cancellationInfoData.penaltyAmountFormatted),
                    ".")),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-cancellation-info__actions d-print-none" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { className: "h-cancellation-info__action", target: "_blank", href: sailBaseCurrency === 'AUD' ? content.cancellationFaqsLinkAu : content.cancellationFaqsLink, "aria-label": content.readCancellationFaqsAriaLabel }, content.readCancellationFaqs),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { className: "h-cancellation-info__action", href: "", onClick: _this.openModal, "aria-label": content.cancelThisBookingAriaLabel }, content.cancelThisBooking)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "d-print-none" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__cancel_booking_modal_trigger__["a" /* CancelBookingModalTrigger */], { content: content, isOpen: _this.state.isModalOpen, onAbort: _this.closeModal, cancelBooking: cancelBooking, onCloseWithSuccess: _this.onCloseWithSuccess, onCloseWithError: _this.onCloseWithError }))));
        };
        _this.toggleInfo = function (event) {
            event.preventDefault();
            if (!_this.state.isInfoOpen && !_this.state.pending && !_this.props.cancellationInfoData) {
                _this.fetchData();
            }
            _this.setState(function (state) {
                return { isInfoOpen: !state.isInfoOpen };
            });
        };
        _this.fetchData = function () {
            _this.setState({ pending: true });
            _this.props.fetchCancellationInfo()
                .then(function () { return _this.setState({ pending: false, errors: null }); })
                .catch(_this.onFetchDataError);
        };
        _this.onFetchDataError = function (apiError) {
            if (apiError.details) {
                _this.setState({
                    pending: false,
                    errors: apiError.details.map(function (n) { return n.message; }),
                });
            }
            else if (apiError.message) {
                _this.setState({
                    pending: false,
                    errors: [apiError.message],
                });
            }
            else {
                _this.setState({
                    pending: false,
                    errors: [_this.props.content.errorFetchingData],
                });
            }
        };
        _this.openModal = function (event) {
            event.preventDefault();
            _this.setState({ isModalOpen: true });
        };
        _this.closeModal = function () {
            _this.setState({ isModalOpen: false });
        };
        _this.onCloseWithSuccess = function () {
            _this.closeModal();
            _this.props.onBookingCancelled();
        };
        _this.onCloseWithError = function (apiError) {
            _this.closeModal();
            _this.props.onError(apiError);
        };
        return _this;
    }
    CancellationInfo.prototype.componentDidUpdate = function (prevProps, state) {
        if (state.isInfoOpen && !this.props.cancellationInfoData && prevProps.cancellationInfoData) {
            this.fetchData();
        }
    };
    CancellationInfo.prototype.render = function () {
        var _a = this.props, content = _a.content, className = _a.className;
        var isInfoOpen = this.state.isInfoOpen;
        var arrowDirection = isInfoOpen ? 'up' : 'down';
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-cancellation-info', className), tabIndex: -1 },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "", className: "h-cancellation-info__open-info-link d-print-none", onClick: this.toggleInfo, "aria-expanded": isInfoOpen },
                content.viewCancellationInfo,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__chevron_chevron__["a" /* Chevron */], { className: "h-cancellation-info__open-info-link__arrow", color: __WEBPACK_IMPORTED_MODULE_5__styles_colors__["c" /* BlueColor */], size: 18, direction: arrowDirection })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { tabIndex: -1 }, isInfoOpen && this.renderInfo())));
    };
    return CancellationInfo;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=cancellation-info.js.map

/***/ }),
/* 741 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InvoiceTable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eyebrow_eyebrow__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__avatar_avatar__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__visually_hidden_visually_hidden__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__insurance_row__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__gratuities_row__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__gratuities_total_cell__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__line_explanation_modal__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__line_explanation_trigger__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__invoice_table_css__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__invoice_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__invoice_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__insurance_insurance_modal__ = __webpack_require__(248);















var InvoiceTable = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(InvoiceTable, _super);
    function InvoiceTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._currentExplanationModalTrigger = null;
        _this._currentAddVppModalTrigger = null;
        _this.state = {
            isExplanationOpen: false,
        };
        _this.handleUpdateSubmission = function (guestRequests) {
            var _a = _this.props, onSubmitVppUpdate = _a.onSubmitVppUpdate, bookingNumber = _a.bookingNumber;
            return onSubmitVppUpdate(bookingNumber, guestRequests);
        };
        _this.handleVppCancel = function () {
            if (_this._currentAddVppModalTrigger) {
                _this._currentAddVppModalTrigger.focus();
                _this._currentAddVppModalTrigger = null;
            }
            _this.props.onCloseVppModal();
        };
        _this.onVppAction = function (seqNumber, action, target) {
            _this._currentAddVppModalTrigger = target || null;
            return _this.props.onVppAction(seqNumber, action);
        };
        _this.onExplanationModalOpen = function (line) { return function (target) {
            _this._currentExplanationModalTrigger = target || null;
            _this.setState({
                currentLine: line,
                isExplanationOpen: true
            });
        }; };
        _this.onExplanationModalClose = function () {
            _this.setState({
                currentLine: undefined,
                isExplanationOpen: false
            }, function () {
                if (_this._currentExplanationModalTrigger) {
                    _this._currentExplanationModalTrigger.focus();
                    _this._currentExplanationModalTrigger = null;
                }
            });
        };
        return _this;
    }
    InvoiceTable.prototype.render = function () {
        var _this = this;
        var _a = this.props, bookingNumber = _a.bookingNumber, invoice = _a.invoice, content = _a.content, vppModalContent = _a.vppModalContent, states = _a.states;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-table", role: "table" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row no-gutters", role: "rowgroup" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-md h-invoice-table-col h-invoice-table__description-col", role: "row" }, this.renderDescriptionColumn(invoice, content)),
                invoice.guests.map(function (g, i) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-md h-invoice-table__col", key: i, role: "row" }, _this.renderGuestColumn(invoice, content, i, bookingNumber))); }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-md-1 h-invoice-table__col", role: "row" }, this.renderTotalsColumn(invoice, content, bookingNumber))),
            this.renderExplanationModal(content),
            this.renderVppModal(invoice, vppModalContent, states)));
    };
    InvoiceTable.prototype.renderDescriptionColumn = function (invoice, content) {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-table__cell h-invoice-table__cell--description", role: "columnheader" }),
            invoice.lineItems.map(function (line, lineIndex) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: lineIndex, "data-code": line.code, className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-invoice-table__cell h-invoice-table__cell--description', _this.renderSeparator(line)), role: "columnheader" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__eyebrow_eyebrow__["a" /* Eyebrow */], null,
                        line.description,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__line_explanation_trigger__["a" /* LineExplanationTrigger */], { content: content, line: line, onOpen: _this.onExplanationModalOpen(line) }))));
            }),
            this.showPaymentReceived(invoice.paymentReceived) &&
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-table__cell h-invoice-table__cell--description", role: "columnheader" }, content.paymentReceived)));
    };
    InvoiceTable.prototype.renderGuestColumn = function (invoice, content, index, bookingNumber) {
        var _this = this;
        var guest = invoice.guests[index];
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-table__cell", role: "columnheader" }, this.renderGuestName(index, content, guest.firstName, guest.lastName)),
            guest.lineItems.map(function (line, lineIndex) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: lineIndex, "data-code": line.code, className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-invoice-table__cell', _this.renderSeparator(line)), role: "cell" }, Object(__WEBPACK_IMPORTED_MODULE_7__common__["f" /* isVppLine */])(line) ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__insurance_row__["a" /* InsuranceRow */], { bookingNumber: bookingNumber, content: content, guest: guest, guestIndex: index, invoice: invoice, line: line, onAction: _this.onVppAction, onExplanationOpen: _this.onExplanationModalOpen(line), submitting: _this.props.submitting })) : Object(__WEBPACK_IMPORTED_MODULE_7__common__["e" /* isGratuitiesLine */])(line) ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__gratuities_row__["a" /* GratuitiesRow */], { bookingNumber: bookingNumber, content: content, guestIndex: index, invoice: invoice, line: line, onAction: _this.props.onGratuitiesAction, onExplanationOpen: _this.onExplanationModalOpen(line) })) : _this.renderLineItem(line))); })));
    };
    InvoiceTable.prototype.renderTotalsColumn = function (invoice, content, bookingNumber) {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-table__cell h-invoice-table__cell--totals d-none d-md-flex", role: "columnheader" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("strong", null, content.totalsColumnHeading)),
            invoice.lineItems.map(function (line, lineIndex) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: lineIndex, "data-code": line.code, className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-invoice-table__cell h-invoice-table__cell--totals', _this.renderSeparator(line), _this.renderLineClasses(line)), role: "cell" }, Object(__WEBPACK_IMPORTED_MODULE_7__common__["e" /* isGratuitiesLine */])(line) ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__gratuities_total_cell__["a" /* GratuitiesTotalCell */], { bookingNumber: bookingNumber, content: content, invoice: invoice, line: line, onAction: _this.props.onGratuitiesAction, onExplanationOpen: _this.onExplanationModalOpen(line) })) : _this.renderLineItem(line))); }),
            this.showPaymentReceived(invoice.paymentReceived) &&
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-table__cell h-invoice-table__cell--totals", role: "cell" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-invoice__cell__line-description", "aria-hidden": "true" }, content.paymentReceived),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-invoice__cell__line-amount", "aria-hidden": "true" }, invoice.paymentReceivedFormatted),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], null, content.paymentReceived + " " + invoice.paymentReceivedFormatted))));
    };
    InvoiceTable.prototype.renderGuestName = function (index, content, firstName, lastName) {
        var fullName = Object(__WEBPACK_IMPORTED_MODULE_7__common__["a" /* getGuestName */])(index, content, firstName, lastName);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-table__guest-name", "aria-hidden": "true" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__avatar_avatar__["a" /* Avatar */], { fullName: fullName, className: "d-print-none" }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { "data-pii": "true", className: "h-invoice-table__guest-name-label" }, fullName)),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], null, (content.chargesFor || '').replace('{GuestName}', fullName))));
    };
    InvoiceTable.prototype.buildFormattedAmount = function (amountFormatted, content) {
        return amountFormatted === __WEBPACK_IMPORTED_MODULE_3__models__["a" /* HiddenAmountToken */]
            ? (content.hiddenTravelAgentAmountReplacement || amountFormatted) + " " + (content.hiddenTravelAgentAmountDisclaimerSignal || '')
            : amountFormatted;
    };
    InvoiceTable.prototype.renderLineItem = function (line) {
        var content = this.props.content;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-invoice__cell__line-description" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__eyebrow_eyebrow__["a" /* Eyebrow */], null,
                    line.description,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__line_explanation_trigger__["a" /* LineExplanationTrigger */], { content: content, line: line, onOpen: this.onExplanationModalOpen(line) }))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-invoice__cell__line-amount" }, this.buildFormattedAmount(line.amountFormatted, content))));
    };
    InvoiceTable.prototype.renderSeparator = function (line) {
        if (line.code === 'FEDT') {
            return 'h-invoice-table__separator--bottom';
        }
        if (line.code === 'PSUB' || line.code === 'GRSS') {
            return 'h-invoice-table__separator--top';
        }
        return null;
    };
    InvoiceTable.prototype.renderLineClasses = function (line) {
        if (line.code === 'GRSS') {
            return 'h-invoice-table__cell--grand-total';
        }
        return 'd-none d-md-flex';
    };
    InvoiceTable.prototype.renderExplanationModal = function (content) {
        var _a = this.state, currentLine = _a.currentLine, isExplanationOpen = _a.isExplanationOpen;
        if (!currentLine) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__line_explanation_modal__["a" /* LineExplanationModal */], { content: content, isOpen: isExplanationOpen, line: currentLine, onClose: this.onExplanationModalClose }));
    };
    InvoiceTable.prototype.renderVppModal = function (bookingInvoice, vppModalContent, states) {
        if (!states) {
            return null;
        }
        var _a = this.props, vppSelectedGuests = _a.vppSelectedGuests, isVppModalOpen = _a.isVppModalOpen;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null, isVppModalOpen && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__insurance_insurance_modal__["a" /* InsuranceModal */], { isOpen: isVppModalOpen, content: vppModalContent, states: states, guests: bookingInvoice.guests, selectedGuests: vppSelectedGuests || [], onCancel: this.handleVppCancel, onContinue: this.handleUpdateSubmission }))));
    };
    InvoiceTable.prototype.showPaymentReceived = function (paymentReceived) {
        return paymentReceived !== null && paymentReceived !== undefined;
    };
    return InvoiceTable;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=invoice-table.js.map

/***/ }),
/* 743 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 744 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GratuitiesRow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eyebrow_eyebrow__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__visually_hidden_visually_hidden__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_colors__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icons__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__line_explanation_trigger__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__gratuities_row_css__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__gratuities_row_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__gratuities_row_css__);









var GratuitiesRow = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(GratuitiesRow, _super);
    function GratuitiesRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            busy: false
        };
        _this.onActionButtonClick = function (action) { return function (e) {
            e.preventDefault();
            _this.setState({ busy: true, currentAction: action }, function () {
                var onAction = _this.props.onAction;
                var newState = { busy: false, currentAction: undefined };
                onAction(action)
                    .then(function () { return _this.setState(newState); })
                    .catch(function () { return _this.setState(newState); });
            });
        }; };
        return _this;
    }
    GratuitiesRow.prototype.render = function () {
        var _a = this.props, bookingNumber = _a.bookingNumber, line = _a.line, invoice = _a.invoice, guestIndex = _a.guestIndex, content = _a.content;
        if (this.state.busy) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                this.renderLineDescription(line, content),
                this.renderBusyIndicator(invoice, content, bookingNumber)));
        }
        var guest = invoice.guests[guestIndex];
        var availability = this.calculateAvailability(invoice, guest);
        if (availability === 'Unavailable') {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                this.renderLineDescription(line, content),
                this.renderRawLineAmount(line)));
        }
        else if (availability === 'CanAdd') {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                this.renderLineDescription(line, content),
                this.renderOfferGratuitiesToAllGuest(guestIndex, content, invoice, guest, bookingNumber)));
        }
        else if (availability === 'CanRemove') {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                this.renderLineDescription(line, content),
                this.renderRemove(line, content, bookingNumber)));
        }
        return null;
    };
    GratuitiesRow.prototype.renderLineDescription = function (line, content) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-invoice__cell__line-description" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__eyebrow_eyebrow__["a" /* Eyebrow */], null,
                line.description,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__line_explanation_trigger__["a" /* LineExplanationTrigger */], { content: content, line: line, onOpen: this.props.onExplanationOpen }))));
    };
    GratuitiesRow.prototype.renderBusyIndicator = function (invoice, content, bookingNumber) {
        var currentAction = this.state.currentAction;
        var adaVerbiage = '';
        var guestsNames = invoice.guests.map(function (g, i) { return Object(__WEBPACK_IMPORTED_MODULE_2__common__["a" /* getGuestName */])(i, content, g.firstName, g.lastName); }).join(', ');
        if (currentAction === 'add') {
            adaVerbiage = (content.gratuitiesBusyMessage || '').replace('{Action}', content.gratuitiesAdding).replace('{Guest}', guestsNames);
        }
        else if (currentAction === 'remove') {
            adaVerbiage = (content.gratuitiesBusyMessage || '').replace('{Action}', content.gratuitiesRemoving).replace('{Guest}', guestsNames);
        }
        adaVerbiage = (adaVerbiage || '').replace('{BookNumm}', bookingNumber);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-invoice__cell__line-amount", "aria-hidden": "true" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-table__gratuities-busy-container" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__icons__["SpinnerIcon"], { color: __WEBPACK_IMPORTED_MODULE_5__styles_colors__["c" /* BlueColor */], width: 22, height: 22 }))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], null, adaVerbiage)));
    };
    GratuitiesRow.prototype.renderRawLineAmount = function (line) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-invoice__cell__line-amount" }, line.amountFormatted));
    };
    GratuitiesRow.prototype.renderVisuallyHiddenFromLine = function (line) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], null, line.description + " " + line.amountFormatted));
    };
    GratuitiesRow.prototype.renderOfferGratuitiesToAllGuest = function (index, content, invoice, guest, bookingNumber) {
        var quote = invoice.insurancePrepaidGratuitiesQuote;
        var guestQuote = quote.guests.filter(function (g) { return g.seqNumber === guest.seqNumber; })[0];
        var ariaLabel = (content.gratuitiesAddAriaLabel || '')
            .replace('{Amount}', guestQuote.prepaidGratuitiesAmountFormatted)
            .replace('{BookNum}', bookingNumber);
        var addMobileFragment = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-invoice__cell__line-gratuities-amount" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-table__gratuities-container--mobile" }, this.renderActionButton(content.gratuitiesAddLabel, 'add', ariaLabel)))));
        if (index === 0) {
            var helpText = (content.gratuitiesAddHelpText || '')
                .replace('{Amount}', guestQuote.prepaidGratuitiesAmountFormatted);
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-invoice__cell__line-gratuities-amount" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-table__gratuities-container" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-table__gratuities-help-text", "aria-hidden": "true" }, helpText),
                    this.renderActionButton(content.gratuitiesAddLabel, 'add', ariaLabel)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-table__gratuities-container--mobile" }, addMobileFragment)));
        }
        return addMobileFragment;
    };
    GratuitiesRow.prototype.renderRemove = function (line, content, bookingNumber) {
        var ariaLabel = content.gratuitiesRemoveAriaLabel.replace('{BookNum}', bookingNumber);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-invoice__cell__line-gratuities-amount" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-table__gratuities-container" }, this.renderRawLineAmount(line)),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-table__gratuities-container--mobile" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-invoice__cell__line-gratuities-amount-remove" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-table__gratuities-container--mobile" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { "aria-hidden": "true" }, line.amountFormatted),
                            this.renderVisuallyHiddenFromLine(line)),
                        this.renderActionButton(content.gratuitiesRemoveLabel, 'remove', ariaLabel))))));
    };
    GratuitiesRow.prototype.renderActionButton = function (label, action, ariaLabel) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "", className: "h-invoice-table__gratuities-cta d-print-none", "aria-label": ariaLabel, role: "button", onClick: this.onActionButtonClick(action) }, label));
    };
    GratuitiesRow.prototype.calculateAvailability = function (invoice, guest) {
        var quote = invoice.insurancePrepaidGratuitiesQuote, invoiceLines = invoice.lineItems;
        if (!quote.isPrepaidGratuitiesAvailable) {
            return 'Unavailable';
        }
        var filteredGuests = quote.guests.filter(function (g) { return g.seqNumber === guest.seqNumber; });
        if (!filteredGuests.length) {
            return 'GuestDoesNotExists';
        }
        var gratuitiesTotal = this.getGatuitiesValueFromInvoiceLines(invoiceLines);
        if (quote.isPrepaidGratuitiesAvailable && gratuitiesTotal > 0) {
            return 'CanRemove';
        }
        if (quote.isPrepaidGratuitiesAvailable && gratuitiesTotal === 0) {
            return 'CanAdd';
        }
        return 'Unknown';
    };
    GratuitiesRow.prototype.getGatuitiesValueFromInvoiceLines = function (lineItems) {
        var filtered = lineItems.filter(__WEBPACK_IMPORTED_MODULE_2__common__["e" /* isGratuitiesLine */]);
        if (filtered.length > 0) {
            return filtered[0].amount;
        }
        return 0;
    };
    return GratuitiesRow;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=gratuities-row.js.map

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GratuitiesTotalCell; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eyebrow_eyebrow__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__visually_hidden_visually_hidden__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_colors__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icons__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__line_explanation_trigger__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__gratuities_row_css__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__gratuities_row_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__gratuities_row_css__);









var GratuitiesTotalCell = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(GratuitiesTotalCell, _super);
    function GratuitiesTotalCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            busy: false
        };
        _this.onActionButtonClick = function (e) {
            e.preventDefault();
            _this.setState({ busy: true }, function () {
                var onAction = _this.props.onAction;
                var newState = { busy: false };
                onAction('remove')
                    .then(function () { return _this.setState(newState); })
                    .catch(function () { return _this.setState(newState); });
            });
        };
        return _this;
    }
    GratuitiesTotalCell.prototype.render = function () {
        var _a = this.props, bookingNumber = _a.bookingNumber, line = _a.line;
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__common__["e" /* isGratuitiesLine */])(line)) {
            return null;
        }
        var _b = this.props, content = _b.content, invoice = _b.invoice;
        if (this.state.busy) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                this.renderLineDescription(line, content),
                this.renderBusyIndicator(invoice, content, bookingNumber)));
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            this.renderLineDescription(line, content),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-invoice__cell__line-amount h-booking-invoice__cell__line-amount--grats" }, this.renderAmount(line, invoice, content, bookingNumber))));
    };
    GratuitiesTotalCell.prototype.renderLineDescription = function (line, content) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-invoice__cell__line-description", "aria-hidden": "true" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__eyebrow_eyebrow__["a" /* Eyebrow */], null,
                line.description,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__line_explanation_trigger__["a" /* LineExplanationTrigger */], { content: content, line: line, onOpen: this.props.onExplanationOpen }))));
    };
    GratuitiesTotalCell.prototype.renderAmount = function (line, invoice, content, bookingNumber) {
        var quote = invoice.insurancePrepaidGratuitiesQuote;
        var ariaLabel = content.gratuitiesRemoveAriaLabel.replace('{BookNum}', bookingNumber);
        if (quote.isPrepaidGratuitiesAvailable && line.amount > 0) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null, line.amountFormatted),
                this.renderActionButton(content.gratuitiesRemoveLabel, ariaLabel)));
        }
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null, line.amountFormatted);
    };
    GratuitiesTotalCell.prototype.renderBusyIndicator = function (invoice, content, bookingNumber) {
        var guestsNames = invoice.guests.map(function (g, i) { return Object(__WEBPACK_IMPORTED_MODULE_2__common__["a" /* getGuestName */])(i, content, g.firstName, g.lastName); }).join(', ');
        var adaVerbiage = content.gratuitiesBusyMessage.replace('{Action}', content.gratuitiesRemoving)
            .replace('{Guest}', guestsNames)
            .replace('{BookNumm}', bookingNumber);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-booking-invoice__cell__line-amount", "aria-hidden": "true" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-table__gratuities-busy-container" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__icons__["SpinnerIcon"], { color: __WEBPACK_IMPORTED_MODULE_5__styles_colors__["c" /* BlueColor */], width: 22, height: 22 }))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], null, adaVerbiage)));
    };
    GratuitiesTotalCell.prototype.renderActionButton = function (label, ariaLabel) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "", className: "h-invoice-table__gratuities-cta h-invoice-table__gratuities-cta--total", "aria-label": ariaLabel, role: "button", onClick: this.onActionButtonClick }, label));
    };
    return GratuitiesTotalCell;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=gratuities-total-cell.js.map

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LineExplanationModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__line_explanation_host__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__line_explanation_modal_css__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__line_explanation_modal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__line_explanation_modal_css__);







var LineExplanationModal = function (props) {
    var isOpen = props.isOpen, content = props.content, line = props.line, onClose = props.onClose, restProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(props, ["isOpen", "content", "line", "onClose"]);
    if (!line.explanation) {
        return null;
    }
    var closeButtonAriaLabel = getModalCloseButtonAriaLabelByLine(line, content);
    var className = __WEBPACK_IMPORTED_MODULE_5_classnames__('h-invoice-table__explanation-modal', "h-invoice-table__explanation-modal-" + line.code.toLowerCase());
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__modal_modal__["a" /* Modal */], { className: className, dialogDescription: getDialogDescription(line, content), isOpen: isOpen, onRequestClose: onClose, shell: false },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__line_explanation_host__["a" /* LineExplanationHost */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ line: line, onClose: onClose, closeButtonAriaLabel: closeButtonAriaLabel }, restProps))));
};
function getDialogDescription(line, content) {
    if (Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* isVppLine */])(line)) {
        return content.vppDialogDescription;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* isGratuitiesLine */])(line)) {
        return content.gratuitiesDialogDescription;
    }
    return '';
}
function getModalCloseButtonAriaLabelByLine(line, content) {
    if (line.explanation) {
        if (Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* isVppLine */])(line)) {
            return content.vppCloseDialogAriaLabel;
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* isGratuitiesLine */])(line)) {
            return content.gratuitiesCloseDialogAriaLabel;
        }
    }
    return '';
}
//# sourceMappingURL=line-explanation-modal.js.map

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LineExplanationHost; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_colors__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icons__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__line_explanation_host_css__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__line_explanation_host_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__line_explanation_host_css__);






var contentByLineCache = {};
var LineExplanationHost = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(LineExplanationHost, _super);
    function LineExplanationHost() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClose = function (event) {
            event.preventDefault();
            _this.props.onClose();
        };
        return _this;
    }
    LineExplanationHost.prototype.render = function () {
        var _a = this.props, closeButtonAriaLabel = _a.closeButtonAriaLabel, line = _a.line;
        if (!line.explanation) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-table__line-explanation" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-table__line-explanation-wrapper" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__button_button__["a" /* Button */], { className: "h-invoice-table__line-explanation-close", color: "outline-white", onClick: this.onClose, "aria-label": closeButtonAriaLabel },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__icons__["CloseIcon"], { color: __WEBPACK_IMPORTED_MODULE_3__styles_colors__["c" /* BlueColor */] }))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-invoice-table__line-explanation-content", dangerouslySetInnerHTML: { __html: sanitizeContent(line) } })));
    };
    return LineExplanationHost;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

function sanitizeContent(line) {
    if (contentByLineCache[line.code]) {
        return contentByLineCache[line.code];
    }
    var parsedDocument;
    try {
        var parser = new DOMParser();
        parsedDocument = parser.parseFromString(line.explanation, 'text/html');
    }
    catch (_a) {
        return '';
    }
    removeInlineStyle(parsedDocument.body.children);
    contentByLineCache[line.code] = parsedDocument.body.innerHTML;
    return contentByLineCache[line.code];
}
function removeInlineStyle(elements) {
    if (!elements || elements.length === 0) {
        return;
    }
    for (var index = 0; index < elements.length; index++) {
        var element = elements[index];
        element.removeAttribute('style');
        removeInlineStyle(element.children);
    }
}
//# sourceMappingURL=line-explanation-host.js.map

/***/ }),
/* 749 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 750 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 751 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 752 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InsuranceGuestRequest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms__ = __webpack_require__(10);



var InsuranceGuestRequest = function (componentProps) {
    var states = componentProps.states, guestRequestControl = componentProps.guestRequestControl, content = componentProps.content, onControlChanged = componentProps.onControlChanged;
    var selectedGuest = guestRequestControl.controlGroup.controls.get.seqNumber;
    var homeStateCode = guestRequestControl.controlGroup.controls.get.homeStateCode;
    var onValueChange = function (control) { return onControlChanged(guestRequestControl, control); };
    var renderMessage = function (guestRequest, modalContent) {
        var message = null;
        if (guestRequest.hasPurchasedVpp) {
            message = modalContent.hasPurchasedMessage;
        }
        else if (guestRequest.hasError) {
            message = modalContent.stateRequiredMessage;
        }
        if (!message) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-cvp__message", "aria-live": "assertive", role: "alert" }, message));
    };
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row h-cvp-guest-request__list-item" },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-md h-cvp-guest-request__col" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms__["c" /* FormField */], { key: selectedGuest.id, controlModel: selectedGuest, onFieldUpdate: onValueChange }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms__["a" /* Checkbox */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ disabled: guestRequestControl.hasPurchasedVpp }, props.controlProps)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ "data-pii": "true" }, props.labelProps), selectedGuest.props.label))); })),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-md h-cvp-guest-request__col" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms__["c" /* FormField */], { controlModel: homeStateCode, onFieldUpdate: onValueChange }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms__["g" /* Select */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ "aria-label": "" + content.stateSelectAriaLabel, disabled: !guestRequestControl.selected || guestRequestControl.hasPurchasedVpp }, props.controlProps),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("option", { value: "" }, content.stateSelectionDefault),
                    states.map(function (state) { return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("option", { key: state.code, value: state.code }, state.name); })))); })),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-md h-cvp-guest-request__col h-cvp__message" }, renderMessage(guestRequestControl, content))));
};
//# sourceMappingURL=insurance-guest-request.js.map

/***/ }),
/* 754 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 755 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InvoiceDetailsModalTrigger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__invoice_details__ = __webpack_require__(245);




var InvoiceDetailsModalTrigger = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(InvoiceDetailsModalTrigger, _super);
    function InvoiceDetailsModalTrigger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InvoiceDetailsModalTrigger.prototype.render = function () {
        var _a = this.props, isOpen = _a.isOpen, restProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["isOpen"]);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__modal_modal__["a" /* Modal */], { shell: false, isOpen: isOpen, fullScreen: true, onRequestClose: this.props.onRequestClose, dialogDescription: this.props.content.heading },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__invoice_details__["a" /* InvoiceDetails */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ mode: "modal" }, restProps))));
    };
    return InvoiceDetailsModalTrigger;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=invoice-details-modal-trigger.js.map

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Spinner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icons_index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_colors__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__spinner_css__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__spinner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__spinner_css__);






var Spinner = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Spinner, _super);
    function Spinner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Spinner.prototype.render = function () {
        var _a = this.props, className = _a.className, height = _a.height, width = _a.width, color = _a.color;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-spinner__busy-container', className) },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__icons_index__["SpinnerIcon"], { color: color || __WEBPACK_IMPORTED_MODULE_4__styles_colors__["c" /* BlueColor */], width: width, height: height })));
    };
    return Spinner;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=spinner.js.map

/***/ }),
/* 758 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BookedFooter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hub_app_hub_app_download__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__current_sailing__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mobile_nav__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__booked_footer_css__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__booked_footer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__booked_footer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers__ = __webpack_require__(165);








var BookedFooter = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(BookedFooter, _super);
    function BookedFooter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BookedFooter.prototype.render = function () {
        var _a = this.props, item = _a.item, activeSailing = _a.activeSailing;
        var navLinks = item.fields.links.value;
        var funBrowser = navLinks.filter(function (n) { return n.fields.tags.value && n.fields.tags.value.indexOf('FunBrowser') >= 0; })[0];
        var funBrowserLinks = (funBrowser.fields.contentSource.value.fields.links.value);
        var middleLinks = navLinks.filter(function (n, i) { return i !== 0 && n !== funBrowser; });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("footer", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-bkd-ftr', this.props.className) },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: " h-bkd-ftr__main-links--mobile" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "container" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col h-bkd-ftr__padding-mobile" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__current_sailing__["a" /* CurrentSailing */], { eyebrow: item.fields.eyebrow.value, bookAnotherCruise: item.fields.bookAnotherCruise.value, currentSailing: activeSailing.itinerary.shortItineraryTitle })))),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bkd-ftr__horizontal-divider" }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "container" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col h-bkd-ftr__padding-mobile" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__mobile_nav__["a" /* MobileNav */], { navLinks: navLinks, activeSailing: activeSailing }))))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bkd-ftr__main-links--desktop" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "container" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-4" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__current_sailing__["a" /* CurrentSailing */], { eyebrow: item.fields.eyebrow.value, bookAnotherCruise: item.fields.bookAnotherCruise.value, currentSailing: activeSailing.itinerary.shortItineraryTitle })),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-5" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bkd-ftr__link--sailing-aligner" },
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { className: "h-bkd-ftr__link h-bkd-ftr__link--large", href: Object(__WEBPACK_IMPORTED_MODULE_7__helpers__["a" /* replaceUrlPlaceholder */])(navLinks[0].fields.url.value, activeSailing) }, Object(__WEBPACK_IMPORTED_MODULE_7__helpers__["b" /* toTitleCase */])(navLinks[0].fields.title.value))),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null, funBrowserLinks && funBrowserLinks.map(function (n, i) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: i, className: "h-bkd-ftr__link-container" },
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { className: "h-bkd-ftr__link h-bkd-ftr__link--small", "aria-label": n.fields.ariaLabel.value, href: Object(__WEBPACK_IMPORTED_MODULE_7__helpers__["a" /* replaceUrlPlaceholder */])(n.fields.url.value, activeSailing) }, n.fields.text.value))); }))),
                        middleLinks && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-3" }, middleLinks.map(function (n, i) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: i, className: __WEBPACK_IMPORTED_MODULE_2_classnames__({ 'h-bkd-ftr__link--sailing-aligner': i === 0 }) },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { className: "h-bkd-ftr__link h-bkd-ftr__link--large", href: Object(__WEBPACK_IMPORTED_MODULE_7__helpers__["a" /* replaceUrlPlaceholder */])(n.fields.url.value, activeSailing) }, Object(__WEBPACK_IMPORTED_MODULE_7__helpers__["b" /* toTitleCase */])(n.fields.title.value)))); }))))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bkd-ftr__horizontal-divider d-md-none" }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "container d-none d-md-block" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bkd-ftr__horizontal-divider" })))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "container" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col h-bkd-ftr__padding-mobile" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__hub_app_hub_app_download__["a" /* HubAppDownload */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.props.hubApp)))),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col h-bkd-ftr__padding-mobile" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bkd-ftr__horizontal-divider" }))),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col h-bkd-ftr__padding-mobile", dangerouslySetInnerHTML: { __html: item.fields.content.value } })))));
    };
    return BookedFooter;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

//# sourceMappingURL=booked-footer.js.map

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_ui/responsive/ccl/assets/fonts/apple-store-download.svg";

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_ui/responsive/ccl/assets/fonts/google-play-download.svg";

/***/ }),
/* 762 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CurrentSailing; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eyebrow_eyebrow__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chevron_chevron__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_colors__ = __webpack_require__(6);




var CurrentSailing = function (_a) {
    var eyebrow = _a.eyebrow, currentSailing = _a.currentSailing, bookAnotherCruise = _a.bookAnotherCruise;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__eyebrow_eyebrow__["a" /* Eyebrow */], { className: "h-bkd-ftr__eyebrow" }, eyebrow),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-bkd-ftr__sailing" }, currentSailing),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-bkd-ftr__mt16 d-none" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: "h-bkd-ftr__link h-bkd-ftr__link--bold", href: "/booked/home" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, "Manage a different cruise"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__chevron_chevron__["a" /* Chevron */], { direction: "right", size: 14, color: __WEBPACK_IMPORTED_MODULE_3__styles_colors__["i" /* WhiteColor */], className: "h-bkd-ftr__chevron" }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-bkd-ftr__mt16" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: "h-bkd-ftr__link h-bkd-ftr__link--bold", href: "/" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, bookAnotherCruise),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__chevron_chevron__["a" /* Chevron */], { direction: "right", size: 14, color: __WEBPACK_IMPORTED_MODULE_3__styles_colors__["i" /* WhiteColor */], className: "h-bkd-ftr__chevron" })))));
};
//# sourceMappingURL=current-sailing.js.map

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MobileNav; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mobile_dropdown__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mobile_nav_css__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mobile_nav_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__mobile_nav_css__);




var MobileNav = function (_a) {
    var navLinks = _a.navLinks, activeSailing = _a.activeSailing;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-bkd-ftr__mobile-nav" }, navLinks.map(function (n, i) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], { key: i },
        renderItem(n, activeSailing),
        i !== (navLinks.length - 1) && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-bkd-ftr__horizontal-divider" }))); })));
};
function renderItem(item, activeSailing) {
    if (item.templateName === 'MainNavDropdown') {
        var dropdownContent = item.fields.contentSource.value;
        var links = dropdownContent.fields.links.value;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__mobile_dropdown__["a" /* MobileDropdown */], { id: item.id, title: Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["b" /* toTitleCase */])(item.fields.title.value) }, renderFunBrowserLinks(links, activeSailing)));
    }
    else if (item.templateName === 'MainNavLink') {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: "h-bkd-ftr__mobile-nav__link", href: Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* replaceUrlPlaceholder */])(item.fields.url.value, activeSailing) }, Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["b" /* toTitleCase */])(item.fields.title.value))));
    }
    return null;
}
function renderFunBrowserLinks(links, activeSailing) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-bkd-ftr__mobile-nav__fun-browser" }, links.map(function (n, i) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: i, className: "h-bkd-ftr__mobile-nav__fun-browser__item" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: "h-bkd-ftr__mobile-nav__fun-browser__link", href: Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* replaceUrlPlaceholder */])(n.fields.url.value, activeSailing) },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "h-bkd-ftr__mobile-nav__fun-browser__icon", src: n.fields.icon.value.src, alt: n.fields.icon.value.alt, width: "24px", height: "24px" }),
            n.fields.text.value))); })));
}
//# sourceMappingURL=mobile-nav.js.map

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MobileDropdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_focus_trap_react__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_focus_trap_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_focus_trap_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_event_listener__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chevron_chevron__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__click_away_listener_click_away_listener__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_colors__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mobile_dropdown_css__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mobile_dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__mobile_dropdown_css__);









var MobileDropdown = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(MobileDropdown, _super);
    function MobileDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buttonRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.contentRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.containerRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.state = {
            isOpen: false,
            isOpenFirst: false
        };
        _this.toggle = function (e) {
            e.preventDefault();
            _this.setState(function (state) { return ({
                isOpen: !state.isOpen,
                isOpenFirst: state.isOpen === false
            }); });
        };
        _this.close = function (e) {
            if (e.target === _this.buttonRef.current || _this.buttonRef.current.contains(e.target)) {
                return;
            }
            _this.setState(function (prevState) { return prevState.isOpen ? { isOpen: false } : null; });
        };
        _this.onKeyPress = function (e) {
            if (e.keyCode === 27) { // escape key
                if (_this.containerRef.current.contains(e.target)) {
                    _this.setState(function (state) {
                        if (state.isOpen) {
                            _this.buttonRef.current.focus();
                            return { isOpen: false };
                        }
                        return null;
                    });
                }
            }
        };
        return _this;
    }
    MobileDropdown.prototype.render = function () {
        var _a = this.props, title = _a.title, children = _a.children, id = _a.id;
        var isOpen = this.state.isOpen;
        var cn = __WEBPACK_IMPORTED_MODULE_2_classnames__('h-bkd-ftr__mobile-nav__dropdown', { 'h-bkd-ftr__mobile-nav__dropdown--open': isOpen });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this.containerRef, className: cn },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_event_listener___default.a, { target: "document", onKeyUp: this.onKeyPress },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_focus_trap_react__, { active: isOpen },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { className: "h-bkd-ftr__mobile-nav__link", onClick: this.toggle, ref: this.buttonRef, href: "", "aria-expanded": isOpen, "aria-controls": id },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "h-bkd-ftr__mobile-nav__dropdown-title" }, title),
                        ' ',
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__chevron_chevron__["a" /* Chevron */], { "aria-hidden": "true", className: "h-bkd-ftr__mobile-nav__dropdown-chevron", size: 16, direction: isOpen ? 'up' : 'down', color: __WEBPACK_IMPORTED_MODULE_7__styles_colors__["i" /* WhiteColor */] })),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__click_away_listener_click_away_listener__["a" /* ClickAwayListener */], { onClickAway: this.close },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this.contentRef, id: id, className: "h-bkd-ftr__mobile-nav__dropdown__content" }, children))))));
    };
    MobileDropdown.prototype.componentDidUpdate = function () {
        this.setState(function (prevState) { return prevState.isOpenFirst ? { isOpenFirst: false } : null; });
    };
    return MobileDropdown;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=mobile-dropdown.js.map

/***/ }),
/* 766 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 767 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 769 */
/***/ (function(module, exports) {

//# sourceMappingURL=model.js.map

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PromotionalModules */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__promotional_modules_css__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__promotional_modules_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__promotional_modules_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__button_button__ = __webpack_require__(5);




var PromotionalModules = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(PromotionalModules, _super);
    function PromotionalModules() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function (e) {
            e.preventDefault();
            _this.props.onClick(e.currentTarget.dataset.type);
        };
        return _this;
    }
    PromotionalModules.prototype.renderPromoCard = function (promoCard) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-lg", key: promoCard.promotionType },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("article", { className: "h-promotional-modules__item" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("figure", { className: "h-promotional-modules__icon" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", { className: "h-promotional-modules__card-image", src: promoCard.iconUrl, alt: "" })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h3", { className: "h-promotional-modules__name" }, promoCard.title),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { className: "h-promotional-modules__description", dangerouslySetInnerHTML: { __html: promoCard.introHtml } }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-promotional-modules__action" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__button_button__["a" /* Button */], { onClick: this.onClick, "data-type": promoCard.promotionType, "aria-label": promoCard.buttonAriaLabel }, promoCard.buttonText)))));
    };
    PromotionalModules.prototype.render = function () {
        var _this = this;
        var promotionalData = this.props.promotionalData;
        if (!promotionalData || promotionalData.promotionCards === null || promotionalData.promotionCards.length === 0) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("section", { className: "h-promotional-modules" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h2", { className: "h-promotional-modules__title" }, this.props.content.heading),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" }, promotionalData.promotionCards.map(function (card) { return _this.renderPromoCard(card); }))));
    };
    return PromotionalModules;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=promotional-modules.js.map

/***/ }),
/* 771 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StoreBanner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_banner_css__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_banner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__store_banner_css__);




var StoreBanner = function (_a) {
    var className = _a.className, backgroundImage = _a.backgroundImage, heading = _a.heading, description = _a.description, ctaText = _a.ctaText, ctaUrl = _a.ctaUrl, ctaAriaLabel = _a.ctaAriaLabel;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__('h-store-banner', className), style: {
            backgroundImage: "url(\"" + backgroundImage.src + "\")"
        } },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-store-banner__card" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h-store-banner__heading" }, heading),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-store-banner__description", dangerouslySetInnerHTML: { __html: description } }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__button_button__["b" /* LinkButton */], { href: ctaUrl, "aria-label": ctaAriaLabel }, ctaText)))))));
};
//# sourceMappingURL=store-banner.js.map

/***/ }),
/* 773 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ItineraryCalendar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__itinerary_calendar_css__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__itinerary_calendar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__itinerary_calendar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__itinerary_calendar_day__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__booking_selector_booking_selector__ = __webpack_require__(112);





var ItineraryCalendar = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(ItineraryCalendar, _super);
    function ItineraryCalendar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItineraryCalendar.prototype.render = function () {
        var _a = this.props, calendar = _a.calendar, content = _a.content, className = _a.className, bookingSelectorProps = _a.bookingSelectorProps;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: className },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "container" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-dropdown-selector-wrapper" },
                    bookingSelectorProps && bookingSelectorProps.selectedBookings.length > 0 &&
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h3", { className: "h-dropdown-header", "aria-label": content.bookingSelectorHeading + "\n                                    " + this.getTitle(bookingSelectorProps.selectedBookings.length, bookingSelectorProps.content) }, content.bookingSelectorHeading),
                    (!bookingSelectorProps || bookingSelectorProps.selectedBookings.length === 0) &&
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h3", { className: "h-dropdown-header" }, content.sectionHeading),
                    bookingSelectorProps && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-calendar__filter" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__booking_selector_booking_selector__["a" /* BookingSelector */], { content: bookingSelectorProps.content, onSelectedBookings: bookingSelectorProps.onSelectedBookings, selectedBookings: bookingSelectorProps.selectedBookings, activeSailing: bookingSelectorProps.activeSailing, parentNameRef: "itinerary-full", disableSelector: bookingSelectorProps.disableSelector })))),
            calendar.days && calendar.days.map(function (day, index) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__itinerary_calendar_day__["a" /* ItineraryCalendarDay */], { key: index, day: day, content: content })); })));
    };
    ItineraryCalendar.prototype.getTitle = function (selectedBookingsCount, content) {
        return ((selectedBookingsCount === 1 ? content.oneStateroomTitle : content.multiStateroomTitle) || '')
            .replace('{StateroomCount}', selectedBookingsCount.toString());
    };
    return ItineraryCalendar;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=itinerary-calendar.js.map

/***/ }),
/* 775 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ItineraryCalendarDay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lines_ellipsis_lib_html__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lines_ellipsis_lib_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_lines_ellipsis_lib_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__itinerary_calendar_day_css__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__itinerary_calendar_day_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__itinerary_calendar_day_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__eyebrow_eyebrow__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__chevron_chevron__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_colors__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__icons__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__itinerary_calendar_entry__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__visually_hidden_visually_hidden__ = __webpack_require__(14);











var ItineraryCalendarDay = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(ItineraryCalendarDay, _super);
    function ItineraryCalendarDay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            expanded: false,
        };
        _this.getDayId = function () {
            var day = _this.props.day;
            return day.day.replace(' ', '_').trim();
        };
        _this.toggleExpanded = function () {
            _this.setState(function (state) {
                return {
                    expanded: !state.expanded,
                };
            });
        };
        return _this;
    }
    ItineraryCalendarDay.prototype.render = function () {
        var _a = this.props, day = _a.day, content = _a.content, className = _a.className;
        var expanded = this.state.expanded;
        var style = day.portHero && day.portHero.src ? {
            backgroundImage: "url(\"" + day.portHero.src + "\")",
        } : {
            backgroundColor: __WEBPACK_IMPORTED_MODULE_7__styles_colors__["c" /* BlueColor */]
        };
        var wrapperClassName = __WEBPACK_IMPORTED_MODULE_2_classnames__({ 'h-itin-calendar-day-wrapper--collapsed': !expanded }, className);
        var dayId = this.getDayId();
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: wrapperClassName },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("section", { className: "h-itin-calendar-day", style: style },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "container" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("article", { className: "h-itin-calendar-day__card" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-itin-calendar-day__card-wrapper" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__eyebrow_eyebrow__["a" /* Eyebrow */], null, day.day),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h4", { className: "h-itin-calendar-day__card-title" }, day.port),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h5", { className: "h-itin-calendar-day__card-date" }, day.dateMmmmDYyyyDddd),
                            day.portOverviewDescription && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-itin-calendar-day__card-description" },
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_lines_ellipsis_lib_html___default.a, { unsafeHTML: day.portOverviewDescription, maxLine: expanded ? 1000 : 5, ellipsis: "...", basedOn: "words" }))),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__eyebrow_eyebrow__["a" /* Eyebrow */], { className: "h-itin-calendar-day__card-activities" }, content.activities),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "h-itin-calendar-day__card-purchased" },
                                day.purchasedActivitiesCount > 0 && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__icons__["CheckmarkIcon"], { color: "#008285", width: "14", height: "11" }),
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("strong", null,
                                    " ",
                                    content.purchased),
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "h-itin-calendar-day__card-amount" },
                                    " ",
                                    day.purchasedActivitiesCount))),
                        day.entries && day.entries.length > 0 && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", { className: "h-itin-calendar-day__card-toggle", onClick: this.toggleExpanded, "aria-expanded": expanded, "aria-controls": expanded ? dayId : undefined },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__chevron_chevron__["a" /* Chevron */], { className: "h-itin-calendar-day__card-toggle-icon", size: 24, color: __WEBPACK_IMPORTED_MODULE_7__styles_colors__["c" /* BlueColor */], direction: expanded ? 'up' : 'down' }),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__visually_hidden_visually_hidden__["a" /* VisuallyHidden */], null, expanded ? content.adaHideDetails : content.adaShowDetails)))))),
            expanded && this.renderEntries()));
    };
    ItineraryCalendarDay.prototype.renderEntries = function () {
        var _a = this.props, day = _a.day, content = _a.content;
        if (!day || !day.entries) {
            return null;
        }
        var dayId = this.getDayId();
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "container" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { id: dayId, className: "h-itin-calendar-day__details" }, day.entries.map(function (entry, index) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__itinerary_calendar_entry__["a" /* ItineraryCalendarEntry */], { key: index, entry: entry, content: content })); }))));
    };
    return ItineraryCalendarDay;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=itinerary-calendar-day.js.map

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var _require = __webpack_require__(778),
    canvasStyle = _require.canvasStyle,
    mirrorProps = _require.mirrorProps;

var _require2 = __webpack_require__(779),
    omit = _require2.omit;

function hookNode(node, basedOn) {
  /* eslint-env browser */
  if (basedOn !== 'letters' && basedOn !== 'words') {
    throw new Error('Unsupported options basedOn: ' + basedOn);
  }
  if (node.nodeType === Node.TEXT_NODE) {
    var frag = document.createDocumentFragment();
    var units = void 0;
    switch (basedOn) {
      case 'words':
        units = node.textContent.split(/\b|(?=\W)/);
        break;
      case 'letters':
        units = Array.from(node.textContent);
        break;
    }
    units.forEach(function (unit) {
      frag.appendChild(dummySpan(unit));
    });
    node.parentNode.replaceChild(frag, node);
  } else if (node.nodeType === Node.ELEMENT_NODE) {
    var nodes = [].slice.call(node.childNodes);
    var len = nodes.length;
    for (var i = 0; i < len; i++) {
      hookNode(nodes[i], basedOn);
    }
  }
}

function dummySpan(text) {
  var span = document.createElement('span');
  span.className = 'LinesEllipsis-unit';
  span.textContent = text;
  return span;
}

function unwrapTextNode(node) {
  node.parentNode.replaceChild(document.createTextNode(node.textContent), node);
}

function removeFollowingElementLeaves(node, root) {
  if (!root.contains(node) || node === root) return;
  while (node.nextElementSibling) {
    node.parentNode.removeChild(node.nextElementSibling);
  }
  removeFollowingElementLeaves(node.parentNode, root);
}

function findBlockAncestor(node) {
  var ndAncestor = node;
  while (ndAncestor = ndAncestor.parentNode) {
    if (/p|div|main|section|h\d|ul|ol|li/.test(ndAncestor.tagName.toLowerCase())) {
      return ndAncestor;
    }
  }
}

function affectLayout(ndUnit) {
  return !!(ndUnit.offsetHeight && (ndUnit.offsetWidth || /\S/.test(ndUnit.textContent)));
}

var defaultProps = {
  component: 'div',
  unsafeHTML: '',
  maxLine: 1,
  ellipsis: '…', // &hellip;
  ellipsisHTML: undefined,
  className: '',
  basedOn: undefined,
  onReflow: function onReflow() {},

  winWidth: undefined // for the HOC
};
var usedProps = Object.keys(defaultProps);

/**
 * props.unsafeHTML {String} the rich content you want to clamp
 * props.maxLine {Number|String} max lines allowed
 * props.ellipsis {String} the ellipsis indicator
 * props.basedOn {String} letters|words
 * props.className {String}
 */

var HTMLEllipsis = function (_React$Component) {
  _inherits(HTMLEllipsis, _React$Component);

  function HTMLEllipsis(props) {
    _classCallCheck(this, HTMLEllipsis);

    var _this = _possibleConstructorReturn(this, (HTMLEllipsis.__proto__ || Object.getPrototypeOf(HTMLEllipsis)).call(this, props));

    _this.state = {
      html: props.unsafeHTML,
      clamped: false
    };
    _this.canvas = null;
    _this.maxLine = 0;
    _this.nlUnits = [];
    return _this;
  }

  _createClass(HTMLEllipsis, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.initCanvas();
      this.reflow(this.props);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.winWidth !== this.props.winWidth) {
        this.copyStyleToCanvas();
      }
      if (this.props !== prevProps) {
        this.reflow(this.props);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.canvas.parentNode.removeChild(this.canvas);
    }
  }, {
    key: 'setState',
    value: function setState(state, callback) {
      if (typeof state.clamped !== 'undefined') {
        this.clamped = state.clamped;
      }
      return _get(HTMLEllipsis.prototype.__proto__ || Object.getPrototypeOf(HTMLEllipsis.prototype), 'setState', this).call(this, state, callback);
    }
  }, {
    key: 'initCanvas',
    value: function initCanvas() {
      if (this.canvas) return;
      var canvas = this.canvas = document.createElement('div');
      canvas.className = 'LinesEllipsis-canvas ' + this.props.className;
      canvas.setAttribute('aria-hidden', 'true');
      this.copyStyleToCanvas();
      Object.keys(canvasStyle).forEach(function (key) {
        canvas.style[key] = canvasStyle[key];
      });
      document.body.appendChild(canvas);
    }
  }, {
    key: 'copyStyleToCanvas',
    value: function copyStyleToCanvas() {
      var _this2 = this;

      var targetStyle = window.getComputedStyle(this.target);
      mirrorProps.forEach(function (key) {
        _this2.canvas.style[key] = targetStyle[key];
      });
    }
  }, {
    key: 'reflow',
    value: function reflow(props) {
      /* eslint-disable no-control-regex */
      this.maxLine = +props.maxLine || 1;
      this.canvas.innerHTML = props.unsafeHTML;
      var basedOn = props.basedOn || (/^[\x00-\x7F]+$/.test(props.unsafeHTML) ? 'words' : 'letters');
      hookNode(this.canvas, basedOn);
      var clamped = this.putEllipsis(this.calcIndexes());
      var newState = {
        clamped: clamped,
        html: this.canvas.innerHTML
      };
      this.setState(newState, props.onReflow.bind(this, newState));
    }
  }, {
    key: 'calcIndexes',
    value: function calcIndexes() {
      var indexes = [0];
      var nlUnits = this.nlUnits = Array.from(this.canvas.querySelectorAll('.LinesEllipsis-unit'));
      var len = nlUnits.length;
      if (!nlUnits.length) return indexes;

      var nd1stLayoutUnit = nlUnits.find(affectLayout);
      if (!nd1stLayoutUnit) return indexes;

      var line = 1;
      var offsetTop = nd1stLayoutUnit.offsetTop;
      for (var i = 1; i < len; i++) {
        if (affectLayout(nlUnits[i]) && nlUnits[i].offsetTop - offsetTop > 1) {
          line++;
          indexes.push(i);
          offsetTop = nlUnits[i].offsetTop;
          if (line > this.maxLine) {
            break;
          }
        }
      }
      return indexes;
    }
  }, {
    key: 'putEllipsis',
    value: function putEllipsis(indexes) {
      if (indexes.length <= this.maxLine) return false;
      this.nlUnits = this.nlUnits.slice(0, indexes[this.maxLine]);
      var ndPrevUnit = this.nlUnits.pop();
      var ndEllipsis = this.makeEllipsisSpan();

      do {
        removeFollowingElementLeaves(ndPrevUnit, this.canvas);
        findBlockAncestor(ndPrevUnit).appendChild(ndEllipsis);
        ndPrevUnit = this.nlUnits.pop();
      } while (ndPrevUnit && (!affectLayout(ndPrevUnit) || ndEllipsis.offsetHeight > ndPrevUnit.offsetHeight || ndEllipsis.offsetTop > ndPrevUnit.offsetTop));

      if (ndPrevUnit) {
        unwrapTextNode(ndPrevUnit);
      }
      this.nlUnits.forEach(unwrapTextNode);

      return true;
    }
  }, {
    key: 'makeEllipsisSpan',
    value: function makeEllipsisSpan() {
      var _props = this.props,
          ellipsisHTML = _props.ellipsisHTML,
          ellipsis = _props.ellipsis;

      var frag = document.createElement('span');
      frag.appendChild(document.createElement('wbr'));
      var ndEllipsis = document.createElement('span');
      ndEllipsis.className = 'LinesEllipsis-ellipsis';
      if (ellipsisHTML) {
        ndEllipsis.innerHTML = ellipsisHTML;
      } else {
        ndEllipsis.textContent = ellipsis;
      }
      frag.appendChild(ndEllipsis);
      return frag;
    }

    // expose

  }, {
    key: 'isClamped',
    value: function isClamped() {
      return this.clamped; // do not use state.clamped. #27
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          html = _state.html,
          clamped = _state.clamped;

      var _props2 = this.props,
          Component = _props2.component,
          className = _props2.className,
          unsafeHTML = _props2.unsafeHTML,
          rest = _objectWithoutProperties(_props2, ['component', 'className', 'unsafeHTML']);

      return React.createElement(
        Component,
        _extends({
          className: 'LinesEllipsis ' + (clamped ? 'LinesEllipsis--clamped' : '') + ' ' + className,
          ref: function ref(node) {
            return _this3.target = node;
          }
        }, omit(rest, usedProps)),
        React.createElement('div', { dangerouslySetInnerHTML: { __html: clamped ? html : unsafeHTML } })
      );
    }
  }]);

  return HTMLEllipsis;
}(React.Component);

HTMLEllipsis.defaultProps = defaultProps;

module.exports = HTMLEllipsis;



/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  canvasStyle: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    height: 0,
    overflow: 'hidden',
    'padding-top': 0,
    'padding-bottom': 0,
    border: 'none'
  },

  mirrorProps: ['box-sizing', 'width', 'font-size', 'font-weight', 'font-family', 'font-style', 'letter-spacing', 'text-indent', 'white-space', 'word-break', 'padding-left', 'padding-right']
};



/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function omit(obj, omittedKeys) {
  if (!obj || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
    return obj;
  }
  var ret = {};
  Object.keys(obj).forEach(function (key) {
    if (omittedKeys.indexOf(key) > -1) {
      return;
    }
    ret[key] = obj[key];
  });
  return ret;
}

module.exports = {
  omit: omit
};



/***/ }),
/* 780 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ItineraryCalendarEntry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__itinerary_calendar_entry_css__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__itinerary_calendar_entry_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__itinerary_calendar_entry_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chevron_chevron__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_colors__ = __webpack_require__(6);






var ItineraryCalendarEntry = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(ItineraryCalendarEntry, _super);
    function ItineraryCalendarEntry() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItineraryCalendarEntry.prototype.render = function () {
        var _a = this.props, className = _a.className, entry = _a.entry;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-itin-calendar-entry', className) },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-itin-calendar-entry__time" }, entry.timeHMmTt),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-itin-calendar-entry__content" },
                this.renderTitle(),
                this.renderScheduleInfo(),
                this.renderContent())));
    };
    ItineraryCalendarEntry.prototype.renderTitle = function () {
        var _a = this.props, entry = _a.entry, content = _a.content;
        if (entry.activity && entry.activity.productName) {
            var titleLabel = entry.activity.isComplimentary ? content.complimentary : content.purchased;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-itin-calendar-entry__content-header" },
                entry.activity.productImageUrl && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", { className: "h-itin-calendar-entry__content-header-picture", src: entry.activity.productImageUrl, alt: entry.activity.productName, "aria-hidden": true })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-itin-calendar-entry__content-header-product-title" },
                    titleLabel,
                    ":"),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-itin-calendar-entry__content-header-product-name" }, entry.activity.productName)));
        }
        if (entry.title) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-itin-calendar-entry__content-header" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-itin-calendar-entry__content-header-title", dangerouslySetInnerHTML: { __html: entry.title } })));
        }
        return null;
    };
    ItineraryCalendarEntry.prototype.renderScheduleInfo = function () {
        var entry = this.props.entry;
        if (entry.activity && entry.activity.productScheduleInfo) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-itin-calendar-entry__content-scheduleinfo", dangerouslySetInnerHTML: { __html: entry.activity.productScheduleInfo } }));
        }
        return null;
    };
    ItineraryCalendarEntry.prototype.renderContent = function () {
        var entry = this.props.entry;
        if (entry.bookings && entry.bookings.length) {
            return this.renderBookings();
        }
        return this.renderItem(entry.description, entry.ctaText, entry.ctaUrl);
    };
    ItineraryCalendarEntry.prototype.renderBookings = function () {
        var _this = this;
        var entry = this.props.entry;
        if (!entry.bookings) {
            return null;
        }
        return entry.bookings.map(function (booking, index) { return _this.renderItem(booking.title, booking.ctaText, booking.ctaUrl, index); });
    };
    ItineraryCalendarEntry.prototype.renderItem = function (description, ctaText, ctaUrl, key) {
        if (!description && !ctaText) {
            return null;
        }
        var ariaLabel = description ? ctaText + " for " + description : "" + ctaText;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-itin-calendar-entry__content-item", key: key },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null, description),
            description && ctaText && ctaUrl && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-itin-calendar-entry__content-item__spacer" }),
            ctaText && ctaUrl && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: ctaUrl, className: "h-itin-calendar-entry__content-item__link", "aria-label": ariaLabel },
                ctaText,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__chevron_chevron__["a" /* Chevron */], { "aria-hidden": "true", className: "h-itin-calendar-entry__content-item__link__chevron", size: 16, direction: "right", color: __WEBPACK_IMPORTED_MODULE_5__styles_colors__["c" /* BlueColor */] })))));
    };
    return ItineraryCalendarEntry;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=itinerary-calendar-entry.js.map

/***/ }),
/* 782 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 783 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductCarousel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__product_carousel_css__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__product_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__product_carousel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__product_card_product_card__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__carousel_carousel__ = __webpack_require__(160);





var ProductCarousel = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(ProductCarousel, _super);
    function ProductCarousel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getSlideDescription = function (index) {
            var product = _this.props.products[index];
            return product.title;
        };
        return _this;
    }
    ProductCarousel.prototype.render = function () {
        var _a = this.props, products = _a.products, slickSettings = _a.slickSettings, renderDotAriaLabel = _a.renderDotAriaLabel, prevArrowAriaLabel = _a.prevArrowAriaLabel, nextArrowAriaLabel = _a.nextArrowAriaLabel;
        var mergedSlickSettings = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, ProductCarousel.defaultSlickSettings), slickSettings);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-product-carousel" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__carousel_carousel__["a" /* Carousel */], { prevArrowAriaLabel: prevArrowAriaLabel, nextArrowAriaLabel: nextArrowAriaLabel, getSlideDescription: this.getSlideDescription, focusManagement: "a", slickSettings: mergedSlickSettings, renderDotAriaLabel: renderDotAriaLabel }, products.map(function (p, i) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: i, className: "h-product-carousel__slide" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__product_card_product_card__["a" /* ProductCard */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, p)))); }))));
    };
    ProductCarousel.defaultSlickSettings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        centerPadding: '0px',
        adaptiveHeight: false
    };
    return ProductCarousel;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=product-carousel.js.map

/***/ }),
/* 785 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ShorexRecommendationsBanner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eyebrow_eyebrow__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__countdown_countdown__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shorex_recommendations_banner_css__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shorex_recommendations_banner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__shorex_recommendations_banner_css__);






var ShorexRecommendationsBanner = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(ShorexRecommendationsBanner, _super);
    function ShorexRecommendationsBanner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShorexRecommendationsBanner.prototype.render = function () {
        var _a = this.props, eyebrow = _a.eyebrow, title = _a.title, days = _a.days, hours = _a.hours, minutes = _a.minutes, totalMinutesLeft = _a.totalMinutesLeft, adaCountdownFormat = _a.adaCountdownFormat, ctaText = _a.ctaText, onClick = _a.onClick, disclaimer = _a.disclaimer, description = _a.description, ctaAriaLabel = _a.ctaAriaLabel, image = _a.image;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-sxrecb" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-sxrecb__main" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-sxrecb__content" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__eyebrow_eyebrow__["a" /* Eyebrow */], { className: "h-sxrecb__eyebrow" }, eyebrow),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-sxrecb__heading" }, title),
                    description && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-sxrecb__description", dangerouslySetInnerHTML: { __html: description } }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__countdown_countdown__["a" /* Countdown */], { className: "h-sxrecb__countdown", content: {
                            days: days,
                            hours: hours,
                            minutes: minutes,
                            adaCountdownFormat: adaCountdownFormat
                        }, totalMinutesLeft: totalMinutesLeft })),
                image && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-sxrecb__image" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", { src: image.src, alt: image.alt }))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-sxrecb__actions" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-sxrecb__cta-container" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__button_button__["a" /* Button */], { className: "h-sxrecb__cta", onClick: onClick, "aria-label": ctaAriaLabel }, ctaText)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-sxrecb__disclaimer" }, disclaimer))));
    };
    return ShorexRecommendationsBanner;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=shorex-recommendations-banner.js.map

/***/ }),
/* 787 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 788 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CruiseTipsStack */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cruise_tip__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chevron_chevron_circle__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cruise_tips_stack_css__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cruise_tips_stack_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__cruise_tips_stack_css__);






var CruiseTipsStack = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(CruiseTipsStack, _super);
    function CruiseTipsStack() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.applyFocus = 'none';
        _this.prevRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.nextRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.state = {
            currentIndex: 0
        };
        _this.prev = function (e) {
            e.preventDefault();
            _this.setState(function (state) {
                var newIndex = state.currentIndex - 1;
                if (newIndex < 0) {
                    return null;
                }
                if (newIndex === 0) {
                    _this.applyFocus = 'next';
                }
                return { currentIndex: newIndex };
            });
        };
        _this.next = function (e) {
            e.preventDefault();
            _this.setState(function (state) {
                var newIndex = state.currentIndex + 1;
                if (newIndex >= _this.props.cruiseTips.length) {
                    return null;
                }
                if (newIndex === _this.props.cruiseTips.length - 1) {
                    _this.applyFocus = 'prev';
                }
                return { currentIndex: newIndex };
            });
        };
        return _this;
    }
    CruiseTipsStack.prototype.render = function () {
        var cruiseTips = this.props.cruiseTips;
        var idx = this.state.currentIndex;
        var isFirst = idx === 0;
        var isLast = idx === cruiseTips.length - 1;
        var cruiseTip = cruiseTips[idx];
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-ctips-stk" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__cruise_tip__["a" /* CruiseTip */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, cruiseTip, { count: cruiseTips.length, tabIndex: 0 })),
            cruiseTips.length > 1 && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-ctips-stk__pager" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { ref: this.prevRef, role: "button", href: "", tabIndex: isFirst ? -1 : 0, className: __WEBPACK_IMPORTED_MODULE_4_classnames__('h-ctips-stk__pager-prev', { 'h-ctips-stk__pager-prev--disabled': isFirst }), onClick: this.prev, "aria-label": this.generateAriaLabel(this.props.previousAriaLabel, idx, cruiseTips.length) },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__chevron_chevron_circle__["a" /* ChevronCircle */], { direction: "left", size: 32 })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { ref: this.nextRef, role: "button", href: "", tabIndex: isLast ? -1 : 0, className: __WEBPACK_IMPORTED_MODULE_4_classnames__('h-ctips-stk__pager-next', { 'h-ctips-stk__pager-next--disabled': isLast }), onClick: this.next, "aria-label": this.generateAriaLabel(this.props.nextAriaLabel, idx, cruiseTips.length) },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__chevron_chevron_circle__["a" /* ChevronCircle */], { direction: "right", size: 32 })))));
    };
    CruiseTipsStack.prototype.generateAriaLabel = function (text, currentIndex, count) {
        return (text || '')
            .replace('{Current}', (currentIndex + 1).toString())
            .replace('{Total}', count.toString());
    };
    CruiseTipsStack.prototype.componentDidUpdate = function () {
        if (this.applyFocus === 'prev' && this.prevRef.current) {
            this.prevRef.current.focus();
        }
        else if (this.applyFocus === 'next' && this.nextRef.current) {
            this.nextRef.current.focus();
        }
        this.applyFocus = 'none';
    };
    return CruiseTipsStack;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=cruise-tips-stack.js.map

/***/ }),
/* 790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 791 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 792 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PrintDocumentsModalTrigger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__print_documents_modal__ = __webpack_require__(257);




var PrintDocumentsModalTrigger = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(PrintDocumentsModalTrigger, _super);
    function PrintDocumentsModalTrigger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PrintDocumentsModalTrigger.prototype.render = function () {
        var _a = this.props, isOpen = _a.isOpen, restProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["isOpen"]);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__modal_modal__["a" /* Modal */], { shell: false, isOpen: isOpen, fullScreen: false, onRequestClose: this.props.onRequestClose, dialogDescription: this.props.content.heading, className: "h-print-documents-modal-wrapper" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__print_documents_modal__["a" /* PrintDocumentsModal */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, restProps))));
    };
    return PrintDocumentsModalTrigger;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=print-documents-modal-trigger.js.map

/***/ }),
/* 794 */
/***/ (function(module, exports) {

//# sourceMappingURL=models.js.map

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FacebookCountdownShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__facebook_countdown_share_button_css__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__facebook_countdown_share_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__facebook_countdown_share_button_css__);




var FacebookCountdownShareButton = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(FacebookCountdownShareButton, _super);
    function FacebookCountdownShareButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.facebookFeedUrl = 'https://www.facebook.com/dialog/feed?app_id={facebookAppId}&display=popup&link=';
        return _this;
    }
    FacebookCountdownShareButton.prototype.render = function () {
        var _a = this.props, className = _a.className, windowLocationOrigin = _a.windowLocationOrigin, sailing = _a.sailing, bookedSharePage = _a.bookedSharePage, shareCountdownText = _a.shareCountdownText, socialNetworkIconUrl = _a.socialNetworkIconUrl, shareTitleFormat = _a.shareTitleFormat, buttonAriaLabelText = _a.buttonAriaLabelText, facebookAppId = _a.facebookAppId;
        var itinerary = sailing.itinerary;
        if (!itinerary || !itinerary.itineraryUrl || !shareCountdownText || itinerary.totalMinutesUntilSailing <= 0) {
            return null;
        }
        var itinUrl = this.buildItinerarySharePageUrl(sailing, shareTitleFormat, bookedSharePage, windowLocationOrigin || window.location.origin, facebookAppId);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-facebook-countdown-share__btn-container', className) },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { key: "facebook-countdown", className: "h-btn h-btn--block h-facebook-countdown-share__btn", role: "button", "aria-label": buttonAriaLabelText, target: "_blank", href: itinUrl },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", { className: "h-facebook-countdown-share__img", src: socialNetworkIconUrl, alt: "" }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "h-facebook-countdown-share__text" }, shareCountdownText))));
    };
    FacebookCountdownShareButton.prototype.buildItinerarySharePageUrl = function (sailing, shareTitleFormat, bookedSharePage, windowLocationOrigin, facebookAppId) {
        var itinerary = sailing.itinerary;
        var title = this.buildShareTitle(sailing, shareTitleFormat);
        var description = itinerary.itineraryTitle + " on " + itinerary.shipName;
        var itineraryUrl = itinerary.itineraryUrl;
        var pageWithParams = bookedSharePage
            .replace('{itineraryUrl}', itineraryUrl)
            .replace('{description}', description)
            .replace('{title}', title);
        var callbackPageWithParams = "" + windowLocationOrigin + pageWithParams;
        var facebookShareUrl = "" + this.facebookFeedUrl.replace('{facebookAppId}', facebookAppId) + encodeURIComponent(callbackPageWithParams);
        return facebookShareUrl;
    };
    FacebookCountdownShareButton.prototype.buildShareTitle = function (sailing, shareTitleFormat) {
        var totalMinutesLeft = sailing.itinerary.totalMinutesUntilSailing;
        var days = Math.floor(totalMinutesLeft / 24 / 60);
        var hours = Math.floor((totalMinutesLeft - (days * 24 * 60)) / 60);
        var minutes = totalMinutesLeft - (days * 24 * 60) - (hours * 60);
        var title = shareTitleFormat;
        title = this.buildTimeToken('days', days, title);
        title = this.buildTimeToken('hours', hours, title);
        title = this.buildTimeToken('minutes', minutes, title);
        return title;
    };
    FacebookCountdownShareButton.prototype.buildTimeToken = function (token, count, shareTitleFormat) {
        var replacementToken = count > 0 ? token : '';
        var replacementCount = count > 0 ? count.toString() : '';
        return shareTitleFormat.replace("{" + token + "}", replacementCount).replace("{#" + token + "}", replacementToken);
    };
    return FacebookCountdownShareButton;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

//# sourceMappingURL=facebook-countdown-share-button.js.map

/***/ }),
/* 796 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ReservationForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reservation_form_css__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reservation_form_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__reservation_form_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__notification_notification__ = __webpack_require__(64);





var NoUpdates = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(NoUpdates, _super);
    function NoUpdates() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoUpdates.prototype.render = function () {
        return this.props.children;
    };
    NoUpdates.prototype.shouldComponentUpdate = function () {
        return false;
    };
    return NoUpdates;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
var ReservationForm = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(ReservationForm, _super);
    function ReservationForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.el = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.onNotificationClosed = function () {
            if (!!_this.props.onNotificationClosed) {
                _this.props.onNotificationClosed();
            }
        };
        return _this;
    }
    ReservationForm.prototype.render = function () {
        var props = this.props;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('h-res-form', props.className), ref: this.el },
            this.renderResultNotification(props.submissionStatus),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "container" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", { src: props.content.bannerImage.src, "aria-hidden": "true", className: "h-res-form__banner" }))),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](NoUpdates, null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-lg-5", dangerouslySetInnerHTML: { __html: this.replaceFormPlaceholders(props.content) } }),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-lg-7", dangerouslySetInnerHTML: { __html: props.content.mainContent } })),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: { height: '16px' } }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col", dangerouslySetInnerHTML: { __html: props.content.footerContent } }))))));
    };
    ReservationForm.prototype.componentDidMount = function () {
        this.initializeForm();
    };
    ReservationForm.prototype.initializeForm = function () {
        var elements = this.el.current.querySelectorAll('.h-form__field');
        for (var i = 0; i < elements.length; i++) {
            var element = elements[i];
            this.initializeField(element);
        }
        this.initializeBookings();
        this.initializeSubmitButton();
    };
    ReservationForm.prototype.initializeBookings = function () {
        var content = this.props.content;
        var row = this.el.current.querySelector('#bookings-row');
        var bookingsCount = content.bookings.length;
        var selectParentElement = row.querySelector('.buy-mode__select');
        selectParentElement.style.display = bookingsCount > 1 ? '' : 'none';
        var selectElement = row.querySelector('select');
        selectElement.required = bookingsCount > 0;
        if (bookingsCount === 1) {
            selectElement.selectedIndex = 1;
            row.style.display = 'none';
        }
        var inputParentElement = row.querySelector('.browse-mode__input');
        if (inputParentElement) {
            var inputElement = inputParentElement.querySelector('input');
            inputElement.formNoValidate = bookingsCount > 0;
            inputElement.required = bookingsCount === 0;
            inputParentElement.style.display = bookingsCount === 0 ? '' : 'none';
        }
    };
    ReservationForm.prototype.initializeSubmitButton = function () {
        var _this = this;
        var form = this.el.current.querySelector('form');
        form.addEventListener('submit', function (e) {
            e.preventDefault();
            if (!form.checkValidity()) {
                var fields = form.querySelectorAll('input,select');
                // IE doesn't support nodelist.forEach(element => {})
                for (var i = 0; i < fields.length; i++) {
                    var field = fields[i];
                    if (field.offsetParent /* Not hidden */) {
                        // CustomEvent for IE. IE doesn't support an Event constructor
                        var changeEvent = new CustomEvent('change', { 'bubbles': true });
                        field.dispatchEvent(changeEvent);
                        var blurEvent = new CustomEvent('blur');
                        field.dispatchEvent(blurEvent);
                    }
                }
                var firstErr = form.querySelector('.h-form__field--invalid input,.h-form__field--invalid select');
                if (firstErr) {
                    firstErr.focus();
                }
                return;
            }
            var data = {};
            for (var i = 0; i < form.elements.length; i++) {
                var control = form.elements[i];
                if (control.tagName === 'INPUT' && control.offsetParent /* Not hidden */) {
                    data[control.name] = control.value;
                }
                else if (control.tagName === 'SELECT' && control.value) {
                    data[control.name] = control.value;
                }
            }
            _this.props.onSubmit(data);
        });
    };
    ReservationForm.prototype.initializeField = function (field) {
        var input = field.querySelector('input,select');
        var error = field.querySelector('.h-form__error');
        if (!input) {
            return;
        }
        input.addEventListener('change', function (e) {
            field.classList.remove('h-form__field--pristine');
            field.classList.add('h-form__field--dirty');
            // this is needed for CSS reasons
            input.setAttribute('value', input.value);
            input.removeAttribute('aria-describedby');
            var errors = [];
            if (input.required && !input.value) {
                errors.push('required');
                input.setAttribute('aria-describedby', error ? error.id : '');
            }
            if (input.pattern && input.value && !input.value.match(input.pattern)) {
                errors.push('pattern');
                input.setAttribute('aria-invalid', 'true');
                input.setAttribute('aria-describedby', error ? error.id : '');
            }
            else {
                input.setAttribute('aria-invalid', 'false');
            }
            if (errors.length) {
                field.classList.remove('h-form__field--valid');
                field.classList.add('h-form__field--invalid');
            }
            else {
                field.classList.remove('h-form__field--invalid');
                field.classList.add('h-form__field--valid');
            }
            if (input.tagName === 'SELECT') {
                if (input.value) {
                    input.classList.add('h-form__select--filled');
                }
                else {
                    input.classList.remove('h-form__select--filled');
                }
            }
            else if (input.tagName === 'INPUT' && input.name.toUpperCase().indexOf('BOOKING') > -1) {
                input.value = input.value.toUpperCase();
            }
            // tslint:disable-next-line:align
        }, false);
        input.addEventListener('blur', function (e) {
            field.classList.remove('h-form__field--untouched');
            field.classList.add('h-form__field--touched');
            // tslint:disable-next-line:align
        }, false);
    };
    ReservationForm.prototype.replaceFormPlaceholders = function (data) {
        return data.formContent
            .replace('{FirstName}', data.firstName || '')
            .replace('{LastName}', data.lastName || '')
            .replace('{Email}', data.email || '')
            .replace('{BookingsOptions}', data.bookings.map(function (n) { return "<option value=\"" + n.bookingNumber + "\">" + n.bookingNumber + "</option>"; }).join(''));
    };
    ReservationForm.prototype.renderResultNotification = function (status) {
        if (status === 'none') {
            return null;
        }
        var content = this.props.content;
        var message = status === 'error' ? content.errorMessage : content.successMessage;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { "aria-live": "assertive", role: "alert" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__notification_notification__["a" /* Notification */], { type: status === 'error' ? 'error' : 'success', mode: "edge", closeMode: "manual", closeAriaLabel: content.closeNotificationAriaLabel, onClose: this.onNotificationClosed }, message)));
    };
    return ReservationForm;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=reservation-form.js.map

/***/ }),
/* 798 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmailInvitation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__email_invitation_css__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__email_invitation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__email_invitation_css__);






function renderRequestStatus(status, content) {
    var cn = __WEBPACK_IMPORTED_MODULE_1_classnames__('h-email-invitation__status-text', { 'h-email-invitation__status-text--error': status === 'error' }, { 'h-email-invitation__status-text--success': status === 'success' });
    var statusMessage = '';
    if (status === 'error') {
        statusMessage = content.submissionError;
    }
    return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", null, statusMessage && __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: "row h-email-invitation__list-item" },
        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: "col" },
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: cn }, statusMessage)))));
}
var EmailInvitation = function (_a) {
    var email = _a.email, content = _a.content, status = _a.status, submitting = _a.submitting, sendingEmail = _a.sendingEmail, onChange = _a.onChange, onSendClick = _a.onSendClick;
    var emailSent = status === 'success';
    return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("h3", null, content.invitationTitle),
        __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: "row h-email-invitation" },
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: "col-md" },
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["c" /* FormField */], { controlModel: email, onFieldUpdate: onChange }, function (props) { return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"], null,
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["d" /* Input */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ minLength: 5 }, props.controlProps)),
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.labelProps), content.emailLabel),
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__forms__["b" /* Error */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.errorProps)))); })),
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: "col-md h-email-invitation__col-last" },
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__button_button__["a" /* Button */], { color: "red", type: "button", className: "h-email-" + status + " h-btn--min-width", onClick: onSendClick, "aria-label": content.buttonAriaLabel, disabled: submitting || emailSent, busy: submitting && sendingEmail }, emailSent ? content.invitationSent : content.buttonText))),
        renderRequestStatus(status, content)));
};
//# sourceMappingURL=email-invitation.js.map

/***/ }),
/* 800 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 801 */
/***/ (function(module, exports) {

//# sourceMappingURL=model.js.map

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TravelCompanionSection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__email_invitation_email_invitation_form__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__travel_companion_lists__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__travel_companion_section_heading__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__travel_companion_conflict_modal__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cclr_huge_ui__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__travel_companion_section_css__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__travel_companion_section_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__travel_companion_section_css__);








var TravelCompanionSection = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(TravelCompanionSection, _super);
    function TravelCompanionSection(props) {
        var _this = _super.call(this, props) || this;
        _this.handleEmailSendClick = function (emailTo) {
            _this.setState({ submitting: true });
            return _this.props.onEmailSend(emailTo)
                .then(function (_) { return _this.setState({ submitting: false }); })
                .catch(function (_) { return _this.setState({ submitting: false }); });
        };
        _this.handleLinkGuestsClick = function (mode) {
            _this.setState({ openModal: false, submitting: true, submissionResponse: null, errorMessage: null, linkingBookings: true });
            return _this.props.onLinkClick(mode)
                .then(function (response) {
                _this.setState({
                    submissionResponse: response,
                    openModal: response.canMergeGroup || response.canOnlyJoin,
                    submitting: false,
                    linkingBookings: false,
                });
            })
                .catch(_this.onSubmissionError);
        };
        _this.onSubmissionError = function (apiError) {
            var errorMessage;
            if (apiError.details && apiError.details.length > 0) {
                errorMessage = apiError.details.map(function (e) { return e.message; }).join('. ');
            }
            else {
                errorMessage = apiError.message || _this.props.content.genericErrorMessage;
            }
            _this.setState({
                status: 'error',
                submitting: false,
                linkingBookings: false,
                errorMessage: errorMessage,
            });
        };
        _this.getProfileBookingGuests = function () {
            var guests = [];
            _this.props.sailing.bookings.map(function (b) {
                b.guests.map(function (g) { return guests.push({ sequenceNumber: g.seqNumber, firstName: g.firstName, lastName: g.lastName, bookingNumber: b.bookingNumber }); });
            });
            return guests;
        };
        _this.toggleDetails = function (e) {
            e.preventDefault();
            _this.setState(function (prevState) {
                return {
                    isExpanded: !prevState.isExpanded,
                };
            });
        };
        _this.onModalClose = function () {
            _this.setState({ openModal: false });
        };
        _this.renderConflictModal = function () {
            var content = _this.props.content;
            var _a = _this.state, openModal = _a.openModal, submissionResponse = _a.submissionResponse, submitting = _a.submitting;
            var modalProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, _this.props), { canMergeGroups: submissionResponse === null || submissionResponse === void 0 ? void 0 : submissionResponse.canMergeGroup, submitting: submitting, openModal: openModal, bodyMessage: content.conflictModalBody.replace('{invitedBy}', (_this.props.guestFullName || (submissionResponse === null || submissionResponse === void 0 ? void 0 : submissionResponse.invitedBy))), onConflictSubmit: _this.handleLinkGuestsClick, onClose: _this.onModalClose });
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__travel_companion_conflict_modal__["a" /* TravelCompanionConflictModal */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, modalProps)));
        };
        _this.state = {
            openModal: false,
            status: 'default',
            submitting: false,
            linkingBookings: false,
            isExpanded: false,
        };
        return _this;
    }
    TravelCompanionSection.prototype.render = function () {
        var _a = this.props, content = _a.content, linkManagedBookingsEnabled = _a.linkManagedBookingsEnabled, otherCompanions = _a.otherCompanions, showEmailLink = _a.showEmailLink;
        var _b = this.state, submissionResponse = _b.submissionResponse, submitting = _b.submitting, errorMessage = _b.errorMessage, linkingBookings = _b.linkingBookings, isExpanded = _b.isExpanded;
        var cn = isExpanded ? '' : 'h-bk-tc-card--collapsed';
        var id = 'h-bk-tc-card';
        if (!content) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: cn },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bk-tc-header" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__travel_companion_section_heading__["a" /* TravelCompanionHeading */], { heading: content.headerText })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bk-tc-card__main" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bk-tc-managed-card" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__travel_companion_lists__["a" /* TravelCompanionLists */], { content: content, guests: this.getProfileBookingGuests(), otherCompanions: otherCompanions, linkManagedBookingsEnabled: linkManagedBookingsEnabled, onLinkClick: this.handleLinkGuestsClick, onRemoveLinkClick: this.props.onRemoveLinkClick, errorMessage: errorMessage || (submissionResponse === null || submissionResponse === void 0 ? void 0 : submissionResponse.errorMessage), submitting: submitting, linkingBookings: linkingBookings })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "d-md-none h-bk-tc-card__toggle-details-row no-gutters" }, this.renderToggleDetails(id, content, isExpanded))),
            showEmailLink &&
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bk-tc-email-card" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__email_invitation_email_invitation_form__["a" /* EmailInvitationForm */], { onSubmit: this.handleEmailSendClick, content: content, submitting: submitting })),
            ((submissionResponse === null || submissionResponse === void 0 ? void 0 : submissionResponse.canMergeGroup) || (submissionResponse === null || submissionResponse === void 0 ? void 0 : submissionResponse.canOnlyJoin)) && this.renderConflictModal()));
    };
    TravelCompanionSection.prototype.renderToggleDetails = function (id, content, isExpanded) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "#", className: "h-bk-tc-card__action-link h-bk-tc-card__toggle-link", onClick: this.toggleDetails, role: "button", "aria-expanded": isExpanded ? 'true' : 'false', "aria-controls": id }, content.headerText)),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "#", className: "h-bk-tc-card__toggle-details-icon", onClick: this.toggleDetails, role: "button", "aria-expanded": isExpanded ? 'true' : 'false', "aria-controls": id, "aria-label": content.headerText },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__cclr_huge_ui__["ChevronCircle"], { direction: isExpanded ? 'up' : 'down', size: 44, shadowMode: "simple" })))));
    };
    return TravelCompanionSection;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=travel-companion-section.js.map

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GuestListRow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatar_avatar__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__guest_list_row_css__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__guest_list_row_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__guest_list_row_css__);




function getGuestName(guest, guestNameSub, index, showOnlyLastNameInitial) {
    if (guest.firstName === 'TBA') {
        return guestNameSub + " " + (index + 1);
    }
    var fullName = guest.firstName + " " + (showOnlyLastNameInitial ? guest.lastName.slice(0, 1) + '.' : guest.lastName);
    return fullName;
}
var GuestListRow = function (_a) {
    var className = _a.className, guests = _a.guests, guestNameSub = _a.guestNameSub, showOnlyLastNameInitial = _a.showOnlyLastNameInitial;
    if (!guests) {
        return null;
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row h-guest-list__row" }, guests.map(function (g, i) {
        var guestFullName = getGuestName(g, guestNameSub, i, showOnlyLastNameInitial);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: i, className: __WEBPACK_IMPORTED_MODULE_1_classnames__('col-lg-3', className) },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "d-flex h-guest-list__row-info" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__avatar_avatar__["a" /* Avatar */], { fullName: guestFullName, "aria-hidden": "true" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-guest-list-name__container" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { "data-pii": "true", className: "h-guest-list-guest__name" }, guestFullName)))));
    })));
};
//# sourceMappingURL=guest-list-row.js.map

/***/ }),
/* 804 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkManagedBookingsCard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__button_button__ = __webpack_require__(5);


var LinkManagedBookingsCard = function (_a) {
    var submitting = _a.submitting, errorMessage = _a.errorMessage, imgUrl = _a.imgUrl, title = _a.title, description = _a.description, buttonText = _a.buttonText, buttonAriaLabel = _a.buttonAriaLabel, linkingBookings = _a.linkingBookings, onLinkClick = _a.onLinkClick;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row h-tc-managed-guest-link--container" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "h-tc-managed-guest-link__title" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "h-tc-managed-guest-link__title-icon" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: imgUrl, alt: "" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "h-tc-managed-guest-link__title-text" }, title)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-tc-managed-guest-link__description", dangerouslySetInnerHTML: { __html: description } })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-tc-managed-guest-link__button" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__button_button__["a" /* Button */], { color: "red", type: "button", className: "h-btn--min-width", onClick: onLinkClick, "aria-label": buttonAriaLabel, disabled: submitting, busy: submitting && linkingBookings }, buttonText),
                errorMessage && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row h-tc-managed-guest-link__error" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col", dangerouslySetInnerHTML: { __html: errorMessage } })))))));
};
//# sourceMappingURL=link-managed-bookings-card.js.map

/***/ }),
/* 806 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TravelCompanionHeading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__travel_companion_section_heading_css__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__travel_companion_section_heading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__travel_companion_section_heading_css__);


var TravelCompanionHeading = function (_a) {
    var heading = _a.heading;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-bk-tc-heading" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h-bk-tc-heading__title" }, heading)));
};
//# sourceMappingURL=travel-companion-section-heading.js.map

/***/ }),
/* 808 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 809 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 810 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TravelCompanionForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms_index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__travel_companion_landing__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__travel_companion_confirmation_result__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__travel_companion_conflict_modal__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__travel_companion_form_css__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__travel_companion_form_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__travel_companion_form_css__);








var TravelCompanionForm = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(TravelCompanionForm, _super);
    function TravelCompanionForm(props) {
        var _this = _super.call(this, props) || this;
        _this.submitRequest = function (actionMode) {
            if (_this.state.controlGroup.valid) {
                _this.setState({ openModal: false, submissionResponse: null, submitting: true, errorMessage: null, status: 'default' });
                var request = Object(__WEBPACK_IMPORTED_MODULE_2__forms_index__["o" /* values */])(_this.state.controlGroup);
                request.mode = actionMode;
                return _this.props
                    .onSubmit(request)
                    .then(function (response) {
                    _this.setState({
                        submissionResponse: response,
                        status: response.success || response.alreadyInGroup || !!response.errorMessage ? 'withResult' : 'default',
                        openModal: response.canMergeGroup || response.canOnlyJoin,
                        submitting: false,
                    });
                })
                    .catch(_this.onSubmissionError);
            }
            else {
                return Promise.reject();
            }
        };
        _this.onSubmissionError = function (apiError) {
            var errorMessage;
            if (apiError.details && apiError.details.length > 0) {
                errorMessage = apiError.details.map(function (e) { return e.message; }).join('. ');
            }
            else {
                errorMessage = apiError.message || _this.props.content.fallbackErrorMessage;
            }
            _this.setState({
                status: 'error',
                submitting: false,
                errorMessage: errorMessage,
            });
        };
        _this.onSubmit = function (e) {
            e.preventDefault();
            _this.submitRequest('default');
        };
        _this.onControlChange = function (control) {
            _this.setState(function (prevState) {
                var updatedNewControlGroup = Object(__WEBPACK_IMPORTED_MODULE_2__forms_index__["m" /* replaceControlModel */])(prevState.controlGroup, control);
                return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, prevState), { controlGroup: updatedNewControlGroup });
            });
        };
        _this.createControlGroup = function () {
            var content = _this.props.content;
            var controlGroup = Object(__WEBPACK_IMPORTED_MODULE_2__forms_index__["h" /* createControlGroup */])(Object(__WEBPACK_IMPORTED_MODULE_2__forms_index__["i" /* createControlModel */])({
                name: 'lastName',
                value: '',
                validators: {
                    required: true,
                    pattern: content.lastNameRegex,
                },
                errorMessages: {
                    required: content.lastNameRequired,
                    pattern: content.invalidLastName,
                },
            }), Object(__WEBPACK_IMPORTED_MODULE_2__forms_index__["i" /* createControlModel */])({
                name: 'companionBookingNumber',
                value: '',
                validators: {
                    required: true,
                    pattern: content.bookingNumberRegex,
                },
                errorMessages: {
                    required: content.bookingNumberRequired,
                    pattern: content.invalidBookingNumber,
                },
            }));
            return {
                controlGroup: controlGroup,
            };
        };
        _this.getResultMessage = function (status, props) {
            var _a = _this.state, submissionResponse = _a.submissionResponse, errorMessage = _a.errorMessage;
            if (status === 'error') {
                return errorMessage;
            }
            else if (submissionResponse === null || submissionResponse === void 0 ? void 0 : submissionResponse.alreadyInGroup) {
                return Object(__WEBPACK_IMPORTED_MODULE_5__common__["b" /* replacePlaceHolders */])(props.content.alreadyCompanionBody, props);
            }
            else if (submissionResponse === null || submissionResponse === void 0 ? void 0 : submissionResponse.success) {
                return Object(__WEBPACK_IMPORTED_MODULE_5__common__["b" /* replacePlaceHolders */])(props.content.confirmationBody, props);
            }
            return '';
        };
        _this.onModalClose = function () {
            _this.setState({ openModal: false });
        };
        _this.renderConflictModal = function () {
            var _a = _this.state, openModal = _a.openModal, submissionResponse = _a.submissionResponse, submitting = _a.submitting;
            var modalProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, _this.props), { canMergeGroups: submissionResponse === null || submissionResponse === void 0 ? void 0 : submissionResponse.canMergeGroup, submitting: submitting, openModal: openModal, bodyMessage: Object(__WEBPACK_IMPORTED_MODULE_5__common__["b" /* replacePlaceHolders */])(_this.props.content.conflictModalBody, _this.props), onConflictSubmit: _this.submitRequest, onClose: _this.onModalClose });
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__travel_companion_conflict_modal__["a" /* TravelCompanionConflictModal */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, modalProps)));
        };
        _this.renderLandingPage = function () {
            var _a = _this.state, controlGroup = _a.controlGroup, submitting = _a.submitting;
            var landingPageProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ onControlChange: _this.onControlChange, onSubmitRequest: _this.onSubmit, controlGroup: controlGroup, submitting: submitting }, _this.props);
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__travel_companion_landing__["a" /* TravelCompanionLanding */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, landingPageProps)));
        };
        _this.state = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ status: props.status || 'default', openModal: false, errorMessage: props.message, submitting: false }, _this.createControlGroup());
        return _this;
    }
    TravelCompanionForm.prototype.render = function () {
        var _a = this.state, submissionResponse = _a.submissionResponse, status = _a.status, submitting = _a.submitting;
        var resultStatus = status;
        var message = this.getResultMessage(status, this.props);
        var displayModal = (submissionResponse === null || submissionResponse === void 0 ? void 0 : submissionResponse.canMergeGroup) || (submissionResponse === null || submissionResponse === void 0 ? void 0 : submissionResponse.canOnlyJoin);
        var displayLanding = status === 'default' || displayModal;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "container h-tc-container" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col" },
                    displayLanding && this.renderLandingPage(),
                    displayModal && this.renderConflictModal(),
                    !submitting && (status === 'withResult' || status === 'error') &&
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__travel_companion_confirmation_result__["a" /* TravelComponentConfirmationResult */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.props, { message: message, status: resultStatus, showConfetti: !!(submissionResponse === null || submissionResponse === void 0 ? void 0 : submissionResponse.success) }))))));
    };
    return TravelCompanionForm;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=travel-companion-form.js.map

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TravelCompanionLanding; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(119);





var TravelCompanionLanding = function (_a) {
    var content = _a.content, controlGroup = _a.controlGroup, submitting = _a.submitting, onControlChange = _a.onControlChange, onSubmitRequest = _a.onSubmitRequest, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["content", "controlGroup", "submitting", "onControlChange", "onSubmitRequest"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bk-tc-landing" },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-landing-icon--container" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row h-row h-landing-icon" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-md" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", { src: content.icon.src, alt: "" })))),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row h-row h-bk-tc-landing-heading" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h1", { className: "h-bk-tc-landing-heading__title" }, content.defaultTitle)),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row h-row h-bk-tc-landing__body" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-lg" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { "data-pii": "true", dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_4__common__["b" /* replacePlaceHolders */])(content.textBody, otherProps) } }))),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row h-row" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-md" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__forms__["c" /* FormField */], { controlModel: controlGroup.controls.get.companionBookingNumber, onFieldUpdate: onControlChange, forceUpperCaseText: true }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__forms__["d" /* Input */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ maxLength: 6 }, props.controlProps)),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.labelProps), content.bookingNumberLabel),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__forms__["b" /* Error */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.errorProps)))); })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-md" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__forms__["c" /* FormField */], { controlModel: controlGroup.controls.get.lastName, onFieldUpdate: onControlChange, forceUpperCaseText: true }, function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__forms__["d" /* Input */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ maxLength: 15 }, props.controlProps)),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__forms__["e" /* Label */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.labelProps), content.lastNameLabel),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__forms__["b" /* Error */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.errorProps)))); }))),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row h-row h-bk-tc-landing__last" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-md" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__button_button__["a" /* Button */], { color: "red", type: "button", className: "h-btn--min-width", onClick: onSubmitRequest, "aria-label": content.acceptInvitationButtonTextAriaLabel, disabled: submitting, busy: submitting }, content.acceptInvitationButtonText)))));
};
//# sourceMappingURL=travel-companion-landing.js.map

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TravelComponentConfirmationResult; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_button__ = __webpack_require__(5);



function replaceSailingPlaceHolders(text, props) {
    var shipCode = props.shipCode, sailDateYyyyMmDd = props.sailDateYyyyMmDd;
    return text.replace('{shipCode}', shipCode)
        .replace('{sailDate}', sailDateYyyyMmDd);
}
var TravelComponentConfirmationResult = function (_a) {
    var content = _a.content, message = _a.message, status = _a.status, alreadyInGroup = _a.alreadyInGroup, showConfetti = _a.showConfetti, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["content", "message", "status", "alreadyInGroup", "showConfetti"]);
    var title = content.confirmationTitle;
    if (alreadyInGroup) {
        title = content.alreadyCompanionTitle;
    }
    else if (status === 'error') {
        title = content.errorTitle;
    }
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
        showConfetti && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bk-tc-result-success" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", { src: content.confettiImage.src, alt: "" })),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-bk-tc-result" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row h-row h-bk-tc-result-heading" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h1", { className: "h-bk-tc-result-heading__title" }, title)),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row h-row h-bk-tc-result__body" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-lg", dangerouslySetInnerHTML: { __html: message } })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row h-row h-tc-cta-group" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-md h-tc-cta-group__first" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__button_button__["b" /* LinkButton */], { href: replaceSailingPlaceHolders(content.manageBookingUrl, otherProps), color: "red", className: "h-btn--min-width", "aria-label": content.manageBookingButtonTextAriaLabel, dangerouslySetInnerHTML: { __html: content.manageBookingButtonText } })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-md h-tc-cta-group__last" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__button_button__["b" /* LinkButton */], { href: replaceSailingPlaceHolders(content.plannerUrl, otherProps), color: "outline-black", className: "h-btn--min-width", "aria-label": content.viewPlannerButtonTextAriaLabel, dangerouslySetInnerHTML: { __html: content.viewPlannerButtonText } }))))));
};
//# sourceMappingURL=travel-companion-confirmation-result.js.map

/***/ }),
/* 814 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 815 */
/***/ (function(module, exports) {

//# sourceMappingURL=model.js.map

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GenericHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__generic_header_css__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__generic_header_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__generic_header_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cclr_huge_ui__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__one_col_grid__ = __webpack_require__(818);




var GenericHeader = function (_a) {
    var children = _a.children, headerLogoAriaLabel = _a.headerLogoAriaLabel, headerClose = _a.headerClose;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("header", { className: "h-anon-header" },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__one_col_grid__["a" /* OneColumnGrid */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-anon-header__wrapper d-flex justify-content-between align-items-center" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "/booked/home" + window.location.search, "aria-label": headerLogoAriaLabel },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", { className: "h-anon-header__logo", src: "/~/media/images/header2013/carnival-logo png.png", alt: "" }))),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "/booked/home" + window.location.search, "aria-label": headerClose },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__cclr_huge_ui__["CloseIcon"], { className: "h-anon-header__close-icon", width: 24, height: 24, color: __WEBPACK_IMPORTED_MODULE_2__cclr_huge_ui__["BlackColor"] }))))),
        children && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-anon-header__itin" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__one_col_grid__["a" /* OneColumnGrid */], null, children))));
};
//# sourceMappingURL=generic-header.js.map

/***/ }),
/* 817 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OneColumnGrid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var OneColumnGrid = function (_a) {
    var children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md" }, children))));
};
//# sourceMappingURL=one-col-grid.js.map

/***/ }),
/* 819 */
/***/ (function(module, exports) {

//# sourceMappingURL=model.js.map

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TravelCompanionRemoveConfirmModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal_modal_shell__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common__ = __webpack_require__(119);






var TravelCompanionRemoveConfirmModal = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(TravelCompanionRemoveConfirmModal, _super);
    function TravelCompanionRemoveConfirmModal(props) {
        var _this = _super.call(this, props) || this;
        _this.renderFooter = function (content) {
            if (content == null) {
                return null;
            }
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "col-sm-6 col-md-12 col-lg-auto h-bk-dtl-card__footer-actions" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__button_button__["a" /* Button */], { className: "h-bk-dtl-card__footer-action", color: "outline-black", onClick: _this.onCancelClick, "aria-label": content.cancelModalAriaLabel }, content.cancelButton),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__button_button__["a" /* Button */], { className: "h-bk-dtl-card__footer-action", color: "red", onClick: _this.onConfirmClick, "aria-label": content.confirmTextAriaLabel }, content.confirmText))));
        };
        _this.onCancelClick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            var onCancel = _this.props.onCancel;
            onCancel();
        };
        _this.onConfirmClick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            var onConfirm = _this.props.onConfirm;
            onConfirm();
        };
        _this.closeButtonRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        return _this;
    }
    TravelCompanionRemoveConfirmModal.prototype.render = function () {
        var _a = this.props, guests = _a.guests, onCancel = _a.onCancel, isOpen = _a.isOpen, content = _a.content;
        var guestsNames = Object(__WEBPACK_IMPORTED_MODULE_5__common__["a" /* listGuests */])(guests, content.confirmModalDescription);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__modal_modal__["a" /* Modal */], { isOpen: isOpen, shell: true, fullScreen: false, header: this.renderHeader(content), dialogDescription: guestsNames, closeButtonRef: this.closeButtonRef, onRequestClose: onCancel, footer: this.renderFooter(content) },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row" }, guestsNames)));
    };
    TravelCompanionRemoveConfirmModal.prototype.renderHeader = function (content) {
        if (content == null) {
            return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h2", { className: __WEBPACK_IMPORTED_MODULE_4__modal_modal_shell__["a" /* ModalHeadingClassName */] }, content.confirmModalHeader);
    };
    return TravelCompanionRemoveConfirmModal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=travel-companion-remove-confirm-modal.js.map

/***/ }),
/* 821 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 822 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TravelCompanionRemoveModalTrigger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__travel_companion_remove_card__ = __webpack_require__(261);




var TravelCompanionRemoveModalTrigger = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(TravelCompanionRemoveModalTrigger, _super);
    function TravelCompanionRemoveModalTrigger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TravelCompanionRemoveModalTrigger.prototype.render = function () {
        var _a = this.props, isOpen = _a.isOpen, restProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["isOpen"]);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__modal_modal__["a" /* Modal */], { shell: false, isOpen: isOpen, fullScreen: true, onRequestClose: restProps.onCancelRemove, dialogDescription: restProps.content.removeAdditionalCompanionsLink },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__travel_companion_remove_card__["a" /* TravelCompanionRemoveCard */], { companions: restProps.companions, content: restProps.content, onRemoveCompanions: restProps.onRemoveCompanions, onCancelRemove: restProps.onCancelRemove })));
    };
    return TravelCompanionRemoveModalTrigger;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=travel-companion-remove-modal-trigger.js.map

/***/ }),
/* 824 */
/***/ (function(module, exports) {

//# sourceMappingURL=model.js.map

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EditBookingModalTrigger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__edit_booking__ = __webpack_require__(262);




var EditBookingModalTrigger = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(EditBookingModalTrigger, _super);
    function EditBookingModalTrigger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditBookingModalTrigger.prototype.render = function () {
        var _a = this.props, isOpen = _a.isOpen, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["isOpen"]);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__modal_modal__["a" /* Modal */], { shell: false, isOpen: isOpen, fullScreen: true, onRequestClose: this.props.onClose, dialogDescription: this.props.content.modalTitle },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__edit_booking__["a" /* EditBooking */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, otherProps))));
    };
    return EditBookingModalTrigger;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=edit-booking-modal-trigger.js.map

/***/ }),
/* 826 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 827 */
/***/ (function(module, exports) {

//# sourceMappingURL=models.js.map

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ViewCancellationInfoModalTrigger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_cancellation_info_modal__ = __webpack_require__(264);




var ViewCancellationInfoModalTrigger = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(ViewCancellationInfoModalTrigger, _super);
    function ViewCancellationInfoModalTrigger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ViewCancellationInfoModalTrigger.prototype.render = function () {
        var _a = this.props, isOpen = _a.isOpen, otherProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["isOpen"]);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__modal_modal__["a" /* Modal */], { shell: false, isOpen: isOpen, fullScreen: false, onRequestClose: this.props.onAbort, dialogDescription: this.props.content.cancelThisBooking, className: "h-compact-cancel-modal-shell", shouldCloseOnOverlayClick: false },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__view_cancellation_info_modal__["a" /* ViewCancellationInfoModal */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, otherProps))));
    };
    return ViewCancellationInfoModalTrigger;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=view-cancellation-info-modal-trigger.js.map

/***/ }),
/* 829 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 830 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GuestActionConfirmationModalTrigger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__guest_action_confirmation__ = __webpack_require__(265);




var GuestActionConfirmationModalTrigger = function (props) {
    var _a;
    var isOpen = props.isOpen, restProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(props, ["isOpen"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__modal_modal__["a" /* Modal */], { shell: false, isOpen: isOpen, fullScreen: true, onRequestClose: props.onClose, dialogDescription: ((_a = props.content) === null || _a === void 0 ? void 0 : _a.modalHeaderText) || '' }, __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__guest_action_confirmation__["a" /* GuestActionConfirmation */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, restProps))));
};
//# sourceMappingURL=guest-action-confirmation-modal-trigger.js.map

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RemoveGuestModalTrigger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__remove_guest_details__ = __webpack_require__(833);




var RemoveGuestModalTrigger = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(RemoveGuestModalTrigger, _super);
    function RemoveGuestModalTrigger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RemoveGuestModalTrigger.prototype.render = function () {
        var _a = this.props, isOpen = _a.isOpen, restProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["isOpen"]);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__modal_modal__["a" /* Modal */], { shell: false, isOpen: isOpen, fullScreen: true, onRequestClose: this.props.onCancel, dialogDescription: this.props.content.removeHeaderAriaLabel },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__remove_guest_details__["a" /* RemoveGuestDetails */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, restProps))));
    };
    return RemoveGuestModalTrigger;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=remove-guest-modal-trigger.js.map

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RemoveGuestDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_tabs__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modal_modal_shell__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__stateroom_tabs_stateroom_tabs__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__remove_guest_consent_modal_trigger__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__remove_guest_item__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__remove_guest_details_css__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__remove_guest_details_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__remove_guest_details_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__notification_notifications_group__ = __webpack_require__(49);











var RemoveGuestDetails = function (_a) {
    var sailing = _a.sailing, content = _a.content, bookingNumber = _a.bookingNumber, onRemoveGuests = _a.onRemoveGuests, onCancel = _a.onCancel, fetchPenalty = _a.fetchPenalty;
    var _b = __WEBPACK_IMPORTED_MODULE_1_react__["useState"]([]), controls = _b[0], setControls = _b[1];
    var _c = __WEBPACK_IMPORTED_MODULE_1_react__["useState"](false), isOpenConfirmationModal = _c[0], setIsOpenConfirmationModal = _c[1];
    var _d = __WEBPACK_IMPORTED_MODULE_1_react__["useState"](null), notifications = _d[0], setNotifications = _d[1];
    var _e = __WEBPACK_IMPORTED_MODULE_1_react__["useState"](false), submitting = _e[0], setSubmitting = _e[1];
    var closeButtonRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
    var booking = sailing.bookings.find(function (b) { return b.bookingNumber === bookingNumber; });
    __WEBPACK_IMPORTED_MODULE_1_react__["useEffect"](function () {
        setControls(createRemoveGuestControls());
    }, [bookingNumber]);
    var createRemoveGuestControls = function () {
        var requestControls = booking.guests.map(function (g, _) {
            var guestFullName = g.firstName === 'TBA'
                ? content.guestNameWhenTba + " " + g.lastName
                : g.firstName + " " + g.lastName;
            var controlGroup = Object(__WEBPACK_IMPORTED_MODULE_4__forms__["h" /* createControlGroup */])(Object(__WEBPACK_IMPORTED_MODULE_4__forms__["i" /* createControlModel */])({
                name: 'seqNumber',
                id: "seqNumber_" + g.seqNumber,
                value: "" + g.seqNumber,
            }));
            return {
                controlGroup: controlGroup,
                seqNumber: g.seqNumber,
                disabled: false,
                guestName: guestFullName,
                bookingNumber: bookingNumber
            };
        });
        return requestControls;
    };
    var disableUncheckedControls = function (guestControls) {
        var result = guestControls.map(function (control) {
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, control), { disabled: !isChecked(control) });
        });
        return result;
    };
    var isChecked = function (guestItemControl) { return guestItemControl.controlGroup.controls.get.seqNumber.checked === true; };
    var enableControls = function (guestControls) {
        var result = guestControls.map(function (control) {
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, control), { disabled: false });
        });
        return result;
    };
    var handleRemoveGuests = function (requests) {
        setSubmitting(true);
        setIsOpenConfirmationModal(false);
        var apiRequests = requests.map(function (r) { return ({ bookingNumber: r.bookingNumber, seqNumber: r.seqNumber, guestName: r.guestName }); });
        onRemoveGuests(apiRequests).then(onGuestsRemovalSuccess).catch(onGuestRemovalError);
    };
    var onGuestsRemovalSuccess = function (response) {
        if (!response) {
            return;
        }
        var advisories = response.advisories || [];
        setNotifications(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spreadArrays */])([{
                type: 'success',
                message: content.successSubmittingMessage
            }], advisories.map(function (n) { return ({
            type: 'info',
            message: n.message
        }); })));
        setSubmitting(false);
        setFocus(closeButtonRef.current);
    };
    var onGuestRemovalError = function (apiError) {
        var errorNotifications;
        if (apiError.details && apiError.details.length > 0) {
            errorNotifications = apiError.details.map(function (n) { return ({
                type: 'error',
                message: n.message,
            }); });
        }
        else {
            errorNotifications = [{ type: 'error', message: apiError.message || content.errorSubmittingMessage }];
        }
        setNotifications(errorNotifications);
        setSubmitting(false);
        setFocus(closeButtonRef.current);
    };
    var handleControlChanged = function (itemControl, controlModel) {
        var controlItems = controls.map(function (control) {
            if (control.seqNumber !== itemControl.seqNumber) {
                return control;
            }
            var newControlGroup = Object(__WEBPACK_IMPORTED_MODULE_4__forms__["m" /* replaceControlModel */])(control.controlGroup, controlModel);
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, control), { controlGroup: newControlGroup });
        });
        if (controlModel.checked) {
            var checkedItemsCount = controlItems.filter(function (control) { return isChecked(control); }).length;
            if (booking.guests.length - checkedItemsCount === 1) {
                controlItems = disableUncheckedControls(controlItems);
            }
        }
        else {
            if (controlItems.some(function (control) { return control.disabled; })) {
                controlItems = enableControls(controlItems);
            }
        }
        setControls(controlItems);
    };
    var handleOpenConfirmationModal = function (e) {
        e.preventDefault();
        var requests = controls.filter(function (c) { return isChecked(c); });
        if (requests.length === 0) {
            return;
        }
        setIsOpenConfirmationModal(true);
    };
    var handleClosingConfirmationModal = function () { return setIsOpenConfirmationModal(false); };
    function renderGuests() {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "container h-remove-guest-list__container" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-remove-guest-details" }, content.removeBodyText),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-remove-guest-details-list" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row h-remove-guest-details-list__header" }, content.selectGuestsText),
                controls.map(function (g) { return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "row", key: g.seqNumber },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__remove_guest_item__["a" /* RemoveGuestItem */], { itineraryName: sailing.itinerary.itineraryTitle, content: content, guestControl: g, submitting: submitting, onSelectGuestChanged: handleControlChanged })); }))));
    }
    function renderBody() {
        var tabTitle = [{
                id: booking.bookingNumber,
                eyebrow: content.booking + " " + booking.bookingNumber,
                title: content.stateroom + " 1"
            }];
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__stateroom_tabs_stateroom_tabs__["d" /* StateroomTabs */], { tabTitles: tabTitle, selectedId: bookingNumber, onSelect: function () { return; } },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_tabs__["c" /* TabPanel */], { key: booking.bookingNumber, className: __WEBPACK_IMPORTED_MODULE_6__stateroom_tabs_stateroom_tabs__["b" /* StateroomTabPanelClassName */], selectedClassName: __WEBPACK_IMPORTED_MODULE_6__stateroom_tabs_stateroom_tabs__["c" /* StateroomTabPanelSelectedClassName */], disabled: submitting }, renderGuests())));
    }
    var handleCancel = function () { return onCancel; };
    function renderFooter() {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-remove-guest-details-modal__buttons" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-remove-guest-details-modal__button" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__button_button__["a" /* Button */], { color: "outline-black", type: "button", className: "h-btn--min-width", onClick: handleCancel, "aria-label": content.cancelButtonAriaLabel, disabled: submitting, busy: submitting }, content.cancelButtonText)),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "h-remove-guest-details-modal__button" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__button_button__["a" /* Button */], { color: "red", type: "button", className: "h-btn--min-width", onClick: handleOpenConfirmationModal, "aria-label": content.removeGuestSubmitAriaLabel, disabled: submitting, busy: submitting }, content.removeGuestSubmitText))));
    }
    function renderHeader() {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null, content && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h2", { className: __WEBPACK_IMPORTED_MODULE_5__modal_modal_shell__["a" /* ModalHeadingClassName */] }, content.removeHeaderLabel)));
    }
    function renderConfirmation() {
        var guestRequests = controls.filter(function (c) { return isChecked(c); });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__remove_guest_consent_modal_trigger__["a" /* RemoveGuestConsentModalTrigger */], { isOpen: isOpenConfirmationModal, itineraryName: sailing.itinerary.itineraryTitle, content: content, submitting: submitting, guestRequests: guestRequests, onRemoveGuests: handleRemoveGuests, onCancel: handleClosingConfirmationModal, fetchPenalty: fetchPenalty }));
    }
    var handleOnCloseNotificationGroup = function (type) {
        return setNotifications((notifications === null || notifications === void 0 ? void 0 : notifications.filter(function (n) { return n.type !== type; })) || null);
    };
    function renderNotifications() {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__notification_notifications_group__["a" /* NotificationsGroup */], { notifications: notifications, closeAriaLabel: content.closeNotificationAriaLabel, autoCloseAriaLabel: content.autoCloseNotificationAriaLabel, onCloseGroup: handleOnCloseNotificationGroup }));
    }
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__modal_modal_shell__["b" /* ModalShell */], { header: renderHeader(), footer: renderFooter(), onRequestClose: onCancel, closeModalText: content === null || content === void 0 ? void 0 : content.cancelButtonAriaLabel, closeButtonRef: closeButtonRef, shellClassName: "h-remove-guest-details-modal", notification: renderNotifications(), disableClose: submitting },
        renderBody(),
        renderConfirmation()));
    function setFocus(element) {
        if (element) {
            element.focus();
        }
    }
};
//# sourceMappingURL=remove-guest-details.js.map

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RemoveGuestConsentModalTrigger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__remove_guest_consent__ = __webpack_require__(835);




var RemoveGuestConsentModalTrigger = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(RemoveGuestConsentModalTrigger, _super);
    function RemoveGuestConsentModalTrigger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RemoveGuestConsentModalTrigger.prototype.render = function () {
        var _a = this.props, isOpen = _a.isOpen, restProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["isOpen"]);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__modal_modal__["a" /* Modal */], { shell: false, isOpen: isOpen, dialogDescription: this.props.content.removeHeaderLabel },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__remove_guest_consent__["a" /* RemoveGuestConsent */], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, restProps))));
    };
    return RemoveGuestConsentModalTrigger;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=remove-guest-consent-modal-trigger.js.map

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RemoveGuestConsent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cclr_huge_ui__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_button__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__remove_guest_consent_css__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__remove_guest_consent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__remove_guest_consent_css__);




var RemoveGuestConsent = function (_a) {
    var content = _a.content, itineraryName = _a.itineraryName, submitting = _a.submitting, guestRequests = _a.guestRequests, onRemoveGuests = _a.onRemoveGuests, onCancel = _a.onCancel, fetchPenalty = _a.fetchPenalty;
    var _b = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](null), penalty = _b[0], setPenalty = _b[1];
    var _c = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), errorFetchingPenalty = _c[0], setErrorFetchingPenalty = _c[1];
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        fetchPenalty(guestRequests[0].bookingNumber, guestRequests.map(function (g) { return g.seqNumber; }))
            .then(function (r) { return setPenalty(r); })
            .catch(function () { return setErrorFetchingPenalty(true); });
    }, guestRequests);
    function replaceNames(bodyText) {
        return bodyText.replace('{sailing}', itineraryName);
    }
    var removeGuestsConfirmed = function (e) {
        onRemoveGuests(guestRequests);
    };
    function renderHeader() {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, content && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: __WEBPACK_IMPORTED_MODULE_1__cclr_huge_ui__["ModalHeadingClassName"] }, content.removeHeaderLabel)));
    }
    function renderBody() {
        if (!penalty && !errorFetchingPenalty) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-remove-guest-conf__busy-container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__cclr_huge_ui__["SpinnerIcon"], { color: __WEBPACK_IMPORTED_MODULE_1__cclr_huge_ui__["BlueColor"], width: 32, height: 32 })));
        }
        if (errorFetchingPenalty) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-remove-guest-conf__body" }, content.confirmationModalErrorFetchingPenalty));
        }
        var message = penalty
            ? "" + replaceNames(content.penaltyAmountMessage) + penalty.penaltyAmountFormatted
            : replaceNames(content.confirmationModalText);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-remove-guest-conf__body" },
            message,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-remove-guest-conf-guests-list" }, guestRequests.map(function (guest) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { key: guest.seqNumber },
                "- ",
                guest.guestName); }))));
    }
    function renderFooter() {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h-cancel-booking__actions" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__button_button__["a" /* Button */], { className: "h-cancel-booking__button", color: "red", disabled: submitting, busy: submitting, "aria-label": content.cancelButtonAriaLabel, onClick: onCancel }, content.cancelButtonText),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__button_button__["a" /* Button */], { className: "h-cancel-booking__button", color: "outline-black", disabled: submitting || errorFetchingPenalty || !penalty, onClick: removeGuestsConfirmed }, content.removeGuestSubmitText)));
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__cclr_huge_ui__["ModalShell"], { header: renderHeader(), footer: renderFooter(), onRequestClose: onCancel, closeModalText: content === null || content === void 0 ? void 0 : content.cancelButtonAriaLabel, shellClassName: "h-remove-guest-conf-modal" }, renderBody()));
};
//# sourceMappingURL=remove-guest-consent.js.map

/***/ }),
/* 836 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 837 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 838 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ScrollToTop_scss__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ScrollToTop_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ScrollToTop_scss__);







/* eslint-disable */

var ScrollToTop = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ScrollToTop, _React$Component);

  function ScrollToTop() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ScrollToTop);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ScrollToTop.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ScrollToTop)).call(this));

    _this.state = {
      intervalId: 0, scrollStepInPx: "50", delayInMs: "16.66", resized: false
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ScrollToTop, [{
    key: 'scrollStep',
    value: function scrollStep() {
      if (window.pageYOffset === 0) {
        clearInterval(this.state.intervalId);
      }
      window.scroll(0, window.pageYOffset - this.state.scrollStepInPx);
      if (window.scrollY == 0) {
        $('#skipMainContent_ADA').focus();
      }
    }
  }, {
    key: 'scrollToTop',
    value: function scrollToTop() {
      var intervalId = setInterval(this.scrollStep.bind(this), this.state.delayInMs);
      this.setState({
        intervalId: intervalId
      });
      if ($('#ccl-refresh-header')) {
        $('#ccl-refresh-header .header-branding .logo').focus();
        $('#ccl-refresh-header .header-branding .logo').css('focus', '3px solid red !important');
      } else {
        $('.top-nav .nav-left .logo').focus();
        $('.top-nav .nav-left .logo').css('focus', '3px solid red !important');
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      $(window).resize(function () {
        _this2.setState({ resized: true });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var element = null;
      if (window.innerWidth <= 800) {
        element = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'a',
          { href: 'javascript:;', 'aria-label': 'click on this back to top button to go to begining of the page', role: 'button' },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('img', { className: 'scroll', src: '/_ui/responsive/ccl/assets/icons/scroll-arrow-to-up.svg',
            alt: '', onClick: function onClick() {
              _this3.scrollToTop();
            } })
        );
      } else {
        element = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'a',
          { href: 'javascript:;', className: 'btn btn-outline-black back-to-top-btn',
            'aria-label': 'click on this back to top button to go to begining of the page',
            role: 'button', onClick: function onClick() {
              _this3.scrollToTop();
            } },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'span',
            { className: 'back-to-top-text' },
            'Back to Top'
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('img', { className: 'scroll', src: '/_ui/responsive/ccl/assets/icons/scroll-arrow-to-up.svg',
            alt: 'Top Arrow' })
        );
      }
      return element;
    }
  }]);

  return ScrollToTop;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ScrollToTop);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 840 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_cclr_booked__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_cclr_huge_ui__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__todoPlanner_error__ = __webpack_require__(267);










/* eslint-disable */

var AlertsContainer = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AlertsContainer, _Component);

  function AlertsContainer(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AlertsContainer);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AlertsContainer.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AlertsContainer)).call(this, props));

    _this.state = { sailDate: "", shipCode: "" };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AlertsContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if ($('#sailDate').length > 0) {
        var currentSailDate = $('#sailDate')[0].value;
        var currentShipCode = $('#shipCode')[0].value;
        this.setState({
          sailDate: currentSailDate,
          shipCode: currentShipCode
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.sailDate && this.state.shipCode) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_cclr_booked__["ParametersSailingProvider"],
          {
            sailDate: this.state.sailDate,
            shipCode: this.state.shipCode,
            renderLoading: function renderLoading() {
              return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_cclr_huge_ui__["Spinner"], null);
            },
            renderError: function renderError() {
              return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__todoPlanner_error__["a" /* Error */], null);
            }
          },
          function (sailing, sailings) {
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_cclr_booked__["AlertsManagerContainer"], {
                shipCode: sailing.itinerary.shipCode,
                sailDate: sailing.itinerary.sailDate
              })
            );
          }
        );
      } else {
        return null;
      }
    }
  }]);

  return AlertsContainer;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AlertsContainer);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* unused harmony export register */
/* harmony export (immutable) */ __webpack_exports__["a"] = unregister;
// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read http://bit.ly/CRA-PWA
/* eslint-disable */
var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
// [::1] is the IPv6 localhost address.
window.location.hostname === '[::1]' ||
// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));

function register(config) {
  if ("production" === 'production' && 'serviceWorker' in navigator) {
    // The URL constructor is available in all browsers that support SW.
    var publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebook/create-react-app/issues/2374
      return;
    }

    window.addEventListener('load', function () {
      var swUrl = process.env.PUBLIC_URL + '/service-worker.js';

      if (isLocalhost) {
        // This is running on localhost. Let's check if a service worker still exists or not.
        checkValidServiceWorker(swUrl, config);

        // Add some additional logging to localhost, pointing developers to the
        // service worker/PWA documentation.
        navigator.serviceWorker.ready.then(function () {
          console.log('This web app is being served cache-first by a service ' + 'worker. To learn more, visit http://bit.ly/CRA-PWA');
        });
      } else {
        // Is not localhost. Just register service worker
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker.register(swUrl).then(function (registration) {
    registration.onupdatefound = function () {
      var installingWorker = registration.installing;
      if (installingWorker == null) {
        return;
      }
      installingWorker.onstatechange = function () {
        if (installingWorker.state === 'installed') {
          if (navigator.serviceWorker.controller) {
            // At this point, the updated precached content has been fetched,
            // but the previous service worker will still serve the older
            // content until all client tabs are closed.
            console.log('New content is available and will be used when all ' + 'tabs for this page are closed. See http://bit.ly/CRA-PWA.');

            // Execute callback
            if (config && config.onUpdate) {
              config.onUpdate(registration);
            }
          } else {
            // At this point, everything has been precached.
            // It's the perfect time to display a
            // "Content is cached for offline use." message.
            console.log('Content is cached for offline use.');

            // Execute callback
            if (config && config.onSuccess) {
              config.onSuccess(registration);
            }
          }
        }
      };
    };
  }).catch(function (error) {
    console.error('Error during service worker registration:', error);
  });
}

function checkValidServiceWorker(swUrl, config) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl).then(function (response) {
    // Ensure service worker exists, and that we really are getting a JS file.
    var contentType = response.headers.get('content-type');
    if (response.status === 404 || contentType != null && contentType.indexOf('javascript') === -1) {
      // No service worker found. Probably a different app. Reload the page.
      navigator.serviceWorker.ready.then(function (registration) {
        registration.unregister().then(function () {
          window.location.reload();
        });
      });
    } else {
      // Service worker found. Proceed as normal.
      registerValidSW(swUrl, config);
    }
  }).catch(function () {
    console.log('No internet connection found. App is running in offline mode.');
  });
}

function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(function (registration) {
      registration.unregister();
    });
  }
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(843)))

/***/ }),
/* 843 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/reactComp.js